/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 926);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(41);
var hide = __webpack_require__(23);
var redefine = __webpack_require__(24);
var ctx = __webpack_require__(33);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(87);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(760)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(30);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(121)('wks');
var uid = __webpack_require__(72);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntlProvider; });
/* unused harmony export FormattedDate */
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var IE8_DOM_DEFINE = __webpack_require__(247);
var toPrimitive = __webpack_require__(45);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(44);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMProperty = __webpack_require__(84);
var ReactDOMComponentFlags = __webpack_require__(297);

var invariant = __webpack_require__(2);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(42);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var createDesc = __webpack_require__(68);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(23);
var has = __webpack_require__(22);
var SRC = __webpack_require__(72)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(41).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(6);
var defined = __webpack_require__(42);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(92);
var createDesc = __webpack_require__(68);
var toIObject = __webpack_require__(29);
var toPrimitive = __webpack_require__(45);
var has = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(247);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(22);
var toObject = __webpack_require__(17);
var IE_PROTO = __webpack_require__(174)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(91);
var defined = __webpack_require__(42);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(149)('wks');
var uid = __webpack_require__(109);
var Symbol = __webpack_require__(39).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(20);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RECEIVE_NAVI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RECEIVE_PAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RECEIVE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RECEIVE_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RECEIVE_RESERVATION_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SWITCH_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RECEIVE_FRONTPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RECEIVE_INSTAGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RECEIVE_MENUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECEIVE_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RECEIVE_BLOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RECEIVE_COLLECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchNavi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchFront; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchReservationTexts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return switchLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchContact; });
/* unused harmony export fetchBlog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_dateAPI__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_shopifyAPI__ = __webpack_require__(217);
var RECEIVE_NAVI='RECEIVE_NAVI';var RECEIVE_PAGES='RECEIVE_PAGES';var RECEIVE_DATE='RECEIVE_DATE';var RECEIVE_HOURS='RECEIVE_HOURS';var RECEIVE_RESERVATION_INFO='RECEIVE_RESERVATION_INFO';var SWITCH_LANG='SWITCH_LANG';var RECEIVE_FRONTPAGE='RECEIVE_FRONTPAGE';var RECEIVE_INSTAGRAM='RECEIVE_INSTAGRAM';var RECEIVE_MENUS='RECEIVE_MENUS';var RECEIVE_CONTACT='RECEIVE_CONTACT';var RECEIVE_BLOGS='RECEIVE_BLOGS';var RECEIVE_COLLECTIONS='RECEIVE_COLLECTIONS';var isFetching={};// filter item by time
var isItemValid=function isItemValid(item,time){return(!item.fields.validFrom||new Date(time)>=new Date(item.fields.validFrom))&&(!item.fields.validUntil||new Date(time)<new Date(item.fields.validUntil));};var fetchNavi=function fetchNavi(locale){return function(dispatch,state){var FLAG='fetchNavi';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["a" /* getNavi */])(locale).then(function(items){isFetching[FLAG]=false;dispatch(receiveNavi(items));});}};};var receiveNavi=function receiveNavi(items){return{type:RECEIVE_NAVI,items:items.map(function(item){return Object.assign({},item.fields);})};};var fetchPage=function fetchPage(slug,locale){return function(dispatch){var FLAG='fetchPage_'+slug;if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["b" /* getPage */])(slug,locale).then(function(item){isFetching[FLAG]=false;dispatch(receivePage(item));});}};};var receivePage=function receivePage(item){return{type:RECEIVE_PAGES,item:item};};// fetch and get the front page head
var fetchFront=function fetchFront(locale,time){return function(dispatch){var FLAG='fetchFront';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["c" /* getFront */])(locale).then(function(item){isFetching[FLAG]=false;dispatch(receiveFront(item,time));});}};};var receiveFront=function receiveFront(data,time){return{type:RECEIVE_FRONTPAGE,data:{header:data.header,containers:data.containers?data.containers.filter(function(lift){return isItemValid(lift,time);}):null}};};var fetchDate=function fetchDate(){return function(dispatch){var FLAG='fetchDate';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_dateAPI__["a" /* getDate */])().then(function(date){isFetching[FLAG]=false;dispatch(receiveDate(date));});}};};var receiveDate=function receiveDate(date){return{type:RECEIVE_DATE,date:date};};var fetchReservationTexts=function fetchReservationTexts(locale){return function(dispatch){var FLAG='fetchReservationTexts';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["d" /* getReservationTexts */])(locale).then(function(texts){isFetching[FLAG]=false;dispatch(receiveReservationTexts(texts));});}};};var receiveReservationTexts=function receiveReservationTexts(texts){return{type:RECEIVE_RESERVATION_INFO,texts:texts};};// fetch and receive the open hours text
var fetchHours=function fetchHours(locale){return function(dispatch){var FLAG='fetchHours';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["e" /* getHours */])(locale).then(function(text){isFetching[FLAG]=false;dispatch(receiveHours(text));});}};};var receiveHours=function receiveHours(hoursText){return{type:RECEIVE_HOURS,hoursText:hoursText};};var switchLang=function switchLang(){return{type:SWITCH_LANG};};// fetch and receive instagram
/*export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  
  const site_name = process.env.REACT_APP_INSTAGRAM_SITE_NAME;
  var today = new Date();

  const timestamp = today.getFullYear() + "" + (today.getMonth() +1) + "" + today.getDate() + "" + today.getHours();
  return fetch(`https://instagram.monkfish.fi/cache/${site_name}.json?c=${timestamp}`)
    .then(x=>{
      return x.json()
    })
    .then(y=>{
      dispatch(receiveInstagram(y.data));
    })
}*//*export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  const commentsParam = '';
  const instagram_id = process.env.REACT_APP_INSTAGRAM_ID;
  const access_token = process.env.REACT_APP_INSTAGRAM_TOKEN;
  
  return fetch(`https://graph.facebook.com/v7.0/${instagram_id}/media?fields=media_url,thumbnail_url,caption,media_type,like_count,shortcode,timestamp,comments_count,username,children{media_url},permalink${commentsParam}&limit=2&access_token=${access_token}`)
    .then(x=>{
      return x.json()
    })
    .then(y=>{
      dispatch(receiveInstagram(y.data));
    })
}
*//*
const receiveInstagram = (data) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_INSTAGRAM,
    data
  };
}
*/// fetch and receive menu data
var fetchMenu=function fetchMenu(time,locale){return function(dispatch){var FLAG="fetchMenu";if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["f" /* getMenus */])(locale).then(function(data){return dispatch(receiveMenus(data,time));});}};};var receiveMenus=function receiveMenus(menus,time){var FLAG="fetchMenu";isFetching[FLAG]=false;return{type:RECEIVE_MENUS,data:menus.filter(function(menu){return isItemValid(menu,time);})};};// fetch and receive the contact page content
var fetchContact=function fetchContact(locale){return function(dispatch){var FLAG='fetchContact';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["g" /* getContact */])(locale).then(function(data){isFetching[FLAG]=false;dispatch(receiveContact(data));});}};};var receiveContact=function receiveContact(data){return{type:RECEIVE_CONTACT,data:data};};var fetchBlog=function fetchBlog(locale,limit,offset){return function(dispatch){var FLAG='fetchBlog';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_contentfulAPI__["h" /* getBlogs */])(locale,limit,offset).then(function(data){dispatch(receiveBlogs(data));});}};};var receiveBlogs=function receiveBlogs(blogs){var FLAG='fetchBlog';isFetching[FLAG]=false;return{type:RECEIVE_BLOGS,data:blogs};};var fetchCollection=function fetchCollection(id){return function(dispatch){var FLAG='fetchGiftCard';if(!isFetching[FLAG]){isFetching[FLAG]=true;return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_shopifyAPI__["b" /* getProductsInCollection */])(id).then(function(collection){isFetching[FLAG]=false;dispatch(receiveCollection(collection));});}};};var receiveCollection=function receiveCollection(collection){return{type:RECEIVE_COLLECTIONS,collection:collection};};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(33);
var IObject = __webpack_require__(91);
var toObject = __webpack_require__(17);
var toLength = __webpack_require__(15);
var asc = __webpack_require__(159);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(41);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(295);
var PooledClass = __webpack_require__(73);
var ReactFeatureFlags = __webpack_require__(300);
var ReactReconciler = __webpack_require__(85);
var Transaction = __webpack_require__(132);

var invariant = __webpack_require__(2);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(77)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var core = __webpack_require__(38);
var ctx = __webpack_require__(76);
var hide = __webpack_require__(56);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(227);
var toPrimitive = __webpack_require__(153);
var dP = Object.defineProperty;

exports.f = __webpack_require__(47) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(268);
var $export = __webpack_require__(0);
var shared = __webpack_require__(121)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(271))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(13)) {
  var LIBRARY = __webpack_require__(64);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(123);
  var $buffer = __webpack_require__(180);
  var ctx = __webpack_require__(33);
  var anInstance = __webpack_require__(62);
  var propertyDesc = __webpack_require__(68);
  var hide = __webpack_require__(23);
  var redefineAll = __webpack_require__(69);
  var toInteger = __webpack_require__(44);
  var toLength = __webpack_require__(15);
  var toIndex = __webpack_require__(266);
  var toAbsoluteIndex = __webpack_require__(71);
  var toPrimitive = __webpack_require__(45);
  var has = __webpack_require__(22);
  var classof = __webpack_require__(90);
  var isObject = __webpack_require__(7);
  var toObject = __webpack_require__(17);
  var isArrayIter = __webpack_require__(166);
  var create = __webpack_require__(65);
  var getPrototypeOf = __webpack_require__(28);
  var gOPN = __webpack_require__(66).f;
  var getIterFn = __webpack_require__(182);
  var uid = __webpack_require__(72);
  var wks = __webpack_require__(10);
  var createArrayMethod = __webpack_require__(40);
  var createArrayIncludes = __webpack_require__(110);
  var speciesConstructor = __webpack_require__(122);
  var ArrayIterators = __webpack_require__(183);
  var Iterators = __webpack_require__(79);
  var $iterDetect = __webpack_require__(116);
  var setSpecies = __webpack_require__(70);
  var arrayFill = __webpack_require__(158);
  var arrayCopyWithin = __webpack_require__(239);
  var $DP = __webpack_require__(14);
  var $GOPD = __webpack_require__(27);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(73);

var emptyFunction = __webpack_require__(30);
var warning = __webpack_require__(8);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var Parser = __webpack_require__(386).Parser;
var ReactRenderer = __webpack_require__(382);
var propTypes = __webpack_require__(3);

function ReactMarkdown(props) {
    React.Component.call(this, props);
}

ReactMarkdown.prototype = Object.create(React.Component.prototype);
ReactMarkdown.prototype.constructor = ReactMarkdown;

ReactMarkdown.prototype.render = function() {
    var containerProps = this.props.containerProps || {};
    var renderer = new ReactRenderer(this.props);
    var parser = new Parser(this.props.parserOptions);
    var ast = parser.parse(this.props.source || '');

    if (this.props.walker) {
        var walker = ast.walker();
        var event;

        while ((event = walker.next())) {
            this.props.walker.call(this, event, walker);
        }
    }

    if (this.props.className) {
        containerProps.className = this.props.className;
    }

    return React.createElement.apply(React,
        [this.props.containerTagName, containerProps, this.props.childBefore]
            .concat(renderer.render(ast).concat(
                [this.props.childAfter]
            ))
    );
};

ReactMarkdown.propTypes = {
    className: propTypes.string,
    containerProps: propTypes.object,
    source: propTypes.string.isRequired,
    containerTagName: propTypes.string,
    childBefore: propTypes.object,
    childAfter: propTypes.object,
    sourcePos: propTypes.bool,
    escapeHtml: propTypes.bool,
    skipHtml: propTypes.bool,
    softBreak: propTypes.string,
    allowNode: propTypes.func,
    allowedTypes: propTypes.array,
    disallowedTypes: propTypes.array,
    transformLinkUri: propTypes.func,
    transformImageUri: propTypes.func,
    unwrapDisallowed: propTypes.bool,
    renderers: propTypes.object,
    walker: propTypes.func,
    parserOptions: propTypes.object
};

ReactMarkdown.defaultProps = {
    containerTagName: 'div',
    parserOptions: {}
};

ReactMarkdown.types = ReactRenderer.types;
ReactMarkdown.renderers = ReactRenderer.renderers;
ReactMarkdown.uriTransformer = ReactRenderer.uriTransformer;

module.exports = ReactMarkdown;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var createDesc = __webpack_require__(107);
module.exports = __webpack_require__(47) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(10)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(23)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(72)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(22);
var setDesc = __webpack_require__(14).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 61 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(33);
var call = __webpack_require__(250);
var isArrayIter = __webpack_require__(166);
var anObject = __webpack_require__(4);
var toLength = __webpack_require__(15);
var getIterFn = __webpack_require__(182);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(4);
var dPs = __webpack_require__(256);
var enumBugKeys = __webpack_require__(162);
var IE_PROTO = __webpack_require__(174)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(161)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(164).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(258);
var hiddenKeys = __webpack_require__(162).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(258);
var enumBugKeys = __webpack_require__(162);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(24);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(14);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(863);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(864);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(865);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(866);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(867);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(868);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(322);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(213);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(869);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(870);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(871);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(872);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(753);
var decode = __webpack_require__(752);

var C_BACKSLASH = 92;

var decodeHTML = __webpack_require__(272).decodeHTML;

var ENTITY = "&(?:#x[a-f0-9]{1,8}|#[0-9]{1,8}|[a-z][a-z0-9]{1,31});";

var TAGNAME = '[A-Za-z][A-Za-z0-9-]*';
var ATTRIBUTENAME = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var UNQUOTEDVALUE = "[^\"'=<>`\\x00-\\x20]+";
var SINGLEQUOTEDVALUE = "'[^']*'";
var DOUBLEQUOTEDVALUE = '"[^"]*"';
var ATTRIBUTEVALUE = "(?:" + UNQUOTEDVALUE + "|" + SINGLEQUOTEDVALUE + "|" + DOUBLEQUOTEDVALUE + ")";
var ATTRIBUTEVALUESPEC = "(?:" + "\\s*=" + "\\s*" + ATTRIBUTEVALUE + ")";
var ATTRIBUTE = "(?:" + "\\s+" + ATTRIBUTENAME + ATTRIBUTEVALUESPEC + "?)";
var OPENTAG = "<" + TAGNAME + ATTRIBUTE + "*" + "\\s*/?>";
var CLOSETAG = "</" + TAGNAME + "\\s*[>]";
var HTMLCOMMENT = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var PROCESSINGINSTRUCTION = "[<][?].*?[?][>]";
var DECLARATION = "<![A-Z]+" + "\\s+[^>]*>";
var CDATA = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var HTMLTAG = "(?:" + OPENTAG + "|" + CLOSETAG + "|" + HTMLCOMMENT + "|" +
        PROCESSINGINSTRUCTION + "|" + DECLARATION + "|" + CDATA + ")";
var reHtmlTag = new RegExp('^' + HTMLTAG, 'i');

var reBackslashOrAmp = /[\\&]/;

var ESCAPABLE = '[!"#$%&\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]';

var reEntityOrEscapedChar = new RegExp('\\\\' + ESCAPABLE + '|' + ENTITY, 'gi');

var XMLSPECIAL = '[&<>"]';

var reXmlSpecial = new RegExp(XMLSPECIAL, 'g');

var reXmlSpecialOrEntity = new RegExp(ENTITY + '|' + XMLSPECIAL, 'gi');

var unescapeChar = function(s) {
    if (s.charCodeAt(0) === C_BACKSLASH) {
        return s.charAt(1);
    } else {
        return decodeHTML(s);
    }
};

// Replace entities and backslash escapes with literal characters.
var unescapeString = function(s) {
    if (reBackslashOrAmp.test(s)) {
        return s.replace(reEntityOrEscapedChar, unescapeChar);
    } else {
        return s;
    }
};

var normalizeURI = function(uri) {
    try {
        return encode(decode(uri));
    }
    catch(err) {
        return uri;
    }
};

var replaceUnsafeChar = function(s) {
    switch (s) {
    case '&':
        return '&amp;';
    case '<':
        return '&lt;';
    case '>':
        return '&gt;';
    case '"':
        return '&quot;';
    default:
        return s;
    }
};

var escapeXml = function(s, preserve_entities) {
    if (reXmlSpecial.test(s)) {
        if (preserve_entities) {
            return s.replace(reXmlSpecialOrEntity, replaceUnsafeChar);
        } else {
            return s.replace(reXmlSpecial, replaceUnsafeChar);
        }
    } else {
        return s;
    }
};

module.exports = { unescapeString: unescapeString,
                   normalizeURI: normalizeURI,
                   escapeXml: escapeXml,
                   reHtmlTag: reHtmlTag,
                   OPENTAG: OPENTAG,
                   CLOSETAG: CLOSETAG,
                   ENTITY: ENTITY,
                   ESCAPABLE: ESCAPABLE
                 };


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(223);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(143);
var defined = __webpack_require__(141);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(14).f;
var has = __webpack_require__(22);
var TAG = __webpack_require__(10)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(42);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(178);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(196);
var setInnerHTML = __webpack_require__(134);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(204);
var setTextContent = __webpack_require__(313);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(799);
var ReactInstrumentation = __webpack_require__(35);

var warning = __webpack_require__(8);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(890);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(635);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(827);

var _HelmetConstants = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactBaseClasses = __webpack_require__(337);
var ReactChildren = __webpack_require__(893);
var ReactDOMFactories = __webpack_require__(894);
var ReactElement = __webpack_require__(88);
var ReactPropTypes = __webpack_require__(895);
var ReactVersion = __webpack_require__(896);

var createReactClass = __webpack_require__(897);
var onlyChild = __webpack_require__(901);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactCurrentOwner = __webpack_require__(54);

var warning = __webpack_require__(8);
var canDefineProperty = __webpack_require__(341);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(339);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(32);
var TAG = __webpack_require__(10)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(32);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var EventPluginRegistry = __webpack_require__(197);
var EventPluginUtils = __webpack_require__(198);
var ReactErrorUtils = __webpack_require__(202);

var accumulateInto = __webpack_require__(306);
var forEachAccumulated = __webpack_require__(307);
var invariant = __webpack_require__(2);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(96);
var EventPluginUtils = __webpack_require__(198);

var accumulateInto = __webpack_require__(306);
var forEachAccumulated = __webpack_require__(307);
var warning = __webpack_require__(8);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

var getEventTarget = __webpack_require__(207);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.classnames);
    global.themeColors = mod.exports;
  }
})(this, function (exports, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = themeColors;

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This is a utility function to apply the different text colors as a class name.
   *
   * @param {Object} options - The options to use to figure out which styles to apply.
   * @param {boolean?} options.text - Boolean if the base text color should attempt to be
   *    applied. This will only be applied if all the other states are not true.
   * @param {boolean?} options.disabled - Boolean if the text should be disabled.
   * @param {boolean?} options.error - Boolean if the error color should attempt to be applied.
   *    This will only be applied if the disabled state is false.
   * @param {boolean?} options.primary - Boolean if the primary color should be applied. This
   *    will only be applied if all the other states are false.
   * @param {boolean?} options.secondary - Boolean if the secondary color should be applied.
   *    This will only be applied if all the other states are false.
   * @param {boolean?} options.inherit - Boolean if the color should be inherited by a parent.
   *    This will only be applied if the error and disabled states are false.
   * @return {String} the class name
   */
  function themeColors() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$themeText = _ref.themeText,
        themeText = _ref$themeText === undefined ? true : _ref$themeText,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? false : _ref$text,
        _ref$background = _ref.background,
        background = _ref$background === undefined ? false : _ref$background,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$error = _ref.error,
        error = _ref$error === undefined ? false : _ref$error,
        _ref$hint = _ref.hint,
        hint = _ref$hint === undefined ? false : _ref$hint,
        _ref$primary = _ref.primary,
        primary = _ref$primary === undefined ? false : _ref$primary,
        _ref$secondary = _ref.secondary,
        secondary = _ref$secondary === undefined ? false : _ref$secondary,
        _ref$inherit = _ref.inherit,
        inherit = _ref$inherit === undefined ? false : _ref$inherit,
        _ref$ink = _ref.ink,
        ink = _ref$ink === undefined ? false : _ref$ink,
        _ref$card = _ref.card,
        card = _ref$card === undefined ? false : _ref$card,
        _ref$hover = _ref.hover,
        hover = _ref$hover === undefined ? false : _ref$hover;

    var className = arguments[1];

    var colors = '';
    if (themeText) {
      if (disabled) {
        colors = 'md-text--disabled';
      } else if (error) {
        colors = 'md-text--error';
      } else if (inherit) {
        colors = 'md-text--inherit';
      } else {
        colors = (0, _classnames2.default)({
          'md-text': text && !primary && !secondary && !hint,
          'md-text--secondary': hint,
          'md-text--theme-primary': !hint && primary,
          'md-text--theme-secondary': !hint && secondary,
          'md-ink--primary': ink && primary,
          'md-ink--secondary': ink && secondary
        });
      }
    } else {
      colors = (0, _classnames2.default)({
        'md-background': background && !primary && !secondary && !card,
        'md-background--card': card,
        'md-background--primary': primary,
        'md-background--primary-hover': primary && hover,
        'md-background--secondary': secondary,
        'md-background--secondary-hover': secondary && hover
      });
    }

    return (0, _classnames2.default)(colors, className);
  }
});
//# sourceMappingURL=themeColors.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentBlocks_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentBlocks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ContentBlocks_css__);
var FullbleedHero=function FullbleedHero(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fullbleed hero',style:__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.image')?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.image.fields.file.url')+'?fm=jpg&q=80)'}:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,{meta:[{"name":"description","content":__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.lead')},{"property":"og:description","content":__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.lead')}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.heading')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,props.fields.heading),__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.lead')&&props.slug!=='reservation'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.lead'),softBreak:'br'})),__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaText')&&(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaInternalLink')||__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaExternalLink'))&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaInternalLink')?__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaInternalLink.fields.slug'):__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaExternalLink'),className:'btn'},__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(props,'fields.ctaText')))));};FullbleedHero.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(FullbleedHero));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(76);
var call = __webpack_require__(411);
var isArrayIter = __webpack_require__(410);
var anObject = __webpack_require__(55);
var toLength = __webpack_require__(151);
var getIterFn = __webpack_require__(236);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(55);
var dPs = __webpack_require__(414);
var enumBugKeys = __webpack_require__(142);
var IE_PROTO = __webpack_require__(148)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(226)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(409).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(232);
var enumBugKeys = __webpack_require__(142);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(49).f;
var has = __webpack_require__(61);
var TAG = __webpack_require__(31)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(29);
var toLength = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(71);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(24);
var redefineAll = __webpack_require__(69);
var meta = __webpack_require__(59);
var forOf = __webpack_require__(63);
var anInstance = __webpack_require__(62);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(116);
var setToStringTag = __webpack_require__(80);
var inheritIfRequired = __webpack_require__(165);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(23);
var redefine = __webpack_require__(24);
var fails = __webpack_require__(6);
var defined = __webpack_require__(42);
var wks = __webpack_require__(10);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(4);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(32);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(7);
var cof = __webpack_require__(32);
var MATCH = __webpack_require__(10)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(10)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(64) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 118 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(20);
var ctx = __webpack_require__(33);
var forOf = __webpack_require__(63);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(20);
var SPECIES = __webpack_require__(10)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(23);
var uid = __webpack_require__(72);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["a" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(747);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(730);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(286);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(348)(module)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventPluginRegistry = __webpack_require__(197);
var ReactEventEmitterMixin = __webpack_require__(791);
var ViewportMetrics = __webpack_require__(305);

var getVendorPrefixedEventName = __webpack_require__(823);
var isEventSupported = __webpack_require__(208);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);
var ViewportMetrics = __webpack_require__(305);

var getEventModifierState = __webpack_require__(206);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);
var DOMNamespaces = __webpack_require__(196);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(204);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(839)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./TextField'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.TextField);
    global.index = mod.exports;
  }
})(this, function (exports, _TextField2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TextField = undefined;

  var _TextField3 = _interopRequireDefault(_TextField2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _TextField3.default;
  exports.TextField = _TextField3.default;
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(194);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(828);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultArrowRenderer = __webpack_require__(888);

var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);

var _defaultFilterOptions = __webpack_require__(334);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(335);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

var _defaultClearRenderer = __webpack_require__(889);

var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);

var _Option = __webpack_require__(887);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(332);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);

var instanceId = 1;

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	_createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
				var menuNode = _reactDom2.default.findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
				var menuDOM = _reactDom2.default.findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				return;
			}

			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.handleInputValueChange('')
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'handleRequired',
		value: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param	{String|Number|Array}	value		- the value of the select input
   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value, nextProps) {
			var _this2 = this;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this2.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}

		/**
   * Retrieve a value from the given options and valueKey
   * @param	{String|Number|Array}	value	- the selected value(s)
   * @param	{Object}		props	- the Select component's props (or nextProps)
   */

	}, {
		key: 'expandValue',
		value: function expandValue(value, props) {
			var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options,
			    valueKey = props.valueKey;

			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this3 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.onChange) {
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this4 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			if (this.props.multi) {
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					_this4.addValue(value);
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this4.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange('')
			}, this.focus);
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'getInputValue',
		value: function getInputValue() {
			return this.state.inputValue;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2.default.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2.default.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2.default.createElement(
						ValueComponent,
						{
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							disabled: _this5.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2.default.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2.default.createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;

			var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps,
				    inputClassName = _props$inputProps.inputClassName,
				    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

				var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));

				return _react2.default.createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}

			if (this.props.autosize) {
				return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement('input', inputProps)
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();

			return _react2.default.createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			return _react2.default.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;

				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2.default.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2.default.createElement('input', {
					type: 'hidden',
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2.default.createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this7.props.name,
					value: stringifyValue(item[_this7.props.valueKey]),
					disabled: _this7.props.disabled });
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2.default)('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2.default.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2.default.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

;

Select.propTypes = {
	'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
	'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
	addLabelText: _propTypes2.default.string, // placeholder displayed when you want to add a label on a multi-value input
	arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
	autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
	autofocus: _propTypes2.default.bool, // autofocus the component on mount
	autosize: _propTypes2.default.bool, // whether to enable autosizing or not
	backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: _propTypes2.default.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: _propTypes2.default.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: _propTypes2.default.bool, // should it be possible to reset value
	closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
	deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
	disabled: _propTypes2.default.bool, // whether the Select is disabled or not
	escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
	filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
	filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
	ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
	inputProps: _propTypes2.default.object, // custom attributes for the Input
	inputRenderer: _propTypes2.default.func, // returns a custom input component
	instanceId: _propTypes2.default.string, // set the components instanceId
	isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: _propTypes2.default.string, // path of the label value in option objects
	matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
	matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
	menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
	menuRenderer: _propTypes2.default.func, // renders a custom menu with options
	menuStyle: _propTypes2.default.object, // optional style to apply to the menu
	multi: _propTypes2.default.bool, // multi-value input
	name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
	onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onClose: _propTypes2.default.func, // fires when the menu is closed
	onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
	onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: _propTypes2.default.func, // fires when the menu is opened
	onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: _propTypes2.default.bool, // always open options menu on focus
	optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: _propTypes2.default.func, // option component to render in dropdown
	optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
	options: _propTypes2.default.array, // array of options
	pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
	resetValue: _propTypes2.default.any, // value to use when you clear the control
	scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: _propTypes2.default.bool, // whether to enable searching feature or not
	simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: _propTypes2.default.object, // optional style to apply to the control
	tabIndex: _propTypes2.default.string, // optional tab index of the control
	tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
	value: _propTypes2.default.any, // initial field value
	valueComponent: _propTypes2.default.func, // value component to render
	valueKey: _propTypes2.default.string, // path of the label value in option objects
	valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
	wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
};

Select.defaultProps = {
	addLabelText: 'Add "{label}"?',
	arrowRenderer: _defaultArrowRenderer2.default,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: _defaultClearRenderer2.default,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: _defaultFilterOptions2.default,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: _defaultMenuRenderer2.default,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onSelectResetsInput: true,
	onCloseResetsInput: true,
	openOnClick: true,
	optionComponent: _Option2.default,
	pageSize: 5,
	placeholder: 'Select...',
	required: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	valueComponent: _Value2.default,
	valueKey: 'value'
};

exports.default = Select;

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__);
var FullbleedContentBlock=function FullbleedContentBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fullbleed content-block '+props.align,style:props.fields.image?{backgroundImage:'url('+props.fields.image[0].fields.file.url+'?fm=jpg&q=80)'}:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},props.align!=='center'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.fields.topHeading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheading'},props.fields.topHeading),props.fields.heading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.fields.heading),props.fields.lead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.lead,softBreak:'br'})),props.fields.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.content,softBreak:'br'})),props.fields.leadLinkText&&(props.fields.leadInternalLink||props.fields.leadLinkUrl)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.fields.leadInternalLink?props.fields.leadInternalLink.fields.slug:props.fields.leadLinkUrl,className:'btn'},props.fields.leadLinkText))));};FullbleedContentBlock.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(FullbleedContentBlock));

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loader_css__);
var Loader=function Loader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isContainer(node) {
    switch (node._type) {
    case 'Document':
    case 'BlockQuote':
    case 'List':
    case 'Item':
    case 'Paragraph':
    case 'Heading':
    case 'Emph':
    case 'Strong':
    case 'Link':
    case 'Image':
    case 'CustomInline':
    case 'CustomBlock':
        return true;
    default:
        return false;
    }
}

var resumeAt = function(node, entering) {
    this.current = node;
    this.entering = (entering === true);
};

var next = function(){
    var cur = this.current;
    var entering = this.entering;

    if (cur === null) {
        return null;
    }

    var container = isContainer(cur);

    if (entering && container) {
        if (cur._firstChild) {
            this.current = cur._firstChild;
            this.entering = true;
        } else {
            // stay on node but exit
            this.entering = false;
        }

    } else if (cur === this.root) {
        this.current = null;

    } else if (cur._next === null) {
        this.current = cur._parent;
        this.entering = false;

    } else {
        this.current = cur._next;
        this.entering = true;
    }

    return {entering: entering, node: cur};
};

var NodeWalker = function(root) {
    return { current: root,
             root: root,
             entering: true,
             next: next,
             resumeAt: resumeAt };
};

var Node = function(nodeType, sourcepos) {
    this._type = nodeType;
    this._parent = null;
    this._firstChild = null;
    this._lastChild = null;
    this._prev = null;
    this._next = null;
    this._sourcepos = sourcepos;
    this._lastLineBlank = false;
    this._open = true;
    this._string_content = null;
    this._literal = null;
    this._listData = {};
    this._info = null;
    this._destination = null;
    this._title = null;
    this._isFenced = false;
    this._fenceChar = null;
    this._fenceLength = 0;
    this._fenceOffset = null;
    this._level = null;
    this._onEnter = null;
    this._onExit = null;
};

var proto = Node.prototype;

Object.defineProperty(proto, 'isContainer', {
    get: function () { return isContainer(this); }
});

Object.defineProperty(proto, 'type', {
    get: function() { return this._type; }
});

Object.defineProperty(proto, 'firstChild', {
    get: function() { return this._firstChild; }
});

Object.defineProperty(proto, 'lastChild', {
    get: function() { return this._lastChild; }
});

Object.defineProperty(proto, 'next', {
    get: function() { return this._next; }
});

Object.defineProperty(proto, 'prev', {
    get: function() { return this._prev; }
});

Object.defineProperty(proto, 'parent', {
    get: function() { return this._parent; }
});

Object.defineProperty(proto, 'sourcepos', {
    get: function() { return this._sourcepos; }
});

Object.defineProperty(proto, 'literal', {
    get: function() { return this._literal; },
    set: function(s) { this._literal = s; }
});

Object.defineProperty(proto, 'destination', {
    get: function() { return this._destination; },
    set: function(s) { this._destination = s; }
});

Object.defineProperty(proto, 'title', {
    get: function() { return this._title; },
    set: function(s) { this._title = s; }
});

Object.defineProperty(proto, 'info', {
    get: function() { return this._info; },
    set: function(s) { this._info = s; }
});

Object.defineProperty(proto, 'level', {
    get: function() { return this._level; },
    set: function(s) { this._level = s; }
});

Object.defineProperty(proto, 'listType', {
    get: function() { return this._listData.type; },
    set: function(t) { this._listData.type = t; }
});

Object.defineProperty(proto, 'listTight', {
    get: function() { return this._listData.tight; },
    set: function(t) { this._listData.tight = t; }
});

Object.defineProperty(proto, 'listStart', {
    get: function() { return this._listData.start; },
    set: function(n) { this._listData.start = n; }
});

Object.defineProperty(proto, 'listDelimiter', {
    get: function() { return this._listData.delimiter; },
    set: function(delim) { this._listData.delimiter = delim; }
});

Object.defineProperty(proto, 'onEnter', {
    get: function() { return this._onEnter; },
    set: function(s) { this._onEnter = s; }
});

Object.defineProperty(proto, 'onExit', {
    get: function() { return this._onExit; },
    set: function(s) { this._onExit = s; }
});

Node.prototype.appendChild = function(child) {
    child.unlink();
    child._parent = this;
    if (this._lastChild) {
        this._lastChild._next = child;
        child._prev = this._lastChild;
        this._lastChild = child;
    } else {
        this._firstChild = child;
        this._lastChild = child;
    }
};

Node.prototype.prependChild = function(child) {
    child.unlink();
    child._parent = this;
    if (this._firstChild) {
        this._firstChild._prev = child;
        child._next = this._firstChild;
        this._firstChild = child;
    } else {
        this._firstChild = child;
        this._lastChild = child;
    }
};

Node.prototype.unlink = function() {
    if (this._prev) {
        this._prev._next = this._next;
    } else if (this._parent) {
        this._parent._firstChild = this._next;
    }
    if (this._next) {
        this._next._prev = this._prev;
    } else if (this._parent) {
        this._parent._lastChild = this._prev;
    }
    this._parent = null;
    this._next = null;
    this._prev = null;
};

Node.prototype.insertAfter = function(sibling) {
    sibling.unlink();
    sibling._next = this._next;
    if (sibling._next) {
        sibling._next._prev = sibling;
    }
    sibling._prev = this;
    this._next = sibling;
    sibling._parent = this._parent;
    if (!sibling._next) {
        sibling._parent._lastChild = sibling;
    }
};

Node.prototype.insertBefore = function(sibling) {
    sibling.unlink();
    sibling._prev = this._prev;
    if (sibling._prev) {
        sibling._prev._next = sibling;
    }
    sibling._next = this;
    this._prev = sibling;
    sibling._parent = this._parent;
    if (!sibling._prev) {
        sibling._parent._firstChild = sibling;
    }
};

Node.prototype.walker = function() {
    var walker = new NodeWalker(this);
    return walker;
};

module.exports = Node;


/* Example of use of walker:

 var walker = w.walker();
 var event;

 while (event = walker.next()) {
 console.log(event.entering, event.node.type);
 }

 */


/***/ }),
/* 140 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(140);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(145);
var $export = __webpack_require__(48);
var redefine = __webpack_require__(234);
var hide = __webpack_require__(56);
var has = __webpack_require__(61);
var Iterators = __webpack_require__(89);
var $iterCreate = __webpack_require__(412);
var setToStringTag = __webpack_require__(108);
var getPrototypeOf = __webpack_require__(416);
var ITERATOR = __webpack_require__(31)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(109)('meta');
var isObject = __webpack_require__(57);
var has = __webpack_require__(61);
var setDesc = __webpack_require__(49).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(77)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(149)('keys');
var uid = __webpack_require__(109);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(150);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(141);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(57);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(39);
var core = __webpack_require__(38);
var LIBRARY = __webpack_require__(145);
var wksExt = __webpack_require__(155);
var defineProperty = __webpack_require__(49).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(31);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(421)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(144)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(424);
var global = __webpack_require__(39);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(89);
var TO_STRING_TAG = __webpack_require__(31)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(15);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(435);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(14);
var createDesc = __webpack_require__(68);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(10)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var setPrototypeOf = __webpack_require__(173).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(79);
var ITERATOR = __webpack_require__(10)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(65);
var descriptor = __webpack_require__(68);
var setToStringTag = __webpack_require__(80);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(10)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(64);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(24);
var hide = __webpack_require__(23);
var has = __webpack_require__(22);
var Iterators = __webpack_require__(79);
var $iterCreate = __webpack_require__(167);
var setToStringTag = __webpack_require__(80);
var getPrototypeOf = __webpack_require__(28);
var ITERATOR = __webpack_require__(10)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(179).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(32)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(20);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(4);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(33)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(121)('keys');
var uid = __webpack_require__(72);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);
var defined = __webpack_require__(42);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(115);
var defined = __webpack_require__(42);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(44);
var defined = __webpack_require__(42);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(33);
var invoke = __webpack_require__(248);
var html = __webpack_require__(164);
var cel = __webpack_require__(161);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(32)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(13);
var LIBRARY = __webpack_require__(64);
var $typed = __webpack_require__(123);
var hide = __webpack_require__(23);
var redefineAll = __webpack_require__(69);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(62);
var toInteger = __webpack_require__(44);
var toLength = __webpack_require__(15);
var toIndex = __webpack_require__(266);
var gOPN = __webpack_require__(66).f;
var dP = __webpack_require__(14).f;
var arrayFill = __webpack_require__(158);
var setToStringTag = __webpack_require__(80);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(41);
var LIBRARY = __webpack_require__(64);
var wksExt = __webpack_require__(267);
var defineProperty = __webpack_require__(14).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(90);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(79);
module.exports = __webpack_require__(41).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(58);
var step = __webpack_require__(251);
var Iterators = __webpack_require__(79);
var toIObject = __webpack_require__(29);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(168)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(345);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(347);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(708);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(190);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(721);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(716);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(285),
    isObjectLike = __webpack_require__(749);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(776);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(83);
var Danger = __webpack_require__(768);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactInstrumentation = __webpack_require__(35);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(204);
var setInnerHTML = __webpack_require__(134);
var setTextContent = __webpack_require__(313);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactErrorUtils = __webpack_require__(202);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(797);
var propTypesFactory = __webpack_require__(291);

var React = __webpack_require__(87);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(54);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(35);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var emptyFunction = __webpack_require__(30);
var warning = __webpack_require__(8);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_async_script__);



var callbackName = "onloadcallback";
var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
var globalName = "grecaptcha";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_async_script___default()(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */], URL, {
  callbackName: callbackName,
  globalName: globalName,
  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
}));

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(214);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shopClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductsInCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shopify_buy__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shopify_buy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shopify_buy__);
var accessToken='9c4e2fd6650990d5ede03094254a3f98';var domain='bw-restaurants-oy';var appId='6674841627';var shopClient=__WEBPACK_IMPORTED_MODULE_0_shopify_buy___default.a.buildClient({accessToken:accessToken,domain:domain+'.myshopify.com',appId:appId});var getProductsInCollection=function getProductsInCollection(collection){return shopClient.fetchQueryProducts({collection_id:collection}).then(function(response){return response;}).catch(function(){console.log('Request failed');});};

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__);
var ContentBlock=function ContentBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.align.toLowerCase()},props.fields.topHeading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheading'},props.fields.topHeading),props.fields.heading&&props.fields.align.toLowerCase()==='center'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.fields.heading),props.fields.heading&&props.fields.align.toLowerCase()!=='center'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.fields.heading),props.fields.lead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.lead,softBreak:'br'})),props.fields.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.content,softBreak:'br'})),props.fields.leadLinkText&&(props.fields.leadInternalLink||props.fields.leadLinkUrl)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.fields.leadInternalLink?props.fields.leadInternalLink.fields.slug:props.fields.leadLinkUrl,className:'btn'},props.fields.leadLinkText));};ContentBlock.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ContentBlock));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentBlocks_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentBlocks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ContentBlocks_css__);
var ContentBlockHolder=function ContentBlockHolder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-block '+(props.dual?'dual':'single')+' '+props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},props.children));};ContentBlockHolder.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContentBlockHolder));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ContentBlocks_css__);
var ContentBlockImage=function ContentBlockImage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-block with-image '+props.align},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image'},props.fields.image&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundImage:'url('+props.fields.image[0].fields.file.url+')'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.fields.topHeading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subheading'},props.fields.topHeading),props.fields.heading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.fields.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},props.fields.lead&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.lead,softBreak:'br'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},props.fields.content&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.fields.content,softBreak:'br'})),props.fields.leadLinkText&&(props.fields.leadInternalLink||props.fields.leadLinkUrl)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.fields.leadInternalLink?props.fields.leadInternalLink.fields.slug:props.fields.leadLinkUrl,className:'btn'},props.fields.leadLinkText))));};ContentBlockImage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(ContentBlockImage));

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsLetter_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsLetter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewsLetter_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsLetter=function(_Component){_inherits(NewsLetter,_Component);function NewsLetter(props){_classCallCheck(this,NewsLetter);var _this=_possibleConstructorReturn(this,(NewsLetter.__proto__||Object.getPrototypeOf(NewsLetter)).call(this,props));_this.state={email:'',status:'',emailType1:false,emailType2:false,emailType3:false};return _this;}_createClass(NewsLetter,[{key:'emailTypeHandler1',value:function emailTypeHandler1(event){if(this.state.emailType1===false){this.setState({emailType1:true});if(this.state.emailType2===true){this.setState({emailType3:true});}}else{this.setState({emailType1:false});this.setState({emailType3:false});}}},{key:'emailTypeHandler2',value:function emailTypeHandler2(event){if(this.state.emailType2===false){this.setState({emailType2:true});if(this.state.emailType1===true){this.setState({emailType3:true});}}else{this.setState({emailType2:false});this.setState({emailType3:false});}}},{key:'emailHandler',value:function emailHandler(email){this.setState({email:email});}},{key:'resetHandler',value:function resetHandler(event){event.preventDefault();this.setState({email:'',status:''});}},{key:'subscribeHandler',value:function subscribeHandler(event){event.preventDefault();var t=this;t.setState({status:''});var type='personal';if(t.state.emailType1===true&&t.state.emailType3===false){type='personal';}if(t.state.emailType2===true&&t.state.emailType1===false){type='business';}if(t.state.emailType3===true){type='both';}fetch('https://campaign.monkfish.fi/bwcm/subscribe.php?email='+this.state.email+'&type='+type).then(function(response){response.text().then(function(text){if(text==='success'){t.setState({status:'success'});}else{t.setState({status:'fail',emailType1:false,emailType2:false,emailType3:false});}});});}},{key:'render',value:function render(){var email=this.state.email;var status=this.state.status;var messages=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["e" /* defineMessages */])({placeholder:{id:'newsletter.placeholder'}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.classname?this.props.classname:null},this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.orderTitle'})),!this.props.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.title'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.text'}),' '),status===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.subscribeHandler.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'email-type'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.private'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'email-type',value:'private',onChange:this.emailTypeHandler1.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.business'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'email-type',value:'business',onChange:this.emailTypeHandler2.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'email',type:'email',label:this.props.intl.formatMessage(messages.placeholder),onChange:this.emailHandler.bind(this),value:email,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:email.length===0?'disabled':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.submit'})))),status==='success'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.success'})),status==='fail'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.fail'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#nogo',onClick:this.resetHandler.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'newsletter.tryAgain'})),'.'));}}]);return NewsLetter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NewsLetter.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(NewsLetter));

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RenderProduct_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RenderProduct_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__RenderProduct_css__);
var RenderProduct=function RenderProduct(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product',key:props.product.fields.title},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,props.product.fields.title),!props.hidePrice&&!props.product.fields.specialFormatPrice&&props.product.fields.price&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price'},props.product.fields.price.toFixed(2).replace('.',',').replace(',00','')),!props.hidePrice&&props.product.fields.specialFormatPrice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'price'},props.product.fields.specialFormatPrice.replace('.',',')),props.product.fields.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:props.product.fields.description,softBreak:'br'}));};RenderProduct.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(RenderProduct));

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(140);
var TAG = __webpack_require__(31)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
var document = __webpack_require__(39).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(47) && !__webpack_require__(77)(function () {
  return Object.defineProperty(__webpack_require__(226)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(140);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(106);
var createDesc = __webpack_require__(107);
var toIObject = __webpack_require__(78);
var toPrimitive = __webpack_require__(153);
var has = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(227);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(47) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(232);
var hiddenKeys = __webpack_require__(142).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(61);
var toIObject = __webpack_require__(78);
var arrayIndexOf = __webpack_require__(401)(false);
var IE_PROTO = __webpack_require__(148)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(56);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(225);
var ITERATOR = __webpack_require__(31)('iterator');
var Iterators = __webpack_require__(89);
module.exports = __webpack_require__(38).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 237 */
/***/ (function(module, exports) {



/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(32);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(15);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(63);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(20);
var toObject = __webpack_require__(17);
var IObject = __webpack_require__(91);
var toLength = __webpack_require__(15);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(20);
var isObject = __webpack_require__(7);
var invoke = __webpack_require__(248);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(14).f;
var create = __webpack_require__(65);
var redefineAll = __webpack_require__(69);
var ctx = __webpack_require__(33);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var $iterDefine = __webpack_require__(168);
var step = __webpack_require__(251);
var setSpecies = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(13);
var fastKey = __webpack_require__(59).fastKey;
var validate = __webpack_require__(82);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(90);
var from = __webpack_require__(240);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(69);
var getWeak = __webpack_require__(59).getWeak;
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(7);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var createArrayMethod = __webpack_require__(40);
var $has = __webpack_require__(22);
var validate = __webpack_require__(82);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(114);
var isObject = __webpack_require__(7);
var toLength = __webpack_require__(15);
var ctx = __webpack_require__(33);
var IS_CONCAT_SPREADABLE = __webpack_require__(10)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(161)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 248 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(7);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(4);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(170);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(118);
var pIE = __webpack_require__(92);
var toObject = __webpack_require__(17);
var IObject = __webpack_require__(91);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14);
var anObject = __webpack_require__(4);
var getKeys = __webpack_require__(67);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(29);
var gOPN = __webpack_require__(66).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(22);
var toIObject = __webpack_require__(29);
var arrayIndexOf = __webpack_require__(110)(false);
var IE_PROTO = __webpack_require__(174)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(67);
var toIObject = __webpack_require__(29);
var isEnum = __webpack_require__(92).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(66);
var gOPS = __webpack_require__(118);
var anObject = __webpack_require__(4);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(81).trim;

module.exports = 1 / $parseFloat(__webpack_require__(178) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(81).trim;
var ws = __webpack_require__(178);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var isObject = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(172);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(15);
var repeat = __webpack_require__(177);
var defined = __webpack_require__(42);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(44);
var toLength = __webpack_require__(15);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(10);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(243);
var validate = __webpack_require__(82);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(111)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(13) && /./g.flags != 'g') __webpack_require__(14).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(113)
});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(243);
var validate = __webpack_require__(82);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(111)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(40)(0);
var redefine = __webpack_require__(24);
var meta = __webpack_require__(59);
var assign = __webpack_require__(255);
var weak = __webpack_require__(245);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var validate = __webpack_require__(82);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(111)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(640),
    decode = __webpack_require__(638);

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(30);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(690)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(922);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(707);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(189),
    getRawTag = __webpack_require__(722),
    objectToString = __webpack_require__(743);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(717),
    getValue = __webpack_require__(723);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(129)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(351);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(761);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(129),__webpack_require__(1),__webpack_require__(850)):"function"==typeof define&&define.amd?define(["moment","react","react-onclickoutside"],t):"object"==typeof exports?exports.DatePicker=t(require("moment"),require("react"),require("react-onclickoutside")):e.DatePicker=t(e.moment,e.React,e.onClickOutside)}(this,function(e,t,n){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(1),u=r(c),l=n(4),f=r(l),d=n(5),h=(r(d),n(21)),m=r(h),y=n(11),v=r(y),b=n(18),g=n(2),w=r(g),_=n(12),D=r(_),k="react-datepicker-ignore-onclickoutside",O=(0,D.default)(u.default),E=function(e){function t(e){a(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.getPreSelection=function(){return n.props.openToDate?(0,w.default)(n.props.openToDate):n.props.selectsEnd&&n.props.startDate?(0,w.default)(n.props.startDate):n.props.selectsStart&&n.props.endDate?(0,w.default)(n.props.endDate):"undefined"!=typeof n.props.utcOffset?w.default.utc().utcOffset(n.props.utcOffset):(0,w.default)()},n.calcInitialState=function(){var e=n.getPreSelection(),t=(0,b.getEffectiveMinDate)(n.props),r=(0,b.getEffectiveMaxDate)(n.props),o=t&&e.isBefore(t)?t:r&&e.isAfter(r)?r:e;return{open:!1,preventFocus:!1,preSelection:n.props.selected?(0,w.default)(n.props.selected):o}},n.clearPreventFocusTimeout=function(){n.preventFocusTimeout&&clearTimeout(n.preventFocusTimeout)},n.setFocus=function(){n.input.focus()},n.setOpen=function(e){n.setState({open:e,preSelection:e&&n.state.open?n.state.preSelection:n.calcInitialState().preSelection})},n.handleFocus=function(e){n.state.preventFocus||(n.props.onFocus(e),n.setOpen(!0))},n.cancelFocusInput=function(){clearTimeout(n.inputFocusTimeout),n.inputFocusTimeout=null},n.deferFocusInput=function(){n.cancelFocusInput(),n.inputFocusTimeout=setTimeout(function(){return n.setFocus()},1)},n.handleDropdownFocus=function(){n.cancelFocusInput()},n.handleBlur=function(e){n.state.open?n.deferFocusInput():n.props.onBlur(e)},n.handleCalendarClickOutside=function(e){n.props.inline||n.setOpen(!1),n.props.onClickOutside(e),n.props.withPortal&&e.preventDefault()},n.handleChange=function(e){if(!n.props.onChangeRaw||(n.props.onChangeRaw(e),!e.isDefaultPrevented())){n.setState({inputValue:e.target.value});var t=(0,b.parseDate)(e.target.value,n.props);!t&&e.target.value||n.setSelected(t,e,!0)}},n.handleSelect=function(e,t){n.setState({preventFocus:!0},function(){return n.preventFocusTimeout=setTimeout(function(){return n.setState({preventFocus:!1})},50),n.preventFocusTimeout}),n.setSelected(e,t),n.props.shouldCloseOnSelect?n.props.inline||n.setOpen(!1):n.setPreSelection(e)},n.setSelected=function(e,t,r){var o=e;null!==o&&(0,b.isDayDisabled)(o,n.props)||((0,b.isSameDay)(n.props.selected,o)&&!n.props.allowSameDay||(null!==o&&(n.props.selected&&(o=(0,w.default)(o).set({hour:n.props.selected.hour(),minute:n.props.selected.minute(),second:n.props.selected.second()})),n.setState({preSelection:o})),n.props.onChange(o,t)),n.props.onSelect(o,t),r||n.setState({inputValue:null}))},n.setPreSelection=function(e){var t="undefined"!=typeof n.props.minDate&&"undefined"!=typeof n.props.maxDate,r=!t||!e||(0,b.isDayInRange)(e,n.props.minDate,n.props.maxDate);r&&n.setState({preSelection:e})},n.handleTimeChange=function(e){var t=n.props.selected?n.props.selected:n.getPreSelection(),r=t.clone().set({hour:e.get("hours"),minute:e.get("minutes")});n.setState({preSelection:r}),n.props.onChange(r)},n.onInputClick=function(){n.props.disabled||n.setOpen(!0)},n.onInputKeyDown=function(e){n.props.onKeyDown(e);var t=e.key;if(!n.state.open&&!n.props.inline)return void("Enter"!==t&&"Escape"!==t&&"Tab"!==t&&n.onInputClick());var r=(0,w.default)(n.state.preSelection);if("Enter"===t)e.preventDefault(),w.default.isMoment(n.state.preSelection)||w.default.isDate(n.state.preSelection)?(n.handleSelect(r,e),!n.props.shouldCloseOnSelect&&n.setPreSelection(r)):n.setOpen(!1);else if("Escape"===t)e.preventDefault(),n.setOpen(!1);else if("Tab"===t)n.setOpen(!1);else if(!n.props.disabledKeyboardNavigation){var o=void 0;switch(t){case"ArrowLeft":e.preventDefault(),o=r.subtract(1,"days");break;case"ArrowRight":e.preventDefault(),o=r.add(1,"days");break;case"ArrowUp":e.preventDefault(),o=r.subtract(1,"weeks");break;case"ArrowDown":e.preventDefault(),o=r.add(1,"weeks");break;case"PageUp":e.preventDefault(),o=r.subtract(1,"months");break;case"PageDown":e.preventDefault(),o=r.add(1,"months");break;case"Home":e.preventDefault(),o=r.subtract(1,"years");break;case"End":e.preventDefault(),o=r.add(1,"years")}n.setPreSelection(o)}},n.onClearClick=function(e){e.preventDefault(),n.props.onChange(null,e)},n.renderCalendar=function(){return n.props.inline||n.state.open&&!n.props.disabled?f.default.createElement(O,{ref:function(e){n.calendar=e},locale:n.props.locale,dateFormat:n.props.dateFormatCalendar,useWeekdaysShort:n.props.useWeekdaysShort,dropdownMode:n.props.dropdownMode,selected:n.props.selected,preSelection:n.state.preSelection,onSelect:n.handleSelect,onWeekSelect:n.props.onWeekSelect,openToDate:n.props.openToDate,minDate:n.props.minDate,maxDate:n.props.maxDate,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,excludeDates:n.props.excludeDates,filterDate:n.props.filterDate,onClickOutside:n.handleCalendarClickOutside,formatWeekNumber:n.props.formatWeekNumber,highlightDates:n.props.highlightDates,includeDates:n.props.includeDates,inline:n.props.inline,peekNextMonth:n.props.peekNextMonth,showMonthDropdown:n.props.showMonthDropdown,showWeekNumbers:n.props.showWeekNumbers,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,forceShowMonthNavigation:n.props.forceShowMonthNavigation,scrollableYearDropdown:n.props.scrollableYearDropdown,todayButton:n.props.todayButton,weekLabel:n.props.weekLabel,utcOffset:n.props.utcOffset,outsideClickIgnoreClass:k,fixedHeight:n.props.fixedHeight,monthsShown:n.props.monthsShown,onDropdownFocus:n.handleDropdownFocus,onMonthChange:n.props.onMonthChange,dayClassName:n.props.dayClassName,showTimeSelect:n.props.showTimeSelect,onTimeChange:n.handleTimeChange,timeIntervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,className:n.props.calendarClassName,yearDropdownItemNumber:n.props.yearDropdownItemNumber},n.props.children):null},n.renderDateInput=function(){var e=(0,v.default)(n.props.className,o({},k,n.state.open)),t=n.props.customInput||f.default.createElement("input",{type:"text"}),r="string"==typeof n.props.value?n.props.value:"string"==typeof n.state.inputValue?n.state.inputValue:(0,b.safeDateFormat)(n.props.selected,n.props);return f.default.cloneElement(t,{ref:function(e){n.input=e},value:r,onBlur:n.handleBlur,onChange:n.handleChange,onClick:n.onInputClick,onFocus:n.handleFocus,onKeyDown:n.onInputKeyDown,id:n.props.id,name:n.props.name,autoFocus:n.props.autoFocus,placeholder:n.props.placeholderText,disabled:n.props.disabled,autoComplete:n.props.autoComplete,className:e,title:n.props.title,readOnly:n.props.readOnly,required:n.props.required,tabIndex:n.props.tabIndex})},n.renderClearButton=function(){return n.props.isClearable&&null!=n.props.selected?f.default.createElement("a",{className:"react-datepicker__close-icon",href:"#",onClick:n.onClearClick}):null},n.state=n.calcInitialState(),n}return s(t,e),p(t,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"L",dateFormatCalendar:"MMMM YYYY",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},utcOffset:(0,w.default)().utcOffset(),monthsShown:1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,timeIntervals:30}}}]),p(t,[{key:"componentWillReceiveProps",value:function(e){var t=this.props.selected&&this.props.selected.month(),n=e.selected&&e.selected.month();this.props.inline&&t!==n&&this.setPreSelection(e.selected)}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?f.default.createElement("div",null,this.props.inline?null:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?f.default.createElement("div",{className:"react-datepicker__portal"},e):null):f.default.createElement(m.default,{className:this.props.popperClassName,hidePopper:!this.state.open||this.props.disabled,popperModifiers:this.props.popperModifiers,targetComponent:f.default.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperComponent:e,popperPlacement:this.props.popperPlacement})}}]),t}(f.default.Component);t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(2),c=r(p),u=n(3),l=r(u),f=n(13),d=r(f),h=n(15),m=r(h),y=n(20),v=r(y),b=n(4),g=r(b),w=n(5),_=(r(w),n(11)),D=r(_),k=n(18),O=["react-datepicker__year-select","react-datepicker__month-select"],E=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return O.some(function(e){return t.indexOf(e)>=0})},C=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.handleClickOutside=function(e){n.props.onClickOutside(e)},n.handleDropdownFocus=function(e){E(e.target)&&n.props.onDropdownFocus()},n.getDateInView=function(){var e=n.props,t=e.preSelection,r=e.selected,o=e.openToDate,a=e.utcOffset,i=(0,k.getEffectiveMinDate)(n.props),s=(0,k.getEffectiveMaxDate)(n.props),p=c.default.utc().utcOffset(a),u=o||r||t;return u?u:i&&p.isBefore(i)?i:s&&p.isAfter(s)?s:p},n.localizeMoment=function(e){return e.clone().locale(n.props.locale||c.default.locale())},n.increaseMonth=function(){n.setState({date:n.state.date.clone().add(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.decreaseMonth=function(){n.setState({date:n.state.date.clone().subtract(1,"month")},function(){return n.handleMonthChange(n.state.date)})},n.handleDayClick=function(e,t){return n.props.onSelect(e,t)},n.handleDayMouseEnter=function(e){return n.setState({selectingDate:e})},n.handleMonthMouseLeave=function(){return n.setState({selectingDate:null})},n.handleMonthChange=function(e){n.props.onMonthChange&&n.props.onMonthChange(e)},n.changeYear=function(e){n.setState({date:n.state.date.clone().set("year",e)})},n.changeMonth=function(e){n.setState({date:n.state.date.clone().set("month",e)},function(){return n.handleMonthChange(n.state.date)})},n.header=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=e.clone().startOf("week"),r=[];return n.props.showWeekNumbers&&r.push(g.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),r.concat([0,1,2,3,4,5,6].map(function(e){var r=t.clone().add(e,"days"),o=n.props.useWeekdaysShort?r.localeData().weekdaysShort(r):r.localeData().weekdaysMin(r);return g.default.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))},n.renderPreviousMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,k.allDaysDisabledBefore)(n.state.date,"month",n.props))return g.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--previous",onClick:n.decreaseMonth})},n.renderNextMonthButton=function(){if(n.props.forceShowMonthNavigation||!(0,k.allDaysDisabledAfter)(n.state.date,"month",n.props)){var e=["react-datepicker__navigation","react-datepicker__navigation--next"];return n.props.showTimeSelect&&e.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&e.push("react-datepicker__navigation--next--with-today-button"),g.default.createElement("a",{className:e.join(" "),onClick:n.increaseMonth})}},n.renderCurrentMonth=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,t=["react-datepicker__current-month"];return n.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),g.default.createElement("div",{className:t.join(" ")},e.format(n.props.dateFormat))},n.renderYearDropdown=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return g.default.createElement(l.default,{dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:n.state.date.year(),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})},n.renderMonthDropdown=function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown)return g.default.createElement(d.default,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonth,month:n.state.date.month()})},n.renderTodayButton=function(){if(n.props.todayButton)return g.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(c.default.utc().utcOffset(n.props.utcOffset).startOf("date"),e)}},n.props.todayButton)},n.renderMonths=function(){for(var e=[],t=0;t<n.props.monthsShown;++t){var r=n.state.date.clone().add(t,"M"),o="month-"+t;e.push(g.default.createElement("div",{key:o,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},g.default.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),g.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--"+n.props.dropdownMode,onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==t),n.renderYearDropdown(0!==t)),g.default.createElement("div",{className:"react-datepicker__day-names"},n.header(r))),g.default.createElement(m.default,{day:r,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,formatWeekNumber:n.props.formatWeekNumber,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,utcOffset:n.props.utcOffset})))}return e},n.renderTimeSection=function(){return n.props.showTimeSelect?g.default.createElement(v.default,{selected:n.props.selected,onChange:n.props.onTimeChange,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer}):void 0},n.state={date:n.localizeMoment(n.getDateInView()),selectingDate:null,monthContainer:n.monthContainer},n}return i(t,e),s(t,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},utcOffset:c.default.utc().utcOffset(),monthsShown:1,forceShowMonthNavigation:!1}}}]),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=function(){e.setState({monthContainer:e.monthContainer})}())}},{key:"componentWillReceiveProps",value:function(e){e.preSelection&&!(0,k.isSameDay)(e.preSelection,this.props.preSelection)?this.setState({date:this.localizeMoment(e.preSelection)}):e.openToDate&&!(0,k.isSameDay)(e.openToDate,this.props.openToDate)&&this.setState({date:this.localizeMoment(e.openToDate)})}},{key:"render",value:function(){return g.default.createElement("div",{className:(0,D.default)("react-datepicker",this.props.className)},g.default.createElement("div",{className:"react-datepicker__triangle"}),this.renderPreviousMonthButton(),this.renderNextMonthButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.props.children)}}]),t}(g.default.Component);t.default=C},function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(10)),f=r(l),d=n(12),h=r(d),m=(0,h.default)(f.default),y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(){for(var e=r.props.minDate?r.props.minDate.year():1900,t=r.props.maxDate?r.props.maxDate.year():2100,n=[],o=e;o<=t;o++)n.push(c.default.createElement("option",{key:o,value:o},o));return n},r.onSelectChange=function(e){r.onChange(e.target.value)},r.renderSelectMode=function(){return c.default.createElement("select",{value:r.props.year,className:"react-datepicker__year-select",onChange:r.onSelectChange},r.renderSelectOptions())},r.renderReadView=function(e){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),c.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},r.props.year))},r.renderDropdown=function(){return c.default.createElement(m,{key:"dropdown",ref:"options",year:r.props.year,onChange:r.onChange,onCancel:r.toggleDropdown,scrollableYearDropdown:r.props.scrollableYearDropdown,yearDropdownItemNumber:r.props.yearDropdownItemNumber})},r.renderScrollMode=function(){var e=r.state.dropdownVisible,t=[r.renderReadView(!e)];return e&&t.unshift(r.renderDropdown()),t},r.onChange=function(e){r.toggleDropdown(),e!==r.props.year&&r.props.onChange(e)},r.toggleDropdown=function(){r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=void 0;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return c.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--"+this.props.dropdownMode},e)}}]),t}(c.default.Component);t.default=y},function(e,n){e.exports=t},function(e,t,n){e.exports=n(6)()},function(e,t,n){"use strict";var r=n(7),o=n(8),a=n(9);e.exports=function(){function e(e,t,n,r,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,p){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var u=[n,r,a,i,s,p],l=0;c=new Error(t.replace(/%s/g,function(){return u[l++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=r},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e,t){for(var n=[],r=0;r<2*t+1;r++)n.push(e+t-r);return n}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=r(c),l=n(5),f=(r(l),n(11)),d=r(f),h=function(e){function t(e){o(this,t);var n=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.renderOptions=function(){var e=n.props.year,t=n.state.yearsList.map(function(t){return u.default.createElement("div",{className:"react-datepicker__year-option",key:t,ref:t,onClick:n.onChange.bind(n,t)},e===t?u.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)});return t.unshift(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),t.push(u.default.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},u.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t},n.onChange=function(e){n.props.onChange(e)},n.handleClickOutside=function(){n.props.onCancel()},n.shiftYears=function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})},n.incrementYears=function(){return n.shiftYears(1)},n.decrementYears=function(){return n.shiftYears(-1)};var r=e.yearDropdownItemNumber,i=e.scrollableYearDropdown,p=r||(i?10:5);return n.state={yearsList:s(n.props.year,p)},n}return i(t,e),p(t,[{key:"render",value:function(){var e=(0,d.default)({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return u.default.createElement("div",{className:e},this.renderOptions())}}]),t}(u.default.Component);t.default=h},function(e,t,n){var r,o;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
!function(){"use strict";function n(){for(var e=[],t=0;t<arguments.length;t++){var r=arguments[t];if(r){var o=typeof r;if("string"===o||"number"===o)e.push(r);else if(Array.isArray(r))e.push(n.apply(null,r));else if("object"===o)for(var i in r)a.call(r,i)&&r[i]&&e.push(i)}}return e.join(" ")}var a={}.hasOwnProperty;"undefined"!=typeof e&&e.exports?e.exports=n:(r=[],o=function(){return n}.apply(t,r),!(void 0!==o&&(e.exports=o)))}()},function(e,t){e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(14)),f=r(l),d=n(12),h=r(d),m=n(2),y=r(m),v=(0,h.default)(f.default),b=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={dropdownVisible:!1},r.renderSelectOptions=function(e){return e.map(function(e,t){return c.default.createElement("option",{key:t,value:t},e)})},r.renderSelectMode=function(e){return c.default.createElement("select",{value:r.props.month,className:"react-datepicker__month-select",onChange:function(e){return r.onChange(e.target.value)}},r.renderSelectOptions(e))},r.renderReadView=function(e,t){return c.default.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:r.toggleDropdown},c.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},t[r.props.month]),c.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}))},r.renderDropdown=function(e){return c.default.createElement(v,{key:"dropdown",ref:"options",month:r.props.month,monthNames:e,onChange:r.onChange,onCancel:r.toggleDropdown})},r.renderScrollMode=function(e){var t=r.state.dropdownVisible,n=[r.renderReadView(!t,e)];return t&&n.unshift(r.renderDropdown(e)),n},r.onChange=function(e){r.toggleDropdown(),e!==r.props.month&&r.props.onChange(e)},r.toggleDropdown=function(){return r.setState({dropdownVisible:!r.state.dropdownVisible})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e=this,t=y.default.localeData(this.props.locale),n=[0,1,2,3,4,5,6,7,8,9,10,11].map(function(n){return t.months((0,y.default)({M:n}),e.props.dateFormat)}),r=void 0;switch(this.props.dropdownMode){case"scroll":r=this.renderScrollMode(n);break;case"select":r=this.renderSelectMode(n)}return c.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--"+this.props.dropdownMode},r)}}]),t}(c.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.renderOptions=function(){return r.props.monthNames.map(function(e,t){return c.default.createElement("div",{className:"react-datepicker__month-option",key:e,ref:e,onClick:r.onChange.bind(r,t)},r.props.month===t?c.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})},r.onChange=function(e){return r.props.onChange(e)},r.handleClickOutside=function(){return r.props.onCancel()},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),t}(c.default.Component));t.default=l},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=n(16),h=r(d),m=6,y=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleMouseLeave=function(){r.props.onMouseLeave&&r.props.onMouseLeave()},r.isWeekInMonth=function(e){var t=r.props.day,n=e.clone().add(6,"days");return e.isSame(t,"month")||n.isSame(t,"month")},r.renderWeeks=function(){for(var e=[],t=r.props.fixedHeight,n=r.props.day.clone().startOf("month").startOf("week"),o=0,a=!1;;){if(e.push(c.default.createElement(h.default,{key:o,day:n,month:r.props.day.month(),onDayClick:r.handleDayClick,onDayMouseEnter:r.handleDayMouseEnter,onWeekSelect:r.props.onWeekSelect,formatWeekNumber:r.props.formatWeekNumber,minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,showWeekNumber:r.props.showWeekNumbers,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})),a)break;o++,n=n.clone().add(1,"weeks");var i=t&&o>=m,s=!t&&!r.isWeekInMonth(n);if(i||s){if(!r.props.peekNextMonth)break;a=!0}}return e},r.getClassNames=function(){var e=r.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd;return(0,f.default)("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(n||o)})},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox"},this.renderWeeks())}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(17)),f=r(l),d=n(19),h=r(d),m=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleDayClick=function(e,t){r.props.onDayClick&&r.props.onDayClick(e,t)},r.handleDayMouseEnter=function(e){r.props.onDayMouseEnter&&r.props.onDayMouseEnter(e)},r.handleWeekClick=function(e,t,n){"function"==typeof r.props.onWeekSelect&&r.props.onWeekSelect(e,t,n)},r.formatWeekNumber=function(e){return r.props.formatWeekNumber?r.props.formatWeekNumber(e):parseInt(e.format("w"),10)},r.renderDays=function(){var e=r.props.day.clone().startOf("week"),t=[],n=r.formatWeekNumber(e);if(r.props.showWeekNumber){var o=r.props.onWeekSelect?r.handleWeekClick.bind(r,e,n):void 0;t.push(c.default.createElement(h.default,{key:"W",weekNumber:n,onClick:o}))}return t.concat([0,1,2,3,4,5,6].map(function(t){var n=e.clone().add(t,"days");return c.default.createElement(f.default,{key:t,day:n,month:r.props.month,onClick:r.handleDayClick.bind(r,n),onMouseEnter:r.handleDayMouseEnter.bind(r,n),minDate:r.props.minDate,maxDate:r.props.maxDate,excludeDates:r.props.excludeDates,includeDates:r.props.includeDates,inline:r.props.inline,highlightDates:r.props.highlightDates,selectingDate:r.props.selectingDate,filterDate:r.props.filterDate,preSelection:r.props.preSelection,selected:r.props.selected,selectsStart:r.props.selectsStart,selectsEnd:r.props.selectsEnd,startDate:r.props.startDate,endDate:r.props.endDate,dayClassName:r.props.dayClassName,utcOffset:r.props.utcOffset})}))},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){return c.default.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(2),l=r(u),f=n(4),d=r(f),h=n(5),m=(r(h),n(11)),y=r(m),v=n(18),b=function(e){function t(){var e,n,r,s;a(this,t);for(var c=arguments.length,u=Array(c),f=0;f<c;f++)u[f]=arguments[f];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),r.handleClick=function(e){!r.isDisabled()&&r.props.onClick&&r.props.onClick(e)},r.handleMouseEnter=function(e){!r.isDisabled()&&r.props.onMouseEnter&&r.props.onMouseEnter(e)},r.isSameDay=function(e){return(0,v.isSameDay)(r.props.day,e)},r.isKeyboardSelected=function(){return!r.props.inline&&!r.isSameDay(r.props.selected)&&r.isSameDay(r.props.preSelection)},r.isDisabled=function(){return(0,v.isDayDisabled)(r.props.day,r.props)},r.getHighLightedClass=function(e){var t=r.props,n=t.day,a=t.highlightDates;if(!a)return o({},e,!1);for(var i={},s=0,c=a.length;s<c;s++){var u=a[s];if(u instanceof l.default)(0,v.isSameDay)(n,u)&&(i[e]=!0);else if("object"===("undefined"==typeof u?"undefined":p(u))){var f=Object.keys(u),d=u[f[0]];if("string"==typeof f[0]&&d.constructor===Array)for(var h=0,m=d.length;h<m;h++)(0,v.isSameDay)(n,d[h])&&(i[f[0]]=!0)}}return i},r.isInRange=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isDayInRange)(t,n,o)},r.isInSelectingRange=function(){var e=r.props,t=e.day,n=e.selectsStart,o=e.selectsEnd,a=e.selectingDate,i=e.startDate,s=e.endDate;return!(!n&&!o||!a||r.isDisabled())&&(n&&s&&a.isSameOrBefore(s)?(0,v.isDayInRange)(t,a,s):!!(o&&i&&a.isSameOrAfter(i))&&(0,v.isDayInRange)(t,i,a))},r.isSelectingRangeStart=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.startDate,a=e.selectsStart;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isSelectingRangeEnd=function(){if(!r.isInSelectingRange())return!1;var e=r.props,t=e.day,n=e.selectingDate,o=e.endDate,a=e.selectsEnd;return a?(0,v.isSameDay)(t,n):(0,v.isSameDay)(t,o)},r.isRangeStart=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(n,t)},r.isRangeEnd=function(){var e=r.props,t=e.day,n=e.startDate,o=e.endDate;return!(!n||!o)&&(0,v.isSameDay)(o,t)},r.isWeekend=function(){var e=r.props.day.day();return 0===e||6===e},r.isOutsideMonth=function(){return void 0!==r.props.month&&r.props.month!==r.props.day.month()},r.getClassNames=function(e){var t=r.props.dayClassName?r.props.dayClassName(e):void 0;return(0,y.default)("react-datepicker__day",t,"react-datepicker__day--"+(0,v.getDayOfWeekCode)(r.props.day),{"react-datepicker__day--disabled":r.isDisabled(),"react-datepicker__day--selected":r.isSameDay(r.props.selected),"react-datepicker__day--keyboard-selected":r.isKeyboardSelected(),"react-datepicker__day--range-start":r.isRangeStart(),"react-datepicker__day--range-end":r.isRangeEnd(),"react-datepicker__day--in-range":r.isInRange(),"react-datepicker__day--in-selecting-range":r.isInSelectingRange(),"react-datepicker__day--selecting-range-start":r.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":r.isSelectingRangeEnd(),"react-datepicker__day--today":r.isSameDay(l.default.utc().utcOffset(r.props.utcOffset)),"react-datepicker__day--weekend":r.isWeekend(),"react-datepicker__day--outside-month":r.isOutsideMonth()},r.getHighLightedClass("react-datepicker__day--highlighted"))},s=n,i(r,s)}return s(t,e),c(t,[{key:"render",value:function(){return d.default.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-"+this.props.day.date(),role:"option"},this.props.day.date())}}]),t}(d.default.Component);b.defaultProps={utcOffset:l.default.utc().utcOffset()},t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){return e&&t?e.isSame(t,"day"):!e&&!t}function a(e,t){return e&&t?e.utcOffset()===t.utcOffset():!e&&!t}function i(e,t,n){var r=t.clone().startOf("day").subtract(1,"seconds"),o=n.clone().startOf("day").add(1,"seconds");return e.clone().startOf("day").isBetween(r,o)}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.minDate,r=t.maxDate,a=t.excludeDates,i=t.includeDates,s=t.filterDate;return n&&e.isBefore(n,"day")||r&&e.isAfter(r,"day")||a&&a.some(function(t){return o(e,t)})||i&&!i.some(function(t){return o(e,t)})||s&&!s(e.clone())||!1}function p(e,t){for(var n=t.length,r=0;r<n;r++)if(t[r].get("hours")===e.get("hours")&&t[r].get("minutes")===e.get("minutes"))return!0;return!1}function c(e,t){var n=t.minTime,r=t.maxTime;if(!n||!r)throw new Error("Both minTime and maxTime props required");var o=(0,b.default)().hours(0).minutes(0).seconds(0),a=o.clone().hours(e.get("hours")).minutes(e.get("minutes")),i=o.clone().hours(n.get("hours")).minutes(n.get("minutes")),s=o.clone().hours(r.get("hours")).minutes(r.get("minutes"));return!(a.isSameOrAfter(i)&&a.isSameOrBefore(s))}function u(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.minDate,o=n.includeDates,a=e.clone().subtract(1,t);return r&&a.isBefore(r,t)||o&&o.every(function(e){return a.isBefore(e,t)})||!1}function l(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=n.maxDate,o=n.includeDates,a=e.clone().add(1,t);return r&&a.isAfter(r,t)||o&&o.every(function(e){return a.isAfter(e,t)})||!1}function f(e){var t=e.minDate,n=e.includeDates;return n&&t?b.default.min(n.filter(function(e){return t.isSameOrBefore(e,"day")})):n?b.default.min(n):t}function d(e){var t=e.maxDate,n=e.includeDates;return n&&t?b.default.max(n.filter(function(e){return t.isSameOrAfter(e,"day")})):n?b.default.max(n):t}function h(e,t){var n=t.dateFormat,r=t.locale,o=(0,b.default)(e,n,r||b.default.locale(),!0);return o.isValid()?o:null}function m(e,t){var n=t.dateFormat,r=t.locale;return e&&e.clone().locale(r||b.default.locale()).format(Array.isArray(n)?n[0]:n)||""}function y(e){return g[e.isoWeekday()]}Object.defineProperty(t,"__esModule",{value:!0}),t.isSameDay=o,t.isSameUtcOffset=a,t.isDayInRange=i,t.isDayDisabled=s,t.isTimeDisabled=p,t.isTimeInDisabledRange=c,t.allDaysDisabledBefore=u,t.allDaysDisabledAfter=l,t.getEffectiveMinDate=f,t.getEffectiveMaxDate=d,t.parseDate=h,t.safeDateFormat=m,t.getDayOfWeekCode=y;var v=n(2),b=r(v),g={1:"mon",2:"tue",3:"wed",4:"thu",5:"fri",6:"sat",7:"sun"}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(11)),f=r(l),d=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){r.props.onClick&&r.props.onClick(e)},i=n,a(r,i)}return i(t,e),s(t,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return c.default.createElement("div",{className:(0,f.default)(e),"aria-label":"week-"+this.props.weekNumber,onClick:this.handleClick},this.props.weekNumber)}}]),t}(c.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(2)),f=r(l),d=n(18),h=function(e){function t(){var e,n,r,i;o(this,t);for(var s=arguments.length,p=Array(s),u=0;u<s;u++)p[u]=arguments[u];return n=r=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.handleClick=function(e){(r.props.minTime||r.props.maxTime)&&(0,d.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,d.isTimeDisabled)(e,r.props.excludeTimes)||r.props.onChange(e)},r.liClasses=function(e,t,n){var o=["react-datepicker__time-list-item"];return t===e.get("hours")&&n===e.get("minutes")&&o.push("react-datepicker__time-list-item--selected"),((r.props.minTime||r.props.maxTime)&&(0,d.isTimeInDisabledRange)(e,r.props)||r.props.excludeTimes&&(0,d.isTimeDisabled)(e,r.props.excludeTimes))&&o.push("react-datepicker__time-list-item--disabled"),o.join(" ")},r.renderTimes=function(){for(var e=[],t=r.props.intervals,n=r.props.selected?r.props.selected:(0,f.default)(),o=n.get("hours"),a=n.get("minutes"),i=(0,f.default)().startOf("day"),s=1440/t,p=0;p<s;p++)e.push(i.clone().add(p*t,"minutes"));return e.map(function(e,t){return c.default.createElement("li",{key:t,onClick:r.handleClick.bind(r,e),className:r.liClasses(e,o,a)},e.format("hh:mm A"))})},i=n,a(r,i)}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=60/this.props.intervals,t=this.props.selected?this.props.selected.get("hours"):(0,f.default)().get("hours");this.list.scrollTop=30*(e*t)}},{key:"render",value:function(){var e=this,t=null;return this.props.monthRef&&(t=this.props.monthRef.clientHeight-39),c.default.createElement("div",{className:"react-datepicker__time-container "+(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},c.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time"},c.default.createElement("div",{className:"react-datepicker-time__header"},"Time")),c.default.createElement("div",{className:"react-datepicker__time"},c.default.createElement("div",{className:"react-datepicker__time-box"},c.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:t?{height:t}:{}},this.renderTimes.bind(this)()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null}}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.popperPlacementPositions=void 0;var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),p=n(4),c=r(p),u=n(5),l=(r(u),n(22)),f=(t.popperPlacementPositions=["auto","auto-left","auto-right","bottom","bottom-end","bottom-start","left","left-end","left-start","right","right-end","right-start","top","top-end","top-start"],function(e){function t(){return o(this,t),a(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){var e=this.props,t=e.hidePopper,n=e.popperComponent,r=e.popperModifiers,o=e.popperPlacement,a=e.targetComponent;return c.default.createElement(l.Manager,null,c.default.createElement(l.Target,{className:"react-datepicker-wrapper"},a),!t&&c.default.createElement(l.Popper,{className:"react-datepicker-popper",modifiers:r,placement:o},n))}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperPlacement:"bottom-start"}}}]),t}(c.default.Component));t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.Arrow=t.Popper=t.Target=t.Manager=void 0;var o=n(23),a=r(o),i=n(24),s=r(i),p=n(25),c=r(p),u=n(29),l=r(u);t.Manager=a.default,t.Target=s.default,t.Popper=c.default,t.Arrow=l.default},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var p=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(4),u=(r(c),n(5)),l=r(u),f=function(e){function t(){var e,n,r,o;a(this,t);for(var s=arguments.length,p=Array(s),c=0;c<s;c++)p[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r._setTargetNode=function(e){r._targetNode=e},r._getTargetNode=function(){return r._targetNode},o=n,i(r,o)}return s(t,e),p(t,[{key:"getChildContext",value:function(){return{popperManager:{setTargetNode:this._setTargetNode,getTargetNode:this._getTargetNode}}}},{key:"render",value:function(){var e=this.props,t=e.tag,n=e.children,r=o(e,["tag","children"]);return t!==!1?(0,c.createElement)(t,r,n):n}}]),t}(c.Component);f.childContextTypes={popperManager:l.default.object.isRequired},f.propTypes={tag:l.default.oneOfType([l.default.string,l.default.bool])},f.defaultProps={tag:"div"},t.default=f},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"div":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popperManager,l=function(e){u.setTargetNode(e),"function"==typeof s&&s(e)};if("function"==typeof p){var f={ref:l};return p({targetProps:f,restProps:c})}var d=a({},c);return"string"==typeof r?d.ref=l:d.innerRef=l,(0,i.createElement)(r,d,p)};c.contextTypes={popperManager:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function p(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var c=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(4),f=(r(l),n(5)),d=r(f),h=n(26),m=r(h),y=n(27),v=r(y),b=function(e){function t(){var e,n,r,o;i(this,t);for(var a=arguments.length,p=Array(a),u=0;u<a;u++)p[u]=arguments[u];return n=r=s(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(p))),r.state={},r._setArrowNode=function(e){r._arrowNode=e},r._getTargetNode=function(){return r.context.popperManager.getTargetNode()},r._updateStateModifier={enabled:!0,order:900,fn:function(e){return(r.state.data&&!(0,v.default)(e.offsets,r.state.data.offsets)||!r.state.data)&&r.setState({data:e}),e}},r._getPopperStyle=function(){var e=r.state.data;if(!r._popper||!e)return{position:"absolute",pointerEvents:"none",opacity:0};var t=e.offsets.popper,n=(t.top,t.left,t.position);return c({position:n},e.styles)},r._getPopperPlacement=function(){return r.state.data?r.state.data.placement:void 0},r._getArrowStyle=function(){if(r.state.data&&r.state.data.offsets.arrow){var e=r.state.data.offsets.arrow,t=e.top,n=e.left;return{top:t,left:n}}return{}},o=n,s(r,o)}return p(t,e),u(t,[{key:"getChildContext",value:function(){return{popper:{setArrowNode:this._setArrowNode,getArrowStyle:this._getArrowStyle}}}},{key:"componentDidMount",value:function(){this._updatePopper()}},{key:"componentDidUpdate",value:function(e){e.placement===this.props.placement&&e.eventsEnabled===this.props.eventsEnabled||this._updatePopper(),this._popper&&e.children!==this.props.children&&this._popper.scheduleUpdate()}},{key:"componentWillUnmount",value:function(){this._destroyPopper()}},{key:"_updatePopper",value:function(){this._destroyPopper(),this._node&&this._createPopper()}},{key:"_createPopper",value:function(){var e=this.props,t=e.placement,n=e.eventsEnabled,r=c({},this.props.modifiers,{applyStyle:{enabled:!1},updateState:this._updateStateModifier});this._arrowNode&&(r.arrow={
element:this._arrowNode}),this._popper=new m.default(this._getTargetNode(),this._node,{placement:t,eventsEnabled:n,modifiers:r}),this._popper.scheduleUpdate()}},{key:"_destroyPopper",value:function(){this._popper&&this._popper.destroy()}},{key:"render",value:function(){var e=this,t=this.props,n=t.component,r=t.innerRef,i=(t.placement,t.eventsEnabled,t.modifiers,t.children),s=a(t,["component","innerRef","placement","eventsEnabled","modifiers","children"]),p=function(t){e._node=t,"function"==typeof r&&r(t)},u=this._getPopperStyle(),f=this._getPopperPlacement();if("function"==typeof i){var d=o({ref:p,style:u},"data-placement",f);return i({popperProps:d,restProps:s,scheduleUpdate:this._popper&&this._popper.scheduleUpdate})}var h=c({},s,{style:c({},s.style,u),"data-placement":f});return"string"==typeof n?h.ref=p:h.innerRef=p,(0,l.createElement)(n,h,i)}}]),t}(l.Component);b.contextTypes={popperManager:d.default.object.isRequired},b.childContextTypes={popper:d.default.object.isRequired},b.propTypes={component:d.default.oneOfType([d.default.node,d.default.func]),innerRef:d.default.func,placement:d.default.oneOf(m.default.placements),eventsEnabled:d.default.bool,modifiers:d.default.object,children:d.default.oneOfType([d.default.node,d.default.func])},b.defaultProps={component:"div",placement:"bottom",eventsEnabled:!0,modifiers:{}},t.default=b},function(e,t,n){(function(t){/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.12.3
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
!function(t,n){e.exports=n()}(this,function(){"use strict";function e(e){var t=!1,n=0,r=document.createElement("span"),o=new MutationObserver(function(){e(),t=!1});return o.observe(r,{attributes:!0}),function(){t||(t=!0,r.setAttribute("x-index",n),n+=1)}}function n(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e()},ce))}}function r(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function o(e,t){if(1!==e.nodeType)return[];var n=window.getComputedStyle(e,null);return t?n[t]:n}function a(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function i(e){if(!e||["HTML","BODY","#document"].indexOf(e.nodeName)!==-1)return window.document.body;var t=o(e),n=t.overflow,r=t.overflowX,s=t.overflowY;return/(auto|scroll)/.test(n+s+r)?e:i(a(e))}function s(e){var t=e&&e.offsetParent,n=t&&t.nodeName;return n&&"BODY"!==n&&"HTML"!==n?["TD","TABLE"].indexOf(t.nodeName)!==-1&&"static"===o(t,"position")?s(t):t:window.document.documentElement}function p(e){var t=e.nodeName;return"BODY"!==t&&("HTML"===t||s(e.firstElementChild)===e)}function c(e){return null!==e.parentNode?c(e.parentNode):e}function u(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return window.document.documentElement;var n=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=n?e:t,o=n?t:e,a=document.createRange();a.setStart(r,0),a.setEnd(o,0);var i=a.commonAncestorContainer;if(e!==i&&t!==i||r.contains(o))return p(i)?i:s(i);var l=c(e);return l.host?u(l.host,t):u(e,c(t).host)}function l(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var o=window.document.documentElement,a=window.document.scrollingElement||o;return a[n]}return e[n]}function f(e,t){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=l(t,"top"),o=l(t,"left"),a=n?-1:1;return e.top+=r*a,e.bottom+=r*a,e.left+=o*a,e.right+=o*a,e}function d(e,t){var n="x"===t?"Left":"Top",r="Left"===n?"Right":"Bottom";return+e["border"+n+"Width"].split("px")[0]+ +e["border"+r+"Width"].split("px")[0]}function h(e,t,n,r){return Math.max(t["offset"+e],t["scroll"+e],n["client"+e],n["offset"+e],n["scroll"+e],he()?n["offset"+e]+r["margin"+("Height"===e?"Top":"Left")]+r["margin"+("Height"===e?"Bottom":"Right")]:0)}function m(){var e=window.document.body,t=window.document.documentElement,n=he()&&window.getComputedStyle(t);return{height:h("Height",e,t,n),width:h("Width",e,t,n)}}function y(e){return be({},e,{right:e.left+e.width,bottom:e.top+e.height})}function v(e){var t={};if(he())try{t=e.getBoundingClientRect();var n=l(e,"top"),r=l(e,"left");t.top+=n,t.left+=r,t.bottom+=n,t.right+=r}catch(e){}else t=e.getBoundingClientRect();var a={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?m():{},s=i.width||e.clientWidth||a.right-a.left,p=i.height||e.clientHeight||a.bottom-a.top,c=e.offsetWidth-s,u=e.offsetHeight-p;if(c||u){var f=o(e);c-=d(f,"x"),u-=d(f,"y"),a.width-=c,a.height-=u}return y(a)}function b(e,t){var n=he(),r="HTML"===t.nodeName,a=v(e),s=v(t),p=i(e),c=o(t),u=+c.borderTopWidth.split("px")[0],l=+c.borderLeftWidth.split("px")[0],d=y({top:a.top-s.top-u,left:a.left-s.left-l,width:a.width,height:a.height});if(d.marginTop=0,d.marginLeft=0,!n&&r){var h=+c.marginTop.split("px")[0],m=+c.marginLeft.split("px")[0];d.top-=u-h,d.bottom-=u-h,d.left-=l-m,d.right-=l-m,d.marginTop=h,d.marginLeft=m}return(n?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(d=f(d,t)),d}function g(e){var t=window.document.documentElement,n=b(e,t),r=Math.max(t.clientWidth,window.innerWidth||0),o=Math.max(t.clientHeight,window.innerHeight||0),a=l(t),i=l(t,"left"),s={top:a-n.top+n.marginTop,left:i-n.left+n.marginLeft,width:r,height:o};return y(s)}function w(e){var t=e.nodeName;return"BODY"!==t&&"HTML"!==t&&("fixed"===o(e,"position")||w(a(e)))}function _(e,t,n,r){var o={top:0,left:0},s=u(e,t);if("viewport"===r)o=g(s);else{var p=void 0;"scrollParent"===r?(p=i(a(e)),"BODY"===p.nodeName&&(p=window.document.documentElement)):p="window"===r?window.document.documentElement:r;var c=b(p,s);if("HTML"!==p.nodeName||w(s))o=c;else{var l=m(),f=l.height,d=l.width;o.top+=c.top-c.marginTop,o.bottom=f+c.top,o.left+=c.left-c.marginLeft,o.right=d+c.left}}return o.left+=n,o.top+=n,o.right-=n,o.bottom-=n,o}function D(e){var t=e.width,n=e.height;return t*n}function k(e,t,n,r,o){var a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(e.indexOf("auto")===-1)return e;var i=_(n,r,a,o),s={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},p=Object.keys(s).map(function(e){return be({key:e},s[e],{area:D(s[e])})}).sort(function(e,t){return t.area-e.area}),c=p.filter(function(e){var t=e.width,r=e.height;return t>=n.clientWidth&&r>=n.clientHeight}),u=c.length>0?c[0].key:p[0].key,l=e.split("-")[1];return u+(l?"-"+l:"")}function O(e,t,n){var r=u(t,n);return b(n,r)}function E(e){var t=window.getComputedStyle(e),n=parseFloat(t.marginTop)+parseFloat(t.marginBottom),r=parseFloat(t.marginLeft)+parseFloat(t.marginRight),o={width:e.offsetWidth+r,height:e.offsetHeight+n};return o}function C(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function S(e,t,n){n=n.split("-")[0];var r=E(e),o={width:r.width,height:r.height},a=["right","left"].indexOf(n)!==-1,i=a?"top":"left",s=a?"left":"top",p=a?"height":"width",c=a?"width":"height";return o[i]=t[i]+t[p]/2-r[p]/2,n===s?o[s]=t[s]-r[c]:o[s]=t[C(s)],o}function M(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function P(e,t,n){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===n});var r=M(e,function(e){return e[t]===n});return e.indexOf(r)}function T(e,t,n){var o=void 0===n?e:e.slice(0,P(e,"name",n));return o.forEach(function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=e.function||e.fn;e.enabled&&r(n)&&(t.offsets.popper=y(t.offsets.popper),t.offsets.reference=y(t.offsets.reference),t=n(t,e))}),t}function x(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=O(this.state,this.popper,this.reference),e.placement=k(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.offsets.popper=S(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position="absolute",e=T(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function N(e,t){return e.some(function(e){var n=e.name,r=e.enabled;return r&&n===t})}function j(e){for(var t=[!1,"ms","Webkit","Moz","O"],n=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length-1;r++){var o=t[r],a=o?""+o+n:e;if("undefined"!=typeof window.document.body.style[a])return a}return null}function R(){return this.state.isDestroyed=!0,N(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.left="",this.popper.style.position="",this.popper.style.top="",this.popper.style[j("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function W(e,t,n,r){var o="BODY"===e.nodeName,a=o?window:e;a.addEventListener(t,n,{passive:!0}),o||W(i(a.parentNode),t,n,r),r.push(a)}function I(e,t,n,r){n.updateBound=r,window.addEventListener("resize",n.updateBound,{passive:!0});var o=i(e);return W(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function L(){this.state.eventsEnabled||(this.state=I(this.reference,this.options,this.state,this.scheduleUpdate))}function A(e,t){return window.removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound)}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function F(){this.state.eventsEnabled&&(window.cancelAnimationFrame(this.scheduleUpdate),this.state=A(this.reference,this.state))}function B(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function Y(e,t){Object.keys(t).forEach(function(n){var r="";["width","height","top","right","bottom","left"].indexOf(n)!==-1&&B(t[n])&&(r="px"),e.style[n]=t[n]+r})}function H(e,t){Object.keys(t).forEach(function(n){var r=t[n];r!==!1?e.setAttribute(n,t[n]):e.removeAttribute(n)})}function U(e){return Y(e.instance.popper,e.styles),H(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&Y(e.arrowElement,e.arrowStyles),e}function V(e,t,n,r,o){var a=O(o,t,e),i=k(n.placement,a,t,e,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return t.setAttribute("x-placement",i),Y(t,{position:"absolute"}),n}function q(e,t){var n=t.x,r=t.y,o=e.offsets.popper,a=M(e.instance.modifiers,function(e){return"applyStyle"===e.name}).gpuAcceleration;void 0!==a&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==a?a:t.gpuAcceleration,p=s(e.instance.popper),c=v(p),u={position:o.position},l={left:Math.floor(o.left),top:Math.floor(o.top),bottom:Math.floor(o.bottom),right:Math.floor(o.right)},f="bottom"===n?"top":"bottom",d="right"===r?"left":"right",h=j("transform"),m=void 0,y=void 0;if(y="bottom"===f?-c.height+l.bottom:l.top,m="right"===d?-c.width+l.right:l.left,i&&h)u[h]="translate3d("+m+"px, "+y+"px, 0)",u[f]=0,u[d]=0,u.willChange="transform";else{var b="bottom"===f?-1:1,g="right"===d?-1:1;u[f]=y*b,u[d]=m*g,u.willChange=f+", "+d}var w={"x-placement":e.placement};return e.attributes=be({},w,e.attributes),e.styles=be({},u,e.styles),e.arrowStyles=be({},e.offsets.arrow,e.arrowStyles),e}function K(e,t,n){var r=M(e,function(e){var n=e.name;return n===t}),o=!!r&&e.some(function(e){return e.name===n&&e.enabled&&e.order<r.order});if(!o){var a="`"+t+"`",i="`"+n+"`";console.warn(i+" modifier is required by "+a+" modifier in order to work, be sure to include it before "+a+"!")}return o}function z(e,t){if(!K(e.instance.modifiers,"arrow","keepTogether"))return e;var n=t.element;if("string"==typeof n){if(n=e.instance.popper.querySelector(n),!n)return e}else if(!e.instance.popper.contains(n))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var r=e.placement.split("-")[0],a=e.offsets,i=a.popper,s=a.reference,p=["left","right"].indexOf(r)!==-1,c=p?"height":"width",u=p?"Top":"Left",l=u.toLowerCase(),f=p?"left":"top",d=p?"bottom":"right",h=E(n)[c];s[d]-h<i[l]&&(e.offsets.popper[l]-=i[l]-(s[d]-h)),s[l]+h>i[d]&&(e.offsets.popper[l]+=s[l]+h-i[d]);var m=s[l]+s[c]/2-h/2,v=o(e.instance.popper,"margin"+u).replace("px",""),b=m-y(e.offsets.popper)[l]-v;return b=Math.max(Math.min(i[c]-h,b),0),e.arrowElement=n,e.offsets.arrow={},e.offsets.arrow[l]=Math.round(b),e.offsets.arrow[f]="",e}function G(e){return"end"===e?"start":"start"===e?"end":e}function X(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=we.indexOf(e),r=we.slice(n+1).concat(we.slice(0,n));return t?r.reverse():r}function J(e,t){if(N(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var n=_(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement),r=e.placement.split("-")[0],o=C(r),a=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case _e.FLIP:i=[r,o];break;case _e.CLOCKWISE:i=X(r);break;case _e.COUNTERCLOCKWISE:i=X(r,!0);break;default:i=t.behavior}return i.forEach(function(s,p){if(r!==s||i.length===p+1)return e;r=e.placement.split("-")[0],o=C(r);var c=e.offsets.popper,u=e.offsets.reference,l=Math.floor,f="left"===r&&l(c.right)>l(u.left)||"right"===r&&l(c.left)<l(u.right)||"top"===r&&l(c.bottom)>l(u.top)||"bottom"===r&&l(c.top)<l(u.bottom),d=l(c.left)<l(n.left),h=l(c.right)>l(n.right),m=l(c.top)<l(n.top),y=l(c.bottom)>l(n.bottom),v="left"===r&&d||"right"===r&&h||"top"===r&&m||"bottom"===r&&y,b=["top","bottom"].indexOf(r)!==-1,g=!!t.flipVariations&&(b&&"start"===a&&d||b&&"end"===a&&h||!b&&"start"===a&&m||!b&&"end"===a&&y);(f||v||g)&&(e.flipped=!0,(f||v)&&(r=i[p+1]),g&&(a=G(a)),e.placement=r+(a?"-"+a:""),e.offsets.popper=be({},e.offsets.popper,S(e.instance.popper,e.offsets.reference,e.placement)),e=T(e.instance.modifiers,e,"flip"))}),e}function Q(e){var t=e.offsets,n=t.popper,r=t.reference,o=e.placement.split("-")[0],a=Math.floor,i=["top","bottom"].indexOf(o)!==-1,s=i?"right":"bottom",p=i?"left":"top",c=i?"width":"height";return n[s]<a(r[p])&&(e.offsets.popper[p]=a(r[p])-n[c]),n[p]>a(r[s])&&(e.offsets.popper[p]=a(r[s])),e}function Z(e,t,n,r){var o=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),a=+o[1],i=o[2];if(!a)return e;if(0===i.indexOf("%")){var s=void 0;switch(i){case"%p":s=n;break;case"%":case"%r":default:s=r}var p=y(s);return p[t]/100*a}if("vh"===i||"vw"===i){var c=void 0;return c="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),c/100*a}return a}function $(e,t,n,r){var o=[0,0],a=["right","left"].indexOf(r)!==-1,i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),s=i.indexOf(M(i,function(e){return e.search(/,|\s/)!==-1}));i[s]&&i[s].indexOf(",")===-1&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var p=/\s*,\s*|\s+/,c=s!==-1?[i.slice(0,s).concat([i[s].split(p)[0]]),[i[s].split(p)[1]].concat(i.slice(s+1))]:[i];return c=c.map(function(e,r){var o=(1===r?!a:a)?"height":"width",i=!1;return e.reduce(function(e,t){return""===e[e.length-1]&&["+","-"].indexOf(t)!==-1?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return Z(e,o,t,n)})}),c.forEach(function(e,t){e.forEach(function(n,r){B(n)&&(o[t]+=n*("-"===e[r-1]?-1:1))})}),o}function ee(e,t){var n=t.offset,r=e.placement,o=e.offsets,a=o.popper,i=o.reference,s=r.split("-")[0],p=void 0;return p=B(+n)?[+n,0]:$(n,a,i,s),"left"===s?(a.top+=p[0],a.left-=p[1]):"right"===s?(a.top+=p[0],a.left+=p[1]):"top"===s?(a.left+=p[0],a.top-=p[1]):"bottom"===s&&(a.left+=p[0],a.top+=p[1]),e.popper=a,e}function te(e,t){var n=t.boundariesElement||s(e.instance.popper);e.instance.reference===n&&(n=s(n));var r=_(e.instance.popper,e.instance.reference,t.padding,n);t.boundaries=r;var o=t.priority,a=e.offsets.popper,i={primary:function(e){var n=a[e];return a[e]<r[e]&&!t.escapeWithReference&&(n=Math.max(a[e],r[e])),ve({},e,n)},secondary:function(e){var n="right"===e?"left":"top",o=a[n];return a[e]>r[e]&&!t.escapeWithReference&&(o=Math.min(a[n],r[e]-("right"===e?a.width:a.height))),ve({},n,o)}};return o.forEach(function(e){var t=["left","top"].indexOf(e)!==-1?"primary":"secondary";a=be({},a,i[t](e))}),e.offsets.popper=a,e}function ne(e){var t=e.placement,n=t.split("-")[0],r=t.split("-")[1];if(r){var o=e.offsets,a=o.reference,i=o.popper,s=["bottom","top"].indexOf(n)!==-1,p=s?"left":"top",c=s?"width":"height",u={start:ve({},p,a[p]),end:ve({},p,a[p]+a[c]-i[c])};e.offsets.popper=be({},i,u[r])}return e}function re(e){if(!K(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,n=M(e.instance.modifiers,function(e){return"preventOverflow"===e.name}).boundaries;if(t.bottom<n.top||t.left>n.right||t.top>n.bottom||t.right<n.left){if(e.hide===!0)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(e.hide===!1)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}function oe(e){var t=e.placement,n=t.split("-")[0],r=e.offsets,o=r.popper,a=r.reference,i=["left","right"].indexOf(n)!==-1,s=["top","left"].indexOf(n)===-1;return o[i?"left":"top"]=a[n]-(s?o[i?"width":"height"]:0),e.placement=C(t),e.offsets.popper=y(o),e}for(var ae=["native code","[object MutationObserverConstructor]"],ie=function(e){return ae.some(function(t){return(e||"").toString().indexOf(t)>-1})},se="undefined"!=typeof window,pe=["Edge","Trident","Firefox"],ce=0,ue=0;ue<pe.length;ue+=1)if(se&&navigator.userAgent.indexOf(pe[ue])>=0){ce=1;break}var le=se&&ie(window.MutationObserver),fe=le?e:n,de=void 0,he=function(){return void 0===de&&(de=navigator.appVersion.indexOf("MSIE 10")!==-1),de},me=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},ye=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),ve=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e},be=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},ge=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],we=ge.slice(3),_e={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},De={shift:{order:100,enabled:!0,fn:ne},offset:{order:200,enabled:!0,fn:ee,offset:0},preventOverflow:{order:300,enabled:!0,fn:te,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:Q},arrow:{order:500,enabled:!0,fn:z,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:J,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:oe},hide:{order:800,enabled:!0,fn:re},computeStyle:{order:850,enabled:!0,fn:q,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:U,onLoad:V,gpuAcceleration:void 0}},ke={placement:"bottom",eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:De},Oe=function(){function e(t,n){var o=this,a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};me(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=fe(this.update.bind(this)),this.options=be({},e.Defaults,a),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t.jquery?t[0]:t,this.popper=n.jquery?n[0]:n,this.options.modifiers={},Object.keys(be({},e.Defaults.modifiers,a.modifiers)).forEach(function(t){o.options.modifiers[t]=be({},e.Defaults.modifiers[t]||{},a.modifiers?a.modifiers[t]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return be({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&r(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state)}),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return ye(e,[{key:"update",value:function(){return x.call(this)}},{key:"destroy",value:function(){return R.call(this)}},{key:"enableEventListeners",value:function(){return L.call(this)}},{key:"disableEventListeners",value:function(){return F.call(this)}}]),e}();return Oe.Utils=("undefined"!=typeof window?window:t).PopperUtils,Oe.placements=ge,Oe.Defaults=ke,Oe})}).call(t,function(){return this}())},function(e,t,n){/*!
	 * is-equal-shallow <https://github.com/jonschlinkert/is-equal-shallow>
	 *
	 * Copyright (c) 2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
"use strict";var r=n(28);e.exports=function(e,t){if(!e&&!t)return!0;if(!e&&t||e&&!t)return!1;var n,o=0,a=0;for(n in t)if(a++,!r(t[n])||!e.hasOwnProperty(n)||e[n]!==t[n])return!1;for(n in e)o++;return o===a}},function(e,t){/*!
	 * is-primitive <https://github.com/jonschlinkert/is-primitive>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
"use strict";e.exports=function(e){return null==e||"function"!=typeof e&&"object"!=typeof e}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},i=n(4),s=(r(i),n(5)),p=r(s),c=function(e,t){var n=e.component,r=void 0===n?"span":n,s=e.innerRef,p=e.children,c=o(e,["component","innerRef","children"]),u=t.popper,l=function(e){u.setArrowNode(e),"function"==typeof s&&s(e)},f=u.getArrowStyle();if("function"==typeof p){var d={ref:l,style:f};return p({arrowProps:d,restProps:c})}var h=a({},c,{style:a({},f,c.style)});return"string"==typeof r?h.ref=l:h.innerRef=l,(0,i.createElement)(r,h,p)};c.contextTypes={popper:p.default.object.isRequired},c.propTypes={component:p.default.oneOfType([p.default.node,p.default.func]),innerRef:p.default.func,children:p.default.oneOfType([p.default.node,p.default.func])},t.default=c}])});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(73);

var invariant = __webpack_require__(2);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactInstrumentation = __webpack_require__(35);

var quoteAttributeValueForBrowser = __webpack_require__(824);
var warning = __webpack_require__(8);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(200);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactUpdates = __webpack_require__(46);

var warning = __webpack_require__(8);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(784);

var containsNode = __webpack_require__(662);
var focusNode = __webpack_require__(277);
var getActiveElement = __webpack_require__(278);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(83);
var DOMProperty = __webpack_require__(84);
var React = __webpack_require__(87);
var ReactBrowserEventEmitter = __webpack_require__(130);
var ReactCurrentOwner = __webpack_require__(54);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactDOMContainerInfo = __webpack_require__(778);
var ReactDOMFeatureFlags = __webpack_require__(780);
var ReactFeatureFlags = __webpack_require__(300);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(35);
var ReactMarkupChecksum = __webpack_require__(794);
var ReactReconciler = __webpack_require__(85);
var ReactUpdateQueue = __webpack_require__(203);
var ReactUpdates = __webpack_require__(46);

var emptyObject = __webpack_require__(124);
var instantiateReactComponent = __webpack_require__(311);
var invariant = __webpack_require__(2);
var setInnerHTML = __webpack_require__(134);
var shouldUpdateReactComponent = __webpack_require__(209);
var warning = __webpack_require__(8);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var React = __webpack_require__(87);

var invariant = __webpack_require__(2);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(304);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(16);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var ReactCompositeComponent = __webpack_require__(775);
var ReactEmptyComponent = __webpack_require__(299);
var ReactHostComponent = __webpack_require__(301);

var getNextDebugID = __webpack_require__(899);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);
var escapeTextContentForBrowser = __webpack_require__(133);
var setInnerHTML = __webpack_require__(134);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(54);
var REACT_ELEMENT_TYPE = __webpack_require__(790);

var getIteratorFn = __webpack_require__(821);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(199);
var warning = __webpack_require__(8);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 315 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(100)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/themeColors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.themeColors);
    global.FontIcon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _themeColors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _themeColors2 = _interopRequireDefault(_themeColors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ICON_SIZE = 24;

  /**
   * The \`FontIcon\` component is used for rendering a font-icon library's
   * icon. The default is to use the `material-icons` library, but others
   * can be used as well.
   *
   * If you are using another font-icon library that does not always create
   * icons with a perfect 1:1 scale (such as font-awesome), it is recommended
   * to update the `.md-icon` styles to set the width and height to `$md-font-icon-size`.
   * However, this will prevent different sided icons.
   *
   * ```scss
   * .md-icon.fa {
   *   height: $md-font-icon-size;
   *   width: $md-font-icon-size;
   * }
   * ```
   */

  var FontIcon = function (_PureComponent) {
    _inherits(FontIcon, _PureComponent);

    function FontIcon(props) {
      _classCallCheck(this, FontIcon);

      var _this = _possibleConstructorReturn(this, (FontIcon.__proto__ || Object.getPrototypeOf(FontIcon)).call(this));

      _initialiseProps.call(_this);

      _this.state = { styles: _this._mergeStyles(props) };
      return _this;
    }

    _createClass(FontIcon, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _props = this.props,
            style = _props.style,
            forceSize = _props.forceSize,
            forceFontSize = _props.forceFontSize;

        if (style !== nextProps.style || forceSize !== nextProps.forceSize || forceFontSize !== nextProps.forceFontSize) {
          this.setState({ styles: this._mergeStyles(nextProps) });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var styles = this.state.styles;

        var _props2 = this.props,
            iconClassName = _props2.iconClassName,
            className = _props2.className,
            children = _props2.children,
            disabled = _props2.disabled,
            primary = _props2.primary,
            secondary = _props2.secondary,
            error = _props2.error,
            inherit = _props2.inherit,
            style = _props2.style,
            forceSize = _props2.forceSize,
            forceFontSize = _props2.forceFontSize,
            props = _objectWithoutProperties(_props2, ['iconClassName', 'className', 'children', 'disabled', 'primary', 'secondary', 'error', 'inherit', 'style', 'forceSize', 'forceFontSize']);

        var classes = (0, _classnames2.default)('md-icon', iconClassName, (0, _themeColors2.default)({
          disabled: disabled,
          error: error,
          inherit: inherit,
          primary: primary,
          secondary: secondary
        }), className);

        return _react2.default.createElement(
          'i',
          _extends({}, props, { style: styles, className: classes }),
          children
        );
      }
    }]);

    return FontIcon;
  }(_react.PureComponent);

  FontIcon.propTypes = {
    /**
     * An optional style to apply.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the `FontIcon`.
     */
    className: _propTypes2.default.string,

    /**
     * The icon font library className to use to display the icon.
     */
    iconClassName: _propTypes2.default.string.isRequired,

    /**
     * Boolean if the primary theme color should be applied.
     */
    primary: _propTypes2.default.bool,

    /**
     * Boolean if the secondary theme color should be applied.
     */
    secondary: _propTypes2.default.bool,

    /**
     * Boolean if the icon is considered disabled and should inherit the
     * disabled color.
     */
    disabled: _propTypes2.default.bool,

    /**
     * Boolean if the error color should be applied to the icon.
     */
    error: _propTypes2.default.bool,

    /**
     * Boolean if the color of the icon should be inherited by parent elements.
     */
    inherit: _propTypes2.default.bool,

    /**
     * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
     * to enforce. This is useful when using other font icon libraries that do not have a consistent
     * size.
     */
    forceSize: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),

    /**
     * Boolean if the `forceSize` prop should also force the `font-size` instead of only `width` and `height`.
     */
    forceFontSize: function forceFontSize(props, propName, component) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var error = _propTypes2.default.bool.apply(_propTypes2.default, [props, propName, component].concat(args));
      if (!error && typeof props.forceSize === 'undefined' && props[propName]) {
        error = new Error('You provided a `forceFontSize` prop to the ' + component + ' component, without specifying the `forceSize` ' + ('prop. Either set the `forceSize` prop to a boolean or a number, or disable `' + propName + '`.'));
      }

      return error;
    },

    /**
     * Any children required to display the icon with the font library.
     */
    children: _propTypes2.default.node
  };
  FontIcon.defaultProps = {
    iconClassName: 'material-icons'
  };

  var _initialiseProps = function _initialiseProps() {
    this._mergeStyles = function (_ref) {
      var style = _ref.style,
          forceSize = _ref.forceSize,
          forceFontSize = _ref.forceFontSize;

      var styles = style;
      if (typeof forceSize === 'boolean') {
        styles = _extends({
          height: ICON_SIZE,
          width: ICON_SIZE,
          fontSize: forceFontSize ? ICON_SIZE : undefined
        }, style);
      } else if (typeof forceSize === 'number') {
        styles = _extends({
          height: forceSize,
          width: forceSize,
          fontSize: forceFontSize ? forceSize : undefined
        }, style);
      }

      return styles;
    };
  };

  exports.default = FontIcon;
});
//# sourceMappingURL=FontIcon.js.map

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(319);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(320);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(212);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(323);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(215);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(881);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(883);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(882);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(329);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(329);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(885);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(884);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(136);

var _Select2 = _interopRequireDefault(_Select);

var _stripDiacritics = __webpack_require__(336);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
	_propTypes2.default.string, _propTypes2.default.node]),
	multi: _propTypes2.default.bool, // multi-value input
	noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2.default.string, _propTypes2.default.node]),
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
	options: _propTypes2.default.array.isRequired, // array of options
	placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2.default.string, _propTypes2.default.node]),
	searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
	_propTypes2.default.string, _propTypes2.default.node]),
	value: _propTypes2.default.any // initial field value
};

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var transformedInputValue = inputValue;

			if (ignoreAccents) {
				transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(transformedInputValue);
			}

			this.setState({ inputValue: inputValue });
			this.loadOptions(transformedInputValue);

			// Return the original input value to avoid modifying the user's view of the input while typing.
			return inputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    multi = _props3.multi,
			    onChange = _props3.onChange,
			    placeholder = _props3.placeholder,
			    value = _props3.value;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);

	return Async;
}(_react.Component);

exports.default = Async;


Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(136);

var _Select2 = _interopRequireDefault(_Select);

var _defaultFilterOptions = __webpack_require__(334);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(335);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatableSelect = function (_React$Component) {
	_inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		_classCallCheck(this, CreatableSelect);

		var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	_createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options,
			    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions() {
			var _props2 = this.props,
			    filterOptions = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    options = _props2.options,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.select.filterOptions();

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;


			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;


			if (onInputChange) {
				onInputChange(input);
			}

			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    newOptionCreator = _props4.newOptionCreator,
			    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
			    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
				}
			});

			return children(props);
		}
	}]);

	return CreatableSelect;
}(_react2.default.Component);

;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: _defaultFilterOptions2.default,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: _defaultMenuRenderer2.default,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: _propTypes2.default.func,

	// See Select.propTypes.filterOptions
	filterOptions: _propTypes2.default.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: _propTypes2.default.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: _propTypes2.default.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: _propTypes2.default.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: _propTypes2.default.func,

	// input change handler: function (inputValue) {}
	onInputChange: _propTypes2.default.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: _propTypes2.default.func,

	// new option click handler: function (option) {}
	onNewOptionClick: _propTypes2.default.func,

	// See Select.propTypes.options
	options: _propTypes2.default.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: _propTypes2.default.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: _propTypes2.default.func
};

exports.default = CreatableSelect;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Value = function (_React$Component) {
	_inherits(Value, _React$Component);

	function Value(props) {
		_classCallCheck(this, Value);

		var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	_createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2.default.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2.default.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);

	return Value;
}(_react2.default.Component);

;

Value.propTypes = {
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
	id: _propTypes2.default.string, // Unique id for the value - used for aria
	onClick: _propTypes2.default.func, // method to handle click on value label
	onRemove: _propTypes2.default.func, // method to handle removal of the value
	value: _propTypes2.default.object.isRequired // the option object for this value
};

exports.default = Value;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;

var _Select = __webpack_require__(136);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(330);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(886);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(331);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Value = __webpack_require__(332);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Select2.default.Async = _Async2.default;
_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
_Select2.default.Creatable = _Creatable2.default;
_Select2.default.Value = _Value2.default;

exports.default = _Select2.default;
exports.Async = _Async2.default;
exports.AsyncCreatable = _AsyncCreatable2.default;
exports.Creatable = _Creatable2.default;
exports.Value = _Value2.default;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stripDiacritics = __webpack_require__(336);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2.default)(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

exports.default = filterOptions;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey,
	    onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2.default)(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2.default.createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

exports.default = menuRenderer;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stripDiacritics;
var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(101),
    _assign = __webpack_require__(11);

var ReactNoopUpdateQueue = __webpack_require__(340);

var canDefineProperty = __webpack_require__(341);
var emptyObject = __webpack_require__(124);
var invariant = __webpack_require__(2);
var lowPriorityWarning = __webpack_require__(900);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(101);

var ReactCurrentOwner = __webpack_require__(54);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(8);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {
// lazy require symbols table
var _symbols, removelist;
function symbols(code) {
    if (_symbols) return _symbols[code];
    _symbols = __webpack_require__(915);
    removelist = ['sign','cross','of','symbol','staff','hand','black','white']
        .map(function (word) {return new RegExp(word, 'gi')});
    return _symbols[code];
}

function slug(string, opts) {
    string = string.toString();
    if ('string' === typeof opts)
        opts = {replacement:opts};
    opts = opts || {};
    opts.mode = opts.mode || slug.defaults.mode;
    var defaults = slug.defaults.modes[opts.mode];
    var keys = ['replacement','multicharmap','charmap','remove','lower'];
    for (var key, i = 0, l = keys.length; i < l; i++) { key = keys[i];
        opts[key] = (key in opts) ? opts[key] : defaults[key];
    }
    if ('undefined' === typeof opts.symbols)
        opts.symbols = defaults.symbols;

    var lengths = [];
    for (var key in opts.multicharmap) {
        if (!opts.multicharmap.hasOwnProperty(key))
            continue;

        var len = key.length;
        if (lengths.indexOf(len) === -1)
            lengths.push(len);
    }

    var code, unicode, result = "";
    for (var char, i = 0, l = string.length; i < l; i++) { char = string[i];
        if (!lengths.some(function (len) {
            var str = string.substr(i, len);
            if (opts.multicharmap[str]) {
                i += len - 1;
                char = opts.multicharmap[str];
                return true;
            } else return false;
        })) {
            if (opts.charmap[char]) {
                char = opts.charmap[char];
                code = char.charCodeAt(0);
            } else {
                code = string.charCodeAt(i);
            }
            if (opts.symbols && (unicode = symbols(code))) {
                char = unicode.name.toLowerCase();
                for(var j = 0, rl = removelist.length; j < rl; j++) {
                    char = char.replace(removelist[j], '');
                }
                char = char.replace(/^\s+|\s+$/g, '');
            }
        }
        char = char.replace(/[^\w\s\-\.\_~]/g, ''); // allowed
        if (opts.remove) char = char.replace(opts.remove, ''); // add flavour
        result += char;
    }
    result = result.replace(/^\s+|\s+$/g, ''); // trim leading/trailing spaces
    result = result.replace(/[-\s]+/g, opts.replacement); // convert spaces
    result = result.replace(opts.replacement+"$",''); // remove trailing separator
    if (opts.lower)
      result = result.toLowerCase();
    return result;
};

slug.defaults = {
    mode: 'pretty',
};

slug.multicharmap = slug.defaults.multicharmap = {
    '<3': 'love', '&&': 'and', '||': 'or', 'w/': 'with',
};

// https://code.djangoproject.com/browser/django/trunk/django/contrib/admin/media/js/urlify.js
slug.charmap  = slug.defaults.charmap = {
    // latin
    'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
    'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
    'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
    'Õ': 'O', 'Ö': 'O', 'Ő': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U',
    'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH', 'ß': 'ss', 'à':'a', 'á':'a',
    'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
    'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
    'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
    'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
    'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ẞ': 'SS',
    // greek
    'α':'a', 'β':'b', 'γ':'g', 'δ':'d', 'ε':'e', 'ζ':'z', 'η':'h', 'θ':'8',
    'ι':'i', 'κ':'k', 'λ':'l', 'μ':'m', 'ν':'n', 'ξ':'3', 'ο':'o', 'π':'p',
    'ρ':'r', 'σ':'s', 'τ':'t', 'υ':'y', 'φ':'f', 'χ':'x', 'ψ':'ps', 'ω':'w',
    'ά':'a', 'έ':'e', 'ί':'i', 'ό':'o', 'ύ':'y', 'ή':'h', 'ώ':'w', 'ς':'s',
    'ϊ':'i', 'ΰ':'y', 'ϋ':'y', 'ΐ':'i',
    'Α':'A', 'Β':'B', 'Γ':'G', 'Δ':'D', 'Ε':'E', 'Ζ':'Z', 'Η':'H', 'Θ':'8',
    'Ι':'I', 'Κ':'K', 'Λ':'L', 'Μ':'M', 'Ν':'N', 'Ξ':'3', 'Ο':'O', 'Π':'P',
    'Ρ':'R', 'Σ':'S', 'Τ':'T', 'Υ':'Y', 'Φ':'F', 'Χ':'X', 'Ψ':'PS', 'Ω':'W',
    'Ά':'A', 'Έ':'E', 'Ί':'I', 'Ό':'O', 'Ύ':'Y', 'Ή':'H', 'Ώ':'W', 'Ϊ':'I',
    'Ϋ':'Y',
    // turkish
    'ş':'s', 'Ş':'S', 'ı':'i', 'İ':'I',
    'ğ':'g', 'Ğ':'G',
    // russian
    'а':'a', 'б':'b', 'в':'v', 'г':'g', 'д':'d', 'е':'e', 'ё':'yo', 'ж':'zh',
    'з':'z', 'и':'i', 'й':'j', 'к':'k', 'л':'l', 'м':'m', 'н':'n', 'о':'o',
    'п':'p', 'р':'r', 'с':'s', 'т':'t', 'у':'u', 'ф':'f', 'х':'h', 'ц':'c',
    'ч':'ch', 'ш':'sh', 'щ':'sh', 'ъ':'u', 'ы':'y', 'ь':'', 'э':'e', 'ю':'yu',
    'я':'ya',
    'А':'A', 'Б':'B', 'В':'V', 'Г':'G', 'Д':'D', 'Е':'E', 'Ё':'Yo', 'Ж':'Zh',
    'З':'Z', 'И':'I', 'Й':'J', 'К':'K', 'Л':'L', 'М':'M', 'Н':'N', 'О':'O',
    'П':'P', 'Р':'R', 'С':'S', 'Т':'T', 'У':'U', 'Ф':'F', 'Х':'H', 'Ц':'C',
    'Ч':'Ch', 'Ш':'Sh', 'Щ':'Sh', 'Ъ':'U', 'Ы':'Y', 'Ь':'', 'Э':'E', 'Ю':'Yu',
    'Я':'Ya',
    // ukranian
    'Є':'Ye', 'І':'I', 'Ї':'Yi', 'Ґ':'G', 'є':'ye', 'і':'i', 'ї':'yi', 'ґ':'g',
    // czech
    'č':'c', 'ď':'d', 'ě':'e', 'ň': 'n', 'ř':'r', 'š':'s', 'ť':'t', 'ů':'u',
    'ž':'z', 'Č':'C', 'Ď':'D', 'Ě':'E', 'Ň': 'N', 'Ř':'R', 'Š':'S', 'Ť':'T',
    'Ů':'U', 'Ž':'Z',
    // polish
    'ą':'a', 'ć':'c', 'ę':'e', 'ł':'l', 'ń':'n', 'ś':'s', 'ź':'z',
    'ż':'z', 'Ą':'A', 'Ć':'C', 'Ę':'E', 'Ł':'L', 'Ń':'N', 'Ś':'S',
    'Ź':'Z', 'Ż':'Z',
    // latvian
    'ā':'a', 'ē':'e', 'ģ':'g', 'ī':'i', 'ķ':'k', 'ļ':'l', 'ņ':'n',
    'ū':'u', 'Ā':'A', 'Ē':'E', 'Ģ':'G', 'Ī':'I',
    'Ķ':'K', 'Ļ':'L', 'Ņ':'N', 'Ū':'U',
    // lithuanian
    'ė':'e', 'į':'i', 'ų':'u', 'Ė': 'E', 'Į': 'I', 'Ų':'U',
    // romanian
    'ț':'t', 'Ț':'T', 'ţ':'t', 'Ţ':'T', 'ș':'s', 'Ș':'S', 'ă':'a', 'Ă':'A',
    // vietnamese
    'Ạ': 'A', 'Ả': 'A', 'Ầ': 'A', 'Ấ': 'A', 'Ậ': 'A', 'Ẩ': 'A', 'Ẫ': 'A',
    'Ằ': 'A', 'Ắ': 'A', 'Ặ': 'A', 'Ẳ': 'A', 'Ẵ': 'A', 'Ẹ': 'E', 'Ẻ': 'E',
    'Ẽ': 'E', 'Ề': 'E', 'Ế': 'E', 'Ệ': 'E', 'Ể': 'E', 'Ễ': 'E', 'Ị': 'I',
    'Ỉ': 'I', 'Ĩ': 'I', 'Ọ': 'O', 'Ỏ': 'O', 'Ồ': 'O', 'Ố': 'O', 'Ộ': 'O',
    'Ổ': 'O', 'Ỗ': 'O', 'Ơ': 'O', 'Ờ': 'O', 'Ớ': 'O', 'Ợ': 'O', 'Ở': 'O',
    'Ỡ': 'O', 'Ụ': 'U', 'Ủ': 'U', 'Ũ': 'U', 'Ư': 'U', 'Ừ': 'U', 'Ứ': 'U',
    'Ự': 'U', 'Ử': 'U', 'Ữ': 'U', 'Ỳ': 'Y', 'Ỵ': 'Y', 'Ỷ': 'Y', 'Ỹ': 'Y',
    'Đ': 'D', 'ạ': 'a', 'ả': 'a', 'ầ': 'a', 'ấ': 'a', 'ậ': 'a', 'ẩ': 'a',
    'ẫ': 'a', 'ằ': 'a', 'ắ': 'a', 'ặ': 'a', 'ẳ': 'a', 'ẵ': 'a', 'ẹ': 'e',
    'ẻ': 'e', 'ẽ': 'e', 'ề': 'e', 'ế': 'e', 'ệ': 'e', 'ể': 'e', 'ễ': 'e',
    'ị': 'i', 'ỉ': 'i', 'ĩ': 'i', 'ọ': 'o', 'ỏ': 'o', 'ồ': 'o', 'ố': 'o',
    'ộ': 'o', 'ổ': 'o', 'ỗ': 'o', 'ơ': 'o', 'ờ': 'o', 'ớ': 'o', 'ợ': 'o',
    'ở': 'o', 'ỡ': 'o', 'ụ': 'u', 'ủ': 'u', 'ũ': 'u', 'ư': 'u', 'ừ': 'u',
    'ứ': 'u', 'ự': 'u', 'ử': 'u', 'ữ': 'u', 'ỳ': 'y', 'ỵ': 'y', 'ỷ': 'y',
    'ỹ': 'y', 'đ': 'd',
    // currency
    '€': 'euro', '₢': 'cruzeiro', '₣': 'french franc', '£': 'pound',
    '₤': 'lira', '₥': 'mill', '₦': 'naira', '₧': 'peseta', '₨': 'rupee',
    '₩': 'won', '₪': 'new shequel', '₫': 'dong', '₭': 'kip', '₮': 'tugrik',
    '₯': 'drachma', '₰': 'penny', '₱': 'peso', '₲': 'guarani', '₳': 'austral',
    '₴': 'hryvnia', '₵': 'cedi', '¢': 'cent', '¥': 'yen', '元': 'yuan',
    '円': 'yen', '﷼': 'rial', '₠': 'ecu', '¤': 'currency', '฿': 'baht',
    "$": 'dollar', '₹': 'indian rupee',
    // symbols
    '©':'(c)', 'œ': 'oe', 'Œ': 'OE', '∑': 'sum', '®': '(r)', '†': '+',
    '“': '"', '”': '"', '‘': "'", '’': "'", '∂': 'd', 'ƒ': 'f', '™': 'tm',
    '℠': 'sm', '…': '...', '˚': 'o', 'º': 'o', 'ª': 'a', '•': '*',
    '∆': 'delta', '∞': 'infinity', '♥': 'love', '&': 'and', '|': 'or',
    '<': 'less', '>': 'greater',
};

slug.defaults.modes = {
    rfc3986: {
        replacement: '-',
        symbols: true,
        remove: null,
        lower: true,
        charmap: slug.defaults.charmap,
        multicharmap: slug.defaults.multicharmap,
    },
    pretty: {
        replacement: '-',
        symbols: true,
        remove: /[.]/g,
        lower: false,
        charmap: slug.defaults.charmap,
        multicharmap: slug.defaults.multicharmap,
    },
};

// Be compatible with different module systems

if (true) { // AMD
    // dont load symbols table in the browser
    for (var key in slug.defaults.modes) {
        if (!slug.defaults.modes.hasOwnProperty(key))
            continue;

        slug.defaults.modes[key].symbols = false;
    }
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {return slug}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module !== 'undefined' && module.exports) { // CommonJS
    symbols(); // preload symbols table
    module.exports = slug;
} else { // Script tag
    // dont load symbols table in the browser
    for (var key in slug.defaults.modes) {
        if (!slug.defaults.modes.hasOwnProperty(key))
            continue;

        slug.defaults.modes[key].symbols = false;
    }
    root.slug = slug;
}

}(this));


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_intl__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__redux_store__ = __webpack_require__(376);
// import './index.css';
function getParameterByName(name){var match=RegExp('[?&]'+name+'=([^&]*)').exec(window.location.search);return match&&decodeURIComponent(match[1].replace(/\+/g,' '));}var lang=getParameterByName('lang');if(['fi','en'].indexOf(lang)>-1&&lang!==__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].getState().lang){__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__redux_actions__["a" /* switchLang */])());}var locale=__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */].getState().lang;var intl=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_intl__["a" /* getIntl */])(locale);__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_11__redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* IntlProvider */],intl,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */],null)))),document.getElementById('app-container'));__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(758).enable();
  window.Promise = __webpack_require__(757);
}

// fetch() polyfill for making API calls.
__webpack_require__(917);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(11);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_FrontPage__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_MenuPage__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ContentPage__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ContactPage__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_Header_Header__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_Footer_Footer__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Shopify_Cart__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_shopifyAPI__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_css__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.state={isCartOpen:false,checkout:{lineItems:[]}};_this.handleCartToggle=_this.handleCartToggle.bind(_this);_this.addVariantToCart=_this.addVariantToCart.bind(_this);_this.updateQuantityInCart=_this.updateQuantityInCart.bind(_this);_this.removeLineItemInCart=_this.removeLineItemInCart.bind(_this);return _this;}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_10__api_shopifyAPI__["a" /* shopClient */].createCart({}).then(function(res){_this2.setState({checkout:res});});}},{key:'addVariantToCart',value:function addVariantToCart(variant,quantity){var _this3=this;this.setState({isCartOpen:true});var lineItemsToAdd={variant:variant,quantity:parseInt(quantity,10)};return this.state.checkout.createLineItemsFromVariants(lineItemsToAdd).then(function(res){_this3.setState({checkout:res});});}},{key:'updateQuantityInCart',value:function updateQuantityInCart(lineItemId,quantity){var _this4=this;return this.state.checkout.updateLineItem(lineItemId,quantity).then(function(res){_this4.setState({checkout:res});});}},{key:'removeLineItemInCart',value:function removeLineItemInCart(lineItemId){var _this5=this;return this.state.checkout.removeLineItem([lineItemId]).then(function(res){_this5.setState({checkout:res});});}},{key:'handleCartToggle',value:function handleCartToggle(){if(this.state.isCartOpen){this.setState({isCartOpen:false});}else{this.setState({isCartOpen:true});}}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a,{titleTemplate:'%s \u2013 Gaijin',meta:[{"property":"og:url","content":window.location.href},{"property":"og:type","content":"website"}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Shopify_Cart__["a" /* default */],{checkout:this.state.checkout,isCartOpen:this.state.isCartOpen,handleCartToggle:this.handleCartToggle,updateQuantityInCart:this.updateQuantityInCart,removeLineItemInCart:this.removeLineItemInCart}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/:slug?',component:__WEBPACK_IMPORTED_MODULE_7__containers_Header_Header__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_3__containers_FrontPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/menu/:slug/:subslug?',component:__WEBPACK_IMPORTED_MODULE_4__containers_MenuPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/contact',component:__WEBPACK_IMPORTED_MODULE_6__containers_ContactPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/:slug',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_ContentPage__["a" /* default */],Object.assign({},props,{addVariantToCart:_this6.addVariantToCart}));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__containers_Footer_Footer__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNavi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getReservationTexts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFront; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBlogs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_contentful__);
var SPACE_ID="tbu6yo6b5o8c"||'tbu6yo6b5o8c';var ACCESS_TOKEN="e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7"||'e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7';var HOST="cdn.contentful.com"||'cdn.contentful.com';var SITE='Gaijin';var client=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful__["createClient"])({space:SPACE_ID,accessToken:ACCESS_TOKEN,host:HOST});// get navigation
var getNavi=function getNavi(locale){return client.getEntries({content_type:'navigation','fields.site':SITE,limit:1,include:2,locale:locale,select:['fields.entries']}).then(function(response){return response.items[0].fields.entries;}).catch(function(error){console.log('error occured');console.log(error);});};var getPage=function getPage(slug,locale){return client.getEntries({content_type:'page','fields.site':SITE,'fields.slug':slug,include:2,locale:locale,select:['fields.slug','fields.title','fields.elements']}).then(function(response){return response.items[0].fields;}).catch(function(error){console.log('error occured');console.log(error);});};var getReservationTexts=function getReservationTexts(locale){return client.getEntries({content_type:'reservationTexts','fields.site':SITE,limit:1,locale:locale,select:['fields.backgroundImage','fields.onlineBookingInfo','fields.groupReservationInfo']}).then(function(response){return Object.assign({},response.items[0].fields);}).catch(function(error){console.log('error occured');console.log(error);});};// get open hours
var getHours=function getHours(locale){return client.getEntries({content_type:'contactUs','fields.site':SITE,limit:1,locale:locale,select:['fields.openingHours']}).then(function(response){return response.items[0].fields.openingHours;}).catch(function(error){console.log('error occured');console.log(error);});};// get front page
var getFront=function getFront(locale){return client.getEntries({content_type:'frontPage','fields.site':SITE,limit:1,include:10,locale:locale,select:['fields.header','fields.lifts','fields.containers']}).then(function(response){return{"header":response.items[0].fields.header.fields,"lifts":response.items[0].fields.lifts,"containers":response.items[0].fields.containers};}).catch(function(error){console.log('error occured');console.log(error);});};// get Menus
var getMenus=function getMenus(locale){return client.getEntries({content_type:'menu','fields.site':SITE,order:'fields.order',locale:locale,include:10}).then(function(response){return response.items;}).catch(function(error){console.log('error occured');console.log(error);});};// get open hours
var getContact=function getContact(locale){return client.getEntries({content_type:'contactUs','fields.site':SITE,limit:1,include:2,locale:locale,select:['fields.header','fields.leftColumn','fields.rightColumn']}).then(function(response){return{"header":response.items[0].fields.header.fields,"leftColumn":response.items[0].fields.leftColumn,"rightColumn":response.items[0].fields.rightColumn};}).catch(function(error){console.log('error occured');console.log(error);});};// get Blogs
var getBlogs=function getBlogs(locale){var limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var offset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return client.getEntries({content_type:'blogPost','fields.site':SITE,order:'-fields.published',limit:limit,skip:offset,locale:locale// include: 10
}).then(function(response){return response.items;}).catch(function(error){console.log('error occured');console.log(error);});};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDate; });
var BACKUP_URL='https://ottoboni.fi.cloudplatform.fi/helpers/currentdate/CurrentDate.php';var getDate=function getDate(){return fetch(document.location).then(function(response){if(response.headers.has('Date')){return response.headers.get('Date');}// Resort to Ottoboni date helper as a backup-plan
return fetch(BACKUP_URL).then(function(response){return response.text();}).then(function(text){return text;});});};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
var Address=function Address(_ref){var intl=_ref.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Gaijin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('address',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.google.fi/maps/place/Bulevardi+6,+00120+Helsinki/',rel:'noopener noreferrer'},'Bulevardi 6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'00120 Helsinki'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:info@gaijin.fi'},'info@gaijin.fi'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'tel:+358103229386'},intl.locale==='en'?'+358 ':'0','10 322 9386'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.facebook.com/ravintola.gaijin/',className:'some facebook'},'Facebook'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.linkedin.com/company/bw-restaurants-oy/',className:'some linkedin'},'LinkedIn'));};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Address));

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactForm_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ContactForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RECAPTCHA_KEY='6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';var encode=function encode(data){return Object.keys(data).map(function(key){return encodeURIComponent(key)+"="+encodeURIComponent(data[key]);}).join("&");};var ContactForm=function(_Component){_inherits(ContactForm,_Component);function ContactForm(props){_classCallCheck(this,ContactForm);var _this=_possibleConstructorReturn(this,(ContactForm.__proto__||Object.getPrototypeOf(ContactForm)).call(this,props));_this.state={subject:'Gaijin '+(_this.props.intl.locale==="fi"?'tiedustelu':'contact request'),language:_this.props.intl.locale,name:'',email:'',phone:'',message:'',success:false,error:false};return _this;}_createClass(ContactForm,[{key:'handleChange',value:function handleChange(field,value){this.setState(_defineProperty({},field,value));}},{key:'handleRecaptcha',value:function handleRecaptcha(value){this.setState({"g-recaptcha-response":value});}},{key:'handleSubmit',value:function handleSubmit(e){var _this2=this;e.preventDefault();if(this.state.email&&this.state.message){fetch("/",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:encode(Object.assign({"form-name":"contact"},this.state))}).then(function(){return _this2.setState({success:true,error:false});}).catch(function(error){return _this2.setState({success:false,error:true});});}else{this.setState({error:true});}}},{key:'render',value:function render(){var _this3=this;var labels=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["e" /* defineMessages */])({name:{id:'contactForm.name'},email:{id:'contactForm.email'},phone:{id:'contactForm.phone'},message:{id:'contactForm.message'},submit:{id:'contactForm.submit'}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'contactForm.heading'})),!this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'contact',onSubmit:this.handleSubmit.bind(this),'data-netlify-recaptcha':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'bot-field',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'contactForm.description'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'name',className:'md-cell',label:this.props.intl.formatMessage(labels.name),onChange:function onChange(e){return _this3.handleChange('name',e);},value:this.state.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'email',type:'email',className:'md-cell',required:true,label:this.props.intl.formatMessage(labels.email),onChange:function onChange(e){return _this3.handleChange('email',e);},value:this.state.email}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'phone',className:'md-cell',label:this.props.intl.formatMessage(labels.phone),onChange:function onChange(e){return _this3.handleChange('phone',e);},value:this.state.phone}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'message',className:'md-cell',rows:3,required:true,label:this.props.intl.formatMessage(labels.message),onChange:function onChange(e){return _this3.handleChange('message',e);},value:this.state.message}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_google_recaptcha__["a" /* default */],{ref:'recaptcha',sitekey:RECAPTCHA_KEY,onChange:function onChange(val){return _this3.handleRecaptcha(val);},theme:'dark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.state['g-recaptcha-response'],type:'submit'},this.props.intl.formatMessage(labels.submit)))),!this.state.success&&this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'contactForm.fail'})),this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'success'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'contactForm.success'})));}}]);return ContactForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContactForm.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContactForm));

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Facebook=function(_Component){_inherits(Facebook,_Component);function Facebook(){_classCallCheck(this,Facebook);return _possibleConstructorReturn(this,(Facebook.__proto__||Object.getPrototypeOf(Facebook)).apply(this,arguments));}_createClass(Facebook,[{key:"componentDidMount",value:function componentDidMount(){if(window.FB){window.FB.XFBML.parse();}else{window.fbAsyncInit=function(){window.FB.init({xfbml:true,version:"v18.0"});};var script=document.createElement("script");script.src="https://connect.facebook.net/en_US/sdk.js";script.async=true;script.defer=true;script.crossOrigin="anonymous";script.nonce="fb_plugin";document.body.appendChild(script);}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fb-page","data-href":"https://www.facebook.com/ravintola.gaijin","data-tabs":"timeline","data-width":"500","data-height":"500","data-small-header":"true","data-adapt-container-width":"true","data-hide-cover":"false","data-show-facepile":"false"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("blockquote",{cite:"https://www.facebook.com/ravintola.gaijin",className:"fb-xfbml-parse-ignore"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.facebook.com/ravintola.gaijin"},"Ravintola Gaijin")));}}]);return Facebook;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Facebook);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
var Hours=function Hours(_ref){var text=_ref.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'open-hours'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:text,softBreak:'br'})));};/* harmony default export */ __webpack_exports__["a"] = (Hours);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
// intl.locale
var LangWrapper=function LangWrapper(_ref){var onSwitch=_ref.onSwitch,intl=_ref.intl;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lang-wrapper'},intl.locale==='fi'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'FIN'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',onClick:function onClick(e){e.preventDefault();onSwitch();}},'FIN'),intl.locale==='fi'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',onClick:function onClick(e){e.preventDefault();onSwitch();}},'ENG'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'ENG'));};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(LangWrapper));

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Map_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import GoogleMapsStyles from './GoogleMapsStyles.json'
import MarkerImage from './poi.svg'*//*import MarkerFarang from './farang.png'
import MarkerBoulevardSocial from './boulevard-social.png'
import MarkerBronda from './bronda.png'
import MarkerLevain from './levain.png'*/var Map=function(_Component){_inherits(Map,_Component);function Map(){_classCallCheck(this,Map);return _possibleConstructorReturn(this,(Map.__proto__||Object.getPrototypeOf(Map)).apply(this,arguments));}_createClass(Map,[{key:'render',/*  componentDidMount() {
    const latLng = {lat: 60.165974, lng: 24.942055}

    const FarangPosition = {lat: 60.171952, lng: 24.931447}
    const GaijinPosition = {lat: 60.165974, lng: 24.942055}
    const BoulevardSocialPosition = GaijinPosition
    const BrondaPosition = {lat: 60.167011, lng: 24.945389}
    const LevainPosition = {lat: 60.159273, lng: 24.936880}

    const map = new window.google.maps.Map(this.refs.map, {
      zoom: 17,
      minZoom: 13,
      maxZoom: 18,
      center: latLng,
      mapTypeId: 'roadmap',
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      styles: GoogleMapsStyles
    });

    const Marker = {
      url: MarkerImage,
      size: new window.google.maps.Size(52,75),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,75)
    };

    const Farang = {
      url: MarkerFarang,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const BoulevardSocial = {
      url: MarkerBoulevardSocial,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Bronda = {
      url: MarkerBronda,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Levain = {
      url: MarkerLevain,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    new window.google.maps.Marker({
      position: latLng,
      map: map,
      icon: Marker
    });

    new window.google.maps.Marker({
      position: FarangPosition,
      map: map,
      icon: Farang
    });

    new window.google.maps.Marker({
      position: BoulevardSocialPosition,
      map: map,
      icon: BoulevardSocial
    });

    new window.google.maps.Marker({
      position: BrondaPosition,
      map: map,
      icon: Bronda
    });

    new window.google.maps.Marker({
      position: LevainPosition,
      map: map,
      icon: Levain
    });

    const center = map.getCenter();

    window.google.maps.event.addListenerOnce(map, 'idle', function() {
      window.google.maps.event.trigger(map, 'resize');
      map.setCenter(center);
    })
    window.google.maps.event.addDomListener(window, 'resize', function() {
      map.setCenter(center);
    })
  }*/value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'google-map',ref:'map'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'map-contributors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://leafletjs.com',title:'A JS library for interactive maps'},'Leaflet'),' | \xA9 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.openstreetmap.org/copyright'},'OpenStreetMap'),' \xA9 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://cartodb.com/attributions'},'CartoDB'))));}}]);return Map;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Map);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datepicker__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_google_recaptcha__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OfferForm_css__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OfferForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__OfferForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RECAPTCHA_KEY='6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';var encode=function encode(data){return Object.keys(data).map(function(key){return encodeURIComponent(key)+"="+encodeURIComponent(data[key]);}).join("&");};var OfferForm=function(_Component){_inherits(OfferForm,_Component);function OfferForm(props){_classCallCheck(this,OfferForm);var _this=_possibleConstructorReturn(this,(OfferForm.__proto__||Object.getPrototypeOf(OfferForm)).call(this,props));_this.state={subject:'Gaijin '+(_this.props.intl.locale==="fi"?'Premium Catering tarjouspyyntö':'Premium Catering request'),language:_this.props.intl.locale,name:'',company:'',email:'',phone:'',date:'',time:'',location:'',people:'',event:'',// restaurant: [],
description:'',dishes:'',service:[],budget:'',success:false,error:false};return _this;}_createClass(OfferForm,[{key:'handleChange',value:function handleChange(field,value){this.setState(_defineProperty({},field,value));}},{key:'handleRecaptcha',value:function handleRecaptcha(value){this.setState({"g-recaptcha-response":value});}},{key:'handleCheckbox',value:function handleCheckbox(name,checkbox){var array=void 0;if(name==='restaurant'){array=this.state.restaurant;}if(name==='service'){array=this.state.service;}if(array.indexOf(checkbox)===-1){array.push(checkbox);}else{var index=array.indexOf(checkbox);array.splice(index,1);}this.setState(_defineProperty({},name,array));}},{key:'handleSubmit',value:function handleSubmit(e){var _this2=this;e.preventDefault();if(this.state.name&&this.state.email&&this.state.phone&&this.state.date&&this.state.people&&this.state.budget){fetch("/",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:encode(Object.assign({"form-name":"offer"},this.state))}).then(function(){return _this2.setState({success:true,error:false});}).catch(function(error){return _this2.setState({success:false,error:true});});}else{this.setState({error:true});}}},{key:'render',value:function render(){var _this3=this;var options=[{value:'cocktail',label:this.props.intl.messages["offerForm.serviceTypeCocktail"]},{value:'buffet',label:this.props.intl.messages["offerForm.serviceTypeBuffet"]},{value:'dinner',label:this.props.intl.messages["offerForm.serviceTypeDinner"]}];var fiLocale=__webpack_require__(288);__WEBPACK_IMPORTED_MODULE_5_moment___default.a.locale('fi',fiLocale);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'offer',className:'offer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.intl.messages["offerForm.heading"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.intl.messages["offerForm.description"])),!this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit.bind(this),'data-netlify-recaptcha':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'form-name',value:'offer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'bot-field',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'name',label:this.props.intl.messages["offerForm.name"],onChange:function onChange(e){return _this3.handleChange('name',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'company',label:this.props.intl.messages["offerForm.company"],onChange:function onChange(e){return _this3.handleChange('company',e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'email',type:'email',label:this.props.intl.messages["offerForm.email"],onChange:function onChange(e){return _this3.handleChange('email',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'phone',type:'tel',label:this.props.intl.messages["offerForm.phone"],onChange:function onChange(e){return _this3.handleChange('phone',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'halfwidth'},this.state.date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'datepicker-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'date',className:'md-floating-label md-floating-label--floating'},this.props.intl.messages["offerForm.date"],' *')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datepicker___default.a,{locale:'fi',placeholderText:this.props.intl.messages["offerForm.date"]+' *',selected:this.state.date,onChange:function onChange(e){return _this3.setState({date:e});},minDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()(),maxDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(365,"days")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'time',className:'halfwidth',label:this.props.intl.messages["offerForm.time"],onChange:function onChange(e){return _this3.handleChange('time',e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'location',label:this.props.intl.messages["offerForm.location"],onChange:function onChange(e){return _this3.handleChange('location',e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-wrapper'},this.state.serviceType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'serviceType',className:'md-floating-label md-floating-label--floating'},this.props.intl.messages["offerForm.serviceType"],' *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select___default.a,{name:'form-field-name',clearable:false,searchable:false,openOnFocus:true,placeholder:this.props.intl.messages["offerForm.serviceType"],value:this.state.serviceType,options:options,onChange:function onChange(e){return _this3.setState({serviceType:e.value});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'eventType',type:'tel',label:this.props.intl.messages["offerForm.eventType"],onChange:function onChange(e){return _this3.handleChange('eventType',e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'people',className:'halfwidth',label:this.props.intl.messages["offerForm.people"],onChange:function onChange(e){return _this3.handleChange('people',e);},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,this.props.intl.messages["offerForm.premisesHeading"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.intl.messages["offerForm.premisesDescription"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'description',rows:3,onChange:function onChange(e){return _this3.handleChange('description',e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,this.props.intl.messages["offerForm.dishesHeading"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control radio'},this.props.intl.messages["offerForm.dishesYes"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'dishes',value:'yes',checked:this.state.dishes==='yes',onChange:function onChange(e){return _this3.handleChange('dishes',e.currentTarget.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control radio'},this.props.intl.messages["offerForm.dishesNo"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',name:'dishes',value:'no',checked:this.state.dishes==='no',onChange:function onChange(e){return _this3.handleChange('dishes',e.currentTarget.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',{className:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,this.props.intl.messages["offerForm.activityHeading"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.intl.messages["offerForm.activityDescription"],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* Link */],{to:'/ohjelmapalvelut'},this.props.intl.locale==='fi'?'täällä':'here'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control checkbox'},this.props.intl.messages["offerForm.activityCocktailSchool"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'service',value:'cocktail',onChange:function onChange(e){return _this3.handleCheckbox('service',e.currentTarget.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control checkbox'},this.props.intl.messages["offerForm.activitySakeTasting"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'service',value:'saketasting',onChange:function onChange(e){return _this3.handleCheckbox('service',e.currentTarget.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control checkbox'},this.props.intl.messages["offerForm.activityWineTasting"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',name:'service',value:'winetasting',onChange:function onChange(e){return _this3.handleCheckbox('service',e.currentTarget.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'indicator'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'budget',className:'halfwidth',label:this.props.intl.messages["offerForm.budget"],onChange:function onChange(e){return _this3.handleChange('budget',e);},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_google_recaptcha__["a" /* default */],{ref:'recaptcha',sitekey:RECAPTCHA_KEY,onChange:function onChange(val){return _this3.handleRecaptcha(val);},theme:'dark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.state['g-recaptcha-response'],className:'btn',type:'submit'},this.props.intl.messages["offerForm.submit"])),!this.state.success&&this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fail'},this.props.intl.messages["offerForm.fail"]),this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'success'},this.props.intl.messages["offerForm.success"]));}}]);return OfferForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);OfferForm.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(OfferForm));

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RenderProduct__ = __webpack_require__(222);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RenderCategory=function(_PureComponent){_inherits(RenderCategory,_PureComponent);function RenderCategory(){_classCallCheck(this,RenderCategory);return _possibleConstructorReturn(this,(RenderCategory.__proto__||Object.getPrototypeOf(RenderCategory)).apply(this,arguments));}_createClass(RenderCategory,[{key:'render',value:function render(){var _props=Object.assign({},this.props),products=_props.products,categories=_props.categories,category=_props.category;if(category.fields){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subcategory'},category.fields.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,category.fields.title),category.fields.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:category.fields.description,softBreak:'br'}),category.fields.pdfMenuButtonText&&category.fields.pdfMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:category.fields.pdfMenu.fields.file.url,className:'btn',target:'_blank'},category.fields.pdfMenuButtonText,' (PDF)'),category.fields.children&&category.fields.children.map(function(child){var product=products.find(function(p){return p.sys.id===child.sys.id;});var subcategory=categories.find(function(p){return p.sys.id===child.sys.id;});if(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RenderProduct__["a" /* default */],{product:product,hidePrice:category.fields.tastingMenu?true:false,key:product.sys.id});}if(subcategory){var columns='single';if(subcategory.fields.columns===false){columns='dual';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"subcategory tastingmenu "+columns,key:subcategory.sys.id},subcategory.fields.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,subcategory.fields.title),subcategory.fields.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_markdown___default.a,{source:subcategory.fields.description,softBreak:'br'}),subcategory.fields.pdfMenuButtonText&&subcategory.fields.pdfMenu&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:subcategory.fields.pdfMenu.fields.file.url,className:'btn',target:'_blank'},subcategory.fields.pdfMenuButtonText,' (PDF)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'products'},subcategory.fields.children&&subcategory.fields.children.map(function(subchild){var subproduct=products.find(function(p){return p.sys.id===subchild.sys.id;});if(subproduct){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RenderProduct__["a" /* default */],{product:subproduct,hidePrice:subcategory.fields.tastingMenu?true:false,key:subproduct.sys.id});}return null;})));}return null;}));}}}]);return RenderCategory;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (RenderCategory);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_google_recaptcha__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OfferForm_css__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OfferForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__OfferForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReservationForm_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReservationForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ReservationForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RECAPTCHA_KEY='6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';var encode=function encode(data){return Object.keys(data).map(function(key){return encodeURIComponent(key)+"="+encodeURIComponent(data[key]);}).join("&");};var ReservationForm=function(_Component){_inherits(ReservationForm,_Component);function ReservationForm(props){_classCallCheck(this,ReservationForm);var _this=_possibleConstructorReturn(this,(ReservationForm.__proto__||Object.getPrototypeOf(ReservationForm)).call(this,props));_this.state={subject:'Gaijin '+(_this.props.intl.locale==="fi"?'varaustiedustelu':'reservation request'),language:_this.props.intl.locale,date:'',time:'',people:'',wishes:'',name:'',email:'',phone:'',billing:'',success:false,error:false};return _this;}_createClass(ReservationForm,[{key:'handleChange',value:function handleChange(field,value){this.setState(_defineProperty({},field,value));}},{key:'handleRecaptcha',value:function handleRecaptcha(value){this.setState({"g-recaptcha-response":value});}},{key:'handleSubmit',value:function handleSubmit(e){var _this2=this;e.preventDefault();if(this.state.date&&this.state.time&&this.state.people&&this.state.wishes&&this.state.name&&this.state.email&&this.state.phone){fetch("/",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:encode(Object.assign({"form-name":"reservation"},this.state))}).then(function(){return _this2.setState({success:true,error:false});}).catch(function(error){return _this2.setState({success:false,error:true});});}else{this.setState({error:true});}}},{key:'render',value:function render(){var _this3=this;if(this.props.intl.locale==='fi'){var fiLocale=__webpack_require__(288);__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('fi',fiLocale);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offer reservation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.intl.messages["groupReservation.heading"]),!this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{name:'reservation',onSubmit:this.handleSubmit.bind(this),'data-netlify-recaptcha':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'form-name',value:'reservation'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'bot-field',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('fieldset',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.date&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'datepicker-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'date',className:'md-floating-label md-floating-label--floating'},this.props.intl.messages["groupReservation.date"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datepicker___default.a,{locale:'fi',placeholderText:this.props.intl.messages["groupReservation.date"],selected:this.state.date,onChange:function onChange(e){return _this3.setState({date:e});},minDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()(),maxDate:__WEBPACK_IMPORTED_MODULE_4_moment___default()().add(365,"days")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'time',label:this.props.intl.messages["groupReservation.time"],onChange:function onChange(e){return _this3.handleChange('time',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'people',label:this.props.intl.messages["groupReservation.people"],onChange:function onChange(e){return _this3.handleChange('people',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'wishes',label:this.props.intl.messages["groupReservation.wishes"],onChange:function onChange(e){return _this3.handleChange('wishes',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'name',label:this.props.intl.messages["groupReservation.name"],onChange:function onChange(e){return _this3.handleChange('name',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'email',type:'email',label:this.props.intl.messages["groupReservation.email"],onChange:function onChange(e){return _this3.handleChange('email',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'phone',type:'tel',label:this.props.intl.messages["groupReservation.phone"],onChange:function onChange(e){return _this3.handleChange('phone',e);},required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_md_lib_TextFields___default.a,{id:'budget',label:this.props.intl.messages["groupReservation.billing"],onChange:function onChange(e){return _this3.handleChange('billing',e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.intl.messages["groupReservation.notice"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_google_recaptcha__["a" /* default */],{ref:'recaptcha',sitekey:RECAPTCHA_KEY,onChange:function onChange(val){return _this3.handleRecaptcha(val);},theme:'dark'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!this.state['g-recaptcha-response'],className:'btn',type:'submit'},this.props.intl.messages["general.sendRequest"])),!this.state.success&&this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fail'},this.props.intl.messages["groupReservation.fail"]),this.state.success&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'success'},this.props.intl.messages["groupReservation.success"]));}}]);return ReservationForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ReservationForm.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ReservationForm));

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineItem__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cart_css__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Cart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Cart_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Cart=function(_Component){_inherits(Cart,_Component);function Cart(){_classCallCheck(this,Cart);return _possibleConstructorReturn(this,(Cart.__proto__||Object.getPrototypeOf(Cart)).apply(this,arguments));}_createClass(Cart,[{key:'render',value:function render(){var _this2=this;var line_items=this.props.checkout.lineItems.map(function(line_item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LineItem__["a" /* default */],{updateQuantityInCart:_this2.props.updateQuantityInCart,removeLineItemInCart:_this2.props.removeLineItemInCart,key:line_item.id,line_item:line_item});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart-status',onClick:this.props.handleCartToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.checkout.lineItemCount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cart-toggle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cart'+(this.props.isCartOpen?' open':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.intl.messages["shoppingCart.heading"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close',onClick:this.props.handleCartToggle})),line_items.length<1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.intl.messages["shoppingCart.emptyCart"]),line_items.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'products'},line_items),line_items.length>0&&this.props.checkout.subtotal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,this.props.intl.messages["shoppingCart.totalPrice"],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.checkout.subtotal.replace('.',',')+' €')),line_items.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.checkout.checkoutUrl+'&locale='+this.props.intl.locale,className:'btn',target:'_blank'},this.props.intl.messages["shoppingCart.checkout"]))));}}]);return Cart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Cart));

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineItem_css__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LineItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LineItem=function(_Component){_inherits(LineItem,_Component);function LineItem(props){_classCallCheck(this,LineItem);var _this=_possibleConstructorReturn(this,(LineItem.__proto__||Object.getPrototypeOf(LineItem)).call(this,props));_this.decrementQuantity=_this.decrementQuantity.bind(_this);_this.incrementQuantity=_this.incrementQuantity.bind(_this);return _this;}_createClass(LineItem,[{key:'decrementQuantity',value:function decrementQuantity(lineItemId){var updatedQuantity=this.props.line_item.quantity-1;this.props.updateQuantityInCart(lineItemId,updatedQuantity);}},{key:'incrementQuantity',value:function incrementQuantity(lineItemId){var updatedQuantity=this.props.line_item.quantity+1;this.props.updateQuantityInCart(lineItemId,updatedQuantity);}},{key:'render',value:function render(){var _this2=this;var product=this.props.line_item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-details'},product.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'minus',onClick:function onClick(){return _this2.decrementQuantity(product.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,product.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'plus',onClick:function onClick(){return _this2.incrementQuantity(product.id);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'product-price'},product.line_price.replace('.',',')+' €'));}}]);return LineItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LineItem);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShopifyProduct_css__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShopifyProduct_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ShopifyProduct_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShopifyProduct=function(_Component){_inherits(ShopifyProduct,_Component);function ShopifyProduct(props){_classCallCheck(this,ShopifyProduct);var _this=_possibleConstructorReturn(this,(ShopifyProduct.__proto__||Object.getPrototypeOf(ShopifyProduct)).call(this,props));_this.state={variantID:null,variantLabel:null};return _this;}_createClass(ShopifyProduct,[{key:'componentDidMount',value:function componentDidMount(){var firstVariant=this.props.product.variants[0];this.setState({variantID:firstVariant.id,variantLabel:firstVariant.optionValues[0].value});}},{key:'render',value:function render(){var _this2=this;var product=this.props.product;var variants=[];var i=void 0;for(i=0;i<product.variants.length;i++){var variant=product.variants[i].attrs.variant;variants.push({value:variant.id,label:variant.option_values[0].value});}var t=this;var variantObject=product.variants.filter(function(obj){return obj.id===t.state.variantID;})[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'shopify-product'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,product.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:product.description}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,this.props.intl.messages["webshop.chooseValue"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'select-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select___default.a,{name:'product-variant',value:{value:this.state.variantID,label:this.state.variantLabel},clearable:false,searchable:false,openOnFocus:true,options:variants,onChange:function onChange(e){return _this2.setState({variantID:e.value,variantLabel:e.label});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn add-to-cart',onClick:function onClick(){return _this2.props.addVariantToCart(variantObject,1);}},this.props.intl.messages["webshop.addToCart"]))));}}]);return ShopifyProduct;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ShopifyProduct.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ShopifyProduct));

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(74);
var SubNav=function SubNav(_ref){var items=_ref.items,onNav=_ref.onNav,currentPath=_ref.currentPath;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'subnav'},items&&items.map(function(item,i){var active=false;if(item.parent){if(currentPath.indexOf(item.parent)>=0){active=true;}}if(!item.hidden){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* NavLink */],{className:active?'active':null,to:item.link,key:'navlink_'+i,onClick:function onClick(){return onNav();}},item.title);}return null;}));};/* harmony default export */ __webpack_exports__["a"] = (SubNav);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContentBlocks_FullbleedHero__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContactForm__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loader__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactPage_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ContactPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_helmet__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactPage=function(_Component){_inherits(ContactPage,_Component);function ContactPage(){_classCallCheck(this,ContactPage);return _possibleConstructorReturn(this,(ContactPage.__proto__||Object.getPrototypeOf(ContactPage)).apply(this,arguments));}_createClass(ContactPage,[{key:'componentDidMount',value:function componentDidMount(){var locale=this.props.intl.locale;if(!this.props.contact.header){this.props.fetchContact(locale);}}},{key:'render',value:function render(){var contact=this.props.contact;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,this.props.intl.messages["header.contactUs"])),!contact.header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Loader__["a" /* default */],null),contact.header&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ContentBlocks_FullbleedHero__["a" /* default */],{fields:contact.header}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contact-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'open-hours',className:'left-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'cacheover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'footer.openTitle'})),contact.leftColumn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_markdown___default.a,{source:contact.leftColumn,softBreak:'br'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ContactForm__["a" /* default */],null),contact.rightColumn&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_markdown___default.a,{source:contact.rightColumn,softBreak:'br'}))))));}}]);return ContactPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContactPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{contact:state.contact,hours:state.hours};};var mapDispatchToProps={fetchContact:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["f" /* fetchContact */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(ContactPage)));

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loader__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContentBlocks_FullbleedHero__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContentBlocks_ContentBlockImage__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContentBlocks_ContentBlockHolder__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContentBlocks_ContentBlock__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContentBlocks_FullbleedContentBlock__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ContentPages_ReservationPage__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_OfferForm__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shopify_ShopifyProduct__ = __webpack_require__(366);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentPage=function(_Component){_inherits(ContentPage,_Component);function ContentPage(){_classCallCheck(this,ContentPage);return _possibleConstructorReturn(this,(ContentPage.__proto__||Object.getPrototypeOf(ContentPage)).apply(this,arguments));}_createClass(ContentPage,[{key:'componentDidMount',value:function componentDidMount(){this.checkForPageData();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.checkForPageData();}},{key:'checkForPageData',value:function checkForPageData(){var locale=this.props.intl.locale;var slug=this.props.match.params.slug;var page=this.props.pages[slug];var collection=this.props.collection;if(!page){this.props.fetchPage(slug,locale);}if(page){if(page.slug==='reservation'){if(!this.props.reservationTexts){this.props.fetchReservationTexts(this.props.intl.locale);}}if(page.elements){if(!collection&&page.elements.filter(function(e){return e.sys.contentType.sys.id==='shopifyCollection';}).length>0){var collectionId=page.elements.find(function(e){return e.sys.contentType.sys.id==='shopifyCollection';}).fields.collectionId;this.props.fetchCollection(collectionId);}}}}},{key:'render',value:function render(){var _this2=this;var slug=this.props.match.params.slug;var _props=Object.assign({},this.props),pages=_props.pages;var page=pages[slug];var collection=this.props.collection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!pages[slug]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Loader__["a" /* default */],null),pages[slug]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:page.slug,style:page.slug==='reservation'?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(this.props,'reservationTexts.backgroundImage.fields.file.url')}:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_helmet___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,page.title)),page.elements&&page.elements.map(function(key,i){if(key.sys.contentType.sys.id==='header'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ContentBlocks_FullbleedHero__["a" /* default */],{key:key.sys.id,fields:key.fields,slug:slug});}if(key.sys.contentType.sys.id==='container'){if(key.fields.type===true){var align=key.fields.align.toLowerCase();if((align==='left'||align==='right')&&key.fields.image){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ContentBlocks_ContentBlockImage__["a" /* default */],{align:align,fields:key.fields,key:key.sys.id});}if(align==='dual'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ContentBlocks_ContentBlockHolder__["a" /* default */],{dual:true,key:key.sys.id},key.fields.elements.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ContentBlocks_ContentBlock__["a" /* default */],{key:key.sys.id,align:key.fields.align.toLowerCase(),fields:key.fields});}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ContentBlocks_ContentBlockHolder__["a" /* default */],{key:key.sys.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ContentBlocks_ContentBlock__["a" /* default */],{align:align,fields:key.fields}));}if(key.fields.type===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ContentBlocks_FullbleedContentBlock__["a" /* default */],{key:key.sys.id,align:key.fields.align.toLowerCase(),fields:key.fields});}}if(key.sys.contentType.sys.id==='shopifyCollection'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key.sys.id,className:'shopify-container'},collection&&collection.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Shopify_ShopifyProduct__["a" /* default */],Object.assign({key:key.id,product:key},_this2.props));}));}return null;}),page.slug==='reservation'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ContentPages_ReservationPage__["a" /* default */],{elements:page.elements}),page.slug==='premium-catering'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_OfferForm__["a" /* default */],null)));}}]);return ContentPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContentPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{pages:state.pages,collection:state.collections,reservationTexts:state.reservationTexts};};var mapDispatchToProps={fetchPage:__WEBPACK_IMPORTED_MODULE_10__redux_actions__["c" /* fetchPage */],fetchCollection:__WEBPACK_IMPORTED_MODULE_10__redux_actions__["d" /* fetchCollection */],fetchReservationTexts:__WEBPACK_IMPORTED_MODULE_10__redux_actions__["e" /* fetchReservationTexts */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ContentPage)));

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ReservationForm__ = __webpack_require__(363);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReservationPage=function(_Component){_inherits(ReservationPage,_Component);function ReservationPage(props){_classCallCheck(this,ReservationPage);var _this=_possibleConstructorReturn(this,(ReservationPage.__proto__||Object.getPrototypeOf(ReservationPage)).call(this,props));_this.state={modalUrl:null,modalOpen:false,showForm:false};return _this;}_createClass(ReservationPage,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.reservationTexts){this.props.fetchReservationTexts(this.props.intl.locale);}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reservation-body container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.intl.messages["general.bookTable"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.intl.locale==='fi'?'https://www.sevenrooms.com/reservations/gaijin':'https://www.sevenrooms.com/reservations/gaijin?lang=en',target:'_blank',className:'btn',rel:'noopener noreferrer'},this.props.intl.messages["general.bookOnline"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'btn',onClick:function onClick(){return _this2.setState({showForm:!_this2.state.showForm});}},this.props.intl.messages["general.bookFormBtn"]),this.state.showForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reservation_form_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ReservationForm__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.props,'reservationTexts.groupReservationInfo')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.props,'reservationTexts.groupReservationInfo'),softBreak:'br'})),__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.props,'reservationTexts.onlineBookingInfo')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_markdown___default.a,{source:__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.props,'reservationTexts.onlineBookingInfo'),softBreak:'br'}));}}]);return ReservationPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ReservationPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{reservationTexts:state.reservationTexts};};var mapDispatchToProps={fetchReservationTexts:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["e" /* fetchReservationTexts */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(ReservationPage)));

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Map_Map_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Address_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NewsLetter_NewsLetter_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Footer_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Hours__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router_dom__ = __webpack_require__(74);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.hours){this.props.fetchHours(this.props.intl.locale);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Map_Map_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',{className:'app-footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Address_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],{id:'footer.openTitle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Hours__["a" /* default */],{text:this.props.hours}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],{id:'footer.otherTimes'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Link */],{to:'/contact',className:'footer-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],{id:'footer.specialHours'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_NewsLetter_NewsLetter_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Link */],{to:'/reservation',className:'footer-link'},this.props.intl.messages["general.bookTable"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Link */],{to:'/yrityskortti',className:'footer-link'},this.props.intl.messages["general.businessCard"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router_dom__["d" /* Link */],{to:'/lahjakortti',className:'footer-link'},this.props.intl.messages["general.giftCard"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.w-restaurants.fi/',className:'footer-link'},'W-Restaurants Oy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.w-restaurants.fi/asiakasrekisterin-tietosuojaseloste',className:'footer-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],{id:'footer.privacyPolicy'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.w-restaurants.fi/b2b-suoramarkkinoinnin-tietosuojaseloste',className:'footer-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */],{id:'footer.b2bPrivacyPolicy'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.w-restaurants.fi/verkkokaupan-toimitusehdot',className:'footer-link'},this.props.intl.messages["footer.webshopTerms"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.w-restaurants.fi/kuvapankki',className:'footer-link'},this.props.intl.messages["general.forMedia"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.oivahymy.fi/hae-yrityksia/#text=gaijin',target:'_blank',className:'footer-link',rel:'noopener noreferrer'},this.props.intl.messages["general.oiva"]))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Footer.propTypes={intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{hours:state.hours};};var mapDispatchToProps={fetchHours:__WEBPACK_IMPORTED_MODULE_2__redux_actions__["b" /* fetchHours */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(Footer)));

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FrontPage_css__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FrontPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FrontPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContentBlocks_FullbleedHero__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentBlocks_FullbleedContentBlock__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_NewsLetter_NewsLetter_js__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Facebook__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ContentBlocks_ContentBlockImage__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ContentBlocks_ContentBlockHolder__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ContentBlocks_ContentBlock__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_award_jpg__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_award_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_award_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FrontPage=function(_Component){_inherits(FrontPage,_Component);function FrontPage(){_classCallCheck(this,FrontPage);return _possibleConstructorReturn(this,(FrontPage.__proto__||Object.getPrototypeOf(FrontPage)).apply(this,arguments));}_createClass(FrontPage,[{key:'componentDidMount',value:function componentDidMount(){if(!this.props.headField||!this.props.liftField){this.props.fetchFront(this.props.intl.locale,this.props.date);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_helmet___default.a,{title:'Gaijin',titleTemplate:'%s'}),!this.props.headField&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Loader__["a" /* default */],null),this.props.headField&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ContentBlocks_FullbleedHero__["a" /* default */],{fields:this.props.headField}),this.props.containers&&this.props.containers.map(function(key,i){if(key.sys.contentType.sys.id==='container'){if(key.fields.type===true){var align=key.fields.align.toLowerCase();if((align==='left'||align==='right')&&key.fields.image){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ContentBlocks_ContentBlockImage__["a" /* default */],{align:align,fields:key.fields,key:key.sys.id});}if(align==='dual'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ContentBlocks_ContentBlockHolder__["a" /* default */],{dual:true,key:key.sys.id},key.fields.elements.map(function(key,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ContentBlocks_ContentBlock__["a" /* default */],{key:key.sys.id,align:key.fields.align.toLowerCase(),fields:key.fields});}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ContentBlocks_ContentBlockHolder__["a" /* default */],{key:key.sys.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ContentBlocks_ContentBlock__["a" /* default */],{align:align,fields:key.fields}));}if(key.fields.type===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ContentBlocks_FullbleedContentBlock__["a" /* default */],{key:key.sys.id,align:key.fields.align.toLowerCase(),fields:key.fields});}}return null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'newsletter-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_NewsLetter_NewsLetter_js__["a" /* default */],{title:true,classname:'newsletter'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'facebook'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Facebook__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'award'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__assets_img_award_jpg___default.a,alt:''}))))));}}]);return FrontPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);FrontPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{headField:state.front.header,date:state.date,containers:state.front.containers,instagrams:state.instagrams,lifts:state.front.lifts?state.front.lifts.map(function(x){return{"align":"Center","heading":x.fields.title,"content":x.fields.description,"leadLinkText":x.fields.linkText,"leadLinkUrl":x.fields.link};}):[]};};var mapDispatchToProps={fetchFront:__WEBPACK_IMPORTED_MODULE_5__redux_actions__["h" /* fetchFront */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(FrontPage)));

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LangWrapper__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slug__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_slug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SubNav__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header_css__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileNav_css__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MobileNav_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MobileNav_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={navigationOpen:false,menuOpen:false};return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){var locale=this.props.intl.locale;this.props.fetchDate();if(!this.props.navi){this.props.fetchNavi(locale);}if(!this.props.menus.length){this.props.fetchMenu(this.props.date,locale);}var lastScrollTop=0;window.addEventListener('scroll',function(){var nav=document.querySelector('header.sticky-header');var st=window.pageYOffset||document.documentElement.scrollTop;if(st>lastScrollTop){// downscroll
if(window.pageYOffset>nav.offsetHeight){nav.classList.remove('full');nav.classList.add('hide');if(window.pageYOffset>500){nav.classList.remove('hide');nav.classList.add('sticky');}}}else{// upscroll
if(window.pageYOffset>500){nav.classList.add('full');}else{nav.classList.add('hide');if(window.pageYOffset<300){nav.classList.remove('sticky');nav.classList.remove('full');nav.classList.remove('hide');}}}lastScrollTop=st;});}},{key:'componentDidUpdate',value:function componentDidUpdate(){window.scroll(0,0);}},{key:'handleNavToggle',value:function handleNavToggle(){if(this.state.navigationOpen){this.setState({navigationOpen:false});}else{// if(window.innerWidth <= 767) {
this.setState({navigationOpen:true});// }
}}},{key:'handleMenu',value:function handleMenu(){if(this.state.menuOpen){this.setState({menuOpen:false});}else{this.setState({menuOpen:true});}}},{key:'onSwitchLang',value:function onSwitchLang(){this.props.switchLang();window.location.reload();}},{key:'render',value:function render(){var _this2=this;var isItemValid=function isItemValid(item,time){return item&&item.fields&&(!item.fields.validFrom||new Date(time)>=new Date(item.fields.validFrom))&&(!item.fields.validUntil||new Date(time)<new Date(item.fields.validUntil));};var _props=Object.assign({},this.props),naviItems=_props.naviItems,menus=_props.menus,match=_props.match;var currentSlug=match.params.slug;var date=this.props.date;var childrenBool=void 0;if(naviItems){naviItems.forEach(function(item){var mainPage=item.mainPage||(item.childPages?item.childPages[0]:null);var isCurrent=currentSlug===mainPage.fields.slug;if(item.childPages){item.childPages.map(function(child){return isCurrent=isCurrent||currentSlug===child.fields.slug;});if(isCurrent){childrenBool=true;}}});}var children=void 0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:"sticky-header"+(childrenBool?' subnav':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'logo'},'W Restaurants')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',null,naviItems&&naviItems.map(function(item,i){var mainPage=item.mainPage||(item.childPages?item.childPages[0]:null);var isCurrent=currentSlug===mainPage.fields.slug;if(item.childPages){item.childPages.map(function(child){return isCurrent=isCurrent||currentSlug===child.fields.slug;});if(isCurrent){children=item.childPages;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{key:'navilink_'+i,to:'/'+mainPage.fields.slug,activeClassName:'active',className:isCurrent?'active':null},item.label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{to:'/contact',activeClassName:'active'},this.props.intl.messages["header.contactUs"]),children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SubNav__["a" /* default */],{onNav:function onNav(){return _this2.handleNavToggle();},items:children.map(function(item){return{link:'/'+item.fields.slug,hidden:false,title:item.fields.title};})}),this.props.location.pathname.indexOf('menu')>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SubNav__["a" /* default */],{currentPath:this.props.location.pathname,onNav:function onNav(){return _this2.handleNavToggle();},items:menus.map(function(item){var link='/menu/'+__WEBPACK_IMPORTED_MODULE_6_slug___default()(item.fields.title.toLowerCase());var parent=link;if(item.fields.children){var _children=item.fields.children.filter(function(category){return isItemValid(category,date);});if(_children){link=link+'/'+__WEBPACK_IMPORTED_MODULE_6_slug___default()(_children[0].fields.title.toLowerCase());}}return{parent:parent,link:link,hidden:!item.fields.showInNavigation,title:item.fields.title};})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],{to:'/reservation',className:'reservation'},this.props.intl.messages["general.bookTable"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],{to:'/lahjakortti',className:'reservation gifts',activeClassName:'active',onClick:this.handleNavToggle.bind(this)},this.props.intl.messages["general.giftBtn"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LangWrapper__["a" /* default */],{onSwitch:function onSwitch(){return _this2.onSwitchLang();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'nav-toggle',onClick:this.handleNavToggle.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'mobile-nav '+(this.state.navigationOpen?'open':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close',onClick:this.handleNavToggle.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LangWrapper__["a" /* default */],{onSwitch:function onSwitch(){return _this2.onSwitchLang();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{to:'/',activeClassName:'active',onClick:this.handleNavToggle.bind(this)},this.props.intl.messages["header.home"]),naviItems&&naviItems.map(function(item,i){var mainPage=item.mainPage||(item.childPages?item.childPages[0]:null);var isCurrent=currentSlug===mainPage.fields.slug;var children=void 0;if(item.childPages){item.childPages.map(function(child){return isCurrent=isCurrent||currentSlug===child.fields.slug;});if(isCurrent){children=item.childPages;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'navilink_'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{to:'/'+mainPage.fields.slug,activeClassName:'active',onClick:_this2.handleNavToggle.bind(_this2)},item.label),children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SubNav__["a" /* default */],{onNav:function onNav(){return _this2.handleNavToggle();},items:children.map(function(item){return{link:'/'+item.fields.slug,hidden:false,title:item.fields.title};})}),mainPage.fields.slug==='menu'&&currentSlug==='menu'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SubNav__["a" /* default */],{onNav:function onNav(){return _this2.handleNavToggle();},items:menus.map(function(item){var link='/menu/'+__WEBPACK_IMPORTED_MODULE_6_slug___default()(item.fields.title.toLowerCase());if(item.fields.children){var _children2=item.fields.children.filter(function(category){return isItemValid(category,date);});if(_children2){link=link+'/'+__WEBPACK_IMPORTED_MODULE_6_slug___default()(_children2[0].fields.title.toLowerCase());}}return{link:link,hidden:!item.fields.showInNavigation,title:item.fields.title};})}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* NavLink */],{to:'/contact',activeClassName:'active',onClick:this.handleNavToggle.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */],{id:'header.contactUs'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],{to:'/reservation',className:'reservation',onClick:this.handleNavToggle.bind(this)},this.props.intl.messages["general.bookTable"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],{to:'/lahjakortti',className:'reservation gifts',activeClassName:'active',onClick:this.handleNavToggle.bind(this)},this.props.intl.messages["general.giftBtn"])));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Header.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{naviItems:state.navi,menus:state.menus,date:state.date};};var mapDispatchToProps={fetchNavi:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["i" /* fetchNavi */],fetchMenu:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["g" /* fetchMenu */],fetchDate:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["j" /* fetchDate */],switchLang:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["a" /* switchLang */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(Header))));

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slug__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_slug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_slug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuPage_css__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MenuPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ContentBlocks_FullbleedHero__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ContentBlocks_FullbleedContentBlock__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_RenderProduct__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RenderCategory__ = __webpack_require__(362);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MenuPage=function(_Component){_inherits(MenuPage,_Component);function MenuPage(){_classCallCheck(this,MenuPage);return _possibleConstructorReturn(this,(MenuPage.__proto__||Object.getPrototypeOf(MenuPage)).apply(this,arguments));}_createClass(MenuPage,[{key:'componentDidMount',value:function componentDidMount(){var locale=this.props.intl.locale;if(!this.props.menus.length){this.props.fetchMenu(this.props.date,locale);}}},{key:'componentDidUpdate',value:function componentDidUpdate(){var menuSlug=this.props.match.params.slug;var menus=this.props.menus;var menu=menus.find(function(menu){return __WEBPACK_IMPORTED_MODULE_5_slug___default()(menu.fields.title.toLowerCase())===menuSlug;});if(menus.length&&!menu){this.props.history.replace('/menu');}}},{key:'render',value:function render(){var _this2=this;var isItemValid=function isItemValid(item,time){return(!item.fields.validFrom||new Date(time)>=new Date(item.fields.validFrom))&&(!item.fields.validUntil||new Date(time)<new Date(item.fields.validUntil));};var menuSlug=this.props.match.params.slug;var menuSubSlug=this.props.match.params.subslug;var _props=Object.assign({},this.props),menus=_props.menus,categories=_props.categories,products=_props.products;var productGroups=categories.filter(function(category){return isItemValid(category,_this2.props.date);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu'},menus&&menus.map(function(menu){if(menuSlug!==__WEBPACK_IMPORTED_MODULE_5_slug___default()(menu.fields.title.toLowerCase())){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:menu.fields.title,style:{backgroundImage:'url('+menu.fields.image.fields.file.url+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_helmet___default.a,{title:menu.fields.title}),menu.fields.specialDiets&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'special-diets'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ContentBlocks_FullbleedHero__["a" /* default */],{key:menu.sys.id,fields:{heading:menu.fields.title,lead:menu.fields.description,image:menu.fields.image}})),!menu.fields.specialDiets&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'category cols-'+menu.fields.columns,id:__WEBPACK_IMPORTED_MODULE_5_slug___default()(menu.fields.title.toLowerCase())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ContentBlocks_FullbleedContentBlock__["a" /* default */],{key:menu.sys.id,align:'center',fields:{heading:menu.fields.longTitle?menu.fields.longTitle:menu.fields.title}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},menu.fields.children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'subcategory-nav'},menu.fields.children.map(function(child){var category=productGroups.find(function(p){return p.sys.id===child.sys.id;});if(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* NavLink */],{to:'/menu/'+menuSlug+'/'+__WEBPACK_IMPORTED_MODULE_5_slug___default()(category.fields.title.toLowerCase()),key:category.sys.id,activeClassName:'active'},category.fields.title);}return null;})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'products-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'products-categories'},menu.fields.children&&menu.fields.children.map(function(child,index){var product=products.find(function(p){return p.sys.id===child.sys.id;});var category=productGroups.find(function(p){return p.sys.id===child.sys.id;});if(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_RenderProduct__["a" /* default */],Object.assign({product:product,key:product.fields.title},_this2.props));}if(category&&__WEBPACK_IMPORTED_MODULE_5_slug___default()(category.fields.title.toLowerCase())===menuSubSlug){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_RenderCategory__["a" /* default */],Object.assign({category:category,key:category.fields.title},_this2.props));}return null;})),menu.fields.children&&menu.fields.children.map(function(child){var menu=menus.find(function(p){return p.sys.id===child.sys.id;});if(menu){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'submenu cols-'+menu.fields.columns,key:menu.fields.title,id:__WEBPACK_IMPORTED_MODULE_5_slug___default()(menu.fields.title.toLowerCase())},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,menu.fields.title),menu.fields.description&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,menu.fields.description),menu.fields.children&&menu.fields.children.map(function(child){var product=products.find(function(p){return p.sys.id===child.sys.id;});var category=productGroups.find(function(p){return p.sys.id===child.sys.id;});if(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_RenderProduct__["a" /* default */],Object.assign({product:product,key:product.fields.title},_this2.props));}if(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_RenderCategory__["a" /* default */],Object.assign({category:category,key:category.fields.title},_this2.props));}return null;}));}return null;})))));}));}}]);return MenuPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MenuPage.propTypes={intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* intlShape */].isRequired};var mapStateToProps=function mapStateToProps(state){return{menus:state.menus,date:state.date,products:state.products,categories:state.categories};};var mapDispatchToProps={fetchMenu:__WEBPACK_IMPORTED_MODULE_4__redux_actions__["g" /* fetchMenu */]};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(MenuPage)));

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(37);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function storeState(key,state){localStorage.setItem('bw_restaurants_'+key,JSON.stringify(state));};function getStoredState(key){return JSON.parse(localStorage.getItem('bw_restaurants_'+key));};function navi(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_1__actions__["k" /* RECEIVE_NAVI */]){return action.items;}return state;}function pages(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_1__actions__["l" /* RECEIVE_PAGES */]){var items=Object.assign({},state,_defineProperty({},action.item.slug,action.item));return items;}return state;}function date(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:new Date();var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_1__actions__["m" /* RECEIVE_DATE */]){return new Date(action.date);}return state;}// reservation page
var reservationTexts=function reservationTexts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["n" /* RECEIVE_RESERVATION_INFO */]:return action.texts;default:return state;}};// open hour text
var hours=function hours(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* RECEIVE_HOURS */]:return action.hoursText;default:return state;}};// the language of page
var lang=function lang(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:getStoredState('lang')||"fi";var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* SWITCH_LANG */]:var _lang=state==="fi"?"en":"fi";storeState('lang',_lang);return _lang;default:return state;}};// the frontpage
var front=function front(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* RECEIVE_FRONTPAGE */]:return action.data;default:return state;}};// the instagrams
var instagrams=function instagrams(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["r" /* RECEIVE_INSTAGRAM */]:return action.data;default:return state;}};// the menus
var menus=function menus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* RECEIVE_MENUS */]:return action.data;default:return state;}};// all products
var products=function products(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* RECEIVE_MENUS */]:var _menus=action.data;var _products=[];var getProduct=function getProduct(obj){if(obj.sys.contentType){switch(obj.sys.contentType.sys.id){case"category":if(obj.fields.children){obj.fields.children.forEach(getProduct);}break;case"product":_products.push(obj);break;default:break;}}};_menus.forEach(function(menu){if(menu.fields.children){menu.fields.children.forEach(getProduct);}});return _products;default:return state;}};// product group, category
var categories=function categories(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* RECEIVE_MENUS */]:var _menus2=action.data;var _categories=[];var getCategory=function getCategory(obj){if(obj.sys.contentType){switch(obj.sys.contentType.sys.id){case"category":_categories.push(obj);if(obj.fields.children){obj.fields.children.forEach(getCategory);}break;default:break;}}};_menus2.forEach(function(menu){if(menu.fields.children){menu.fields.children.forEach(getCategory);}});return _categories;default:return state;}};// contact page
var contact=function contact(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* RECEIVE_CONTACT */]:return action.data;default:return state;}};// blogs page
var blogs=function blogs(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* RECEIVE_BLOGS */]:return action.data;default:return state;}};// collections
var collections=function collections(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* RECEIVE_COLLECTIONS */]:return action.collection;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* combineReducers */])({navi:navi,pages:pages,date:date,hours:hours,lang:lang,front:front,instagrams:instagrams,menus:menus,products:products,categories:categories,contact:contact,blogs:blogs,collections:collections,reservationTexts:reservationTexts}));

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(375);
var store=__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */],__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a),window.devToolsExtension?window.devToolsExtension():function(f){return f;}));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocale */
/* harmony export (immutable) */ __webpack_exports__["a"] = getIntl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_fi__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_fi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_fi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flat__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_en_json__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__lang_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_fi_json__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lang_fi_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__lang_fi_json__);
// Get our translations files
// Load "en" and "fi" utils
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default.a);__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_2_react_intl_locale_data_fi___default.a);var locales=['en','fi'];var defaultLocale='fi';var messages={en:__WEBPACK_IMPORTED_MODULE_3_flat___default()(__WEBPACK_IMPORTED_MODULE_4__lang_en_json___default.a),fi:__WEBPACK_IMPORTED_MODULE_3_flat___default()(__WEBPACK_IMPORTED_MODULE_5__lang_fi_json___default.a)};function getLocale(url){// Get the "en" from the url "http://domain.tld/en"
var firstURIlevel=url.replace(/^\//,"").split("/")[0];// If there is not the locale in the url, we take the default locale
return firstURIlevel&&locales.indexOf(firstURIlevel)>-1?firstURIlevel:defaultLocale;}function getIntl(locale){// We will inject this into IntlProvider
return{locale:locale,messages:messages[locale],defaultLocale:defaultLocale};}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(633);

__webpack_require__(907);

__webpack_require__(391);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(380)
var ieee754 = __webpack_require__(680)
var isArray = __webpack_require__(700)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var assign = __webpack_require__(709);
var isPlainObject = __webpack_require__(710);
var xssFilters = __webpack_require__(918);
var pascalCase = __webpack_require__(754);

var typeAliases = {
    blockquote: 'block_quote',
    thematicbreak: 'thematic_break',
    htmlblock: 'html_block',
    htmlinline: 'html_inline',
    codeblock: 'code_block',
    hardbreak: 'linebreak'
};

var defaultRenderers = {
    block_quote: 'blockquote', // eslint-disable-line camelcase
    emph: 'em',
    linebreak: 'br',
    image: 'img',
    item: 'li',
    link: 'a',
    paragraph: 'p',
    strong: 'strong',
    thematic_break: 'hr', // eslint-disable-line camelcase

    html_block: HtmlRenderer, // eslint-disable-line camelcase
    html_inline: HtmlRenderer, // eslint-disable-line camelcase

    list: function List(props) {
        var tag = props.type.toLowerCase() === 'bullet' ? 'ul' : 'ol';
        var attrs = getCoreProps(props);

        if (props.start !== null && props.start !== 1) {
            attrs.start = props.start.toString();
        }

        return createElement(tag, attrs, props.children);
    },
    code_block: function CodeBlock(props) { // eslint-disable-line camelcase
        var className = props.language && 'language-' + props.language;
        var code = createElement('code', { className: className }, props.literal);
        return createElement('pre', getCoreProps(props), code);
    },
    code: function Code(props) {
        return createElement('code', getCoreProps(props), props.children);
    },
    heading: function Heading(props) {
        return createElement('h' + props.level, getCoreProps(props), props.children);
    },

    text: null,
    softbreak: null
};

var coreTypes = Object.keys(defaultRenderers);

function getCoreProps(props) {
    return {
        'key': props.nodeKey,
        'className': props.className,
        'data-sourcepos': props['data-sourcepos']
    };
}

function normalizeTypeName(typeName) {
    var norm = typeName.toLowerCase();
    var type = typeAliases[norm] || norm;
    return typeof defaultRenderers[type] !== 'undefined' ? type : typeName;
}

function normalizeRenderers(renderers) {
    return Object.keys(renderers || {}).reduce(function(normalized, type) {
        var norm = normalizeTypeName(type);
        normalized[norm] = renderers[type];
        return normalized;
    }, {});
}

function HtmlRenderer(props) {
    var coreProps = getCoreProps(props);
    var nodeProps = props.escapeHtml ? {} : { dangerouslySetInnerHTML: { __html: props.literal } };
    var children = props.escapeHtml ? [props.literal] : null;

    if (props.escapeHtml || !props.skipHtml) {
        var actualProps = assign(coreProps, nodeProps);
        return createElement(props.isBlock ? 'div' : 'span', actualProps, children);
    }
}

function isGrandChildOfList(node) {
    var grandparent = node.parent.parent;
    return (
        grandparent &&
        grandparent.type.toLowerCase() === 'list' &&
        grandparent.listTight
    );
}

function addChild(node, child) {
    var parent = node;
    do {
        parent = parent.parent;
    } while (!parent.react);

    parent.react.children.push(child);
}

function createElement(tagName, props, children) {
    var nodeChildren = Array.isArray(children) && children.reduce(reduceChildren, []);
    var args = [tagName, props].concat(nodeChildren || children);
    return React.createElement.apply(React, args);
}

function reduceChildren(children, child) {
    var lastIndex = children.length - 1;
    if (typeof child === 'string' && typeof children[lastIndex] === 'string') {
        children[lastIndex] += child;
    } else {
        children.push(child);
    }

    return children;
}

function flattenPosition(pos) {
    return [
        pos[0][0], ':', pos[0][1], '-',
        pos[1][0], ':', pos[1][1]
    ].map(String).join('');
}

// For some nodes, we want to include more props than for others
function getNodeProps(node, key, opts, renderer) {
    var props = { key: key }, undef;

    // `sourcePos` is true if the user wants source information (line/column info from markdown source)
    if (opts.sourcePos && node.sourcepos) {
        props['data-sourcepos'] = flattenPosition(node.sourcepos);
    }

    var type = normalizeTypeName(node.type);

    switch (type) {
        case 'html_inline':
        case 'html_block':
            props.isBlock = type === 'html_block';
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            break;
        case 'code_block':
            var codeInfo = node.info ? node.info.split(/ +/) : [];
            if (codeInfo.length > 0 && codeInfo[0].length > 0) {
                props.language = codeInfo[0];
                props.codeinfo = codeInfo;
            }
            break;
        case 'code':
            props.children = node.literal;
            props.inline = true;
            break;
        case 'heading':
            props.level = node.level;
            break;
        case 'softbreak':
            props.softBreak = opts.softBreak;
            break;
        case 'link':
            props.href = opts.transformLinkUri ? opts.transformLinkUri(node.destination) : node.destination;
            props.title = node.title || undef;
            if (opts.linkTarget) {
                props.target = opts.linkTarget;
            }
            break;
        case 'image':
            props.src = opts.transformImageUri ? opts.transformImageUri(node.destination) : node.destination;
            props.title = node.title || undef;

            // Commonmark treats image description as children. We just want the text
            props.alt = node.react.children.join('');
            node.react.children = undef;
            break;
        case 'list':
            props.start = node.listStart;
            props.type = node.listType;
            props.tight = node.listTight;
            break;
        default:
    }

    if (typeof renderer !== 'string') {
        props.literal = node.literal;
    }

    var children = props.children || (node.react && node.react.children);
    if (Array.isArray(children)) {
        props.children = children.reduce(reduceChildren, []) || null;
    }

    return props;
}

function getPosition(node) {
    if (!node) {
        return null;
    }

    if (node.sourcepos) {
        return flattenPosition(node.sourcepos);
    }

    return getPosition(node.parent);
}

function renderNodes(block) {
    var walker = block.walker();

    // Softbreaks are usually treated as newlines, but in HTML we might want explicit linebreaks
    var softBreak = (
        this.softBreak === 'br' ?
        React.createElement('br') :
        this.softBreak
    );

    var propOptions = {
        sourcePos: this.sourcePos,
        escapeHtml: this.escapeHtml,
        skipHtml: this.skipHtml,
        transformLinkUri: this.transformLinkUri,
        transformImageUri: this.transformImageUri,
        softBreak: softBreak,
        linkTarget: this.linkTarget
    };

    var e, node, entering, leaving, type, doc, key, nodeProps, prevPos, prevIndex = 0;
    while ((e = walker.next())) {
        var pos = getPosition(e.node.sourcepos ? e.node : e.node.parent);
        if (prevPos === pos) {
            key = pos + prevIndex;
            prevIndex++;
        } else {
            key = pos;
            prevIndex = 0;
        }

        prevPos = pos;
        entering = e.entering;
        leaving = !entering;
        node = e.node;
        type = normalizeTypeName(node.type);
        nodeProps = null;

        // If we have not assigned a document yet, assume the current node is just that
        if (!doc) {
            doc = node;
            node.react = { children: [] };
            continue;
        } else if (node === doc) {
            // When we're leaving...
            continue;
        }

        // In HTML, we don't want paragraphs inside of list items
        if (type === 'paragraph' && isGrandChildOfList(node)) {
            continue;
        }

        // If we're skipping HTML nodes, don't keep processing
        if (this.skipHtml && (type === 'html_block' || type === 'html_inline')) {
            continue;
        }

        var isDocument = node === doc;
        var disallowedByConfig = this.allowedTypes.indexOf(type) === -1;
        var disallowedByUser = false;

        // Do we have a user-defined function?
        var isCompleteParent = node.isContainer && leaving;
        var renderer = this.renderers[type];
        if (this.allowNode && (isCompleteParent || !node.isContainer)) {
            var nodeChildren = isCompleteParent ? node.react.children : [];

            nodeProps = getNodeProps(node, key, propOptions, renderer);
            disallowedByUser = !this.allowNode({
                type: pascalCase(type),
                renderer: this.renderers[type],
                props: nodeProps,
                children: nodeChildren
            });
        }

        if (!isDocument && (disallowedByUser || disallowedByConfig)) {
            if (!this.unwrapDisallowed && entering && node.isContainer) {
                walker.resumeAt(node, false);
            }

            continue;
        }

        var isSimpleNode = type === 'text' || type === 'softbreak';
        if (typeof renderer !== 'function' && !isSimpleNode && typeof renderer !== 'string') {
            throw new Error(
                'Renderer for type `' + pascalCase(node.type) + '` not defined or is not renderable'
            );
        }

        if (node.isContainer && entering) {
            node.react = {
                component: renderer,
                props: {},
                children: []
            };
        } else {
            var childProps = nodeProps || getNodeProps(node, key, propOptions, renderer);
            if (renderer) {
                childProps = typeof renderer === 'string'
                    ? childProps
                    : assign(childProps, {nodeKey: childProps.key});

                addChild(node, React.createElement(renderer, childProps));
            } else if (type === 'text') {
                addChild(node, node.literal);
            } else if (type === 'softbreak') {
                addChild(node, softBreak);
            }
        }
    }

    return doc.react.children;
}

function defaultLinkUriFilter(uri) {
    var url = uri.replace(/file:\/\//g, 'x-file://');

    // React does a pretty swell job of escaping attributes,
    // so to prevent double-escaping, we need to decode
    return decodeURI(xssFilters.uriInDoubleQuotedAttr(url));
}

function ReactRenderer(options) {
    var opts = options || {};

    if (opts.allowedTypes && opts.disallowedTypes) {
        throw new Error('Only one of `allowedTypes` and `disallowedTypes` should be defined');
    }

    if (opts.allowedTypes && !Array.isArray(opts.allowedTypes)) {
        throw new Error('`allowedTypes` must be an array');
    }

    if (opts.disallowedTypes && !Array.isArray(opts.disallowedTypes)) {
        throw new Error('`disallowedTypes` must be an array');
    }

    if (opts.allowNode && typeof opts.allowNode !== 'function') {
        throw new Error('`allowNode` must be a function');
    }

    var linkFilter = opts.transformLinkUri;
    if (typeof linkFilter === 'undefined') {
        linkFilter = defaultLinkUriFilter;
    } else if (linkFilter && typeof linkFilter !== 'function') {
        throw new Error('`transformLinkUri` must either be a function, or `null` to disable');
    }

    var imageFilter = opts.transformImageUri;
    if (typeof imageFilter !== 'undefined' && typeof imageFilter !== 'function') {
        throw new Error('`transformImageUri` must be a function');
    }

    if (opts.renderers && !isPlainObject(opts.renderers)) {
        throw new Error('`renderers` must be a plain object of `Type`: `Renderer` pairs');
    }

    var allowedTypes = (opts.allowedTypes && opts.allowedTypes.map(normalizeTypeName)) || coreTypes;
    if (opts.disallowedTypes) {
        var disallowed = opts.disallowedTypes.map(normalizeTypeName);
        allowedTypes = allowedTypes.filter(function filterDisallowed(type) {
            return disallowed.indexOf(type) === -1;
        });
    }

    return {
        sourcePos: Boolean(opts.sourcePos),
        softBreak: opts.softBreak || '\n',
        renderers: assign({}, defaultRenderers, normalizeRenderers(opts.renderers)),
        escapeHtml: Boolean(opts.escapeHtml),
        skipHtml: Boolean(opts.skipHtml),
        transformLinkUri: linkFilter,
        transformImageUri: imageFilter,
        allowNode: opts.allowNode,
        allowedTypes: allowedTypes,
        unwrapDisallowed: Boolean(opts.unwrapDisallowed),
        render: renderNodes,
        linkTarget: opts.linkTarget || false
    };
}

ReactRenderer.uriTransformer = defaultLinkUriFilter;
ReactRenderer.types = coreTypes.map(pascalCase);
ReactRenderer.renderers = coreTypes.reduce(function(renderers, type) {
    renderers[pascalCase(type)] = defaultRenderers[type];
    return renderers;
}, {});

module.exports = ReactRenderer;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Node = __webpack_require__(139);
var unescapeString = __webpack_require__(75).unescapeString;
var OPENTAG = __webpack_require__(75).OPENTAG;
var CLOSETAG = __webpack_require__(75).CLOSETAG;

var CODE_INDENT = 4;

var C_TAB = 9;
var C_NEWLINE = 10;
var C_GREATERTHAN = 62;
var C_LESSTHAN = 60;
var C_SPACE = 32;
var C_OPEN_BRACKET = 91;

var InlineParser = __webpack_require__(387);

var reHtmlBlockOpen = [
   /./, // dummy for 0
   /^<(?:script|pre|style)(?:\s|>|$)/i,
   /^<!--/,
   /^<[?]/,
   /^<![A-Z]/,
   /^<!\[CDATA\[/,
   /^<[/]?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|title|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|[/]?[>]|$)/i,
    new RegExp('^(?:' + OPENTAG + '|' + CLOSETAG + ')\s*$', 'i')
];

var reHtmlBlockClose = [
   /./, // dummy for 0
   /<\/(?:script|pre|style)>/i,
   /-->/,
   /\?>/,
   />/,
   /\]\]>/
];

var reThematicBreak = /^(?:(?:\* *){3,}|(?:_ *){3,}|(?:- *){3,}) *$/;

var reMaybeSpecial = /^[#`~*+_=<>0-9-]/;

var reNonSpace = /[^ \t\f\v\r\n]/;

var reBulletListMarker = /^[*+-]/;

var reOrderedListMarker = /^(\d{1,9})([.)])/;

var reATXHeadingMarker = /^#{1,6}(?: +|$)/;

var reCodeFence = /^`{3,}(?!.*`)|^~{3,}(?!.*~)/;

var reClosingCodeFence = /^(?:`{3,}|~{3,})(?= *$)/;

var reSetextHeadingLine = /^(?:=+|-+) *$/;

var reLineEnding = /\r\n|\n|\r/;

// Returns true if string contains only space characters.
var isBlank = function(s) {
    return !(reNonSpace.test(s));
};

var peek = function(ln, pos) {
    if (pos < ln.length) {
        return ln.charCodeAt(pos);
    } else {
        return -1;
    }
};

// DOC PARSER

// These are methods of a Parser object, defined below.

// Returns true if block ends with a blank line, descending if needed
// into lists and sublists.
var endsWithBlankLine = function(block) {
    while (block) {
        if (block._lastLineBlank) {
            return true;
        }
        var t = block.type;
        if (t === 'List' || t === 'Item') {
            block = block._lastChild;
        } else {
            break;
        }
    }
    return false;
};

// Break out of all containing lists, resetting the tip of the
// document to the parent of the highest list, and finalizing
// all the lists.  (This is used to implement the "two blank lines
// break out of all lists" feature.)
var breakOutOfLists = function(block) {
    var b = block;
    var last_list = null;
    do {
        if (b.type === 'List') {
            last_list = b;
        }
        b = b._parent;
    } while (b);

    if (last_list) {
        while (block !== last_list) {
            this.finalize(block, this.lineNumber);
            block = block._parent;
        }
        this.finalize(last_list, this.lineNumber);
        this.tip = last_list._parent;
    }
};

// Add a line to the block at the tip.  We assume the tip
// can accept lines -- that check should be done before calling this.
var addLine = function() {
    this.tip._string_content += this.currentLine.slice(this.offset) + '\n';
};

// Add block of type tag as a child of the tip.  If the tip can't
// accept children, close and finalize it and try its parent,
// and so on til we find a block that can accept children.
var addChild = function(tag, offset) {
    while (!this.blocks[this.tip.type].canContain(tag)) {
        this.finalize(this.tip, this.lineNumber - 1);
    }

    var column_number = offset + 1; // offset 0 = column 1
    var newBlock = new Node(tag, [[this.lineNumber, column_number], [0, 0]]);
    newBlock._string_content = '';
    this.tip.appendChild(newBlock);
    this.tip = newBlock;
    return newBlock;
};

// Parse a list marker and return data on the marker (type,
// start, delimiter, bullet character, padding) or null.
var parseListMarker = function(parser) {
    var rest = parser.currentLine.slice(parser.nextNonspace);
    var match;
    var nextc;
    var spacesStartCol;
    var spacesStartOffset;
    var data = { type: null,
                 tight: true,  // lists are tight by default
                 bulletChar: null,
                 start: null,
                 delimiter: null,
                 padding: null,
                 markerOffset: parser.indent };
    if ((match = rest.match(reBulletListMarker))) {
        data.type = 'Bullet';
        data.bulletChar = match[0][0];

    } else if ((match = rest.match(reOrderedListMarker))) {
        data.type = 'Ordered';
        data.start = parseInt(match[1]);
        data.delimiter = match[2];
    } else {
        return null;
    }
    // make sure we have spaces after
    nextc = peek(parser.currentLine, parser.nextNonspace + match[0].length);
    if (!(nextc === -1 || nextc === C_TAB || nextc === C_SPACE)) {
        return null;
    }

    // we've got a match! advance offset and calculate padding
    parser.advanceNextNonspace(); // to start of marker
    parser.advanceOffset(match[0].length, true); // to end of marker
    spacesStartCol = parser.column;
    spacesStartOffset = parser.offset;
    do {
        parser.advanceOffset(1, true);
        nextc = peek(parser.currentLine, parser.offset);
    } while (parser.column - spacesStartCol < 5 &&
           (nextc === C_SPACE || nextc === C_TAB));
    var blank_item = peek(parser.currentLine, parser.offset) === -1;
    var spaces_after_marker = parser.column - spacesStartCol;
    if (spaces_after_marker >= 5 ||
        spaces_after_marker < 1 ||
        blank_item) {
        data.padding = match[0].length + 1;
        parser.column = spacesStartCol;
        parser.offset = spacesStartOffset;
        if (peek(parser.currentLine, parser.offset) === C_SPACE) {
            parser.advanceOffset(1, true);
        }
    } else {
        data.padding = match[0].length + spaces_after_marker;
    }
    return data;
};

// Returns true if the two list items are of the same type,
// with the same delimiter and bullet character.  This is used
// in agglomerating list items into lists.
var listsMatch = function(list_data, item_data) {
    return (list_data.type === item_data.type &&
            list_data.delimiter === item_data.delimiter &&
            list_data.bulletChar === item_data.bulletChar);
};

// Finalize and close any unmatched blocks.
var closeUnmatchedBlocks = function() {
    if (!this.allClosed) {
        // finalize any blocks not matched
        while (this.oldtip !== this.lastMatchedContainer) {
            var parent = this.oldtip._parent;
            this.finalize(this.oldtip, this.lineNumber - 1);
            this.oldtip = parent;
        }
        this.allClosed = true;
    }
};

// 'finalize' is run when the block is closed.
// 'continue' is run to check whether the block is continuing
// at a certain line and offset (e.g. whether a block quote
// contains a `>`.  It returns 0 for matched, 1 for not matched,
// and 2 for "we've dealt with this line completely, go to next."
var blocks = {
    Document: {
        continue: function() { return 0; },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    List: {
        continue: function() { return 0; },
        finalize: function(parser, block) {
            var item = block._firstChild;
            while (item) {
                // check for non-final list item ending with blank line:
                if (endsWithBlankLine(item) && item._next) {
                    block._listData.tight = false;
                    break;
                }
                // recurse into children of list item, to see if there are
                // spaces between any of them:
                var subitem = item._firstChild;
                while (subitem) {
                    if (endsWithBlankLine(subitem) &&
                        (item._next || subitem._next)) {
                        block._listData.tight = false;
                        break;
                    }
                    subitem = subitem._next;
                }
                item = item._next;
            }
        },
        canContain: function(t) { return (t === 'Item'); },
        acceptsLines: false
    },
    BlockQuote: {
        continue: function(parser) {
            var ln = parser.currentLine;
            if (!parser.indented &&
                peek(ln, parser.nextNonspace) === C_GREATERTHAN) {
                parser.advanceNextNonspace();
                parser.advanceOffset(1, false);
                if (peek(ln, parser.offset) === C_SPACE) {
                    parser.offset++;
                }
            } else {
                return 1;
            }
            return 0;
        },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    Item: {
        continue: function(parser, container) {
            if (parser.blank && container._firstChild !== null) {
                parser.advanceNextNonspace();
            } else if (parser.indent >=
                       container._listData.markerOffset +
                       container._listData.padding) {
                parser.advanceOffset(container._listData.markerOffset +
                    container._listData.padding, true);
            } else {
                return 1;
            }
            return 0;
        },
        finalize: function() { return; },
        canContain: function(t) { return (t !== 'Item'); },
        acceptsLines: false
    },
    Heading: {
        continue: function() {
            // a heading can never container > 1 line, so fail to match:
            return 1;
        },
        finalize: function() { return; },
        canContain: function() { return false; },
        acceptsLines: false
    },
    ThematicBreak: {
        continue: function() {
            // a thematic break can never container > 1 line, so fail to match:
            return 1;
        },
        finalize: function() { return; },
        canContain: function() { return false; },
        acceptsLines: false
    },
    CodeBlock: {
        continue: function(parser, container) {
            var ln = parser.currentLine;
            var indent = parser.indent;
            if (container._isFenced) { // fenced
                var match = (indent <= 3 &&
                    ln.charAt(parser.nextNonspace) === container._fenceChar &&
                    ln.slice(parser.nextNonspace).match(reClosingCodeFence));
                if (match && match[0].length >= container._fenceLength) {
                    // closing fence - we're at end of line, so we can return
                    parser.finalize(container, parser.lineNumber);
                    return 2;
                } else {
                    // skip optional spaces of fence offset
                    var i = container._fenceOffset;
                    while (i > 0 && peek(ln, parser.offset) === C_SPACE) {
                        parser.advanceOffset(1, false);
                        i--;
                    }
                }
            } else { // indented
                if (indent >= CODE_INDENT) {
                    parser.advanceOffset(CODE_INDENT, true);
                } else if (parser.blank) {
                    parser.advanceNextNonspace();
                } else {
                    return 1;
                }
            }
            return 0;
        },
        finalize: function(parser, block) {
            if (block._isFenced) { // fenced
                // first line becomes info string
                var content = block._string_content;
                var newlinePos = content.indexOf('\n');
                var firstLine = content.slice(0, newlinePos);
                var rest = content.slice(newlinePos + 1);
                block.info = unescapeString(firstLine.trim());
                block._literal = rest;
            } else { // indented
                block._literal = block._string_content.replace(/(\n *)+$/, '\n');
            }
            block._string_content = null; // allow GC
        },
        canContain: function() { return false; },
        acceptsLines: true
    },
    HtmlBlock: {
        continue: function(parser, container) {
            return ((parser.blank &&
                     (container._htmlBlockType === 6 ||
                      container._htmlBlockType === 7)) ? 1 : 0);
        },
        finalize: function(parser, block) {
            block._literal = block._string_content.replace(/(\n *)+$/, '');
            block._string_content = null; // allow GC
        },
        canContain: function() { return false; },
        acceptsLines: true
    },
    Paragraph: {
        continue: function(parser) {
            return (parser.blank ? 1 : 0);
        },
        finalize: function(parser, block) {
            var pos;
            var hasReferenceDefs = false;

            // try parsing the beginning as link reference definitions:
            while (peek(block._string_content, 0) === C_OPEN_BRACKET &&
                   (pos =
                    parser.inlineParser.parseReference(block._string_content,
                                                       parser.refmap))) {
                block._string_content = block._string_content.slice(pos);
                hasReferenceDefs = true;
            }
            if (hasReferenceDefs && isBlank(block._string_content)) {
                block.unlink();
            }
        },
        canContain: function() { return false; },
        acceptsLines: true
    }
};

// block start functions.  Return values:
// 0 = no match
// 1 = matched container, keep going
// 2 = matched leaf, no more block starts
var blockStarts = [
    // block quote
    function(parser) {
        if (!parser.indented &&
            peek(parser.currentLine, parser.nextNonspace) === C_GREATERTHAN) {
            parser.advanceNextNonspace();
            parser.advanceOffset(1, false);
            // optional following space
            if (peek(parser.currentLine, parser.offset) === C_SPACE) {
                parser.advanceOffset(1, false);
            }
            parser.closeUnmatchedBlocks();
            parser.addChild('BlockQuote', parser.nextNonspace);
            return 1;
        } else {
            return 0;
        }
    },

    // ATX heading
    function(parser) {
        var match;
        if (!parser.indented &&
            (match = parser.currentLine.slice(parser.nextNonspace).match(reATXHeadingMarker))) {
            parser.advanceNextNonspace();
            parser.advanceOffset(match[0].length, false);
            parser.closeUnmatchedBlocks();
            var container = parser.addChild('Heading', parser.nextNonspace);
            container.level = match[0].trim().length; // number of #s
            // remove trailing ###s:
            container._string_content =
                parser.currentLine.slice(parser.offset).replace(/^ *#+ *$/, '').replace(/ +#+ *$/, '');
            parser.advanceOffset(parser.currentLine.length - parser.offset);
            return 2;
        } else {
            return 0;
        }
    },

    // Fenced code block
    function(parser) {
        var match;
        if (!parser.indented &&
            (match = parser.currentLine.slice(parser.nextNonspace).match(reCodeFence))) {
            var fenceLength = match[0].length;
            parser.closeUnmatchedBlocks();
            var container = parser.addChild('CodeBlock', parser.nextNonspace);
            container._isFenced = true;
            container._fenceLength = fenceLength;
            container._fenceChar = match[0][0];
            container._fenceOffset = parser.indent;
            parser.advanceNextNonspace();
            parser.advanceOffset(fenceLength, false);
            return 2;
        } else {
            return 0;
        }
    },

    // HTML block
    function(parser, container) {
        if (!parser.indented &&
            peek(parser.currentLine, parser.nextNonspace) === C_LESSTHAN) {
            var s = parser.currentLine.slice(parser.nextNonspace);
            var blockType;

            for (blockType = 1; blockType <= 7; blockType++) {
                if (reHtmlBlockOpen[blockType].test(s) &&
                    (blockType < 7 ||
                     container.type !== 'Paragraph')) {
                    parser.closeUnmatchedBlocks();
                    // We don't adjust parser.offset;
                    // spaces are part of the HTML block:
                    var b = parser.addChild('HtmlBlock',
                                            parser.offset);
                    b._htmlBlockType = blockType;
                    return 2;
                }
            }
        }

        return 0;

    },

    // Setext heading
    function(parser, container) {
        var match;
        if (!parser.indented &&
            container.type === 'Paragraph' &&
                   ((match = parser.currentLine.slice(parser.nextNonspace).match(reSetextHeadingLine)))) {
            parser.closeUnmatchedBlocks();
            var heading = new Node('Heading', container.sourcepos);
            heading.level = match[0][0] === '=' ? 1 : 2;
            heading._string_content = container._string_content;
            container.insertAfter(heading);
            container.unlink();
            parser.tip = heading;
            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
            return 2;
        } else {
            return 0;
        }
    },

    // thematic break
    function(parser) {
        if (!parser.indented &&
            reThematicBreak.test(parser.currentLine.slice(parser.nextNonspace))) {
            parser.closeUnmatchedBlocks();
            parser.addChild('ThematicBreak', parser.nextNonspace);
            parser.advanceOffset(parser.currentLine.length - parser.offset, false);
            return 2;
        } else {
            return 0;
        }
    },

    // list item
    function(parser, container) {
        var data;

        if ((!parser.indented || container.type === 'List')
                && (data = parseListMarker(parser))) {
            parser.closeUnmatchedBlocks();

            // add the list if needed
            if (parser.tip.type !== 'List' ||
                !(listsMatch(container._listData, data))) {
                container = parser.addChild('List', parser.nextNonspace);
                container._listData = data;
            }

            // add the list item
            container = parser.addChild('Item', parser.nextNonspace);
            container._listData = data;
            return 1;
        } else {
            return 0;
        }
    },

    // indented code block
    function(parser) {
        if (parser.indented &&
            parser.tip.type !== 'Paragraph' &&
            !parser.blank) {
            // indented code
            parser.advanceOffset(CODE_INDENT, true);
            parser.closeUnmatchedBlocks();
            parser.addChild('CodeBlock', parser.offset);
            return 2;
        } else {
            return 0;
        }
     }

];

var advanceOffset = function(count, columns) {
    var cols = 0;
    var currentLine = this.currentLine;
    var charsToTab;
    var c;
    while (count > 0 && (c = currentLine[this.offset])) {
        if (c === '\t') {
            charsToTab = 4 - (this.column % 4);
            this.column += charsToTab;
            this.offset += 1;
            count -= (columns ? charsToTab : 1);
        } else {
            cols += 1;
            this.offset += 1;
            this.column += 1; // assume ascii; block starts are ascii
            count -= 1;
        }
    }
};

var advanceNextNonspace = function() {
    this.offset = this.nextNonspace;
    this.column = this.nextNonspaceColumn;
};

var findNextNonspace = function() {
    var currentLine = this.currentLine;
    var i = this.offset;
    var cols = this.column;
    var c;

    while ((c = currentLine.charAt(i)) !== '') {
        if (c === ' ') {
            i++;
            cols++;
        } else if (c === '\t') {
            i++;
            cols += (4 - (cols % 4));
        } else {
            break;
        }
    }
    this.blank = (c === '\n' || c === '\r' || c === '');
    this.nextNonspace = i;
    this.nextNonspaceColumn = cols;
    this.indent = this.nextNonspaceColumn - this.column;
    this.indented = this.indent >= CODE_INDENT;
};

// Analyze a line of text and update the document appropriately.
// We parse markdown text by calling this on each line of input,
// then finalizing the document.
var incorporateLine = function(ln) {
    var all_matched = true;
    var t;

    var container = this.doc;
    this.oldtip = this.tip;
    this.offset = 0;
    this.column = 0;
    this.lineNumber += 1;

    // replace NUL characters for security
    if (ln.indexOf('\u0000') !== -1) {
        ln = ln.replace(/\0/g, '\uFFFD');
    }

    this.currentLine = ln;

    // For each containing block, try to parse the associated line start.
    // Bail out on failure: container will point to the last matching block.
    // Set all_matched to false if not all containers match.
    var lastChild;
    while ((lastChild = container._lastChild) && lastChild._open) {
        container = lastChild;

        this.findNextNonspace();

        switch (this.blocks[container.type].continue(this, container)) {
        case 0: // we've matched, keep going
            break;
        case 1: // we've failed to match a block
            all_matched = false;
            break;
        case 2: // we've hit end of line for fenced code close and can return
            this.lastLineLength = ln.length;
            return;
        default:
            throw 'continue returned illegal value, must be 0, 1, or 2';
        }
        if (!all_matched) {
            container = container._parent; // back up to last matching block
            break;
        }
    }

    this.allClosed = (container === this.oldtip);
    this.lastMatchedContainer = container;

    // Check to see if we've hit 2nd blank line; if so break out of list:
    if (this.blank && container._lastLineBlank) {
        this.breakOutOfLists(container);
        container = this.tip;
    }

    var matchedLeaf = container.type !== 'Paragraph' &&
            blocks[container.type].acceptsLines;
    var starts = this.blockStarts;
    var startsLen = starts.length;
    // Unless last matched container is a code block, try new container starts,
    // adding children to the last matched container:
    while (!matchedLeaf) {

        this.findNextNonspace();

        // this is a little performance optimization:
        if (!this.indented &&
            !reMaybeSpecial.test(ln.slice(this.nextNonspace))) {
            this.advanceNextNonspace();
            break;
        }

        var i = 0;
        while (i < startsLen) {
            var res = starts[i](this, container);
            if (res === 1) {
                container = this.tip;
                break;
            } else if (res === 2) {
                container = this.tip;
                matchedLeaf = true;
                break;
            } else {
                i++;
            }
        }

        if (i === startsLen) { // nothing matched
            this.advanceNextNonspace();
            break;
        }
    }

    // What remains at the offset is a text line.  Add the text to the
    // appropriate container.

   // First check for a lazy paragraph continuation:
    if (!this.allClosed && !this.blank &&
        this.tip.type === 'Paragraph') {
        // lazy paragraph continuation
        this.addLine();

    } else { // not a lazy continuation

        // finalize any blocks not matched
        this.closeUnmatchedBlocks();
        if (this.blank && container.lastChild) {
            container.lastChild._lastLineBlank = true;
        }

        t = container.type;

        // Block quote lines are never blank as they start with >
        // and we don't count blanks in fenced code for purposes of tight/loose
        // lists or breaking out of lists.  We also don't set _lastLineBlank
        // on an empty list item, or if we just closed a fenced block.
        var lastLineBlank = this.blank &&
            !(t === 'BlockQuote' ||
              (t === 'CodeBlock' && container._isFenced) ||
              (t === 'Item' &&
               !container._firstChild &&
               container.sourcepos[0][0] === this.lineNumber));

        // propagate lastLineBlank up through parents:
        var cont = container;
        while (cont) {
            cont._lastLineBlank = lastLineBlank;
            cont = cont._parent;
        }

        if (this.blocks[t].acceptsLines) {
            this.addLine();
            // if HtmlBlock, check for end condition
            if (t === 'HtmlBlock' &&
                container._htmlBlockType >= 1 &&
                container._htmlBlockType <= 5 &&
                reHtmlBlockClose[container._htmlBlockType].test(this.currentLine.slice(this.offset))) {
                this.finalize(container, this.lineNumber);
            }

        } else if (this.offset < ln.length && !this.blank) {
            // create paragraph container for line
            container = this.addChild('Paragraph', this.offset);
            this.advanceNextNonspace();
            this.addLine();
        }
    }
    this.lastLineLength = ln.length;
};

// Finalize a block.  Close it and do any necessary postprocessing,
// e.g. creating string_content from strings, setting the 'tight'
// or 'loose' status of a list, and parsing the beginnings
// of paragraphs for reference definitions.  Reset the tip to the
// parent of the closed block.
var finalize = function(block, lineNumber) {
    var above = block._parent;
    block._open = false;
    block.sourcepos[1] = [lineNumber, this.lastLineLength];

    this.blocks[block.type].finalize(this, block);

    this.tip = above;
};

// Walk through a block & children recursively, parsing string content
// into inline content where appropriate.
var processInlines = function(block) {
    var node, event, t;
    var walker = block.walker();
    this.inlineParser.refmap = this.refmap;
    this.inlineParser.options = this.options;
    while ((event = walker.next())) {
        node = event.node;
        t = node.type;
        if (!event.entering && (t === 'Paragraph' || t === 'Heading')) {
            this.inlineParser.parse(node);
        }
    }
};

var Document = function() {
    var doc = new Node('Document', [[1, 1], [0, 0]]);
    return doc;
};

// The main parsing function.  Returns a parsed document AST.
var parse = function(input) {
    this.doc = new Document();
    this.tip = this.doc;
    this.refmap = {};
    this.lineNumber = 0;
    this.lastLineLength = 0;
    this.offset = 0;
    this.column = 0;
    this.lastMatchedContainer = this.doc;
    this.currentLine = "";
    if (this.options.time) { console.time("preparing input"); }
    var lines = input.split(reLineEnding);
    var len = lines.length;
    if (input.charCodeAt(input.length - 1) === C_NEWLINE) {
        // ignore last blank line created by final newline
        len -= 1;
    }
    if (this.options.time) { console.timeEnd("preparing input"); }
    if (this.options.time) { console.time("block parsing"); }
    for (var i = 0; i < len; i++) {
        this.incorporateLine(lines[i]);
    }
    while (this.tip) {
        this.finalize(this.tip, len);
    }
    if (this.options.time) { console.timeEnd("block parsing"); }
    if (this.options.time) { console.time("inline parsing"); }
    this.processInlines(this.doc);
    if (this.options.time) { console.timeEnd("inline parsing"); }
    return this.doc;
};


// The Parser object.
function Parser(options){
    return {
        doc: new Document(),
        blocks: blocks,
        blockStarts: blockStarts,
        tip: this.doc,
        oldtip: this.doc,
        currentLine: "",
        lineNumber: 0,
        offset: 0,
        column: 0,
        nextNonspace: 0,
        nextNonspaceColumn: 0,
        indent: 0,
        indented: false,
        blank: false,
        allClosed: true,
        lastMatchedContainer: this.doc,
        refmap: {},
        lastLineLength: 0,
        inlineParser: new InlineParser(options),
        findNextNonspace: findNextNonspace,
        advanceOffset: advanceOffset,
        advanceNextNonspace: advanceNextNonspace,
        breakOutOfLists: breakOutOfLists,
        addLine: addLine,
        addChild: addChild,
        incorporateLine: incorporateLine,
        finalize: finalize,
        processInlines: processInlines,
        closeUnmatchedBlocks: closeUnmatchedBlocks,
        parse: parse,
        options: options || {}
    };
}

module.exports = Parser;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// derived from https://github.com/mathiasbynens/String.fromCodePoint
/*! http://mths.be/fromcodepoint v0.2.1 by @mathias */
if (String.fromCodePoint) {
    module.exports = function (_) {
        try {
            return String.fromCodePoint(_);
        } catch (e) {
            if (e instanceof RangeError) {
                return String.fromCharCode(0xFFFD);
            }
            throw e;
        }
    };

} else {

  var stringFromCharCode = String.fromCharCode;
  var floor = Math.floor;
  var fromCodePoint = function() {
      var MAX_SIZE = 0x4000;
      var codeUnits = [];
      var highSurrogate;
      var lowSurrogate;
      var index = -1;
      var length = arguments.length;
      if (!length) {
          return '';
      }
      var result = '';
      while (++index < length) {
          var codePoint = Number(arguments[index]);
          if (
              !isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
                  codePoint < 0 || // not a valid Unicode code point
                  codePoint > 0x10FFFF || // not a valid Unicode code point
                  floor(codePoint) !== codePoint // not an integer
          ) {
              return String.fromCharCode(0xFFFD);
          }
          if (codePoint <= 0xFFFF) { // BMP code point
              codeUnits.push(codePoint);
          } else { // Astral code point; split in surrogate halves
              // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
              codePoint -= 0x10000;
              highSurrogate = (codePoint >> 10) + 0xD800;
              lowSurrogate = (codePoint % 0x400) + 0xDC00;
              codeUnits.push(highSurrogate, lowSurrogate);
          }
          if (index + 1 === length || codeUnits.length > MAX_SIZE) {
              result += stringFromCharCode.apply(null, codeUnits);
              codeUnits.length = 0;
          }
      }
      return result;
  };
  module.exports = fromCodePoint;
}


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var escapeXml = __webpack_require__(75).escapeXml;

// Helper function to produce an HTML tag.
var tag = function(name, attrs, selfclosing) {
    var result = '<' + name;
    if (attrs && attrs.length > 0) {
        var i = 0;
        var attrib;
        while ((attrib = attrs[i]) !== undefined) {
            result += ' ' + attrib[0] + '="' + attrib[1] + '"';
            i++;
        }
    }
    if (selfclosing) {
        result += ' /';
    }

    result += '>';
    return result;
};

var reHtmlTag = /\<[^>]*\>/;
var reUnsafeProtocol = /^javascript:|vbscript:|file:|data:/i;
var reSafeDataProtocol = /^data:image\/(?:png|gif|jpeg|webp)/i;

var potentiallyUnsafe = function(url) {
    return reUnsafeProtocol.test(url) &&
        !reSafeDataProtocol.test(url);
};

var renderNodes = function(block) {

    var attrs;
    var info_words;
    var tagname;
    var walker = block.walker();
    var event, node, entering;
    var buffer = "";
    var lastOut = "\n";
    var disableTags = 0;
    var grandparent;
    var out = function(s) {
        if (disableTags > 0) {
            buffer += s.replace(reHtmlTag, '');
        } else {
            buffer += s;
        }
        lastOut = s;
    };
    var esc = this.escape;
    var cr = function() {
        if (lastOut !== '\n') {
            buffer += '\n';
            lastOut = '\n';
        }
    };

    var options = this.options;

    if (options.time) { console.time("rendering"); }

    while ((event = walker.next())) {
        entering = event.entering;
        node = event.node;

        attrs = [];
        if (options.sourcepos) {
            var pos = node.sourcepos;
            if (pos) {
                attrs.push(['data-sourcepos', String(pos[0][0]) + ':' +
                            String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
                            String(pos[1][1])]);
            }
        }

        switch (node.type) {
        case 'Text':
            out(esc(node.literal, false));
            break;

        case 'Softbreak':
            out(this.softbreak);
            break;

        case 'Hardbreak':
            out(tag('br', [], true));
            cr();
            break;

        case 'Emph':
            out(tag(entering ? 'em' : '/em'));
            break;

        case 'Strong':
            out(tag(entering ? 'strong' : '/strong'));
            break;

        case 'HtmlInline':
            if (options.safe) {
                out('<!-- raw HTML omitted -->');
            } else {
                out(node.literal);
            }
            break;

        case 'CustomInline':
            if (entering && node.onEnter) {
                out(node.onEnter);
            } else if (!entering && node.onExit) {
                out(node.onExit);
            }
            break;

        case 'Link':
            if (entering) {
                if (!(options.safe && potentiallyUnsafe(node.destination))) {
                    attrs.push(['href', esc(node.destination, true)]);
                }
                if (node.title) {
                    attrs.push(['title', esc(node.title, true)]);
                }
                out(tag('a', attrs));
            } else {
                out(tag('/a'));
            }
            break;

        case 'Image':
            if (entering) {
                if (disableTags === 0) {
                    if (options.safe &&
                         potentiallyUnsafe(node.destination)) {
                        out('<img src="" alt="');
                    } else {
                        out('<img src="' + esc(node.destination, true) +
                            '" alt="');
                    }
                }
                disableTags += 1;
            } else {
                disableTags -= 1;
                if (disableTags === 0) {
                    if (node.title) {
                        out('" title="' + esc(node.title, true));
                    }
                    out('" />');
                }
            }
            break;

        case 'Code':
            out(tag('code') + esc(node.literal, false) + tag('/code'));
            break;

        case 'Document':
            break;

        case 'Paragraph':
            grandparent = node.parent.parent;
            if (grandparent !== null &&
                grandparent.type === 'List') {
                if (grandparent.listTight) {
                    break;
                }
            }
            if (entering) {
                cr();
                out(tag('p', attrs));
            } else {
                out(tag('/p'));
                cr();
            }
            break;

        case 'BlockQuote':
            if (entering) {
                cr();
                out(tag('blockquote', attrs));
                cr();
            } else {
                cr();
                out(tag('/blockquote'));
                cr();
            }
            break;

        case 'Item':
            if (entering) {
                out(tag('li', attrs));
            } else {
                out(tag('/li'));
                cr();
            }
            break;

        case 'List':
            tagname = node.listType === 'Bullet' ? 'ul' : 'ol';
            if (entering) {
                var start = node.listStart;
                if (start !== null && start !== 1) {
                    attrs.push(['start', start.toString()]);
                }
                cr();
                out(tag(tagname, attrs));
                cr();
            } else {
                cr();
                out(tag('/' + tagname));
                cr();
            }
            break;

        case 'Heading':
            tagname = 'h' + node.level;
            if (entering) {
                cr();
                out(tag(tagname, attrs));
            } else {
                out(tag('/' + tagname));
                cr();
            }
            break;

        case 'CodeBlock':
            info_words = node.info ? node.info.split(/\s+/) : [];
            if (info_words.length > 0 && info_words[0].length > 0) {
                attrs.push(['class', 'language-' + esc(info_words[0], true)]);
            }
            cr();
            out(tag('pre') + tag('code', attrs));
            out(esc(node.literal, false));
            out(tag('/code') + tag('/pre'));
            cr();
            break;

        case 'HtmlBlock':
            cr();
            if (options.safe) {
                out('<!-- raw HTML omitted -->');
            } else {
                out(node.literal);
            }
            cr();
            break;

        case 'CustomBlock':
            cr();
            if (entering && node.onEnter) {
                out(node.onEnter);
            } else if (!entering && node.onExit) {
                out(node.onExit);
            }
            cr();
            break;

        case 'ThematicBreak':
            cr();
            out(tag('hr', attrs, true));
            cr();
            break;

        default:
            throw "Unknown node type " + node.type;
        }

    }
    if (options.time) { console.timeEnd("rendering"); }
    return buffer;
};

// The HtmlRenderer object.
function HtmlRenderer(options){
    return {
        // default options:
        softbreak: '\n', // by default, soft breaks are rendered as newlines in HTML
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        escape: escapeXml,
        options: options || {},
        render: renderNodes
    };
}

module.exports = HtmlRenderer;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// commonmark.js - CommomMark in JavaScript
// Copyright (C) 2014 John MacFarlane
// License: BSD3.

// Basic usage:
//
// var commonmark = require('commonmark');
// var parser = new commonmark.Parser();
// var renderer = new commonmark.HtmlRenderer();
// console.log(renderer.render(parser.parse('Hello *world*')));

module.exports.version = '0.24.0'
module.exports.Node = __webpack_require__(139);
module.exports.Parser = __webpack_require__(383);
module.exports.HtmlRenderer = __webpack_require__(385);
module.exports.XmlRenderer = __webpack_require__(389);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Node = __webpack_require__(139);
var common = __webpack_require__(75);
var normalizeReference = __webpack_require__(388);

var normalizeURI = common.normalizeURI;
var unescapeString = common.unescapeString;
var fromCodePoint = __webpack_require__(384);
var decodeHTML = __webpack_require__(272).decodeHTML;
__webpack_require__(911); // Polyfill for String.prototype.repeat

// Constants for character codes:

var C_NEWLINE = 10;
var C_ASTERISK = 42;
var C_UNDERSCORE = 95;
var C_BACKTICK = 96;
var C_OPEN_BRACKET = 91;
var C_CLOSE_BRACKET = 93;
var C_LESSTHAN = 60;
var C_BANG = 33;
var C_BACKSLASH = 92;
var C_AMPERSAND = 38;
var C_OPEN_PAREN = 40;
var C_CLOSE_PAREN = 41;
var C_COLON = 58;
var C_SINGLEQUOTE = 39;
var C_DOUBLEQUOTE = 34;

// Some regexps used in inline parser:

var ESCAPABLE = common.ESCAPABLE;
var ESCAPED_CHAR = '\\\\' + ESCAPABLE;
var REG_CHAR = '[^\\\\()\\x00-\\x20]';
var IN_PARENS_NOSP = '\\((' + REG_CHAR + '|' + ESCAPED_CHAR + '|\\\\)*\\)';

var ENTITY = common.ENTITY;
var reHtmlTag = common.reHtmlTag;

var rePunctuation = new RegExp(/^[\u2000-\u206F\u2E00-\u2E7F\\'!"#\$%&\(\)\*\+,\-\.\/:;<=>\?@\[\]\^_`\{\|\}~]/);

var reLinkTitle = new RegExp(
    '^(?:"(' + ESCAPED_CHAR + '|[^"\\x00])*"' +
        '|' +
        '\'(' + ESCAPED_CHAR + '|[^\'\\x00])*\'' +
        '|' +
        '\\((' + ESCAPED_CHAR + '|[^)\\x00])*\\))');

var reLinkDestinationBraces = new RegExp(
    '^(?:[<](?:[^ <>\\t\\n\\\\\\x00]' + '|' + ESCAPED_CHAR + '|' + '\\\\)*[>])');

var reLinkDestination = new RegExp(
    '^(?:' + REG_CHAR + '+|' + ESCAPED_CHAR + '|\\\\|' + IN_PARENS_NOSP + ')*');

var reEscapable = new RegExp('^' + ESCAPABLE);

var reEntityHere = new RegExp('^' + ENTITY, 'i');

var reTicks = /`+/;

var reTicksHere = /^`+/;

var reEllipses = /\.\.\./g;

var reDash = /--+/g;

var reEmailAutolink = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;

var reAutolink = /^<[A-Za-z][A-Za-z0-9.+-]{1,31}:[^<>\x00-\x20]*>/i;

var reSpnl = /^ *(?:\n *)?/;

var reWhitespaceChar = /^\s/;

var reWhitespace = /\s+/g;

var reFinalSpace = / *$/;

var reInitialSpace = /^ */;

var reSpaceAtEndOfLine = /^ *(?:\n|$)/;

var reLinkLabel = new RegExp('^\\[(?:[^\\\\\\[\\]]|' + ESCAPED_CHAR +
  '|\\\\){0,1000}\\]');

// Matches a string of non-special characters.
var reMain = /^[^\n`\[\]\\!<&*_'"]+/m;

var text = function(s) {
    var node = new Node('Text');
    node._literal = s;
    return node;
};

// INLINE PARSER

// These are methods of an InlineParser object, defined below.
// An InlineParser keeps track of a subject (a string to be
// parsed) and a position in that subject.

// If re matches at current position in the subject, advance
// position in subject and return the match; otherwise return null.
var match = function(re) {
    var m = re.exec(this.subject.slice(this.pos));
    if (m === null) {
        return null;
    } else {
        this.pos += m.index + m[0].length;
        return m[0];
    }
};

// Returns the code for the character at the current subject position, or -1
// there are no more characters.
var peek = function() {
    if (this.pos < this.subject.length) {
        return this.subject.charCodeAt(this.pos);
    } else {
        return -1;
    }
};

// Parse zero or more space characters, including at most one newline
var spnl = function() {
    this.match(reSpnl);
    return true;
};

// All of the parsers below try to match something at the current position
// in the subject.  If they succeed in matching anything, they
// return the inline matched, advancing the subject.

// Attempt to parse backticks, adding either a backtick code span or a
// literal sequence of backticks.
var parseBackticks = function(block) {
    var ticks = this.match(reTicksHere);
    if (ticks === null) {
        return false;
    }
    var afterOpenTicks = this.pos;
    var matched;
    var node;
    while ((matched = this.match(reTicks)) !== null) {
        if (matched === ticks) {
            node = new Node('Code');
            node._literal = this.subject.slice(afterOpenTicks,
                                        this.pos - ticks.length)
                          .trim().replace(reWhitespace, ' ');
            block.appendChild(node);
            return true;
        }
    }
    // If we got here, we didn't match a closing backtick sequence.
    this.pos = afterOpenTicks;
    block.appendChild(text(ticks));
    return true;
};

// Parse a backslash-escaped special character, adding either the escaped
// character, a hard line break (if the backslash is followed by a newline),
// or a literal backslash to the block's children.  Assumes current character
// is a backslash.
var parseBackslash = function(block) {
    var subj = this.subject;
    var node;
    this.pos += 1;
    if (this.peek() === C_NEWLINE) {
        this.pos += 1;
        node = new Node('Hardbreak');
        block.appendChild(node);
    } else if (reEscapable.test(subj.charAt(this.pos))) {
        block.appendChild(text(subj.charAt(this.pos)));
        this.pos += 1;
    } else {
        block.appendChild(text('\\'));
    }
    return true;
};

// Attempt to parse an autolink (URL or email in pointy brackets).
var parseAutolink = function(block) {
    var m;
    var dest;
    var node;
    if ((m = this.match(reEmailAutolink))) {
        dest = m.slice(1, m.length - 1);
        node = new Node('Link');
        node._destination = normalizeURI('mailto:' + dest);
        node._title = '';
        node.appendChild(text(dest));
        block.appendChild(node);
        return true;
    } else if ((m = this.match(reAutolink))) {
        dest = m.slice(1, m.length - 1);
        node = new Node('Link');
        node._destination = normalizeURI(dest);
        node._title = '';
        node.appendChild(text(dest));
        block.appendChild(node);
        return true;
    } else {
        return false;
    }
};

// Attempt to parse a raw HTML tag.
var parseHtmlTag = function(block) {
    var m = this.match(reHtmlTag);
    if (m === null) {
        return false;
    } else {
        var node = new Node('HtmlInline');
        node._literal = m;
        block.appendChild(node);
        return true;
    }
};

// Scan a sequence of characters with code cc, and return information about
// the number of delimiters and whether they are positioned such that
// they can open and/or close emphasis or strong emphasis.  A utility
// function for strong/emph parsing.
var scanDelims = function(cc) {
    var numdelims = 0;
    var char_before, char_after, cc_after;
    var startpos = this.pos;
    var left_flanking, right_flanking, can_open, can_close;
    var after_is_whitespace, after_is_punctuation, before_is_whitespace, before_is_punctuation;

    if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
        numdelims++;
        this.pos++;
    } else {
        while (this.peek() === cc) {
            numdelims++;
            this.pos++;
        }
    }

    if (numdelims === 0) {
        return null;
    }

    char_before = startpos === 0 ? '\n' : this.subject.charAt(startpos - 1);

    cc_after = this.peek();
    if (cc_after === -1) {
        char_after = '\n';
    } else {
        char_after = fromCodePoint(cc_after);
    }

    after_is_whitespace = reWhitespaceChar.test(char_after);
    after_is_punctuation = rePunctuation.test(char_after);
    before_is_whitespace = reWhitespaceChar.test(char_before);
    before_is_punctuation = rePunctuation.test(char_before);

    left_flanking = !after_is_whitespace &&
            !(after_is_punctuation && !before_is_whitespace && !before_is_punctuation);
    right_flanking = !before_is_whitespace &&
            !(before_is_punctuation && !after_is_whitespace && !after_is_punctuation);
    if (cc === C_UNDERSCORE) {
        can_open = left_flanking &&
            (!right_flanking || before_is_punctuation);
        can_close = right_flanking &&
            (!left_flanking || after_is_punctuation);
    } else if (cc === C_SINGLEQUOTE || cc === C_DOUBLEQUOTE) {
        can_open = left_flanking && !right_flanking;
        can_close = right_flanking;
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    this.pos = startpos;
    return { numdelims: numdelims,
             can_open: can_open,
             can_close: can_close };
};

// Handle a delimiter marker for emphasis or a quote.
var handleDelim = function(cc, block) {
    var res = this.scanDelims(cc);
    if (!res) {
        return false;
    }
    var numdelims = res.numdelims;
    var startpos = this.pos;
    var contents;

    this.pos += numdelims;
    if (cc === C_SINGLEQUOTE) {
        contents = "\u2019";
    } else if (cc === C_DOUBLEQUOTE) {
        contents = "\u201C";
    } else {
        contents = this.subject.slice(startpos, this.pos);
    }
    var node = text(contents);
    block.appendChild(node);

    // Add entry to stack for this opener
    this.delimiters = { cc: cc,
                        numdelims: numdelims,
                        node: node,
                        previous: this.delimiters,
                        next: null,
                        can_open: res.can_open,
                        can_close: res.can_close,
                        active: true };
    if (this.delimiters.previous !== null) {
        this.delimiters.previous.next = this.delimiters;
    }

    return true;

};

var removeDelimiter = function(delim) {
    if (delim.previous !== null) {
        delim.previous.next = delim.next;
    }
    if (delim.next === null) {
        // top of stack
        this.delimiters = delim.previous;
    } else {
        delim.next.previous = delim.previous;
    }
};

var removeDelimitersBetween = function(bottom, top) {
    if (bottom.next !== top) {
        bottom.next = top;
        top.previous = bottom;
    }
};

var processEmphasis = function(stack_bottom) {
    var opener, closer, old_closer;
    var opener_inl, closer_inl;
    var tempstack;
    var use_delims;
    var tmp, next;
    var opener_found;
    var openers_bottom = [];

    openers_bottom[C_UNDERSCORE] = stack_bottom;
    openers_bottom[C_ASTERISK] = stack_bottom;
    openers_bottom[C_SINGLEQUOTE] = stack_bottom;
    openers_bottom[C_DOUBLEQUOTE] = stack_bottom;

    // find first closer above stack_bottom:
    closer = this.delimiters;
    while (closer !== null && closer.previous !== stack_bottom) {
        closer = closer.previous;
    }
    // move forward, looking for closers, and handling each
    while (closer !== null) {
        var closercc = closer.cc;
        if (!(closer.can_close && (closercc === C_UNDERSCORE ||
                                   closercc === C_ASTERISK ||
                                   closercc === C_SINGLEQUOTE ||
                                   closercc === C_DOUBLEQUOTE))) {
            closer = closer.next;
        } else {
            // found emphasis closer. now look back for first matching opener:
            opener = closer.previous;
            opener_found = false;
            while (opener !== null && opener !== stack_bottom &&
                   opener !== openers_bottom[closercc]) {
                if (opener.cc === closer.cc && opener.can_open) {
                    opener_found = true;
                    break;
                }
                opener = opener.previous;
            }
            old_closer = closer;

            if (closercc === C_ASTERISK || closercc === C_UNDERSCORE) {
                if (!opener_found) {
                    closer = closer.next;
                } else {
                    // calculate actual number of delimiters used from closer
                    if (closer.numdelims < 3 || opener.numdelims < 3) {
                        use_delims = closer.numdelims <= opener.numdelims ?
                            closer.numdelims : opener.numdelims;
                    } else {
                        use_delims = closer.numdelims % 2 === 0 ? 2 : 1;
                    }

                    opener_inl = opener.node;
                    closer_inl = closer.node;

                    // remove used delimiters from stack elts and inlines
                    opener.numdelims -= use_delims;
                    closer.numdelims -= use_delims;
                    opener_inl._literal =
                        opener_inl._literal.slice(0,
                                                  opener_inl._literal.length - use_delims);
                    closer_inl._literal =
                        closer_inl._literal.slice(0,
                                                  closer_inl._literal.length - use_delims);

                    // build contents for new emph element
                    var emph = new Node(use_delims === 1 ? 'Emph' : 'Strong');

                    tmp = opener_inl._next;
                    while (tmp && tmp !== closer_inl) {
                        next = tmp._next;
                        tmp.unlink();
                        emph.appendChild(tmp);
                        tmp = next;
                    }

                    opener_inl.insertAfter(emph);

                    // remove elts between opener and closer in delimiters stack
                    removeDelimitersBetween(opener, closer);

                    // if opener has 0 delims, remove it and the inline
                    if (opener.numdelims === 0) {
                        opener_inl.unlink();
                        this.removeDelimiter(opener);
                    }

                    if (closer.numdelims === 0) {
                        closer_inl.unlink();
                        tempstack = closer.next;
                        this.removeDelimiter(closer);
                        closer = tempstack;
                    }

                }

            } else if (closercc === C_SINGLEQUOTE) {
                closer.node._literal = "\u2019";
                if (opener_found) {
                    opener.node._literal = "\u2018";
                }
                closer = closer.next;

            } else if (closercc === C_DOUBLEQUOTE) {
                closer.node._literal = "\u201D";
                if (opener_found) {
                    opener.node.literal = "\u201C";
                }
                closer = closer.next;

            }
            if (!opener_found) {
                // Set lower bound for future searches for openers:
                openers_bottom[closercc] = old_closer.previous;
                if (!old_closer.can_open) {
                    // We can remove a closer that can't be an opener,
                    // once we've seen there's no matching opener:
                    this.removeDelimiter(old_closer);
                }
            }
        }

    }

    // remove all delimiters
    while (this.delimiters !== null && this.delimiters !== stack_bottom) {
        this.removeDelimiter(this.delimiters);
    }
};

// Attempt to parse link title (sans quotes), returning the string
// or null if no match.
var parseLinkTitle = function() {
    var title = this.match(reLinkTitle);
    if (title === null) {
        return null;
    } else {
        // chop off quotes from title and unescape:
        return unescapeString(title.substr(1, title.length - 2));
    }
};

// Attempt to parse link destination, returning the string or
// null if no match.
var parseLinkDestination = function() {
    var res = this.match(reLinkDestinationBraces);
    if (res === null) {
        res = this.match(reLinkDestination);
        if (res === null) {
            return null;
        } else {
            return normalizeURI(unescapeString(res));
        }
    } else {  // chop off surrounding <..>:
        return normalizeURI(unescapeString(res.substr(1, res.length - 2)));
    }
};

// Attempt to parse a link label, returning number of characters parsed.
var parseLinkLabel = function() {
    var m = this.match(reLinkLabel);
    if (m === null || m.length > 1001) {
        return 0;
    } else {
        return m.length;
    }
};

// Add open bracket to delimiter stack and add a text node to block's children.
var parseOpenBracket = function(block) {
    var startpos = this.pos;
    this.pos += 1;

    var node = text('[');
    block.appendChild(node);

    // Add entry to stack for this opener
    this.delimiters = { cc: C_OPEN_BRACKET,
                        numdelims: 1,
                        node: node,
                        previous: this.delimiters,
                        next: null,
                        can_open: true,
                        can_close: false,
                        index: startpos,
                        active: true };
    if (this.delimiters.previous !== null) {
        this.delimiters.previous.next = this.delimiters;
    }

    return true;

};

// IF next character is [, and ! delimiter to delimiter stack and
// add a text node to block's children.  Otherwise just add a text node.
var parseBang = function(block) {
    var startpos = this.pos;
    this.pos += 1;
    if (this.peek() === C_OPEN_BRACKET) {
        this.pos += 1;

        var node = text('![');
        block.appendChild(node);

        // Add entry to stack for this opener
        this.delimiters = { cc: C_BANG,
                            numdelims: 1,
                            node: node,
                            previous: this.delimiters,
                            next: null,
                            can_open: true,
                            can_close: false,
                            index: startpos + 1,
                            active: true };
        if (this.delimiters.previous !== null) {
            this.delimiters.previous.next = this.delimiters;
        }
    } else {
        block.appendChild(text('!'));
    }
    return true;
};

// Try to match close bracket against an opening in the delimiter
// stack.  Add either a link or image, or a plain [ character,
// to block's children.  If there is a matching delimiter,
// remove it from the delimiter stack.
var parseCloseBracket = function(block) {
    var startpos;
    var is_image;
    var dest;
    var title;
    var matched = false;
    var reflabel;
    var opener;

    this.pos += 1;
    startpos = this.pos;

    // look through stack of delimiters for a [ or ![
    opener = this.delimiters;

    while (opener !== null) {
        if (opener.cc === C_OPEN_BRACKET || opener.cc === C_BANG) {
            break;
        }
        opener = opener.previous;
    }

    if (opener === null) {
        // no matched opener, just return a literal
        block.appendChild(text(']'));
        return true;
    }

    if (!opener.active) {
        // no matched opener, just return a literal
        block.appendChild(text(']'));
        // take opener off emphasis stack
        this.removeDelimiter(opener);
        return true;
    }

    // If we got here, open is a potential opener
    is_image = opener.cc === C_BANG;

    // Check to see if we have a link/image

    // Inline link?
    if (this.peek() === C_OPEN_PAREN) {
        this.pos++;
        if (this.spnl() &&
            ((dest = this.parseLinkDestination()) !== null) &&
            this.spnl() &&
            // make sure there's a space before the title:
            (reWhitespaceChar.test(this.subject.charAt(this.pos - 1)) &&
             (title = this.parseLinkTitle()) || true) &&
            this.spnl() &&
            this.peek() === C_CLOSE_PAREN) {
            this.pos += 1;
            matched = true;
        }
    } else {

        // Next, see if there's a link label
        var savepos = this.pos;
        var beforelabel = this.pos;
        var n = this.parseLinkLabel();
        if (n === 0 || n === 2) {
            // empty or missing second label
            reflabel = this.subject.slice(opener.index, startpos);
        } else {
            reflabel = this.subject.slice(beforelabel, beforelabel + n);
        }
        if (n === 0) {
            // If shortcut reference link, rewind before spaces we skipped.
            this.pos = savepos;
        }

        // lookup rawlabel in refmap
        var link = this.refmap[normalizeReference(reflabel)];
        if (link) {
            dest = link.destination;
            title = link.title;
            matched = true;
        }
    }

    if (matched) {
        var node = new Node(is_image ? 'Image' : 'Link');
        node._destination = dest;
        node._title = title || '';

        var tmp, next;
        tmp = opener.node._next;
        while (tmp) {
            next = tmp._next;
            tmp.unlink();
            node.appendChild(tmp);
            tmp = next;
        }
        block.appendChild(node);
        this.processEmphasis(opener.previous);

        opener.node.unlink();

        // processEmphasis will remove this and later delimiters.
        // Now, for a link, we also deactivate earlier link openers.
        // (no links in links)
        if (!is_image) {
          opener = this.delimiters;
          while (opener !== null) {
            if (opener.cc === C_OPEN_BRACKET) {
                opener.active = false; // deactivate this opener
            }
            opener = opener.previous;
          }
        }

        return true;

    } else { // no match

        this.removeDelimiter(opener);  // remove this opener from stack
        this.pos = startpos;
        block.appendChild(text(']'));
        return true;
    }

};

// Attempt to parse an entity.
var parseEntity = function(block) {
    var m;
    if ((m = this.match(reEntityHere))) {
        block.appendChild(text(decodeHTML(m)));
        return true;
    } else {
        return false;
    }
};

// Parse a run of ordinary characters, or a single character with
// a special meaning in markdown, as a plain string.
var parseString = function(block) {
    var m;
    if ((m = this.match(reMain))) {
        if (this.options.smart) {
            block.appendChild(text(
                m.replace(reEllipses, "\u2026")
                    .replace(reDash, function(chars) {
                        var enCount = 0;
                        var emCount = 0;
                        if (chars.length % 3 === 0) { // If divisible by 3, use all em dashes
                            emCount = chars.length / 3;
                        } else if (chars.length % 2 === 0) { // If divisible by 2, use all en dashes
                            enCount = chars.length / 2;
                        } else if (chars.length % 3 === 2) { // If 2 extra dashes, use en dash for last 2; em dashes for rest
                            enCount = 1;
                            emCount = (chars.length - 2) / 3;
                        } else { // Use en dashes for last 4 hyphens; em dashes for rest
                            enCount = 2;
                            emCount = (chars.length - 4) / 3;
                        }
                        return "\u2014".repeat(emCount) + "\u2013".repeat(enCount);
                    })));
        } else {
            block.appendChild(text(m));
        }
        return true;
    } else {
        return false;
    }
};

// Parse a newline.  If it was preceded by two spaces, return a hard
// line break; otherwise a soft line break.
var parseNewline = function(block) {
    this.pos += 1; // assume we're at a \n
    // check previous node for trailing spaces
    var lastc = block._lastChild;
    if (lastc && lastc.type === 'Text' && lastc._literal[lastc._literal.length - 1] === ' ') {
        var hardbreak = lastc._literal[lastc._literal.length - 2] === ' ';
        lastc._literal = lastc._literal.replace(reFinalSpace, '');
        block.appendChild(new Node(hardbreak ? 'Hardbreak' : 'Softbreak'));
    } else {
        block.appendChild(new Node('Softbreak'));
    }
    this.match(reInitialSpace); // gobble leading spaces in next line
    return true;
};

// Attempt to parse a link reference, modifying refmap.
var parseReference = function(s, refmap) {
    this.subject = s;
    this.pos = 0;
    var rawlabel;
    var dest;
    var title;
    var matchChars;
    var startpos = this.pos;

    // label:
    matchChars = this.parseLinkLabel();
    if (matchChars === 0) {
        return 0;
    } else {
        rawlabel = this.subject.substr(0, matchChars);
    }

    // colon:
    if (this.peek() === C_COLON) {
        this.pos++;
    } else {
        this.pos = startpos;
        return 0;
    }

    //  link url
    this.spnl();

    dest = this.parseLinkDestination();
    if (dest === null || dest.length === 0) {
        this.pos = startpos;
        return 0;
    }

    var beforetitle = this.pos;
    this.spnl();
    title = this.parseLinkTitle();
    if (title === null) {
        title = '';
        // rewind before spaces
        this.pos = beforetitle;
    }

    // make sure we're at line end:
    var atLineEnd = true;
    if (this.match(reSpaceAtEndOfLine) === null) {
        if (title === '') {
            atLineEnd = false;
        } else {
            // the potential title we found is not at the line end,
            // but it could still be a legal link reference if we
            // discard the title
            title = '';
            // rewind before spaces
            this.pos = beforetitle;
            // and instead check if the link URL is at the line end
            atLineEnd = this.match(reSpaceAtEndOfLine) !== null;
        }
    }

    if (!atLineEnd) {
        this.pos = startpos;
        return 0;
    }

    var normlabel = normalizeReference(rawlabel);
    if (normlabel === '') {
        // label must contain non-whitespace characters
        this.pos = startpos;
        return 0;
    }

    if (!refmap[normlabel]) {
        refmap[normlabel] = { destination: dest, title: title };
    }
    return this.pos - startpos;
};

// Parse the next inline element in subject, advancing subject position.
// On success, add the result to block's children and return true.
// On failure, return false.
var parseInline = function(block) {
    var res = false;
    var c = this.peek();
    if (c === -1) {
        return false;
    }
    switch(c) {
    case C_NEWLINE:
        res = this.parseNewline(block);
        break;
    case C_BACKSLASH:
        res = this.parseBackslash(block);
        break;
    case C_BACKTICK:
        res = this.parseBackticks(block);
        break;
    case C_ASTERISK:
    case C_UNDERSCORE:
        res = this.handleDelim(c, block);
        break;
    case C_SINGLEQUOTE:
    case C_DOUBLEQUOTE:
        res = this.options.smart && this.handleDelim(c, block);
        break;
    case C_OPEN_BRACKET:
        res = this.parseOpenBracket(block);
        break;
    case C_BANG:
        res = this.parseBang(block);
        break;
    case C_CLOSE_BRACKET:
        res = this.parseCloseBracket(block);
        break;
    case C_LESSTHAN:
        res = this.parseAutolink(block) || this.parseHtmlTag(block);
        break;
    case C_AMPERSAND:
        res = this.parseEntity(block);
        break;
    default:
        res = this.parseString(block);
        break;
    }
    if (!res) {
        this.pos += 1;
        block.appendChild(text(fromCodePoint(c)));
    }

    return true;
};

// Parse string content in block into inline children,
// using refmap to resolve references.
var parseInlines = function(block) {
    this.subject = block._string_content.trim();
    this.pos = 0;
    this.delimiters = null;
    while (this.parseInline(block)) {
    }
    block._string_content = null; // allow raw string to be garbage collected
    this.processEmphasis(null);
};

// The InlineParser object.
function InlineParser(options){
    return {
        subject: '',
        delimiters: null,  // used by handleDelim method
        pos: 0,
        refmap: {},
        match: match,
        peek: peek,
        spnl: spnl,
        parseBackticks: parseBackticks,
        parseBackslash: parseBackslash,
        parseAutolink: parseAutolink,
        parseHtmlTag: parseHtmlTag,
        scanDelims: scanDelims,
        handleDelim: handleDelim,
        parseLinkTitle: parseLinkTitle,
        parseLinkDestination: parseLinkDestination,
        parseLinkLabel: parseLinkLabel,
        parseOpenBracket: parseOpenBracket,
        parseCloseBracket: parseCloseBracket,
        parseBang: parseBang,
        parseEntity: parseEntity,
        parseString: parseString,
        parseNewline: parseNewline,
        parseReference: parseReference,
        parseInline: parseInline,
        processEmphasis: processEmphasis,
        removeDelimiter: removeDelimiter,
        options: options || {},
        parse: parseInlines
    };
}

module.exports = InlineParser;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* The bulk of this code derives from https://github.com/dmoscrop/fold-case
But in addition to case-folding, we also normalize whitespace.

fold-case is Copyright Mathias Bynens <https://mathiasbynens.be/>

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

/*eslint-disable  key-spacing, comma-spacing */

var regex = /[ \t\r\n]+|[A-Z\xB5\xC0-\xD6\xD8-\xDF\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u0149\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u017F\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C5\u01C7\u01C8\u01CA\u01CB\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F0-\u01F2\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0345\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03AB\u03B0\u03C2\u03CF-\u03D1\u03D5\u03D6\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F0\u03F1\u03F4\u03F5\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u0587\u10A0-\u10C5\u10C7\u10CD\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E96-\u1E9B\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F50\u1F52\u1F54\u1F56\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1F80-\u1FAF\u1FB2-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD2\u1FD3\u1FD6-\u1FDB\u1FE2-\u1FE4\u1FE6-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A\u212B\u2132\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0\uA7B1\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27]|\uD806[\uDCA0-\uDCBF]/g;

var map = {'A':'a','B':'b','C':'c','D':'d','E':'e','F':'f','G':'g','H':'h','I':'i','J':'j','K':'k','L':'l','M':'m','N':'n','O':'o','P':'p','Q':'q','R':'r','S':'s','T':'t','U':'u','V':'v','W':'w','X':'x','Y':'y','Z':'z','\xB5':'\u03BC','\xC0':'\xE0','\xC1':'\xE1','\xC2':'\xE2','\xC3':'\xE3','\xC4':'\xE4','\xC5':'\xE5','\xC6':'\xE6','\xC7':'\xE7','\xC8':'\xE8','\xC9':'\xE9','\xCA':'\xEA','\xCB':'\xEB','\xCC':'\xEC','\xCD':'\xED','\xCE':'\xEE','\xCF':'\xEF','\xD0':'\xF0','\xD1':'\xF1','\xD2':'\xF2','\xD3':'\xF3','\xD4':'\xF4','\xD5':'\xF5','\xD6':'\xF6','\xD8':'\xF8','\xD9':'\xF9','\xDA':'\xFA','\xDB':'\xFB','\xDC':'\xFC','\xDD':'\xFD','\xDE':'\xFE','\u0100':'\u0101','\u0102':'\u0103','\u0104':'\u0105','\u0106':'\u0107','\u0108':'\u0109','\u010A':'\u010B','\u010C':'\u010D','\u010E':'\u010F','\u0110':'\u0111','\u0112':'\u0113','\u0114':'\u0115','\u0116':'\u0117','\u0118':'\u0119','\u011A':'\u011B','\u011C':'\u011D','\u011E':'\u011F','\u0120':'\u0121','\u0122':'\u0123','\u0124':'\u0125','\u0126':'\u0127','\u0128':'\u0129','\u012A':'\u012B','\u012C':'\u012D','\u012E':'\u012F','\u0132':'\u0133','\u0134':'\u0135','\u0136':'\u0137','\u0139':'\u013A','\u013B':'\u013C','\u013D':'\u013E','\u013F':'\u0140','\u0141':'\u0142','\u0143':'\u0144','\u0145':'\u0146','\u0147':'\u0148','\u014A':'\u014B','\u014C':'\u014D','\u014E':'\u014F','\u0150':'\u0151','\u0152':'\u0153','\u0154':'\u0155','\u0156':'\u0157','\u0158':'\u0159','\u015A':'\u015B','\u015C':'\u015D','\u015E':'\u015F','\u0160':'\u0161','\u0162':'\u0163','\u0164':'\u0165','\u0166':'\u0167','\u0168':'\u0169','\u016A':'\u016B','\u016C':'\u016D','\u016E':'\u016F','\u0170':'\u0171','\u0172':'\u0173','\u0174':'\u0175','\u0176':'\u0177','\u0178':'\xFF','\u0179':'\u017A','\u017B':'\u017C','\u017D':'\u017E','\u017F':'s','\u0181':'\u0253','\u0182':'\u0183','\u0184':'\u0185','\u0186':'\u0254','\u0187':'\u0188','\u0189':'\u0256','\u018A':'\u0257','\u018B':'\u018C','\u018E':'\u01DD','\u018F':'\u0259','\u0190':'\u025B','\u0191':'\u0192','\u0193':'\u0260','\u0194':'\u0263','\u0196':'\u0269','\u0197':'\u0268','\u0198':'\u0199','\u019C':'\u026F','\u019D':'\u0272','\u019F':'\u0275','\u01A0':'\u01A1','\u01A2':'\u01A3','\u01A4':'\u01A5','\u01A6':'\u0280','\u01A7':'\u01A8','\u01A9':'\u0283','\u01AC':'\u01AD','\u01AE':'\u0288','\u01AF':'\u01B0','\u01B1':'\u028A','\u01B2':'\u028B','\u01B3':'\u01B4','\u01B5':'\u01B6','\u01B7':'\u0292','\u01B8':'\u01B9','\u01BC':'\u01BD','\u01C4':'\u01C6','\u01C5':'\u01C6','\u01C7':'\u01C9','\u01C8':'\u01C9','\u01CA':'\u01CC','\u01CB':'\u01CC','\u01CD':'\u01CE','\u01CF':'\u01D0','\u01D1':'\u01D2','\u01D3':'\u01D4','\u01D5':'\u01D6','\u01D7':'\u01D8','\u01D9':'\u01DA','\u01DB':'\u01DC','\u01DE':'\u01DF','\u01E0':'\u01E1','\u01E2':'\u01E3','\u01E4':'\u01E5','\u01E6':'\u01E7','\u01E8':'\u01E9','\u01EA':'\u01EB','\u01EC':'\u01ED','\u01EE':'\u01EF','\u01F1':'\u01F3','\u01F2':'\u01F3','\u01F4':'\u01F5','\u01F6':'\u0195','\u01F7':'\u01BF','\u01F8':'\u01F9','\u01FA':'\u01FB','\u01FC':'\u01FD','\u01FE':'\u01FF','\u0200':'\u0201','\u0202':'\u0203','\u0204':'\u0205','\u0206':'\u0207','\u0208':'\u0209','\u020A':'\u020B','\u020C':'\u020D','\u020E':'\u020F','\u0210':'\u0211','\u0212':'\u0213','\u0214':'\u0215','\u0216':'\u0217','\u0218':'\u0219','\u021A':'\u021B','\u021C':'\u021D','\u021E':'\u021F','\u0220':'\u019E','\u0222':'\u0223','\u0224':'\u0225','\u0226':'\u0227','\u0228':'\u0229','\u022A':'\u022B','\u022C':'\u022D','\u022E':'\u022F','\u0230':'\u0231','\u0232':'\u0233','\u023A':'\u2C65','\u023B':'\u023C','\u023D':'\u019A','\u023E':'\u2C66','\u0241':'\u0242','\u0243':'\u0180','\u0244':'\u0289','\u0245':'\u028C','\u0246':'\u0247','\u0248':'\u0249','\u024A':'\u024B','\u024C':'\u024D','\u024E':'\u024F','\u0345':'\u03B9','\u0370':'\u0371','\u0372':'\u0373','\u0376':'\u0377','\u037F':'\u03F3','\u0386':'\u03AC','\u0388':'\u03AD','\u0389':'\u03AE','\u038A':'\u03AF','\u038C':'\u03CC','\u038E':'\u03CD','\u038F':'\u03CE','\u0391':'\u03B1','\u0392':'\u03B2','\u0393':'\u03B3','\u0394':'\u03B4','\u0395':'\u03B5','\u0396':'\u03B6','\u0397':'\u03B7','\u0398':'\u03B8','\u0399':'\u03B9','\u039A':'\u03BA','\u039B':'\u03BB','\u039C':'\u03BC','\u039D':'\u03BD','\u039E':'\u03BE','\u039F':'\u03BF','\u03A0':'\u03C0','\u03A1':'\u03C1','\u03A3':'\u03C3','\u03A4':'\u03C4','\u03A5':'\u03C5','\u03A6':'\u03C6','\u03A7':'\u03C7','\u03A8':'\u03C8','\u03A9':'\u03C9','\u03AA':'\u03CA','\u03AB':'\u03CB','\u03C2':'\u03C3','\u03CF':'\u03D7','\u03D0':'\u03B2','\u03D1':'\u03B8','\u03D5':'\u03C6','\u03D6':'\u03C0','\u03D8':'\u03D9','\u03DA':'\u03DB','\u03DC':'\u03DD','\u03DE':'\u03DF','\u03E0':'\u03E1','\u03E2':'\u03E3','\u03E4':'\u03E5','\u03E6':'\u03E7','\u03E8':'\u03E9','\u03EA':'\u03EB','\u03EC':'\u03ED','\u03EE':'\u03EF','\u03F0':'\u03BA','\u03F1':'\u03C1','\u03F4':'\u03B8','\u03F5':'\u03B5','\u03F7':'\u03F8','\u03F9':'\u03F2','\u03FA':'\u03FB','\u03FD':'\u037B','\u03FE':'\u037C','\u03FF':'\u037D','\u0400':'\u0450','\u0401':'\u0451','\u0402':'\u0452','\u0403':'\u0453','\u0404':'\u0454','\u0405':'\u0455','\u0406':'\u0456','\u0407':'\u0457','\u0408':'\u0458','\u0409':'\u0459','\u040A':'\u045A','\u040B':'\u045B','\u040C':'\u045C','\u040D':'\u045D','\u040E':'\u045E','\u040F':'\u045F','\u0410':'\u0430','\u0411':'\u0431','\u0412':'\u0432','\u0413':'\u0433','\u0414':'\u0434','\u0415':'\u0435','\u0416':'\u0436','\u0417':'\u0437','\u0418':'\u0438','\u0419':'\u0439','\u041A':'\u043A','\u041B':'\u043B','\u041C':'\u043C','\u041D':'\u043D','\u041E':'\u043E','\u041F':'\u043F','\u0420':'\u0440','\u0421':'\u0441','\u0422':'\u0442','\u0423':'\u0443','\u0424':'\u0444','\u0425':'\u0445','\u0426':'\u0446','\u0427':'\u0447','\u0428':'\u0448','\u0429':'\u0449','\u042A':'\u044A','\u042B':'\u044B','\u042C':'\u044C','\u042D':'\u044D','\u042E':'\u044E','\u042F':'\u044F','\u0460':'\u0461','\u0462':'\u0463','\u0464':'\u0465','\u0466':'\u0467','\u0468':'\u0469','\u046A':'\u046B','\u046C':'\u046D','\u046E':'\u046F','\u0470':'\u0471','\u0472':'\u0473','\u0474':'\u0475','\u0476':'\u0477','\u0478':'\u0479','\u047A':'\u047B','\u047C':'\u047D','\u047E':'\u047F','\u0480':'\u0481','\u048A':'\u048B','\u048C':'\u048D','\u048E':'\u048F','\u0490':'\u0491','\u0492':'\u0493','\u0494':'\u0495','\u0496':'\u0497','\u0498':'\u0499','\u049A':'\u049B','\u049C':'\u049D','\u049E':'\u049F','\u04A0':'\u04A1','\u04A2':'\u04A3','\u04A4':'\u04A5','\u04A6':'\u04A7','\u04A8':'\u04A9','\u04AA':'\u04AB','\u04AC':'\u04AD','\u04AE':'\u04AF','\u04B0':'\u04B1','\u04B2':'\u04B3','\u04B4':'\u04B5','\u04B6':'\u04B7','\u04B8':'\u04B9','\u04BA':'\u04BB','\u04BC':'\u04BD','\u04BE':'\u04BF','\u04C0':'\u04CF','\u04C1':'\u04C2','\u04C3':'\u04C4','\u04C5':'\u04C6','\u04C7':'\u04C8','\u04C9':'\u04CA','\u04CB':'\u04CC','\u04CD':'\u04CE','\u04D0':'\u04D1','\u04D2':'\u04D3','\u04D4':'\u04D5','\u04D6':'\u04D7','\u04D8':'\u04D9','\u04DA':'\u04DB','\u04DC':'\u04DD','\u04DE':'\u04DF','\u04E0':'\u04E1','\u04E2':'\u04E3','\u04E4':'\u04E5','\u04E6':'\u04E7','\u04E8':'\u04E9','\u04EA':'\u04EB','\u04EC':'\u04ED','\u04EE':'\u04EF','\u04F0':'\u04F1','\u04F2':'\u04F3','\u04F4':'\u04F5','\u04F6':'\u04F7','\u04F8':'\u04F9','\u04FA':'\u04FB','\u04FC':'\u04FD','\u04FE':'\u04FF','\u0500':'\u0501','\u0502':'\u0503','\u0504':'\u0505','\u0506':'\u0507','\u0508':'\u0509','\u050A':'\u050B','\u050C':'\u050D','\u050E':'\u050F','\u0510':'\u0511','\u0512':'\u0513','\u0514':'\u0515','\u0516':'\u0517','\u0518':'\u0519','\u051A':'\u051B','\u051C':'\u051D','\u051E':'\u051F','\u0520':'\u0521','\u0522':'\u0523','\u0524':'\u0525','\u0526':'\u0527','\u0528':'\u0529','\u052A':'\u052B','\u052C':'\u052D','\u052E':'\u052F','\u0531':'\u0561','\u0532':'\u0562','\u0533':'\u0563','\u0534':'\u0564','\u0535':'\u0565','\u0536':'\u0566','\u0537':'\u0567','\u0538':'\u0568','\u0539':'\u0569','\u053A':'\u056A','\u053B':'\u056B','\u053C':'\u056C','\u053D':'\u056D','\u053E':'\u056E','\u053F':'\u056F','\u0540':'\u0570','\u0541':'\u0571','\u0542':'\u0572','\u0543':'\u0573','\u0544':'\u0574','\u0545':'\u0575','\u0546':'\u0576','\u0547':'\u0577','\u0548':'\u0578','\u0549':'\u0579','\u054A':'\u057A','\u054B':'\u057B','\u054C':'\u057C','\u054D':'\u057D','\u054E':'\u057E','\u054F':'\u057F','\u0550':'\u0580','\u0551':'\u0581','\u0552':'\u0582','\u0553':'\u0583','\u0554':'\u0584','\u0555':'\u0585','\u0556':'\u0586','\u10A0':'\u2D00','\u10A1':'\u2D01','\u10A2':'\u2D02','\u10A3':'\u2D03','\u10A4':'\u2D04','\u10A5':'\u2D05','\u10A6':'\u2D06','\u10A7':'\u2D07','\u10A8':'\u2D08','\u10A9':'\u2D09','\u10AA':'\u2D0A','\u10AB':'\u2D0B','\u10AC':'\u2D0C','\u10AD':'\u2D0D','\u10AE':'\u2D0E','\u10AF':'\u2D0F','\u10B0':'\u2D10','\u10B1':'\u2D11','\u10B2':'\u2D12','\u10B3':'\u2D13','\u10B4':'\u2D14','\u10B5':'\u2D15','\u10B6':'\u2D16','\u10B7':'\u2D17','\u10B8':'\u2D18','\u10B9':'\u2D19','\u10BA':'\u2D1A','\u10BB':'\u2D1B','\u10BC':'\u2D1C','\u10BD':'\u2D1D','\u10BE':'\u2D1E','\u10BF':'\u2D1F','\u10C0':'\u2D20','\u10C1':'\u2D21','\u10C2':'\u2D22','\u10C3':'\u2D23','\u10C4':'\u2D24','\u10C5':'\u2D25','\u10C7':'\u2D27','\u10CD':'\u2D2D','\u1E00':'\u1E01','\u1E02':'\u1E03','\u1E04':'\u1E05','\u1E06':'\u1E07','\u1E08':'\u1E09','\u1E0A':'\u1E0B','\u1E0C':'\u1E0D','\u1E0E':'\u1E0F','\u1E10':'\u1E11','\u1E12':'\u1E13','\u1E14':'\u1E15','\u1E16':'\u1E17','\u1E18':'\u1E19','\u1E1A':'\u1E1B','\u1E1C':'\u1E1D','\u1E1E':'\u1E1F','\u1E20':'\u1E21','\u1E22':'\u1E23','\u1E24':'\u1E25','\u1E26':'\u1E27','\u1E28':'\u1E29','\u1E2A':'\u1E2B','\u1E2C':'\u1E2D','\u1E2E':'\u1E2F','\u1E30':'\u1E31','\u1E32':'\u1E33','\u1E34':'\u1E35','\u1E36':'\u1E37','\u1E38':'\u1E39','\u1E3A':'\u1E3B','\u1E3C':'\u1E3D','\u1E3E':'\u1E3F','\u1E40':'\u1E41','\u1E42':'\u1E43','\u1E44':'\u1E45','\u1E46':'\u1E47','\u1E48':'\u1E49','\u1E4A':'\u1E4B','\u1E4C':'\u1E4D','\u1E4E':'\u1E4F','\u1E50':'\u1E51','\u1E52':'\u1E53','\u1E54':'\u1E55','\u1E56':'\u1E57','\u1E58':'\u1E59','\u1E5A':'\u1E5B','\u1E5C':'\u1E5D','\u1E5E':'\u1E5F','\u1E60':'\u1E61','\u1E62':'\u1E63','\u1E64':'\u1E65','\u1E66':'\u1E67','\u1E68':'\u1E69','\u1E6A':'\u1E6B','\u1E6C':'\u1E6D','\u1E6E':'\u1E6F','\u1E70':'\u1E71','\u1E72':'\u1E73','\u1E74':'\u1E75','\u1E76':'\u1E77','\u1E78':'\u1E79','\u1E7A':'\u1E7B','\u1E7C':'\u1E7D','\u1E7E':'\u1E7F','\u1E80':'\u1E81','\u1E82':'\u1E83','\u1E84':'\u1E85','\u1E86':'\u1E87','\u1E88':'\u1E89','\u1E8A':'\u1E8B','\u1E8C':'\u1E8D','\u1E8E':'\u1E8F','\u1E90':'\u1E91','\u1E92':'\u1E93','\u1E94':'\u1E95','\u1E9B':'\u1E61','\u1EA0':'\u1EA1','\u1EA2':'\u1EA3','\u1EA4':'\u1EA5','\u1EA6':'\u1EA7','\u1EA8':'\u1EA9','\u1EAA':'\u1EAB','\u1EAC':'\u1EAD','\u1EAE':'\u1EAF','\u1EB0':'\u1EB1','\u1EB2':'\u1EB3','\u1EB4':'\u1EB5','\u1EB6':'\u1EB7','\u1EB8':'\u1EB9','\u1EBA':'\u1EBB','\u1EBC':'\u1EBD','\u1EBE':'\u1EBF','\u1EC0':'\u1EC1','\u1EC2':'\u1EC3','\u1EC4':'\u1EC5','\u1EC6':'\u1EC7','\u1EC8':'\u1EC9','\u1ECA':'\u1ECB','\u1ECC':'\u1ECD','\u1ECE':'\u1ECF','\u1ED0':'\u1ED1','\u1ED2':'\u1ED3','\u1ED4':'\u1ED5','\u1ED6':'\u1ED7','\u1ED8':'\u1ED9','\u1EDA':'\u1EDB','\u1EDC':'\u1EDD','\u1EDE':'\u1EDF','\u1EE0':'\u1EE1','\u1EE2':'\u1EE3','\u1EE4':'\u1EE5','\u1EE6':'\u1EE7','\u1EE8':'\u1EE9','\u1EEA':'\u1EEB','\u1EEC':'\u1EED','\u1EEE':'\u1EEF','\u1EF0':'\u1EF1','\u1EF2':'\u1EF3','\u1EF4':'\u1EF5','\u1EF6':'\u1EF7','\u1EF8':'\u1EF9','\u1EFA':'\u1EFB','\u1EFC':'\u1EFD','\u1EFE':'\u1EFF','\u1F08':'\u1F00','\u1F09':'\u1F01','\u1F0A':'\u1F02','\u1F0B':'\u1F03','\u1F0C':'\u1F04','\u1F0D':'\u1F05','\u1F0E':'\u1F06','\u1F0F':'\u1F07','\u1F18':'\u1F10','\u1F19':'\u1F11','\u1F1A':'\u1F12','\u1F1B':'\u1F13','\u1F1C':'\u1F14','\u1F1D':'\u1F15','\u1F28':'\u1F20','\u1F29':'\u1F21','\u1F2A':'\u1F22','\u1F2B':'\u1F23','\u1F2C':'\u1F24','\u1F2D':'\u1F25','\u1F2E':'\u1F26','\u1F2F':'\u1F27','\u1F38':'\u1F30','\u1F39':'\u1F31','\u1F3A':'\u1F32','\u1F3B':'\u1F33','\u1F3C':'\u1F34','\u1F3D':'\u1F35','\u1F3E':'\u1F36','\u1F3F':'\u1F37','\u1F48':'\u1F40','\u1F49':'\u1F41','\u1F4A':'\u1F42','\u1F4B':'\u1F43','\u1F4C':'\u1F44','\u1F4D':'\u1F45','\u1F59':'\u1F51','\u1F5B':'\u1F53','\u1F5D':'\u1F55','\u1F5F':'\u1F57','\u1F68':'\u1F60','\u1F69':'\u1F61','\u1F6A':'\u1F62','\u1F6B':'\u1F63','\u1F6C':'\u1F64','\u1F6D':'\u1F65','\u1F6E':'\u1F66','\u1F6F':'\u1F67','\u1FB8':'\u1FB0','\u1FB9':'\u1FB1','\u1FBA':'\u1F70','\u1FBB':'\u1F71','\u1FBE':'\u03B9','\u1FC8':'\u1F72','\u1FC9':'\u1F73','\u1FCA':'\u1F74','\u1FCB':'\u1F75','\u1FD8':'\u1FD0','\u1FD9':'\u1FD1','\u1FDA':'\u1F76','\u1FDB':'\u1F77','\u1FE8':'\u1FE0','\u1FE9':'\u1FE1','\u1FEA':'\u1F7A','\u1FEB':'\u1F7B','\u1FEC':'\u1FE5','\u1FF8':'\u1F78','\u1FF9':'\u1F79','\u1FFA':'\u1F7C','\u1FFB':'\u1F7D','\u2126':'\u03C9','\u212A':'k','\u212B':'\xE5','\u2132':'\u214E','\u2160':'\u2170','\u2161':'\u2171','\u2162':'\u2172','\u2163':'\u2173','\u2164':'\u2174','\u2165':'\u2175','\u2166':'\u2176','\u2167':'\u2177','\u2168':'\u2178','\u2169':'\u2179','\u216A':'\u217A','\u216B':'\u217B','\u216C':'\u217C','\u216D':'\u217D','\u216E':'\u217E','\u216F':'\u217F','\u2183':'\u2184','\u24B6':'\u24D0','\u24B7':'\u24D1','\u24B8':'\u24D2','\u24B9':'\u24D3','\u24BA':'\u24D4','\u24BB':'\u24D5','\u24BC':'\u24D6','\u24BD':'\u24D7','\u24BE':'\u24D8','\u24BF':'\u24D9','\u24C0':'\u24DA','\u24C1':'\u24DB','\u24C2':'\u24DC','\u24C3':'\u24DD','\u24C4':'\u24DE','\u24C5':'\u24DF','\u24C6':'\u24E0','\u24C7':'\u24E1','\u24C8':'\u24E2','\u24C9':'\u24E3','\u24CA':'\u24E4','\u24CB':'\u24E5','\u24CC':'\u24E6','\u24CD':'\u24E7','\u24CE':'\u24E8','\u24CF':'\u24E9','\u2C00':'\u2C30','\u2C01':'\u2C31','\u2C02':'\u2C32','\u2C03':'\u2C33','\u2C04':'\u2C34','\u2C05':'\u2C35','\u2C06':'\u2C36','\u2C07':'\u2C37','\u2C08':'\u2C38','\u2C09':'\u2C39','\u2C0A':'\u2C3A','\u2C0B':'\u2C3B','\u2C0C':'\u2C3C','\u2C0D':'\u2C3D','\u2C0E':'\u2C3E','\u2C0F':'\u2C3F','\u2C10':'\u2C40','\u2C11':'\u2C41','\u2C12':'\u2C42','\u2C13':'\u2C43','\u2C14':'\u2C44','\u2C15':'\u2C45','\u2C16':'\u2C46','\u2C17':'\u2C47','\u2C18':'\u2C48','\u2C19':'\u2C49','\u2C1A':'\u2C4A','\u2C1B':'\u2C4B','\u2C1C':'\u2C4C','\u2C1D':'\u2C4D','\u2C1E':'\u2C4E','\u2C1F':'\u2C4F','\u2C20':'\u2C50','\u2C21':'\u2C51','\u2C22':'\u2C52','\u2C23':'\u2C53','\u2C24':'\u2C54','\u2C25':'\u2C55','\u2C26':'\u2C56','\u2C27':'\u2C57','\u2C28':'\u2C58','\u2C29':'\u2C59','\u2C2A':'\u2C5A','\u2C2B':'\u2C5B','\u2C2C':'\u2C5C','\u2C2D':'\u2C5D','\u2C2E':'\u2C5E','\u2C60':'\u2C61','\u2C62':'\u026B','\u2C63':'\u1D7D','\u2C64':'\u027D','\u2C67':'\u2C68','\u2C69':'\u2C6A','\u2C6B':'\u2C6C','\u2C6D':'\u0251','\u2C6E':'\u0271','\u2C6F':'\u0250','\u2C70':'\u0252','\u2C72':'\u2C73','\u2C75':'\u2C76','\u2C7E':'\u023F','\u2C7F':'\u0240','\u2C80':'\u2C81','\u2C82':'\u2C83','\u2C84':'\u2C85','\u2C86':'\u2C87','\u2C88':'\u2C89','\u2C8A':'\u2C8B','\u2C8C':'\u2C8D','\u2C8E':'\u2C8F','\u2C90':'\u2C91','\u2C92':'\u2C93','\u2C94':'\u2C95','\u2C96':'\u2C97','\u2C98':'\u2C99','\u2C9A':'\u2C9B','\u2C9C':'\u2C9D','\u2C9E':'\u2C9F','\u2CA0':'\u2CA1','\u2CA2':'\u2CA3','\u2CA4':'\u2CA5','\u2CA6':'\u2CA7','\u2CA8':'\u2CA9','\u2CAA':'\u2CAB','\u2CAC':'\u2CAD','\u2CAE':'\u2CAF','\u2CB0':'\u2CB1','\u2CB2':'\u2CB3','\u2CB4':'\u2CB5','\u2CB6':'\u2CB7','\u2CB8':'\u2CB9','\u2CBA':'\u2CBB','\u2CBC':'\u2CBD','\u2CBE':'\u2CBF','\u2CC0':'\u2CC1','\u2CC2':'\u2CC3','\u2CC4':'\u2CC5','\u2CC6':'\u2CC7','\u2CC8':'\u2CC9','\u2CCA':'\u2CCB','\u2CCC':'\u2CCD','\u2CCE':'\u2CCF','\u2CD0':'\u2CD1','\u2CD2':'\u2CD3','\u2CD4':'\u2CD5','\u2CD6':'\u2CD7','\u2CD8':'\u2CD9','\u2CDA':'\u2CDB','\u2CDC':'\u2CDD','\u2CDE':'\u2CDF','\u2CE0':'\u2CE1','\u2CE2':'\u2CE3','\u2CEB':'\u2CEC','\u2CED':'\u2CEE','\u2CF2':'\u2CF3','\uA640':'\uA641','\uA642':'\uA643','\uA644':'\uA645','\uA646':'\uA647','\uA648':'\uA649','\uA64A':'\uA64B','\uA64C':'\uA64D','\uA64E':'\uA64F','\uA650':'\uA651','\uA652':'\uA653','\uA654':'\uA655','\uA656':'\uA657','\uA658':'\uA659','\uA65A':'\uA65B','\uA65C':'\uA65D','\uA65E':'\uA65F','\uA660':'\uA661','\uA662':'\uA663','\uA664':'\uA665','\uA666':'\uA667','\uA668':'\uA669','\uA66A':'\uA66B','\uA66C':'\uA66D','\uA680':'\uA681','\uA682':'\uA683','\uA684':'\uA685','\uA686':'\uA687','\uA688':'\uA689','\uA68A':'\uA68B','\uA68C':'\uA68D','\uA68E':'\uA68F','\uA690':'\uA691','\uA692':'\uA693','\uA694':'\uA695','\uA696':'\uA697','\uA698':'\uA699','\uA69A':'\uA69B','\uA722':'\uA723','\uA724':'\uA725','\uA726':'\uA727','\uA728':'\uA729','\uA72A':'\uA72B','\uA72C':'\uA72D','\uA72E':'\uA72F','\uA732':'\uA733','\uA734':'\uA735','\uA736':'\uA737','\uA738':'\uA739','\uA73A':'\uA73B','\uA73C':'\uA73D','\uA73E':'\uA73F','\uA740':'\uA741','\uA742':'\uA743','\uA744':'\uA745','\uA746':'\uA747','\uA748':'\uA749','\uA74A':'\uA74B','\uA74C':'\uA74D','\uA74E':'\uA74F','\uA750':'\uA751','\uA752':'\uA753','\uA754':'\uA755','\uA756':'\uA757','\uA758':'\uA759','\uA75A':'\uA75B','\uA75C':'\uA75D','\uA75E':'\uA75F','\uA760':'\uA761','\uA762':'\uA763','\uA764':'\uA765','\uA766':'\uA767','\uA768':'\uA769','\uA76A':'\uA76B','\uA76C':'\uA76D','\uA76E':'\uA76F','\uA779':'\uA77A','\uA77B':'\uA77C','\uA77D':'\u1D79','\uA77E':'\uA77F','\uA780':'\uA781','\uA782':'\uA783','\uA784':'\uA785','\uA786':'\uA787','\uA78B':'\uA78C','\uA78D':'\u0265','\uA790':'\uA791','\uA792':'\uA793','\uA796':'\uA797','\uA798':'\uA799','\uA79A':'\uA79B','\uA79C':'\uA79D','\uA79E':'\uA79F','\uA7A0':'\uA7A1','\uA7A2':'\uA7A3','\uA7A4':'\uA7A5','\uA7A6':'\uA7A7','\uA7A8':'\uA7A9','\uA7AA':'\u0266','\uA7AB':'\u025C','\uA7AC':'\u0261','\uA7AD':'\u026C','\uA7B0':'\u029E','\uA7B1':'\u0287','\uFF21':'\uFF41','\uFF22':'\uFF42','\uFF23':'\uFF43','\uFF24':'\uFF44','\uFF25':'\uFF45','\uFF26':'\uFF46','\uFF27':'\uFF47','\uFF28':'\uFF48','\uFF29':'\uFF49','\uFF2A':'\uFF4A','\uFF2B':'\uFF4B','\uFF2C':'\uFF4C','\uFF2D':'\uFF4D','\uFF2E':'\uFF4E','\uFF2F':'\uFF4F','\uFF30':'\uFF50','\uFF31':'\uFF51','\uFF32':'\uFF52','\uFF33':'\uFF53','\uFF34':'\uFF54','\uFF35':'\uFF55','\uFF36':'\uFF56','\uFF37':'\uFF57','\uFF38':'\uFF58','\uFF39':'\uFF59','\uFF3A':'\uFF5A','\uD801\uDC00':'\uD801\uDC28','\uD801\uDC01':'\uD801\uDC29','\uD801\uDC02':'\uD801\uDC2A','\uD801\uDC03':'\uD801\uDC2B','\uD801\uDC04':'\uD801\uDC2C','\uD801\uDC05':'\uD801\uDC2D','\uD801\uDC06':'\uD801\uDC2E','\uD801\uDC07':'\uD801\uDC2F','\uD801\uDC08':'\uD801\uDC30','\uD801\uDC09':'\uD801\uDC31','\uD801\uDC0A':'\uD801\uDC32','\uD801\uDC0B':'\uD801\uDC33','\uD801\uDC0C':'\uD801\uDC34','\uD801\uDC0D':'\uD801\uDC35','\uD801\uDC0E':'\uD801\uDC36','\uD801\uDC0F':'\uD801\uDC37','\uD801\uDC10':'\uD801\uDC38','\uD801\uDC11':'\uD801\uDC39','\uD801\uDC12':'\uD801\uDC3A','\uD801\uDC13':'\uD801\uDC3B','\uD801\uDC14':'\uD801\uDC3C','\uD801\uDC15':'\uD801\uDC3D','\uD801\uDC16':'\uD801\uDC3E','\uD801\uDC17':'\uD801\uDC3F','\uD801\uDC18':'\uD801\uDC40','\uD801\uDC19':'\uD801\uDC41','\uD801\uDC1A':'\uD801\uDC42','\uD801\uDC1B':'\uD801\uDC43','\uD801\uDC1C':'\uD801\uDC44','\uD801\uDC1D':'\uD801\uDC45','\uD801\uDC1E':'\uD801\uDC46','\uD801\uDC1F':'\uD801\uDC47','\uD801\uDC20':'\uD801\uDC48','\uD801\uDC21':'\uD801\uDC49','\uD801\uDC22':'\uD801\uDC4A','\uD801\uDC23':'\uD801\uDC4B','\uD801\uDC24':'\uD801\uDC4C','\uD801\uDC25':'\uD801\uDC4D','\uD801\uDC26':'\uD801\uDC4E','\uD801\uDC27':'\uD801\uDC4F','\uD806\uDCA0':'\uD806\uDCC0','\uD806\uDCA1':'\uD806\uDCC1','\uD806\uDCA2':'\uD806\uDCC2','\uD806\uDCA3':'\uD806\uDCC3','\uD806\uDCA4':'\uD806\uDCC4','\uD806\uDCA5':'\uD806\uDCC5','\uD806\uDCA6':'\uD806\uDCC6','\uD806\uDCA7':'\uD806\uDCC7','\uD806\uDCA8':'\uD806\uDCC8','\uD806\uDCA9':'\uD806\uDCC9','\uD806\uDCAA':'\uD806\uDCCA','\uD806\uDCAB':'\uD806\uDCCB','\uD806\uDCAC':'\uD806\uDCCC','\uD806\uDCAD':'\uD806\uDCCD','\uD806\uDCAE':'\uD806\uDCCE','\uD806\uDCAF':'\uD806\uDCCF','\uD806\uDCB0':'\uD806\uDCD0','\uD806\uDCB1':'\uD806\uDCD1','\uD806\uDCB2':'\uD806\uDCD2','\uD806\uDCB3':'\uD806\uDCD3','\uD806\uDCB4':'\uD806\uDCD4','\uD806\uDCB5':'\uD806\uDCD5','\uD806\uDCB6':'\uD806\uDCD6','\uD806\uDCB7':'\uD806\uDCD7','\uD806\uDCB8':'\uD806\uDCD8','\uD806\uDCB9':'\uD806\uDCD9','\uD806\uDCBA':'\uD806\uDCDA','\uD806\uDCBB':'\uD806\uDCDB','\uD806\uDCBC':'\uD806\uDCDC','\uD806\uDCBD':'\uD806\uDCDD','\uD806\uDCBE':'\uD806\uDCDE','\uD806\uDCBF':'\uD806\uDCDF','\xDF':'ss','\u0130':'i\u0307','\u0149':'\u02BCn','\u01F0':'j\u030C','\u0390':'\u03B9\u0308\u0301','\u03B0':'\u03C5\u0308\u0301','\u0587':'\u0565\u0582','\u1E96':'h\u0331','\u1E97':'t\u0308','\u1E98':'w\u030A','\u1E99':'y\u030A','\u1E9A':'a\u02BE','\u1E9E':'ss','\u1F50':'\u03C5\u0313','\u1F52':'\u03C5\u0313\u0300','\u1F54':'\u03C5\u0313\u0301','\u1F56':'\u03C5\u0313\u0342','\u1F80':'\u1F00\u03B9','\u1F81':'\u1F01\u03B9','\u1F82':'\u1F02\u03B9','\u1F83':'\u1F03\u03B9','\u1F84':'\u1F04\u03B9','\u1F85':'\u1F05\u03B9','\u1F86':'\u1F06\u03B9','\u1F87':'\u1F07\u03B9','\u1F88':'\u1F00\u03B9','\u1F89':'\u1F01\u03B9','\u1F8A':'\u1F02\u03B9','\u1F8B':'\u1F03\u03B9','\u1F8C':'\u1F04\u03B9','\u1F8D':'\u1F05\u03B9','\u1F8E':'\u1F06\u03B9','\u1F8F':'\u1F07\u03B9','\u1F90':'\u1F20\u03B9','\u1F91':'\u1F21\u03B9','\u1F92':'\u1F22\u03B9','\u1F93':'\u1F23\u03B9','\u1F94':'\u1F24\u03B9','\u1F95':'\u1F25\u03B9','\u1F96':'\u1F26\u03B9','\u1F97':'\u1F27\u03B9','\u1F98':'\u1F20\u03B9','\u1F99':'\u1F21\u03B9','\u1F9A':'\u1F22\u03B9','\u1F9B':'\u1F23\u03B9','\u1F9C':'\u1F24\u03B9','\u1F9D':'\u1F25\u03B9','\u1F9E':'\u1F26\u03B9','\u1F9F':'\u1F27\u03B9','\u1FA0':'\u1F60\u03B9','\u1FA1':'\u1F61\u03B9','\u1FA2':'\u1F62\u03B9','\u1FA3':'\u1F63\u03B9','\u1FA4':'\u1F64\u03B9','\u1FA5':'\u1F65\u03B9','\u1FA6':'\u1F66\u03B9','\u1FA7':'\u1F67\u03B9','\u1FA8':'\u1F60\u03B9','\u1FA9':'\u1F61\u03B9','\u1FAA':'\u1F62\u03B9','\u1FAB':'\u1F63\u03B9','\u1FAC':'\u1F64\u03B9','\u1FAD':'\u1F65\u03B9','\u1FAE':'\u1F66\u03B9','\u1FAF':'\u1F67\u03B9','\u1FB2':'\u1F70\u03B9','\u1FB3':'\u03B1\u03B9','\u1FB4':'\u03AC\u03B9','\u1FB6':'\u03B1\u0342','\u1FB7':'\u03B1\u0342\u03B9','\u1FBC':'\u03B1\u03B9','\u1FC2':'\u1F74\u03B9','\u1FC3':'\u03B7\u03B9','\u1FC4':'\u03AE\u03B9','\u1FC6':'\u03B7\u0342','\u1FC7':'\u03B7\u0342\u03B9','\u1FCC':'\u03B7\u03B9','\u1FD2':'\u03B9\u0308\u0300','\u1FD3':'\u03B9\u0308\u0301','\u1FD6':'\u03B9\u0342','\u1FD7':'\u03B9\u0308\u0342','\u1FE2':'\u03C5\u0308\u0300','\u1FE3':'\u03C5\u0308\u0301','\u1FE4':'\u03C1\u0313','\u1FE6':'\u03C5\u0342','\u1FE7':'\u03C5\u0308\u0342','\u1FF2':'\u1F7C\u03B9','\u1FF3':'\u03C9\u03B9','\u1FF4':'\u03CE\u03B9','\u1FF6':'\u03C9\u0342','\u1FF7':'\u03C9\u0342\u03B9','\u1FFC':'\u03C9\u03B9','\uFB00':'ff','\uFB01':'fi','\uFB02':'fl','\uFB03':'ffi','\uFB04':'ffl','\uFB05':'st','\uFB06':'st','\uFB13':'\u0574\u0576','\uFB14':'\u0574\u0565','\uFB15':'\u0574\u056B','\uFB16':'\u057E\u0576','\uFB17':'\u0574\u056D'};

// Normalize reference label: collapse internal whitespace
// to single space, remove leading/trailing whitespace, case fold.
module.exports = function(string) {
    return string.slice(1, string.length - 1).trim().replace(regex, function($0) {
        // Note: there is no need to check `hasOwnProperty($0)` here.
        // If character not found in lookup table, it must be whitespace.
        return map[$0] || ' ';
    });
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var escapeXml = __webpack_require__(75).escapeXml;

// Helper function to produce an XML tag.
var tag = function(name, attrs, selfclosing) {
    var result = '<' + name;
    if (attrs && attrs.length > 0) {
        var i = 0;
        var attrib;
        while ((attrib = attrs[i]) !== undefined) {
            result += ' ' + attrib[0] + '="' + attrib[1] + '"';
            i++;
        }
    }
    if (selfclosing) {
        result += ' /';
    }

    result += '>';
    return result;
};

var reXMLTag = /\<[^>]*\>/;

var toTagName = function(s) {
    return s.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
};

var renderNodes = function(block) {

    var attrs;
    var tagname;
    var walker = block.walker();
    var event, node, entering;
    var buffer = "";
    var lastOut = "\n";
    var disableTags = 0;
    var indentLevel = 0;
    var indent = '  ';
    var container;
    var selfClosing;
    var nodetype;

    var out = function(s) {
        if (disableTags > 0) {
            buffer += s.replace(reXMLTag, '');
        } else {
            buffer += s;
        }
        lastOut = s;
    };
    var esc = this.escape;
    var cr = function() {
        if (lastOut !== '\n') {
            buffer += '\n';
            lastOut = '\n';
            for (var i = indentLevel; i > 0; i--) {
                buffer += indent;
            }
        }
    };

    var options = this.options;

    if (options.time) { console.time("rendering"); }

    buffer += '<?xml version="1.0" encoding="UTF-8"?>\n';
    buffer += '<!DOCTYPE CommonMark SYSTEM "CommonMark.dtd">\n';

    while ((event = walker.next())) {
        entering = event.entering;
        node = event.node;
        nodetype = node.type;

        container = node.isContainer;
        selfClosing = nodetype === 'ThematicBreak' || nodetype === 'Hardbreak' ||
            nodetype === 'Softbreak';
        tagname = toTagName(nodetype);

        if (entering) {

            attrs = [];

            switch (nodetype) {
            case 'Document':
                attrs.push(['xmlns', 'http://commonmark.org/xml/1.0']);
                break;
            case 'List':
                if (node.listType !== null) {
                    attrs.push(['type', node.listType.toLowerCase()]);
                }
                if (node.listStart !== null) {
                    attrs.push(['start', String(node.listStart)]);
                }
                if (node.listTight !== null) {
                    attrs.push(['tight', (node.listTight ? 'true' : 'false')]);
                }
                var delim = node.listDelimiter;
                if (delim !== null) {
                    var delimword = '';
                    if (delim === '.') {
                        delimword = 'period';
                    } else {
                        delimword = 'paren';
                    }
                    attrs.push(['delimiter', delimword]);
                }
                break;
            case 'CodeBlock':
                if (node.info) {
                    attrs.push(['info', node.info]);
                }
                break;
            case 'Heading':
                attrs.push(['level', String(node.level)]);
                break;
            case 'Link':
            case 'Image':
                attrs.push(['destination', node.destination]);
                attrs.push(['title', node.title]);
                break;
            case 'CustomInline':
            case 'CustomBlock':
                attrs.push(['on_enter', node.onEnter]);
                attrs.push(['on_exit', node.onExit]);
                break;
            default:
                break;
            }
            if (options.sourcepos) {
                var pos = node.sourcepos;
                if (pos) {
                    attrs.push(['sourcepos', String(pos[0][0]) + ':' +
                                String(pos[0][1]) + '-' + String(pos[1][0]) + ':' +
                                String(pos[1][1])]);
                }
            }

            cr();
            out(tag(tagname, attrs, selfClosing));
            if (container) {
                indentLevel += 1;
            } else if (!container && !selfClosing) {
                var lit = node.literal;
                if (lit) {
                    out(esc(lit));
                }
                out(tag('/' + tagname));
            }
        } else {
            indentLevel -= 1;
            cr();
            out(tag('/' + tagname));
        }


    }
    if (options.time) { console.timeEnd("rendering"); }
    buffer += '\n';
    return buffer;
};

// The XmlRenderer object.
function XmlRenderer(options){
    return {
        // default options:
        softbreak: '\n', // by default, soft breaks are rendered as newlines in HTML
        // set to "<br />" to make them hard breaks
        // set to " " if you want to ignore line wrapping in source
        escape: escapeXml,
        options: options || {},
        render: renderNodes
    };
}

module.exports = XmlRenderer;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["contentful"] = factory();
	else
		root["contentful"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 96);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(38);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(163);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_es_modules_create_http_client__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__dist_es_modules_create_http_client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_es_modules_create_request_config__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__dist_es_modules_create_request_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dist_es_modules_enforce_obj_path__ = __webpack_require__(105);
/* unused harmony reexport enforceObjPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dist_es_modules_freeze_sys__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__dist_es_modules_freeze_sys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dist_es_modules_promised_wait__ = __webpack_require__(108);
/* unused harmony reexport promisedWait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dist_es_modules_to_plain_object__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__dist_es_modules_to_plain_object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dist_es_modules_get_user_agent__ = __webpack_require__(107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__dist_es_modules_get_user_agent__["a"]; });








/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(122);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(67),
    isLength = __webpack_require__(68);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(44),
    baseKeys = __webpack_require__(132),
    isArrayLike = __webpack_require__(6);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(24),
    baseAssignValue = __webpack_require__(45);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(183),
    listCacheDelete = __webpack_require__(184),
    listCacheGet = __webpack_require__(185),
    listCacheHas = __webpack_require__(186),
    listCacheSet = __webpack_require__(187);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(30);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(135),
    baseMatchesProperty = __webpack_require__(136),
    identity = __webpack_require__(31),
    isArray = __webpack_require__(1),
    property = __webpack_require__(223);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(46),
    isObject = __webpack_require__(3);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(180);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(131),
    getValue = __webpack_require__(169);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(93);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(34);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(34);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(188),
    mapCacheDelete = __webpack_require__(189),
    mapCacheGet = __webpack_require__(190),
    mapCacheHas = __webpack_require__(191),
    mapCacheSet = __webpack_require__(192);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(9),
    stackClear = __webpack_require__(202),
    stackDelete = __webpack_require__(203),
    stackGet = __webpack_require__(204),
    stackHas = __webpack_require__(205),
    stackSet = __webpack_require__(206);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(45),
    eq = __webpack_require__(30);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(125),
    createBaseEach = __webpack_require__(151);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(1),
    isSymbol = __webpack_require__(217);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(24),
    copyObject = __webpack_require__(8),
    createAssigner = __webpack_require__(150),
    isArrayLike = __webpack_require__(6),
    isPrototype = __webpack_require__(16),
    keys = __webpack_require__(7);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(85);
var buildURL = __webpack_require__(88);
var parseHeaders = __webpack_require__(94);
var isURLSameOrigin = __webpack_require__(92);
var createError = __webpack_require__(37);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(87);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if (undefined !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(90);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(84);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixinLinkGetters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_each__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_partial__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_partial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_memoize__);







/**
 * Sets getters on links for a given response
 * @private
 * @param {Array<Entry|Asset|DeletedEntry|DeletedAsset>} items
 * @param {Object} includes - Object with lists of Entry, Asset, DeletedEntry and DeletedAsset
 */
function mixinLinkGetters(items, includes) {
  var linkGetter = __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(getLinksFromIncludes, memoizationResolver);
  __WEBPACK_IMPORTED_MODULE_1_lodash_each___default()(items, function (item) {
    if (item.fields) {
      setLocalizedFieldGetters(item.fields, !!item.sys.locale);
    }
  });

  /**
   * If a field does not have a locale defined in sys, the content of that field
   * is an object where the keys are each available locale, and we need to iterate
   * over each of those
   * @private
   * @param {Object} fields - Fields object
   * @param {boolean} hasLocale - If entry has been requested with a locale
   */
  function setLocalizedFieldGetters(fields, hasLocale) {
    if (hasLocale) {
      setFieldGettersForFields(fields);
    } else {
      __WEBPACK_IMPORTED_MODULE_1_lodash_each___default()(fields, function (localizedField) {
        return setFieldGettersForFields(localizedField);
      });
    }
  }

  /**
   * Sets getters on each link field or list of link fields for each item
   * @private
   * @param {Object} fields - Fields object
   */
  function setFieldGettersForFields(fields) {
    __WEBPACK_IMPORTED_MODULE_1_lodash_each___default()(fields, function (field, fieldKey) {
      if (Array.isArray(field)) {
        addGetterForLinkArray(field, fieldKey, fields);
      } else {
        addGetterForLink(field, fieldKey, fields);
      }
    });
  }

  /**
   * Sets a getter which resolves the link of the given fieldKey in fields
   * @private
   * @param {Object} field - Field object
   * @param {string} fieldKey
   * @param {Object} fields - Fields object
   */
  function addGetterForLink(field, fieldKey, fields) {
    if (__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(field, 'sys.type') === 'Link') {
      Object.defineProperty(fields, fieldKey, {
        get: __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default()(linkGetter, field)
      });
    }
  }

  /**
   * Sets a getter which resolves the array of links of the given fieldKey in fields
   * @private
   * @param {Array<Object>} field - List field array
   * @param {string} fieldKey
   * @param {Object} fields - Fields object
   */
  function addGetterForLinkArray(listField, fieldKey, fields) {
    if (__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(listField[0], 'sys.type') === 'Link') {
      Object.defineProperty(fields, fieldKey, {
        get: function get() {
          return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(listField, __WEBPACK_IMPORTED_MODULE_4_lodash_partial___default()(linkGetter));
        }
      });
    }
  }

  /**
   * Looks for given link field in includes.
   * If linked entity is not found, it returns the original link.
   * This method shouldn't be used directly, and it's memoized whenever this
   * module's main method is used.
   * This is done to prevent the same link being resolved multiple times.
   * @private
   * @param {Object} field - Field object
   * @return {Object} Field, or link if field not resolved
   */
  function getLinksFromIncludes(field) {
    var link = __WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(includes[field.sys.linkType], ['sys.id', field.sys.id]);
    if (link && link.fields) {
      setLocalizedFieldGetters(link.fields, !!link.sys.locale);
      return link;
    }
    return field;
  }

  function memoizationResolver(link) {
    return link.sys.id;
  }
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mixinStringifySafe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_stringify_safe__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_stringify_safe__);


function mixinStringifySafe(data) {
  return Object.defineProperty(data, 'stringifySafe', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value() {
      var serializer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var indent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      return __WEBPACK_IMPORTED_MODULE_0_json_stringify_safe___default()(this, serializer, indent, function (key, value) {
        return {
          sys: {
            type: 'Link',
            linkType: 'Entry',
            id: value.sys.id,
            circular: true
          }
        };
      });
    }
  });
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(2);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(21),
    setCacheAdd = __webpack_require__(199),
    setCacheHas = __webpack_require__(200);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(140),
    isArguments = __webpack_require__(66),
    isArray = __webpack_require__(1),
    isBuffer = __webpack_require__(32),
    isIndex = __webpack_require__(15),
    isTypedArray = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(159);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(53),
    toKey = __webpack_require__(18);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(128),
    isObjectLike = __webpack_require__(69);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(31),
    overRest = __webpack_require__(197),
    setToString = __webpack_require__(201);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(1),
    isKey = __webpack_require__(27),
    stringToPath = __webpack_require__(208),
    toString = __webpack_require__(224);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(144),
    composeArgsRight = __webpack_require__(145),
    countHolders = __webpack_require__(149),
    createCtor = __webpack_require__(12),
    createRecurry = __webpack_require__(56),
    getHolder = __webpack_require__(26),
    reorder = __webpack_require__(198),
    replaceHolders = __webpack_require__(29),
    root = __webpack_require__(2);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(181),
    setData = __webpack_require__(62),
    setWrapToString = __webpack_require__(64);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(28);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(28);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(48);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    isObject = __webpack_require__(3);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

exports.arrayToObject = function (source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function (target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D    // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, references) {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }

    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0; i < obj.length; ++i) {
            if (obj[i] && typeof obj[i] === 'object') {
                compacted.push(exports.compact(obj[i], refs));
            } else if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        obj[key] = exports.compact(obj[key], refs);
    });

    return obj;
};

exports.isRegExp = function (obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function (obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(79);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createContentfulApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entities__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paged_sync__ = __webpack_require__(102);
/**
 * Contentful Delivery API Client. Contains methods which allow access to the
 * different kinds of entities present in Contentful (Entries, Assets, etc).
 * @namespace ContentfulClientAPI
 * @see Entities
 */

/**
 * The different kinds of top level entities you can find in Contentful
 * @namespace Entities
 */

/**
 * System metadata. See <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/introduction/common-resource-attributes">Common Resource Attributes</a> for more details.
 * @memberof Entities
 * @typedef Sys
 * @prop {string} type
 * @prop {string} id
 * @prop {Entities.Link} space
 * @prop {string} createdAt
 * @prop {string} updatedAt
 * @prop {number} revision
 */

/**
 * Link to another entity. See <a href="https://www.contentful.com/developers/docs/concepts/links/">Links</a> for more details.
 * @memberof Entities
 * @typedef Link
 * @prop {string} type - type of this entity. Always link.
 * @prop {string} id
 * @prop {string} linkType - type of this link. If defined, either Entry or Asset
 */

/**
 * @memberof ContentfulClientAPI
 * @typedef {Object} ClientAPI
 * @prop {function} getSpace
 * @prop {function} getContentType
 * @prop {function} getContentTypes
 * @prop {function} getEntry
 * @prop {function} getEntries
 * @prop {function} getAsset
 * @prop {function} getAssets
 * @prop {function} parseEntries
 * @prop {function} sync
 */





/**
 * Creates API object with methods to access functionality from Contentful's
 * Delivery API
 * @private
 * @param {Object} params - API initialization params
 * @prop {Object} http - HTTP client instance
 * @prop {Object} entities - Object with wrapper methods for each kind of entity
 * @prop {Function} shouldLinksResolve - Link resolver preconfigured with global setting
 * @return {ClientAPI}
 */
function createContentfulApi(_ref) {
  var http = _ref.http,
      shouldLinksResolve = _ref.shouldLinksResolve;
  var wrapSpace = __WEBPACK_IMPORTED_MODULE_1__entities__["a" /* default */].space.wrapSpace;
  var _entities$contentType = __WEBPACK_IMPORTED_MODULE_1__entities__["a" /* default */].contentType,
      wrapContentType = _entities$contentType.wrapContentType,
      wrapContentTypeCollection = _entities$contentType.wrapContentTypeCollection;
  var _entities$entry = __WEBPACK_IMPORTED_MODULE_1__entities__["a" /* default */].entry,
      wrapEntry = _entities$entry.wrapEntry,
      wrapEntryCollection = _entities$entry.wrapEntryCollection;
  var _entities$asset = __WEBPACK_IMPORTED_MODULE_1__entities__["a" /* default */].asset,
      wrapAsset = _entities$asset.wrapAsset,
      wrapAssetCollection = _entities$asset.wrapAssetCollection;


  function errorHandler(error) {
    if (error.data) {
      throw error.data;
    }
    throw error;
  }

  /**
   * Gets the Space which the client is currently configured to use
   * @memberof ContentfulClientAPI
   * @return {Promise<Entities.Space>} Promise for a Space
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   * // returns the space object with the above <space-id>
   * client.getSpace()
   * .then((space) => console.log(space))
   * .catch(console.error)
   */
  function getSpace() {
    return http.get('').then(function (response) {
      return wrapSpace(response.data);
    }, errorHandler);
  }

  /**
   * Gets a Content Type
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @return {Promise<Entities.ContentType>} Promise for a Content Type
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getContentType('<content_type_id>')
   * .then((contentType) => console.log(contentType))
   * .catch(console.error)
   */
  function getContentType(id) {
    return http.get('content_types/' + id).then(function (response) {
      return wrapContentType(response.data);
    }, errorHandler);
  }

  /**
   * Gets a collection of Content Types
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.ContentTypeCollection>} Promise for a collection of Content Types
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getContentTypes()
   * .then((response) => console.log(response.items))
   * .catch(console.error)
   */
  function getContentTypes() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return http.get('content_types', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
      return wrapContentTypeCollection(response.data);
    }, errorHandler);
  }

  /**
   * Gets an Entry
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Entry>} Promise for an Entry
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getEntry('<entry_id>')
   * .then((entry) => console.log(entry))
   * .catch(console.error)
   */
  function getEntry(id) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    normalizeSelect(query);
    return http.get('entries/' + id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
      return wrapEntry(response.data);
    }, errorHandler);
  }

  /**
   * Gets a collection of Entries
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.EntryCollection>} Promise for a collection of Entries
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getEntries()
   * .then((response) => console.log(response.items))
   * .catch(console.error)
   */
  function getEntries() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var resolveLinks = shouldLinksResolve(query);
    var resolveForAllLocales = query.locale && query.locale === '*';
    normalizeSelect(query);
    return http.get('entries', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
      return wrapEntryCollection(response.data, resolveLinks, resolveForAllLocales);
    }, errorHandler);
  }
  /**
   * Gets an Asset
   * @memberof ContentfulClientAPI
   * @param  {string} id
   * @param  {Object=} query - Object with search parameters. In this method it's only useful for `locale`.
   * @return {Promise<Entities.Asset>} Promise for an Asset
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getAsset('<asset_id>')
   * .then((asset) => console.log(asset))
   * .catch(console.error)
   */
  function getAsset(id) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    normalizeSelect(query);
    return http.get('assets/' + id, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
      return wrapAsset(response.data);
    }, errorHandler);
  }

  /**
   * Gets a collection of Assets
   * @memberof ContentfulClientAPI
   * @param  {Object=} query - Object with search parameters. Check the <a href="https://www.contentful.com/developers/docs/javascript/tutorials/using-js-cda-sdk/#retrieving-entries-with-search-parameters">JS SDK tutorial</a> and the <a href="https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/search-parameters">REST API reference</a> for more details.
   * @return {Promise<Entities.AssetCollection>} Promise for a collection of Assets
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.getAssets()
   * .then((response) => console.log(response.items))
   * .catch(console.error)
   */
  function getAssets() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    normalizeSelect(query);
    return http.get('assets', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
      return wrapAssetCollection(response.data);
    }, errorHandler);
  }

  /**
   * Synchronizes either all the content or only new content since last sync
   * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
   * <strong> Important note: </strong> The the sync api endpoint does not support include or link resolution.
   * However contentful.js is doing link resolution client side if you only make an initial sync.
   * For the delta sync (using nextSyncToken) it is not possible since the sdk wont have access to all the data to make such an operation.
   * @memberof ContentfulClientAPI
   * @param  {Object} query - Query object for the sync call. One of initial or nextSyncToken always needs to be specified, but not both.
   * @param  {boolean?} query.initial - Indicates if this is the first sync. Use it if you don't have a sync token.
   * @param  {string?} query.nextSyncToken - The token you got the last time you used this method. Ensures you only get changed content.
   * @param  {string=} query.type - Filter by this type (Entry or Asset)
   * @param  {string=} query.content_type - Filter by this content type id
   * @param  {boolean=} query.resolveLinks - When true, links to other Entries or Assets are resolved. Default: true.
   * @return {Promise<Sync.SyncCollection>} Promise for the collection resulting of a sync operation
   * @example
   * const contentful = require('contentful')
   *
   * const client = contentful.createClient({
   *   space: '<space_id>',
   *   accessToken: '<content_delivery_api_key>'
   * })
   *
   * client.sync({
   *   initial: true
   * })
   * .then((response) => console.log({
   *   entries: response.entries,
   *   assets: response.assets,
   *   nextSyncToken: response.nextSyncToken
   * }))
   * .catch(console.error)
   */
  function sync() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var resolveLinks = shouldLinksResolve(query);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__paged_sync__["a" /* default */])(http, query, resolveLinks);
  }

  /**
  * Parse raw json data into collection of entry objects.Links will be resolved also
  * @memberof ContentfulClientAPI
  * @param {Object} raw json data
  * @example
  * let data = {items: [
  *    {
  *    sys: {type: 'Entry', locale: 'en-US'},
  *    fields: {
  *      animal: {sys: {type: 'Link', linkType: 'Animal', id: 'oink'}},
  *      anotheranimal: {sys: {type: 'Link', linkType: 'Animal', id: 'middle-parrot'}}
  *    }
  *  }
  * ],
  * includes: {
  *  Animal: [
  *    {
  *      sys: {type: 'Animal', id: 'oink', locale: 'en-US'},
  *      fields: {
  *        name: 'Pig',
  *        friend: {sys: {type: 'Link', linkType: 'Animal', id: 'groundhog'}}
  *      }
  *    }
  *   ]
  *  }
  * }
  * console.log( data.items[0].fields.foo ); // undefined
  * let parsedData = client.parseEntries(data);
  * console.log( parsedData.items[0].fields.foo ); // foo
  */
  function parseEntries(data) {
    return wrapEntryCollection(data, true, false);
  }
  /*
   * sdk relies heavily on sys metadata
   * so we cannot omit the sys property on sdk level
   * */
  function normalizeSelect(query) {
    if (query.select && !/sys/i.test(query.select)) {
      query.select += ',sys';
    }
  }

  return {
    getSpace: getSpace,
    getContentType: getContentType,
    getContentTypes: getContentTypes,
    getEntry: getEntry,
    getEntries: getEntries,
    getAsset: getAsset,
    getAssets: getAssets,
    parseEntries: parseEntries,
    sync: sync
  };
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLinkResolver;
/**
 * Link resolution can be set globally, or it can be turned off for the methods
 * which make use of it. The local setting always overrides the global setting.
 * @private
 * @param {boolean} globalSetting - Global library setting for link resolution
 * @returns {function} Link resolver method preconfigured with global setting
 */
function createLinkResolver(globalSetting) {
  /**
   * Link resolver method
   * @param {Object} query - regular query object used for collection endpoints
   */
  return function shouldLinksResolve(query) {
    return !!('resolveLinks' in query ? query.resolveLinks : globalSetting);
  };
}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = '4.6.1'


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(38);
var Axios = __webpack_require__(81);
var defaults = __webpack_require__(20);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(35);
axios.CancelToken = __webpack_require__(80);
axios.isCancel = __webpack_require__(36);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(95);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(35);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(20);
var utils = __webpack_require__(0);
var InterceptorManager = __webpack_require__(82);
var dispatchRequest = __webpack_require__(83);
var isAbsoluteURL = __webpack_require__(91);
var combineURLs = __webpack_require__(89);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(86);
var isCancel = __webpack_require__(36);
var defaults = __webpack_require__(20);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(37);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createClient"] = createClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_contentful_api__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__create_link_resolver__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__version_js__);
/**
 * Contentful Delivery API SDK. Allows you to create instances of a client
 * with access to the Contentful Content Delivery API.
 * @namespace contentful
 * @see ContentfulClientAPI
 */







/**
 * Create a client instance
 * @func
 * @name createClient
 * @memberof contentful
 * @param {Object} params - Client initialization parameters
 * @prop {string} params.space - Space ID
 * @prop {string} params.accessToken - Contentful CDA Access Token
 * @prop {boolean=} params.insecure - Requests will be made over http instead of the default https (default: true)
 * @prop {string=} params.host - API host (default: cdn.contentful.com). Also usable with preview.contentful.com.
 * @prop {string=} params.basePath - Path appended to the host to support gateways/proxies with custom urls.
 * @prop {Object=} params.httpAgent - Optional Node.js HTTP agent for proxying (see <a href="https://nodejs.org/api/http.html#http_class_http_agent">Node.js docs</a> and <a href="https://www.npmjs.com/package/https-proxy-agent">https-proxy-agent</a>)
 * @prop {Object=} params.httpsAgent - Optional Node.js HTTP agent for proxying (see <a href="https://nodejs.org/api/http.html#http_class_http_agent">Node.js docs</a> and <a href="https://www.npmjs.com/package/https-proxy-agent">https-proxy-agent</a>)
 * @prop {Object=} params.proxy - Optional Axios proxy (see <a href="https://github.com/mzabriskie/axios#request-config"> axios docs </a>)
 * @prop {Object=} params.headers - Optional additional headers
 * @prop {boolean=?} params.resolveLinks - If we should resolve links between entries (default: true)
 * @prop {boolean=?} params.retryOnError - If we should retry on errors and 429 rate limit exceptions (default: true)
 * @prop {string=?} params.application - Application name and version e.g myApp/version
 * @prop {string=?} params.integration - Integration name and version e.g react/version
 * @returns {ContentfulClientAPI.ClientAPI}
 * @example
 * const contentful = require('contentful')
 * const client = contentful.createClient({
 *  accessToken: 'myAccessToken',
 *  space: 'mySpaceId'
 * })
 */

function createClient(params) {
  if (!params.accessToken) {
    throw new TypeError('Expected parameter accessToken');
  }

  if (!params.space) {
    throw new TypeError('Expected parameter space');
  }

  // Use resolveLinks param if specified, otherwise default to true
  var resolveLinks = !!('resolveLinks' in params ? params.resolveLinks : true);
  var shouldLinksResolve = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__create_link_resolver__["a" /* default */])(resolveLinks);
  var userAgentHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["a" /* getUserAgentHeader */])('contentful.js/' + __WEBPACK_IMPORTED_MODULE_5__version_js___default.a, params.application, params.integration);
  params.defaultHostname = 'cdn.contentful.com';
  params.headers = __WEBPACK_IMPORTED_MODULE_0_lodash_assign___default()(params.headers, {
    'Content-Type': 'application/vnd.contentful.delivery.v1+json',
    'X-Contentful-User-Agent': userAgentHeader
  });

  var http = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["b" /* createHttpClient */])(__WEBPACK_IMPORTED_MODULE_1_axios___default.a, params);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__create_contentful_api__["a" /* default */])({
    http: http,
    shouldLinksResolve: shouldLinksResolve
  });
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["wrapAsset"] = wrapAsset;
/* harmony export (immutable) */ __webpack_exports__["wrapAssetCollection"] = wrapAssetCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__ = __webpack_require__(4);



/**
 * @memberof Entities
 * @typedef Asset
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {string=} sys.locale - If present, indicates the locale which this asset uses
 * @prop {Object} fields - Object with content for each field
 * @prop {string} fields.title - Title for this asset
 * @prop {string} fields.description - Description for this asset
 * @prop {Object} fields.file - File object for this asset
 * @prop {string} fields.file.fileName - Name for the file
 * @prop {string} fields.file.contentType - Mime type for the file
 * @prop {string} fields.file.url - Url where the file is available at.
 * @prop {Object} fields.file.details - Details for the file, depending on file type (example: image size in bytes, etc)
 * @prop {function(): Object} toPlainObject() - Returns this Asset as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw asset data
 * @return {Asset} Wrapped asset data
 */
function wrapAsset(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
}

/**
 * @memberof Entities
 * @typedef AssetCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Asset>} items
 * @prop {function(): Object} toPlainObject() - Returns this Asset collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw asset collection data
 * @return {AssetCollection} Wrapped asset collection data
 */
function wrapAssetCollection(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["wrapContentType"] = wrapContentType;
/* harmony export (immutable) */ __webpack_exports__["wrapContentTypeCollection"] = wrapContentTypeCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__ = __webpack_require__(4);



/**
 * @memberof Entities
 * @typedef ContentType
 * @prop {Entities.Sys} sys - System metadata
 * @prop {string} name
 * @prop {string} description
 * @prop {string} displayField - Field used as the main display field for Entries
 * @prop {string} Array<Field> - All the fields contained in this Content Type
 * @prop {function(): Object} toPlainObject() - Returns this Content Type as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw content type data
 * @return {ContentType} Wrapped content type data
 */
function wrapContentType(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
}

/**
 * @memberof Entities
 * @typedef ContentTypeCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.ContentType>} items
 * @prop {function(): Object} toPlainObject() - Returns this Content Type collection as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw content type collection data
 * @return {ContentTypeCollection} Wrapped content type collection data
 */
function wrapContentTypeCollection(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
}

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["wrapEntry"] = wrapEntry;
/* harmony export (immutable) */ __webpack_exports__["wrapEntryCollection"] = wrapEntryCollection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_link_getters__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_stringify_safe__ = __webpack_require__(40);






/**
 * Types of fields found in an Entry
 * @namespace EntryFields
 */

/**
 * @memberof EntryFields
 * @typedef Symbol
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Text
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Integer
 * @type number
 */

/**
 * @memberof EntryFields
 * @typedef Number
 * @type number
 */

/**
 * @memberof EntryFields
 * @typedef Date
 * @type string
 */

/**
 * @memberof EntryFields
 * @typedef Boolean
 * @type boolean
 */

/**
 * @memberof EntryFields
 * @typedef Location
 * @prop {string} lat - latitude
 * @prop {string} lon - longitude
 */

/**
 * A Field in an Entry can have one of the following types that can be defined in Contentful. See <a href="https://www.contentful.com/developers/docs/references/field-type/">Field Types</a> for more details.
 * @memberof Entities
 * @typedef Field
 * @type EntryFields.Symbol | EntryFields.Text | EntryFields.Integer | EntryFields.Number | EntryFields.Date | EntryFields.Boolean | EntryFields.Location | Entities.Link | Array<EntryFields.Symbol|Entities.Link> | Object
 */

/**
 * @memberof Entities
 * @typedef Entry
 * @prop {Entities.Sys} sys - Standard system metadata with additional entry specific properties
 * @prop {Entities.Link} sys.contentType - Content Type used by this Entry
 * @prop {string=} sys.locale - If present, indicates the locale which this entry uses
 * @prop {Object<EntryFields.Field>} fields - Object with content for each field
 * @prop {function(): Object} toPlainObject() - Returns this Entry as a plain JS object
 */

/**
 * @private
 * @param {Object} data - Raw entry data
 * @return {Entry} Wrapped entry data
 */
function wrapEntry(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
}

/**
 * @memberof Entities
 * @typedef EntryCollection
 * @prop {number} total
 * @prop {number} skip
 * @prop {number} limit
 * @prop {Array<Entities.Entry>} items
 * @prop {Array<Object>=} errors - Array of errors that might occur when retrieving entries.
 * @prop {Object<Array>=} includes - Object with arrays of includes for Entries and Assets. This will be present if resolveLinks is on, and any linked entries or assets exist. Those links will be resolved in the Entries present in the items array, but they are also present here in raw form.
 * @prop {function(): Object} toPlainObject() - Returns this Entry collection as a plain JS object
 * @prop {function(?function=, space=): Object} stringifySafe(replacer,space) - Stringifies the entry collection, accounting for circular references. Circular references will be replaced with just a Link object, with a <code>circular</code> property set to <code>true</code>. See <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify">MDN</a> and <a href="https://www.npmjs.com/package/json-stringify-safe">json-stringify-safe</a> for more details on the arguments this method can take.
 */

/**
 * Data is also mixed in with link getters if links exist and includes were requested
 * @private
 * @param {Object} data - Raw entry collection data
 * @return {EntryCollection} Wrapped entry collection data
 */
function wrapEntryCollection(data, resolveLinks, resolveForAllLocales) {
  var wrappedData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mixins_stringify_safe__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["e" /* toPlainObject */])(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(data)));
  if (resolveLinks) {
    var includes = prepareIncludes(wrappedData.includes, wrappedData.items);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__mixins_link_getters__["a" /* default */])(wrappedData.items, includes, resolveForAllLocales);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["d" /* freezeSys */])(wrappedData);
}

function prepareIncludes() {
  var includes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var items = arguments[1];

  includes.Entry = includes.Entry || [];
  includes.Entry = __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(includes.Entry.concat(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(items)));
  return includes;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__space__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asset__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content_type__ = __webpack_require__(98);





/* harmony default export */ __webpack_exports__["a"] = ({
  space: __WEBPACK_IMPORTED_MODULE_0__space__,
  entry: __WEBPACK_IMPORTED_MODULE_1__entry__,
  asset: __WEBPACK_IMPORTED_MODULE_2__asset__,
  contentType: __WEBPACK_IMPORTED_MODULE_3__content_type__
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["wrapSpace"] = wrapSpace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__ = __webpack_require__(4);


/**
 * @memberof Entities
 * @typedef Space
 * @prop {Object} sys - System metadata
 * @prop {string} sys.id - Space id
 * @prop {string} sys.type - Entity type
 * @prop {string} name - Space name
 * @prop {Array<string>} locales - Array with locale codes
 * @prop {function(): Object} toPlainObject() - Returns this Space as a plain JS object
 */

/**
 * @private
 * @param  {Object} data - API response for a Space
 * @return {Space}
 */
function wrapSpace(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful_sdk_core__["e" /* toPlainObject */])(data));
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pagedSync;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_link_getters__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_stringify_safe__ = __webpack_require__(40);
/**
 * See <a href="https://www.contentful.com/developers/docs/concepts/sync/">Synchronization</a> for more information.
 * @namespace Sync
 */






/**
 * @memberof Sync
 * @typedef SyncCollection
 * @prop {Array<Entities.Entry>} entries - All existing entries on first sync. New and updated entries on subsequent syncs.
 * @prop {Array<Entities.Asset>} assets - All existing assets on first sync. New and updated assets on subsequent syncs.
 * @prop {Array<Sync.DeletedEntry>} deletedEntries - List of deleted Entries since last sync
 * @prop {Array<Sync.DeletedAsset>} deletedAssets - List of deleted Assets since last sync
 * @prop {string} nextSyncToken - Token to be sent to the next sync call
 * @prop {function(): Object} toPlainObject() - Returns this Sync collection as a plain JS object
 * @prop {function(?function=, space=): Object} stringifySafe(replacer,space) - Stringifies the Sync collection, accounting for circular references. Circular references will be replaced with just a Link object, with a <code>circular</code> property set to <code>true</code>. See <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify">MDN</a> and <a href="https://www.npmjs.com/package/json-stringify-safe">json-stringify-safe</a> for more details on the arguments this method can take.
 */

/**
 * Deleted Entries are the same as Entries, but only appear on the sync API.
 * @memberof Sync
 * @typedef DeletedEntry
 * @type Entities.Entry
 */

/**
 * Deleted Assets are the same as Assets, but only appear on the sync API.
 * @memberof Sync
 * @typedef DeletedAsset
 * @type Entities.Asset
 */

/**
 * This module retrieves all the available pages for a sync operation
 * @private
 * @param {Object} http - HTTP client
 * @param {Object} query - Query object
 * @param {boolean} resolveLinks - If links should be resolved
 * @return {Promise<SyncCollection>}
 */
function pagedSync(http, query, resolveLinks) {
  if (!query || !query.initial && !query.nextSyncToken) {
    throw new Error('Please provide one of `initial` or `nextSyncToken` parameters for syncing');
  }

  if (query && query.content_type && !query.type) {
    query.type = 'Entry';
  } else if (query && query.content_type && query.type && query.type !== 'Entry') {
    throw new Error('When using the `content_type` filter your `type` parameter cannot be different from `Entry`.');
  }

  if (query.nextSyncToken) {
    query.sync_token = query.nextSyncToken;
    delete query.initial;
    delete query.nextSyncToken;
  }

  return getSyncPage(http, [], query).then(function (response) {
    // clones response.items used in includes because we don't want these to be mutated
    if (resolveLinks) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__mixins_link_getters__["a" /* default */])(response.items, mapIncludeItems(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(response.items)));
    }
    // maps response items again after getters are attached
    var mappedResponseItems = mapResponseItems(response.items);
    mappedResponseItems.nextSyncToken = response.nextSyncToken;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["d" /* freezeSys */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mixins_stringify_safe__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["e" /* toPlainObject */])(mappedResponseItems)));
  }, function (error) {
    throw error.data;
  });
}

/**
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object} Entities mapped to an object for each entity type
 */
function mapResponseItems(items) {
  return {
    entries: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'Entry']),
    assets: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'Asset']),
    deletedEntries: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'DeletedEntry']),
    deletedAssets: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'DeletedAsset'])
  };
}

/**
 * Creates an object similar to the one retrieved on `includes` from the `entries`
 * endpoint, for usage with the link getters mixin
 * @private
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @return {Object}
 */
function mapIncludeItems(items) {
  return {
    Entry: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'Entry']),
    Asset: __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(items, ['sys.type', 'Asset'])
  };
}

/**
 * If the response contains a nextPageUrl, extracts the sync token to get the
 * next page and calls itself again with that token.
 * Otherwise, if the response contains a nextSyncUrl, extracts the sync token
 * and returns it.
 * On each call of this function, any retrieved items are collected in the
 * supplied items array, which gets returned in the end
 * @private
 * @param {Object} http
 * @param {Array<Entities.Entry|Entities.Array|Sync.DeletedEntry|Sync.DeletedAsset>} items
 * @param {Object} query
 * @return {Promise<{items: Array, nextSyncToken: string}>}
 */
function getSyncPage(http, items, query) {
  return http.get('sync', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_contentful_sdk_core__["c" /* createRequestConfig */])({ query: query })).then(function (response) {
    var data = response.data;
    items = items.concat(data.items);
    if (data.nextPageUrl) {
      delete query.initial;
      query.sync_token = getToken(data.nextPageUrl);
      return getSyncPage(http, items, query);
    } else if (data.nextSyncUrl) {
      return {
        items: items,
        nextSyncToken: getToken(data.nextSyncUrl)
      };
    }
  });
}

/**
 * Extracts token out of an url
 * @private
 */
function getToken(url) {
  var urlParts = url.split('?');
  return urlParts.length > 0 ? urlParts[1].replace('sync_token=', '') : '';
}

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = createHttpClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rate_limit__ = __webpack_require__(109);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();







// Matches 'sub.host:port' and extracts hostname and port
// Also enforces toplevel domain specified, no spaces and no protocol
var HOST_REGEX = /^(?!\w+:\/\/)([^\s:]+\.[^\s:]+)(?::(\d+))?(?!:)$/;

/**
 * Create pre configured axios instance
 * @private
 * @param {Object} axios - Axios library
 * @param {Object} httpClientParams - Initialization parameters for the HTTP client
 * @prop {string} space - Space ID
 * @prop {string} accessToken - Access Token
 * @prop {boolean=} insecure - If we should use http instead
 * @prop {string=} host - Alternate host
 * @prop {Object=} httpAgent - HTTP agent for node
 * @prop {Object=} httpsAgent - HTTPS agent for node
 * @prop {Object=} proxy - Axios proxy config
 * @prop {Object=} headers - Additional headers
 * @return {Object} Initialized axios instance
 */
function createHttpClient(axios, options) {
  var defaultConfig = {
    insecure: false,
    retryOnError: true,
    logHandler: function logHandler(level, data) {
      if (level === 'error' && data) {
        var title = [data.name, data.message].filter(function (a) {
          return a;
        }).join(' - ');
        console.error('[error] ' + title);
        console.error(data);
        return;
      }
      console.log('[' + level + '] ' + data);
    },
    // Passed to axios
    headers: {},
    httpAgent: false,
    httpsAgent: false,
    timeout: 30000,
    proxy: false,
    basePath: ''
  };
  var config = _extends({}, defaultConfig, options);

  if (!config.accessToken) {
    var missingAccessTokenError = new TypeError('Expected parameter accessToken');
    config.logHandler('error', missingAccessTokenError);
    throw missingAccessTokenError;
  }

  // Construct axios baseURL option
  var protocol = config.insecure ? 'http' : 'https';
  var space = config.space ? config.space + '/' : '';
  var hostname = config.defaultHostname;
  var port = config.insecure ? 80 : 443;

  if (HOST_REGEX.test(config.host)) {
    var parsed = config.host.split(':');
    if (parsed.length === 2) {
      var _parsed = _slicedToArray(parsed, 2);

      hostname = _parsed[0];
      port = _parsed[1];
    } else {
      hostname = parsed[0];
    }
  }

  // Ensure that basePath does start but not end with a slash
  if (config.basePath) {
    config.basePath = '/' + config.basePath.split('/').filter(Boolean).join('/');
  }

  var baseURL = protocol + '://' + hostname + ':' + port + config.basePath + '/spaces/' + space;

  config.headers['Authorization'] = 'Bearer ' + config.accessToken;

  // Set these headers only for node because browsers don't like it when you
  // override user-agent or accept-encoding.
  // The SDKs should set their own X-Contentful-User-Agent.
  if (process && process.release && process.release.name === 'node') {
    config.headers['user-agent'] = 'node.js/' + process.version;
    config.headers['Accept-Encoding'] = 'gzip';
  }

  var axiosOptions = {
    // Axios
    baseURL: baseURL,
    headers: config.headers,
    httpAgent: config.httpAgent,
    httpsAgent: config.httpsAgent,
    paramsSerializer: __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify,
    proxy: config.proxy,
    timeout: config.timeout,
    // Contentful
    logHandler: config.logHandler,
    retryOnError: config.retryOnError
  };
  var instance = axios.create(axiosOptions);
  instance.httpClientParams = options;

  /**
   * Creates a new axios instance with the same default base parameters as the
   * current one, and with any overrides passed to the newParams object
   * This is useful as the SDKs use dependency injection to get the axios library
   * and the version of the library comes from different places depending
   * on whether it's a browser build or a node.js build.
   * @private
   * @param {Object} httpClientParams - Initialization parameters for the HTTP client
   * @return {Object} Initialized axios instance
   */
  instance.cloneWithNewParams = function (newParams) {
    return createHttpClient(axios, __WEBPACK_IMPORTED_MODULE_1_lodash_assign___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(options), newParams));
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__rate_limit__["a" /* default */])(instance);
  return instance;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRequestConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);


/**
 * Creates request parameters configuration by parsing an existing query object
 * @private
 * @param {Object} query
 * @return {Object} Config object with `params` property, ready to be used in axios
 */
function createRequestConfig(_ref) {
  var query = _ref.query;

  var config = {};
  delete query.resolveLinks;
  config.params = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(query);
  return config;
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function enforceObjPath(obj, path) {
  if (!(path in obj)) {
    var err = new Error();
    err.name = 'PropertyMissing';
    err.message = 'Required property ' + path + ' missing from:\n\n' + JSON.stringify(obj) + '\n\n';
    throw err;
  }
  return true;
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = freezeSys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject__);


function freezeObjectDeep(obj) {
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isPlainObject___default()(value)) {
      freezeObjectDeep(value);
    }
  });
  return Object.freeze(obj);
}

function freezeSys(obj) {
  freezeObjectDeep(obj.sys || {});
  return obj;
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["a"] = getUserAgentHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_os__);


function isReactNative() {
  return typeof window !== 'undefined' && 'navigator' in window && 'product' in window.navigator && window.navigator.product === 'ReactNative';
}

function isNode() {
  return typeof process !== 'undefined' && 'release' in process && 'name' in process.release && process.release.name === 'node';
}

function getBrowserOS() {
  var userAgent = window.navigator.userAgent;
  var platform = window.navigator.platform;
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  var os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'macOS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

function getNodeOS() {
  var os = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_os__["platform"])() || 'linux';
  var version = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_os__["release"])() || '0.0.0';
  var osMap = {
    android: 'Android',
    aix: 'Linux',
    darwin: 'macOS',
    freebsd: 'Linux',
    linux: 'Linux',
    openbsd: 'Linux',
    sunos: 'Linux',
    win32: 'Windows'
  };
  if (os in osMap) {
    return (osMap[os] || 'Linux') + '/' + version;
  }
  return null;
}

function getUserAgentHeader(sdk, application, integration) {
  var headerParts = [];

  if (application) {
    headerParts.push('app ' + application);
  }

  if (integration) {
    headerParts.push('integration ' + integration);
  }

  headerParts.push('sdk ' + sdk);

  var os = null;
  if (isReactNative()) {
    os = getBrowserOS();
    headerParts.push('platform ReactNative');
  } else if (isNode()) {
    os = getNodeOS();
    headerParts.push('platform node.js/' + process.versions.node);
  } else {
    os = getBrowserOS();
    headerParts.push('platform browser');
  }

  if (os) {
    headerParts.push('os ' + os);
  }

  return headerParts.filter(function (item) {
    return item !== '';
  }).join('; ') + ';';
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);


function promisedWait(ms) {
  return new __WEBPACK_IMPORTED_MODULE_0_es6_promise__["Promise"](function (resolve) {
    setTimeout(resolve, ms || 3000);
  });
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rateLimit;
var attempts = {};
var networkErrorAttempts = 0;

function rateLimit(instance) {
  var maxRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  instance.interceptors.response.use(function (response) {
    // we don't need to do anything here
    return response;
  }, function (error) {
    var response = error.response,
        config = error.config;

    if (!instance.defaults.retryOnError) {
      return Promise.reject(error);
    }

    var retryErrorType = null;
    var wait = 0;

    // Errors without response or config did not recieve anything from the server
    // Should be a network related error
    if (!response || !config) {
      retryErrorType = 'Connection';
      networkErrorAttempts++;

      if (networkErrorAttempts > maxRetry) {
        error.attempts = networkErrorAttempts;
        return Promise.reject(error);
      }

      wait = Math.pow(Math.SQRT2, networkErrorAttempts);
      response = {};
    } else {
      networkErrorAttempts = 0;
    }

    if (response.status >= 500 && response.status < 600) {
      // 5** errors are server related
      retryErrorType = 'Server ' + response.status;
      var headers = response.headers || {};
      var requestId = headers['x-contentful-request-id'] || null;
      attempts[requestId] = attempts[requestId] || 0;
      attempts[requestId]++;

      // we reject if there are too much errors of with the same request id
      if (attempts[requestId] > maxRetry || !requestId) {
        error.attempts = attempts[requestId];
        return Promise.reject(error);
      }
      wait = Math.pow(Math.SQRT2, attempts[requestId]);
    } else if (response.status === 429) {
      // 429 errors are exceeded rate limit exceptions
      retryErrorType = 'Rate limit';
      // all headers are lowercased by axios https://github.com/mzabriskie/axios/issues/413
      if (response.headers && error.response.headers['x-contentful-ratelimit-reset']) {
        wait = response.headers['x-contentful-ratelimit-reset'];
      }
    }

    if (retryErrorType) {
      // convert to ms and add jitter
      wait = Math.floor(wait * 1000 + Math.random() * 200 + 500);
      instance.defaults.logHandler('warning', retryErrorType + ' error occured. Waiting for ' + wait + ' ms before retrying...');
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(instance(config));
        }, wait);
      });
    }
    return Promise.reject(error);
  });
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPlainObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);


/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param {Object} data - Any plain JSON response returned from the API
 * @return {Object} Enhanced object with toPlainObject method
 */
function toPlainObject(data) {
  return Object.defineProperty(data, 'toPlainObject', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(this);
    }
  });
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"vertx\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(74)))

/***/ }),
/* 112 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(171),
    hashDelete = __webpack_require__(172),
    hashGet = __webpack_require__(173),
    hashHas = __webpack_require__(174),
    hashSet = __webpack_require__(175);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(2);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(127);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(8),
    keys = __webpack_require__(7);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(8),
    keysIn = __webpack_require__(218);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(22),
    arrayEach = __webpack_require__(43),
    assignValue = __webpack_require__(24),
    baseAssign = __webpack_require__(120),
    baseAssignIn = __webpack_require__(121),
    cloneBuffer = __webpack_require__(143),
    copyArray = __webpack_require__(54),
    copySymbols = __webpack_require__(146),
    copySymbolsIn = __webpack_require__(147),
    getAllKeys = __webpack_require__(57),
    getAllKeysIn = __webpack_require__(164),
    getTag = __webpack_require__(59),
    initCloneArray = __webpack_require__(176),
    initCloneByTag = __webpack_require__(177),
    initCloneObject = __webpack_require__(178),
    isArray = __webpack_require__(1),
    isBuffer = __webpack_require__(32),
    isObject = __webpack_require__(3),
    keys = __webpack_require__(7);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(25);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(152);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(124),
    keys = __webpack_require__(7);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(47),
    baseIsNaN = __webpack_require__(130),
    strictIndexOf = __webpack_require__(207);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(22),
    equalArrays = __webpack_require__(160),
    equalByTag = __webpack_require__(161),
    equalObjects = __webpack_require__(162),
    getTag = __webpack_require__(59),
    isArray = __webpack_require__(1),
    isBuffer = __webpack_require__(32),
    isTypedArray = __webpack_require__(70);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(22),
    baseIsEqual = __webpack_require__(50);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(67),
    isMasked = __webpack_require__(182),
    isObject = __webpack_require__(3),
    toSource = __webpack_require__(209);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(16),
    nativeKeys = __webpack_require__(195);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(3),
    isPrototype = __webpack_require__(16),
    nativeKeysIn = __webpack_require__(196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(25),
    isArrayLike = __webpack_require__(6);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(129),
    getMatchData = __webpack_require__(166),
    matchesStrictComparable = __webpack_require__(61);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(50),
    get = __webpack_require__(65),
    hasIn = __webpack_require__(215),
    isKey = __webpack_require__(27),
    isStrictComparable = __webpack_require__(60),
    matchesStrictComparable = __webpack_require__(61),
    toKey = __webpack_require__(18);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(48);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(42),
    arrayIncludes = __webpack_require__(116),
    arrayIncludesWith = __webpack_require__(117),
    cacheHas = __webpack_require__(52),
    createSet = __webpack_require__(157),
    setToArray = __webpack_require__(63);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(31);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(2);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(230)(module)))

/***/ }),
/* 144 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(8),
    getSymbols = __webpack_require__(167);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(8),
    getSymbolsIn = __webpack_require__(168);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(2);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(51),
    isIterateeCall = __webpack_require__(179);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(6);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(12),
    root = __webpack_require__(2);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(23),
    createCtor = __webpack_require__(12),
    createHybrid = __webpack_require__(55),
    createRecurry = __webpack_require__(56),
    getHolder = __webpack_require__(26),
    replaceHolders = __webpack_require__(29),
    root = __webpack_require__(2);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(11),
    isArrayLike = __webpack_require__(6),
    keys = __webpack_require__(7);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(23),
    createCtor = __webpack_require__(12),
    root = __webpack_require__(2);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(114),
    noop = __webpack_require__(221),
    setToArray = __webpack_require__(63);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(139),
    createBind = __webpack_require__(153),
    createCurry = __webpack_require__(154),
    createHybrid = __webpack_require__(55),
    createPartial = __webpack_require__(156),
    getData = __webpack_require__(165),
    mergeData = __webpack_require__(194),
    setData = __webpack_require__(62),
    setWrapToString = __webpack_require__(64),
    toInteger = __webpack_require__(71);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(42),
    arraySome = __webpack_require__(119),
    cacheHas = __webpack_require__(52);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(57);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(74)))

/***/ }),
/* 164 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(60),
    keys = __webpack_require__(7);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(53),
    isArguments = __webpack_require__(66),
    isArray = __webpack_require__(1),
    isIndex = __webpack_require__(15),
    isLength = __webpack_require__(68),
    toKey = __webpack_require__(18);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(17);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(17);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(17);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(17);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(46),
    getPrototype = __webpack_require__(58),
    isPrototype = __webpack_require__(16);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(30),
    isArrayLike = __webpack_require__(6),
    isIndex = __webpack_require__(15),
    isObject = __webpack_require__(3);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(148);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(10);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(113),
    ListCache = __webpack_require__(9),
    Map = __webpack_require__(41);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(13);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(13);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(13);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(13);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(28);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(23);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(54),
    isIndex = __webpack_require__(15);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(9);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(9),
    Map = __webpack_require__(41),
    MapCache = __webpack_require__(21);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(193);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(214);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(115),
    baseFilter = __webpack_require__(123),
    baseIteratee = __webpack_require__(11),
    isArray = __webpack_require__(1);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(155),
    findIndex = __webpack_require__(213);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(47),
    baseIteratee = __webpack_require__(11),
    toInteger = __webpack_require__(71);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(43),
    baseEach = __webpack_require__(25),
    castFunction = __webpack_require__(142),
    isArray = __webpack_require__(1);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(126),
    hasPath = __webpack_require__(170);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(49),
    getPrototype = __webpack_require__(58),
    isObjectLike = __webpack_require__(69);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(44),
    baseKeysIn = __webpack_require__(133),
    isArrayLike = __webpack_require__(6);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(118),
    baseIteratee = __webpack_require__(11),
    baseMap = __webpack_require__(134),
    isArray = __webpack_require__(1);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(21);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(51),
    createWrap = __webpack_require__(158),
    getHolder = __webpack_require__(26),
    replaceHolders = __webpack_require__(29);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(137),
    basePropertyDeep = __webpack_require__(138),
    isKey = __webpack_require__(27),
    toKey = __webpack_require__(18);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 224 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(141);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(229);
var parse = __webpack_require__(228);
var formats = __webpack_require__(72);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function parseObjectRecursive(chain, val, options) {
    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (
            !isNaN(index)
            && root !== cleanRoot
            && String(index) === cleanRoot
            && index >= 0
            && (options.parseArrays && index <= options.arrayLimit)
        ) {
            obj = [];
            obj[index] = parseObject(chain, val, options);
        } else {
            obj[cleanRoot] = parseObject(chain, val, options);
        }
    }

    return obj;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var formats = __webpack_require__(72);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats.default;
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);
});
//# sourceMappingURL=contentful.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(441);
module.exports = __webpack_require__(41).RegExp.escape;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
__webpack_require__(156);
module.exports = __webpack_require__(423);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(237);
__webpack_require__(156);
__webpack_require__(157);
__webpack_require__(425);
__webpack_require__(432);
__webpack_require__(431);
__webpack_require__(430);
module.exports = __webpack_require__(38).Map;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(426);
module.exports = __webpack_require__(38).Object.assign;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(427);
var $Object = __webpack_require__(38).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(428);
module.exports = __webpack_require__(38).Object.setPrototypeOf;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(429);
__webpack_require__(237);
__webpack_require__(433);
__webpack_require__(434);
module.exports = __webpack_require__(38).Symbol;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(156);
__webpack_require__(157);
module.exports = __webpack_require__(155).f('iterator');


/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(103);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(78);
var toLength = __webpack_require__(151);
var toAbsoluteIndex = __webpack_require__(422);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(76);
var IObject = __webpack_require__(143);
var toObject = __webpack_require__(152);
var toLength = __webpack_require__(151);
var asc = __webpack_require__(404);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(57);
var isArray = __webpack_require__(228);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(403);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(49).f;
var create = __webpack_require__(104);
var redefineAll = __webpack_require__(233);
var ctx = __webpack_require__(76);
var anInstance = __webpack_require__(224);
var forOf = __webpack_require__(103);
var $iterDefine = __webpack_require__(144);
var step = __webpack_require__(229);
var setSpecies = __webpack_require__(420);
var DESCRIPTORS = __webpack_require__(47);
var fastKey = __webpack_require__(146).fastKey;
var validate = __webpack_require__(235);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(225);
var from = __webpack_require__(400);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(39);
var $export = __webpack_require__(48);
var meta = __webpack_require__(146);
var fails = __webpack_require__(77);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(233);
var forOf = __webpack_require__(103);
var anInstance = __webpack_require__(224);
var isObject = __webpack_require__(57);
var setToStringTag = __webpack_require__(108);
var dP = __webpack_require__(49).f;
var each = __webpack_require__(402)(0);
var DESCRIPTORS = __webpack_require__(47);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(105);
var gOPS = __webpack_require__(147);
var pIE = __webpack_require__(106);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(39).document;
module.exports = document && document.documentElement;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(89);
var ITERATOR = __webpack_require__(31)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(55);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(104);
var descriptor = __webpack_require__(107);
var setToStringTag = __webpack_require__(108);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(56)(IteratorPrototype, __webpack_require__(31)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(105);
var gOPS = __webpack_require__(147);
var pIE = __webpack_require__(106);
var toObject = __webpack_require__(152);
var IObject = __webpack_require__(143);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(77)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var anObject = __webpack_require__(55);
var getKeys = __webpack_require__(105);

module.exports = __webpack_require__(47) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(78);
var gOPN = __webpack_require__(231).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(61);
var toObject = __webpack_require__(152);
var IE_PROTO = __webpack_require__(148)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(48);
var aFunction = __webpack_require__(223);
var ctx = __webpack_require__(76);
var forOf = __webpack_require__(103);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(48);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(57);
var anObject = __webpack_require__(55);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(76)(Function.call, __webpack_require__(230).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(39);
var core = __webpack_require__(38);
var dP = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(47);
var SPECIES = __webpack_require__(31)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(150);
var defined = __webpack_require__(141);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(150);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var get = __webpack_require__(236);
module.exports = __webpack_require__(38).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(399);
var step = __webpack_require__(229);
var Iterators = __webpack_require__(89);
var toIObject = __webpack_require__(78);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(144)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(405);
var validate = __webpack_require__(235);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(407)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(48);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(413) });


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(48);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(104) });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(48);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(419).set });


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(39);
var has = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(47);
var $export = __webpack_require__(48);
var redefine = __webpack_require__(234);
var META = __webpack_require__(146).KEY;
var $fails = __webpack_require__(77);
var shared = __webpack_require__(149);
var setToStringTag = __webpack_require__(108);
var uid = __webpack_require__(109);
var wks = __webpack_require__(31);
var wksExt = __webpack_require__(155);
var wksDefine = __webpack_require__(154);
var enumKeys = __webpack_require__(408);
var isArray = __webpack_require__(228);
var anObject = __webpack_require__(55);
var toIObject = __webpack_require__(78);
var toPrimitive = __webpack_require__(153);
var createDesc = __webpack_require__(107);
var _create = __webpack_require__(104);
var gOPNExt = __webpack_require__(415);
var $GOPD = __webpack_require__(230);
var $DP = __webpack_require__(49);
var $keys = __webpack_require__(105);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(231).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(106).f = $propertyIsEnumerable;
  __webpack_require__(147).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(145)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(417)('Map');


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(418)('Map');


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(48);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(406)('Map') });


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('asyncIterator');


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(154)('observable');


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var isArray = __webpack_require__(114);
var SPECIES = __webpack_require__(10)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(45);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(118);
var pIE = __webpack_require__(92);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 440 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(439)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(239) });

__webpack_require__(58)('copyWithin');


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(40)(4);

$export($export.P + $export.F * !__webpack_require__(34)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(158) });

__webpack_require__(58)('fill');


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(40)(2);

$export($export.P + $export.F * !__webpack_require__(34)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(40)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(40)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(40)(0);
var STRICT = __webpack_require__(34)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(33);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var call = __webpack_require__(250);
var isArrayIter = __webpack_require__(166);
var toLength = __webpack_require__(15);
var createProperty = __webpack_require__(160);
var getIterFn = __webpack_require__(182);

$export($export.S + $export.F * !__webpack_require__(116)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(110)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(34)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(114) });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(29);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(91) != Object || !__webpack_require__(34)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(29);
var toInteger = __webpack_require__(44);
var toLength = __webpack_require__(15);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(34)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(40)(1);

$export($export.P + $export.F * !__webpack_require__(34)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(160);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(34)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(241);

$export($export.P + $export.F * !__webpack_require__(34)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(164);
var cof = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(15);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(40)(3);

$export($export.P + $export.F * !__webpack_require__(34)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(20);
var toObject = __webpack_require__(17);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(34)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(70)('Array');


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(436);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(45);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(10)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(23)(proto, TO_PRIMITIVE, __webpack_require__(437));


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(24)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(242) });


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(28);
var HAS_INSTANCE = __webpack_require__(10)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(14).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(14).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(13) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(253);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(170);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(169);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(252) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(253) });


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(170) });


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(169);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(169);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(22);
var cof = __webpack_require__(32);
var inheritIfRequired = __webpack_require__(165);
var toPrimitive = __webpack_require__(45);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(66).f;
var gOPD = __webpack_require__(27).f;
var dP = __webpack_require__(14).f;
var $trim = __webpack_require__(81).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(65)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(13) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(24)(global, NUMBER, $Number);
}


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(249) });


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(249);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(261);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(262);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(44);
var aNumberValue = __webpack_require__(238);
var repeat = __webpack_require__(177);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(238);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(255) });


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(65) });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperties: __webpack_require__(256) });


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(13), 'Object', { defineProperty: __webpack_require__(14).f });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(43)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(29);
var $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(43)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(43)('getOwnPropertyNames', function () {
  return __webpack_require__(257).f;
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(17);
var $getPrototypeOf = __webpack_require__(28);

__webpack_require__(43)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(7);

__webpack_require__(43)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(7);

__webpack_require__(43)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(7);

__webpack_require__(43)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(440) });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(17);
var $keys = __webpack_require__(67);

__webpack_require__(43)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(43)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(43)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(173).set });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(90);
var test = {};
test[__webpack_require__(10)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(24)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(261);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(262);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(64);
var global = __webpack_require__(5);
var ctx = __webpack_require__(33);
var classof = __webpack_require__(90);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var aFunction = __webpack_require__(20);
var anInstance = __webpack_require__(62);
var forOf = __webpack_require__(63);
var speciesConstructor = __webpack_require__(122);
var task = __webpack_require__(179).set;
var microtask = __webpack_require__(171)();
var newPromiseCapabilityModule = __webpack_require__(172);
var perform = __webpack_require__(263);
var promiseResolve = __webpack_require__(264);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(10)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(69)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(80)($Promise, PROMISE);
__webpack_require__(70)(PROMISE);
Wrapper = __webpack_require__(41)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(116)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(4);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(65);
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var bind = __webpack_require__(242);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(14);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var toPrimitive = __webpack_require__(45);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(27).f;
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(167)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(27);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(28);
var anObject = __webpack_require__(4);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(22);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(4);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(260) });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(4);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(173);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(14);
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(22);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(68);
var anObject = __webpack_require__(4);
var isObject = __webpack_require__(7);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(165);
var dP = __webpack_require__(14).f;
var gOPN = __webpack_require__(66).f;
var isRegExp = __webpack_require__(115);
var $flags = __webpack_require__(113);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(13) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(10)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(24)(global, 'RegExp', $RegExp);
}

__webpack_require__(70)('RegExp');


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(112)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(112)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(112)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(112)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(115);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(269);
var anObject = __webpack_require__(4);
var $flags = __webpack_require__(113);
var DESCRIPTORS = __webpack_require__(13);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(24)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(25)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(25)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(25)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(25)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(175)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(15);
var context = __webpack_require__(176);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(163)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(25)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(25)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(25)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(71);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(176);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(163)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(25)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(175)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(168)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(25)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(29);
var toLength = __webpack_require__(15);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(177)
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(25)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(15);
var context = __webpack_require__(176);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(163)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(25)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(25)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(25)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(81)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(13);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(24);
var META = __webpack_require__(59).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(121);
var setToStringTag = __webpack_require__(80);
var uid = __webpack_require__(72);
var wks = __webpack_require__(10);
var wksExt = __webpack_require__(267);
var wksDefine = __webpack_require__(181);
var enumKeys = __webpack_require__(438);
var isArray = __webpack_require__(114);
var anObject = __webpack_require__(4);
var toIObject = __webpack_require__(29);
var toPrimitive = __webpack_require__(45);
var createDesc = __webpack_require__(68);
var _create = __webpack_require__(65);
var gOPNExt = __webpack_require__(257);
var $GOPD = __webpack_require__(27);
var $DP = __webpack_require__(14);
var $keys = __webpack_require__(67);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(66).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(92).f = $propertyIsEnumerable;
  __webpack_require__(118).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(64)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(123);
var buffer = __webpack_require__(180);
var anObject = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(71);
var toLength = __webpack_require__(15);
var isObject = __webpack_require__(7);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(122);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(70)(ARRAY_BUFFER);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(123).ABV, {
  DataView: __webpack_require__(180).DataView
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(245);
var validate = __webpack_require__(82);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(111)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(246);
var toObject = __webpack_require__(17);
var toLength = __webpack_require__(15);
var aFunction = __webpack_require__(20);
var arraySpeciesCreate = __webpack_require__(159);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(58)('flatMap');


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(246);
var toObject = __webpack_require__(17);
var toLength = __webpack_require__(15);
var toInteger = __webpack_require__(44);
var arraySpeciesCreate = __webpack_require__(159);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(58)('flatten');


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(110)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(58)('includes');


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(171)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(32)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(32);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(119)('Map');


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(120)('Map');


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(244)('Map') });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(254);
var fround = __webpack_require__(252);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(254) });


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var aFunction = __webpack_require__(20);
var $defineProperty = __webpack_require__(14);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(13) && $export($export.P + __webpack_require__(117), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var aFunction = __webpack_require__(20);
var $defineProperty = __webpack_require__(14);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(13) && $export($export.P + __webpack_require__(117), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(259)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(260);
var toIObject = __webpack_require__(29);
var gOPD = __webpack_require__(27);
var createProperty = __webpack_require__(160);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(13) && $export($export.P + __webpack_require__(117), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(17);
var toPrimitive = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(13) && $export($export.P + __webpack_require__(117), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(259)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(41);
var microtask = __webpack_require__(171)();
var OBSERVABLE = __webpack_require__(10)('observable');
var aFunction = __webpack_require__(20);
var anObject = __webpack_require__(4);
var anInstance = __webpack_require__(62);
var redefineAll = __webpack_require__(69);
var hide = __webpack_require__(23);
var forOf = __webpack_require__(63);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(70)('Observable');


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(41);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(122);
var promiseResolve = __webpack_require__(264);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(172);
var perform = __webpack_require__(263);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(270);
var from = __webpack_require__(240);
var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(50);
var anObject = __webpack_require__(4);
var aFunction = __webpack_require__(20);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(119)('Set');


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(120)('Set');


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(244)('Set') });


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(175)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(42);
var toLength = __webpack_require__(15);
var isRegExp = __webpack_require__(115);
var getFlags = __webpack_require__(113);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(167)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(265);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(265);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(181)('asyncIterator');


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(181)('observable');


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(119)('WeakMap');


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(120)('WeakMap');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(119)('WeakSet');


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(120)('WeakSet');


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(183);
var getKeys = __webpack_require__(67);
var redefine = __webpack_require__(24);
var global = __webpack_require__(5);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(79);
var wks = __webpack_require__(10);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(179);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(561);
__webpack_require__(500);
__webpack_require__(502);
__webpack_require__(501);
__webpack_require__(504);
__webpack_require__(506);
__webpack_require__(511);
__webpack_require__(505);
__webpack_require__(503);
__webpack_require__(513);
__webpack_require__(512);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(507);
__webpack_require__(499);
__webpack_require__(510);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(467);
__webpack_require__(469);
__webpack_require__(468);
__webpack_require__(517);
__webpack_require__(516);
__webpack_require__(487);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(548);
__webpack_require__(553);
__webpack_require__(560);
__webpack_require__(551);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(549);
__webpack_require__(554);
__webpack_require__(556);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(550);
__webpack_require__(552);
__webpack_require__(555);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(462);
__webpack_require__(464);
__webpack_require__(463);
__webpack_require__(466);
__webpack_require__(465);
__webpack_require__(451);
__webpack_require__(449);
__webpack_require__(455);
__webpack_require__(452);
__webpack_require__(458);
__webpack_require__(460);
__webpack_require__(448);
__webpack_require__(454);
__webpack_require__(445);
__webpack_require__(459);
__webpack_require__(443);
__webpack_require__(457);
__webpack_require__(456);
__webpack_require__(450);
__webpack_require__(453);
__webpack_require__(442);
__webpack_require__(444);
__webpack_require__(447);
__webpack_require__(446);
__webpack_require__(461);
__webpack_require__(183);
__webpack_require__(533);
__webpack_require__(538);
__webpack_require__(269);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(518);
__webpack_require__(268);
__webpack_require__(270);
__webpack_require__(271);
__webpack_require__(573);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(568);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(566);
__webpack_require__(569);
__webpack_require__(567);
__webpack_require__(570);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(526);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(532);
__webpack_require__(531);
__webpack_require__(576);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(617);
__webpack_require__(620);
__webpack_require__(619);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(618);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(598);
__webpack_require__(601);
__webpack_require__(597);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(582);
__webpack_require__(616);
__webpack_require__(581);
__webpack_require__(615);
__webpack_require__(627);
__webpack_require__(629);
__webpack_require__(580);
__webpack_require__(614);
__webpack_require__(626);
__webpack_require__(628);
__webpack_require__(579);
__webpack_require__(625);
__webpack_require__(578);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(589);
__webpack_require__(588);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(594);
__webpack_require__(593);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(608);
__webpack_require__(607);
__webpack_require__(610);
__webpack_require__(609);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(577);
__webpack_require__(602);
__webpack_require__(632);
__webpack_require__(631);
__webpack_require__(630);
module.exports = __webpack_require__(41);


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var emptyObject = __webpack_require__(124);
var _invariant = __webpack_require__(2);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(637);
var isArguments = __webpack_require__(636);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 636 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 637 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(273),
    legacyMap = __webpack_require__(642),
    xmlMap    = __webpack_require__(274),
    decodeCodePoint = __webpack_require__(639);

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(641);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(274)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(273)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(660);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(670);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(2);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(21);

var createArrayFromMixed = __webpack_require__(663);
var getMarkupWrap = __webpack_require__(665);
var invariant = __webpack_require__(2);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(21);

var invariant = __webpack_require__(2);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(667);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(669);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(699)

var flat = module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step(object, prev, currentDepth) {
    currentDepth = currentDepth ? currentDepth : 1
    Object.keys(object).forEach(function(key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten(target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey(key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1
    ) ? key
      : parsedKey
  }

  Object.keys(target).forEach(function(key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === "[object Object]" ||
        type === "[object Array]"
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(26);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(185);

var _PathUtils = __webpack_require__(94);

var _createTransitionManager = __webpack_require__(186);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(26);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(185);

var _PathUtils = __webpack_require__(94);

var _createTransitionManager = __webpack_require__(186);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(94);

var _LocationUtils = __webpack_require__(185);

var _createTransitionManager = __webpack_require__(186);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(280);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsHistory */])();
  var needsHashChangeListener = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripTrailingSlash */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripBasename */])(path, basename);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(280);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripTrailingSlash */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripBasename */])(path, basename);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(187);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(676);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(677);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(678);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(95);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 680 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(683)['default'];
exports['default'] = exports;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__(682);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(685)['default'];
exports['default'] = exports;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(283), src$es5$$ = __webpack_require__(689), src$compiler$$ = __webpack_require__(686), intl$messageformat$parser$$ = __webpack_require__(684);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(283);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(687), src$en$$ = __webpack_require__(688);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(696)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(923);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(282), src$diff$$ = __webpack_require__(693), src$es5$$ = __webpack_require__(695);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(692), src$en$$ = __webpack_require__(694);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(698);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(921);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 699 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 700 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(705);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(36)))

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(706);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(284);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(702);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 710 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(724),
    hashDelete = __webpack_require__(725),
    hashGet = __webpack_require__(726),
    hashHas = __webpack_require__(727),
    hashSet = __webpack_require__(728);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(732),
    listCacheDelete = __webpack_require__(733),
    listCacheGet = __webpack_require__(734),
    listCacheHas = __webpack_require__(735),
    listCacheSet = __webpack_require__(736);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(286),
    root = __webpack_require__(190);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(737),
    mapCacheDelete = __webpack_require__(738),
    mapCacheGet = __webpack_require__(739),
    mapCacheHas = __webpack_require__(740),
    mapCacheSet = __webpack_require__(741);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(719),
    toKey = __webpack_require__(745);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(748),
    isMasked = __webpack_require__(731),
    isObject = __webpack_require__(287),
    toSource = __webpack_require__(746);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(189),
    arrayMap = __webpack_require__(715),
    isArray = __webpack_require__(192),
    isSymbol = __webpack_require__(193);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(192),
    isKey = __webpack_require__(729),
    stringToPath = __webpack_require__(744),
    toString = __webpack_require__(751);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(190);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(189);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(128);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(128);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(128);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(128);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(192),
    isSymbol = __webpack_require__(193);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(720);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 732 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(126);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(126);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(126);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(126);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(711),
    ListCache = __webpack_require__(712),
    Map = __webpack_require__(713);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(127);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(127);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(127);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(127);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(750);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(742);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(193);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 747 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(285),
    isObject = __webpack_require__(287);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(714);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(718);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




/* eslint-disable no-bitwise */

var decodeCache = {};

function getDecodeCache(exclude) {
  var i, ch, cache = decodeCache[exclude];
  if (cache) { return cache; }

  cache = decodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);
    cache.push(ch);
  }

  for (i = 0; i < exclude.length; i++) {
    ch = exclude.charCodeAt(i);
    cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
  }

  return cache;
}


// Decode percent-encoded string.
//
function decode(string, exclude) {
  var cache;

  if (typeof exclude !== 'string') {
    exclude = decode.defaultChars;
  }

  cache = getDecodeCache(exclude);

  return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
    var i, l, b1, b2, b3, b4, chr,
        result = '';

    for (i = 0, l = seq.length; i < l; i += 3) {
      b1 = parseInt(seq.slice(i + 1, i + 3), 16);

      if (b1 < 0x80) {
        result += cache[b1];
        continue;
      }

      if ((b1 & 0xE0) === 0xC0 && (i + 3 < l)) {
        // 110xxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);

        if ((b2 & 0xC0) === 0x80) {
          chr = ((b1 << 6) & 0x7C0) | (b2 & 0x3F);

          if (chr < 0x80) {
            result += '\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 3;
          continue;
        }
      }

      if ((b1 & 0xF0) === 0xE0 && (i + 6 < l)) {
        // 1110xxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
          chr = ((b1 << 12) & 0xF000) | ((b2 << 6) & 0xFC0) | (b3 & 0x3F);

          if (chr < 0x800 || (chr >= 0xD800 && chr <= 0xDFFF)) {
            result += '\ufffd\ufffd\ufffd';
          } else {
            result += String.fromCharCode(chr);
          }

          i += 6;
          continue;
        }
      }

      if ((b1 & 0xF8) === 0xF0 && (i + 9 < l)) {
        // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
        b2 = parseInt(seq.slice(i + 4, i + 6), 16);
        b3 = parseInt(seq.slice(i + 7, i + 9), 16);
        b4 = parseInt(seq.slice(i + 10, i + 12), 16);

        if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
          chr = ((b1 << 18) & 0x1C0000) | ((b2 << 12) & 0x3F000) | ((b3 << 6) & 0xFC0) | (b4 & 0x3F);

          if (chr < 0x10000 || chr > 0x10FFFF) {
            result += '\ufffd\ufffd\ufffd\ufffd';
          } else {
            chr -= 0x10000;
            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
          }

          i += 9;
          continue;
        }
      }

      result += '\ufffd';
    }

    return result;
  });
}


decode.defaultChars   = ';/?:@&=+$,#';
decode.componentChars = '';


module.exports = decode;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";




var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";


module.exports = encode;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/*!
 * pascalcase <https://github.com/jonschlinkert/pascalcase>
 *
 * Copyright (c) 2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

function pascalcase(str) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string.');
  }
  str = str.replace(/([A-Z])/g, ' $1');
  if (str.length === 1) { return str.toUpperCase(); }
  str = str.replace(/^[\W_]+|[\W_]+$/g, '').toLowerCase();
  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str.replace(/[\W_]+(\w|$)/g, function (_, ch) {
    return ch.toUpperCase();
  });
}

module.exports = pascalcase;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(756)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 756 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(290);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(290);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(292);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

var ReactPropTypesSecret = __webpack_require__(292);
var checkPropTypes = __webpack_require__(759);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(325);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(327);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(879);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(324);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(328);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(326);

var _inherits3 = _interopRequireDefault(_inherits2);

var _map = __webpack_require__(880);

var _map2 = _interopRequireDefault(_map);

exports.default = makeAsyncScript;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCRIPT_MAP = new _map2.default();

// A counter used to generate a unique id for each component that uses the function
var idCount = 0;

function makeAsyncScript(Component, scriptURL, options) {
  options = options || {};
  var wrappedComponentName = Component.displayName || Component.name || "Component";

  var AsyncScriptLoader = function (_React$Component) {
    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);

    function AsyncScriptLoader() {
      (0, _classCallCheck3.default)(this, AsyncScriptLoader);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.state = {};
      return _this;
    }

    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
      if (!this.__scriptLoaderID) {
        this.__scriptLoaderID = "async-script-loader-" + idCount++;
      }
      return this.__scriptLoaderID;
    };

    AsyncScriptLoader.prototype.getComponent = function getComponent() {
      return this.childComponent;
    };

    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var key = this.asyncScriptLoaderGetScriptLoaderID();
      var _options = options,
          globalName = _options.globalName,
          callbackName = _options.callbackName;

      if (globalName && typeof window[globalName] !== "undefined") {
        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
      }

      if (SCRIPT_MAP.has(scriptURL)) {
        var entry = SCRIPT_MAP.get(scriptURL);
        if (entry && (entry.loaded || entry.errored)) {
          this.asyncScriptLoaderHandleLoad(entry);
          return;
        }
        entry.observers.set(key, function (entry) {
          return _this2.asyncScriptLoaderHandleLoad(entry);
        });
        return;
      }

      var observers = new _map2.default();
      observers.set(key, function (entry) {
        return _this2.asyncScriptLoaderHandleLoad(entry);
      });
      SCRIPT_MAP.set(scriptURL, {
        loaded: false,
        observers: observers
      });

      var script = document.createElement("script");

      script.src = scriptURL;
      script.async = 1;

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
        if (SCRIPT_MAP.has(scriptURL)) {
          var mapEntry = SCRIPT_MAP.get(scriptURL);
          var observersMap = mapEntry.observers;

          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var _ref2 = _ref,
                obsKey = _ref2[0],
                observer = _ref2[1];

            if (func(observer)) {
              observersMap.delete(obsKey);
            }
          }
        }
      };

      if (callbackName && typeof window !== "undefined") {
        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
      }

      script.onload = function () {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.loaded = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            if (callbackName) {
              return false;
            }
            observer(mapEntry);
            return true;
          });
        }
      };
      script.onerror = function (event) {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.errored = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            observer(mapEntry);
            return true;
          });
        }
      };

      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
      script.onreadystatechange = function () {
        if (_this2.readyState === "loaded") {
          // wait for other events, then call onload if default onload hadn't been called
          window.setTimeout(function () {
            var mapEntry = SCRIPT_MAP.get(scriptURL);
            if (mapEntry && mapEntry.loaded !== true) {
              script.onload();
            }
          }, 0);
        }
      };

      document.body.appendChild(script);
    };

    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
      this.setState(state, this.props.asyncScriptOnLoad);
    };

    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
      // Remove tag script
      if (options.removeOnUnmount === true) {
        var allScripts = document.getElementsByTagName("script");
        for (var i = 0; i < allScripts.length; i += 1) {
          if (allScripts[i].src.indexOf(scriptURL) > -1) {
            if (allScripts[i].parentNode) {
              allScripts[i].parentNode.removeChild(allScripts[i]);
            }
          }
        }
      }
      // Clean the observer entry
      var mapEntry = SCRIPT_MAP.get(scriptURL);
      if (mapEntry) {
        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
        if (options.removeOnUnmount === true) {
          SCRIPT_MAP.delete(scriptURL);
        }
      }
    };

    AsyncScriptLoader.prototype.render = function render() {
      var _this3 = this;

      var globalName = options.globalName;
      var _props = this.props,
          asyncScriptOnLoad = _props.asyncScriptOnLoad,
          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);

      if (globalName && typeof window !== "undefined") {
        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
      }
      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
          _this3.childComponent = comp;
        } }, childProps));
    };

    return AsyncScriptLoader;
  }(_react2.default.Component);

  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
  AsyncScriptLoader.propTypes = {
    asyncScriptOnLoad: _propTypes2.default.func
  };
  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
    var mapEntry = SCRIPT_MAP.get(scriptURL);
    if (!mapEntry || !mapEntry.loaded) {
      throw new Error("Script is not loaded.");
    }
    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var observer = _ref3;

      observer(mapEntry);
    }
    delete window[options.callbackName];
  };

  if (options.exposeFuncs) {
    var _loop = function _loop() {
      if (_isArray3) {
        if (_i3 >= _iterator3.length) return "break";
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) return "break";
        _ref4 = _i3.value;
      }

      var funcToExpose = _ref4;

      /* eslint-disable no-loop-func */
      AsyncScriptLoader.prototype[funcToExpose] = function () {
        var _getComponent;

        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
      };
      /* eslint-enable no-loop-func */
    };

    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
      var _ref4;

      var _ret = _loop();

      if (_ret === "break") break;
    }
  }
  return AsyncScriptLoader;
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(16);

var focusNode = __webpack_require__(277);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(21);
var FallbackCompositionState = __webpack_require__(771);
var SyntheticCompositionEvent = __webpack_require__(808);
var SyntheticInputEvent = __webpack_require__(811);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(294);
var ExecutionEnvironment = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(35);

var camelizeStyleName = __webpack_require__(661);
var dangerousStyleValue = __webpack_require__(817);
var hyphenateStyleName = __webpack_require__(668);
var memoizeStringOnly = __webpack_require__(671);
var warning = __webpack_require__(8);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(96);
var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(21);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactUpdates = __webpack_require__(46);
var SyntheticEvent = __webpack_require__(52);

var inputValueTracking = __webpack_require__(310);
var getEventTarget = __webpack_require__(207);
var isEventSupported = __webpack_require__(208);
var isTextInputElement = __webpack_require__(312);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var DOMLazyTree = __webpack_require__(83);
var ExecutionEnvironment = __webpack_require__(21);

var createNodesFromMarkup = __webpack_require__(664);
var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(2);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(97);
var ReactDOMComponentTree = __webpack_require__(16);
var SyntheticMouseEvent = __webpack_require__(131);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(73);

var getTextContentAccessor = __webpack_require__(309);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(84);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(85);

var instantiateReactComponent = __webpack_require__(311);
var KeyEscapeUtils = __webpack_require__(199);
var shouldUpdateReactComponent = __webpack_require__(209);
var traverseAllChildren = __webpack_require__(314);
var warning = __webpack_require__(8);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTENTFUL_HOST":"cdn.contentful.com","REACT_APP_CONTENTFUL_SPACE_ID":"tbu6yo6b5o8c","REACT_APP_INSTAGRAM_SITE_NAME":"gaijin","REACT_APP_CONTENTFUL_ACCESS_TOKEN":"e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(338);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(289)))

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(195);
var ReactDOMIDOperations = __webpack_require__(781);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var React = __webpack_require__(87);
var ReactComponentEnvironment = __webpack_require__(201);
var ReactCurrentOwner = __webpack_require__(54);
var ReactErrorUtils = __webpack_require__(202);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(35);
var ReactNodeTypes = __webpack_require__(304);
var ReactReconciler = __webpack_require__(85);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(124);
var invariant = __webpack_require__(2);
var shallowEqual = __webpack_require__(184);
var shouldUpdateReactComponent = __webpack_require__(209);
var warning = __webpack_require__(8);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(16);
var ReactDefaultInjection = __webpack_require__(789);
var ReactMount = __webpack_require__(303);
var ReactReconciler = __webpack_require__(85);
var ReactUpdates = __webpack_require__(46);
var ReactVersion = __webpack_require__(802);

var findDOMNode = __webpack_require__(818);
var getHostComponentFromComposite = __webpack_require__(308);
var renderSubtreeIntoContainer = __webpack_require__(825);
var warning = __webpack_require__(8);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var AutoFocusUtils = __webpack_require__(764);
var CSSPropertyOperations = __webpack_require__(766);
var DOMLazyTree = __webpack_require__(83);
var DOMNamespaces = __webpack_require__(196);
var DOMProperty = __webpack_require__(84);
var DOMPropertyOperations = __webpack_require__(296);
var EventPluginHub = __webpack_require__(96);
var EventPluginRegistry = __webpack_require__(197);
var ReactBrowserEventEmitter = __webpack_require__(130);
var ReactDOMComponentFlags = __webpack_require__(297);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactDOMInput = __webpack_require__(782);
var ReactDOMOption = __webpack_require__(783);
var ReactDOMSelect = __webpack_require__(298);
var ReactDOMTextarea = __webpack_require__(786);
var ReactInstrumentation = __webpack_require__(35);
var ReactMultiChild = __webpack_require__(795);
var ReactServerRenderingTransaction = __webpack_require__(800);

var emptyFunction = __webpack_require__(30);
var escapeTextContentForBrowser = __webpack_require__(133);
var invariant = __webpack_require__(2);
var isEventSupported = __webpack_require__(208);
var shallowEqual = __webpack_require__(184);
var inputValueTracking = __webpack_require__(310);
var validateDOMNesting = __webpack_require__(210);
var warning = __webpack_require__(8);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(210);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var DOMLazyTree = __webpack_require__(83);
var ReactDOMComponentTree = __webpack_require__(16);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(195);
var ReactDOMComponentTree = __webpack_require__(16);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMPropertyOperations = __webpack_require__(296);
var LinkedValueUtils = __webpack_require__(200);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var React = __webpack_require__(87);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactDOMSelect = __webpack_require__(298);

var warning = __webpack_require__(8);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);

var getNodeForCharacterOffset = __webpack_require__(822);
var getTextContentAccessor = __webpack_require__(309);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var DOMChildrenOperations = __webpack_require__(195);
var DOMLazyTree = __webpack_require__(83);
var ReactDOMComponentTree = __webpack_require__(16);

var escapeTextContentForBrowser = __webpack_require__(133);
var invariant = __webpack_require__(2);
var validateDOMNesting = __webpack_require__(210);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9),
    _assign = __webpack_require__(11);

var LinkedValueUtils = __webpack_require__(200);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactUpdates = __webpack_require__(46);

var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var ReactUpdates = __webpack_require__(46);
var Transaction = __webpack_require__(132);

var emptyFunction = __webpack_require__(30);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(763);
var BeforeInputEventPlugin = __webpack_require__(765);
var ChangeEventPlugin = __webpack_require__(767);
var DefaultEventPluginOrder = __webpack_require__(769);
var EnterLeaveEventPlugin = __webpack_require__(770);
var HTMLDOMPropertyConfig = __webpack_require__(772);
var ReactComponentBrowserEnvironment = __webpack_require__(774);
var ReactDOMComponent = __webpack_require__(777);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactDOMEmptyComponent = __webpack_require__(779);
var ReactDOMTreeTraversal = __webpack_require__(787);
var ReactDOMTextComponent = __webpack_require__(785);
var ReactDefaultBatchingStrategy = __webpack_require__(788);
var ReactEventListener = __webpack_require__(792);
var ReactInjection = __webpack_require__(793);
var ReactReconcileTransaction = __webpack_require__(798);
var SVGDOMPropertyConfig = __webpack_require__(803);
var SelectEventPlugin = __webpack_require__(804);
var SimpleEventPlugin = __webpack_require__(805);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(96);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var EventListener = __webpack_require__(276);
var ExecutionEnvironment = __webpack_require__(21);
var PooledClass = __webpack_require__(73);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactUpdates = __webpack_require__(46);

var getEventTarget = __webpack_require__(207);
var getUnboundedScrollPosition = __webpack_require__(666);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(84);
var EventPluginHub = __webpack_require__(96);
var EventPluginUtils = __webpack_require__(198);
var ReactComponentEnvironment = __webpack_require__(201);
var ReactEmptyComponent = __webpack_require__(299);
var ReactBrowserEventEmitter = __webpack_require__(130);
var ReactHostComponent = __webpack_require__(301);
var ReactUpdates = __webpack_require__(46);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(816);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactComponentEnvironment = __webpack_require__(201);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(35);

var ReactCurrentOwner = __webpack_require__(54);
var ReactReconciler = __webpack_require__(85);
var ReactChildReconciler = __webpack_require__(773);

var emptyFunction = __webpack_require__(30);
var flattenChildren = __webpack_require__(819);
var invariant = __webpack_require__(2);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var invariant = __webpack_require__(2);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var CallbackQueue = __webpack_require__(295);
var PooledClass = __webpack_require__(73);
var ReactBrowserEventEmitter = __webpack_require__(130);
var ReactInputSelection = __webpack_require__(302);
var ReactInstrumentation = __webpack_require__(35);
var Transaction = __webpack_require__(132);
var ReactUpdateQueue = __webpack_require__(203);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(796);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(11);

var PooledClass = __webpack_require__(73);
var Transaction = __webpack_require__(132);
var ReactInstrumentation = __webpack_require__(35);
var ReactServerUpdateQueue = __webpack_require__(801);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(203);

var warning = __webpack_require__(8);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(21);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactInputSelection = __webpack_require__(302);
var SyntheticEvent = __webpack_require__(52);

var getActiveElement = __webpack_require__(278);
var isTextInputElement = __webpack_require__(312);
var shallowEqual = __webpack_require__(184);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(9);

var EventListener = __webpack_require__(276);
var EventPropagators = __webpack_require__(97);
var ReactDOMComponentTree = __webpack_require__(16);
var SyntheticAnimationEvent = __webpack_require__(806);
var SyntheticClipboardEvent = __webpack_require__(807);
var SyntheticEvent = __webpack_require__(52);
var SyntheticFocusEvent = __webpack_require__(810);
var SyntheticKeyboardEvent = __webpack_require__(812);
var SyntheticMouseEvent = __webpack_require__(131);
var SyntheticDragEvent = __webpack_require__(809);
var SyntheticTouchEvent = __webpack_require__(813);
var SyntheticTransitionEvent = __webpack_require__(814);
var SyntheticUIEvent = __webpack_require__(99);
var SyntheticWheelEvent = __webpack_require__(815);

var emptyFunction = __webpack_require__(30);
var getEventCharCode = __webpack_require__(205);
var invariant = __webpack_require__(2);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(131);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

var getEventCharCode = __webpack_require__(205);
var getEventKey = __webpack_require__(820);
var getEventModifierState = __webpack_require__(206);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

var getEventModifierState = __webpack_require__(206);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(52);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(131);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(294);
var warning = __webpack_require__(8);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(54);
var ReactDOMComponentTree = __webpack_require__(16);
var ReactInstanceMap = __webpack_require__(98);

var getHostComponentFromComposite = __webpack_require__(308);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(199);
var traverseAllChildren = __webpack_require__(314);
var warning = __webpack_require__(8);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_CONTENTFUL_HOST":"cdn.contentful.com","REACT_APP_CONTENTFUL_SPACE_ID":"tbu6yo6b5o8c","REACT_APP_INSTAGRAM_SITE_NAME":"gaijin","REACT_APP_CONTENTFUL_ACCESS_TOKEN":"e218c3e95c9baa00b1ba82bc971f8636489205545cf5cfe389c809f2552029b7"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(338);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(289)))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(205);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(21);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(133);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(303);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ReCAPTCHA = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReCAPTCHA);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this));

    _this.state = {};
    _this.handleExpired = _this.handleExpired.bind(_this);
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
    return _this;
  }

  ReCAPTCHA.prototype.getValue = function getValue() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this.state.widgetId);
    }
    return null;
  };

  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.state.widgetId;
    }
    return null;
  };

  ReCAPTCHA.prototype.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;
    var widgetId = this.state.widgetId;


    if (grecaptcha && widgetId !== undefined) {
      return grecaptcha.execute(widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  ReCAPTCHA.prototype.reset = function reset() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      this.props.grecaptcha.reset(this.state.widgetId);
    }
  };

  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  };

  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
      var wrapper = document.createElement("div");
      var id = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        size: this.props.size,
        stoken: this.props.stoken,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);

      this.setState({
        widgetId: id
      }, cb);
    }
    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.state.widgetId !== undefined) {
      while (this.captcha.firstChild) {
        this.captcha.removeChild(this.captcha.firstChild);
      }
      this.reset();
    }
  };

  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  ReCAPTCHA.prototype.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        sitekey = _props.sitekey,
        onChange = _props.onChange,
        theme = _props.theme,
        type = _props.type,
        tabindex = _props.tabindex,
        onExpired = _props.onExpired,
        size = _props.size,
        stoken = _props.stoken,
        grecaptcha = _props.grecaptcha,
        badge = _props.badge,
        childProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
    /* eslint-enable no-unused-vars */


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, childProps, { ref: this.handleRecaptchaRef }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReCAPTCHA);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(11);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';

			var inputProps = _objectWithoutProperties(this.props, []);

			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				_react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				_react2.default.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

;

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(newValue) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1
};

exports.default = AutosizeInput;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t.ReactIntlLocaleData=t.ReactIntlLocaleData||{},t.ReactIntlLocaleData.fi=e())}(this,function(){"use strict";return[{locale:"fi",pluralRuleFunction:function(t,e){var n=!String(t).split(".")[1];return e?"other":1==t&&n?"one":"other"},fields:{year:{displayName:"vuosi",relative:{0:"tänä vuonna",1:"ensi vuonna","-1":"viime vuonna"},relativeTime:{future:{one:"{0} vuoden päästä",other:"{0} vuoden päästä"},past:{one:"{0} vuosi sitten",other:"{0} vuotta sitten"}}},month:{displayName:"kuukausi",relative:{0:"tässä kuussa",1:"ensi kuussa","-1":"viime kuussa"},relativeTime:{future:{one:"{0} kuukauden päästä",other:"{0} kuukauden päästä"},past:{one:"{0} kuukausi sitten",other:"{0} kuukautta sitten"}}},day:{displayName:"päivä",relative:{0:"tänään",1:"huomenna",2:"ylihuomenna","-2":"toissa päivänä","-1":"eilen"},relativeTime:{future:{one:"{0} päivän päästä",other:"{0} päivän päästä"},past:{one:"{0} päivä sitten",other:"{0} päivää sitten"}}},hour:{displayName:"tunti",relative:{0:"tämän tunnin aikana"},relativeTime:{future:{one:"{0} tunnin päästä",other:"{0} tunnin päästä"},past:{one:"{0} tunti sitten",other:"{0} tuntia sitten"}}},minute:{displayName:"minuutti",relative:{0:"tämän minuutin aikana"},relativeTime:{future:{one:"{0} minuutin päästä",other:"{0} minuutin päästä"},past:{one:"{0} minuutti sitten",other:"{0} minuuttia sitten"}}},second:{displayName:"sekunti",relative:{0:"nyt"},relativeTime:{future:{one:"{0} sekunnin päästä",other:"{0} sekunnin päästä"},past:{one:"{0} sekunti sitten",other:"{0} sekuntia sitten"}}}}}]});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Divider = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Divider = function (_PureComponent) {
    _inherits(Divider, _PureComponent);

    function Divider() {
      _classCallCheck(this, Divider);

      return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
    }

    _createClass(Divider, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            inset = _props.inset,
            vertical = _props.vertical,
            props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);

        var Component = vertical ? 'div' : 'hr';

        return _react2.default.createElement(Component, _extends({}, props, {
          className: (0, _classnames2.default)('md-divider', {
            'md-divider--vertical': vertical,
            'md-divider--inset': inset
          }, className)
        }));
      }
    }]);

    return Divider;
  }(_react.PureComponent);

  Divider.propTypes = {
    /*
     * An optional style to apply to the divider.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the divider.
     */
    className: _propTypes2.default.string,

    /**
     * Boolean if this divider should be inset relative to it's container
     * component. This means that if it is in a `List` with `Avatar`, it
     * will start the divider  to the left of the main text in the list.
     */
    inset: _propTypes2.default.bool,

    /**
     * Boolean if the divider should be vertical instead of horizontal.
     */
    vertical: _propTypes2.default.bool
  };
  exports.default = Divider;
});
//# sourceMappingURL=Divider.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(316)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../FontIcons/FontIcon'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.FontIcon);
    global.getDeprecatedIcon = mod.exports;
  }
})(this, function (exports, _react, _FontIcon) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getDeprecatedIcon;

  var _react2 = _interopRequireDefault(_react);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function getDeprecatedIcon(className, children, icon) {
    if (className || children) {
      return _react2.default.createElement(
        _FontIcon2.default,
        { iconClassName: className },
        children
      );
    }

    return icon;
  }
});
//# sourceMappingURL=getDeprecatedIcon.js.map

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(908)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('resize-observer-polyfill'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.resizeObserverPolyfill);
    global.ResizeObserver = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _resizeObserverPolyfill) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ResizeObserver = function (_PureComponent) {
    _inherits(ResizeObserver, _PureComponent);

    function ResizeObserver() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ResizeObserver);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResizeObserver.__proto__ || Object.getPrototypeOf(ResizeObserver)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._scrollHeight = null, _this._scrollWidth = null, _this._measure = function (entries) {
        if (!_this._observer || !_this._target) {
          return;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entry = _step.value;

            if (!entry) {
              return;
            }

            var _entry$contentRect = entry.contentRect,
                height = _entry$contentRect.height,
                width = _entry$contentRect.width;
            var _entry$target = entry.target,
                scrollHeight = _entry$target.scrollHeight,
                scrollWidth = _entry$target.scrollWidth;

            if (_this._isHeightChange(height, scrollHeight) || _this._isWidthChange(width, scrollWidth)) {
              _this._height = height;
              _this._width = width;
              _this._scrollHeight = scrollHeight;
              _this._scrollWidth = scrollWidth;
              _this.props.onResize({ height: height, width: width, scrollHeight: scrollHeight, scrollWidth: scrollWidth, el: entry.target });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }, _this._isHeightChange = function (height, scrollHeight) {
        return _this.props.watchHeight && (height !== _this._height || scrollHeight !== _this._scrollHeight);
      }, _this._isWidthChange = function (width, scrollWidth) {
        return _this.props.watchWidth && (width !== _this._width || scrollWidth !== _this._scrollWidth);
      }, _this._handleRef = function (container) {
        if (container) {
          _this._container = container;
          _this._target = _this._getTarget(container, _this.props.target);
          _this._observer = new _resizeObserverPolyfill2.default(_this._measure);

          if (_this._target) {
            _this._observer.observe(_this._target);
          }
        } else {
          if (_this._observer) {
            _this._observer.disconnect();
          }

          _this._container = null;
          _this._target = null;
          _this._observer = null;
          _this._height = null;
          _this._width = null;
          _this._scrollHeight = null;
          _this._scrollWidth = null;
        }

        if (_this.props.elRef) {
          _this.props.elRef(_this._target);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ResizeObserver, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var target = this.props.target;

        var nextTarget = nextProps.target;
        if (target === nextTarget) {
          return;
        } else if (nextTarget) {
          if (this._target) {
            this._observer.unobserve(this._target);
          }
          this._target = this._getTarget(this._container, nextTarget);
          this._observer.observe(this._target);
        }
      }
    }, {
      key: '_getTarget',
      value: function _getTarget(container, target) {
        if (target === null || target && typeof target !== 'string') {
          return target;
        }

        var t = null;
        if (target) {
          t = document.getElementById(target) || document.querySelector(target);
        } else {
          t = container.parentNode;
        }

        if (!t) {
          throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
        }

        return t;
      }
    }, {
      key: 'render',
      value: function render() {
        var Component = this.props.component;

        return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
      }
    }]);

    return ResizeObserver;
  }(_react.PureComponent);

  ResizeObserver.propTypes = {
    /**
     * Boolean if the height should be watched for the resize target.
     */
    watchHeight: _propTypes2.default.bool,

    /**
     * Boolean if the width should be watched for the resize target.
     */
    watchWidth: _propTypes2.default.bool,

    /**
     * An optional target that should be used for detecting resize events. This can either
     * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
     *
     * If this prop is not provided and not null, it will default to the parent node of this component.
     * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
     * it has been correctly passed a target string or object.
     */
    target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),

    /**
     * The component to be rendered as. This should normally just be the default `span`, but there are cases
     * where the component should be switched to something else for valid html.
     */
    component: _propTypes2.default.string,

    /**
     * A function to call when the height or width has been changed and that attribute is being watched.
     * The callback will include the current height, width, scrollHeight and scrollWidth of the target.
     *
     * ```js
     * onResize({ height: nextHeight, width: nextWidth, scrollHeight: nextScrollHeight, scrollWidth: nextScrollWidth });
     * ```
     */
    onResize: _propTypes2.default.func.isRequired,

    /**
     * An optional ref callback that will include the `target` or the parent node of the resize observer. Just
     * like other refs, this will provide null when it unmounts.
     */
    elRef: _propTypes2.default.func
  };
  ResizeObserver.defaultProps = {
    watchHeight: false,
    watchWidth: false,
    component: 'span'
  };
  exports.default = ResizeObserver;
});
//# sourceMappingURL=ResizeObserver.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(100)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/themeColors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.themeColors);
    global.FloatingLabel = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _themeColors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _themeColors2 = _interopRequireDefault(_themeColors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var FloatingLabel = function (_PureComponent) {
    _inherits(FloatingLabel, _PureComponent);

    function FloatingLabel() {
      _classCallCheck(this, FloatingLabel);

      return _possibleConstructorReturn(this, (FloatingLabel.__proto__ || Object.getPrototypeOf(FloatingLabel)).apply(this, arguments));
    }

    _createClass(FloatingLabel, [{
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            label = _props.label,
            htmlFor = _props.htmlFor,
            className = _props.className,
            floating = _props.floating,
            active = _props.active,
            error = _props.error,
            disabled = _props.disabled,
            iconOffset = _props.iconOffset,
            customSize = _props.customSize,
            props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);

        if (!label) {
          return null;
        }

        return _react2.default.createElement(
          'label',
          _extends({}, props, {
            htmlFor: htmlFor,
            className: (0, _classnames2.default)('md-floating-label', (_cn = {
              'md-floating-label--inactive': !floating,
              'md-floating-label--inactive-sized': !floating && !customSize
            }, _defineProperty(_cn, 'md-floating-label--' + customSize, customSize), _defineProperty(_cn, 'md-floating-label--inactive-' + customSize, customSize && !floating), _defineProperty(_cn, 'md-floating-label--floating', floating), _defineProperty(_cn, 'md-floating-label--icon-offset', iconOffset), _cn), (0, _themeColors2.default)({
              disabled: disabled,
              error: error,
              hint: !active,
              primary: active
            }, className))
          }),
          label
        );
      }
    }]);

    return FloatingLabel;
  }(_react.PureComponent);

  FloatingLabel.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    label: _propTypes2.default.node,
    floating: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    active: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    iconOffset: _propTypes2.default.bool,
    customSize: _propTypes2.default.string,
    htmlFor: _propTypes2.default.string
  };
  exports.default = FloatingLabel;
});
//# sourceMappingURL=FloatingLabel.js.map

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(100), __webpack_require__(838)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/themeColors'), require('./TextArea'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.themeColors, global.TextArea);
    global.InputField = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _themeColors, _TextArea) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _themeColors2 = _interopRequireDefault(_themeColors);

  var _TextArea2 = _interopRequireDefault(_TextArea);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var InputField = function (_PureComponent) {
    _inherits(InputField, _PureComponent);

    function InputField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, InputField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputField.__proto__ || Object.getPrototypeOf(InputField)).call.apply(_ref, [this].concat(args))), _this), _this.getField = function () {
        // eslint-disable-line arrow-body-style
        return typeof _this.props.rows === 'undefined' ? _this._field : _this._field.getField();
      }, _this.getValue = function () {
        if (typeof _this.props.rows === 'undefined') {
          return _this._field.value;
        }

        return _this._field.getValue();
      }, _this.focus = function () {
        _this._field.focus();
      }, _this.blur = function () {
        _this._field.blur();
      }, _this._setField = function (field) {
        _this._field = field;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InputField, [{
      key: 'render',
      value: function render() {
        var _cn;

        var _props = this.props,
            className = _props.className,
            rows = _props.rows,
            label = _props.label,
            customSize = _props.customSize,
            fullWidth = _props.fullWidth,
            type = _props.type,
            passwordVisible = _props.passwordVisible,
            block = _props.block,
            inlineIndicator = _props.inlineIndicator,
            maxRows = _props.maxRows,
            props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator', 'maxRows']);

        var multiline = typeof rows !== 'undefined';
        var Component = multiline ? _TextArea2.default : 'input';
        if (!multiline) {
          props.type = passwordVisible ? 'text' : type;
        } else {
          props.label = label;
          props.block = block;
          props.maxRows = maxRows;
        }

        return (0, _react.createElement)(Component, _extends({}, props, {
          rows: rows,
          ref: this._setField,
          className: (0, _classnames2.default)('md-text-field', (_cn = {
            'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
            'md-text-field--multiline': multiline,
            'md-text-field--margin': !block && !multiline && !label,
            'md-text-field--floating-margin': !block && !multiline && label
          }, _defineProperty(_cn, 'md-text-field--' + customSize, customSize), _defineProperty(_cn, 'md-full-width', fullWidth), _cn), (0, _themeColors2.default)({ disabled: props.disabled, text: !props.disabled }, className))
        }));
      }
    }]);

    return InputField;
  }(_react.PureComponent);

  InputField.propTypes = {
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    type: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    block: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    rows: _propTypes2.default.number,
    maxRows: _propTypes2.default.number,
    label: _propTypes2.default.node,
    fullWidth: _propTypes2.default.bool,
    customSize: _propTypes2.default.string,
    passwordVisible: _propTypes2.default.bool,
    inlineIndicator: _propTypes2.default.bool
  };
  exports.default = InputField;
});
//# sourceMappingURL=InputField.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames);
    global.Message = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Message = function (_PureComponent) {
    _inherits(Message, _PureComponent);

    function Message() {
      _classCallCheck(this, Message);

      return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
    }

    _createClass(Message, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            children = _props.children,
            className = _props.className;


        if (!children) {
          return null;
        }

        return _react2.default.createElement(
          'div',
          {
            'aria-hidden': !active,
            className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
          },
          children
        );
      }
    }]);

    return Message;
  }(_react.PureComponent);

  Message.propTypes = {
    active: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    children: _propTypes2.default.node
  };
  exports.default = Message;
});
//# sourceMappingURL=Message.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(842), __webpack_require__(100)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../constants/keyCodes'), require('../utils/themeColors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.keyCodes, global.themeColors);
    global.PasswordButton = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _keyCodes, _themeColors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _themeColors2 = _interopRequireDefault(_themeColors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var PasswordButton = function (_PureComponent) {
    _inherits(PasswordButton, _PureComponent);

    function PasswordButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, PasswordButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordButton.__proto__ || Object.getPrototypeOf(PasswordButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = { keyboardFocus: false }, _this._handleOutsideClick = function (e) {
        if (_this._button && !_this._button.contains(e.target)) {
          window.removeEventListener('click', _this._handleOutsideClick);
          _this.setState({ keyboardFocus: false });
        }
      }, _this._handleBlur = function () {
        if (_this.state.keyboardFocus) {
          _this.setState({ keyboardFocus: false });
        }
      }, _this._handleKeyUp = function (e) {
        var key = e.which || e.keyCode;
        if (key === _keyCodes.TAB) {
          _this.setState({ keyboardFocus: true });
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PasswordButton, [{
      key: 'render',
      value: function render() {
        var keyboardFocus = this.state.keyboardFocus;

        var _props = this.props,
            active = _props.active,
            passwordVisible = _props.passwordVisible,
            block = _props.block,
            floating = _props.floating,
            icon = _props.icon,
            props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'block', 'floating', 'icon']);

        return _react2.default.createElement(
          'button',
          _extends({}, props, {
            onBlur: this._handleBlur,
            onKeyUp: this._handleKeyUp,
            type: 'button',
            className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
              'md-password-btn--focus': keyboardFocus,
              'md-password-btn--invisible': active && !passwordVisible,
              'md-text-field-inline-indicator--floating': floating,
              'md-text-field-inline-indicator--block': block
            }, (0, _themeColors2.default)({ disabled: !active, hint: active }))
          }),
          icon
        );
      }
    }]);

    return PasswordButton;
  }(_react.PureComponent);

  PasswordButton.propTypes = {
    active: _propTypes2.default.bool,
    passwordVisible: _propTypes2.default.bool,
    icon: _propTypes2.default.element,
    block: _propTypes2.default.bool,
    floating: _propTypes2.default.bool
  };
  exports.default = PasswordButton;
});
//# sourceMappingURL=PasswordButton.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(833)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Helpers/ResizeObserver'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.ResizeObserver);
    global.TextArea = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _ResizeObserver) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _ResizeObserver2 = _interopRequireDefault(_ResizeObserver);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextArea = function (_PureComponent) {
    _inherits(TextArea, _PureComponent);

    function TextArea() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TextArea);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = { height: null }, _this.getField = function () {
        return _this._field;
      }, _this.getValue = function () {
        return _this._field.value;
      }, _this.focus = function () {
        _this._field.focus();
      }, _this.blur = function () {
        _this._field.blur();
      }, _this._calcRowHeight = function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props,
            rows = _ref2.rows;

        if (!_this._field) {
          return 19;
        }

        var height = _this._field.style.height;
        _this._field.style.height = 'auto';
        var rowHeight = _this._field.offsetHeight / rows;
        _this._field.style.height = height;
        return rowHeight;
      }, _this._setMask = function (mask) {
        _this._mask = mask;
      }, _this._setField = function (field) {
        _this._field = field;
      }, _this._handleResize = function () {
        _this._rowHeight = _this._calcRowHeight();
        _this._syncHeightWithMask();
      }, _this._syncHeightWithMask = function (value) {
        // The mask is always null in snapshot teseting
        if (!_this._mask) {
          return;
        }

        if (value !== undefined) {
          _this._mask.value = value;
        }

        var height = _this._mask.scrollHeight;
        if (height === undefined) {
          return;
        }

        var _this$props = _this.props,
            rows = _this$props.rows,
            maxRows = _this$props.maxRows;

        if (maxRows && maxRows > 0) {
          height = Math.min(height, _this._rowHeight * maxRows);
        }

        height = Math.max(_this._rowHeight * rows, height);
        _this.setState({ height: height });
      }, _this._handleChange = function (e) {
        _this._syncHeightWithMask(e.target.value, e);

        if (_this.props.onChange) {
          _this.props.onChange(e);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextArea, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._rowHeight = this._calcRowHeight();
        this._syncHeightWithMask();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.rows !== nextProps.rows) {
          this._rowHeight = this._calcRowHeight(nextProps);
        }

        if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
          this._syncHeightWithMask(nextProps.value);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var height = this.state.height;

        var _props = this.props,
            style = _props.style,
            defaultValue = _props.defaultValue,
            value = _props.value,
            className = _props.className,
            label = _props.label,
            block = _props.block,
            maxRows = _props.maxRows,
            onChange = _props.onChange,
            props = _objectWithoutProperties(_props, ['style', 'defaultValue', 'value', 'className', 'label', 'block', 'maxRows', 'onChange']);

        return _react2.default.createElement(
          'div',
          {
            style: { height: height && height + 5 },
            className: (0, _classnames2.default)('md-text-field-multiline-container', {
              'md-text-field--margin': !label && !block,
              'md-text-field--floating-margin': label && !block
            })
          },
          _react2.default.createElement(_ResizeObserver2.default, { watchWidth: true, onResize: this._handleResize }),
          _react2.default.createElement('textarea', {
            ref: this._setMask,
            className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
            readOnly: true,
            rows: props.rows,
            tabIndex: -1,
            style: style,
            defaultValue: defaultValue,
            'aria-hidden': true,
            value: value
          }),
          _react2.default.createElement('textarea', _extends({}, props, {
            ref: this._setField,
            style: Object.assign({}, style, { height: height }),
            className: className,
            defaultValue: defaultValue,
            value: value,
            onChange: this._handleChange
          }))
        );
      }
    }]);

    return TextArea;
  }(_react.PureComponent);

  TextArea.propTypes = {
    id: _propTypes2.default.string,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    rows: _propTypes2.default.number.isRequired,
    maxRows: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    defaultValue: _propTypes2.default.string,
    floatingLabel: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    block: _propTypes2.default.bool,
    label: _propTypes2.default.node
  };
  exports.default = TextArea;
});
//# sourceMappingURL=TextArea.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(852), __webpack_require__(853), __webpack_require__(848), __webpack_require__(843), __webpack_require__(844), __webpack_require__(845), __webpack_require__(846), __webpack_require__(847), __webpack_require__(316), __webpack_require__(832), __webpack_require__(834), __webpack_require__(841), __webpack_require__(837), __webpack_require__(835), __webpack_require__(840)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/getField'), require('../utils/Positioning/getTextWidth'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/invalidIf'), require('../utils/PropTypes/minNumber'), require('../utils/StringUtils/addSuffix'), require('../FontIcons/FontIcon'), require('../FontIcons/getDeprecatedIcon'), require('./FloatingLabel'), require('./TextFieldMessage'), require('./PasswordButton'), require('./InputField'), require('./TextFieldDivider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.isRequiredForA11y, global.getField, global.getTextWidth, global.controlled, global.invalidIf, global.minNumber, global.addSuffix, global.FontIcon, global.getDeprecatedIcon, global.FloatingLabel, global.TextFieldMessage, global.PasswordButton, global.InputField, global.TextFieldDivider);
    global.TextField = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _isRequiredForA11y, _getField, _getTextWidth, _controlled, _invalidIf, _minNumber, _addSuffix, _FontIcon, _getDeprecatedIcon, _FloatingLabel, _TextFieldMessage, _PasswordButton, _InputField, _TextFieldDivider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _deprecated2 = _interopRequireDefault(_deprecated);

  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

  var _getField2 = _interopRequireDefault(_getField);

  var _getTextWidth2 = _interopRequireDefault(_getTextWidth);

  var _controlled2 = _interopRequireDefault(_controlled);

  var _invalidIf2 = _interopRequireDefault(_invalidIf);

  var _minNumber2 = _interopRequireDefault(_minNumber);

  var _addSuffix2 = _interopRequireDefault(_addSuffix);

  var _FontIcon2 = _interopRequireDefault(_FontIcon);

  var _getDeprecatedIcon2 = _interopRequireDefault(_getDeprecatedIcon);

  var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);

  var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);

  var _PasswordButton2 = _interopRequireDefault(_PasswordButton);

  var _InputField2 = _interopRequireDefault(_InputField);

  var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DEFAULT_TEXT_FIELD_SIZE = 180;

  /**
   * The `TextField` component can either be a single line `input` field or a multiline
   * `textarea` field. `FontIcon`s, messages, and password indicators can also be added
   * to this field.
   *
   * The optional mouse and touch events will be added to the entire container while the
   * text specific events will be added to the `input` or `textarea` tags.
   */

  var TextField = function (_PureComponent) {
    _inherits(TextField, _PureComponent);

    function TextField(props) {
      _classCallCheck(this, TextField);

      var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

      _initialiseProps.call(_this);

      var currentLength = _this._getLength(typeof props.value !== 'undefined' ? props.value : props.defaultValue);

      _this._canvas = null;
      var width = null;
      if (typeof props.resize !== 'undefined') {
        width = typeof props.resize.min === 'number' ? props.resize.min : DEFAULT_TEXT_FIELD_SIZE;
      }

      _this.state = {
        active: false,
        error: props.maxLength ? props.maxLength < currentLength : false,
        floating: _this._isValued(props.defaultValue) || _this._isValued(props.value),
        passwordVisible: props.passwordInitiallyVisible,
        currentLength: currentLength,
        width: width
      };
      return _this;
    }

    _createClass(TextField, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _props = this.props,
            value = _props.value,
            defaultValue = _props.defaultValue,
            resize = _props.resize;

        var v = typeof value !== 'undefined' ? value : defaultValue;
        if (!resize || typeof document === 'undefined' || !v) {
          return;
        }

        this.setState({ width: this._calcWidth(v) });
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props2 = this.props,
            value = _props2.value,
            defaultValue = _props2.defaultValue,
            resize = _props2.resize;

        var v = typeof value !== 'undefined' ? value : defaultValue;
        if (resize && v) {
          this.setState({ width: this._calcWidth(v) }); // eslint-disable-line react/no-did-mount-set-state
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var value = nextProps.value,
            maxLength = nextProps.maxLength,
            required = nextProps.required,
            resize = nextProps.resize;

        if (this.props.value !== value) {
          var _state = this.state,
              error = _state.error,
              width = _state.width;

          var currentLength = this._getLength(value);
          if (required && error) {
            error = !this._isValued(value);
          }

          if (maxLength) {
            error = error || currentLength > maxLength;
          }

          if (resize) {
            var nextWidth = this._calcWidth(value);
            if (!resize.disableShrink || nextWidth > width) {
              width = nextWidth;
            }
          }

          this.setState({
            error: error,
            width: width,
            currentLength: currentLength,
            floating: this._isValued(value) || this.state.floating && this.state.active
          });
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        this._field.blur();
      }
    }, {
      key: '_cloneIcon',
      value: function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
        if (!icon) {
          return icon;
        }

        try {
          var iconEl = _react.Children.only(icon);
          return (0, _react.cloneElement)(iconEl, {
            key: iconEl.key || 'icon-' + dir,
            disabled: stateful ? disabled : undefined,
            primary: stateful ? !error && active : undefined,
            error: stateful ? error : undefined,
            className: (0, _classnames2.default)('md-text-field-icon', {
              'md-text-field-icon--positioned': !block
            }, iconEl.props.className)
          });
        } catch (e) {
          return icon;
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state2 = this.state,
            currentLength = _state2.currentLength,
            passwordVisible = _state2.passwordVisible,
            width = _state2.width;

        var _props3 = this.props,
            id = _props3.id,
            type = _props3.type,
            style = _props3.style,
            className = _props3.className,
            inputStyle = _props3.inputStyle,
            inputClassName = _props3.inputClassName,
            block = _props3.block,
            fullWidth = _props3.fullWidth,
            required = _props3.required,
            customSize = _props3.customSize,
            maxLength = _props3.maxLength,
            errorText = _props3.errorText,
            helpText = _props3.helpText,
            helpOnFocus = _props3.helpOnFocus,
            disabled = _props3.disabled,
            leftIconStateful = _props3.leftIconStateful,
            rightIconStateful = _props3.rightIconStateful,
            passwordIcon = _props3.passwordIcon,
            lineDirection = _props3.lineDirection,
            paddedBlock = _props3.paddedBlock,
            onDoubleClick = _props3.onDoubleClick,
            onTouchStart = _props3.onTouchStart,
            onTouchMove = _props3.onTouchMove,
            onTouchCancel = _props3.onTouchCancel,
            onTouchEnd = _props3.onTouchEnd,
            onMouseDown = _props3.onMouseDown,
            onMouseUp = _props3.onMouseUp,
            onMouseOver = _props3.onMouseOver,
            onMouseLeave = _props3.onMouseLeave,
            ink = _props3.ink,
            inlineIndicator = _props3.inlineIndicator,
            toolbar = _props3.toolbar,
            icon = _props3.icon,
            passwordIconChildren = _props3.passwordIconChildren,
            passwordIconClassName = _props3.passwordIconClassName,
            propLabel = _props3.label,
            propPlaceholder = _props3.placeholder,
            propError = _props3.error,
            propActive = _props3.active,
            propFloating = _props3.floating,
            propLeftIcon = _props3.leftIcon,
            propRightIcon = _props3.rightIcon,
            onClick = _props3.onClick,
            onChange = _props3.onChange,
            onBlur = _props3.onBlur,
            onFocus = _props3.onFocus,
            resize = _props3.resize,
            adjustMinWidth = _props3.adjustMinWidth,
            propFloatingLabel = _props3.floatingLabel,
            props = _objectWithoutProperties(_props3, ['id', 'type', 'style', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'passwordIcon', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'toolbar', 'icon', 'passwordIconChildren', 'passwordIconClassName', 'label', 'placeholder', 'error', 'active', 'floating', 'leftIcon', 'rightIcon', 'onClick', 'onChange', 'onBlur', 'onFocus', 'resize', 'adjustMinWidth', 'floatingLabel']);

        var _props4 = this.props,
            label = _props4.label,
            placeholder = _props4.placeholder,
            error = _props4.error,
            active = _props4.active,
            floating = _props4.floating,
            leftIcon = _props4.leftIcon,
            rightIcon = _props4.rightIcon;

        active = active || this.state.active;
        error = error || this.state.error;
        floating = floating || this.state.floating;

        if (required) {
          if (label) {
            label = (0, _addSuffix2.default)(label, '*');
          }

          if (placeholder && !label) {
            placeholder = (0, _addSuffix2.default)(placeholder, '*');
          }
        }

        if (label && !floating) {
          placeholder = null;
        }

        leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
        if (type === 'password' && !disabled) {
          rightIcon = _react2.default.createElement(_PasswordButton2.default, {
            key: 'password-btn',
            onClick: this._togglePasswordField,
            active: active,
            passwordVisible: passwordVisible,
            icon: (0, _getDeprecatedIcon2.default)(passwordIconClassName, passwordIconChildren, passwordIcon),
            block: block,
            floating: !!label
          });
        } else if (inlineIndicator) {
          var el = _react.Children.only(inlineIndicator);
          rightIcon = (0, _react.cloneElement)(inlineIndicator, {
            key: 'icon-right',
            className: (0, _classnames2.default)('md-text-field-inline-indicator', {
              'md-text-field-inline-indicator--floating': label,
              'md-text-field-inline-indicator--block': block
            }, el.props.className)
          });
        } else {
          rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
        }
        var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;

        var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
          key: 'label',
          label: label,
          htmlFor: id,
          active: active,
          error: error,
          floating: floating,
          customSize: customSize,
          disabled: disabled,
          iconOffset: !!leftIcon
        });

        var message = _react2.default.createElement(_TextFieldMessage2.default, {
          key: 'message',
          active: active,
          error: error,
          errorText: errorText,
          helpText: helpText,
          helpOnFocus: helpOnFocus,
          block: block,
          maxLength: maxLength,
          leftIcon: !!leftIcon,
          rightIcon: !!rightIcon,
          currentLength: currentLength
        });

        var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
          key: 'field',
          ref: this._setField,
          id: id,
          type: type,
          label: label,
          style: inputStyle,
          className: (0, _classnames2.default)({ 'md-text-field--toolbar': toolbar }, inputClassName),
          disabled: disabled,
          customSize: customSize,
          fullWidth: fullWidth,
          passwordVisible: passwordVisible,
          placeholder: placeholder,
          block: block,
          onFocus: this._handleFocus,
          onBlur: this._handleBlur,
          onChange: this._handleChange,
          inlineIndicator: !!inlineIndicator
        }));

        var divider = void 0;
        if (!block) {
          divider = _react2.default.createElement(_TextFieldDivider2.default, {
            key: 'text-divider',
            active: active,
            error: error,
            lineDirection: lineDirection
          });
        }

        var children = void 0;
        if (leftIcon || rightIconed) {
          children = _react2.default.createElement(
            'div',
            { key: 'icon-divider', className: 'md-text-field-icon-container' },
            leftIcon,
            _react2.default.createElement(
              'div',
              {
                key: 'divider-container',
                className: (0, _classnames2.default)('md-text-field-divider-container', {
                  'md-text-field-divider-container--grow': fullWidth
                })
              },
              field,
              divider
            ),
            rightIcon
          );
        } else {
          children = [leftIcon, field, divider, rightIcon];
        }

        children = [floatingLabel, children, message];

        var multiline = typeof props.rows !== 'undefined';
        return _react2.default.createElement(
          'div',
          {
            style: _extends({ width: width }, style),
            className: (0, _classnames2.default)('md-text-field-container', {
              'md-inline-block': !fullWidth && !block,
              'md-full-width': block || fullWidth,
              'md-text-field-container--disabled': disabled,
              'md-text-field-container--input': !multiline,
              'md-text-field-container--input-block': block && !multiline,
              'md-text-field-container--multiline': multiline,
              'md-text-field-container--multiline-block': multiline && block,
              'md-text-field-container--padded-block': block && paddedBlock
            }, className),
            onClick: this._handleContainerClick,
            onDoubleClick: onDoubleClick,
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onTouchStart: onTouchStart,
            onTouchEnd: onTouchEnd,
            onTouchCancel: onTouchCancel,
            onTouchMove: onTouchMove
          },
          ink,
          children
        );
      }
    }, {
      key: 'value',
      get: function get() {
        return this.getField().value;
      }
    }]);

    return TextField;
  }(_react.PureComponent);

  TextField.propTypes = {
    /**
     * The id for a text field. This is required when using the `label` prop for accessibility,
     * but normally a good idea to include one anyways.
     */
    id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),

    /**
     * An optional style to apply to the text field's container.
     */
    style: _propTypes2.default.object,

    /**
     * An optional className to apply to the text field's container.
     */
    className: _propTypes2.default.string,

    /**
     * An optional style to apply to the `input` or `textarea` tag.
     */
    inputStyle: _propTypes2.default.object,

    /**
     * An optional className to apply to the `input` or `textarea` tag.
     */
    inputClassName: _propTypes2.default.string,

    /**
     * An optional value to apply to the text field. This will make the component
     * controlled and require the `onChange` prop.
     */
    value: (0, _controlled2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]), 'onChange'),

    /**
     * An optional default value for the text field.
     */
    defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

    /**
     * Boolean if the text field should be displayed as a `block`. This is equivalent to
     * the `full width` text field in the Material Design specs. This view will disable
     * floating labels and remove the text divider from the component.
     */
    block: _propTypes2.default.bool,

    /**
     * Boolean if the `block` text field should include padding to the left and right of
     * the text field.
     */
    paddedBlock: _propTypes2.default.bool,

    /**
     * Boolean if the text field is currently disabled.
     */
    disabled: _propTypes2.default.bool,

    /**
     * An optional label to display with the text field. This will convert the text field
     * into a floating label text field. You can make it single line by only using the
     * `placeholder` prop.
     */
    label: (0, _invalidIf2.default)(_propTypes2.default.node, 'block'),

    /**
     * An optional placeholder text to display in the text field. If there is no `label` prop,
     * the text field will be displayed as a single line text field. If there is a `label` prop,
     * this will only be visible when there is no value and the user focused the text field.
     */
    placeholder: _propTypes2.default.string,

    /**
     * The type for the text field. This is one of the most import props for mobile accessibility
     * as it will update the keyboard for the text type. This does not get applied on multiline
     * text fields.
     */
    type: _propTypes2.default.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,

    /**
     * An optional function to call when the text field's container triggers the `click` event.
     */
    onClick: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `doubleclick`
     * event.
     */
    onDoubleClick: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchstart`
     * event.
     */
    onTouchStart: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchmove`
     * event.
     */
    onTouchMove: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchcancel`
     * event.
     */
    onTouchCancel: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `touchend`
     * event.
     */
    onTouchEnd: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mousedown`
     * event.
     */
    onMouseDown: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseup`
     * event.
     */
    onMouseUp: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseover`
     * event.
     */
    onMouseOver: _propTypes2.default.func,

    /**
     * An optional function to call when the text field's container triggers the `mouseleave`
     * event.
     */
    onMouseLeave: _propTypes2.default.func,

    /**
     * An optional onChange function to call. If the `value` prop is defined, this is
     * required.
     *
     * When the value changes in the text field, this will be called with the new text
     * field's value and the change event.
     *
     * ```js
     * onChange(e.target.value, e);
     * ```
     */
    onChange: _propTypes2.default.func,

    /**
     * An optional function to call when the text field is blurred.
     */
    onBlur: _propTypes2.default.func,

    /**
     * An optional function to call when the text field is focused.
     */
    onFocus: _propTypes2.default.func,

    /**
     * An optional boolean if the `active` state of the text field can be externally
     * modified as well. The text field is usually considered active when it gains focus.
     *
     * If this prop is set, it will check both the active prop and the active state to
     * determine if one is true.
     */
    active: _propTypes2.default.bool,

    /**
     * An optional boolean if the `error` state of the text field can be externally
     * modified as well. The text field is usually considered errored when it is required
     * and there is no value or the current length of the text field's value is greater
     * than the `maxLength` prop.
     *
     * If this prop is set, it will check both the error prop and the error state to
     * determine if one is true.
     */
    error: _propTypes2.default.bool,

    /**
     * An optional boolean if the `floating` state of the text field's floating label can be
     * externally modified as well. The floating state is true when the text field gains focus
     * or there is a value in the text field.
     *
     * If this prop is set, it will check both the floating prop and the floating state to
     * determine if one is true.
     */
    floating: _propTypes2.default.bool,

    /**
     * Boolean if the text field is required. If the user blurs the text field while there is
     * no value and it is required, the `error` state will be set to true.
     */
    required: _propTypes2.default.bool,

    /**
     * The direction that the underline should appear from.
     */
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right']).isRequired,

    /**
     * An optional icon to place to the left of the text field.
     */
    leftIcon: _propTypes2.default.element,

    /**
     * Boolean if the left icon should be stateful. This means that the icon will
     * gain the active or error colors with the text field.
     */
    leftIconStateful: _propTypes2.default.bool,

    /**
     * An optional icon to place to the right of the text field.
     */
    rightIcon: _propTypes2.default.element,

    /**
     * Boolean if the right icon should be stateful. This means that the icon will
     * gain the active or error colors with the text field.
     */
    rightIconStateful: _propTypes2.default.bool,

    /**
     * The icon to use for a password text field.
     */
    passwordIcon: _propTypes2.default.element,

    /**
     * Boolean if the password is initially visible.
     */
    passwordInitiallyVisible: _propTypes2.default.bool,

    /**
     * Boolean if the text field should be displayed as full width.
     */
    fullWidth: _propTypes2.default.bool,

    /**
     * The number of rows for the `multiline` text field. This value must be greater than
     * or equal to 1. When this value is set, the text field will be converted to a multiline
     * field.
     */
    rows: (0, _minNumber2.default)(1, false),

    /**
     * The maximum number of rows for a `multiline` text field. If this value is
     * `undefined`, `0`, or a number less than `0`, the multiline text field will
     * infinitely expand.
     */
    maxRows: _propTypes2.default.number,

    /**
     * An optional custom size to apply to the text field. This is used along with
     * the `$md-text-field-custom-sizes` variable. It basically applies a className of
     * `md-text-field--NAME`.
     */
    customSize: _propTypes2.default.string,

    /**
     * An optional error text to display below the text field. This will only appear when
     * the text field has the `error` state through the `error` prop, the current length
     * of the text field's value is greater than the `maxLength` prop, or the field is
     * required and the user blurs the text field with no value.
     */
    errorText: _propTypes2.default.node,

    /**
     * An optional help text to display below the text field. This will always be visible
     * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
     */
    helpText: _propTypes2.default.node,

    /**
     * Boolean if the help text should display on focus only.
     */
    helpOnFocus: _propTypes2.default.bool,

    /**
     * An optional max length for the text field. This will insert a counter underneath the
     * text field that appears on focus.
     */
    maxLength: _propTypes2.default.number,

    /**
     * The ink when there is an injectInk above the text field. Used from the SelectField.
     *
     * @access private
     */
    ink: _propTypes2.default.node,

    /**
     * An optional element to display inside of the `TextField` to the farthest right. This will
     * position the indicator absolutely and add some additional padding to the `TextField`.
     */
    inlineIndicator: _propTypes2.default.element,

    /**
     * This prop allows the text field to resize its width to stay between the min and max sizes provided. By
     * default, the field will expand and collapse based on the amount of text provided. The collapsing can
     * be disabled by providing `disableShrink` to the configuration object.
     *
     * If the `min` prop is not provided, it will default to `180` which is about the same size as a default
     * text field.
     */
    resize: _propTypes2.default.shape({
      min: _propTypes2.default.number,
      max: _propTypes2.default.number.isRequired,
      disableShrink: _propTypes2.default.bool
    }),

    /**
     * Boolean if the TextField is in a toolbar and acting as a title. This will apply additional styles to the
     * text field to make it look like the toolbar's title.
     */
    toolbar: _propTypes2.default.bool,

    passwordIconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `passwordIcon` prop instead'),
    passwordIconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `passwordIcon` prop instead'),
    icon: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
    floatingLabel: (0, _deprecated2.default)(_propTypes2.default.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
    adjustMinWidth: (0, _deprecated2.default)(_propTypes2.default.bool, 'Manually add a min width style instead')
  };
  TextField.defaultProps = {
    type: 'text',
    lineDirection: 'left',
    passwordIcon: _react2.default.createElement(
      _FontIcon2.default,
      null,
      'remove_red_eye'
    ),
    leftIconStateful: true,
    rightIconStateful: true,
    fullWidth: true
  };

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getField = function () {
      return _this2._field.getField();
    };

    this.focus = function () {
      _this2._field.focus();
    };

    this._isValued = function (v) {
      return v === 0 || !!v;
    };

    this._getLength = function (v) {
      if (_this2._isValued(v)) {
        return String(v).length;
      }

      return 0;
    };

    this._setField = function (field) {
      if (field !== null) {
        _this2._field = field;
      }
    };

    this._calcWidth = function (value) {
      var width = (0, _getTextWidth2.default)(value, _this2._field && _this2._field.getField());
      if (width === null) {
        // some error happened, don't do other logic
        return width;
      }

      var max = _this2.props.resize.max;

      var min = (0, _getField2.default)(_this2.props.resize, { min: DEFAULT_TEXT_FIELD_SIZE }, 'min');

      return Math.min(max, Math.max(min, width));
    };

    this._handleContainerClick = function (e) {
      if (_this2.props.onClick) {
        _this2.props.onClick(e);
      }

      if (!_this2.props.disabled) {
        _this2.focus();
      }
    };

    this._handleBlur = function (e) {
      var _props5 = _this2.props,
          required = _props5.required,
          maxLength = _props5.maxLength,
          onBlur = _props5.onBlur;

      if (onBlur) {
        onBlur(e);
      }

      var value = e.target.value;

      var state = {
        active: false,
        error: required && !_this2._isValued(value) || maxLength && String(value).length > maxLength
      };

      if (!_this2.props.block) {
        state.floating = _this2._isValued(value);
      }

      _this2.setState(state);
    };

    this._handleFocus = function (e) {
      var _props6 = _this2.props,
          onFocus = _props6.onFocus,
          block = _props6.block;

      if (onFocus) {
        onFocus(e);
      }

      var state = { active: true };
      if (!block) {
        state.floating = true;
      }

      _this2.setState(state);
    };

    this._handleChange = function (e) {
      var _props7 = _this2.props,
          onChange = _props7.onChange,
          maxLength = _props7.maxLength,
          required = _props7.required,
          resize = _props7.resize;
      var value = e.target.value;

      if (onChange) {
        onChange(e.target.value, e);
      }

      var currentLength = value.length;
      var state = void 0;
      if (typeof maxLength !== 'undefined') {
        state = { currentLength: currentLength, error: currentLength > maxLength };
      } else if (required && _this2.state.error) {
        state = { error: !currentLength };
      }

      if (typeof _this2.props.value === 'undefined' && resize) {
        var width = _this2._calcWidth(value);
        if (!resize.disableShrink || width > _this2.state.width) {
          state = state || {};
          state.width = _this2._calcWidth(value);
        }
      }

      if (state) {
        _this2.setState(state);
      }
    };

    this._togglePasswordField = function () {
      _this2.setState({ passwordVisible: !_this2.state.passwordVisible }, _this2.focus);
    };
  };

  exports.default = TextField;
});
//# sourceMappingURL=TextField.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(831)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../Dividers/Divider'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Divider);
    global.TextFieldDivider = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _Divider) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _Divider2 = _interopRequireDefault(_Divider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextFieldDivider = function (_PureComponent) {
    _inherits(TextFieldDivider, _PureComponent);

    function TextFieldDivider() {
      _classCallCheck(this, TextFieldDivider);

      return _possibleConstructorReturn(this, (TextFieldDivider.__proto__ || Object.getPrototypeOf(TextFieldDivider)).apply(this, arguments));
    }

    _createClass(TextFieldDivider, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            active = _props.active,
            error = _props.error,
            lineDirection = _props.lineDirection,
            className = _props.className,
            props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);

        return _react2.default.createElement(_Divider2.default, _extends({}, props, {
          className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
            'md-divider--text-field-expanded': active,
            'md-divider--text-field-active': !error && active,
            'md-divider--text-field-error': error
          }, className)
        }));
      }
    }]);

    return TextFieldDivider;
  }(_react.PureComponent);

  TextFieldDivider.propTypes = {
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    error: _propTypes2.default.bool,
    lineDirection: _propTypes2.default.oneOf(['left', 'center', 'right'])
  };
  exports.default = TextFieldDivider;
});
//# sourceMappingURL=TextFieldDivider.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(3), __webpack_require__(19), __webpack_require__(100), __webpack_require__(836)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('classnames'), require('../utils/themeColors'), require('./Message'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.themeColors, global.Message);
    global.TextFieldMessage = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _classnames, _themeColors, _Message) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _classnames2 = _interopRequireDefault(_classnames);

  var _themeColors2 = _interopRequireDefault(_themeColors);

  var _Message2 = _interopRequireDefault(_Message);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var TextFieldMessage = function (_PureComponent) {
    _inherits(TextFieldMessage, _PureComponent);

    function TextFieldMessage(props) {
      _classCallCheck(this, TextFieldMessage);

      var _this = _possibleConstructorReturn(this, (TextFieldMessage.__proto__ || Object.getPrototypeOf(TextFieldMessage)).call(this, props));

      _this.state = {
        message: props.error && props.errorText || props.helpText || props.errorText,
        isMessageVisible: _this._isMessageVisible(props)
      };
      return _this;
    }

    _createClass(TextFieldMessage, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
        if (this._anyChanges(keys, this.props, nextProps)) {
          this.setState({
            isMessageVisible: this._isMessageVisible(nextProps),
            message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
          });
        }
      }
    }, {
      key: '_anyChanges',
      value: function _anyChanges(keys, p1, p2) {
        var changed = false;
        keys.some(function (key) {
          if (p1[key] !== p2[key]) {
            changed = true;
          }

          return changed;
        });

        return changed;
      }
    }, {
      key: '_isMessageVisible',
      value: function _isMessageVisible(props) {
        var error = props.error,
            errorText = props.errorText,
            helpText = props.helpText,
            helpOnFocus = props.helpOnFocus,
            active = props.active;

        if (error && errorText) {
          return true;
        }

        return !!(helpText && (!helpOnFocus || active));
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            maxLength = _props.maxLength,
            error = _props.error,
            className = _props.className,
            errorText = _props.errorText,
            helpText = _props.helpText,
            currentLength = _props.currentLength,
            leftIcon = _props.leftIcon,
            rightIcon = _props.rightIcon,
            block = _props.block,
            active = _props.active;
        var _state = this.state,
            isMessageVisible = _state.isMessageVisible,
            message = _state.message;


        if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
          return null;
        }

        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('md-text-field-message-container', {
              'md-text-field-message-container--count-only': !message || !isMessageVisible,
              'md-text-field-message-container--left-icon-offset': leftIcon,
              'md-text-field-message-container--right-icon-offset': rightIcon,
              'md-full-width': !block
            }, (0, _themeColors2.default)({ error: error, disabled: !error }), className)
          },
          _react2.default.createElement(
            _Message2.default,
            { key: 'message', active: isMessageVisible },
            message
          ),
          _react2.default.createElement(
            _Message2.default,
            { key: 'counter', className: 'md-text-field-message--counter', active: active },
            maxLength ? currentLength + ' / ' + maxLength : null
          )
        );
      }
    }]);

    return TextFieldMessage;
  }(_react.PureComponent);

  TextFieldMessage.propTypes = {
    className: _propTypes2.default.string,
    error: _propTypes2.default.bool,
    helpText: _propTypes2.default.node,
    errorText: _propTypes2.default.node,
    active: _propTypes2.default.bool,
    helpOnFocus: _propTypes2.default.bool,
    maxLength: _propTypes2.default.number,
    currentLength: _propTypes2.default.number,
    leftIcon: _propTypes2.default.bool,
    rightIcon: _propTypes2.default.bool,
    block: _propTypes2.default.bool
  };
  exports.default = TextFieldMessage;
});
//# sourceMappingURL=TextFieldMessage.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.keyCodes = mod.exports;
  }
})(this, function (exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var LEFT_MOUSE = exports.LEFT_MOUSE = 0;
  var RIGHT_MOUSE = exports.RIGHT_MOUSE = 2;

  var TAB = exports.TAB = 9;
  var ENTER = exports.ENTER = 13;
  var ESC = exports.ESC = 27;
  var SPACE = exports.SPACE = 32;
  var PAGE_UP = exports.PAGE_UP = 33;
  var PAGE_DOWN = exports.PAGE_DOWN = 34;
  var END = exports.END = 35;
  var HOME = exports.HOME = 36;
  var LEFT = exports.LEFT = 37;
  var UP = exports.UP = 38;
  var RIGHT = exports.RIGHT = 39;
  var DOWN = exports.DOWN = 40;

  var ZERO = exports.ZERO = 48;
  var NINE = exports.NINE = 57;
  var KEYPAD_ZERO = exports.KEYPAD_ZERO = 96;
  var KEYPAD_NINE = exports.KEYPAD_NINE = 105;
});
//# sourceMappingURL=keyCodes.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getTextWidth = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getTextWidth;
  /** @module utils/Positioning/getTextWidth */

  var cachedCanvas = void 0;

  /**
   * A utility function to measure the width (in px) of any text. It will require a canvas
   * and an element to use to determine the current fonts to apply since different fonts will
   * have different widths.
   *
   * This isn't fully accurate since some browsers handle the calculations a bit differently so
   * they are off by a 0-3px
   *
   * @param {String} text - The text to measure the width
   * @param {HTMLElement} el - The element to use to determine the current font for the text.
   * @param {HTMLElement=} canvas - An optional canvas to use for doing the calculations. If this
   *    is omitted, it will just use the locally created canvas to do the calculations.
   * @return {number} this will either return null if there is a problem calculating the width or
   *    the length (in px) of the text.
   */
  function getTextWidth(text, el, canvas) {
    if (!el) {
      return null;
    }

    if (!canvas) {
      if (!cachedCanvas) {
        cachedCanvas = document.createElement('canvas');
      }

      canvas = cachedCanvas;
    }

    var context = canvas.getContext('2d');
    if (!context) {
      // context doesn't exist in testing without complicated mocks
      return null;
    }

    var styles = window.getComputedStyle(el);
    var font = styles.font;
    // Some browsers do not actually supply the font style since they are on an older version of CSSProperties,
    // so the font string needs to be made manually.
    if (!font) {
      // font-style font-variant font-weight font-size/line-height font-family
      var sizing = styles.fontSize + ' / ' + styles.lineHeight + ' ' + styles.fontFamily;
      font = styles.fontStyle + ' ' + styles.fontVariant + ' ' + styles.fontWeight + ' ' + sizing;
    }

    context.font = font;
    return context.measureText(text).width;
  }
});
//# sourceMappingURL=getTextWidth.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.controlled = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = controlled;

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Validates the a component is fully controlled or uncontrolled.  If the given prop is not
   * `undefined`, it will check if the `funcName` is defined and a function. A missing function
   * will generate an error similar to the built-in React controlled validation message.
   *
   * @param {String} funcName - The function name to use for additional validation.
   * @param {function} validator - The PropTypes validator to use for the given prop.
   * @return {Error} an error or null.
   */
  function controlled(validator, funcName) {
    var fallbackPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'defaultValue';

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!err && typeof props[propName] !== 'undefined' && !props.readOnly && !props.disabled) {
        var _PropTypes$func;

        var funcError = (_PropTypes$func = _propTypes2.default.func).isRequired.apply(_PropTypes$func, [props, funcName, componentName, location, propFullName].concat(args));
        if (funcError) {
          err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' without a ' + ('`' + funcName + '` handler. This will render a read only field. Set either the `' + funcName + '` ') + ('or use the `' + fallbackPropName + '` instead.'));
        }
      }

      return err;
    };
  } /** @module utils/PropTypes/controlled */
});
//# sourceMappingURL=controlled.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.invalidIf = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = invalidIf;
  /** @module utils/PropTypes/invalidIf */

  /**
   * A custom validator that will throw an error if any of the `ifDefinedProps` are also defined.
   *
   * @param {function} validator - The PropTypes validator to use.
   * @param {String...} ifDefinedProps - any othe rprop names to validate against
   * @return {Error} an error or null
   */
  function invalidIf(validator) {
    for (var _len = arguments.length, ifDefinedProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      ifDefinedProps[_key - 1] = arguments[_key];
    }

    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (err) {
        return err;
      }

      var defined = typeof props[propName] !== 'undefined' && !!props[propName];
      var othersDefined = ifDefinedProps.filter(function (name) {
        return typeof props[name] !== 'undefined' && !!props[name];
      });
      if (defined && othersDefined.length) {
        var names = '`' + othersDefined.join('`, `') + '`';
        if (othersDefined.length === 1) {
          return new Error('You provided both a `' + propFullNameSafe + '` and ' + names + ' prop to the ' + componentNameSafe + ' ' + 'but only one can be given.');
        }

        return new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' when ' + ('the following props were defined: ' + names + '. Either remove the `' + propFullNameSafe + '` ') + 'or use the remove all the other props.');
      }

      return null;
    };
  }
});
//# sourceMappingURL=invalidIf.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.minNumber = mod.exports;
  }
})(this, function (exports, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = minNumber;

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Validates the a prop's value is greater than or equal to the minimum value.
   *
   * @param {Number} min - the minimum value for the prop.
   * @param {Boolean} required - Boolean if the prop is required.
   * @return {Error} an error or null.
   */
  function minNumber(min, required) {
    return function validate(props, propName, componentName, location, propFullName) {
      var componentNameSafe = componentName || '<<anonymous>>';
      var propFullNameSafe = propFullName || propName;

      var validator = _propTypes2.default.number;
      if (required) {
        validator = validator.isRequired;
      }

      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        args[_key - 5] = arguments[_key];
      }

      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
      if (!required && !err && props[propName] < min) {
        err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
      }

      return err;
    };
  } /** @module utils/PropTypes/minNumber */
});
//# sourceMappingURL=minNumber.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.addSuffix = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addSuffix;
  /** @module utils/StringUtils/addSuffix */

  /**
   * Optionally adds a suffix to a string if it does
   * not already contain that string.
   *
   * @param {String} str - The string to modify
   * @param {String} suffix - The suffix to add
   *
   * @return {String} the string with a suffix
   */
  function addSuffix(str, suffix) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    return str.indexOf(suffix) === -1 ? str.trim() + ' ' + suffix : str;
  }
});
//# sourceMappingURL=addSuffix.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getField = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getField;
  /** @module utils/getField */

  /**
   * Gets the current field for a component that can the field
   * as either uncontrolled or controlled.
   *
   * @param {Object} props - the props object.
   * @param {Object} state = the state object.
   * @param {string=} field - the field to extract a value from. Defaults to 'value'.
   *
   * @return the field's value.
   */
  function getField(props, state) {
    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';

    return typeof props[field] !== 'undefined' ? props[field] : state[field];
  }
});
//# sourceMappingURL=getField.js.map

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isNodeFound */
/* harmony export (immutable) */ __webpack_exports__["b"] = findHighest;
/* harmony export (immutable) */ __webpack_exports__["a"] = clickedScrollbar;
/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }
  return current.classList.contains(ignoreClass);
}

/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */
function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }

  // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }
    current = current.parentNode;
  }
  return current;
}

/**
 * Check if the browser scrollbar was clicked
 */
function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony export (immutable) */ __webpack_exports__["default"] = onClickOutsideHOC;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_helpers__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uid__ = __webpack_require__(851);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var handlersMap = {};

var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';

/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */
function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(onClickOutside, _Component);

    function onClickOutside() {
      var _temp, _this, _ret;

      _classCallCheck(this, onClickOutside);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);
          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      }, _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined') return;

        var events = _this.props.eventTypes;
        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && __WEBPACK_IMPORTED_MODULE_2__dom_helpers__["a" /* clickedScrollbar */](event)) return;

          var current = event.target;

          if (__WEBPACK_IMPORTED_MODULE_2__dom_helpers__["b" /* findHighest */](current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent) {
            handlerOptions = { passive: !_this.props.preventDefault };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      }, _this.disableOnClickOutside = function () {
        var fn = handlersMap[_this._uid];
        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;
          if (!events.forEach) {
            events = [events];
          }
          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      }, _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
     * Access the WrappedComponent's instance.
     */
    onClickOutside.prototype.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    onClickOutside.prototype.componentDidMount = function componentDidMount() {
      this._uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__uid__["a" /* default */])();
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    onClickOutside.prototype.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };

    /**
     * Remove all document's event listeners for this component
     */


    onClickOutside.prototype.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };

    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Can be called to explicitly disable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    onClickOutside.prototype.render = function render() {
      var _this2 = this;

      var props = Object.keys(this.props).filter(function (prop) {
        return prop !== 'excludeScrollbar';
      }).reduce(function (props, prop) {
        props[prop] = _this2.props[prop];
        return props;
      }, {});

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = 'OnClickOutside(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp2;
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (autoInc());

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deprecated;

var _warning = __webpack_require__(18);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(212);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(859);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(318);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(318);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(860);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(212);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(213);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(213);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(873);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(321);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(874);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(875);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(876);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(877);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(215);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(878);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(214);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(679);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(214);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(215);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(323);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(392), __esModule: true };

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(393), __esModule: true };

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(395), __esModule: true };

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(396), __esModule: true };

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(397), __esModule: true };

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(398), __esModule: true };

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(136);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(330);

var _Async2 = _interopRequireDefault(_Async);

var _Creatable = __webpack_require__(331);

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reduce(obj) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatableSelect = function (_React$Component) {
	_inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		_classCallCheck(this, AsyncCreatableSelect);

		return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	_createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Async2.default,
				this.props,
				function (asyncProps) {
					return _react2.default.createElement(
						_Creatable2.default,
						_this2.props,
						function (creatableProps) {
							return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function onInputChange(input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function ref(_ref) {
									_this2.select = _ref;
									creatableProps.ref(_ref);
									asyncProps.ref(_ref);
								}
							}));
						}
					);
				}
			);
		}
	}]);

	return AsyncCreatableSelect;
}(_react2.default.Component);

;

exports.default = AsyncCreatableSelect;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = function (_React$Component) {
	_inherits(Option, _React$Component);

	function Option(props) {
		_classCallCheck(this, Option);

		var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	_createClass(Option, [{
		key: 'blockEvent',
		value: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = (0, _classnames2.default)(this.props.className, option.className);

			return option.disabled ? _react2.default.createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2.default.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);

	return Option;
}(_react2.default.Component);

;

Option.propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string, // className (based on mouse position)
	instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: _propTypes2.default.bool, // the option is disabled
	isFocused: _propTypes2.default.bool, // the option is focused
	isSelected: _propTypes2.default.bool, // the option is selected
	onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
	onSelect: _propTypes2.default.func, // method to handle click on option element
	onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
	option: _propTypes2.default.object.isRequired, // object that is base for that option
	optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
};

exports.default = Option;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arrowRenderer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2.default.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: _propTypes2.default.func
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(643);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(909);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(101);

var invariant = __webpack_require__(2);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(892);
var ReactElement = __webpack_require__(88);

var emptyFunction = __webpack_require__(30);
var traverseAllChildren = __webpack_require__(902);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(88);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(88),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(291);

module.exports = factory(isValidElement);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(337),
    Component = _require.Component;

var _require2 = __webpack_require__(88),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(340);
var factory = __webpack_require__(634);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(101);

var ReactElement = __webpack_require__(88);

var invariant = __webpack_require__(2);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(101);

var ReactCurrentOwner = __webpack_require__(54);
var REACT_ELEMENT_TYPE = __webpack_require__(339);

var getIteratorFn = __webpack_require__(898);
var invariant = __webpack_require__(2);
var KeyEscapeUtils = __webpack_require__(891);
var warning = __webpack_require__(8);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(342);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(344);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map != 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: {} };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window != 'undefined' && typeof document != 'undefined' && window.document === document;

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        return requestAnimationFrame;
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Detect whether running in IE 11 (facepalm).
var isIE11 = typeof navigator != 'undefined' && /Trident\/.*rv:11/.test(navigator.userAgent);

// MutationObserver should not be used if running in Internet Explorer 11 as it's
// implementation is unreliable. Example: https://jsfiddle.net/x2r3jpuz/2/
//
// It's a real bummer that there is no other way to check for this issue but to
// use the UA information.
var mutationObserverSupported = typeof MutationObserver != 'undefined' && !isIE11;

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    /**
     * Indicates whether DOM listeners have been added.
     *
     * @private {boolean}
     */
    this.connected_ = false;

    /**
     * Tells that controller has subscribed for Mutation Events.
     *
     * @private {boolean}
     */
    this.mutationEventsAdded_ = false;

    /**
     * Keeps reference to the instance of MutationObserver.
     *
     * @private {MutationObserver}
     */
    this.mutationsObserver_ = null;

    /**
     * A list of connected observers.
     *
     * @private {Array<ResizeObserverSPI>}
     */
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName;

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */
ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = Array.prototype.slice.call(arguments, 1);

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement != 'undefined') {
        return function (target) { return target instanceof SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly != 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    /**
     * Broadcasted width of content rectangle.
     *
     * @type {number}
     */
    this.broadcastWidth = 0;

    /**
     * Broadcasted height of content rectangle.
     *
     * @type {number}
     */
    this.broadcastHeight = 0;

    /**
     * Reference to the last observed content rectangle.
     *
     * @private {DOMRectInit}
     */
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    /**
     * Reference to the observed element.
     *
     * @type {Element}
     */
    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    /**
     * Collection of resize observations that have detected changes in dimensions
     * of elements.
     *
     * @private {Array<ResizeObservation>}
     */
    this.activeObservations_ = [];

    /**
     * Registry of the ResizeObservation instances.
     *
     * @private {Map<Element, ResizeObservation>}
     */
    this.observations_ = new MapShim();

    /**
     * Reference to the callback function.
     *
     * @private {ResizeObserverCallback}
     */
    this.callback_ = callback;

    /**
     * Reference to the associated ResizeObserverController.
     *
     * @private {ResizeObserverController}
     */
    this.controller_ = controller;

    /**
     * Public ResizeObserver instance which will be passed to the callback
     * function and used as a value of it's "this" binding.
     *
     * @private {ResizeObserver}
     */
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap != 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = function(callback) {
    if (!(this instanceof ResizeObserver$1)) {
        throw new TypeError('Cannot call a class as a function');
    }

    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof ResizeObserver != 'undefined') {
        // eslint-disable-next-line no-undef
        return ResizeObserver;
    }

    return ResizeObserver$1;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, Buffer) {var require;

/* eslint no-undefined: 0 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var assign = void 0;

if (typeof Object.assign === 'function') {
  assign = Object.assign;
} else {
  assign = function assign(target) {
    if (target === undefined || target === null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var output = Object(target);

    var propertyObjects = [].slice.call(arguments, 1);

    if (propertyObjects.length > 0) {
      propertyObjects.forEach(function (source) {
        if (source !== undefined && source !== null) {
          var nextKey = void 0;

          for (nextKey in source) {
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey];
            }
          }
        }
      });
    }

    return output;
  };
}

var assign$1 = assign;

var includes = void 0;

if (!Array.prototype.includes) {
  includes = function includes(array, searchElement) {
    var ObjectifiedArray = Object(array);
    var length = parseInt(ObjectifiedArray.length, 10) || 0;

    if (length === 0) {
      return false;
    }

    var startIndex = parseInt(arguments[2], 10) || 0;
    var index = void 0;

    if (startIndex >= 0) {
      index = startIndex;
    } else {
      index = length + startIndex;

      if (index < 0) {
        index = 0;
      }
    }

    while (index < length) {
      var currentElement = ObjectifiedArray[index];

      /* eslint no-self-compare:0 */
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        // NaN !== NaN
        return true;
      }
      index++;
    }

    return false;
  };
} else {
  includes = function includes(array) {
    var args = [].slice.call(arguments, 1);

    return Array.prototype.includes.apply(array, args);
  };
}

var includes$1 = includes;

function wrap(func, superFunc) {
  function superWrapper() {
    var originalSuper = this['super'];

    this['super'] = function () {
      return superFunc.apply(this, arguments);
    };

    var ret = func.apply(this, arguments);

    this['super'] = originalSuper;

    return ret;
  }

  superWrapper.wrappedFunction = func;

  return superWrapper;
}

function defineProperties(names, proto, destination) {
  var parentProto = Object.getPrototypeOf(destination);

  names.forEach(function (name) {
    var descriptor = Object.getOwnPropertyDescriptor(proto, name);
    var parentDescriptor = parentProto.hasOwnProperty(name) && Object.getOwnPropertyDescriptor(parentProto, name);

    if (typeof parentDescriptor.value === 'function' && typeof descriptor.value === 'function') {
      var wrappedFunction = wrap(descriptor.value, parentDescriptor.value);

      Object.defineProperty(destination, name, { value: wrappedFunction });
    } else {
      Object.defineProperty(destination, name, descriptor);
    }
  });
}

function createClass(props) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object;

  var Constructor = wrap(props.constructor, parent);
  var instancePropertyNames = Object.getOwnPropertyNames(props).filter(function (key) {
    return !includes$1(['constructor', 'static'], key);
  });

  assign$1(Constructor, parent);

  Constructor.prototype = Object.create(parent.prototype);
  defineProperties(instancePropertyNames, props, Constructor.prototype);
  Constructor.prototype.constructor = Constructor;

  var staticProps = props['static'];

  if (staticProps) {
    var staticPropertyNames = Object.getOwnPropertyNames(staticProps);

    defineProperties(staticPropertyNames, staticProps, Constructor);
  }

  return Constructor;
}

var CoreObject = createClass({
  constructor: function constructor() {},


  'static': {
    extend: function extend(subClassProps) {
      return createClass(subClassProps, this);
    }
  }
});

function wrapConsole(logCommand) {
  var logMethod = function logMethod() {
    var log = void 0;

    /* eslint-disable no-console */
    if (console[logCommand]) {
      log = Function.prototype.bind.call(console[logCommand], console);
    } else {
      log = Function.prototype.bind.call(console.log, console);
    }
    log.apply(undefined, arguments);
    /* eslint-enable no-console */
  };

  return function () {
    var args = [].concat(Array.prototype.slice.call(arguments));

    args.unshift('[JS-BUY-SDK]: ');
    logMethod.apply(undefined, _toConsumableArray(args));
  };
}

var Logger = CoreObject.extend({
  /**
   * Wrapper around the console log so in the future we can have better dev output.
   * Also allows us to disable output in production.
   * @private
   * @class Logger
   * @constructor
   */
  constructor: function constructor() {},

  debug: wrapConsole('debug'),
  info: wrapConsole('info'),
  warn: wrapConsole('warn'),
  error: wrapConsole('error')
});

var logger = new Logger();

var Config = CoreObject.extend({
  constructor: function constructor(attrs) {
    var _this = this;

    Object.keys(this.deprecatedProperties).forEach(function (key) {
      if (attrs.hasOwnProperty(key)) {
        var transformName = _this.deprecatedProperties[key];
        var transform = _this[transformName];

        transform(attrs[key], attrs);
      }
    });
    this.requiredProperties.forEach(function (key) {
      if (!attrs.hasOwnProperty(key)) {
        throw new Error('new Config() requires the option \'' + key + '\'');
      } else {
        _this[key] = attrs[key];
      }
    });
    this.optionalProperties.forEach(function (key) {
      if (attrs.hasOwnProperty(key)) {
        _this[key] = attrs[key];
      }
    });
  },


  /**
   * An object with keys for deprecated properties and values as functions that
   * will transform the value into a usable value. A depracation transform should
   * have the value signature function(deprecated_value, config_to_be_transformed)
   * @attribute deprecatedProperties
   * @default { apiKey: this.transformApiKey, myShopifyDomain: this.transformMyShopifyDomain }
   * @type Object
   * @private
   */
  deprecatedProperties: {
    apiKey: 'transformApiKey',
    myShopifyDomain: 'transformMyShopifyDomain'
  },

  /**
   * Transform the myShopifyDomain config to a domain config.
   * @method transformMyShopifyDomain
   * @static
   * @private
   * @param {String} subdomain The original subdomain on myshopify.com
   * @param {Object} attrs. The config attributes to be transformed to a
   * non-deprecated state.
   * @return {Object} the transformed config attributes.
   */
  transformMyShopifyDomain: function transformMyShopifyDomain(subdomain, attrs) {
    logger.warn('Config - ', 'myShopifyDomain is deprecated, please use domain and provide the full shop domain.');
    attrs.domain = subdomain + '.myshopify.com';
  },


  /**
   * Transform the apiKey config to an accessToken config.
   * @method transformApiKey
   * @static
   * @private
   * @param {String} apiKey The original api key
   * @param {Object} attrs. The config attributes to be transformed to a
   * non-deprecated state.
   * @return {Object} the transformed config attributes.
   */
  transformApiKey: function transformApiKey(apiKey, attrs) {
    logger.warn('Config - ', 'apiKey is deprecated, please use accessToken instead.');
    attrs.accessToken = apiKey;
  },


  /**
   * Properties that must be set on initializations
   * @attribute requiredProperties
   * @default ['accessToken', 'appId', 'myShopifyDomain']
   * @type Array
   * @private
   */
  requiredProperties: ['accessToken', 'appId', 'domain'],

  /**
   * Properties that may be set on initializations
   * @attribute optionalProperties
   * @default ['ajaxHeaders']
   * @type Array
   * @private
   */
  optionalProperties: ['ajaxHeaders'],

  /**
   * The accessToken for authenticating against shopify. This is your api client's
   * storefront access token. Not the shared secret. Set during initialization.
   * @attribute accessToken
   * @default ''
   * @type String
   * @private
   */
  accessToken: '',

  /**
   * The apiKey for authenticating against shopify. This is your api client's
   * public api token. Not the shared secret. Set during initialization.
   * @attribute apiKey
   * @default ''
   * @type String
   * @private
   * @deprecated Use `config.accessToken` instead.
   */
  apiKey: '',

  /**
   * @attribute appId
   * @default ''
   * @type String
   * @private
   */
  appId: '',

  /**
   * The domain that all the api requests will go to
   * @attribute domain
   * @default ''
   * @type String
   * @private
   */
  domain: '',

  /**
   * The subdomain of myshopify.io that all the api requests will go to
   * @attribute myShopifyDomain
   * @default ''
   * @type String
   * @private
   * @deprecated Use `config.domain` instead.
   */
  myShopifyDomain: '',

  /**
   * @attribute ajaxHeaders
   * @default {}
   * @type Object
   * @private
   */
  ajaxHeaders: {}
});

var version = 'v0.7.1-66ba4e4'; // eslint-disable-line

var BaseModel = CoreObject.extend({
  constructor: function constructor() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var metaAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.attrs = attrs;

    assign$1(this, metaAttrs);
  },

  attrs: null,
  serializer: null,
  adapter: null,
  shopClient: null
});

/**
  * Class for product option
  * @class ProductOptionModel
  * @constructor
*/
var ProductOptionModel = BaseModel.extend(Object.defineProperties({
  constructor: function constructor() {
    this['super'].apply(this, arguments);

    this.selected = this.values[0];
  }
}, {
  name: {

    /**
      * name of option. Example values: `"Size"`, `"Color"`, etc.
      * @property name
      * @readOnly
      * @type String
    */
    get: function get() {
      return this.attrs.name;
    },
    configurable: true,
    enumerable: true
  },
  values: {

    /**
      * an Array possible values for option. For instance if this option is a "Size" option an example value
      * for values could be: `["Large", "Medium", "Small"]`
      *
      * @property values
      * @readOnly
      * @type Array
    */
    get: function get() {
      return this.attrs.values;
    },
    configurable: true,
    enumerable: true
  },
  selected: {

    /**
      * get/set the currently selected option value with one of the values from the
      * {{#crossLink "ProductOptionModel/values"}}ProductOptionModel.values{{/crossLink}} array. For
      * instance if the option values array had the following `["Large", "Medium", "Small"]` setting `selected` to be
      * `"Large"`, `"Medium"`, or `"Small"` would be valid any other value would throw an `Error`.
      *
      * @property selected
      * @type String
    */
    get: function get() {
      return this._selected;
    },
    set: function set(value) {
      if (includes$1(this.values, value)) {
        this._selected = value;
      } else {
        throw new Error('Invalid option selection for ' + this.name + '.');
      }

      return value;
    },
    configurable: true,
    enumerable: true
  }
}));

var variants = [{ name: 'pico', dimension: '16x16' }, { name: 'icon', dimension: '32x32' }, { name: 'thumb', dimension: '50x50' }, { name: 'small', dimension: '100x100' }, { name: 'compact', dimension: '160x160' }, { name: 'medium', dimension: '240x240' }, { name: 'large', dimension: '480x480' }, { name: 'grande', dimension: '600x600' }, { name: '1024x1024', dimension: '1024x1024' }, { name: '2048x2048', dimension: '2048x2048' }];

/**
* Class for image model
* @class ImageModel
*/
var ImageModel = CoreObject.extend(Object.defineProperties({
  constructor: function constructor(attrs) {
    var _this2 = this;

    Object.keys(attrs).forEach(function (key) {
      _this2[key] = attrs[key];
    });
  }
}, {
  variants: {

    /**
      * Image variants available for an image. An example value of `imageVariant`:
      * ```
      * [
      *   {
      *     "name": "pico",
      *     "dimensions": "16x16",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
      *   },
      *   {
      *     "name": "compact",
      *     "dimensions": "160x160",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
      *   }
      * ]
      * ```
      *
      * @attribute variants
      * @type {Array}
    */
    get: function get() {
      var src = this.src;
      var extensionIndex = src.lastIndexOf('.');
      var pathAndBasename = src.slice(0, extensionIndex);
      var extension = src.slice(extensionIndex);

      variants.forEach(function (variant) {
        variant.src = pathAndBasename + '_' + variant.name + extension;
      });

      return variants;
    },
    configurable: true,
    enumerable: true
  }
}));

/**
  * Model for product variant
  * @class ProductVariantModel
  * @constructor
*/
var ProductVariantModel = BaseModel.extend(Object.defineProperties({
  constructor: function constructor() {
    this['super'].apply(this, arguments);
  },


  /**
    * Get a checkout url for a specific product variant. You can
    * optionally pass a quantity. If no quantity is passed then quantity
    * will default to 1. The example below will grab a checkout url for
    * 3 copies of the first variant:
    * ```
    * const checkoutURL = product.variants[ 0 ].checkoutUrl(3);
    * ```
    *
    * @method checkoutUrl
    * @param {Number} [quantity = 1] quantity of variants
    * @public
    * @return {String} Checkout URL
  */
  checkoutUrl: function checkoutUrl() {
    var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var config = this.config;
    var baseUrl = 'https://' + config.domain + '/cart';

    var variantPath = this.id + ':' + parseInt(quantity, 10);

    var query = 'access_token=' + config.accessToken + '&_fd=0';

    return baseUrl + '/' + variantPath + '?' + query;
  }
}, {
  id: {

    /**
      * Variant unique ID
      * @property id
      * @type {String}
    */
    get: function get() {
      return this.attrs.variant.id;
    },
    configurable: true,
    enumerable: true
  },
  productId: {

    /**
      * ID of product variant belongs to
      * @property productId
      * @type {String}
    */
    get: function get() {
      return this.attrs.product.id;
    },
    configurable: true,
    enumerable: true
  },
  title: {

    /**
      * Title of variant
      * @property title
      * @type {String}
    */
    get: function get() {
      return this.attrs.variant.title;
    },
    configurable: true,
    enumerable: true
  },
  productTitle: {

    /**
      * Title of product variant belongs to
      * @property productTitle
      * @type {String}
    */
    get: function get() {
      return this.attrs.product.title;
    },
    configurable: true,
    enumerable: true
  },
  compareAtPrice: {

    /**
      * Compare at price for variant. The `compareAtPrice` would be
      * the price of the product previously before the product went on sale. For more info
      * go <a href="https://docs.shopify.com/manual/products/promoting-marketing/sales" target="_blank">here</a>.
      *
      * If no `compareAtPrice` is set then this value will be `null`. An example value: `"5.00"`
      * @property compareAtPrice
      * @type {String}
    */
    get: function get() {
      return this.attrs.variant.compare_at_price;
    },
    configurable: true,
    enumerable: true
  },
  price: {

    /**
      * Price of the variant. The price will be in the following form: `"10.00"`
      *
      * @property price
      * @type {String}
    */
    get: function get() {
      return this.attrs.variant.price;
    },
    configurable: true,
    enumerable: true
  },
  formattedPrice: {

    /**
      * Price of variant, formatted according to shop currency format string.
      * For instance `"$10.00"`
      *
      * @property formattedPrice
      * @type {String}
    */
    get: function get() {
      return this.attrs.variant.formatted_price;
    },
    configurable: true,
    enumerable: true
  },
  grams: {

    /**
      * Variant weight in grams. If no weight is defined grams will be `0`.
      * @property grams
      * @type {Number}
    */
    get: function get() {
      return this.attrs.variant.grams;
    },
    configurable: true,
    enumerable: true
  },
  optionValues: {

    /**
      * Option values associated with this variant. Example `optionValues`:
      * ```
      * [
      *   {
      *     "name": "Size",
      *     "option_id": 9165336518,
      *     "value": "small"
      *   },
      *   {
      *     "name": "Color",
      *     "option_id": 9640532358,
      *     "value": "blue"
      *   }
      * ]
      * ````
      *
      * @property optionValues
      * @type {Array|Object}
    */
    get: function get() {
      return this.attrs.variant.option_values;
    },
    configurable: true,
    enumerable: true
  },
  available: {

    /**
      * Variant in stock. Always `true` if inventory tracking is disabled.
      * @property available
      * @type {Boolean}
    */
    get: function get() {
      return this.attrs.variant.available;
    },
    configurable: true,
    enumerable: true
  },
  image: {

    /**
      * Image for variant. An example image `Object`:
      * ```
      * {
      *   created_at: "2016-08-29T12:35:09-04:00",
      *   id: 17690553350,
      *   position: 1,
      *   product_id: 8291029446,
      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
      *   updated_at: "2016-08-29T12:35:09-04:00",
      *   variant_ids: [ 27690103238 ]
      * }
      * ```
      *
      * @property image
      * @type {Object}
    */
    get: function get() {
      var id = this.id;
      var images = this.attrs.product.images;

      var primaryImage = images[0];
      var variantImage = images.filter(function (image) {
        return image.variant_ids.indexOf(id) !== -1;
      })[0];

      var image = variantImage || primaryImage;

      if (!image) {
        return null;
      }

      return new ImageModel(image);
    },
    configurable: true,
    enumerable: true
  },
  imageVariants: {

    /**
      * Image variants available for a variant. An example value of `imageVariant`:
      * ```
      * [
      *   {
      *     "name": "pico",
      *     "dimensions": "16x16",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
      *   },
      *   {
      *     "name": "compact",
      *     "dimensions": "160x160",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
      *   }
      * ]
      * ```
      *
      * @property imageVariant
      * @type {Array}
    */
    get: function get() {
      if (!this.image) {
        return [];
      }

      return this.image.variants;
    },
    configurable: true,
    enumerable: true
  }
}));

var uniq = function uniq(array) {
  return array.reduce(function (uniqueArray, item) {
    if (uniqueArray.indexOf(item) < 0) {
      uniqueArray.push(item);
    }

    return uniqueArray;
  }, []);
};

var NO_IMAGE_URI = 'https://widgets.shopifyapps.com/assets/no-image.svg';

/**
   * Class for products returned by fetch('product')
   * @class ProductModel
   * @constructor
 */
var ProductModel = BaseModel.extend(Object.defineProperties({
  constructor: function constructor() {
    this['super'].apply(this, arguments);
  }
}, {
  id: {

    /**
      * Product unique ID
      *
      * @property id
      * @type {String}
    */
    get: function get() {
      return this.attrs.product_id;
    },
    configurable: true,
    enumerable: true
  },
  title: {

    /**
      * The product title
      * @property title
      * @type {String}
    */
    get: function get() {
      return this.attrs.title;
    },
    configurable: true,
    enumerable: true
  },
  description: {

    /**
      * A product description.
      * @property description
      * @type {String}
    */
    get: function get() {
      return this.attrs.body_html;
    },
    configurable: true,
    enumerable: true
  },
  images: {

    /**
      * An `Array` of `Objects` that contain meta data about an image including `src` of the images.
      *
      * An example image `Object`:
      * ```
      * {
      *   created_at: "2016-08-29T12:35:09-04:00",
      *   id: 17690553350,
      *   position: 1,
      *   product_id: 8291029446,
      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
      *   updated_at: "2016-08-29T12:35:09-04:00",
      *   variant_ids: [ 27690103238 ]
      * }
      * ```
      * @property images
      * @type {Array} array of image objects.
    */
    get: function get() {
      return this.attrs.images.map(function (image) {
        return new ImageModel(image);
      });
    },
    configurable: true,
    enumerable: true
  },
  memoized: {
    get: function get() {
      this._memoized = this._memoized || {};

      return this._memoized;
    },
    configurable: true,
    enumerable: true
  },
  options: {

    /**
     *  Get an array of {{#crossLink "ProductOptionModel"}}ProductOptionModels{{/crossLink}}.
     *  {{#crossLink "ProductOptionModel"}}ProductOptionModels{{/crossLink}} can be used to
     *  define the currently `selectedVariant` from which you can get a checkout url
     *  ({{#crossLink "ProductVariantModel/checkoutUrl"}}ProductVariantModel.checkoutUrl{{/crossLink}}) or can
     *  be added to a cart ({{#crossLink "CartModel/createLineItemsFromVariants"}}CartModel.createLineItemsFromVariants{{/crossLink}}).
     *
     *  Below is an example on how to create html for option selections:
     * ```javascript
     *  // the following will create an Array of HTML to create multiple select inputs
     *  // global callbacks are also created which will set the option as selected
     *  var elements = product.options.map(function(option) {
     *    // we'll create a callback in global scope
     *    // which will be called when the select's value changes
     *    var callBackName = option.name + 'onChange';
     *    window[ callBackName ] = function(select) {
     *      // set the products option to be selected
     *      option.selected = select.value;
     *    };
     *
     *    // return a string which will be HTML for the select
     *    return '<select name="' + option.name + '" onchange="'callBackName'(this)">' + option.values.map(function(value) {
     *      return '<option value="' + value + '">' + value + '</option>';
     *    }) + '</select>';
     *  });
     * ```
     *
     * @property options
     * @type {Array|ProductOptionModel}
     */
    get: function get() {
      if (this.memoized.options) {
        return this.memoized.options;
      }

      var baseOptions = this.attrs.options;
      var variants$$1 = this.variants;

      this.memoized.options = baseOptions.map(function (option) {
        var name = option.name;

        var dupedValues = variants$$1.reduce(function (valueList, variant) {
          var optionValueForOption = variant.optionValues.filter(function (optionValue) {
            return optionValue.name === option.name;
          })[0];

          valueList.push(optionValueForOption.value);

          return valueList;
        }, []);

        var values = uniq(dupedValues);

        return new ProductOptionModel({ name: name, values: values });
      });

      return this.memoized.options;
    },
    configurable: true,
    enumerable: true
  },
  variants: {

    /**
      * An `Array` of {{#crossLink "ProductVariantModel"}}ProductVariantModel's{{/crossLink}}
      * @property variants
      * @type {Array|ProductVariantModel} array of ProductVariantModel instances.
    */
    get: function get() {
      var _this3 = this;

      return this.attrs.variants.map(function (variant) {
        return new ProductVariantModel({ variant: variant, product: _this3 }, { config: _this3.config });
      });
    },
    configurable: true,
    enumerable: true
  },
  selections: {

    /**
      * A read only `Array` of Strings represented currently selected option values. eg. `["Large", "Red"]`
      * @property selections
      * @type {Array | String}
    */
    get: function get() {
      return this.options.map(function (option) {
        return option.selected;
      });
    },
    configurable: true,
    enumerable: true
  },
  selectedVariant: {

    /**
      * Retrieve variant for currently selected options. By default the first value in each
      * option is selected which means `selectedVariant` will never be `null`.
      *
      * With a `selectedVariant` you can create checkout url
      * ({{#crossLink "ProductVariantModel/checkoutUrl"}}ProductVariantModel.checkoutUrl{{/crossLink}}) or it can
      * be added to a cart ({{#crossLink "CartModel/createLineItemsFromVariants"}}CartModel.createLineItemsFromVariants{{/crossLink}}).
      *
      * @property selectedVariant
      * @type {ProductVariantModel}
    */
    get: function get() {
      var variantTitle = this.selections.join(' / ');

      return this.variants.filter(function (variant) {
        return variant.title === variantTitle;
      })[0] || null;
    },
    configurable: true,
    enumerable: true
  },
  selectedVariantImage: {

    /**
      * Retrieve image for currently selected variantImage. An example image Object would look like this:
      * ```
      * {
      *   created_at: "2016-08-29T12:35:09-04:00",
      *   id: 17690553350,
      *   position: 1,
      *   product_id: 8291029446,
      *   src: "https://cdn.shopify.com/s/files/1/1019/0495/products/i11_c3334325-2d67-4623-8cd4-0a6b08aa1b83.jpg?v=1472488509",
      *   updated_at: "2016-08-29T12:35:09-04:00",
      *   variant_ids: [ 27690103238 ]
      * }
      * ```
      *
      * @property selectedVariantImage
      * @type {Object}
    */
    get: function get() {
      if (!this.selectedVariant) {
        return null;
      }

      return this.selectedVariant.image;
    },
    configurable: true,
    enumerable: true
  }
}));

var ListingsSerializer = CoreObject.extend({
  constructor: function constructor(config) {
    this.config = config;
  },
  rootKeyForType: function rootKeyForType(type) {
    return type.slice(0, -1) + '_listing';
  },


  models: {
    collections: BaseModel,
    products: ProductModel
  },

  modelForType: function modelForType(type) {
    return this.models[type];
  },
  deserializeSingle: function deserializeSingle(type) {
    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var modelAttrs = singlePayload[this.rootKeyForType(type)];
    var model = this.modelFromAttrs(type, modelAttrs, metaAttrs);

    return model;
  },
  deserializeMultiple: function deserializeMultiple(type) {
    var _this4 = this;

    var collectionPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var models = collectionPayload[this.rootKeyForType(type) + 's'];

    return models.map(function (attrs) {
      var model = _this4.modelFromAttrs(type, attrs, metaAttrs);

      return model;
    });
  },
  modelFromAttrs: function modelFromAttrs(type, attrs, metaAttrs) {
    var Model = this.modelForType(type);

    metaAttrs.config = this.config;

    return new Model(attrs, metaAttrs);
  }
});

function authToUrl(url, opts) {
  var authorization = void 0;

  if (opts.headers) {
    Object.keys(opts.headers).forEach(function (key) {
      if (key.toLowerCase() === 'authorization') {
        authorization = opts.headers[key];
      }
    });
  }

  if (authorization) {
    var hashedKey = authorization.split(' ').slice(-1)[0];

    try {
      var plainKey = atob(hashedKey);

      var newUrl = void 0;

      if (url.indexOf('?') > -1) {
        newUrl = url + '&_x_http_authorization=' + plainKey;
      } else {
        newUrl = url + '?_x_http_authorization=' + plainKey;
      }

      return newUrl;
    } catch (e) {
      // atob choked on non-encoded data. Therefore, not a form of auth we
      // support.
      //
      // NOOP
      //
    }
  }

  /* eslint newline-before-return: 0 */
  return url;
}

function ie9Ajax(method, url, opts) {
  return new Promise(function (resolve, reject) {
    var xdr = new XDomainRequest();

    xdr.onload = function () {
      try {
        var json = JSON.parse(xdr.responseText);

        resolve({ json: json, originalResponse: xdr, isJSON: true });
      } catch (e) {
        resolve({ text: xdr.responseText, originalResponse: xdr, isText: true });
      }
    };

    function handleError() {
      reject(new Error('There was an error with the XDR'));
    }

    xdr.onerror = handleError;
    xdr.ontimeout = handleError;

    xdr.open(method, authToUrl(url, opts));
    xdr.send(opts.data);
  });
}

function isNodeLikeEnvironment() {
  var windowAbsent = typeof window === 'undefined';
  var requirePresent = "function" === 'function';

  return windowAbsent && requirePresent;
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  var error = new Error(response.statusText);

  error.status = response.status;
  error.response = response;
  throw error;
}

function parseResponse(response) {
  return response.json().then(function (json) {
    return { json: json, originalResponse: response, isJSON: true };
  })['catch'](function () {
    var responseClone = response.clone();

    return responseClone.text().then(function (text) {
      return { text: text, originalResponse: responseClone, isText: true };
    });
  });
}

function ajax(method, url) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // we need to check that we're not running in Node
  // before we should check if this is ie9
  if (!isNodeLikeEnvironment()) {
    var xhr = new XMLHttpRequest();

    if (!('withCredentials' in xhr)) {
      return ie9Ajax.apply(undefined, arguments);
    }
  }

  opts.method = method;
  opts.mode = 'cors';

  return fetch(url, opts).then(checkStatus).then(parseResponse);
}

var ListingsAdapter = CoreObject.extend(Object.defineProperties({
  ajax: ajax,

  constructor: function constructor(config) {
    this.config = config;
  },
  pathForType: function pathForType(type) {
    return '/' + type.slice(0, -1) + '_listings';
  },
  buildUrl: function buildUrl(singleOrMultiple, type, idOrQuery) {
    switch (singleOrMultiple) {
      case 'multiple':
        return this.buildMultipleUrl(type, idOrQuery);
      case 'single':
        return this.buildSingleUrl(type, idOrQuery);
      default:
        return '';
    }
  },
  buildMultipleUrl: function buildMultipleUrl(type) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var url = '' + this.baseUrl + this.pathForType(type);
    var paramNames = Object.keys(query);

    if (paramNames.length > 0) {
      var queryString = paramNames.map(function (key) {
        var value = void 0;

        if (Array.isArray(query[key])) {
          value = query[key].join(',');
        } else {
          value = query[key];
        }

        return key + '=' + encodeURIComponent(value);
      }).join('&');

      return url + '?' + queryString;
    }

    return url;
  },
  buildSingleUrl: function buildSingleUrl(type, id) {
    return '' + this.baseUrl + this.pathForType(type) + '/' + id;
  },
  fetchMultiple: function fetchMultiple() /* type, [query] */{
    var url = this.buildUrl.apply(this, ['multiple'].concat(Array.prototype.slice.call(arguments)));

    return this.ajax('GET', url, { headers: this.headers }).then(function (response) {
      return response.json;
    });
  },
  fetchSingle: function fetchSingle() /* type, id */{
    var url = this.buildUrl.apply(this, ['single'].concat(Array.prototype.slice.call(arguments)));

    return this.ajax('GET', url, { headers: this.headers }).then(function (response) {
      return response.json;
    });
  }
}, {
  base64AccessToken: {
    get: function get() {
      return btoa(this.config.accessToken);
    },
    configurable: true,
    enumerable: true
  },
  baseUrl: {
    get: function get() {
      var _config = this.config,
          domain = _config.domain,
          appId = _config.appId;


      return 'https://' + domain + '/api/apps/' + appId;
    },
    configurable: true,
    enumerable: true
  },
  headers: {
    get: function get() {
      return assign$1({}, {
        Authorization: 'Basic ' + this.base64AccessToken,
        'Content-Type': 'application/json',
        'X-SDK-Variant': 'javascript',
        'X-SDK-Version': version

      }, this.config.ajaxHeaders);
    },
    configurable: true,
    enumerable: true
  }
}));

var GUID_KEY = 'shopify-buy-uuid';

/**
 * A cart stores an Array of `CartLineItemModel`'s in it's `lineItems` property.
 * @class CartLineItemModel
 * @constructor
 */
var CartLineItemModel = BaseModel.extend(Object.defineProperties({
  constructor: function constructor() {
    this['super'].apply(this, arguments);
  }
}, {
  id: {

    /**
     * A line item ID.
     * @property id
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs[GUID_KEY];
    },
    configurable: true,
    enumerable: true
  },
  variant_id: {

    /**
     * ID of line item variant.
     * @property variant_id
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs.variant_id;
    },
    configurable: true,
    enumerable: true
  },
  product_id: {

    /**
     * ID of variant's product.
     * @property product_id
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs.product_id;
    },
    configurable: true,
    enumerable: true
  },
  image: {

    /**
     * Variant's image.
     * Example `Object` returned:
     * ```
     * {
     *    "id": 18723183238,
     *    "created_at": "2016-09-14T17:12:12-04:00",
     *    "position": 1,
     *    "updated_at": "2016-09-14T17:12:12-04:00",
     *    "product_id": 8569911558,
     *    "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/Mop__three_different_mop_handles.jpg?v=1473887532",
     *    "variant_ids": []
     *  }
     * ```
     * @property image
     * @readOnly
     * @type {Object}
     */
    get: function get() {
      if (!this.attrs.image) {
        return null;
      }

      return new ImageModel(this.attrs.image);
    },
    configurable: true,
    enumerable: true
  },
  imageVariants: {

    /**
      * Image variants available for a variant. An example value of `imageVariant`:
      * ```
      * [
      *   {
      *     "name": "pico",
      *     "dimensions": "16x16",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_pico.jpg?v=1469046423"
      *   },
      *   {
      *     "name": "compact",
      *     "dimensions": "160x160",
      *     "src": "https://cdn.shopify.com/s/files/1/1019/0495/products/alien_146ef7c1-26e9-4e96-96e6-9d37128d0005_compact.jpg?v=1469046423"
      *   }
      * ]
      * ```
      *
      * @property imageVariant
      * @type {Array}
    */
    get: function get() {
      if (!this.image) {
        return [];
      }

      return this.image.variants;
    },
    configurable: true,
    enumerable: true
  },
  title: {

    /**
     * Product title of variant's parent product.
     * @property title
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs.title;
    },
    configurable: true,
    enumerable: true
  },
  quantity: {

    /**
     * Count of variants to order.
     * @property quantity
     * @type {Number}
     */
    get: function get() {
      return this.attrs.quantity;
    },
    set: function set(value) {
      var parsedValue = parseInt(value, 10);

      if (parsedValue < 0) {
        throw new Error('Quantities must be positive');
      } else if (parsedValue !== parseFloat(value)) {
        /* incidentally, this covers all NaN values, because NaN !== Nan */
        throw new Error('Quantities must be whole numbers');
      }

      this.attrs.quantity = parsedValue;

      return this.attrs.quantity;
    },
    configurable: true,
    enumerable: true
  },
  properties: {

    /**
     * Customization information for a product.
     * <a href="https://help.shopify.com/themes/customization/products/get-customization-information-for-products" target="_blank">
     * See here for more info
     * </a>.
     * @property properties
     * @type {Object}
     * @private
     */
    get: function get() {
      return this.attrs.properties || {};
    },
    set: function set(value) {
      this.attrs.properties = value || {};

      return value;
    },
    configurable: true,
    enumerable: true
  },
  variant_title: {

    /**
     * Title of variant.
     * @property variant_title
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs.variant_title;
    },
    configurable: true,
    enumerable: true
  },
  price: {

    /**
     * Price of the variant. For example: `"5.00"`.
     * @property price
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return this.attrs.price;
    },
    configurable: true,
    enumerable: true
  },
  compare_at_price: {

    /**
      * Compare at price for variant. The `compareAtPrice` would be
      * the price of the product previously before the product went on sale. For more info
      * go <a href="https://docs.shopify.com/manual/products/promoting-marketing/sales" target="_blank">here</a>.
      *
      * If no `compareAtPrice` is set then this value will be `null`. An example value: `"5.00"`.
      * @property compareAtPrice
      * @readOnly
      * @type {String}
    */
    get: function get() {
      return this.attrs.compare_at_price;
    },
    configurable: true,
    enumerable: true
  },
  line_price: {

    /**
     * The total price for this line item. For instance if the variant costs `1.50` and you have a quantity
     * of 2 then `line_price` will be `3.00`.
     * @property line_price
     * @readOnly
     * @type {String}
     */
    get: function get() {
      return (this.quantity * parseFloat(this.price)).toFixed(2);
    },
    configurable: true,
    enumerable: true
  },
  grams: {

    /**
     * Variant's weight in grams. If no weight is set then `0` is returned.
     * @property grams
     * @readOnly
     * @type {Number}
     */
    get: function get() {
      return this.attrs.grams;
    },
    configurable: true,
    enumerable: true
  }
}));

/* eslint no-undefined: 0 complexity: 0 */
var GUID_PREFIX = 'shopify-buy.' + Date.now();

var GUID_DESC = {
  writable: true,
  configurable: true,
  enumerable: true,
  value: null
};

var uuidSeed = 0;

function uuid() {
  return ++uuidSeed;
}

var numberCache = {};
var stringCache = {};

function setGuidFor(obj) {
  if (obj && obj[GUID_KEY]) {
    return obj[GUID_KEY];
  }

  if (obj === undefined) {
    return '(undefined)';
  }

  if (obj === null) {
    return '(null)';
  }

  var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
  var id = void 0;

  switch (type) {
    case 'number':
      id = numberCache[obj];

      if (!id) {
        id = numberCache[obj] = 'nu' + obj;
      }

      break;

    case 'string':
      id = stringCache[obj];

      if (!id) {
        id = stringCache[obj] = 'st' + uuid();
      }

      break;

    case 'boolean':
      if (obj) {
        id = '(true)';
      } else {
        id = '(false)';
      }

      break;

    default:
      if (obj === Object) {
        id = '(Object)';
        break;
      }

      if (obj === Array) {
        id = '(Array)';
        break;
      }

      id = GUID_PREFIX + '.' + uuid();

      if (obj[GUID_KEY] === null) {
        obj[GUID_KEY] = id;
      } else {
        GUID_DESC.value = id;
        Object.defineProperty(obj, GUID_KEY, GUID_DESC);
      }
  }

  return id;
}

/* global global */

var globalNamespace = void 0;

if (typeof global === 'undefined') {
  globalNamespace = window;
} else {
  globalNamespace = global;
}

function set(key, value) {
  if (!globalNamespace[key]) {
    globalNamespace[key] = value;
  }
}

function get(key) {
  return globalNamespace[key];
}

var globalVars = { set: set, get: get };

function objectsEqual(one, two) {
  if (one === two) {
    return true;
  }

  return Object.keys(one).every(function (key) {
    if (one[key] instanceof Date) {
      return one[key].toString() === two[key].toString();
    } else if (_typeof(one[key]) === 'object') {
      return objectsEqual(one[key], two[key]);
    }

    return one[key] === two[key];
  });
}

/**
* Class for cart model
* @class CartModel
*/
var CartModel = BaseModel.extend(Object.defineProperties({
  constructor: function constructor() {
    this['super'].apply(this, arguments);
  },


  /**
    * Add items to the cart. Updates cart's `lineItems` based on variants passed in.
    * ```javascript
    * cart.addVariants({variant: variantObject, quantity: 1}).then(cart => {
    *   // the cart has created line items
    * });
    * ```
    * @deprecated `createLineItemsFromVariants` will be used in the future as it's more descriptive
    * @method addVariants
    * @param {Object} item - One or more variants
    * @param {ProductVariantModel} item.variant - variant object
    * @param {Number} item.quantity - quantity
    * @param {Object} [moreItems...] - further objects defining `variant` and `quantity` maybe passed in
    * @private
    * @return {Promise|CartModel} - the cart instance.
  */
  addVariants: function addVariants() {
    logger.warn('CartModel - ', 'addVariants is deprecated, please use createLineItemsFromVariants instead');

    return this.createLineItemsFromVariants.apply(this, arguments);
  },


  /**
    * Add items to the cart. Updates cart's `lineItems` based on variants passed in.
    * ```javascript
    * cart.createLineItemsFromVariants({variant: variantObject, quantity: 1}).then(cart => {
    *   // the cart has created line items
    * });
    * ```
    * @method createLineItemsFromVariants
    * @param {Object} item - One or more variants
    * @param {ProductVariantModel} item.variant - variant object
    * @param {Number} item.quantity - quantity
    * @param {Object} [moreItems...] - further objects defining `variant` and `quantity` maybe passed in
    * @public
    * @return {Promise|CartModel} - the cart instance.
  */
  createLineItemsFromVariants: function createLineItemsFromVariants() {
    var newLineItems = [].concat(Array.prototype.slice.call(arguments)).map(function (item) {
      var lineItem = {
        image: item.variant.image,
        image_variants: item.variant.imageVariants,
        variant_id: item.variant.id,
        product_id: item.variant.productId,
        title: item.variant.productTitle,
        quantity: parseInt(item.quantity, 10),
        properties: item.properties || {},
        variant_title: item.variant.title,
        price: item.variant.price,
        compare_at_price: item.variant.compareAtPrice,
        grams: item.variant.grams
      };

      setGuidFor(lineItem);

      return lineItem;
    });
    var existingLineItems = this.attrs.line_items;

    existingLineItems.push.apply(existingLineItems, _toConsumableArray(newLineItems));

    var dedupedLineItems = existingLineItems.reduce(function (itemAcc, item) {
      var matchingItem = itemAcc.filter(function (existingItem) {
        return existingItem.variant_id === item.variant_id && objectsEqual(existingItem.properties, item.properties);
      })[0];

      if (matchingItem) {
        matchingItem.quantity = matchingItem.quantity + item.quantity;
      } else {
        itemAcc.push(item);
      }

      return itemAcc;
    }, []);

    // Users may pass negative numbers and remove items. This ensures there's no
    // item with a quantity of zero or less.
    this.attrs.line_items = dedupedLineItems.reduce(function (itemAcc, item) {
      if (item.quantity >= 1) {
        itemAcc.push(item);
      }

      return itemAcc;
    }, []);

    return this.updateModel();
  },


  /**
    * Update a line item quantity based on line item id
    * ```javascript
    * // This example changes the quantity for the first line item to 2
    * const firstLineItemId = cart.lineItems[0].id;
    *
    * cart.updateLineItem(firstLineItemId, 2).then(cart => {
    *   // the cart has updated the line item
    * });
    * ```
    * @method updateLineItem
    * @param {String} id - line item ID
    * @param {Number} quantity - new quantity for line item
    * @throws {Error} if line item with ID is not in cart.
    * @public
    * @return {Promise|CartModel} - the cart instance
  */
  updateLineItem: function updateLineItem(id, quantity) {
    if (quantity < 1) {
      return this.removeLineItem(id);
    }

    var lineItem = this.lineItems.filter(function (item) {
      return item.id === id;
    })[0];

    if (lineItem) {
      lineItem.quantity = quantity;

      return this.updateModel();
    }

    return new Promise(function (resolve, reject) {
      reject(new Error('line item with id: ' + id + ' not found in cart#' + this.id));
    });
  },


  /**
    * Remove a line item from cart based on line item id
    * ```javascript
    * // This example removes the first line item
    * const firstLineItemId = cart.lineItems[0].id;
    *
    * cart.removeLineItem(firstLineItemId).then(cart => {
    *   // the cart has removed the line item
    * });
    * ```
    *
    * @method removeLineItem
    * @param {String} id - line item ID
    * @throws {Error} if line item with ID is not in cart.
    * @public
    * @return {Promise|CartModel} - the cart instance
  */
  removeLineItem: function removeLineItem(id) {
    var oldLength = this.lineItems.length;
    var newLineItems = this.lineItems.filter(function (item) {
      return item.id !== id;
    });
    var newLength = newLineItems.length;

    if (newLength < oldLength) {
      this.attrs.line_items = newLineItems.map(function (item) {
        return item.attrs;
      });

      return this.updateModel();
    }

    return new Promise(function (resolve, reject) {
      reject(new Error('line item with id: ' + id + ' not found in cart#' + this.id));
    });
  },


  /**
    * Remove all line items from cart
    * ```javascript
    * // This example removes all line items from the cart
    * cart.clearLineItems().then(cart => {
    *   // the cart has removed all line items
    * });
    * @method clearLineItems
    * @public
    * @return {Promise|CartModel} - the cart instance
  */
  clearLineItems: function clearLineItems() {
    this.attrs.line_items = [];

    return this.updateModel();
  },


  /**
    * Force update of cart model on server. This function will only be used in advanced situations and does not need to be called
    * explicitly to update line items. It is automatically called after
    * {{#crossLink "CartModel/createLineItemsFromVariants"}}{{/crossLink}},
    * {{#crossLink "CartModel/updateLineItem"}}{{/crossLink}},
    * {{#crossLink "CartModel/removeLineItem"}}{{/crossLink}},
    * and {{#crossLink "CartModel/removeLineItem"}}{{/crossLink}}
    *
    * @method updateModel
    * @public
    * @return {Promise|CartModel} - the cart instance
  */
  updateModel: function updateModel() {
    var _this5 = this;

    return this.shopClient.update('carts', this).then(function (updateCart) {
      assign$1(_this5.attrs, updateCart.attrs);

      return _this5;
    });
  }
}, {
  id: {

    /**
      * get ID for current cart
      * @property id
      * @readOnly
      * @type {String}
    */
    get: function get() {
      return this.attrs[GUID_KEY];
    },
    configurable: true,
    enumerable: true
  },
  lineItems: {

    /**
      * Get an `Array` of {{#crossLink "CartLineItemModel"}}CartLineItemModel's{{/crossLink}}
      * @property lineItems
      * @readOnly
      * @type {Array}
    */
    get: function get() {
      return (this.attrs.line_items || []).map(function (item) {
        return new CartLineItemModel(item);
      });
    },
    configurable: true,
    enumerable: true
  },
  lineItemCount: {

    /**
      * Gets the total quantity of all line items. Example: you've added two variants with quantities 3 and 2. `lineItemCount` will be 5.
      * @property lineItemCount
      * @readOnly
      * @type {Number}
    */
    get: function get() {
      return this.lineItems.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
    },
    configurable: true,
    enumerable: true
  },
  subtotal: {

    /**
      * Get current subtotal price for all line items. Example: two items have been added to the cart that cost $1.25
      * then the subtotal will be `2.50`
      *
      * @property subtotal
      * @readOnly
      * @type {String}
    */
    get: function get() {
      var subtotal = this.lineItems.reduce(function (runningTotal, lineItem) {
        return runningTotal + parseFloat(lineItem.line_price);
      }, 0);

      return subtotal.toFixed(2);
    },
    configurable: true,
    enumerable: true
  },
  checkoutUrl: {

    /**
      * Get checkout URL for current cart
      * @property checkoutUrl
      * @readOnly
      * @type {String}
    */
    get: function get() {
      var config = this.config;
      var baseUrl = 'https://' + config.domain + '/cart';
      var ga = globalVars.get('ga');

      var variantPath = this.lineItems.map(function (item) {
        return item.variant_id + ':' + item.quantity;
      });

      var query = 'access_token=' + config.accessToken + '&_fd=0';

      if (typeof ga === 'function') {
        var linkerParam = void 0;

        ga(function (tracker) {
          linkerParam = tracker.get('linkerParam');
        });

        if (linkerParam) {
          query += '&' + linkerParam;
        }
      }

      return baseUrl + '/' + variantPath + '?' + query;
    },
    configurable: true,
    enumerable: true
  }
}));

var CartSerializer = CoreObject.extend({
  constructor: function constructor(config) {
    this.config = config;
  },
  rootKeyForType: function rootKeyForType(type) {
    return type.slice(0, -1);
  },
  modelForType: function modelForType() /* type */{
    return CartModel;
  },
  deserializeSingle: function deserializeSingle(type) {
    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var modelAttrs = singlePayload[this.rootKeyForType(type)];
    var model = this.modelFromAttrs(type, modelAttrs, metaAttrs);

    return model;
  },
  modelFromAttrs: function modelFromAttrs(type, attrs, metaAttrs) {
    var Model = this.modelForType(type);

    metaAttrs.config = this.config;

    return new Model(attrs, metaAttrs);
  },
  serialize: function serialize(type, model) {
    var root = this.rootKeyForType(type);
    var payload = {};
    var attrs = assign$1({}, model.attrs);

    payload[root] = attrs;

    delete attrs.attributes;

    Object.keys(attrs).forEach(function (key) {
      var value = attrs[key];

      if (value === null || typeof value === 'string' && value.length === 0) {
        delete attrs[key];
      }
    });

    return payload;
  }
});

var ReferenceModel = BaseModel.extend(Object.defineProperties({

  /**
    * Class for reference model
    * @private
    * @class ReferenceModel
    * @constructor
  */
  constructor: function constructor(attrs) {
    if (Object.keys(attrs).indexOf('referenceId') < 0) {
      throw new Error('Missing key referenceId of reference. References to null are not allowed');
    }

    this['super'].apply(this, arguments);
  }
}, {
  id: {

    /**
      * get the ID for current reference (not what it refers to, but its own unique identifier)
      * @property id
      * @type {String}
    */
    get: function get() {
      return this.attrs[GUID_KEY];
    },
    configurable: true,
    enumerable: true
  },
  referenceId: {
    get: function get() {
      return this.attrs.referenceId;
    },
    set: function set(value) {
      this.attrs.referenceId = value;

      return value;
    },
    configurable: true,
    enumerable: true
  }
}));

var ReferenceSerializer = CoreObject.extend({
  constructor: function constructor(config) {
    this.config = config;
  },
  modelForType: function modelForType() /* type */{
    return ReferenceModel;
  },
  deserializeSingle: function deserializeSingle(type) {
    var singlePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metaAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var Model = this.modelForType(type);

    return new Model(singlePayload, metaAttrs);
  },
  serialize: function serialize(type, model) {
    var attrs = assign$1({}, model.attrs);

    return attrs;
  }
});

var Store = CoreObject.extend({
  constructor: function constructor() {
    this.localStorageAvailable = this.storageAvailable('localStorage');
    this.cache = {};
  },
  setItem: function setItem(key, value) {
    if (this.localStorageAvailable) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      this.cache[key] = value;
    }

    return value;
  },
  getItem: function getItem(key) {
    if (this.localStorageAvailable) {
      var stringValue = localStorage.getItem(key);

      try {
        return JSON.parse(stringValue);
      } catch (e) {
        return null;
      }
    } else {
      return this.cache[key] || null;
    }
  },
  storageAvailable: function storageAvailable(type) {
    try {
      var storage = globalVars.get(type);
      var x = '__storage_test__';

      storage.setItem(x, x);
      storage.removeItem(x);

      return true;
    } catch (e) {
      return false;
    }
  }
});

var LocalStorageAdapter = CoreObject.extend({
  constructor: function constructor() {
    this.store = new Store();
  },
  idKeyForType: function idKeyForType() /* type */{
    return GUID_KEY;
  },
  fetchSingle: function fetchSingle(type, id) {
    var _this6 = this;

    return new Promise(function (resolve, reject) {
      var value = _this6.store.getItem(_this6.storageKey(type, id));

      if (value === null) {
        reject(new Error(type + '#' + id + ' not found'));

        return;
      }

      resolve(value);
    });
  },
  create: function create(type, payload) {
    var _this7 = this;

    return new Promise(function (resolve) {
      var id = _this7.identify(payload);

      _this7.store.setItem(_this7.storageKey(type, id), payload);
      resolve(payload);
    });
  },
  update: function update(type, id, payload) {
    var _this8 = this;

    return new Promise(function (resolve) {
      _this8.store.setItem(_this8.storageKey(type, id), payload);
      resolve(payload);
    });
  },
  storageKey: function storageKey(type, id) {
    return type + '.' + id;
  },
  identify: function identify(payload) {
    var keys = Object.keys(payload);

    if (keys.length === 1 && _typeof(payload[keys[0]]) === 'object') {
      return setGuidFor(payload[keys[0]]);
    }

    return setGuidFor(payload);
  }
});

/**
 * @module shopify-buy
 * @submodule shop-client
 */

function fetchFactory(fetchType, type) {
  var func = void 0;

  switch (fetchType) {
    case 'all':
      func = function func() {
        return this.fetchAll(type);
      };
      break;
    case 'one':
      func = function func() {
        return this.fetch.apply(this, [type].concat(Array.prototype.slice.call(arguments)));
      };
      break;
    case 'query':
      func = function func() {
        return this.fetchQuery.apply(this, [type].concat(Array.prototype.slice.call(arguments)));
      };
      break;
  }

  return func;
}

var ShopClient = CoreObject.extend(Object.defineProperties({
  /**
   * @class ShopClient
   * @constructor
   */
  constructor: function constructor(config) {
    this.config = config;

    this.serializers = {
      products: ListingsSerializer,
      collections: ListingsSerializer,
      carts: CartSerializer,
      references: ReferenceSerializer
    };

    this.adapters = {
      products: ListingsAdapter,
      collections: ListingsAdapter,
      carts: LocalStorageAdapter,
      references: LocalStorageAdapter
    };
  },


  config: null,

  /**
   * Fetch all of a `type`, returning a promise.
   *
   * ```javascript
   * client.fetchAll('products').then(products => {
   *   // do things with products
   * });
   * ```
   *
   * @method fetchAll
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @return {Promise|Array} a promise resolving with an array of `type`
   */
  fetchAll: function fetchAll(type) {
    var _this9 = this;

    var adapter = new this.adapters[type](this.config);

    return adapter.fetchMultiple(type).then(function (payload) {
      return _this9.deserialize(type, payload, adapter, null, { multiple: true });
    });
  },


  /**
   * Fetch one of a `type`, returning a promise.
   *
   * ```javascript
   * client.fetch('products', 123).then(product => {
   *   // do things with the product
   * });
   * ```
   *
   * @method fetch
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @param {String|Number} id a unique identifier
   * @return {Promise|BaseModel} a promise resolving with a single instance of
   * `type` expressed as a `BaseModel`.
   */
  fetch: function fetch(type, id) {
    var _this10 = this;

    var adapter = new this.adapters[type](this.config);

    return adapter.fetchSingle(type, id).then(function (payload) {
      return _this10.deserialize(type, payload, adapter, null, { single: true });
    });
  },


  /**
   * Fetch many of a `type`, that match `query`
   *
   * ```javascript
   * client.fetchQuery('products', { collection_id: 456 }).then(products => {
   *   // do things with the products
   * });
   * ```
   *
   * @method fetchQuery
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @param {Object} query a query sent to the api server.
   * @return {Promise|Array} a promise resolving with an array of `type`.
   */
  fetchQuery: function fetchQuery(type, query) {
    var _this11 = this;

    var adapter = new this.adapters[type](this.config);

    return adapter.fetchMultiple(type, query).then(function (payload) {
      return _this11.deserialize(type, payload, adapter, null, { multiple: true });
    });
  },


  /**
   * Create an instance of `type`, optionally including `modelAttrs`.
   *
   * ```javascript
   * client.create('carts', { line_items: [ ... ] }).then(cart => {
   *   // do things with the cart.
   * });
   * ```
   *
   * @method create
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @param {Object} [modelAttrs={}] attributes representing the internal state
   * of the model to be persisted.
   * @return {Promise|CartModel} a promise resolving with a single instance of
   * `type`
   */
  create: function create(type) {
    var _this12 = this;

    var modelAttrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var adapter = new this.adapters[type](this.config);
    var serializer = new this.serializers[type](this.config);
    var Model = serializer.modelForType(type);
    var model = new Model(modelAttrs, { shopClient: this });
    var attrs = serializer.serialize(type, model);

    return adapter.create(type, attrs).then(function (payload) {
      return _this12.deserialize(type, payload, adapter, serializer, { single: true });
    });
  },


  /**
   * Create an instance of `type`, optionally including `attrs`.
   *
   * ```javascript
   * client.create('carts', { line_items: [ ... ] }).then(cart => {
   *   // do things with the cart.
   * });
   * ```
   *
   * @method update
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @param {BaseModel} updatedModel The model that represents new state to
   * to persist.
   * @return {Promise|CartModel} a promise resolving with a single instance of
   * `type`
   */
  update: function update(type, updatedModel) {
    var _this13 = this;

    var adapter = updatedModel.adapter;
    var serializer = updatedModel.serializer;
    var serializedModel = serializer.serialize(type, updatedModel);
    var id = updatedModel.attrs[adapter.idKeyForType(type)];

    return adapter.update(type, id, serializedModel).then(function (payload) {
      return _this13.deserialize(type, payload, adapter, serializer, { single: true });
    });
  },


  /**
   * Proxy to serializer's deserialize.
   *
   * @method deserialize
   * @private
   * @param {String} type The pluralized name of the type, in lower case.
   * @param {Object} payload The raw payload returned by the adapter.
   * @param {BaseAdapter} adapter The adapter that yielded the payload.
   * @param {BaseSerializer} existingSerializer The serializer to attach. If
   * none is passed, then `this.deserialize` will create one for the type.
   * @param {Object} opts Options that determine which deserialization method to
   * use.
   * @param {Boolean} opts.multiple true when the payload represents multiple
   * models
   * @param {Boolean} opts.single true when the payload represents one model.
   * @return {BaseModel} an instance of `type` reified into a model.
   */
  deserialize: function deserialize(type, payload, adapter, existingSerializer) {
    var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var serializer = existingSerializer || new this.serializers[type](this.config);
    var meta = { shopClient: this, adapter: adapter, serializer: serializer, type: type };
    var serializedPayload = void 0;

    if (opts.multiple) {
      serializedPayload = serializer.deserializeMultiple(type, payload, meta);
    } else {
      serializedPayload = serializer.deserializeSingle(type, payload, meta);
    }

    return serializedPayload;
  },


  /**
    * Creates a {{#crossLink "CartModel"}}CartModel{{/crossLink}} instance.
    *
    * ```javascript
    * client.createCart().then(cart => {
    *   // do something with cart
    * });
    * ```
    *
    * @method createCart
    * @public
    * @return {Promise|CartModel} - new cart instance.
  */
  createCart: function createCart() {
    var userAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var baseAttrs = {
      line_items: []
    };
    var attrs = {};

    assign$1(attrs, baseAttrs);
    assign$1(attrs, userAttrs);

    return this.create('carts', attrs);
  },


  /**
    * Updates an existing {{#crossLink "CartModel"}}CartModel{{/crossLink}} instance and persists it to localStorage.
    *
    * ```javascript
    * client.createCart().then(cart => {
    *   cart.lineItems = [
    *     // ...
    *   ];
    *   client.updateCart(cart);
    * });
    * ```
    *
    * @param {CartModel} updatedCart an updated CartModel
    * @method updateCart
    * @private
    * @return {Promise|CartModel} - updated cart instance.
  */
  updateCart: function updateCart(updatedCart) {
    return this.update('carts', updatedCart);
  },


  /**
   * Retrieve a previously created cart by its key.
   *
   * ```javascript
   * client.fetchCart('shopify-buy.1459804699118.2').then(cart => {
   *   console.log(cart); // The retrieved cart
   * });
   *
   * @method fetchCart
   * @public
   * @param {String} id The cart's unique identifier
   * @return {Promise|CartModel} The cart model.
   *
   */
  fetchCart: fetchFactory('one', 'carts'),

  /**
   * This function will return an `Array` of products from your store
   * ```
   * client.fetchAllProducts()
   * .then(function(products) {
   *   // all products in store
   * });
   * ```
   *
   * @method fetchAllProducts
   * @public
   * @return {Promise|Array} The product models.
   */
  fetchAllProducts: fetchFactory('all', 'products'),

  /**
   * This function will return an `Array` of collections from your store
   * ```
   * client.fetchAllCollections()
   * .then(function(collections) {
   *
   * });
   * ```
   *
   * @method fetchAllCollections
   * @public
   * @return {Promise|Array} The collection models.
   */
  fetchAllCollections: fetchFactory('all', 'collections'),

  /**
   * Fetch one product by its ID.
   *
   * ```javascript
   * client.fetchProduct('8569911558').then(product => {
   *   console.log(product); // The product with an ID of '8569911558'
   * });
   * ```
   *
   * @method fetchProduct
   * @public
   * @param {String|Number} id a unique identifier
   * @return {Promise|BaseModel} The product model with the specified ID.
   */
  fetchProduct: fetchFactory('one', 'products'),

  /**
   * Fetch one collection by its ID.
   *
   * ```javascript
   * client.fetchCollection('336903494').then(collection => {
   *   console.log(collection); // The collection with an ID of '336903494'
   * });
   * ```
   *
   * @method fetchCollection
   * @public
   * @param {String|Number} id a unique identifier
   * @return {Promise|BaseModel} The collection model with the specified ID.
   */
  fetchCollection: fetchFactory('one', 'collections'),

  /**
   * Fetches a list of products matching a specified query.
   *
   * ```javascript
   * client.fetchQueryProducts({ collection_id: '336903494', tag: ['hats'] }).then(products => {
   *   console.log(products); // An array of products in collection '336903494' having the tag 'hats'
   * });
   * ```
   * @method fetchQueryProducts
   * @public
   * @param {Object} query A query sent to the api server containing one or more of:
   *   @param {String|Number} [query.collection_id] The ID of a collection to retrieve products from
   *   @param {Array} [query.tag] A list of tags to filter the products by. Accepts up to 10 tags.
   *   @param {Array} [query.product_ids] A list of product IDs to retrieve
   *   @param {String|Number} [query.page=1] The page offset number of the current lookup (based on the `limit`)
   *   @param {String|Number} [query.limit=50] The number of products to retrieve per page
   *   @param {String} [query.handle] The handle of the product to look up
   *   @param {String} [query.updated_at_min] Products updated since the supplied timestamp (format: 2008-12-31 03:00)
   *   @param {String} [query.sort_by] Will modify how products are ordered. Possible values are:
   *                                   `"updated_at"`, `"best-selling"`, `"title-ascending"`, `"title-descending"`,
   *                                   `"price-descending"`, `"price-ascending"`, `"created-descending"`, `"created-ascending"`,
   *                                   or `"collection-default"`. Using `"collection-default"` means that products will be ordered
   *                                   the using the custom ordering defined in your Shopify Admin. Default value `"collection-default"`.
   * @return {Promise|Array} The product models.
   */
  fetchQueryProducts: fetchFactory('query', 'products'),

  /**
   * Fetches a list of collections matching a specified query.
   *
   * ```javascript
   * client.fetchQueryCollections({page: 2, limit: 20}).then(collections => {
   *   console.log(collections); // An array of collection resources
   * });
   * ```
   *
   * @method fetchQueryCollections
   * @public
   * @param {Object} query a query sent to the api server.
   *   @param {String|Number} [query.page=1] the page offset number of the current lookup (based on the `limit`)
   *   @param {String|Number} [query.limit=50] the number of collections to retrieve per page
   * @return {Promise|Array} The collection models.
   */
  fetchQueryCollections: fetchFactory('query', 'collections'),

  /**
   * This method looks up a reference in localStorage to the most recent cart.
   * If one is not found, creates one. If the cart the reference points to
   * doesn't exist, create one and store the new reference.
   *
   * ```javascript
   * client.fetchRecentCart().then(cart => {
   *  // do stuff with the cart
   * });
   * ```
   *
   * @method fetchRecentCart
   * @public
   * @return {Promise|CartModel} The cart.
   */
  fetchRecentCart: function fetchRecentCart() {
    var _this14 = this;

    return this.fetch('references', this.config.domain + '.recent-cart').then(function (reference) {
      var cartId = reference.referenceId;

      return _this14.fetchCart(cartId);
    })['catch'](function () {
      return _this14.createCart().then(function (cart) {
        var refAttrs = {
          referenceId: cart.id
        };

        refAttrs[GUID_KEY] = _this14.config.domain + '.recent-cart';

        _this14.create('references', refAttrs);

        return cart;
      });
    });
  }
}, {
  serializers: {
    /**
     * @attribute
     * @default {
     *  products: ListingsAdapter,
     *  collections: ListingsAdapter,
     *  carts: CartAdapter
     * }
     * @type Object
     * @protected
     */
    // Prevent leaky state
    get: function get() {
      return assign$1({}, this.shadowedSerializers);
    },
    set: function set(values) {
      this.shadowedSerializers = assign$1({}, values);
    },
    configurable: true,
    enumerable: true
  },
  adapters: {
    get: function get() {
      return assign$1({}, this.shadowedAdapters);
    },
    set: function set(values) {
      this.shadowedAdapters = assign$1({}, values);
    },
    configurable: true,
    enumerable: true
  }
}));

/* globals require */

if (isNodeLikeEnvironment()) {
  /* this indirection is needed because babel throws errors when
   * transpiling require('node-fetch') using `amd` plugin with babel6
   */
  var localRequire = require;
  var _fetch = __webpack_require__(925);

  globalVars.set('fetch', _fetch);
  globalVars.set('Response', _fetch.Response);
}

/* global Buffer */

if (isNodeLikeEnvironment()) {
  globalVars.set('btoa', function (string) {
    return new Buffer(string).toString('base64');
  });
}

/**
 * @module shopify-buy
 * @submodule shopify
 */

/**
 * `ShopifyBuy` only defines one function {{#crossLink "ShopifyBuy/buildClient"}}{{/crossLink}} which can
 * be used to build a {{#crossLink "ShopClient"}}{{/crossLink}} to query your store using the
 * provided
 * {{#crossLink "ShopifyBuy/buildClient/configAttrs:accessToken"}}`accessToken`{{/crossLink}},
 * {{#crossLink "ShopifyBuy/buildClient/configAttrs:appId"}}`appId`{{/crossLink}},
 * and {{#crossLink "ShopifyBuy/buildClient/configAttrs:domain"}}`domain`{{/crossLink}}.
 * @class ShopifyBuy
 * @static
 */
var Shopify = {
  ShopClient: ShopClient,
  Config: Config,
  version: version,
  NO_IMAGE_URI: NO_IMAGE_URI,

  /**
   * Create a ShopClient. This is the main entry point to the SDK.
   *
   * ```javascript
   * const client = ShopifyBuy.buildClient({
   *   accessToken: 'bf081e860bc9dc1ce0654fdfbc20892d',
   *   appId: 6,
   *   myShopifyDomain: 'your-shop-subdomain.myshopify.com', //Deprecated. Use `domain` instead
   *   domain: 'embeds.myshopify.com'
   * });
   * ```
   *
   * @method buildClient
   * @for ShopifyBuy
   * @static
   * @public
   * @param {Object} configAttrs An object of required config data such as: `accessToken`, `appId`, `domain`
   * @param {String} configAttrs.accessToken An access token for your store. Documentation how to get a token:
   *   https://help.shopify.com/api/sdks/custom-storefront/js-buy-sdk/getting-started#generate-javascript-buy-sdk-credentials
   * @param {String} configAttrs.appId Typically will be 6 which is the Buy Button App Id. For more info on App Id see:
   *   https://help.shopify.com/api/sdks/js-buy-sdk/getting-started#app-id
   * @param {String} configAttrs.domain Your shop's full `myshopify.com` domain. For example: `embeds.myshopify.com`
   * @param {String} configAttrs.myShopifyDomain You shop's `myshopify.com` domain. [deprecated Use configAttrs.domain]
   * @return {ShopClient} a client for the shop using your api credentials which you can use to query your store.
   */
  buildClient: function buildClient() {
    var configAttrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var config = new this.Config(configAttrs);

    return new this.ShopClient(config);
  }
};

module.exports = Shopify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(381).Buffer))

/***/ }),
/* 911 */
/***/ (function(module, exports) {

/*! http://mths.be/repeat v0.2.0 by @mathias */
if (!String.prototype.repeat) {
	(function() {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function() {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch(error) {}
			return result;
		}());
		var repeat = function(count) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			// `ToInteger`
			var n = count ? Number(count) : 0;
			if (n != n) { // better `isNaN`
				n = 0;
			}
			// Account for out-of-bounds indices
			if (n < 0 || n == Infinity) {
				throw RangeError();
			}
			var result = '';
			while (n) {
				if (n % 2 == 1) {
					result += string;
				}
				if (n > 1) {
					string += string;
				}
				n >>= 1;
			}
			return result;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'repeat', {
				'value': repeat,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.repeat = repeat;
		}
	}());
}


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(913);


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(914);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(348)(module)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={166:{"value":"00A6","name":"BROKEN BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BROKEN VERTICAL BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\xA6"},169:{"value":"00A9","name":"COPYRIGHT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\xA9"},174:{"value":"00AE","name":"REGISTERED SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"REGISTERED TRADE MARK SIGN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\xAE"},176:{"value":"00B0","name":"DEGREE SIGN","category":"So","class":"0","bidirectional_category":"ET","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\xB0"},1154:{"value":"0482","name":"CYRILLIC THOUSANDS SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0482"},1421:{"value":"058D","name":"RIGHT-FACING ARMENIAN ETERNITY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u058D"},1422:{"value":"058E","name":"LEFT-FACING ARMENIAN ETERNITY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u058E"},1550:{"value":"060E","name":"ARABIC POETIC VERSE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u060E"},1551:{"value":"060F","name":"ARABIC SIGN MISRA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u060F"},1758:{"value":"06DE","name":"ARABIC START OF RUB EL HIZB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u06DE"},1769:{"value":"06E9","name":"ARABIC PLACE OF SAJDAH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u06E9"},1789:{"value":"06FD","name":"ARABIC SIGN SINDHI AMPERSAND","category":"So","class":"0","bidirectional_category":"AL","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u06FD"},1790:{"value":"06FE","name":"ARABIC SIGN SINDHI POSTPOSITION MEN","category":"So","class":"0","bidirectional_category":"AL","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u06FE"},2038:{"value":"07F6","name":"NKO SYMBOL OO DENNEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u07F6"},2554:{"value":"09FA","name":"BENGALI ISSHAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u09FA"},2928:{"value":"0B70","name":"ORIYA ISSHAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0B70"},3059:{"value":"0BF3","name":"TAMIL DAY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF3"},3060:{"value":"0BF4","name":"TAMIL MONTH SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF4"},3061:{"value":"0BF5","name":"TAMIL YEAR SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF5"},3062:{"value":"0BF6","name":"TAMIL DEBIT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF6"},3063:{"value":"0BF7","name":"TAMIL CREDIT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF7"},3064:{"value":"0BF8","name":"TAMIL AS ABOVE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BF8"},3066:{"value":"0BFA","name":"TAMIL NUMBER SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0BFA"},3199:{"value":"0C7F","name":"TELUGU SIGN TUUMU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0C7F"},3407:{"value":"0D4F","name":"MALAYALAM SIGN PARA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0D4F"},3449:{"value":"0D79","name":"MALAYALAM DATE MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0D79"},3841:{"value":"0F01","name":"TIBETAN MARK GTER YIG MGO TRUNCATED A","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F01"},3842:{"value":"0F02","name":"TIBETAN MARK GTER YIG MGO -UM RNAM BCAD MA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F02"},3843:{"value":"0F03","name":"TIBETAN MARK GTER YIG MGO -UM GTER TSHEG MA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F03"},3859:{"value":"0F13","name":"TIBETAN MARK CARET -DZUD RTAGS ME LONG CAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F13"},3861:{"value":"0F15","name":"TIBETAN LOGOTYPE SIGN CHAD RTAGS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F15"},3862:{"value":"0F16","name":"TIBETAN LOGOTYPE SIGN LHAG RTAGS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F16"},3863:{"value":"0F17","name":"TIBETAN ASTROLOGICAL SIGN SGRA GCAN -CHAR RTAGS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F17"},3866:{"value":"0F1A","name":"TIBETAN SIGN RDEL DKAR GCIG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1A"},3867:{"value":"0F1B","name":"TIBETAN SIGN RDEL DKAR GNYIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1B"},3868:{"value":"0F1C","name":"TIBETAN SIGN RDEL DKAR GSUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1C"},3869:{"value":"0F1D","name":"TIBETAN SIGN RDEL NAG GCIG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1D"},3870:{"value":"0F1E","name":"TIBETAN SIGN RDEL NAG GNYIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1E"},3871:{"value":"0F1F","name":"TIBETAN SIGN RDEL DKAR RDEL NAG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F1F"},3892:{"value":"0F34","name":"TIBETAN MARK BSDUS RTAGS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F34"},3894:{"value":"0F36","name":"TIBETAN MARK CARET -DZUD RTAGS BZHI MIG CAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F36"},3896:{"value":"0F38","name":"TIBETAN MARK CHE MGO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0F38"},4030:{"value":"0FBE","name":"TIBETAN KU RU KHA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FBE"},4031:{"value":"0FBF","name":"TIBETAN KU RU KHA BZHI MIG CAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FBF"},4032:{"value":"0FC0","name":"TIBETAN CANTILLATION SIGN HEAVY BEAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC0"},4033:{"value":"0FC1","name":"TIBETAN CANTILLATION SIGN LIGHT BEAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC1"},4034:{"value":"0FC2","name":"TIBETAN CANTILLATION SIGN CANG TE-U","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC2"},4035:{"value":"0FC3","name":"TIBETAN CANTILLATION SIGN SBUB -CHAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC3"},4036:{"value":"0FC4","name":"TIBETAN SYMBOL DRIL BU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC4"},4037:{"value":"0FC5","name":"TIBETAN SYMBOL RDO RJE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC5"},4039:{"value":"0FC7","name":"TIBETAN SYMBOL RDO RJE RGYA GRAM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC7"},4040:{"value":"0FC8","name":"TIBETAN SYMBOL PHUR PA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC8"},4041:{"value":"0FC9","name":"TIBETAN SYMBOL NOR BU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FC9"},4042:{"value":"0FCA","name":"TIBETAN SYMBOL NOR BU NYIS -KHYIL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FCA"},4043:{"value":"0FCB","name":"TIBETAN SYMBOL NOR BU GSUM -KHYIL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FCB"},4044:{"value":"0FCC","name":"TIBETAN SYMBOL NOR BU BZHI -KHYIL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FCC"},4046:{"value":"0FCE","name":"TIBETAN SIGN RDEL NAG RDEL DKAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FCE"},4047:{"value":"0FCF","name":"TIBETAN SIGN RDEL NAG GSUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FCF"},4053:{"value":"0FD5","name":"RIGHT-FACING SVASTI SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FD5"},4054:{"value":"0FD6","name":"LEFT-FACING SVASTI SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FD6"},4055:{"value":"0FD7","name":"RIGHT-FACING SVASTI SIGN WITH DOTS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FD7"},4056:{"value":"0FD8","name":"LEFT-FACING SVASTI SIGN WITH DOTS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0FD8"},4254:{"value":"109E","name":"MYANMAR SYMBOL SHAN ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u109E"},4255:{"value":"109F","name":"MYANMAR SYMBOL SHAN EXCLAMATION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u109F"},5008:{"value":"1390","name":"ETHIOPIC TONAL MARK YIZET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1390"},5009:{"value":"1391","name":"ETHIOPIC TONAL MARK DERET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1391"},5010:{"value":"1392","name":"ETHIOPIC TONAL MARK RIKRIK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1392"},5011:{"value":"1393","name":"ETHIOPIC TONAL MARK SHORT RIKRIK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1393"},5012:{"value":"1394","name":"ETHIOPIC TONAL MARK DIFAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1394"},5013:{"value":"1395","name":"ETHIOPIC TONAL MARK KENAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1395"},5014:{"value":"1396","name":"ETHIOPIC TONAL MARK CHIRET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1396"},5015:{"value":"1397","name":"ETHIOPIC TONAL MARK HIDET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1397"},5016:{"value":"1398","name":"ETHIOPIC TONAL MARK DERET-HIDET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1398"},5017:{"value":"1399","name":"ETHIOPIC TONAL MARK KURT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1399"},6464:{"value":"1940","name":"LIMBU SIGN LOO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1940"},6622:{"value":"19DE","name":"NEW TAI LUE SIGN LAE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19DE"},6623:{"value":"19DF","name":"NEW TAI LUE SIGN LAEV","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19DF"},6624:{"value":"19E0","name":"KHMER SYMBOL PATHAMASAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E0"},6625:{"value":"19E1","name":"KHMER SYMBOL MUOY KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E1"},6626:{"value":"19E2","name":"KHMER SYMBOL PII KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E2"},6627:{"value":"19E3","name":"KHMER SYMBOL BEI KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E3"},6628:{"value":"19E4","name":"KHMER SYMBOL BUON KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E4"},6629:{"value":"19E5","name":"KHMER SYMBOL PRAM KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E5"},6630:{"value":"19E6","name":"KHMER SYMBOL PRAM-MUOY KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E6"},6631:{"value":"19E7","name":"KHMER SYMBOL PRAM-PII KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E7"},6632:{"value":"19E8","name":"KHMER SYMBOL PRAM-BEI KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E8"},6633:{"value":"19E9","name":"KHMER SYMBOL PRAM-BUON KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19E9"},6634:{"value":"19EA","name":"KHMER SYMBOL DAP KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19EA"},6635:{"value":"19EB","name":"KHMER SYMBOL DAP-MUOY KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19EB"},6636:{"value":"19EC","name":"KHMER SYMBOL DAP-PII KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19EC"},6637:{"value":"19ED","name":"KHMER SYMBOL DAP-BEI KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19ED"},6638:{"value":"19EE","name":"KHMER SYMBOL DAP-BUON KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19EE"},6639:{"value":"19EF","name":"KHMER SYMBOL DAP-PRAM KOET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19EF"},6640:{"value":"19F0","name":"KHMER SYMBOL TUTEYASAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F0"},6641:{"value":"19F1","name":"KHMER SYMBOL MUOY ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F1"},6642:{"value":"19F2","name":"KHMER SYMBOL PII ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F2"},6643:{"value":"19F3","name":"KHMER SYMBOL BEI ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F3"},6644:{"value":"19F4","name":"KHMER SYMBOL BUON ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F4"},6645:{"value":"19F5","name":"KHMER SYMBOL PRAM ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F5"},6646:{"value":"19F6","name":"KHMER SYMBOL PRAM-MUOY ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F6"},6647:{"value":"19F7","name":"KHMER SYMBOL PRAM-PII ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F7"},6648:{"value":"19F8","name":"KHMER SYMBOL PRAM-BEI ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F8"},6649:{"value":"19F9","name":"KHMER SYMBOL PRAM-BUON ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19F9"},6650:{"value":"19FA","name":"KHMER SYMBOL DAP ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FA"},6651:{"value":"19FB","name":"KHMER SYMBOL DAP-MUOY ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FB"},6652:{"value":"19FC","name":"KHMER SYMBOL DAP-PII ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FC"},6653:{"value":"19FD","name":"KHMER SYMBOL DAP-BEI ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FD"},6654:{"value":"19FE","name":"KHMER SYMBOL DAP-BUON ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FE"},6655:{"value":"19FF","name":"KHMER SYMBOL DAP-PRAM ROC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u19FF"},7009:{"value":"1B61","name":"BALINESE MUSICAL SYMBOL DONG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B61"},7010:{"value":"1B62","name":"BALINESE MUSICAL SYMBOL DENG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B62"},7011:{"value":"1B63","name":"BALINESE MUSICAL SYMBOL DUNG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B63"},7012:{"value":"1B64","name":"BALINESE MUSICAL SYMBOL DANG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B64"},7013:{"value":"1B65","name":"BALINESE MUSICAL SYMBOL DANG SURANG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B65"},7014:{"value":"1B66","name":"BALINESE MUSICAL SYMBOL DING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B66"},7015:{"value":"1B67","name":"BALINESE MUSICAL SYMBOL DAENG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B67"},7016:{"value":"1B68","name":"BALINESE MUSICAL SYMBOL DEUNG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B68"},7017:{"value":"1B69","name":"BALINESE MUSICAL SYMBOL DAING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B69"},7018:{"value":"1B6A","name":"BALINESE MUSICAL SYMBOL DANG GEDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B6A"},7028:{"value":"1B74","name":"BALINESE MUSICAL SYMBOL RIGHT-HAND OPEN DUG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B74"},7029:{"value":"1B75","name":"BALINESE MUSICAL SYMBOL RIGHT-HAND OPEN DAG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B75"},7030:{"value":"1B76","name":"BALINESE MUSICAL SYMBOL RIGHT-HAND CLOSED TUK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B76"},7031:{"value":"1B77","name":"BALINESE MUSICAL SYMBOL RIGHT-HAND CLOSED TAK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B77"},7032:{"value":"1B78","name":"BALINESE MUSICAL SYMBOL LEFT-HAND OPEN PANG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B78"},7033:{"value":"1B79","name":"BALINESE MUSICAL SYMBOL LEFT-HAND OPEN PUNG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B79"},7034:{"value":"1B7A","name":"BALINESE MUSICAL SYMBOL LEFT-HAND CLOSED PLAK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B7A"},7035:{"value":"1B7B","name":"BALINESE MUSICAL SYMBOL LEFT-HAND CLOSED PLUK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B7B"},7036:{"value":"1B7C","name":"BALINESE MUSICAL SYMBOL LEFT-HAND OPEN PING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u1B7C"},8448:{"value":"2100","name":"ACCOUNT OF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0061 002F 0063","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2100"},8449:{"value":"2101","name":"ADDRESSED TO THE SUBJECT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0061 002F 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2101"},8451:{"value":"2103","name":"DEGREE CELSIUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 00B0 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DEGREES CENTIGRADE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2103"},8452:{"value":"2104","name":"CENTRE LINE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"C L SYMBOL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2104"},8453:{"value":"2105","name":"CARE OF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0063 002F 006F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2105"},8454:{"value":"2106","name":"CADA UNA","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0063 002F 0075","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2106"},8456:{"value":"2108","name":"SCRUPLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2108"},8457:{"value":"2109","name":"DEGREE FAHRENHEIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 00B0 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DEGREES FAHRENHEIT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2109"},8468:{"value":"2114","name":"L B BAR SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2114"},8470:{"value":"2116","name":"NUMERO SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 004E 006F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"NUMERO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2116"},8471:{"value":"2117","name":"SOUND RECORDING COPYRIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2117"},8478:{"value":"211E","name":"PRESCRIPTION TAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u211E"},8479:{"value":"211F","name":"RESPONSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u211F"},8480:{"value":"2120","name":"SERVICE MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<super> 0053 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2120"},8481:{"value":"2121","name":"TELEPHONE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0054 0045 004C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"T E L SYMBOL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2121"},8482:{"value":"2122","name":"TRADE MARK SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<super> 0054 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"TRADEMARK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2122"},8483:{"value":"2123","name":"VERSICLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2123"},8485:{"value":"2125","name":"OUNCE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OUNCE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2125"},8487:{"value":"2127","name":"INVERTED OHM SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"MHO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2127"},8489:{"value":"2129","name":"TURNED GREEK SMALL LETTER IOTA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2129"},8494:{"value":"212E","name":"ESTIMATED SYMBOL","category":"So","class":"0","bidirectional_category":"ET","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u212E"},8506:{"value":"213A","name":"ROTATED CAPITAL Q","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u213A"},8507:{"value":"213B","name":"FACSIMILE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0046 0041 0058","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u213B"},8522:{"value":"214A","name":"PROPERTY LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u214A"},8524:{"value":"214C","name":"PER SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u214C"},8525:{"value":"214D","name":"AKTIESELSKAB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u214D"},8527:{"value":"214F","name":"SYMBOL FOR SAMARITAN SOURCE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u214F"},8586:{"value":"218A","name":"TURNED DIGIT TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u218A"},8587:{"value":"218B","name":"TURNED DIGIT THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u218B"},8597:{"value":"2195","name":"UP DOWN ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2195"},8598:{"value":"2196","name":"NORTH WEST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UPPER LEFT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2196"},8599:{"value":"2197","name":"NORTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UPPER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2197"},8600:{"value":"2198","name":"SOUTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LOWER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2198"},8601:{"value":"2199","name":"SOUTH WEST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LOWER LEFT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2199"},8604:{"value":"219C","name":"LEFTWARDS WAVE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT WAVE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u219C"},8605:{"value":"219D","name":"RIGHTWARDS WAVE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT WAVE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u219D"},8606:{"value":"219E","name":"LEFTWARDS TWO HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT TWO HEADED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u219E"},8607:{"value":"219F","name":"UPWARDS TWO HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP TWO HEADED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u219F"},8609:{"value":"21A1","name":"DOWNWARDS TWO HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN TWO HEADED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A1"},8610:{"value":"21A2","name":"LEFTWARDS ARROW WITH TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW WITH TAIL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A2"},8612:{"value":"21A4","name":"LEFTWARDS ARROW FROM BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW FROM BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A4"},8613:{"value":"21A5","name":"UPWARDS ARROW FROM BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP ARROW FROM BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A5"},8615:{"value":"21A7","name":"DOWNWARDS ARROW FROM BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ARROW FROM BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A7"},8616:{"value":"21A8","name":"UP DOWN ARROW WITH BASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A8"},8617:{"value":"21A9","name":"LEFTWARDS ARROW WITH HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW WITH HOOK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21A9"},8618:{"value":"21AA","name":"RIGHTWARDS ARROW WITH HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT ARROW WITH HOOK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21AA"},8619:{"value":"21AB","name":"LEFTWARDS ARROW WITH LOOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW WITH LOOP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21AB"},8620:{"value":"21AC","name":"RIGHTWARDS ARROW WITH LOOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT ARROW WITH LOOP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21AC"},8621:{"value":"21AD","name":"LEFT RIGHT WAVE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21AD"},8623:{"value":"21AF","name":"DOWNWARDS ZIGZAG ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ZIGZAG ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21AF"},8624:{"value":"21B0","name":"UPWARDS ARROW WITH TIP LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP ARROW WITH TIP LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B0"},8625:{"value":"21B1","name":"UPWARDS ARROW WITH TIP RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP ARROW WITH TIP RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B1"},8626:{"value":"21B2","name":"DOWNWARDS ARROW WITH TIP LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ARROW WITH TIP LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B2"},8627:{"value":"21B3","name":"DOWNWARDS ARROW WITH TIP RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ARROW WITH TIP RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B3"},8628:{"value":"21B4","name":"RIGHTWARDS ARROW WITH CORNER DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT ARROW WITH CORNER DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B4"},8629:{"value":"21B5","name":"DOWNWARDS ARROW WITH CORNER LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ARROW WITH CORNER LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B5"},8630:{"value":"21B6","name":"ANTICLOCKWISE TOP SEMICIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B6"},8631:{"value":"21B7","name":"CLOCKWISE TOP SEMICIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B7"},8632:{"value":"21B8","name":"NORTH WEST ARROW TO LONG BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UPPER LEFT ARROW TO LONG BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B8"},8633:{"value":"21B9","name":"LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW TO BAR OVER RIGHT ARROW TO BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21B9"},8634:{"value":"21BA","name":"ANTICLOCKWISE OPEN CIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BA"},8635:{"value":"21BB","name":"CLOCKWISE OPEN CIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BB"},8636:{"value":"21BC","name":"LEFTWARDS HARPOON WITH BARB UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT HARPOON WITH BARB UP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BC"},8637:{"value":"21BD","name":"LEFTWARDS HARPOON WITH BARB DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT HARPOON WITH BARB DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BD"},8638:{"value":"21BE","name":"UPWARDS HARPOON WITH BARB RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP HARPOON WITH BARB RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BE"},8639:{"value":"21BF","name":"UPWARDS HARPOON WITH BARB LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP HARPOON WITH BARB LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21BF"},8640:{"value":"21C0","name":"RIGHTWARDS HARPOON WITH BARB UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT HARPOON WITH BARB UP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C0"},8641:{"value":"21C1","name":"RIGHTWARDS HARPOON WITH BARB DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT HARPOON WITH BARB DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C1"},8642:{"value":"21C2","name":"DOWNWARDS HARPOON WITH BARB RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN HARPOON WITH BARB RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C2"},8643:{"value":"21C3","name":"DOWNWARDS HARPOON WITH BARB LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN HARPOON WITH BARB LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C3"},8644:{"value":"21C4","name":"RIGHTWARDS ARROW OVER LEFTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT ARROW OVER LEFT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C4"},8645:{"value":"21C5","name":"UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP ARROW LEFT OF DOWN ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C5"},8646:{"value":"21C6","name":"LEFTWARDS ARROW OVER RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW OVER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C6"},8647:{"value":"21C7","name":"LEFTWARDS PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT PAIRED ARROWS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C7"},8648:{"value":"21C8","name":"UPWARDS PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP PAIRED ARROWS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C8"},8649:{"value":"21C9","name":"RIGHTWARDS PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT PAIRED ARROWS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21C9"},8650:{"value":"21CA","name":"DOWNWARDS PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN PAIRED ARROWS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21CA"},8651:{"value":"21CB","name":"LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT HARPOON OVER RIGHT HARPOON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21CB"},8652:{"value":"21CC","name":"RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT HARPOON OVER LEFT HARPOON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21CC"},8653:{"value":"21CD","name":"LEFTWARDS DOUBLE ARROW WITH STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"21D0 0338","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT DOUBLE ARROW WITH STROKE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21CD"},8656:{"value":"21D0","name":"LEFTWARDS DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D0"},8657:{"value":"21D1","name":"UPWARDS DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D1"},8659:{"value":"21D3","name":"DOWNWARDS DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D3"},8661:{"value":"21D5","name":"UP DOWN DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D5"},8662:{"value":"21D6","name":"NORTH WEST DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UPPER LEFT DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D6"},8663:{"value":"21D7","name":"NORTH EAST DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UPPER RIGHT DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D7"},8664:{"value":"21D8","name":"SOUTH EAST DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LOWER RIGHT DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D8"},8665:{"value":"21D9","name":"SOUTH WEST DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LOWER LEFT DOUBLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21D9"},8666:{"value":"21DA","name":"LEFTWARDS TRIPLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT TRIPLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DA"},8667:{"value":"21DB","name":"RIGHTWARDS TRIPLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT TRIPLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DB"},8668:{"value":"21DC","name":"LEFTWARDS SQUIGGLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT SQUIGGLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DC"},8669:{"value":"21DD","name":"RIGHTWARDS SQUIGGLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT SQUIGGLE ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DD"},8670:{"value":"21DE","name":"UPWARDS ARROW WITH DOUBLE STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP ARROW WITH DOUBLE STROKE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DE"},8671:{"value":"21DF","name":"DOWNWARDS ARROW WITH DOUBLE STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN ARROW WITH DOUBLE STROKE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21DF"},8672:{"value":"21E0","name":"LEFTWARDS DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT DASHED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E0"},8673:{"value":"21E1","name":"UPWARDS DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP DASHED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E1"},8674:{"value":"21E2","name":"RIGHTWARDS DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT DASHED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E2"},8675:{"value":"21E3","name":"DOWNWARDS DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DOWN DASHED ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E3"},8676:{"value":"21E4","name":"LEFTWARDS ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT ARROW TO BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E4"},8677:{"value":"21E5","name":"RIGHTWARDS ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT ARROW TO BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E5"},8678:{"value":"21E6","name":"LEFTWARDS WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE LEFT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E6"},8679:{"value":"21E7","name":"UPWARDS WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE UP ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E7"},8680:{"value":"21E8","name":"RIGHTWARDS WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E8"},8681:{"value":"21E9","name":"DOWNWARDS WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE DOWN ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21E9"},8682:{"value":"21EA","name":"UPWARDS WHITE ARROW FROM BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE UP ARROW FROM BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21EA"},8683:{"value":"21EB","name":"UPWARDS WHITE ARROW ON PEDESTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21EB"},8684:{"value":"21EC","name":"UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21EC"},8685:{"value":"21ED","name":"UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21ED"},8686:{"value":"21EE","name":"UPWARDS WHITE DOUBLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21EE"},8687:{"value":"21EF","name":"UPWARDS WHITE DOUBLE ARROW ON PEDESTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21EF"},8688:{"value":"21F0","name":"RIGHTWARDS WHITE ARROW FROM WALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21F0"},8689:{"value":"21F1","name":"NORTH WEST ARROW TO CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21F1"},8690:{"value":"21F2","name":"SOUTH EAST ARROW TO CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21F2"},8691:{"value":"21F3","name":"UP DOWN WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u21F3"},8960:{"value":"2300","name":"DIAMETER SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2300"},8961:{"value":"2301","name":"ELECTRIC ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2301"},8962:{"value":"2302","name":"HOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2302"},8963:{"value":"2303","name":"UP ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2303"},8964:{"value":"2304","name":"DOWN ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2304"},8965:{"value":"2305","name":"PROJECTIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2305"},8966:{"value":"2306","name":"PERSPECTIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2306"},8967:{"value":"2307","name":"WAVY LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2307"},8972:{"value":"230C","name":"BOTTOM RIGHT CROP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u230C"},8973:{"value":"230D","name":"BOTTOM LEFT CROP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u230D"},8974:{"value":"230E","name":"TOP RIGHT CROP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u230E"},8975:{"value":"230F","name":"TOP LEFT CROP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u230F"},8976:{"value":"2310","name":"REVERSED NOT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2310"},8977:{"value":"2311","name":"SQUARE LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2311"},8978:{"value":"2312","name":"ARC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2312"},8979:{"value":"2313","name":"SEGMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2313"},8980:{"value":"2314","name":"SECTOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2314"},8981:{"value":"2315","name":"TELEPHONE RECORDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2315"},8982:{"value":"2316","name":"POSITION INDICATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2316"},8983:{"value":"2317","name":"VIEWDATA SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2317"},8984:{"value":"2318","name":"PLACE OF INTEREST SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"COMMAND KEY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2318"},8985:{"value":"2319","name":"TURNED NOT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2319"},8986:{"value":"231A","name":"WATCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231A"},8987:{"value":"231B","name":"HOURGLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231B"},8988:{"value":"231C","name":"TOP LEFT CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231C"},8989:{"value":"231D","name":"TOP RIGHT CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231D"},8990:{"value":"231E","name":"BOTTOM LEFT CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231E"},8991:{"value":"231F","name":"BOTTOM RIGHT CORNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u231F"},8994:{"value":"2322","name":"FROWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2322"},8995:{"value":"2323","name":"SMILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2323"},8996:{"value":"2324","name":"UP ARROWHEAD BETWEEN TWO HORIZONTAL BARS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"ENTER KEY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2324"},8997:{"value":"2325","name":"OPTION KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2325"},8998:{"value":"2326","name":"ERASE TO THE RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DELETE TO THE RIGHT KEY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2326"},8999:{"value":"2327","name":"X IN A RECTANGLE BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CLEAR KEY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2327"},9000:{"value":"2328","name":"KEYBOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2328"},9003:{"value":"232B","name":"ERASE TO THE LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DELETE TO THE LEFT KEY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u232B"},9004:{"value":"232C","name":"BENZENE RING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u232C"},9005:{"value":"232D","name":"CYLINDRICITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u232D"},9006:{"value":"232E","name":"ALL AROUND-PROFILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u232E"},9007:{"value":"232F","name":"SYMMETRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u232F"},9008:{"value":"2330","name":"TOTAL RUNOUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2330"},9009:{"value":"2331","name":"DIMENSION ORIGIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2331"},9010:{"value":"2332","name":"CONICAL TAPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2332"},9011:{"value":"2333","name":"SLOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2333"},9012:{"value":"2334","name":"COUNTERBORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2334"},9013:{"value":"2335","name":"COUNTERSINK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2335"},9014:{"value":"2336","name":"APL FUNCTIONAL SYMBOL I-BEAM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2336"},9015:{"value":"2337","name":"APL FUNCTIONAL SYMBOL SQUISH QUAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2337"},9016:{"value":"2338","name":"APL FUNCTIONAL SYMBOL QUAD EQUAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2338"},9017:{"value":"2339","name":"APL FUNCTIONAL SYMBOL QUAD DIVIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2339"},9018:{"value":"233A","name":"APL FUNCTIONAL SYMBOL QUAD DIAMOND","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233A"},9019:{"value":"233B","name":"APL FUNCTIONAL SYMBOL QUAD JOT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233B"},9020:{"value":"233C","name":"APL FUNCTIONAL SYMBOL QUAD CIRCLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233C"},9021:{"value":"233D","name":"APL FUNCTIONAL SYMBOL CIRCLE STILE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233D"},9022:{"value":"233E","name":"APL FUNCTIONAL SYMBOL CIRCLE JOT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233E"},9023:{"value":"233F","name":"APL FUNCTIONAL SYMBOL SLASH BAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u233F"},9024:{"value":"2340","name":"APL FUNCTIONAL SYMBOL BACKSLASH BAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2340"},9025:{"value":"2341","name":"APL FUNCTIONAL SYMBOL QUAD SLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2341"},9026:{"value":"2342","name":"APL FUNCTIONAL SYMBOL QUAD BACKSLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2342"},9027:{"value":"2343","name":"APL FUNCTIONAL SYMBOL QUAD LESS-THAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2343"},9028:{"value":"2344","name":"APL FUNCTIONAL SYMBOL QUAD GREATER-THAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2344"},9029:{"value":"2345","name":"APL FUNCTIONAL SYMBOL LEFTWARDS VANE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2345"},9030:{"value":"2346","name":"APL FUNCTIONAL SYMBOL RIGHTWARDS VANE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2346"},9031:{"value":"2347","name":"APL FUNCTIONAL SYMBOL QUAD LEFTWARDS ARROW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2347"},9032:{"value":"2348","name":"APL FUNCTIONAL SYMBOL QUAD RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2348"},9033:{"value":"2349","name":"APL FUNCTIONAL SYMBOL CIRCLE BACKSLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2349"},9034:{"value":"234A","name":"APL FUNCTIONAL SYMBOL DOWN TACK UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234A"},9035:{"value":"234B","name":"APL FUNCTIONAL SYMBOL DELTA STILE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234B"},9036:{"value":"234C","name":"APL FUNCTIONAL SYMBOL QUAD DOWN CARET","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234C"},9037:{"value":"234D","name":"APL FUNCTIONAL SYMBOL QUAD DELTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234D"},9038:{"value":"234E","name":"APL FUNCTIONAL SYMBOL DOWN TACK JOT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234E"},9039:{"value":"234F","name":"APL FUNCTIONAL SYMBOL UPWARDS VANE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u234F"},9040:{"value":"2350","name":"APL FUNCTIONAL SYMBOL QUAD UPWARDS ARROW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2350"},9041:{"value":"2351","name":"APL FUNCTIONAL SYMBOL UP TACK OVERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2351"},9042:{"value":"2352","name":"APL FUNCTIONAL SYMBOL DEL STILE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2352"},9043:{"value":"2353","name":"APL FUNCTIONAL SYMBOL QUAD UP CARET","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2353"},9044:{"value":"2354","name":"APL FUNCTIONAL SYMBOL QUAD DEL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2354"},9045:{"value":"2355","name":"APL FUNCTIONAL SYMBOL UP TACK JOT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2355"},9046:{"value":"2356","name":"APL FUNCTIONAL SYMBOL DOWNWARDS VANE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2356"},9047:{"value":"2357","name":"APL FUNCTIONAL SYMBOL QUAD DOWNWARDS ARROW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2357"},9048:{"value":"2358","name":"APL FUNCTIONAL SYMBOL QUOTE UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2358"},9049:{"value":"2359","name":"APL FUNCTIONAL SYMBOL DELTA UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2359"},9050:{"value":"235A","name":"APL FUNCTIONAL SYMBOL DIAMOND UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235A"},9051:{"value":"235B","name":"APL FUNCTIONAL SYMBOL JOT UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235B"},9052:{"value":"235C","name":"APL FUNCTIONAL SYMBOL CIRCLE UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235C"},9053:{"value":"235D","name":"APL FUNCTIONAL SYMBOL UP SHOE JOT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235D"},9054:{"value":"235E","name":"APL FUNCTIONAL SYMBOL QUOTE QUAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235E"},9055:{"value":"235F","name":"APL FUNCTIONAL SYMBOL CIRCLE STAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u235F"},9056:{"value":"2360","name":"APL FUNCTIONAL SYMBOL QUAD COLON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2360"},9057:{"value":"2361","name":"APL FUNCTIONAL SYMBOL UP TACK DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2361"},9058:{"value":"2362","name":"APL FUNCTIONAL SYMBOL DEL DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2362"},9059:{"value":"2363","name":"APL FUNCTIONAL SYMBOL STAR DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2363"},9060:{"value":"2364","name":"APL FUNCTIONAL SYMBOL JOT DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2364"},9061:{"value":"2365","name":"APL FUNCTIONAL SYMBOL CIRCLE DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2365"},9062:{"value":"2366","name":"APL FUNCTIONAL SYMBOL DOWN SHOE STILE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2366"},9063:{"value":"2367","name":"APL FUNCTIONAL SYMBOL LEFT SHOE STILE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2367"},9064:{"value":"2368","name":"APL FUNCTIONAL SYMBOL TILDE DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2368"},9065:{"value":"2369","name":"APL FUNCTIONAL SYMBOL GREATER-THAN DIAERESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2369"},9066:{"value":"236A","name":"APL FUNCTIONAL SYMBOL COMMA BAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236A"},9067:{"value":"236B","name":"APL FUNCTIONAL SYMBOL DEL TILDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236B"},9068:{"value":"236C","name":"APL FUNCTIONAL SYMBOL ZILDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236C"},9069:{"value":"236D","name":"APL FUNCTIONAL SYMBOL STILE TILDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236D"},9070:{"value":"236E","name":"APL FUNCTIONAL SYMBOL SEMICOLON UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236E"},9071:{"value":"236F","name":"APL FUNCTIONAL SYMBOL QUAD NOT EQUAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u236F"},9072:{"value":"2370","name":"APL FUNCTIONAL SYMBOL QUAD QUESTION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2370"},9073:{"value":"2371","name":"APL FUNCTIONAL SYMBOL DOWN CARET TILDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2371"},9074:{"value":"2372","name":"APL FUNCTIONAL SYMBOL UP CARET TILDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2372"},9075:{"value":"2373","name":"APL FUNCTIONAL SYMBOL IOTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2373"},9076:{"value":"2374","name":"APL FUNCTIONAL SYMBOL RHO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2374"},9077:{"value":"2375","name":"APL FUNCTIONAL SYMBOL OMEGA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2375"},9078:{"value":"2376","name":"APL FUNCTIONAL SYMBOL ALPHA UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2376"},9079:{"value":"2377","name":"APL FUNCTIONAL SYMBOL EPSILON UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2377"},9080:{"value":"2378","name":"APL FUNCTIONAL SYMBOL IOTA UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2378"},9081:{"value":"2379","name":"APL FUNCTIONAL SYMBOL OMEGA UNDERBAR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2379"},9082:{"value":"237A","name":"APL FUNCTIONAL SYMBOL ALPHA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u237A"},9083:{"value":"237B","name":"NOT CHECK MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u237B"},9085:{"value":"237D","name":"SHOULDERED OPEN BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u237D"},9086:{"value":"237E","name":"BELL SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u237E"},9087:{"value":"237F","name":"VERTICAL LINE WITH MIDDLE DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u237F"},9088:{"value":"2380","name":"INSERTION SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2380"},9089:{"value":"2381","name":"CONTINUOUS UNDERLINE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2381"},9090:{"value":"2382","name":"DISCONTINUOUS UNDERLINE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2382"},9091:{"value":"2383","name":"EMPHASIS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2383"},9092:{"value":"2384","name":"COMPOSITION SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2384"},9093:{"value":"2385","name":"WHITE SQUARE WITH CENTRE VERTICAL LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2385"},9094:{"value":"2386","name":"ENTER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2386"},9095:{"value":"2387","name":"ALTERNATIVE KEY SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2387"},9096:{"value":"2388","name":"HELM SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2388"},9097:{"value":"2389","name":"CIRCLED HORIZONTAL BAR WITH NOTCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2389"},9098:{"value":"238A","name":"CIRCLED TRIANGLE DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238A"},9099:{"value":"238B","name":"BROKEN CIRCLE WITH NORTHWEST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238B"},9100:{"value":"238C","name":"UNDO SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238C"},9101:{"value":"238D","name":"MONOSTABLE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238D"},9102:{"value":"238E","name":"HYSTERESIS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238E"},9103:{"value":"238F","name":"OPEN-CIRCUIT-OUTPUT H-TYPE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u238F"},9104:{"value":"2390","name":"OPEN-CIRCUIT-OUTPUT L-TYPE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2390"},9105:{"value":"2391","name":"PASSIVE-PULL-DOWN-OUTPUT SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2391"},9106:{"value":"2392","name":"PASSIVE-PULL-UP-OUTPUT SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2392"},9107:{"value":"2393","name":"DIRECT CURRENT SYMBOL FORM TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2393"},9108:{"value":"2394","name":"SOFTWARE-FUNCTION SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2394"},9109:{"value":"2395","name":"APL FUNCTIONAL SYMBOL QUAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2395"},9110:{"value":"2396","name":"DECIMAL SEPARATOR KEY SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2396"},9111:{"value":"2397","name":"PREVIOUS PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2397"},9112:{"value":"2398","name":"NEXT PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2398"},9113:{"value":"2399","name":"PRINT SCREEN SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2399"},9114:{"value":"239A","name":"CLEAR SCREEN SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u239A"},9140:{"value":"23B4","name":"TOP SQUARE BRACKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B4"},9141:{"value":"23B5","name":"BOTTOM SQUARE BRACKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B5"},9142:{"value":"23B6","name":"BOTTOM SQUARE BRACKET OVER TOP SQUARE BRACKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B6"},9143:{"value":"23B7","name":"RADICAL SYMBOL BOTTOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B7"},9144:{"value":"23B8","name":"LEFT VERTICAL BOX LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B8"},9145:{"value":"23B9","name":"RIGHT VERTICAL BOX LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23B9"},9146:{"value":"23BA","name":"HORIZONTAL SCAN LINE-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BA"},9147:{"value":"23BB","name":"HORIZONTAL SCAN LINE-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BB"},9148:{"value":"23BC","name":"HORIZONTAL SCAN LINE-7","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BC"},9149:{"value":"23BD","name":"HORIZONTAL SCAN LINE-9","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BD"},9150:{"value":"23BE","name":"DENTISTRY SYMBOL LIGHT VERTICAL AND TOP RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BE"},9151:{"value":"23BF","name":"DENTISTRY SYMBOL LIGHT VERTICAL AND BOTTOM RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23BF"},9152:{"value":"23C0","name":"DENTISTRY SYMBOL LIGHT VERTICAL WITH CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C0"},9153:{"value":"23C1","name":"DENTISTRY SYMBOL LIGHT DOWN AND HORIZONTAL WITH CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C1"},9154:{"value":"23C2","name":"DENTISTRY SYMBOL LIGHT UP AND HORIZONTAL WITH CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C2"},9155:{"value":"23C3","name":"DENTISTRY SYMBOL LIGHT VERTICAL WITH TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C3"},9156:{"value":"23C4","name":"DENTISTRY SYMBOL LIGHT DOWN AND HORIZONTAL WITH TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C4"},9157:{"value":"23C5","name":"DENTISTRY SYMBOL LIGHT UP AND HORIZONTAL WITH TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C5"},9158:{"value":"23C6","name":"DENTISTRY SYMBOL LIGHT VERTICAL AND WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C6"},9159:{"value":"23C7","name":"DENTISTRY SYMBOL LIGHT DOWN AND HORIZONTAL WITH WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C7"},9160:{"value":"23C8","name":"DENTISTRY SYMBOL LIGHT UP AND HORIZONTAL WITH WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C8"},9161:{"value":"23C9","name":"DENTISTRY SYMBOL LIGHT DOWN AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23C9"},9162:{"value":"23CA","name":"DENTISTRY SYMBOL LIGHT UP AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CA"},9163:{"value":"23CB","name":"DENTISTRY SYMBOL LIGHT VERTICAL AND TOP LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CB"},9164:{"value":"23CC","name":"DENTISTRY SYMBOL LIGHT VERTICAL AND BOTTOM LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CC"},9165:{"value":"23CD","name":"SQUARE FOOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CD"},9166:{"value":"23CE","name":"RETURN SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CE"},9167:{"value":"23CF","name":"EJECT SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23CF"},9168:{"value":"23D0","name":"VERTICAL LINE EXTENSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D0"},9169:{"value":"23D1","name":"METRICAL BREVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D1"},9170:{"value":"23D2","name":"METRICAL LONG OVER SHORT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D2"},9171:{"value":"23D3","name":"METRICAL SHORT OVER LONG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D3"},9172:{"value":"23D4","name":"METRICAL LONG OVER TWO SHORTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D4"},9173:{"value":"23D5","name":"METRICAL TWO SHORTS OVER LONG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D5"},9174:{"value":"23D6","name":"METRICAL TWO SHORTS JOINED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D6"},9175:{"value":"23D7","name":"METRICAL TRISEME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D7"},9176:{"value":"23D8","name":"METRICAL TETRASEME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D8"},9177:{"value":"23D9","name":"METRICAL PENTASEME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23D9"},9178:{"value":"23DA","name":"EARTH GROUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23DA"},9179:{"value":"23DB","name":"FUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23DB"},9186:{"value":"23E2","name":"WHITE TRAPEZIUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E2"},9187:{"value":"23E3","name":"BENZENE RING WITH CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E3"},9188:{"value":"23E4","name":"STRAIGHTNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E4"},9189:{"value":"23E5","name":"FLATNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E5"},9190:{"value":"23E6","name":"AC CURRENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E6"},9191:{"value":"23E7","name":"ELECTRICAL INTERSECTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E7"},9192:{"value":"23E8","name":"DECIMAL EXPONENT SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E8"},9193:{"value":"23E9","name":"BLACK RIGHT-POINTING DOUBLE TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23E9"},9194:{"value":"23EA","name":"BLACK LEFT-POINTING DOUBLE TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23EA"},9195:{"value":"23EB","name":"BLACK UP-POINTING DOUBLE TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23EB"},9196:{"value":"23EC","name":"BLACK DOWN-POINTING DOUBLE TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23EC"},9197:{"value":"23ED","name":"BLACK RIGHT-POINTING DOUBLE TRIANGLE WITH VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23ED"},9198:{"value":"23EE","name":"BLACK LEFT-POINTING DOUBLE TRIANGLE WITH VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23EE"},9199:{"value":"23EF","name":"BLACK RIGHT-POINTING TRIANGLE WITH DOUBLE VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23EF"},9200:{"value":"23F0","name":"ALARM CLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F0"},9201:{"value":"23F1","name":"STOPWATCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F1"},9202:{"value":"23F2","name":"TIMER CLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F2"},9203:{"value":"23F3","name":"HOURGLASS WITH FLOWING SAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F3"},9204:{"value":"23F4","name":"BLACK MEDIUM LEFT-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F4"},9205:{"value":"23F5","name":"BLACK MEDIUM RIGHT-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F5"},9206:{"value":"23F6","name":"BLACK MEDIUM UP-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F6"},9207:{"value":"23F7","name":"BLACK MEDIUM DOWN-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F7"},9208:{"value":"23F8","name":"DOUBLE VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F8"},9209:{"value":"23F9","name":"BLACK SQUARE FOR STOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23F9"},9210:{"value":"23FA","name":"BLACK CIRCLE FOR RECORD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FA"},9211:{"value":"23FB","name":"POWER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FB"},9212:{"value":"23FC","name":"POWER ON-OFF SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FC"},9213:{"value":"23FD","name":"POWER ON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FD"},9214:{"value":"23FE","name":"POWER SLEEP SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FE"},9215:{"value":"23FF","name":"OBSERVER EYE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u23FF"},9216:{"value":"2400","name":"SYMBOL FOR NULL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR NULL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2400"},9217:{"value":"2401","name":"SYMBOL FOR START OF HEADING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR START OF HEADING","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2401"},9218:{"value":"2402","name":"SYMBOL FOR START OF TEXT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR START OF TEXT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2402"},9219:{"value":"2403","name":"SYMBOL FOR END OF TEXT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR END OF TEXT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2403"},9220:{"value":"2404","name":"SYMBOL FOR END OF TRANSMISSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR END OF TRANSMISSION","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2404"},9221:{"value":"2405","name":"SYMBOL FOR ENQUIRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR ENQUIRY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2405"},9222:{"value":"2406","name":"SYMBOL FOR ACKNOWLEDGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR ACKNOWLEDGE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2406"},9223:{"value":"2407","name":"SYMBOL FOR BELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR BELL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2407"},9224:{"value":"2408","name":"SYMBOL FOR BACKSPACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR BACKSPACE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2408"},9225:{"value":"2409","name":"SYMBOL FOR HORIZONTAL TABULATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR HORIZONTAL TABULATION","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2409"},9226:{"value":"240A","name":"SYMBOL FOR LINE FEED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR LINE FEED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240A"},9227:{"value":"240B","name":"SYMBOL FOR VERTICAL TABULATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR VERTICAL TABULATION","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240B"},9228:{"value":"240C","name":"SYMBOL FOR FORM FEED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR FORM FEED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240C"},9229:{"value":"240D","name":"SYMBOL FOR CARRIAGE RETURN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR CARRIAGE RETURN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240D"},9230:{"value":"240E","name":"SYMBOL FOR SHIFT OUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR SHIFT OUT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240E"},9231:{"value":"240F","name":"SYMBOL FOR SHIFT IN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR SHIFT IN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u240F"},9232:{"value":"2410","name":"SYMBOL FOR DATA LINK ESCAPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DATA LINK ESCAPE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2410"},9233:{"value":"2411","name":"SYMBOL FOR DEVICE CONTROL ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DEVICE CONTROL ONE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2411"},9234:{"value":"2412","name":"SYMBOL FOR DEVICE CONTROL TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DEVICE CONTROL TWO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2412"},9235:{"value":"2413","name":"SYMBOL FOR DEVICE CONTROL THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DEVICE CONTROL THREE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2413"},9236:{"value":"2414","name":"SYMBOL FOR DEVICE CONTROL FOUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DEVICE CONTROL FOUR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2414"},9237:{"value":"2415","name":"SYMBOL FOR NEGATIVE ACKNOWLEDGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR NEGATIVE ACKNOWLEDGE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2415"},9238:{"value":"2416","name":"SYMBOL FOR SYNCHRONOUS IDLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR SYNCHRONOUS IDLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2416"},9239:{"value":"2417","name":"SYMBOL FOR END OF TRANSMISSION BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR END OF TRANSMISSION BLOCK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2417"},9240:{"value":"2418","name":"SYMBOL FOR CANCEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR CANCEL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2418"},9241:{"value":"2419","name":"SYMBOL FOR END OF MEDIUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR END OF MEDIUM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2419"},9242:{"value":"241A","name":"SYMBOL FOR SUBSTITUTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR SUBSTITUTE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241A"},9243:{"value":"241B","name":"SYMBOL FOR ESCAPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR ESCAPE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241B"},9244:{"value":"241C","name":"SYMBOL FOR FILE SEPARATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR FILE SEPARATOR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241C"},9245:{"value":"241D","name":"SYMBOL FOR GROUP SEPARATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR GROUP SEPARATOR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241D"},9246:{"value":"241E","name":"SYMBOL FOR RECORD SEPARATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR RECORD SEPARATOR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241E"},9247:{"value":"241F","name":"SYMBOL FOR UNIT SEPARATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR UNIT SEPARATOR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u241F"},9248:{"value":"2420","name":"SYMBOL FOR SPACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR SPACE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2420"},9249:{"value":"2421","name":"SYMBOL FOR DELETE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR DELETE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2421"},9250:{"value":"2422","name":"BLANK SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLANK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2422"},9251:{"value":"2423","name":"OPEN BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2423"},9252:{"value":"2424","name":"SYMBOL FOR NEWLINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"GRAPHIC FOR NEWLINE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2424"},9253:{"value":"2425","name":"SYMBOL FOR DELETE FORM TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2425"},9254:{"value":"2426","name":"SYMBOL FOR SUBSTITUTE FORM TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2426"},9280:{"value":"2440","name":"OCR HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2440"},9281:{"value":"2441","name":"OCR CHAIR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2441"},9282:{"value":"2442","name":"OCR FORK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2442"},9283:{"value":"2443","name":"OCR INVERTED FORK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2443"},9284:{"value":"2444","name":"OCR BELT BUCKLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2444"},9285:{"value":"2445","name":"OCR BOW TIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2445"},9286:{"value":"2446","name":"OCR BRANCH BANK IDENTIFICATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2446"},9287:{"value":"2447","name":"OCR AMOUNT OF CHECK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2447"},9288:{"value":"2448","name":"OCR DASH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2448"},9289:{"value":"2449","name":"OCR CUSTOMER ACCOUNT NUMBER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2449"},9290:{"value":"244A","name":"OCR DOUBLE BACKSLASH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u244A"},9372:{"value":"249C","name":"PARENTHESIZED LATIN SMALL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0061 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u249C"},9373:{"value":"249D","name":"PARENTHESIZED LATIN SMALL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0062 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u249D"},9374:{"value":"249E","name":"PARENTHESIZED LATIN SMALL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0063 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u249E"},9375:{"value":"249F","name":"PARENTHESIZED LATIN SMALL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0064 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u249F"},9376:{"value":"24A0","name":"PARENTHESIZED LATIN SMALL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0065 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A0"},9377:{"value":"24A1","name":"PARENTHESIZED LATIN SMALL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0066 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A1"},9378:{"value":"24A2","name":"PARENTHESIZED LATIN SMALL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0067 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A2"},9379:{"value":"24A3","name":"PARENTHESIZED LATIN SMALL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0068 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A3"},9380:{"value":"24A4","name":"PARENTHESIZED LATIN SMALL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0069 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A4"},9381:{"value":"24A5","name":"PARENTHESIZED LATIN SMALL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006A 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A5"},9382:{"value":"24A6","name":"PARENTHESIZED LATIN SMALL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006B 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A6"},9383:{"value":"24A7","name":"PARENTHESIZED LATIN SMALL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006C 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A7"},9384:{"value":"24A8","name":"PARENTHESIZED LATIN SMALL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006D 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A8"},9385:{"value":"24A9","name":"PARENTHESIZED LATIN SMALL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24A9"},9386:{"value":"24AA","name":"PARENTHESIZED LATIN SMALL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 006F 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AA"},9387:{"value":"24AB","name":"PARENTHESIZED LATIN SMALL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0070 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AB"},9388:{"value":"24AC","name":"PARENTHESIZED LATIN SMALL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0071 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AC"},9389:{"value":"24AD","name":"PARENTHESIZED LATIN SMALL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0072 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AD"},9390:{"value":"24AE","name":"PARENTHESIZED LATIN SMALL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0073 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AE"},9391:{"value":"24AF","name":"PARENTHESIZED LATIN SMALL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0074 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24AF"},9392:{"value":"24B0","name":"PARENTHESIZED LATIN SMALL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0075 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B0"},9393:{"value":"24B1","name":"PARENTHESIZED LATIN SMALL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0076 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B1"},9394:{"value":"24B2","name":"PARENTHESIZED LATIN SMALL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0077 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B2"},9395:{"value":"24B3","name":"PARENTHESIZED LATIN SMALL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0078 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B3"},9396:{"value":"24B4","name":"PARENTHESIZED LATIN SMALL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0079 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B4"},9397:{"value":"24B5","name":"PARENTHESIZED LATIN SMALL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 007A 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u24B5"},9398:{"value":"24B6","name":"CIRCLED LATIN CAPITAL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D0","titlecase_mapping":"","symbol":"\u24B6"},9399:{"value":"24B7","name":"CIRCLED LATIN CAPITAL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D1","titlecase_mapping":"","symbol":"\u24B7"},9400:{"value":"24B8","name":"CIRCLED LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D2","titlecase_mapping":"","symbol":"\u24B8"},9401:{"value":"24B9","name":"CIRCLED LATIN CAPITAL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D3","titlecase_mapping":"","symbol":"\u24B9"},9402:{"value":"24BA","name":"CIRCLED LATIN CAPITAL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0045","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D4","titlecase_mapping":"","symbol":"\u24BA"},9403:{"value":"24BB","name":"CIRCLED LATIN CAPITAL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D5","titlecase_mapping":"","symbol":"\u24BB"},9404:{"value":"24BC","name":"CIRCLED LATIN CAPITAL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0047","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D6","titlecase_mapping":"","symbol":"\u24BC"},9405:{"value":"24BD","name":"CIRCLED LATIN CAPITAL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0048","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D7","titlecase_mapping":"","symbol":"\u24BD"},9406:{"value":"24BE","name":"CIRCLED LATIN CAPITAL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0049","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D8","titlecase_mapping":"","symbol":"\u24BE"},9407:{"value":"24BF","name":"CIRCLED LATIN CAPITAL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24D9","titlecase_mapping":"","symbol":"\u24BF"},9408:{"value":"24C0","name":"CIRCLED LATIN CAPITAL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DA","titlecase_mapping":"","symbol":"\u24C0"},9409:{"value":"24C1","name":"CIRCLED LATIN CAPITAL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DB","titlecase_mapping":"","symbol":"\u24C1"},9410:{"value":"24C2","name":"CIRCLED LATIN CAPITAL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DC","titlecase_mapping":"","symbol":"\u24C2"},9411:{"value":"24C3","name":"CIRCLED LATIN CAPITAL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DD","titlecase_mapping":"","symbol":"\u24C3"},9412:{"value":"24C4","name":"CIRCLED LATIN CAPITAL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 004F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DE","titlecase_mapping":"","symbol":"\u24C4"},9413:{"value":"24C5","name":"CIRCLED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0050","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24DF","titlecase_mapping":"","symbol":"\u24C5"},9414:{"value":"24C6","name":"CIRCLED LATIN CAPITAL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0051","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E0","titlecase_mapping":"","symbol":"\u24C6"},9415:{"value":"24C7","name":"CIRCLED LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0052","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E1","titlecase_mapping":"","symbol":"\u24C7"},9416:{"value":"24C8","name":"CIRCLED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0053","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E2","titlecase_mapping":"","symbol":"\u24C8"},9417:{"value":"24C9","name":"CIRCLED LATIN CAPITAL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0054","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E3","titlecase_mapping":"","symbol":"\u24C9"},9418:{"value":"24CA","name":"CIRCLED LATIN CAPITAL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0055","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E4","titlecase_mapping":"","symbol":"\u24CA"},9419:{"value":"24CB","name":"CIRCLED LATIN CAPITAL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E5","titlecase_mapping":"","symbol":"\u24CB"},9420:{"value":"24CC","name":"CIRCLED LATIN CAPITAL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E6","titlecase_mapping":"","symbol":"\u24CC"},9421:{"value":"24CD","name":"CIRCLED LATIN CAPITAL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0058","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E7","titlecase_mapping":"","symbol":"\u24CD"},9422:{"value":"24CE","name":"CIRCLED LATIN CAPITAL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0059","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E8","titlecase_mapping":"","symbol":"\u24CE"},9423:{"value":"24CF","name":"CIRCLED LATIN CAPITAL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 005A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"24E9","titlecase_mapping":"","symbol":"\u24CF"},9424:{"value":"24D0","name":"CIRCLED LATIN SMALL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24B6","lowercase_mapping":"","titlecase_mapping":"24B6","symbol":"\u24D0"},9425:{"value":"24D1","name":"CIRCLED LATIN SMALL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0062","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24B7","lowercase_mapping":"","titlecase_mapping":"24B7","symbol":"\u24D1"},9426:{"value":"24D2","name":"CIRCLED LATIN SMALL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0063","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24B8","lowercase_mapping":"","titlecase_mapping":"24B8","symbol":"\u24D2"},9427:{"value":"24D3","name":"CIRCLED LATIN SMALL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0064","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24B9","lowercase_mapping":"","titlecase_mapping":"24B9","symbol":"\u24D3"},9428:{"value":"24D4","name":"CIRCLED LATIN SMALL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0065","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BA","lowercase_mapping":"","titlecase_mapping":"24BA","symbol":"\u24D4"},9429:{"value":"24D5","name":"CIRCLED LATIN SMALL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0066","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BB","lowercase_mapping":"","titlecase_mapping":"24BB","symbol":"\u24D5"},9430:{"value":"24D6","name":"CIRCLED LATIN SMALL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BC","lowercase_mapping":"","titlecase_mapping":"24BC","symbol":"\u24D6"},9431:{"value":"24D7","name":"CIRCLED LATIN SMALL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0068","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BD","lowercase_mapping":"","titlecase_mapping":"24BD","symbol":"\u24D7"},9432:{"value":"24D8","name":"CIRCLED LATIN SMALL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0069","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BE","lowercase_mapping":"","titlecase_mapping":"24BE","symbol":"\u24D8"},9433:{"value":"24D9","name":"CIRCLED LATIN SMALL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24BF","lowercase_mapping":"","titlecase_mapping":"24BF","symbol":"\u24D9"},9434:{"value":"24DA","name":"CIRCLED LATIN SMALL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C0","lowercase_mapping":"","titlecase_mapping":"24C0","symbol":"\u24DA"},9435:{"value":"24DB","name":"CIRCLED LATIN SMALL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C1","lowercase_mapping":"","titlecase_mapping":"24C1","symbol":"\u24DB"},9436:{"value":"24DC","name":"CIRCLED LATIN SMALL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C2","lowercase_mapping":"","titlecase_mapping":"24C2","symbol":"\u24DC"},9437:{"value":"24DD","name":"CIRCLED LATIN SMALL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C3","lowercase_mapping":"","titlecase_mapping":"24C3","symbol":"\u24DD"},9438:{"value":"24DE","name":"CIRCLED LATIN SMALL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 006F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C4","lowercase_mapping":"","titlecase_mapping":"24C4","symbol":"\u24DE"},9439:{"value":"24DF","name":"CIRCLED LATIN SMALL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0070","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C5","lowercase_mapping":"","titlecase_mapping":"24C5","symbol":"\u24DF"},9440:{"value":"24E0","name":"CIRCLED LATIN SMALL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0071","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C6","lowercase_mapping":"","titlecase_mapping":"24C6","symbol":"\u24E0"},9441:{"value":"24E1","name":"CIRCLED LATIN SMALL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0072","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C7","lowercase_mapping":"","titlecase_mapping":"24C7","symbol":"\u24E1"},9442:{"value":"24E2","name":"CIRCLED LATIN SMALL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C8","lowercase_mapping":"","titlecase_mapping":"24C8","symbol":"\u24E2"},9443:{"value":"24E3","name":"CIRCLED LATIN SMALL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0074","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24C9","lowercase_mapping":"","titlecase_mapping":"24C9","symbol":"\u24E3"},9444:{"value":"24E4","name":"CIRCLED LATIN SMALL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0075","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CA","lowercase_mapping":"","titlecase_mapping":"24CA","symbol":"\u24E4"},9445:{"value":"24E5","name":"CIRCLED LATIN SMALL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0076","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CB","lowercase_mapping":"","titlecase_mapping":"24CB","symbol":"\u24E5"},9446:{"value":"24E6","name":"CIRCLED LATIN SMALL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0077","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CC","lowercase_mapping":"","titlecase_mapping":"24CC","symbol":"\u24E6"},9447:{"value":"24E7","name":"CIRCLED LATIN SMALL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0078","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CD","lowercase_mapping":"","titlecase_mapping":"24CD","symbol":"\u24E7"},9448:{"value":"24E8","name":"CIRCLED LATIN SMALL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0079","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CE","lowercase_mapping":"","titlecase_mapping":"24CE","symbol":"\u24E8"},9449:{"value":"24E9","name":"CIRCLED LATIN SMALL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"24CF","lowercase_mapping":"","titlecase_mapping":"24CF","symbol":"\u24E9"},9472:{"value":"2500","name":"BOX DRAWINGS LIGHT HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2500"},9473:{"value":"2501","name":"BOX DRAWINGS HEAVY HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2501"},9474:{"value":"2502","name":"BOX DRAWINGS LIGHT VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2502"},9475:{"value":"2503","name":"BOX DRAWINGS HEAVY VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2503"},9476:{"value":"2504","name":"BOX DRAWINGS LIGHT TRIPLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT TRIPLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2504"},9477:{"value":"2505","name":"BOX DRAWINGS HEAVY TRIPLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY TRIPLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2505"},9478:{"value":"2506","name":"BOX DRAWINGS LIGHT TRIPLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT TRIPLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2506"},9479:{"value":"2507","name":"BOX DRAWINGS HEAVY TRIPLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY TRIPLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2507"},9480:{"value":"2508","name":"BOX DRAWINGS LIGHT QUADRUPLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT QUADRUPLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2508"},9481:{"value":"2509","name":"BOX DRAWINGS HEAVY QUADRUPLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY QUADRUPLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2509"},9482:{"value":"250A","name":"BOX DRAWINGS LIGHT QUADRUPLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT QUADRUPLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250A"},9483:{"value":"250B","name":"BOX DRAWINGS HEAVY QUADRUPLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY QUADRUPLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250B"},9484:{"value":"250C","name":"BOX DRAWINGS LIGHT DOWN AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOWN AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250C"},9485:{"value":"250D","name":"BOX DRAWINGS DOWN LIGHT AND RIGHT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND RIGHT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250D"},9486:{"value":"250E","name":"BOX DRAWINGS DOWN HEAVY AND RIGHT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND RIGHT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250E"},9487:{"value":"250F","name":"BOX DRAWINGS HEAVY DOWN AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOWN AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u250F"},9488:{"value":"2510","name":"BOX DRAWINGS LIGHT DOWN AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOWN AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2510"},9489:{"value":"2511","name":"BOX DRAWINGS DOWN LIGHT AND LEFT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND LEFT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2511"},9490:{"value":"2512","name":"BOX DRAWINGS DOWN HEAVY AND LEFT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND LEFT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2512"},9491:{"value":"2513","name":"BOX DRAWINGS HEAVY DOWN AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOWN AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2513"},9492:{"value":"2514","name":"BOX DRAWINGS LIGHT UP AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT UP AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2514"},9493:{"value":"2515","name":"BOX DRAWINGS UP LIGHT AND RIGHT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND RIGHT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2515"},9494:{"value":"2516","name":"BOX DRAWINGS UP HEAVY AND RIGHT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND RIGHT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2516"},9495:{"value":"2517","name":"BOX DRAWINGS HEAVY UP AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY UP AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2517"},9496:{"value":"2518","name":"BOX DRAWINGS LIGHT UP AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT UP AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2518"},9497:{"value":"2519","name":"BOX DRAWINGS UP LIGHT AND LEFT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND LEFT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2519"},9498:{"value":"251A","name":"BOX DRAWINGS UP HEAVY AND LEFT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND LEFT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251A"},9499:{"value":"251B","name":"BOX DRAWINGS HEAVY UP AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY UP AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251B"},9500:{"value":"251C","name":"BOX DRAWINGS LIGHT VERTICAL AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT VERTICAL AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251C"},9501:{"value":"251D","name":"BOX DRAWINGS VERTICAL LIGHT AND RIGHT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL LIGHT AND RIGHT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251D"},9502:{"value":"251E","name":"BOX DRAWINGS UP HEAVY AND RIGHT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND RIGHT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251E"},9503:{"value":"251F","name":"BOX DRAWINGS DOWN HEAVY AND RIGHT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND RIGHT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u251F"},9504:{"value":"2520","name":"BOX DRAWINGS VERTICAL HEAVY AND RIGHT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL HEAVY AND RIGHT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2520"},9505:{"value":"2521","name":"BOX DRAWINGS DOWN LIGHT AND RIGHT UP HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND RIGHT UP HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2521"},9506:{"value":"2522","name":"BOX DRAWINGS UP LIGHT AND RIGHT DOWN HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND RIGHT DOWN HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2522"},9507:{"value":"2523","name":"BOX DRAWINGS HEAVY VERTICAL AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY VERTICAL AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2523"},9508:{"value":"2524","name":"BOX DRAWINGS LIGHT VERTICAL AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT VERTICAL AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2524"},9509:{"value":"2525","name":"BOX DRAWINGS VERTICAL LIGHT AND LEFT HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL LIGHT AND LEFT HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2525"},9510:{"value":"2526","name":"BOX DRAWINGS UP HEAVY AND LEFT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND LEFT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2526"},9511:{"value":"2527","name":"BOX DRAWINGS DOWN HEAVY AND LEFT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND LEFT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2527"},9512:{"value":"2528","name":"BOX DRAWINGS VERTICAL HEAVY AND LEFT LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL HEAVY AND LEFT LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2528"},9513:{"value":"2529","name":"BOX DRAWINGS DOWN LIGHT AND LEFT UP HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND LEFT UP HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2529"},9514:{"value":"252A","name":"BOX DRAWINGS UP LIGHT AND LEFT DOWN HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND LEFT DOWN HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252A"},9515:{"value":"252B","name":"BOX DRAWINGS HEAVY VERTICAL AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY VERTICAL AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252B"},9516:{"value":"252C","name":"BOX DRAWINGS LIGHT DOWN AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOWN AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252C"},9517:{"value":"252D","name":"BOX DRAWINGS LEFT HEAVY AND RIGHT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT HEAVY AND RIGHT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252D"},9518:{"value":"252E","name":"BOX DRAWINGS RIGHT HEAVY AND LEFT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT HEAVY AND LEFT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252E"},9519:{"value":"252F","name":"BOX DRAWINGS DOWN LIGHT AND HORIZONTAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND HORIZONTAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u252F"},9520:{"value":"2530","name":"BOX DRAWINGS DOWN HEAVY AND HORIZONTAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND HORIZONTAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2530"},9521:{"value":"2531","name":"BOX DRAWINGS RIGHT LIGHT AND LEFT DOWN HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT LIGHT AND LEFT DOWN HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2531"},9522:{"value":"2532","name":"BOX DRAWINGS LEFT LIGHT AND RIGHT DOWN HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT LIGHT AND RIGHT DOWN HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2532"},9523:{"value":"2533","name":"BOX DRAWINGS HEAVY DOWN AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOWN AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2533"},9524:{"value":"2534","name":"BOX DRAWINGS LIGHT UP AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT UP AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2534"},9525:{"value":"2535","name":"BOX DRAWINGS LEFT HEAVY AND RIGHT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT HEAVY AND RIGHT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2535"},9526:{"value":"2536","name":"BOX DRAWINGS RIGHT HEAVY AND LEFT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT HEAVY AND LEFT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2536"},9527:{"value":"2537","name":"BOX DRAWINGS UP LIGHT AND HORIZONTAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND HORIZONTAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2537"},9528:{"value":"2538","name":"BOX DRAWINGS UP HEAVY AND HORIZONTAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND HORIZONTAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2538"},9529:{"value":"2539","name":"BOX DRAWINGS RIGHT LIGHT AND LEFT UP HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT LIGHT AND LEFT UP HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2539"},9530:{"value":"253A","name":"BOX DRAWINGS LEFT LIGHT AND RIGHT UP HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT LIGHT AND RIGHT UP HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253A"},9531:{"value":"253B","name":"BOX DRAWINGS HEAVY UP AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY UP AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253B"},9532:{"value":"253C","name":"BOX DRAWINGS LIGHT VERTICAL AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT VERTICAL AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253C"},9533:{"value":"253D","name":"BOX DRAWINGS LEFT HEAVY AND RIGHT VERTICAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT HEAVY AND RIGHT VERTICAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253D"},9534:{"value":"253E","name":"BOX DRAWINGS RIGHT HEAVY AND LEFT VERTICAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT HEAVY AND LEFT VERTICAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253E"},9535:{"value":"253F","name":"BOX DRAWINGS VERTICAL LIGHT AND HORIZONTAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL LIGHT AND HORIZONTAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u253F"},9536:{"value":"2540","name":"BOX DRAWINGS UP HEAVY AND DOWN HORIZONTAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP HEAVY AND DOWN HORIZONTAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2540"},9537:{"value":"2541","name":"BOX DRAWINGS DOWN HEAVY AND UP HORIZONTAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN HEAVY AND UP HORIZONTAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2541"},9538:{"value":"2542","name":"BOX DRAWINGS VERTICAL HEAVY AND HORIZONTAL LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL HEAVY AND HORIZONTAL LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2542"},9539:{"value":"2543","name":"BOX DRAWINGS LEFT UP HEAVY AND RIGHT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT UP HEAVY AND RIGHT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2543"},9540:{"value":"2544","name":"BOX DRAWINGS RIGHT UP HEAVY AND LEFT DOWN LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT UP HEAVY AND LEFT DOWN LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2544"},9541:{"value":"2545","name":"BOX DRAWINGS LEFT DOWN HEAVY AND RIGHT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT DOWN HEAVY AND RIGHT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2545"},9542:{"value":"2546","name":"BOX DRAWINGS RIGHT DOWN HEAVY AND LEFT UP LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT DOWN HEAVY AND LEFT UP LIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2546"},9543:{"value":"2547","name":"BOX DRAWINGS DOWN LIGHT AND UP HORIZONTAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN LIGHT AND UP HORIZONTAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2547"},9544:{"value":"2548","name":"BOX DRAWINGS UP LIGHT AND DOWN HORIZONTAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP LIGHT AND DOWN HORIZONTAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2548"},9545:{"value":"2549","name":"BOX DRAWINGS RIGHT LIGHT AND LEFT VERTICAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS RIGHT LIGHT AND LEFT VERTICAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2549"},9546:{"value":"254A","name":"BOX DRAWINGS LEFT LIGHT AND RIGHT VERTICAL HEAVY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LEFT LIGHT AND RIGHT VERTICAL HEAVY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254A"},9547:{"value":"254B","name":"BOX DRAWINGS HEAVY VERTICAL AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY VERTICAL AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254B"},9548:{"value":"254C","name":"BOX DRAWINGS LIGHT DOUBLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOUBLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254C"},9549:{"value":"254D","name":"BOX DRAWINGS HEAVY DOUBLE DASH HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOUBLE DASH HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254D"},9550:{"value":"254E","name":"BOX DRAWINGS LIGHT DOUBLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOUBLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254E"},9551:{"value":"254F","name":"BOX DRAWINGS HEAVY DOUBLE DASH VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOUBLE DASH VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u254F"},9552:{"value":"2550","name":"BOX DRAWINGS DOUBLE HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2550"},9553:{"value":"2551","name":"BOX DRAWINGS DOUBLE VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE VERTICAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2551"},9554:{"value":"2552","name":"BOX DRAWINGS DOWN SINGLE AND RIGHT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN SINGLE AND RIGHT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2552"},9555:{"value":"2553","name":"BOX DRAWINGS DOWN DOUBLE AND RIGHT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN DOUBLE AND RIGHT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2553"},9556:{"value":"2554","name":"BOX DRAWINGS DOUBLE DOWN AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE DOWN AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2554"},9557:{"value":"2555","name":"BOX DRAWINGS DOWN SINGLE AND LEFT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN SINGLE AND LEFT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2555"},9558:{"value":"2556","name":"BOX DRAWINGS DOWN DOUBLE AND LEFT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN DOUBLE AND LEFT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2556"},9559:{"value":"2557","name":"BOX DRAWINGS DOUBLE DOWN AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE DOWN AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2557"},9560:{"value":"2558","name":"BOX DRAWINGS UP SINGLE AND RIGHT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP SINGLE AND RIGHT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2558"},9561:{"value":"2559","name":"BOX DRAWINGS UP DOUBLE AND RIGHT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP DOUBLE AND RIGHT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2559"},9562:{"value":"255A","name":"BOX DRAWINGS DOUBLE UP AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE UP AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255A"},9563:{"value":"255B","name":"BOX DRAWINGS UP SINGLE AND LEFT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP SINGLE AND LEFT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255B"},9564:{"value":"255C","name":"BOX DRAWINGS UP DOUBLE AND LEFT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP DOUBLE AND LEFT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255C"},9565:{"value":"255D","name":"BOX DRAWINGS DOUBLE UP AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE UP AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255D"},9566:{"value":"255E","name":"BOX DRAWINGS VERTICAL SINGLE AND RIGHT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL SINGLE AND RIGHT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255E"},9567:{"value":"255F","name":"BOX DRAWINGS VERTICAL DOUBLE AND RIGHT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL DOUBLE AND RIGHT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u255F"},9568:{"value":"2560","name":"BOX DRAWINGS DOUBLE VERTICAL AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE VERTICAL AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2560"},9569:{"value":"2561","name":"BOX DRAWINGS VERTICAL SINGLE AND LEFT DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL SINGLE AND LEFT DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2561"},9570:{"value":"2562","name":"BOX DRAWINGS VERTICAL DOUBLE AND LEFT SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL DOUBLE AND LEFT SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2562"},9571:{"value":"2563","name":"BOX DRAWINGS DOUBLE VERTICAL AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE VERTICAL AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2563"},9572:{"value":"2564","name":"BOX DRAWINGS DOWN SINGLE AND HORIZONTAL DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN SINGLE AND HORIZONTAL DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2564"},9573:{"value":"2565","name":"BOX DRAWINGS DOWN DOUBLE AND HORIZONTAL SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOWN DOUBLE AND HORIZONTAL SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2565"},9574:{"value":"2566","name":"BOX DRAWINGS DOUBLE DOWN AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE DOWN AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2566"},9575:{"value":"2567","name":"BOX DRAWINGS UP SINGLE AND HORIZONTAL DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP SINGLE AND HORIZONTAL DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2567"},9576:{"value":"2568","name":"BOX DRAWINGS UP DOUBLE AND HORIZONTAL SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS UP DOUBLE AND HORIZONTAL SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2568"},9577:{"value":"2569","name":"BOX DRAWINGS DOUBLE UP AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE UP AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2569"},9578:{"value":"256A","name":"BOX DRAWINGS VERTICAL SINGLE AND HORIZONTAL DOUBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL SINGLE AND HORIZONTAL DOUBLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256A"},9579:{"value":"256B","name":"BOX DRAWINGS VERTICAL DOUBLE AND HORIZONTAL SINGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS VERTICAL DOUBLE AND HORIZONTAL SINGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256B"},9580:{"value":"256C","name":"BOX DRAWINGS DOUBLE VERTICAL AND HORIZONTAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS DOUBLE VERTICAL AND HORIZONTAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256C"},9581:{"value":"256D","name":"BOX DRAWINGS LIGHT ARC DOWN AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT ARC DOWN AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256D"},9582:{"value":"256E","name":"BOX DRAWINGS LIGHT ARC DOWN AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT ARC DOWN AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256E"},9583:{"value":"256F","name":"BOX DRAWINGS LIGHT ARC UP AND LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT ARC UP AND LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u256F"},9584:{"value":"2570","name":"BOX DRAWINGS LIGHT ARC UP AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT ARC UP AND RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2570"},9585:{"value":"2571","name":"BOX DRAWINGS LIGHT DIAGONAL UPPER RIGHT TO LOWER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DIAGONAL UPPER RIGHT TO LOWER LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2571"},9586:{"value":"2572","name":"BOX DRAWINGS LIGHT DIAGONAL UPPER LEFT TO LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DIAGONAL UPPER LEFT TO LOWER RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2572"},9587:{"value":"2573","name":"BOX DRAWINGS LIGHT DIAGONAL CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DIAGONAL CROSS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2573"},9588:{"value":"2574","name":"BOX DRAWINGS LIGHT LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2574"},9589:{"value":"2575","name":"BOX DRAWINGS LIGHT UP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT UP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2575"},9590:{"value":"2576","name":"BOX DRAWINGS LIGHT RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2576"},9591:{"value":"2577","name":"BOX DRAWINGS LIGHT DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2577"},9592:{"value":"2578","name":"BOX DRAWINGS HEAVY LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY LEFT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2578"},9593:{"value":"2579","name":"BOX DRAWINGS HEAVY UP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY UP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2579"},9594:{"value":"257A","name":"BOX DRAWINGS HEAVY RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257A"},9595:{"value":"257B","name":"BOX DRAWINGS HEAVY DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257B"},9596:{"value":"257C","name":"BOX DRAWINGS LIGHT LEFT AND HEAVY RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT LEFT AND HEAVY RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257C"},9597:{"value":"257D","name":"BOX DRAWINGS LIGHT UP AND HEAVY DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS LIGHT UP AND HEAVY DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257D"},9598:{"value":"257E","name":"BOX DRAWINGS HEAVY LEFT AND LIGHT RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY LEFT AND LIGHT RIGHT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257E"},9599:{"value":"257F","name":"BOX DRAWINGS HEAVY UP AND LIGHT DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FORMS HEAVY UP AND LIGHT DOWN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u257F"},9600:{"value":"2580","name":"UPPER HALF BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2580"},9601:{"value":"2581","name":"LOWER ONE EIGHTH BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2581"},9602:{"value":"2582","name":"LOWER ONE QUARTER BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2582"},9603:{"value":"2583","name":"LOWER THREE EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2583"},9604:{"value":"2584","name":"LOWER HALF BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2584"},9605:{"value":"2585","name":"LOWER FIVE EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2585"},9606:{"value":"2586","name":"LOWER THREE QUARTERS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LOWER THREE QUARTER BLOCK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2586"},9607:{"value":"2587","name":"LOWER SEVEN EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2587"},9608:{"value":"2588","name":"FULL BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2588"},9609:{"value":"2589","name":"LEFT SEVEN EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2589"},9610:{"value":"258A","name":"LEFT THREE QUARTERS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT THREE QUARTER BLOCK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258A"},9611:{"value":"258B","name":"LEFT FIVE EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258B"},9612:{"value":"258C","name":"LEFT HALF BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258C"},9613:{"value":"258D","name":"LEFT THREE EIGHTHS BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258D"},9614:{"value":"258E","name":"LEFT ONE QUARTER BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258E"},9615:{"value":"258F","name":"LEFT ONE EIGHTH BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u258F"},9616:{"value":"2590","name":"RIGHT HALF BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2590"},9617:{"value":"2591","name":"LIGHT SHADE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2591"},9618:{"value":"2592","name":"MEDIUM SHADE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2592"},9619:{"value":"2593","name":"DARK SHADE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2593"},9620:{"value":"2594","name":"UPPER ONE EIGHTH BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2594"},9621:{"value":"2595","name":"RIGHT ONE EIGHTH BLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2595"},9622:{"value":"2596","name":"QUADRANT LOWER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2596"},9623:{"value":"2597","name":"QUADRANT LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2597"},9624:{"value":"2598","name":"QUADRANT UPPER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2598"},9625:{"value":"2599","name":"QUADRANT UPPER LEFT AND LOWER LEFT AND LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2599"},9626:{"value":"259A","name":"QUADRANT UPPER LEFT AND LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259A"},9627:{"value":"259B","name":"QUADRANT UPPER LEFT AND UPPER RIGHT AND LOWER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259B"},9628:{"value":"259C","name":"QUADRANT UPPER LEFT AND UPPER RIGHT AND LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259C"},9629:{"value":"259D","name":"QUADRANT UPPER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259D"},9630:{"value":"259E","name":"QUADRANT UPPER RIGHT AND LOWER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259E"},9631:{"value":"259F","name":"QUADRANT UPPER RIGHT AND LOWER LEFT AND LOWER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u259F"},9632:{"value":"25A0","name":"BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A0"},9633:{"value":"25A1","name":"WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A1"},9634:{"value":"25A2","name":"WHITE SQUARE WITH ROUNDED CORNERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A2"},9635:{"value":"25A3","name":"WHITE SQUARE CONTAINING BLACK SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A3"},9636:{"value":"25A4","name":"SQUARE WITH HORIZONTAL FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A4"},9637:{"value":"25A5","name":"SQUARE WITH VERTICAL FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A5"},9638:{"value":"25A6","name":"SQUARE WITH ORTHOGONAL CROSSHATCH FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A6"},9639:{"value":"25A7","name":"SQUARE WITH UPPER LEFT TO LOWER RIGHT FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A7"},9640:{"value":"25A8","name":"SQUARE WITH UPPER RIGHT TO LOWER LEFT FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A8"},9641:{"value":"25A9","name":"SQUARE WITH DIAGONAL CROSSHATCH FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25A9"},9642:{"value":"25AA","name":"BLACK SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AA"},9643:{"value":"25AB","name":"WHITE SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AB"},9644:{"value":"25AC","name":"BLACK RECTANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AC"},9645:{"value":"25AD","name":"WHITE RECTANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AD"},9646:{"value":"25AE","name":"BLACK VERTICAL RECTANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AE"},9647:{"value":"25AF","name":"WHITE VERTICAL RECTANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25AF"},9648:{"value":"25B0","name":"BLACK PARALLELOGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B0"},9649:{"value":"25B1","name":"WHITE PARALLELOGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B1"},9650:{"value":"25B2","name":"BLACK UP-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK UP POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B2"},9651:{"value":"25B3","name":"WHITE UP-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE UP POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B3"},9652:{"value":"25B4","name":"BLACK UP-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK UP POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B4"},9653:{"value":"25B5","name":"WHITE UP-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE UP POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B5"},9654:{"value":"25B6","name":"BLACK RIGHT-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK RIGHT POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B6"},9656:{"value":"25B8","name":"BLACK RIGHT-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK RIGHT POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B8"},9657:{"value":"25B9","name":"WHITE RIGHT-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE RIGHT POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25B9"},9658:{"value":"25BA","name":"BLACK RIGHT-POINTING POINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK RIGHT POINTING POINTER","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BA"},9659:{"value":"25BB","name":"WHITE RIGHT-POINTING POINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE RIGHT POINTING POINTER","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BB"},9660:{"value":"25BC","name":"BLACK DOWN-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK DOWN POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BC"},9661:{"value":"25BD","name":"WHITE DOWN-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE DOWN POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BD"},9662:{"value":"25BE","name":"BLACK DOWN-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK DOWN POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BE"},9663:{"value":"25BF","name":"WHITE DOWN-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE DOWN POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25BF"},9664:{"value":"25C0","name":"BLACK LEFT-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK LEFT POINTING TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C0"},9666:{"value":"25C2","name":"BLACK LEFT-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK LEFT POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C2"},9667:{"value":"25C3","name":"WHITE LEFT-POINTING SMALL TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE LEFT POINTING SMALL TRIANGLE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C3"},9668:{"value":"25C4","name":"BLACK LEFT-POINTING POINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK LEFT POINTING POINTER","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C4"},9669:{"value":"25C5","name":"WHITE LEFT-POINTING POINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE LEFT POINTING POINTER","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C5"},9670:{"value":"25C6","name":"BLACK DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C6"},9671:{"value":"25C7","name":"WHITE DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C7"},9672:{"value":"25C8","name":"WHITE DIAMOND CONTAINING BLACK SMALL DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C8"},9673:{"value":"25C9","name":"FISHEYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25C9"},9674:{"value":"25CA","name":"LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CA"},9675:{"value":"25CB","name":"WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CB"},9676:{"value":"25CC","name":"DOTTED CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CC"},9677:{"value":"25CD","name":"CIRCLE WITH VERTICAL FILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CD"},9678:{"value":"25CE","name":"BULLSEYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CE"},9679:{"value":"25CF","name":"BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25CF"},9680:{"value":"25D0","name":"CIRCLE WITH LEFT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D0"},9681:{"value":"25D1","name":"CIRCLE WITH RIGHT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D1"},9682:{"value":"25D2","name":"CIRCLE WITH LOWER HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D2"},9683:{"value":"25D3","name":"CIRCLE WITH UPPER HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D3"},9684:{"value":"25D4","name":"CIRCLE WITH UPPER RIGHT QUADRANT BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D4"},9685:{"value":"25D5","name":"CIRCLE WITH ALL BUT UPPER LEFT QUADRANT BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D5"},9686:{"value":"25D6","name":"LEFT HALF BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D6"},9687:{"value":"25D7","name":"RIGHT HALF BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D7"},9688:{"value":"25D8","name":"INVERSE BULLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D8"},9689:{"value":"25D9","name":"INVERSE WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25D9"},9690:{"value":"25DA","name":"UPPER HALF INVERSE WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DA"},9691:{"value":"25DB","name":"LOWER HALF INVERSE WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DB"},9692:{"value":"25DC","name":"UPPER LEFT QUADRANT CIRCULAR ARC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DC"},9693:{"value":"25DD","name":"UPPER RIGHT QUADRANT CIRCULAR ARC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DD"},9694:{"value":"25DE","name":"LOWER RIGHT QUADRANT CIRCULAR ARC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DE"},9695:{"value":"25DF","name":"LOWER LEFT QUADRANT CIRCULAR ARC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25DF"},9696:{"value":"25E0","name":"UPPER HALF CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E0"},9697:{"value":"25E1","name":"LOWER HALF CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E1"},9698:{"value":"25E2","name":"BLACK LOWER RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E2"},9699:{"value":"25E3","name":"BLACK LOWER LEFT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E3"},9700:{"value":"25E4","name":"BLACK UPPER LEFT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E4"},9701:{"value":"25E5","name":"BLACK UPPER RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E5"},9702:{"value":"25E6","name":"WHITE BULLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E6"},9703:{"value":"25E7","name":"SQUARE WITH LEFT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E7"},9704:{"value":"25E8","name":"SQUARE WITH RIGHT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E8"},9705:{"value":"25E9","name":"SQUARE WITH UPPER LEFT DIAGONAL HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25E9"},9706:{"value":"25EA","name":"SQUARE WITH LOWER RIGHT DIAGONAL HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25EA"},9707:{"value":"25EB","name":"WHITE SQUARE WITH VERTICAL BISECTING LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25EB"},9708:{"value":"25EC","name":"WHITE UP-POINTING TRIANGLE WITH DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE UP POINTING TRIANGLE WITH DOT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25EC"},9709:{"value":"25ED","name":"UP-POINTING TRIANGLE WITH LEFT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP POINTING TRIANGLE WITH LEFT HALF BLACK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25ED"},9710:{"value":"25EE","name":"UP-POINTING TRIANGLE WITH RIGHT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"UP POINTING TRIANGLE WITH RIGHT HALF BLACK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25EE"},9711:{"value":"25EF","name":"LARGE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25EF"},9712:{"value":"25F0","name":"WHITE SQUARE WITH UPPER LEFT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F0"},9713:{"value":"25F1","name":"WHITE SQUARE WITH LOWER LEFT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F1"},9714:{"value":"25F2","name":"WHITE SQUARE WITH LOWER RIGHT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F2"},9715:{"value":"25F3","name":"WHITE SQUARE WITH UPPER RIGHT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F3"},9716:{"value":"25F4","name":"WHITE CIRCLE WITH UPPER LEFT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F4"},9717:{"value":"25F5","name":"WHITE CIRCLE WITH LOWER LEFT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F5"},9718:{"value":"25F6","name":"WHITE CIRCLE WITH LOWER RIGHT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F6"},9719:{"value":"25F7","name":"WHITE CIRCLE WITH UPPER RIGHT QUADRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u25F7"},9728:{"value":"2600","name":"BLACK SUN WITH RAYS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2600"},9729:{"value":"2601","name":"CLOUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2601"},9730:{"value":"2602","name":"UMBRELLA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2602"},9731:{"value":"2603","name":"SNOWMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2603"},9732:{"value":"2604","name":"COMET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2604"},9733:{"value":"2605","name":"BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2605"},9734:{"value":"2606","name":"WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2606"},9735:{"value":"2607","name":"LIGHTNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2607"},9736:{"value":"2608","name":"THUNDERSTORM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2608"},9737:{"value":"2609","name":"SUN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2609"},9738:{"value":"260A","name":"ASCENDING NODE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260A"},9739:{"value":"260B","name":"DESCENDING NODE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260B"},9740:{"value":"260C","name":"CONJUNCTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260C"},9741:{"value":"260D","name":"OPPOSITION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260D"},9742:{"value":"260E","name":"BLACK TELEPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260E"},9743:{"value":"260F","name":"WHITE TELEPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u260F"},9744:{"value":"2610","name":"BALLOT BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2610"},9745:{"value":"2611","name":"BALLOT BOX WITH CHECK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2611"},9746:{"value":"2612","name":"BALLOT BOX WITH X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2612"},9747:{"value":"2613","name":"SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2613"},9748:{"value":"2614","name":"UMBRELLA WITH RAIN DROPS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2614"},9749:{"value":"2615","name":"HOT BEVERAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2615"},9750:{"value":"2616","name":"WHITE SHOGI PIECE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2616"},9751:{"value":"2617","name":"BLACK SHOGI PIECE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2617"},9752:{"value":"2618","name":"SHAMROCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2618"},9753:{"value":"2619","name":"REVERSED ROTATED FLORAL HEART BULLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2619"},9754:{"value":"261A","name":"BLACK LEFT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261A"},9755:{"value":"261B","name":"BLACK RIGHT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261B"},9756:{"value":"261C","name":"WHITE LEFT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261C"},9757:{"value":"261D","name":"WHITE UP POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261D"},9758:{"value":"261E","name":"WHITE RIGHT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261E"},9759:{"value":"261F","name":"WHITE DOWN POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u261F"},9760:{"value":"2620","name":"SKULL AND CROSSBONES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2620"},9761:{"value":"2621","name":"CAUTION SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2621"},9762:{"value":"2622","name":"RADIOACTIVE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2622"},9763:{"value":"2623","name":"BIOHAZARD SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2623"},9764:{"value":"2624","name":"CADUCEUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2624"},9765:{"value":"2625","name":"ANKH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2625"},9766:{"value":"2626","name":"ORTHODOX CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2626"},9767:{"value":"2627","name":"CHI RHO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2627"},9768:{"value":"2628","name":"CROSS OF LORRAINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2628"},9769:{"value":"2629","name":"CROSS OF JERUSALEM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2629"},9770:{"value":"262A","name":"STAR AND CRESCENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262A"},9771:{"value":"262B","name":"FARSI SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SYMBOL OF IRAN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262B"},9772:{"value":"262C","name":"ADI SHAKTI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262C"},9773:{"value":"262D","name":"HAMMER AND SICKLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262D"},9774:{"value":"262E","name":"PEACE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262E"},9775:{"value":"262F","name":"YIN YANG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u262F"},9776:{"value":"2630","name":"TRIGRAM FOR HEAVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2630"},9777:{"value":"2631","name":"TRIGRAM FOR LAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2631"},9778:{"value":"2632","name":"TRIGRAM FOR FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2632"},9779:{"value":"2633","name":"TRIGRAM FOR THUNDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2633"},9780:{"value":"2634","name":"TRIGRAM FOR WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2634"},9781:{"value":"2635","name":"TRIGRAM FOR WATER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2635"},9782:{"value":"2636","name":"TRIGRAM FOR MOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2636"},9783:{"value":"2637","name":"TRIGRAM FOR EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2637"},9784:{"value":"2638","name":"WHEEL OF DHARMA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2638"},9785:{"value":"2639","name":"WHITE FROWNING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2639"},9786:{"value":"263A","name":"WHITE SMILING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263A"},9787:{"value":"263B","name":"BLACK SMILING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263B"},9788:{"value":"263C","name":"WHITE SUN WITH RAYS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263C"},9789:{"value":"263D","name":"FIRST QUARTER MOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263D"},9790:{"value":"263E","name":"LAST QUARTER MOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263E"},9791:{"value":"263F","name":"MERCURY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u263F"},9792:{"value":"2640","name":"FEMALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2640"},9793:{"value":"2641","name":"EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2641"},9794:{"value":"2642","name":"MALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2642"},9795:{"value":"2643","name":"JUPITER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2643"},9796:{"value":"2644","name":"SATURN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2644"},9797:{"value":"2645","name":"URANUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2645"},9798:{"value":"2646","name":"NEPTUNE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2646"},9799:{"value":"2647","name":"PLUTO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2647"},9800:{"value":"2648","name":"ARIES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2648"},9801:{"value":"2649","name":"TAURUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2649"},9802:{"value":"264A","name":"GEMINI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264A"},9803:{"value":"264B","name":"CANCER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264B"},9804:{"value":"264C","name":"LEO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264C"},9805:{"value":"264D","name":"VIRGO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264D"},9806:{"value":"264E","name":"LIBRA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264E"},9807:{"value":"264F","name":"SCORPIUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u264F"},9808:{"value":"2650","name":"SAGITTARIUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2650"},9809:{"value":"2651","name":"CAPRICORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2651"},9810:{"value":"2652","name":"AQUARIUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2652"},9811:{"value":"2653","name":"PISCES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2653"},9812:{"value":"2654","name":"WHITE CHESS KING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2654"},9813:{"value":"2655","name":"WHITE CHESS QUEEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2655"},9814:{"value":"2656","name":"WHITE CHESS ROOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2656"},9815:{"value":"2657","name":"WHITE CHESS BISHOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2657"},9816:{"value":"2658","name":"WHITE CHESS KNIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2658"},9817:{"value":"2659","name":"WHITE CHESS PAWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2659"},9818:{"value":"265A","name":"BLACK CHESS KING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265A"},9819:{"value":"265B","name":"BLACK CHESS QUEEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265B"},9820:{"value":"265C","name":"BLACK CHESS ROOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265C"},9821:{"value":"265D","name":"BLACK CHESS BISHOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265D"},9822:{"value":"265E","name":"BLACK CHESS KNIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265E"},9823:{"value":"265F","name":"BLACK CHESS PAWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u265F"},9824:{"value":"2660","name":"BLACK SPADE SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2660"},9825:{"value":"2661","name":"WHITE HEART SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2661"},9826:{"value":"2662","name":"WHITE DIAMOND SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2662"},9827:{"value":"2663","name":"BLACK CLUB SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2663"},9828:{"value":"2664","name":"WHITE SPADE SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2664"},9829:{"value":"2665","name":"BLACK HEART SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2665"},9830:{"value":"2666","name":"BLACK DIAMOND SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2666"},9831:{"value":"2667","name":"WHITE CLUB SUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2667"},9832:{"value":"2668","name":"HOT SPRINGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2668"},9833:{"value":"2669","name":"QUARTER NOTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2669"},9834:{"value":"266A","name":"EIGHTH NOTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u266A"},9835:{"value":"266B","name":"BEAMED EIGHTH NOTES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BARRED EIGHTH NOTES","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u266B"},9836:{"value":"266C","name":"BEAMED SIXTEENTH NOTES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BARRED SIXTEENTH NOTES","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u266C"},9837:{"value":"266D","name":"MUSIC FLAT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FLAT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u266D"},9838:{"value":"266E","name":"MUSIC NATURAL SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"NATURAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u266E"},9840:{"value":"2670","name":"WEST SYRIAC CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2670"},9841:{"value":"2671","name":"EAST SYRIAC CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2671"},9842:{"value":"2672","name":"UNIVERSAL RECYCLING SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2672"},9843:{"value":"2673","name":"RECYCLING SYMBOL FOR TYPE-1 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2673"},9844:{"value":"2674","name":"RECYCLING SYMBOL FOR TYPE-2 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2674"},9845:{"value":"2675","name":"RECYCLING SYMBOL FOR TYPE-3 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2675"},9846:{"value":"2676","name":"RECYCLING SYMBOL FOR TYPE-4 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2676"},9847:{"value":"2677","name":"RECYCLING SYMBOL FOR TYPE-5 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2677"},9848:{"value":"2678","name":"RECYCLING SYMBOL FOR TYPE-6 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2678"},9849:{"value":"2679","name":"RECYCLING SYMBOL FOR TYPE-7 PLASTICS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2679"},9850:{"value":"267A","name":"RECYCLING SYMBOL FOR GENERIC MATERIALS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267A"},9851:{"value":"267B","name":"BLACK UNIVERSAL RECYCLING SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267B"},9852:{"value":"267C","name":"RECYCLED PAPER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267C"},9853:{"value":"267D","name":"PARTIALLY-RECYCLED PAPER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267D"},9854:{"value":"267E","name":"PERMANENT PAPER SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267E"},9855:{"value":"267F","name":"WHEELCHAIR SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u267F"},9856:{"value":"2680","name":"DIE FACE-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2680"},9857:{"value":"2681","name":"DIE FACE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2681"},9858:{"value":"2682","name":"DIE FACE-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2682"},9859:{"value":"2683","name":"DIE FACE-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2683"},9860:{"value":"2684","name":"DIE FACE-5","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2684"},9861:{"value":"2685","name":"DIE FACE-6","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2685"},9862:{"value":"2686","name":"WHITE CIRCLE WITH DOT RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2686"},9863:{"value":"2687","name":"WHITE CIRCLE WITH TWO DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2687"},9864:{"value":"2688","name":"BLACK CIRCLE WITH WHITE DOT RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2688"},9865:{"value":"2689","name":"BLACK CIRCLE WITH TWO WHITE DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2689"},9866:{"value":"268A","name":"MONOGRAM FOR YANG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268A"},9867:{"value":"268B","name":"MONOGRAM FOR YIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268B"},9868:{"value":"268C","name":"DIGRAM FOR GREATER YANG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268C"},9869:{"value":"268D","name":"DIGRAM FOR LESSER YIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268D"},9870:{"value":"268E","name":"DIGRAM FOR LESSER YANG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268E"},9871:{"value":"268F","name":"DIGRAM FOR GREATER YIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u268F"},9872:{"value":"2690","name":"WHITE FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2690"},9873:{"value":"2691","name":"BLACK FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2691"},9874:{"value":"2692","name":"HAMMER AND PICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2692"},9875:{"value":"2693","name":"ANCHOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2693"},9876:{"value":"2694","name":"CROSSED SWORDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2694"},9877:{"value":"2695","name":"STAFF OF AESCULAPIUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2695"},9878:{"value":"2696","name":"SCALES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2696"},9879:{"value":"2697","name":"ALEMBIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2697"},9880:{"value":"2698","name":"FLOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2698"},9881:{"value":"2699","name":"GEAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2699"},9882:{"value":"269A","name":"STAFF OF HERMES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269A"},9883:{"value":"269B","name":"ATOM SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269B"},9884:{"value":"269C","name":"FLEUR-DE-LIS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269C"},9885:{"value":"269D","name":"OUTLINED WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269D"},9886:{"value":"269E","name":"THREE LINES CONVERGING RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269E"},9887:{"value":"269F","name":"THREE LINES CONVERGING LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u269F"},9888:{"value":"26A0","name":"WARNING SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A0"},9889:{"value":"26A1","name":"HIGH VOLTAGE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A1"},9890:{"value":"26A2","name":"DOUBLED FEMALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A2"},9891:{"value":"26A3","name":"DOUBLED MALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A3"},9892:{"value":"26A4","name":"INTERLOCKED FEMALE AND MALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A4"},9893:{"value":"26A5","name":"MALE AND FEMALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A5"},9894:{"value":"26A6","name":"MALE WITH STROKE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A6"},9895:{"value":"26A7","name":"MALE WITH STROKE AND MALE AND FEMALE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A7"},9896:{"value":"26A8","name":"VERTICAL MALE WITH STROKE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A8"},9897:{"value":"26A9","name":"HORIZONTAL MALE WITH STROKE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26A9"},9898:{"value":"26AA","name":"MEDIUM WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AA"},9899:{"value":"26AB","name":"MEDIUM BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AB"},9900:{"value":"26AC","name":"MEDIUM SMALL WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AC"},9901:{"value":"26AD","name":"MARRIAGE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AD"},9902:{"value":"26AE","name":"DIVORCE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AE"},9903:{"value":"26AF","name":"UNMARRIED PARTNERSHIP SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26AF"},9904:{"value":"26B0","name":"COFFIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B0"},9905:{"value":"26B1","name":"FUNERAL URN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B1"},9906:{"value":"26B2","name":"NEUTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B2"},9907:{"value":"26B3","name":"CERES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B3"},9908:{"value":"26B4","name":"PALLAS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B4"},9909:{"value":"26B5","name":"JUNO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B5"},9910:{"value":"26B6","name":"VESTA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B6"},9911:{"value":"26B7","name":"CHIRON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B7"},9912:{"value":"26B8","name":"BLACK MOON LILITH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B8"},9913:{"value":"26B9","name":"SEXTILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26B9"},9914:{"value":"26BA","name":"SEMISEXTILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BA"},9915:{"value":"26BB","name":"QUINCUNX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BB"},9916:{"value":"26BC","name":"SESQUIQUADRATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BC"},9917:{"value":"26BD","name":"SOCCER BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BD"},9918:{"value":"26BE","name":"BASEBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BE"},9919:{"value":"26BF","name":"SQUARED KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26BF"},9920:{"value":"26C0","name":"WHITE DRAUGHTS MAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C0"},9921:{"value":"26C1","name":"WHITE DRAUGHTS KING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C1"},9922:{"value":"26C2","name":"BLACK DRAUGHTS MAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C2"},9923:{"value":"26C3","name":"BLACK DRAUGHTS KING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C3"},9924:{"value":"26C4","name":"SNOWMAN WITHOUT SNOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C4"},9925:{"value":"26C5","name":"SUN BEHIND CLOUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C5"},9926:{"value":"26C6","name":"RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C6"},9927:{"value":"26C7","name":"BLACK SNOWMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C7"},9928:{"value":"26C8","name":"THUNDER CLOUD AND RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C8"},9929:{"value":"26C9","name":"TURNED WHITE SHOGI PIECE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26C9"},9930:{"value":"26CA","name":"TURNED BLACK SHOGI PIECE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CA"},9931:{"value":"26CB","name":"WHITE DIAMOND IN SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CB"},9932:{"value":"26CC","name":"CROSSING LANES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CC"},9933:{"value":"26CD","name":"DISABLED CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CD"},9934:{"value":"26CE","name":"OPHIUCHUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CE"},9935:{"value":"26CF","name":"PICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26CF"},9936:{"value":"26D0","name":"CAR SLIDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D0"},9937:{"value":"26D1","name":"HELMET WITH WHITE CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D1"},9938:{"value":"26D2","name":"CIRCLED CROSSING LANES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D2"},9939:{"value":"26D3","name":"CHAINS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D3"},9940:{"value":"26D4","name":"NO ENTRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D4"},9941:{"value":"26D5","name":"ALTERNATE ONE-WAY LEFT WAY TRAFFIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D5"},9942:{"value":"26D6","name":"BLACK TWO-WAY LEFT WAY TRAFFIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D6"},9943:{"value":"26D7","name":"WHITE TWO-WAY LEFT WAY TRAFFIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D7"},9944:{"value":"26D8","name":"BLACK LEFT LANE MERGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D8"},9945:{"value":"26D9","name":"WHITE LEFT LANE MERGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26D9"},9946:{"value":"26DA","name":"DRIVE SLOW SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DA"},9947:{"value":"26DB","name":"HEAVY WHITE DOWN-POINTING TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DB"},9948:{"value":"26DC","name":"LEFT CLOSED ENTRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DC"},9949:{"value":"26DD","name":"SQUARED SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DD"},9950:{"value":"26DE","name":"FALLING DIAGONAL IN WHITE CIRCLE IN BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DE"},9951:{"value":"26DF","name":"BLACK TRUCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26DF"},9952:{"value":"26E0","name":"RESTRICTED LEFT ENTRY-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E0"},9953:{"value":"26E1","name":"RESTRICTED LEFT ENTRY-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E1"},9954:{"value":"26E2","name":"ASTRONOMICAL SYMBOL FOR URANUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E2"},9955:{"value":"26E3","name":"HEAVY CIRCLE WITH STROKE AND TWO DOTS ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E3"},9956:{"value":"26E4","name":"PENTAGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E4"},9957:{"value":"26E5","name":"RIGHT-HANDED INTERLACED PENTAGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E5"},9958:{"value":"26E6","name":"LEFT-HANDED INTERLACED PENTAGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E6"},9959:{"value":"26E7","name":"INVERTED PENTAGRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E7"},9960:{"value":"26E8","name":"BLACK CROSS ON SHIELD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E8"},9961:{"value":"26E9","name":"SHINTO SHRINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26E9"},9962:{"value":"26EA","name":"CHURCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26EA"},9963:{"value":"26EB","name":"CASTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26EB"},9964:{"value":"26EC","name":"HISTORIC SITE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26EC"},9965:{"value":"26ED","name":"GEAR WITHOUT HUB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26ED"},9966:{"value":"26EE","name":"GEAR WITH HANDLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26EE"},9967:{"value":"26EF","name":"MAP SYMBOL FOR LIGHTHOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26EF"},9968:{"value":"26F0","name":"MOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F0"},9969:{"value":"26F1","name":"UMBRELLA ON GROUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F1"},9970:{"value":"26F2","name":"FOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F2"},9971:{"value":"26F3","name":"FLAG IN HOLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F3"},9972:{"value":"26F4","name":"FERRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F4"},9973:{"value":"26F5","name":"SAILBOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F5"},9974:{"value":"26F6","name":"SQUARE FOUR CORNERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F6"},9975:{"value":"26F7","name":"SKIER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F7"},9976:{"value":"26F8","name":"ICE SKATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F8"},9977:{"value":"26F9","name":"PERSON WITH BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26F9"},9978:{"value":"26FA","name":"TENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FA"},9979:{"value":"26FB","name":"JAPANESE BANK SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FB"},9980:{"value":"26FC","name":"HEADSTONE GRAVEYARD SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FC"},9981:{"value":"26FD","name":"FUEL PUMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FD"},9982:{"value":"26FE","name":"CUP ON BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FE"},9983:{"value":"26FF","name":"WHITE FLAG WITH HORIZONTAL MIDDLE BLACK STRIPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u26FF"},9984:{"value":"2700","name":"BLACK SAFETY SCISSORS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2700"},9985:{"value":"2701","name":"UPPER BLADE SCISSORS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2701"},9986:{"value":"2702","name":"BLACK SCISSORS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2702"},9987:{"value":"2703","name":"LOWER BLADE SCISSORS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2703"},9988:{"value":"2704","name":"WHITE SCISSORS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2704"},9989:{"value":"2705","name":"WHITE HEAVY CHECK MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2705"},9990:{"value":"2706","name":"TELEPHONE LOCATION SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2706"},9991:{"value":"2707","name":"TAPE DRIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2707"},9992:{"value":"2708","name":"AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2708"},9993:{"value":"2709","name":"ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2709"},9994:{"value":"270A","name":"RAISED FIST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270A"},9995:{"value":"270B","name":"RAISED HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270B"},9996:{"value":"270C","name":"VICTORY HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270C"},9997:{"value":"270D","name":"WRITING HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270D"},9998:{"value":"270E","name":"LOWER RIGHT PENCIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270E"},9999:{"value":"270F","name":"PENCIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u270F"},10000:{"value":"2710","name":"UPPER RIGHT PENCIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2710"},10001:{"value":"2711","name":"WHITE NIB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2711"},10002:{"value":"2712","name":"BLACK NIB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2712"},10003:{"value":"2713","name":"CHECK MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2713"},10004:{"value":"2714","name":"HEAVY CHECK MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2714"},10005:{"value":"2715","name":"MULTIPLICATION X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2715"},10006:{"value":"2716","name":"HEAVY MULTIPLICATION X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2716"},10007:{"value":"2717","name":"BALLOT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2717"},10008:{"value":"2718","name":"HEAVY BALLOT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2718"},10009:{"value":"2719","name":"OUTLINED GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2719"},10010:{"value":"271A","name":"HEAVY GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271A"},10011:{"value":"271B","name":"OPEN CENTRE CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OPEN CENTER CROSS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271B"},10012:{"value":"271C","name":"HEAVY OPEN CENTRE CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY OPEN CENTER CROSS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271C"},10013:{"value":"271D","name":"LATIN CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271D"},10014:{"value":"271E","name":"SHADOWED WHITE LATIN CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271E"},10015:{"value":"271F","name":"OUTLINED LATIN CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u271F"},10016:{"value":"2720","name":"MALTESE CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2720"},10017:{"value":"2721","name":"STAR OF DAVID","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2721"},10018:{"value":"2722","name":"FOUR TEARDROP-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2722"},10019:{"value":"2723","name":"FOUR BALLOON-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2723"},10020:{"value":"2724","name":"HEAVY FOUR BALLOON-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2724"},10021:{"value":"2725","name":"FOUR CLUB-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2725"},10022:{"value":"2726","name":"BLACK FOUR POINTED STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2726"},10023:{"value":"2727","name":"WHITE FOUR POINTED STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2727"},10024:{"value":"2728","name":"SPARKLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2728"},10025:{"value":"2729","name":"STRESS OUTLINED WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2729"},10026:{"value":"272A","name":"CIRCLED WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272A"},10027:{"value":"272B","name":"OPEN CENTRE BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OPEN CENTER BLACK STAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272B"},10028:{"value":"272C","name":"BLACK CENTRE WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK CENTER WHITE STAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272C"},10029:{"value":"272D","name":"OUTLINED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272D"},10030:{"value":"272E","name":"HEAVY OUTLINED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272E"},10031:{"value":"272F","name":"PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u272F"},10032:{"value":"2730","name":"SHADOWED WHITE STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2730"},10033:{"value":"2731","name":"HEAVY ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2731"},10034:{"value":"2732","name":"OPEN CENTRE ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OPEN CENTER ASTERISK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2732"},10035:{"value":"2733","name":"EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2733"},10036:{"value":"2734","name":"EIGHT POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2734"},10037:{"value":"2735","name":"EIGHT POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2735"},10038:{"value":"2736","name":"SIX POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2736"},10039:{"value":"2737","name":"EIGHT POINTED RECTILINEAR BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2737"},10040:{"value":"2738","name":"HEAVY EIGHT POINTED RECTILINEAR BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2738"},10041:{"value":"2739","name":"TWELVE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2739"},10042:{"value":"273A","name":"SIXTEEN POINTED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273A"},10043:{"value":"273B","name":"TEARDROP-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273B"},10044:{"value":"273C","name":"OPEN CENTRE TEARDROP-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OPEN CENTER TEARDROP-SPOKED ASTERISK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273C"},10045:{"value":"273D","name":"HEAVY TEARDROP-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273D"},10046:{"value":"273E","name":"SIX PETALLED BLACK AND WHITE FLORETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273E"},10047:{"value":"273F","name":"BLACK FLORETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u273F"},10048:{"value":"2740","name":"WHITE FLORETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2740"},10049:{"value":"2741","name":"EIGHT PETALLED OUTLINED BLACK FLORETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2741"},10050:{"value":"2742","name":"CIRCLED OPEN CENTRE EIGHT POINTED STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED OPEN CENTER EIGHT POINTED STAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2742"},10051:{"value":"2743","name":"HEAVY TEARDROP-SPOKED PINWHEEL ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2743"},10052:{"value":"2744","name":"SNOWFLAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2744"},10053:{"value":"2745","name":"TIGHT TRIFOLIATE SNOWFLAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2745"},10054:{"value":"2746","name":"HEAVY CHEVRON SNOWFLAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2746"},10055:{"value":"2747","name":"SPARKLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2747"},10056:{"value":"2748","name":"HEAVY SPARKLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2748"},10057:{"value":"2749","name":"BALLOON-SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2749"},10058:{"value":"274A","name":"EIGHT TEARDROP-SPOKED PROPELLER ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274A"},10059:{"value":"274B","name":"HEAVY EIGHT TEARDROP-SPOKED PROPELLER ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274B"},10060:{"value":"274C","name":"CROSS MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274C"},10061:{"value":"274D","name":"SHADOWED WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274D"},10062:{"value":"274E","name":"NEGATIVE SQUARED CROSS MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274E"},10063:{"value":"274F","name":"LOWER RIGHT DROP-SHADOWED WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u274F"},10064:{"value":"2750","name":"UPPER RIGHT DROP-SHADOWED WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2750"},10065:{"value":"2751","name":"LOWER RIGHT SHADOWED WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2751"},10066:{"value":"2752","name":"UPPER RIGHT SHADOWED WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2752"},10067:{"value":"2753","name":"BLACK QUESTION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2753"},10068:{"value":"2754","name":"WHITE QUESTION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2754"},10069:{"value":"2755","name":"WHITE EXCLAMATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2755"},10070:{"value":"2756","name":"BLACK DIAMOND MINUS WHITE X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2756"},10071:{"value":"2757","name":"HEAVY EXCLAMATION MARK SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2757"},10072:{"value":"2758","name":"LIGHT VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2758"},10073:{"value":"2759","name":"MEDIUM VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2759"},10074:{"value":"275A","name":"HEAVY VERTICAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275A"},10075:{"value":"275B","name":"HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275B"},10076:{"value":"275C","name":"HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275C"},10077:{"value":"275D","name":"HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275D"},10078:{"value":"275E","name":"HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275E"},10079:{"value":"275F","name":"HEAVY LOW SINGLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u275F"},10080:{"value":"2760","name":"HEAVY LOW DOUBLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2760"},10081:{"value":"2761","name":"CURVED STEM PARAGRAPH SIGN ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2761"},10082:{"value":"2762","name":"HEAVY EXCLAMATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2762"},10083:{"value":"2763","name":"HEAVY HEART EXCLAMATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2763"},10084:{"value":"2764","name":"HEAVY BLACK HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2764"},10085:{"value":"2765","name":"ROTATED HEAVY BLACK HEART BULLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2765"},10086:{"value":"2766","name":"FLORAL HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2766"},10087:{"value":"2767","name":"ROTATED FLORAL HEART BULLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2767"},10132:{"value":"2794","name":"HEAVY WIDE-HEADED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY WIDE-HEADED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2794"},10133:{"value":"2795","name":"HEAVY PLUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2795"},10134:{"value":"2796","name":"HEAVY MINUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2796"},10135:{"value":"2797","name":"HEAVY DIVISION SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2797"},10136:{"value":"2798","name":"HEAVY SOUTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY LOWER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2798"},10137:{"value":"2799","name":"HEAVY RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2799"},10138:{"value":"279A","name":"HEAVY NORTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY UPPER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279A"},10139:{"value":"279B","name":"DRAFTING POINT RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DRAFTING POINT RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279B"},10140:{"value":"279C","name":"HEAVY ROUND-TIPPED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY ROUND-TIPPED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279C"},10141:{"value":"279D","name":"TRIANGLE-HEADED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"TRIANGLE-HEADED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279D"},10142:{"value":"279E","name":"HEAVY TRIANGLE-HEADED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY TRIANGLE-HEADED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279E"},10143:{"value":"279F","name":"DASHED TRIANGLE-HEADED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"DASHED TRIANGLE-HEADED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u279F"},10144:{"value":"27A0","name":"HEAVY DASHED TRIANGLE-HEADED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY DASHED TRIANGLE-HEADED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A0"},10145:{"value":"27A1","name":"BLACK RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A1"},10146:{"value":"27A2","name":"THREE-D TOP-LIGHTED RIGHTWARDS ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"THREE-D TOP-LIGHTED RIGHT ARROWHEAD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A2"},10147:{"value":"27A3","name":"THREE-D BOTTOM-LIGHTED RIGHTWARDS ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"THREE-D BOTTOM-LIGHTED RIGHT ARROWHEAD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A3"},10148:{"value":"27A4","name":"BLACK RIGHTWARDS ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK RIGHT ARROWHEAD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A4"},10149:{"value":"27A5","name":"HEAVY BLACK CURVED DOWNWARDS AND RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY BLACK CURVED DOWN AND RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A5"},10150:{"value":"27A6","name":"HEAVY BLACK CURVED UPWARDS AND RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY BLACK CURVED UP AND RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A6"},10151:{"value":"27A7","name":"SQUAT BLACK RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUAT BLACK RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A7"},10152:{"value":"27A8","name":"HEAVY CONCAVE-POINTED BLACK RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY CONCAVE-POINTED BLACK RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A8"},10153:{"value":"27A9","name":"RIGHT-SHADED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"RIGHT-SHADED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27A9"},10154:{"value":"27AA","name":"LEFT-SHADED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"LEFT-SHADED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AA"},10155:{"value":"27AB","name":"BACK-TILTED SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BACK-TILTED SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AB"},10156:{"value":"27AC","name":"FRONT-TILTED SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FRONT-TILTED SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AC"},10157:{"value":"27AD","name":"HEAVY LOWER RIGHT-SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY LOWER RIGHT-SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AD"},10158:{"value":"27AE","name":"HEAVY UPPER RIGHT-SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY UPPER RIGHT-SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AE"},10159:{"value":"27AF","name":"NOTCHED LOWER RIGHT-SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"NOTCHED LOWER RIGHT-SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27AF"},10160:{"value":"27B0","name":"CURLY LOOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B0"},10161:{"value":"27B1","name":"NOTCHED UPPER RIGHT-SHADOWED WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"NOTCHED UPPER RIGHT-SHADOWED WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B1"},10162:{"value":"27B2","name":"CIRCLED HEAVY WHITE RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HEAVY WHITE RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B2"},10163:{"value":"27B3","name":"WHITE-FEATHERED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WHITE-FEATHERED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B3"},10164:{"value":"27B4","name":"BLACK-FEATHERED SOUTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK-FEATHERED LOWER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B4"},10165:{"value":"27B5","name":"BLACK-FEATHERED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK-FEATHERED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B5"},10166:{"value":"27B6","name":"BLACK-FEATHERED NORTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"BLACK-FEATHERED UPPER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B6"},10167:{"value":"27B7","name":"HEAVY BLACK-FEATHERED SOUTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY BLACK-FEATHERED LOWER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B7"},10168:{"value":"27B8","name":"HEAVY BLACK-FEATHERED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY BLACK-FEATHERED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B8"},10169:{"value":"27B9","name":"HEAVY BLACK-FEATHERED NORTH EAST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY BLACK-FEATHERED UPPER RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27B9"},10170:{"value":"27BA","name":"TEARDROP-BARBED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"TEARDROP-BARBED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BA"},10171:{"value":"27BB","name":"HEAVY TEARDROP-SHANKED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY TEARDROP-SHANKED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BB"},10172:{"value":"27BC","name":"WEDGE-TAILED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"WEDGE-TAILED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BC"},10173:{"value":"27BD","name":"HEAVY WEDGE-TAILED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"HEAVY WEDGE-TAILED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BD"},10174:{"value":"27BE","name":"OPEN-OUTLINED RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"OPEN-OUTLINED RIGHT ARROW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BE"},10175:{"value":"27BF","name":"DOUBLE CURLY LOOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u27BF"},10240:{"value":"2800","name":"BRAILLE PATTERN BLANK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2800"},10241:{"value":"2801","name":"BRAILLE PATTERN DOTS-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2801"},10242:{"value":"2802","name":"BRAILLE PATTERN DOTS-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2802"},10243:{"value":"2803","name":"BRAILLE PATTERN DOTS-12","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2803"},10244:{"value":"2804","name":"BRAILLE PATTERN DOTS-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2804"},10245:{"value":"2805","name":"BRAILLE PATTERN DOTS-13","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2805"},10246:{"value":"2806","name":"BRAILLE PATTERN DOTS-23","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2806"},10247:{"value":"2807","name":"BRAILLE PATTERN DOTS-123","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2807"},10248:{"value":"2808","name":"BRAILLE PATTERN DOTS-4","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2808"},10249:{"value":"2809","name":"BRAILLE PATTERN DOTS-14","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2809"},10250:{"value":"280A","name":"BRAILLE PATTERN DOTS-24","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280A"},10251:{"value":"280B","name":"BRAILLE PATTERN DOTS-124","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280B"},10252:{"value":"280C","name":"BRAILLE PATTERN DOTS-34","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280C"},10253:{"value":"280D","name":"BRAILLE PATTERN DOTS-134","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280D"},10254:{"value":"280E","name":"BRAILLE PATTERN DOTS-234","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280E"},10255:{"value":"280F","name":"BRAILLE PATTERN DOTS-1234","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u280F"},10256:{"value":"2810","name":"BRAILLE PATTERN DOTS-5","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2810"},10257:{"value":"2811","name":"BRAILLE PATTERN DOTS-15","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2811"},10258:{"value":"2812","name":"BRAILLE PATTERN DOTS-25","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2812"},10259:{"value":"2813","name":"BRAILLE PATTERN DOTS-125","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2813"},10260:{"value":"2814","name":"BRAILLE PATTERN DOTS-35","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2814"},10261:{"value":"2815","name":"BRAILLE PATTERN DOTS-135","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2815"},10262:{"value":"2816","name":"BRAILLE PATTERN DOTS-235","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2816"},10263:{"value":"2817","name":"BRAILLE PATTERN DOTS-1235","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2817"},10264:{"value":"2818","name":"BRAILLE PATTERN DOTS-45","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2818"},10265:{"value":"2819","name":"BRAILLE PATTERN DOTS-145","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2819"},10266:{"value":"281A","name":"BRAILLE PATTERN DOTS-245","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281A"},10267:{"value":"281B","name":"BRAILLE PATTERN DOTS-1245","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281B"},10268:{"value":"281C","name":"BRAILLE PATTERN DOTS-345","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281C"},10269:{"value":"281D","name":"BRAILLE PATTERN DOTS-1345","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281D"},10270:{"value":"281E","name":"BRAILLE PATTERN DOTS-2345","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281E"},10271:{"value":"281F","name":"BRAILLE PATTERN DOTS-12345","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u281F"},10272:{"value":"2820","name":"BRAILLE PATTERN DOTS-6","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2820"},10273:{"value":"2821","name":"BRAILLE PATTERN DOTS-16","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2821"},10274:{"value":"2822","name":"BRAILLE PATTERN DOTS-26","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2822"},10275:{"value":"2823","name":"BRAILLE PATTERN DOTS-126","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2823"},10276:{"value":"2824","name":"BRAILLE PATTERN DOTS-36","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2824"},10277:{"value":"2825","name":"BRAILLE PATTERN DOTS-136","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2825"},10278:{"value":"2826","name":"BRAILLE PATTERN DOTS-236","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2826"},10279:{"value":"2827","name":"BRAILLE PATTERN DOTS-1236","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2827"},10280:{"value":"2828","name":"BRAILLE PATTERN DOTS-46","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2828"},10281:{"value":"2829","name":"BRAILLE PATTERN DOTS-146","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2829"},10282:{"value":"282A","name":"BRAILLE PATTERN DOTS-246","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282A"},10283:{"value":"282B","name":"BRAILLE PATTERN DOTS-1246","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282B"},10284:{"value":"282C","name":"BRAILLE PATTERN DOTS-346","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282C"},10285:{"value":"282D","name":"BRAILLE PATTERN DOTS-1346","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282D"},10286:{"value":"282E","name":"BRAILLE PATTERN DOTS-2346","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282E"},10287:{"value":"282F","name":"BRAILLE PATTERN DOTS-12346","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u282F"},10288:{"value":"2830","name":"BRAILLE PATTERN DOTS-56","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2830"},10289:{"value":"2831","name":"BRAILLE PATTERN DOTS-156","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2831"},10290:{"value":"2832","name":"BRAILLE PATTERN DOTS-256","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2832"},10291:{"value":"2833","name":"BRAILLE PATTERN DOTS-1256","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2833"},10292:{"value":"2834","name":"BRAILLE PATTERN DOTS-356","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2834"},10293:{"value":"2835","name":"BRAILLE PATTERN DOTS-1356","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2835"},10294:{"value":"2836","name":"BRAILLE PATTERN DOTS-2356","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2836"},10295:{"value":"2837","name":"BRAILLE PATTERN DOTS-12356","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2837"},10296:{"value":"2838","name":"BRAILLE PATTERN DOTS-456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2838"},10297:{"value":"2839","name":"BRAILLE PATTERN DOTS-1456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2839"},10298:{"value":"283A","name":"BRAILLE PATTERN DOTS-2456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283A"},10299:{"value":"283B","name":"BRAILLE PATTERN DOTS-12456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283B"},10300:{"value":"283C","name":"BRAILLE PATTERN DOTS-3456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283C"},10301:{"value":"283D","name":"BRAILLE PATTERN DOTS-13456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283D"},10302:{"value":"283E","name":"BRAILLE PATTERN DOTS-23456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283E"},10303:{"value":"283F","name":"BRAILLE PATTERN DOTS-123456","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u283F"},10304:{"value":"2840","name":"BRAILLE PATTERN DOTS-7","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2840"},10305:{"value":"2841","name":"BRAILLE PATTERN DOTS-17","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2841"},10306:{"value":"2842","name":"BRAILLE PATTERN DOTS-27","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2842"},10307:{"value":"2843","name":"BRAILLE PATTERN DOTS-127","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2843"},10308:{"value":"2844","name":"BRAILLE PATTERN DOTS-37","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2844"},10309:{"value":"2845","name":"BRAILLE PATTERN DOTS-137","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2845"},10310:{"value":"2846","name":"BRAILLE PATTERN DOTS-237","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2846"},10311:{"value":"2847","name":"BRAILLE PATTERN DOTS-1237","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2847"},10312:{"value":"2848","name":"BRAILLE PATTERN DOTS-47","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2848"},10313:{"value":"2849","name":"BRAILLE PATTERN DOTS-147","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2849"},10314:{"value":"284A","name":"BRAILLE PATTERN DOTS-247","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284A"},10315:{"value":"284B","name":"BRAILLE PATTERN DOTS-1247","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284B"},10316:{"value":"284C","name":"BRAILLE PATTERN DOTS-347","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284C"},10317:{"value":"284D","name":"BRAILLE PATTERN DOTS-1347","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284D"},10318:{"value":"284E","name":"BRAILLE PATTERN DOTS-2347","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284E"},10319:{"value":"284F","name":"BRAILLE PATTERN DOTS-12347","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u284F"},10320:{"value":"2850","name":"BRAILLE PATTERN DOTS-57","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2850"},10321:{"value":"2851","name":"BRAILLE PATTERN DOTS-157","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2851"},10322:{"value":"2852","name":"BRAILLE PATTERN DOTS-257","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2852"},10323:{"value":"2853","name":"BRAILLE PATTERN DOTS-1257","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2853"},10324:{"value":"2854","name":"BRAILLE PATTERN DOTS-357","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2854"},10325:{"value":"2855","name":"BRAILLE PATTERN DOTS-1357","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2855"},10326:{"value":"2856","name":"BRAILLE PATTERN DOTS-2357","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2856"},10327:{"value":"2857","name":"BRAILLE PATTERN DOTS-12357","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2857"},10328:{"value":"2858","name":"BRAILLE PATTERN DOTS-457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2858"},10329:{"value":"2859","name":"BRAILLE PATTERN DOTS-1457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2859"},10330:{"value":"285A","name":"BRAILLE PATTERN DOTS-2457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285A"},10331:{"value":"285B","name":"BRAILLE PATTERN DOTS-12457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285B"},10332:{"value":"285C","name":"BRAILLE PATTERN DOTS-3457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285C"},10333:{"value":"285D","name":"BRAILLE PATTERN DOTS-13457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285D"},10334:{"value":"285E","name":"BRAILLE PATTERN DOTS-23457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285E"},10335:{"value":"285F","name":"BRAILLE PATTERN DOTS-123457","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u285F"},10336:{"value":"2860","name":"BRAILLE PATTERN DOTS-67","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2860"},10337:{"value":"2861","name":"BRAILLE PATTERN DOTS-167","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2861"},10338:{"value":"2862","name":"BRAILLE PATTERN DOTS-267","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2862"},10339:{"value":"2863","name":"BRAILLE PATTERN DOTS-1267","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2863"},10340:{"value":"2864","name":"BRAILLE PATTERN DOTS-367","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2864"},10341:{"value":"2865","name":"BRAILLE PATTERN DOTS-1367","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2865"},10342:{"value":"2866","name":"BRAILLE PATTERN DOTS-2367","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2866"},10343:{"value":"2867","name":"BRAILLE PATTERN DOTS-12367","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2867"},10344:{"value":"2868","name":"BRAILLE PATTERN DOTS-467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2868"},10345:{"value":"2869","name":"BRAILLE PATTERN DOTS-1467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2869"},10346:{"value":"286A","name":"BRAILLE PATTERN DOTS-2467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286A"},10347:{"value":"286B","name":"BRAILLE PATTERN DOTS-12467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286B"},10348:{"value":"286C","name":"BRAILLE PATTERN DOTS-3467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286C"},10349:{"value":"286D","name":"BRAILLE PATTERN DOTS-13467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286D"},10350:{"value":"286E","name":"BRAILLE PATTERN DOTS-23467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286E"},10351:{"value":"286F","name":"BRAILLE PATTERN DOTS-123467","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u286F"},10352:{"value":"2870","name":"BRAILLE PATTERN DOTS-567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2870"},10353:{"value":"2871","name":"BRAILLE PATTERN DOTS-1567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2871"},10354:{"value":"2872","name":"BRAILLE PATTERN DOTS-2567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2872"},10355:{"value":"2873","name":"BRAILLE PATTERN DOTS-12567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2873"},10356:{"value":"2874","name":"BRAILLE PATTERN DOTS-3567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2874"},10357:{"value":"2875","name":"BRAILLE PATTERN DOTS-13567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2875"},10358:{"value":"2876","name":"BRAILLE PATTERN DOTS-23567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2876"},10359:{"value":"2877","name":"BRAILLE PATTERN DOTS-123567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2877"},10360:{"value":"2878","name":"BRAILLE PATTERN DOTS-4567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2878"},10361:{"value":"2879","name":"BRAILLE PATTERN DOTS-14567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2879"},10362:{"value":"287A","name":"BRAILLE PATTERN DOTS-24567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287A"},10363:{"value":"287B","name":"BRAILLE PATTERN DOTS-124567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287B"},10364:{"value":"287C","name":"BRAILLE PATTERN DOTS-34567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287C"},10365:{"value":"287D","name":"BRAILLE PATTERN DOTS-134567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287D"},10366:{"value":"287E","name":"BRAILLE PATTERN DOTS-234567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287E"},10367:{"value":"287F","name":"BRAILLE PATTERN DOTS-1234567","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u287F"},10368:{"value":"2880","name":"BRAILLE PATTERN DOTS-8","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2880"},10369:{"value":"2881","name":"BRAILLE PATTERN DOTS-18","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2881"},10370:{"value":"2882","name":"BRAILLE PATTERN DOTS-28","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2882"},10371:{"value":"2883","name":"BRAILLE PATTERN DOTS-128","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2883"},10372:{"value":"2884","name":"BRAILLE PATTERN DOTS-38","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2884"},10373:{"value":"2885","name":"BRAILLE PATTERN DOTS-138","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2885"},10374:{"value":"2886","name":"BRAILLE PATTERN DOTS-238","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2886"},10375:{"value":"2887","name":"BRAILLE PATTERN DOTS-1238","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2887"},10376:{"value":"2888","name":"BRAILLE PATTERN DOTS-48","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2888"},10377:{"value":"2889","name":"BRAILLE PATTERN DOTS-148","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2889"},10378:{"value":"288A","name":"BRAILLE PATTERN DOTS-248","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288A"},10379:{"value":"288B","name":"BRAILLE PATTERN DOTS-1248","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288B"},10380:{"value":"288C","name":"BRAILLE PATTERN DOTS-348","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288C"},10381:{"value":"288D","name":"BRAILLE PATTERN DOTS-1348","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288D"},10382:{"value":"288E","name":"BRAILLE PATTERN DOTS-2348","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288E"},10383:{"value":"288F","name":"BRAILLE PATTERN DOTS-12348","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u288F"},10384:{"value":"2890","name":"BRAILLE PATTERN DOTS-58","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2890"},10385:{"value":"2891","name":"BRAILLE PATTERN DOTS-158","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2891"},10386:{"value":"2892","name":"BRAILLE PATTERN DOTS-258","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2892"},10387:{"value":"2893","name":"BRAILLE PATTERN DOTS-1258","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2893"},10388:{"value":"2894","name":"BRAILLE PATTERN DOTS-358","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2894"},10389:{"value":"2895","name":"BRAILLE PATTERN DOTS-1358","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2895"},10390:{"value":"2896","name":"BRAILLE PATTERN DOTS-2358","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2896"},10391:{"value":"2897","name":"BRAILLE PATTERN DOTS-12358","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2897"},10392:{"value":"2898","name":"BRAILLE PATTERN DOTS-458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2898"},10393:{"value":"2899","name":"BRAILLE PATTERN DOTS-1458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2899"},10394:{"value":"289A","name":"BRAILLE PATTERN DOTS-2458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289A"},10395:{"value":"289B","name":"BRAILLE PATTERN DOTS-12458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289B"},10396:{"value":"289C","name":"BRAILLE PATTERN DOTS-3458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289C"},10397:{"value":"289D","name":"BRAILLE PATTERN DOTS-13458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289D"},10398:{"value":"289E","name":"BRAILLE PATTERN DOTS-23458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289E"},10399:{"value":"289F","name":"BRAILLE PATTERN DOTS-123458","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u289F"},10400:{"value":"28A0","name":"BRAILLE PATTERN DOTS-68","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A0"},10401:{"value":"28A1","name":"BRAILLE PATTERN DOTS-168","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A1"},10402:{"value":"28A2","name":"BRAILLE PATTERN DOTS-268","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A2"},10403:{"value":"28A3","name":"BRAILLE PATTERN DOTS-1268","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A3"},10404:{"value":"28A4","name":"BRAILLE PATTERN DOTS-368","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A4"},10405:{"value":"28A5","name":"BRAILLE PATTERN DOTS-1368","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A5"},10406:{"value":"28A6","name":"BRAILLE PATTERN DOTS-2368","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A6"},10407:{"value":"28A7","name":"BRAILLE PATTERN DOTS-12368","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A7"},10408:{"value":"28A8","name":"BRAILLE PATTERN DOTS-468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A8"},10409:{"value":"28A9","name":"BRAILLE PATTERN DOTS-1468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28A9"},10410:{"value":"28AA","name":"BRAILLE PATTERN DOTS-2468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AA"},10411:{"value":"28AB","name":"BRAILLE PATTERN DOTS-12468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AB"},10412:{"value":"28AC","name":"BRAILLE PATTERN DOTS-3468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AC"},10413:{"value":"28AD","name":"BRAILLE PATTERN DOTS-13468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AD"},10414:{"value":"28AE","name":"BRAILLE PATTERN DOTS-23468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AE"},10415:{"value":"28AF","name":"BRAILLE PATTERN DOTS-123468","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28AF"},10416:{"value":"28B0","name":"BRAILLE PATTERN DOTS-568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B0"},10417:{"value":"28B1","name":"BRAILLE PATTERN DOTS-1568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B1"},10418:{"value":"28B2","name":"BRAILLE PATTERN DOTS-2568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B2"},10419:{"value":"28B3","name":"BRAILLE PATTERN DOTS-12568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B3"},10420:{"value":"28B4","name":"BRAILLE PATTERN DOTS-3568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B4"},10421:{"value":"28B5","name":"BRAILLE PATTERN DOTS-13568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B5"},10422:{"value":"28B6","name":"BRAILLE PATTERN DOTS-23568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B6"},10423:{"value":"28B7","name":"BRAILLE PATTERN DOTS-123568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B7"},10424:{"value":"28B8","name":"BRAILLE PATTERN DOTS-4568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B8"},10425:{"value":"28B9","name":"BRAILLE PATTERN DOTS-14568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28B9"},10426:{"value":"28BA","name":"BRAILLE PATTERN DOTS-24568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BA"},10427:{"value":"28BB","name":"BRAILLE PATTERN DOTS-124568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BB"},10428:{"value":"28BC","name":"BRAILLE PATTERN DOTS-34568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BC"},10429:{"value":"28BD","name":"BRAILLE PATTERN DOTS-134568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BD"},10430:{"value":"28BE","name":"BRAILLE PATTERN DOTS-234568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BE"},10431:{"value":"28BF","name":"BRAILLE PATTERN DOTS-1234568","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28BF"},10432:{"value":"28C0","name":"BRAILLE PATTERN DOTS-78","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C0"},10433:{"value":"28C1","name":"BRAILLE PATTERN DOTS-178","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C1"},10434:{"value":"28C2","name":"BRAILLE PATTERN DOTS-278","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C2"},10435:{"value":"28C3","name":"BRAILLE PATTERN DOTS-1278","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C3"},10436:{"value":"28C4","name":"BRAILLE PATTERN DOTS-378","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C4"},10437:{"value":"28C5","name":"BRAILLE PATTERN DOTS-1378","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C5"},10438:{"value":"28C6","name":"BRAILLE PATTERN DOTS-2378","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C6"},10439:{"value":"28C7","name":"BRAILLE PATTERN DOTS-12378","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C7"},10440:{"value":"28C8","name":"BRAILLE PATTERN DOTS-478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C8"},10441:{"value":"28C9","name":"BRAILLE PATTERN DOTS-1478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28C9"},10442:{"value":"28CA","name":"BRAILLE PATTERN DOTS-2478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CA"},10443:{"value":"28CB","name":"BRAILLE PATTERN DOTS-12478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CB"},10444:{"value":"28CC","name":"BRAILLE PATTERN DOTS-3478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CC"},10445:{"value":"28CD","name":"BRAILLE PATTERN DOTS-13478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CD"},10446:{"value":"28CE","name":"BRAILLE PATTERN DOTS-23478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CE"},10447:{"value":"28CF","name":"BRAILLE PATTERN DOTS-123478","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28CF"},10448:{"value":"28D0","name":"BRAILLE PATTERN DOTS-578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D0"},10449:{"value":"28D1","name":"BRAILLE PATTERN DOTS-1578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D1"},10450:{"value":"28D2","name":"BRAILLE PATTERN DOTS-2578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D2"},10451:{"value":"28D3","name":"BRAILLE PATTERN DOTS-12578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D3"},10452:{"value":"28D4","name":"BRAILLE PATTERN DOTS-3578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D4"},10453:{"value":"28D5","name":"BRAILLE PATTERN DOTS-13578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D5"},10454:{"value":"28D6","name":"BRAILLE PATTERN DOTS-23578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D6"},10455:{"value":"28D7","name":"BRAILLE PATTERN DOTS-123578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D7"},10456:{"value":"28D8","name":"BRAILLE PATTERN DOTS-4578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D8"},10457:{"value":"28D9","name":"BRAILLE PATTERN DOTS-14578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28D9"},10458:{"value":"28DA","name":"BRAILLE PATTERN DOTS-24578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DA"},10459:{"value":"28DB","name":"BRAILLE PATTERN DOTS-124578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DB"},10460:{"value":"28DC","name":"BRAILLE PATTERN DOTS-34578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DC"},10461:{"value":"28DD","name":"BRAILLE PATTERN DOTS-134578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DD"},10462:{"value":"28DE","name":"BRAILLE PATTERN DOTS-234578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DE"},10463:{"value":"28DF","name":"BRAILLE PATTERN DOTS-1234578","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28DF"},10464:{"value":"28E0","name":"BRAILLE PATTERN DOTS-678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E0"},10465:{"value":"28E1","name":"BRAILLE PATTERN DOTS-1678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E1"},10466:{"value":"28E2","name":"BRAILLE PATTERN DOTS-2678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E2"},10467:{"value":"28E3","name":"BRAILLE PATTERN DOTS-12678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E3"},10468:{"value":"28E4","name":"BRAILLE PATTERN DOTS-3678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E4"},10469:{"value":"28E5","name":"BRAILLE PATTERN DOTS-13678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E5"},10470:{"value":"28E6","name":"BRAILLE PATTERN DOTS-23678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E6"},10471:{"value":"28E7","name":"BRAILLE PATTERN DOTS-123678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E7"},10472:{"value":"28E8","name":"BRAILLE PATTERN DOTS-4678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E8"},10473:{"value":"28E9","name":"BRAILLE PATTERN DOTS-14678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28E9"},10474:{"value":"28EA","name":"BRAILLE PATTERN DOTS-24678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28EA"},10475:{"value":"28EB","name":"BRAILLE PATTERN DOTS-124678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28EB"},10476:{"value":"28EC","name":"BRAILLE PATTERN DOTS-34678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28EC"},10477:{"value":"28ED","name":"BRAILLE PATTERN DOTS-134678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28ED"},10478:{"value":"28EE","name":"BRAILLE PATTERN DOTS-234678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28EE"},10479:{"value":"28EF","name":"BRAILLE PATTERN DOTS-1234678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28EF"},10480:{"value":"28F0","name":"BRAILLE PATTERN DOTS-5678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F0"},10481:{"value":"28F1","name":"BRAILLE PATTERN DOTS-15678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F1"},10482:{"value":"28F2","name":"BRAILLE PATTERN DOTS-25678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F2"},10483:{"value":"28F3","name":"BRAILLE PATTERN DOTS-125678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F3"},10484:{"value":"28F4","name":"BRAILLE PATTERN DOTS-35678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F4"},10485:{"value":"28F5","name":"BRAILLE PATTERN DOTS-135678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F5"},10486:{"value":"28F6","name":"BRAILLE PATTERN DOTS-235678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F6"},10487:{"value":"28F7","name":"BRAILLE PATTERN DOTS-1235678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F7"},10488:{"value":"28F8","name":"BRAILLE PATTERN DOTS-45678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F8"},10489:{"value":"28F9","name":"BRAILLE PATTERN DOTS-145678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28F9"},10490:{"value":"28FA","name":"BRAILLE PATTERN DOTS-245678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FA"},10491:{"value":"28FB","name":"BRAILLE PATTERN DOTS-1245678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FB"},10492:{"value":"28FC","name":"BRAILLE PATTERN DOTS-345678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FC"},10493:{"value":"28FD","name":"BRAILLE PATTERN DOTS-1345678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FD"},10494:{"value":"28FE","name":"BRAILLE PATTERN DOTS-2345678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FE"},10495:{"value":"28FF","name":"BRAILLE PATTERN DOTS-12345678","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u28FF"},11008:{"value":"2B00","name":"NORTH EAST WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B00"},11009:{"value":"2B01","name":"NORTH WEST WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B01"},11010:{"value":"2B02","name":"SOUTH EAST WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B02"},11011:{"value":"2B03","name":"SOUTH WEST WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B03"},11012:{"value":"2B04","name":"LEFT RIGHT WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B04"},11013:{"value":"2B05","name":"LEFTWARDS BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B05"},11014:{"value":"2B06","name":"UPWARDS BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B06"},11015:{"value":"2B07","name":"DOWNWARDS BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B07"},11016:{"value":"2B08","name":"NORTH EAST BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B08"},11017:{"value":"2B09","name":"NORTH WEST BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B09"},11018:{"value":"2B0A","name":"SOUTH EAST BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0A"},11019:{"value":"2B0B","name":"SOUTH WEST BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0B"},11020:{"value":"2B0C","name":"LEFT RIGHT BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0C"},11021:{"value":"2B0D","name":"UP DOWN BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0D"},11022:{"value":"2B0E","name":"RIGHTWARDS ARROW WITH TIP DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0E"},11023:{"value":"2B0F","name":"RIGHTWARDS ARROW WITH TIP UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B0F"},11024:{"value":"2B10","name":"LEFTWARDS ARROW WITH TIP DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B10"},11025:{"value":"2B11","name":"LEFTWARDS ARROW WITH TIP UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B11"},11026:{"value":"2B12","name":"SQUARE WITH TOP HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B12"},11027:{"value":"2B13","name":"SQUARE WITH BOTTOM HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B13"},11028:{"value":"2B14","name":"SQUARE WITH UPPER RIGHT DIAGONAL HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B14"},11029:{"value":"2B15","name":"SQUARE WITH LOWER LEFT DIAGONAL HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B15"},11030:{"value":"2B16","name":"DIAMOND WITH LEFT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B16"},11031:{"value":"2B17","name":"DIAMOND WITH RIGHT HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B17"},11032:{"value":"2B18","name":"DIAMOND WITH TOP HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B18"},11033:{"value":"2B19","name":"DIAMOND WITH BOTTOM HALF BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B19"},11034:{"value":"2B1A","name":"DOTTED SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1A"},11035:{"value":"2B1B","name":"BLACK LARGE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1B"},11036:{"value":"2B1C","name":"WHITE LARGE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1C"},11037:{"value":"2B1D","name":"BLACK VERY SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1D"},11038:{"value":"2B1E","name":"WHITE VERY SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1E"},11039:{"value":"2B1F","name":"BLACK PENTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B1F"},11040:{"value":"2B20","name":"WHITE PENTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B20"},11041:{"value":"2B21","name":"WHITE HEXAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B21"},11042:{"value":"2B22","name":"BLACK HEXAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B22"},11043:{"value":"2B23","name":"HORIZONTAL BLACK HEXAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B23"},11044:{"value":"2B24","name":"BLACK LARGE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B24"},11045:{"value":"2B25","name":"BLACK MEDIUM DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B25"},11046:{"value":"2B26","name":"WHITE MEDIUM DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B26"},11047:{"value":"2B27","name":"BLACK MEDIUM LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B27"},11048:{"value":"2B28","name":"WHITE MEDIUM LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B28"},11049:{"value":"2B29","name":"BLACK SMALL DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B29"},11050:{"value":"2B2A","name":"BLACK SMALL LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2A"},11051:{"value":"2B2B","name":"WHITE SMALL LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2B"},11052:{"value":"2B2C","name":"BLACK HORIZONTAL ELLIPSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2C"},11053:{"value":"2B2D","name":"WHITE HORIZONTAL ELLIPSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2D"},11054:{"value":"2B2E","name":"BLACK VERTICAL ELLIPSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2E"},11055:{"value":"2B2F","name":"WHITE VERTICAL ELLIPSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B2F"},11077:{"value":"2B45","name":"LEFTWARDS QUADRUPLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B45"},11078:{"value":"2B46","name":"RIGHTWARDS QUADRUPLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B46"},11085:{"value":"2B4D","name":"DOWNWARDS TRIANGLE-HEADED ZIGZAG ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B4D"},11086:{"value":"2B4E","name":"SHORT SLANTED NORTH ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B4E"},11087:{"value":"2B4F","name":"SHORT BACKSLANTED SOUTH ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B4F"},11088:{"value":"2B50","name":"WHITE MEDIUM STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B50"},11089:{"value":"2B51","name":"BLACK SMALL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B51"},11090:{"value":"2B52","name":"WHITE SMALL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B52"},11091:{"value":"2B53","name":"BLACK RIGHT-POINTING PENTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B53"},11092:{"value":"2B54","name":"WHITE RIGHT-POINTING PENTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B54"},11093:{"value":"2B55","name":"HEAVY LARGE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B55"},11094:{"value":"2B56","name":"HEAVY OVAL WITH OVAL INSIDE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B56"},11095:{"value":"2B57","name":"HEAVY CIRCLE WITH CIRCLE INSIDE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B57"},11096:{"value":"2B58","name":"HEAVY CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B58"},11097:{"value":"2B59","name":"HEAVY CIRCLED SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B59"},11098:{"value":"2B5A","name":"SLANTED NORTH ARROW WITH HOOKED HEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5A"},11099:{"value":"2B5B","name":"BACKSLANTED SOUTH ARROW WITH HOOKED TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5B"},11100:{"value":"2B5C","name":"SLANTED NORTH ARROW WITH HORIZONTAL TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5C"},11101:{"value":"2B5D","name":"BACKSLANTED SOUTH ARROW WITH HORIZONTAL TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5D"},11102:{"value":"2B5E","name":"BENT ARROW POINTING DOWNWARDS THEN NORTH EAST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5E"},11103:{"value":"2B5F","name":"SHORT BENT ARROW POINTING DOWNWARDS THEN NORTH EAST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B5F"},11104:{"value":"2B60","name":"LEFTWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B60"},11105:{"value":"2B61","name":"UPWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B61"},11106:{"value":"2B62","name":"RIGHTWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B62"},11107:{"value":"2B63","name":"DOWNWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B63"},11108:{"value":"2B64","name":"LEFT RIGHT TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B64"},11109:{"value":"2B65","name":"UP DOWN TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B65"},11110:{"value":"2B66","name":"NORTH WEST TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B66"},11111:{"value":"2B67","name":"NORTH EAST TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B67"},11112:{"value":"2B68","name":"SOUTH EAST TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B68"},11113:{"value":"2B69","name":"SOUTH WEST TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B69"},11114:{"value":"2B6A","name":"LEFTWARDS TRIANGLE-HEADED DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6A"},11115:{"value":"2B6B","name":"UPWARDS TRIANGLE-HEADED DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6B"},11116:{"value":"2B6C","name":"RIGHTWARDS TRIANGLE-HEADED DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6C"},11117:{"value":"2B6D","name":"DOWNWARDS TRIANGLE-HEADED DASHED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6D"},11118:{"value":"2B6E","name":"CLOCKWISE TRIANGLE-HEADED OPEN CIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6E"},11119:{"value":"2B6F","name":"ANTICLOCKWISE TRIANGLE-HEADED OPEN CIRCLE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B6F"},11120:{"value":"2B70","name":"LEFTWARDS TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B70"},11121:{"value":"2B71","name":"UPWARDS TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B71"},11122:{"value":"2B72","name":"RIGHTWARDS TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B72"},11123:{"value":"2B73","name":"DOWNWARDS TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B73"},11126:{"value":"2B76","name":"NORTH WEST TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B76"},11127:{"value":"2B77","name":"NORTH EAST TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B77"},11128:{"value":"2B78","name":"SOUTH EAST TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B78"},11129:{"value":"2B79","name":"SOUTH WEST TRIANGLE-HEADED ARROW TO BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B79"},11130:{"value":"2B7A","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH DOUBLE HORIZONTAL STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7A"},11131:{"value":"2B7B","name":"UPWARDS TRIANGLE-HEADED ARROW WITH DOUBLE HORIZONTAL STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7B"},11132:{"value":"2B7C","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH DOUBLE HORIZONTAL STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7C"},11133:{"value":"2B7D","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH DOUBLE HORIZONTAL STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7D"},11134:{"value":"2B7E","name":"HORIZONTAL TAB KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7E"},11135:{"value":"2B7F","name":"VERTICAL TAB KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B7F"},11136:{"value":"2B80","name":"LEFTWARDS TRIANGLE-HEADED ARROW OVER RIGHTWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B80"},11137:{"value":"2B81","name":"UPWARDS TRIANGLE-HEADED ARROW LEFTWARDS OF DOWNWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B81"},11138:{"value":"2B82","name":"RIGHTWARDS TRIANGLE-HEADED ARROW OVER LEFTWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B82"},11139:{"value":"2B83","name":"DOWNWARDS TRIANGLE-HEADED ARROW LEFTWARDS OF UPWARDS TRIANGLE-HEADED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B83"},11140:{"value":"2B84","name":"LEFTWARDS TRIANGLE-HEADED PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B84"},11141:{"value":"2B85","name":"UPWARDS TRIANGLE-HEADED PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B85"},11142:{"value":"2B86","name":"RIGHTWARDS TRIANGLE-HEADED PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B86"},11143:{"value":"2B87","name":"DOWNWARDS TRIANGLE-HEADED PAIRED ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B87"},11144:{"value":"2B88","name":"LEFTWARDS BLACK CIRCLED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B88"},11145:{"value":"2B89","name":"UPWARDS BLACK CIRCLED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B89"},11146:{"value":"2B8A","name":"RIGHTWARDS BLACK CIRCLED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8A"},11147:{"value":"2B8B","name":"DOWNWARDS BLACK CIRCLED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8B"},11148:{"value":"2B8C","name":"ANTICLOCKWISE TRIANGLE-HEADED RIGHT U-SHAPED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8C"},11149:{"value":"2B8D","name":"ANTICLOCKWISE TRIANGLE-HEADED BOTTOM U-SHAPED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8D"},11150:{"value":"2B8E","name":"ANTICLOCKWISE TRIANGLE-HEADED LEFT U-SHAPED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8E"},11151:{"value":"2B8F","name":"ANTICLOCKWISE TRIANGLE-HEADED TOP U-SHAPED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B8F"},11152:{"value":"2B90","name":"RETURN LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B90"},11153:{"value":"2B91","name":"RETURN RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B91"},11154:{"value":"2B92","name":"NEWLINE LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B92"},11155:{"value":"2B93","name":"NEWLINE RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B93"},11156:{"value":"2B94","name":"FOUR CORNER ARROWS CIRCLING ANTICLOCKWISE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B94"},11157:{"value":"2B95","name":"RIGHTWARDS BLACK ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B95"},11160:{"value":"2B98","name":"THREE-D TOP-LIGHTED LEFTWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B98"},11161:{"value":"2B99","name":"THREE-D RIGHT-LIGHTED UPWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B99"},11162:{"value":"2B9A","name":"THREE-D TOP-LIGHTED RIGHTWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9A"},11163:{"value":"2B9B","name":"THREE-D LEFT-LIGHTED DOWNWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9B"},11164:{"value":"2B9C","name":"BLACK LEFTWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9C"},11165:{"value":"2B9D","name":"BLACK UPWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9D"},11166:{"value":"2B9E","name":"BLACK RIGHTWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9E"},11167:{"value":"2B9F","name":"BLACK DOWNWARDS EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2B9F"},11168:{"value":"2BA0","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH LONG TIP LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA0"},11169:{"value":"2BA1","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH LONG TIP RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA1"},11170:{"value":"2BA2","name":"UPWARDS TRIANGLE-HEADED ARROW WITH LONG TIP LEFTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA2"},11171:{"value":"2BA3","name":"UPWARDS TRIANGLE-HEADED ARROW WITH LONG TIP RIGHTWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA3"},11172:{"value":"2BA4","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH LONG TIP UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA4"},11173:{"value":"2BA5","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH LONG TIP UPWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA5"},11174:{"value":"2BA6","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH LONG TIP DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA6"},11175:{"value":"2BA7","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH LONG TIP DOWNWARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA7"},11176:{"value":"2BA8","name":"BLACK CURVED DOWNWARDS AND LEFTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA8"},11177:{"value":"2BA9","name":"BLACK CURVED DOWNWARDS AND RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BA9"},11178:{"value":"2BAA","name":"BLACK CURVED UPWARDS AND LEFTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAA"},11179:{"value":"2BAB","name":"BLACK CURVED UPWARDS AND RIGHTWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAB"},11180:{"value":"2BAC","name":"BLACK CURVED LEFTWARDS AND UPWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAC"},11181:{"value":"2BAD","name":"BLACK CURVED RIGHTWARDS AND UPWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAD"},11182:{"value":"2BAE","name":"BLACK CURVED LEFTWARDS AND DOWNWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAE"},11183:{"value":"2BAF","name":"BLACK CURVED RIGHTWARDS AND DOWNWARDS ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BAF"},11184:{"value":"2BB0","name":"RIBBON ARROW DOWN LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB0"},11185:{"value":"2BB1","name":"RIBBON ARROW DOWN RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB1"},11186:{"value":"2BB2","name":"RIBBON ARROW UP LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB2"},11187:{"value":"2BB3","name":"RIBBON ARROW UP RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB3"},11188:{"value":"2BB4","name":"RIBBON ARROW LEFT UP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB4"},11189:{"value":"2BB5","name":"RIBBON ARROW RIGHT UP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB5"},11190:{"value":"2BB6","name":"RIBBON ARROW LEFT DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB6"},11191:{"value":"2BB7","name":"RIBBON ARROW RIGHT DOWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB7"},11192:{"value":"2BB8","name":"UPWARDS WHITE ARROW FROM BAR WITH HORIZONTAL BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB8"},11193:{"value":"2BB9","name":"UP ARROWHEAD IN A RECTANGLE BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BB9"},11197:{"value":"2BBD","name":"BALLOT BOX WITH LIGHT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BBD"},11198:{"value":"2BBE","name":"CIRCLED X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BBE"},11199:{"value":"2BBF","name":"CIRCLED BOLD X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BBF"},11200:{"value":"2BC0","name":"BLACK SQUARE CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC0"},11201:{"value":"2BC1","name":"BLACK DIAMOND CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC1"},11202:{"value":"2BC2","name":"TURNED BLACK PENTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC2"},11203:{"value":"2BC3","name":"HORIZONTAL BLACK OCTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC3"},11204:{"value":"2BC4","name":"BLACK OCTAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC4"},11205:{"value":"2BC5","name":"BLACK MEDIUM UP-POINTING TRIANGLE CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC5"},11206:{"value":"2BC6","name":"BLACK MEDIUM DOWN-POINTING TRIANGLE CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC6"},11207:{"value":"2BC7","name":"BLACK MEDIUM LEFT-POINTING TRIANGLE CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC7"},11208:{"value":"2BC8","name":"BLACK MEDIUM RIGHT-POINTING TRIANGLE CENTRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BC8"},11210:{"value":"2BCA","name":"TOP HALF BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCA"},11211:{"value":"2BCB","name":"BOTTOM HALF BLACK CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCB"},11212:{"value":"2BCC","name":"LIGHT FOUR POINTED BLACK CUSP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCC"},11213:{"value":"2BCD","name":"ROTATED LIGHT FOUR POINTED BLACK CUSP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCD"},11214:{"value":"2BCE","name":"WHITE FOUR POINTED CUSP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCE"},11215:{"value":"2BCF","name":"ROTATED WHITE FOUR POINTED CUSP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BCF"},11216:{"value":"2BD0","name":"SQUARE POSITION INDICATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BD0"},11217:{"value":"2BD1","name":"UNCERTAINTY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BD1"},11218:{"value":"2BD2","name":"GROUP MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BD2"},11244:{"value":"2BEC","name":"LEFTWARDS TWO-HEADED ARROW WITH TRIANGLE ARROWHEADS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BEC"},11245:{"value":"2BED","name":"UPWARDS TWO-HEADED ARROW WITH TRIANGLE ARROWHEADS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BED"},11246:{"value":"2BEE","name":"RIGHTWARDS TWO-HEADED ARROW WITH TRIANGLE ARROWHEADS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BEE"},11247:{"value":"2BEF","name":"DOWNWARDS TWO-HEADED ARROW WITH TRIANGLE ARROWHEADS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2BEF"},11493:{"value":"2CE5","name":"COPTIC SYMBOL MI RO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CE5"},11494:{"value":"2CE6","name":"COPTIC SYMBOL PI RO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CE6"},11495:{"value":"2CE7","name":"COPTIC SYMBOL STAUROS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CE7"},11496:{"value":"2CE8","name":"COPTIC SYMBOL TAU RO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CE8"},11497:{"value":"2CE9","name":"COPTIC SYMBOL KHI RO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CE9"},11498:{"value":"2CEA","name":"COPTIC SYMBOL SHIMA SIMA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2CEA"},11904:{"value":"2E80","name":"CJK RADICAL REPEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E80"},11905:{"value":"2E81","name":"CJK RADICAL CLIFF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E81"},11906:{"value":"2E82","name":"CJK RADICAL SECOND ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E82"},11907:{"value":"2E83","name":"CJK RADICAL SECOND TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E83"},11908:{"value":"2E84","name":"CJK RADICAL SECOND THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E84"},11909:{"value":"2E85","name":"CJK RADICAL PERSON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E85"},11910:{"value":"2E86","name":"CJK RADICAL BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E86"},11911:{"value":"2E87","name":"CJK RADICAL TABLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E87"},11912:{"value":"2E88","name":"CJK RADICAL KNIFE ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E88"},11913:{"value":"2E89","name":"CJK RADICAL KNIFE TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E89"},11914:{"value":"2E8A","name":"CJK RADICAL DIVINATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8A"},11915:{"value":"2E8B","name":"CJK RADICAL SEAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8B"},11916:{"value":"2E8C","name":"CJK RADICAL SMALL ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8C"},11917:{"value":"2E8D","name":"CJK RADICAL SMALL TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8D"},11918:{"value":"2E8E","name":"CJK RADICAL LAME ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8E"},11919:{"value":"2E8F","name":"CJK RADICAL LAME TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E8F"},11920:{"value":"2E90","name":"CJK RADICAL LAME THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E90"},11921:{"value":"2E91","name":"CJK RADICAL LAME FOUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E91"},11922:{"value":"2E92","name":"CJK RADICAL SNAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E92"},11923:{"value":"2E93","name":"CJK RADICAL THREAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E93"},11924:{"value":"2E94","name":"CJK RADICAL SNOUT ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E94"},11925:{"value":"2E95","name":"CJK RADICAL SNOUT TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E95"},11926:{"value":"2E96","name":"CJK RADICAL HEART ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E96"},11927:{"value":"2E97","name":"CJK RADICAL HEART TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E97"},11928:{"value":"2E98","name":"CJK RADICAL HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E98"},11929:{"value":"2E99","name":"CJK RADICAL RAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E99"},11931:{"value":"2E9B","name":"CJK RADICAL CHOKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E9B"},11932:{"value":"2E9C","name":"CJK RADICAL SUN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E9C"},11933:{"value":"2E9D","name":"CJK RADICAL MOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E9D"},11934:{"value":"2E9E","name":"CJK RADICAL DEATH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E9E"},11935:{"value":"2E9F","name":"CJK RADICAL MOTHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6BCD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2E9F"},11936:{"value":"2EA0","name":"CJK RADICAL CIVILIAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA0"},11937:{"value":"2EA1","name":"CJK RADICAL WATER ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA1"},11938:{"value":"2EA2","name":"CJK RADICAL WATER TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA2"},11939:{"value":"2EA3","name":"CJK RADICAL FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA3"},11940:{"value":"2EA4","name":"CJK RADICAL PAW ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA4"},11941:{"value":"2EA5","name":"CJK RADICAL PAW TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA5"},11942:{"value":"2EA6","name":"CJK RADICAL SIMPLIFIED HALF TREE TRUNK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA6"},11943:{"value":"2EA7","name":"CJK RADICAL COW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA7"},11944:{"value":"2EA8","name":"CJK RADICAL DOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA8"},11945:{"value":"2EA9","name":"CJK RADICAL JADE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EA9"},11946:{"value":"2EAA","name":"CJK RADICAL BOLT OF CLOTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAA"},11947:{"value":"2EAB","name":"CJK RADICAL EYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAB"},11948:{"value":"2EAC","name":"CJK RADICAL SPIRIT ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAC"},11949:{"value":"2EAD","name":"CJK RADICAL SPIRIT TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAD"},11950:{"value":"2EAE","name":"CJK RADICAL BAMBOO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAE"},11951:{"value":"2EAF","name":"CJK RADICAL SILK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EAF"},11952:{"value":"2EB0","name":"CJK RADICAL C-SIMPLIFIED SILK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB0"},11953:{"value":"2EB1","name":"CJK RADICAL NET ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB1"},11954:{"value":"2EB2","name":"CJK RADICAL NET TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB2"},11955:{"value":"2EB3","name":"CJK RADICAL NET THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB3"},11956:{"value":"2EB4","name":"CJK RADICAL NET FOUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB4"},11957:{"value":"2EB5","name":"CJK RADICAL MESH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB5"},11958:{"value":"2EB6","name":"CJK RADICAL SHEEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB6"},11959:{"value":"2EB7","name":"CJK RADICAL RAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB7"},11960:{"value":"2EB8","name":"CJK RADICAL EWE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB8"},11961:{"value":"2EB9","name":"CJK RADICAL OLD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EB9"},11962:{"value":"2EBA","name":"CJK RADICAL BRUSH ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBA"},11963:{"value":"2EBB","name":"CJK RADICAL BRUSH TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBB"},11964:{"value":"2EBC","name":"CJK RADICAL MEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBC"},11965:{"value":"2EBD","name":"CJK RADICAL MORTAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBD"},11966:{"value":"2EBE","name":"CJK RADICAL GRASS ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBE"},11967:{"value":"2EBF","name":"CJK RADICAL GRASS TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EBF"},11968:{"value":"2EC0","name":"CJK RADICAL GRASS THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC0"},11969:{"value":"2EC1","name":"CJK RADICAL TIGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC1"},11970:{"value":"2EC2","name":"CJK RADICAL CLOTHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC2"},11971:{"value":"2EC3","name":"CJK RADICAL WEST ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC3"},11972:{"value":"2EC4","name":"CJK RADICAL WEST TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC4"},11973:{"value":"2EC5","name":"CJK RADICAL C-SIMPLIFIED SEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC5"},11974:{"value":"2EC6","name":"CJK RADICAL SIMPLIFIED HORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC6"},11975:{"value":"2EC7","name":"CJK RADICAL HORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC7"},11976:{"value":"2EC8","name":"CJK RADICAL C-SIMPLIFIED SPEECH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC8"},11977:{"value":"2EC9","name":"CJK RADICAL C-SIMPLIFIED SHELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EC9"},11978:{"value":"2ECA","name":"CJK RADICAL FOOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECA"},11979:{"value":"2ECB","name":"CJK RADICAL C-SIMPLIFIED CART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECB"},11980:{"value":"2ECC","name":"CJK RADICAL SIMPLIFIED WALK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECC"},11981:{"value":"2ECD","name":"CJK RADICAL WALK ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECD"},11982:{"value":"2ECE","name":"CJK RADICAL WALK TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECE"},11983:{"value":"2ECF","name":"CJK RADICAL CITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ECF"},11984:{"value":"2ED0","name":"CJK RADICAL C-SIMPLIFIED GOLD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED0"},11985:{"value":"2ED1","name":"CJK RADICAL LONG ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED1"},11986:{"value":"2ED2","name":"CJK RADICAL LONG TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED2"},11987:{"value":"2ED3","name":"CJK RADICAL C-SIMPLIFIED LONG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED3"},11988:{"value":"2ED4","name":"CJK RADICAL C-SIMPLIFIED GATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED4"},11989:{"value":"2ED5","name":"CJK RADICAL MOUND ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED5"},11990:{"value":"2ED6","name":"CJK RADICAL MOUND TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED6"},11991:{"value":"2ED7","name":"CJK RADICAL RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED7"},11992:{"value":"2ED8","name":"CJK RADICAL BLUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED8"},11993:{"value":"2ED9","name":"CJK RADICAL C-SIMPLIFIED TANNED LEATHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2ED9"},11994:{"value":"2EDA","name":"CJK RADICAL C-SIMPLIFIED LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDA"},11995:{"value":"2EDB","name":"CJK RADICAL C-SIMPLIFIED WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDB"},11996:{"value":"2EDC","name":"CJK RADICAL C-SIMPLIFIED FLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDC"},11997:{"value":"2EDD","name":"CJK RADICAL EAT ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDD"},11998:{"value":"2EDE","name":"CJK RADICAL EAT TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDE"},11999:{"value":"2EDF","name":"CJK RADICAL EAT THREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EDF"},12000:{"value":"2EE0","name":"CJK RADICAL C-SIMPLIFIED EAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE0"},12001:{"value":"2EE1","name":"CJK RADICAL HEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE1"},12002:{"value":"2EE2","name":"CJK RADICAL C-SIMPLIFIED HORSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE2"},12003:{"value":"2EE3","name":"CJK RADICAL BONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE3"},12004:{"value":"2EE4","name":"CJK RADICAL GHOST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE4"},12005:{"value":"2EE5","name":"CJK RADICAL C-SIMPLIFIED FISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE5"},12006:{"value":"2EE6","name":"CJK RADICAL C-SIMPLIFIED BIRD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE6"},12007:{"value":"2EE7","name":"CJK RADICAL C-SIMPLIFIED SALT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE7"},12008:{"value":"2EE8","name":"CJK RADICAL SIMPLIFIED WHEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE8"},12009:{"value":"2EE9","name":"CJK RADICAL SIMPLIFIED YELLOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EE9"},12010:{"value":"2EEA","name":"CJK RADICAL C-SIMPLIFIED FROG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EEA"},12011:{"value":"2EEB","name":"CJK RADICAL J-SIMPLIFIED EVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EEB"},12012:{"value":"2EEC","name":"CJK RADICAL C-SIMPLIFIED EVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EEC"},12013:{"value":"2EED","name":"CJK RADICAL J-SIMPLIFIED TOOTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EED"},12014:{"value":"2EEE","name":"CJK RADICAL C-SIMPLIFIED TOOTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EEE"},12015:{"value":"2EEF","name":"CJK RADICAL J-SIMPLIFIED DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EEF"},12016:{"value":"2EF0","name":"CJK RADICAL C-SIMPLIFIED DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EF0"},12017:{"value":"2EF1","name":"CJK RADICAL TURTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EF1"},12018:{"value":"2EF2","name":"CJK RADICAL J-SIMPLIFIED TURTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EF2"},12019:{"value":"2EF3","name":"CJK RADICAL C-SIMPLIFIED TURTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F9F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2EF3"},12032:{"value":"2F00","name":"KANGXI RADICAL ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E00","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F00"},12033:{"value":"2F01","name":"KANGXI RADICAL LINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E28","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F01"},12034:{"value":"2F02","name":"KANGXI RADICAL DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E36","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F02"},12035:{"value":"2F03","name":"KANGXI RADICAL SLASH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E3F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F03"},12036:{"value":"2F04","name":"KANGXI RADICAL SECOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E59","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F04"},12037:{"value":"2F05","name":"KANGXI RADICAL HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E85","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F05"},12038:{"value":"2F06","name":"KANGXI RADICAL TWO","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4E8C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F06"},12039:{"value":"2F07","name":"KANGXI RADICAL LID","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4EA0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F07"},12040:{"value":"2F08","name":"KANGXI RADICAL MAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 4EBA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F08"},12041:{"value":"2F09","name":"KANGXI RADICAL LEGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 513F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F09"},12042:{"value":"2F0A","name":"KANGXI RADICAL ENTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5165","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0A"},12043:{"value":"2F0B","name":"KANGXI RADICAL EIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 516B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0B"},12044:{"value":"2F0C","name":"KANGXI RADICAL DOWN BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5182","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0C"},12045:{"value":"2F0D","name":"KANGXI RADICAL COVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5196","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0D"},12046:{"value":"2F0E","name":"KANGXI RADICAL ICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 51AB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0E"},12047:{"value":"2F0F","name":"KANGXI RADICAL TABLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 51E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F0F"},12048:{"value":"2F10","name":"KANGXI RADICAL OPEN BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 51F5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F10"},12049:{"value":"2F11","name":"KANGXI RADICAL KNIFE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5200","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F11"},12050:{"value":"2F12","name":"KANGXI RADICAL POWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 529B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F12"},12051:{"value":"2F13","name":"KANGXI RADICAL WRAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 52F9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F13"},12052:{"value":"2F14","name":"KANGXI RADICAL SPOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5315","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F14"},12053:{"value":"2F15","name":"KANGXI RADICAL RIGHT OPEN BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 531A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F15"},12054:{"value":"2F16","name":"KANGXI RADICAL HIDING ENCLOSURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5338","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F16"},12055:{"value":"2F17","name":"KANGXI RADICAL TEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5341","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F17"},12056:{"value":"2F18","name":"KANGXI RADICAL DIVINATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 535C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F18"},12057:{"value":"2F19","name":"KANGXI RADICAL SEAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5369","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F19"},12058:{"value":"2F1A","name":"KANGXI RADICAL CLIFF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5382","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1A"},12059:{"value":"2F1B","name":"KANGXI RADICAL PRIVATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 53B6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1B"},12060:{"value":"2F1C","name":"KANGXI RADICAL AGAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 53C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1C"},12061:{"value":"2F1D","name":"KANGXI RADICAL MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 53E3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1D"},12062:{"value":"2F1E","name":"KANGXI RADICAL ENCLOSURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 56D7","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1E"},12063:{"value":"2F1F","name":"KANGXI RADICAL EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 571F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F1F"},12064:{"value":"2F20","name":"KANGXI RADICAL SCHOLAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 58EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F20"},12065:{"value":"2F21","name":"KANGXI RADICAL GO","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5902","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F21"},12066:{"value":"2F22","name":"KANGXI RADICAL GO SLOWLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 590A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F22"},12067:{"value":"2F23","name":"KANGXI RADICAL EVENING","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5915","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F23"},12068:{"value":"2F24","name":"KANGXI RADICAL BIG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5927","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F24"},12069:{"value":"2F25","name":"KANGXI RADICAL WOMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5973","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F25"},12070:{"value":"2F26","name":"KANGXI RADICAL CHILD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5B50","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F26"},12071:{"value":"2F27","name":"KANGXI RADICAL ROOF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5B80","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F27"},12072:{"value":"2F28","name":"KANGXI RADICAL INCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5BF8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F28"},12073:{"value":"2F29","name":"KANGXI RADICAL SMALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5C0F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F29"},12074:{"value":"2F2A","name":"KANGXI RADICAL LAME","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5C22","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2A"},12075:{"value":"2F2B","name":"KANGXI RADICAL CORPSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5C38","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2B"},12076:{"value":"2F2C","name":"KANGXI RADICAL SPROUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5C6E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2C"},12077:{"value":"2F2D","name":"KANGXI RADICAL MOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5C71","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2D"},12078:{"value":"2F2E","name":"KANGXI RADICAL RIVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5DDB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2E"},12079:{"value":"2F2F","name":"KANGXI RADICAL WORK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5DE5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F2F"},12080:{"value":"2F30","name":"KANGXI RADICAL ONESELF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5DF1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F30"},12081:{"value":"2F31","name":"KANGXI RADICAL TURBAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5DFE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F31"},12082:{"value":"2F32","name":"KANGXI RADICAL DRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5E72","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F32"},12083:{"value":"2F33","name":"KANGXI RADICAL SHORT THREAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5E7A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F33"},12084:{"value":"2F34","name":"KANGXI RADICAL DOTTED CLIFF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5E7F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F34"},12085:{"value":"2F35","name":"KANGXI RADICAL LONG STRIDE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5EF4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F35"},12086:{"value":"2F36","name":"KANGXI RADICAL TWO HANDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5EFE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F36"},12087:{"value":"2F37","name":"KANGXI RADICAL SHOOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5F0B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F37"},12088:{"value":"2F38","name":"KANGXI RADICAL BOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5F13","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F38"},12089:{"value":"2F39","name":"KANGXI RADICAL SNOUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5F50","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F39"},12090:{"value":"2F3A","name":"KANGXI RADICAL BRISTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5F61","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3A"},12091:{"value":"2F3B","name":"KANGXI RADICAL STEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5F73","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3B"},12092:{"value":"2F3C","name":"KANGXI RADICAL HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 5FC3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3C"},12093:{"value":"2F3D","name":"KANGXI RADICAL HALBERD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6208","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3D"},12094:{"value":"2F3E","name":"KANGXI RADICAL DOOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6236","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3E"},12095:{"value":"2F3F","name":"KANGXI RADICAL HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 624B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F3F"},12096:{"value":"2F40","name":"KANGXI RADICAL BRANCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 652F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F40"},12097:{"value":"2F41","name":"KANGXI RADICAL RAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6534","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F41"},12098:{"value":"2F42","name":"KANGXI RADICAL SCRIPT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6587","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F42"},12099:{"value":"2F43","name":"KANGXI RADICAL DIPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6597","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F43"},12100:{"value":"2F44","name":"KANGXI RADICAL AXE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 65A4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F44"},12101:{"value":"2F45","name":"KANGXI RADICAL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 65B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F45"},12102:{"value":"2F46","name":"KANGXI RADICAL NOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 65E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F46"},12103:{"value":"2F47","name":"KANGXI RADICAL SUN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F47"},12104:{"value":"2F48","name":"KANGXI RADICAL SAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 66F0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F48"},12105:{"value":"2F49","name":"KANGXI RADICAL MOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F49"},12106:{"value":"2F4A","name":"KANGXI RADICAL TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6728","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4A"},12107:{"value":"2F4B","name":"KANGXI RADICAL LACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6B20","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4B"},12108:{"value":"2F4C","name":"KANGXI RADICAL STOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6B62","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4C"},12109:{"value":"2F4D","name":"KANGXI RADICAL DEATH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6B79","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4D"},12110:{"value":"2F4E","name":"KANGXI RADICAL WEAPON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6BB3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4E"},12111:{"value":"2F4F","name":"KANGXI RADICAL DO NOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6BCB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F4F"},12112:{"value":"2F50","name":"KANGXI RADICAL COMPARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6BD4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F50"},12113:{"value":"2F51","name":"KANGXI RADICAL FUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6BDB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F51"},12114:{"value":"2F52","name":"KANGXI RADICAL CLAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6C0F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F52"},12115:{"value":"2F53","name":"KANGXI RADICAL STEAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6C14","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F53"},12116:{"value":"2F54","name":"KANGXI RADICAL WATER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 6C34","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F54"},12117:{"value":"2F55","name":"KANGXI RADICAL FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 706B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F55"},12118:{"value":"2F56","name":"KANGXI RADICAL CLAW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 722A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F56"},12119:{"value":"2F57","name":"KANGXI RADICAL FATHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7236","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F57"},12120:{"value":"2F58","name":"KANGXI RADICAL DOUBLE X","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 723B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F58"},12121:{"value":"2F59","name":"KANGXI RADICAL HALF TREE TRUNK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 723F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F59"},12122:{"value":"2F5A","name":"KANGXI RADICAL SLICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7247","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5A"},12123:{"value":"2F5B","name":"KANGXI RADICAL FANG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7259","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5B"},12124:{"value":"2F5C","name":"KANGXI RADICAL COW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 725B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5C"},12125:{"value":"2F5D","name":"KANGXI RADICAL DOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 72AC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5D"},12126:{"value":"2F5E","name":"KANGXI RADICAL PROFOUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7384","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5E"},12127:{"value":"2F5F","name":"KANGXI RADICAL JADE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7389","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F5F"},12128:{"value":"2F60","name":"KANGXI RADICAL MELON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 74DC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F60"},12129:{"value":"2F61","name":"KANGXI RADICAL TILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 74E6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F61"},12130:{"value":"2F62","name":"KANGXI RADICAL SWEET","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7518","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F62"},12131:{"value":"2F63","name":"KANGXI RADICAL LIFE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 751F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F63"},12132:{"value":"2F64","name":"KANGXI RADICAL USE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7528","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F64"},12133:{"value":"2F65","name":"KANGXI RADICAL FIELD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7530","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F65"},12134:{"value":"2F66","name":"KANGXI RADICAL BOLT OF CLOTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 758B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F66"},12135:{"value":"2F67","name":"KANGXI RADICAL SICKNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7592","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F67"},12136:{"value":"2F68","name":"KANGXI RADICAL DOTTED TENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7676","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F68"},12137:{"value":"2F69","name":"KANGXI RADICAL WHITE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 767D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F69"},12138:{"value":"2F6A","name":"KANGXI RADICAL SKIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 76AE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6A"},12139:{"value":"2F6B","name":"KANGXI RADICAL DISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 76BF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6B"},12140:{"value":"2F6C","name":"KANGXI RADICAL EYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 76EE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6C"},12141:{"value":"2F6D","name":"KANGXI RADICAL SPEAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 77DB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6D"},12142:{"value":"2F6E","name":"KANGXI RADICAL ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 77E2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6E"},12143:{"value":"2F6F","name":"KANGXI RADICAL STONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 77F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F6F"},12144:{"value":"2F70","name":"KANGXI RADICAL SPIRIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 793A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F70"},12145:{"value":"2F71","name":"KANGXI RADICAL TRACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 79B8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F71"},12146:{"value":"2F72","name":"KANGXI RADICAL GRAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 79BE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F72"},12147:{"value":"2F73","name":"KANGXI RADICAL CAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7A74","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F73"},12148:{"value":"2F74","name":"KANGXI RADICAL STAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7ACB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F74"},12149:{"value":"2F75","name":"KANGXI RADICAL BAMBOO","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7AF9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F75"},12150:{"value":"2F76","name":"KANGXI RADICAL RICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7C73","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F76"},12151:{"value":"2F77","name":"KANGXI RADICAL SILK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7CF8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F77"},12152:{"value":"2F78","name":"KANGXI RADICAL JAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7F36","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F78"},12153:{"value":"2F79","name":"KANGXI RADICAL NET","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7F51","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F79"},12154:{"value":"2F7A","name":"KANGXI RADICAL SHEEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7F8A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7A"},12155:{"value":"2F7B","name":"KANGXI RADICAL FEATHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 7FBD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7B"},12156:{"value":"2F7C","name":"KANGXI RADICAL OLD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8001","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7C"},12157:{"value":"2F7D","name":"KANGXI RADICAL AND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 800C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7D"},12158:{"value":"2F7E","name":"KANGXI RADICAL PLOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8012","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7E"},12159:{"value":"2F7F","name":"KANGXI RADICAL EAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8033","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F7F"},12160:{"value":"2F80","name":"KANGXI RADICAL BRUSH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 807F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F80"},12161:{"value":"2F81","name":"KANGXI RADICAL MEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8089","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F81"},12162:{"value":"2F82","name":"KANGXI RADICAL MINISTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 81E3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F82"},12163:{"value":"2F83","name":"KANGXI RADICAL SELF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 81EA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F83"},12164:{"value":"2F84","name":"KANGXI RADICAL ARRIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 81F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F84"},12165:{"value":"2F85","name":"KANGXI RADICAL MORTAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 81FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F85"},12166:{"value":"2F86","name":"KANGXI RADICAL TONGUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 820C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F86"},12167:{"value":"2F87","name":"KANGXI RADICAL OPPOSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 821B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F87"},12168:{"value":"2F88","name":"KANGXI RADICAL BOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 821F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F88"},12169:{"value":"2F89","name":"KANGXI RADICAL STOPPING","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 826E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F89"},12170:{"value":"2F8A","name":"KANGXI RADICAL COLOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8272","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8A"},12171:{"value":"2F8B","name":"KANGXI RADICAL GRASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8278","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8B"},12172:{"value":"2F8C","name":"KANGXI RADICAL TIGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 864D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8C"},12173:{"value":"2F8D","name":"KANGXI RADICAL INSECT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 866B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8D"},12174:{"value":"2F8E","name":"KANGXI RADICAL BLOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8840","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8E"},12175:{"value":"2F8F","name":"KANGXI RADICAL WALK ENCLOSURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 884C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F8F"},12176:{"value":"2F90","name":"KANGXI RADICAL CLOTHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8863","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F90"},12177:{"value":"2F91","name":"KANGXI RADICAL WEST","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 897E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F91"},12178:{"value":"2F92","name":"KANGXI RADICAL SEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 898B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F92"},12179:{"value":"2F93","name":"KANGXI RADICAL HORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 89D2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F93"},12180:{"value":"2F94","name":"KANGXI RADICAL SPEECH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8A00","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F94"},12181:{"value":"2F95","name":"KANGXI RADICAL VALLEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8C37","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F95"},12182:{"value":"2F96","name":"KANGXI RADICAL BEAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8C46","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F96"},12183:{"value":"2F97","name":"KANGXI RADICAL PIG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8C55","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F97"},12184:{"value":"2F98","name":"KANGXI RADICAL BADGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8C78","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F98"},12185:{"value":"2F99","name":"KANGXI RADICAL SHELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8C9D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F99"},12186:{"value":"2F9A","name":"KANGXI RADICAL RED","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8D64","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9A"},12187:{"value":"2F9B","name":"KANGXI RADICAL RUN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8D70","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9B"},12188:{"value":"2F9C","name":"KANGXI RADICAL FOOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8DB3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9C"},12189:{"value":"2F9D","name":"KANGXI RADICAL BODY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8EAB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9D"},12190:{"value":"2F9E","name":"KANGXI RADICAL CART","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8ECA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9E"},12191:{"value":"2F9F","name":"KANGXI RADICAL BITTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8F9B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2F9F"},12192:{"value":"2FA0","name":"KANGXI RADICAL MORNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8FB0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA0"},12193:{"value":"2FA1","name":"KANGXI RADICAL WALK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 8FB5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA1"},12194:{"value":"2FA2","name":"KANGXI RADICAL CITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9091","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA2"},12195:{"value":"2FA3","name":"KANGXI RADICAL WINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9149","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA3"},12196:{"value":"2FA4","name":"KANGXI RADICAL DISTINGUISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 91C6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA4"},12197:{"value":"2FA5","name":"KANGXI RADICAL VILLAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 91CC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA5"},12198:{"value":"2FA6","name":"KANGXI RADICAL GOLD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 91D1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA6"},12199:{"value":"2FA7","name":"KANGXI RADICAL LONG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9577","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA7"},12200:{"value":"2FA8","name":"KANGXI RADICAL GATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9580","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA8"},12201:{"value":"2FA9","name":"KANGXI RADICAL MOUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 961C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FA9"},12202:{"value":"2FAA","name":"KANGXI RADICAL SLAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 96B6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAA"},12203:{"value":"2FAB","name":"KANGXI RADICAL SHORT TAILED BIRD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 96B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAB"},12204:{"value":"2FAC","name":"KANGXI RADICAL RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 96E8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAC"},12205:{"value":"2FAD","name":"KANGXI RADICAL BLUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9751","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAD"},12206:{"value":"2FAE","name":"KANGXI RADICAL WRONG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 975E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAE"},12207:{"value":"2FAF","name":"KANGXI RADICAL FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9762","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FAF"},12208:{"value":"2FB0","name":"KANGXI RADICAL LEATHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9769","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB0"},12209:{"value":"2FB1","name":"KANGXI RADICAL TANNED LEATHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 97CB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB1"},12210:{"value":"2FB2","name":"KANGXI RADICAL LEEK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 97ED","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB2"},12211:{"value":"2FB3","name":"KANGXI RADICAL SOUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 97F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB3"},12212:{"value":"2FB4","name":"KANGXI RADICAL LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9801","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB4"},12213:{"value":"2FB5","name":"KANGXI RADICAL WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 98A8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB5"},12214:{"value":"2FB6","name":"KANGXI RADICAL FLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 98DB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB6"},12215:{"value":"2FB7","name":"KANGXI RADICAL EAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 98DF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB7"},12216:{"value":"2FB8","name":"KANGXI RADICAL HEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9996","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB8"},12217:{"value":"2FB9","name":"KANGXI RADICAL FRAGRANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9999","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FB9"},12218:{"value":"2FBA","name":"KANGXI RADICAL HORSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 99AC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBA"},12219:{"value":"2FBB","name":"KANGXI RADICAL BONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9AA8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBB"},12220:{"value":"2FBC","name":"KANGXI RADICAL TALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9AD8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBC"},12221:{"value":"2FBD","name":"KANGXI RADICAL HAIR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9ADF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBD"},12222:{"value":"2FBE","name":"KANGXI RADICAL FIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9B25","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBE"},12223:{"value":"2FBF","name":"KANGXI RADICAL SACRIFICIAL WINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9B2F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FBF"},12224:{"value":"2FC0","name":"KANGXI RADICAL CAULDRON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9B32","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC0"},12225:{"value":"2FC1","name":"KANGXI RADICAL GHOST","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9B3C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC1"},12226:{"value":"2FC2","name":"KANGXI RADICAL FISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9B5A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC2"},12227:{"value":"2FC3","name":"KANGXI RADICAL BIRD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9CE5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC3"},12228:{"value":"2FC4","name":"KANGXI RADICAL SALT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9E75","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC4"},12229:{"value":"2FC5","name":"KANGXI RADICAL DEER","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9E7F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC5"},12230:{"value":"2FC6","name":"KANGXI RADICAL WHEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9EA5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC6"},12231:{"value":"2FC7","name":"KANGXI RADICAL HEMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9EBB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC7"},12232:{"value":"2FC8","name":"KANGXI RADICAL YELLOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9EC3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC8"},12233:{"value":"2FC9","name":"KANGXI RADICAL MILLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9ECD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FC9"},12234:{"value":"2FCA","name":"KANGXI RADICAL BLACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9ED1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCA"},12235:{"value":"2FCB","name":"KANGXI RADICAL EMBROIDERY","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9EF9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCB"},12236:{"value":"2FCC","name":"KANGXI RADICAL FROG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9EFD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCC"},12237:{"value":"2FCD","name":"KANGXI RADICAL TRIPOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F0E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCD"},12238:{"value":"2FCE","name":"KANGXI RADICAL DRUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F13","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCE"},12239:{"value":"2FCF","name":"KANGXI RADICAL RAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F20","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FCF"},12240:{"value":"2FD0","name":"KANGXI RADICAL NOSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F3B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD0"},12241:{"value":"2FD1","name":"KANGXI RADICAL EVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F4A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD1"},12242:{"value":"2FD2","name":"KANGXI RADICAL TOOTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F52","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD2"},12243:{"value":"2FD3","name":"KANGXI RADICAL DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F8D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD3"},12244:{"value":"2FD4","name":"KANGXI RADICAL TURTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9F9C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD4"},12245:{"value":"2FD5","name":"KANGXI RADICAL FLUTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 9FA0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FD5"},12272:{"value":"2FF0","name":"IDEOGRAPHIC DESCRIPTION CHARACTER LEFT TO RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF0"},12273:{"value":"2FF1","name":"IDEOGRAPHIC DESCRIPTION CHARACTER ABOVE TO BELOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF1"},12274:{"value":"2FF2","name":"IDEOGRAPHIC DESCRIPTION CHARACTER LEFT TO MIDDLE AND RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF2"},12275:{"value":"2FF3","name":"IDEOGRAPHIC DESCRIPTION CHARACTER ABOVE TO MIDDLE AND BELOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF3"},12276:{"value":"2FF4","name":"IDEOGRAPHIC DESCRIPTION CHARACTER FULL SURROUND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF4"},12277:{"value":"2FF5","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF5"},12278:{"value":"2FF6","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM BELOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF6"},12279:{"value":"2FF7","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF7"},12280:{"value":"2FF8","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM UPPER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF8"},12281:{"value":"2FF9","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM UPPER RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FF9"},12282:{"value":"2FFA","name":"IDEOGRAPHIC DESCRIPTION CHARACTER SURROUND FROM LOWER LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FFA"},12283:{"value":"2FFB","name":"IDEOGRAPHIC DESCRIPTION CHARACTER OVERLAID","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u2FFB"},12292:{"value":"3004","name":"JAPANESE INDUSTRIAL STANDARD SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3004"},12306:{"value":"3012","name":"POSTAL MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3012"},12307:{"value":"3013","name":"GETA MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3013"},12320:{"value":"3020","name":"POSTAL MARK FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3020"},12342:{"value":"3036","name":"CIRCLED POSTAL MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 3012","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3036"},12343:{"value":"3037","name":"IDEOGRAPHIC TELEGRAPH LINE FEED SEPARATOR SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3037"},12350:{"value":"303E","name":"IDEOGRAPHIC VARIATION INDICATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u303E"},12351:{"value":"303F","name":"IDEOGRAPHIC HALF FILL SPACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u303F"},12688:{"value":"3190","name":"IDEOGRAPHIC ANNOTATION LINKING MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KANBUN TATETEN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3190"},12689:{"value":"3191","name":"IDEOGRAPHIC ANNOTATION REVERSE MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN RE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3191"},12694:{"value":"3196","name":"IDEOGRAPHIC ANNOTATION TOP MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E0A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN ZYOU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3196"},12695:{"value":"3197","name":"IDEOGRAPHIC ANNOTATION MIDDLE MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E2D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN TYUU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3197"},12696:{"value":"3198","name":"IDEOGRAPHIC ANNOTATION BOTTOM MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E0B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN GE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3198"},12697:{"value":"3199","name":"IDEOGRAPHIC ANNOTATION FIRST MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 7532","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN KOU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3199"},12698:{"value":"319A","name":"IDEOGRAPHIC ANNOTATION SECOND MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E59","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN OTU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319A"},12699:{"value":"319B","name":"IDEOGRAPHIC ANNOTATION THIRD MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E19","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN HEI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319B"},12700:{"value":"319C","name":"IDEOGRAPHIC ANNOTATION FOURTH MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4E01","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN TEI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319C"},12701:{"value":"319D","name":"IDEOGRAPHIC ANNOTATION HEAVEN MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 5929","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN TEN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319D"},12702:{"value":"319E","name":"IDEOGRAPHIC ANNOTATION EARTH MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 5730","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN TI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319E"},12703:{"value":"319F","name":"IDEOGRAPHIC ANNOTATION MAN MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"<super> 4EBA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"KAERITEN ZIN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u319F"},12736:{"value":"31C0","name":"CJK STROKE T","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C0"},12737:{"value":"31C1","name":"CJK STROKE WG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C1"},12738:{"value":"31C2","name":"CJK STROKE XG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C2"},12739:{"value":"31C3","name":"CJK STROKE BXG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C3"},12740:{"value":"31C4","name":"CJK STROKE SW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C4"},12741:{"value":"31C5","name":"CJK STROKE HZZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C5"},12742:{"value":"31C6","name":"CJK STROKE HZG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C6"},12743:{"value":"31C7","name":"CJK STROKE HP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C7"},12744:{"value":"31C8","name":"CJK STROKE HZWG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C8"},12745:{"value":"31C9","name":"CJK STROKE SZWG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31C9"},12746:{"value":"31CA","name":"CJK STROKE HZT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CA"},12747:{"value":"31CB","name":"CJK STROKE HZZP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CB"},12748:{"value":"31CC","name":"CJK STROKE HPWG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CC"},12749:{"value":"31CD","name":"CJK STROKE HZW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CD"},12750:{"value":"31CE","name":"CJK STROKE HZZZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CE"},12751:{"value":"31CF","name":"CJK STROKE N","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31CF"},12752:{"value":"31D0","name":"CJK STROKE H","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D0"},12753:{"value":"31D1","name":"CJK STROKE S","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D1"},12754:{"value":"31D2","name":"CJK STROKE P","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D2"},12755:{"value":"31D3","name":"CJK STROKE SP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D3"},12756:{"value":"31D4","name":"CJK STROKE D","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D4"},12757:{"value":"31D5","name":"CJK STROKE HZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D5"},12758:{"value":"31D6","name":"CJK STROKE HG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D6"},12759:{"value":"31D7","name":"CJK STROKE SZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D7"},12760:{"value":"31D8","name":"CJK STROKE SWZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D8"},12761:{"value":"31D9","name":"CJK STROKE ST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31D9"},12762:{"value":"31DA","name":"CJK STROKE SG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DA"},12763:{"value":"31DB","name":"CJK STROKE PD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DB"},12764:{"value":"31DC","name":"CJK STROKE PZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DC"},12765:{"value":"31DD","name":"CJK STROKE TN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DD"},12766:{"value":"31DE","name":"CJK STROKE SZZ","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DE"},12767:{"value":"31DF","name":"CJK STROKE SWG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31DF"},12768:{"value":"31E0","name":"CJK STROKE HXWG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31E0"},12769:{"value":"31E1","name":"CJK STROKE HZZZG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31E1"},12770:{"value":"31E2","name":"CJK STROKE PG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31E2"},12771:{"value":"31E3","name":"CJK STROKE Q","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u31E3"},12800:{"value":"3200","name":"PARENTHESIZED HANGUL KIYEOK","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1100 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL GIYEOG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3200"},12801:{"value":"3201","name":"PARENTHESIZED HANGUL NIEUN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1102 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3201"},12802:{"value":"3202","name":"PARENTHESIZED HANGUL TIKEUT","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1103 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL DIGEUD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3202"},12803:{"value":"3203","name":"PARENTHESIZED HANGUL RIEUL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1105 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL LIEUL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3203"},12804:{"value":"3204","name":"PARENTHESIZED HANGUL MIEUM","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1106 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3204"},12805:{"value":"3205","name":"PARENTHESIZED HANGUL PIEUP","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1107 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL BIEUB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3205"},12806:{"value":"3206","name":"PARENTHESIZED HANGUL SIOS","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1109 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3206"},12807:{"value":"3207","name":"PARENTHESIZED HANGUL IEUNG","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110B 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3207"},12808:{"value":"3208","name":"PARENTHESIZED HANGUL CIEUC","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110C 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL JIEUJ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3208"},12809:{"value":"3209","name":"PARENTHESIZED HANGUL CHIEUCH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL CIEUC","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3209"},12810:{"value":"320A","name":"PARENTHESIZED HANGUL KHIEUKH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110F 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL KIYEOK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320A"},12811:{"value":"320B","name":"PARENTHESIZED HANGUL THIEUTH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1110 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL TIEUT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320B"},12812:{"value":"320C","name":"PARENTHESIZED HANGUL PHIEUPH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1111 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL PIEUP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320C"},12813:{"value":"320D","name":"PARENTHESIZED HANGUL HIEUH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1112 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320D"},12814:{"value":"320E","name":"PARENTHESIZED HANGUL KIYEOK A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1100 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL GA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320E"},12815:{"value":"320F","name":"PARENTHESIZED HANGUL NIEUN A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1102 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL NA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u320F"},12816:{"value":"3210","name":"PARENTHESIZED HANGUL TIKEUT A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1103 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL DA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3210"},12817:{"value":"3211","name":"PARENTHESIZED HANGUL RIEUL A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1105 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL LA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3211"},12818:{"value":"3212","name":"PARENTHESIZED HANGUL MIEUM A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1106 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL MA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3212"},12819:{"value":"3213","name":"PARENTHESIZED HANGUL PIEUP A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1107 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL BA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3213"},12820:{"value":"3214","name":"PARENTHESIZED HANGUL SIOS A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1109 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL SA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3214"},12821:{"value":"3215","name":"PARENTHESIZED HANGUL IEUNG A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110B 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL A","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3215"},12822:{"value":"3216","name":"PARENTHESIZED HANGUL CIEUC A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110C 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL JA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3216"},12823:{"value":"3217","name":"PARENTHESIZED HANGUL CHIEUCH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110E 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL CA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3217"},12824:{"value":"3218","name":"PARENTHESIZED HANGUL KHIEUKH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110F 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL KA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3218"},12825:{"value":"3219","name":"PARENTHESIZED HANGUL THIEUTH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1110 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL TA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3219"},12826:{"value":"321A","name":"PARENTHESIZED HANGUL PHIEUPH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1111 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL PA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u321A"},12827:{"value":"321B","name":"PARENTHESIZED HANGUL HIEUH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 1112 1161 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL HA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u321B"},12828:{"value":"321C","name":"PARENTHESIZED HANGUL CIEUC U","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 110C 116E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"PARENTHESIZED HANGUL JU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u321C"},12829:{"value":"321D","name":"PARENTHESIZED KOREAN CHARACTER OJEON","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0028 110B 1169 110C 1165 11AB 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u321D"},12830:{"value":"321E","name":"PARENTHESIZED KOREAN CHARACTER O HU","category":"So","class":"0","bidirectional_category":"ON","mapping":"<compat> 0028 110B 1169 1112 116E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u321E"},12842:{"value":"322A","name":"PARENTHESIZED IDEOGRAPH MOON","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 6708 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322A"},12843:{"value":"322B","name":"PARENTHESIZED IDEOGRAPH FIRE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 706B 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322B"},12844:{"value":"322C","name":"PARENTHESIZED IDEOGRAPH WATER","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 6C34 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322C"},12845:{"value":"322D","name":"PARENTHESIZED IDEOGRAPH WOOD","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 6728 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322D"},12846:{"value":"322E","name":"PARENTHESIZED IDEOGRAPH METAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 91D1 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322E"},12847:{"value":"322F","name":"PARENTHESIZED IDEOGRAPH EARTH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 571F 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u322F"},12848:{"value":"3230","name":"PARENTHESIZED IDEOGRAPH SUN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 65E5 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3230"},12849:{"value":"3231","name":"PARENTHESIZED IDEOGRAPH STOCK","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 682A 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3231"},12850:{"value":"3232","name":"PARENTHESIZED IDEOGRAPH HAVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 6709 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3232"},12851:{"value":"3233","name":"PARENTHESIZED IDEOGRAPH SOCIETY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 793E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3233"},12852:{"value":"3234","name":"PARENTHESIZED IDEOGRAPH NAME","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 540D 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3234"},12853:{"value":"3235","name":"PARENTHESIZED IDEOGRAPH SPECIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 7279 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3235"},12854:{"value":"3236","name":"PARENTHESIZED IDEOGRAPH FINANCIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 8CA1 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3236"},12855:{"value":"3237","name":"PARENTHESIZED IDEOGRAPH CONGRATULATION","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 795D 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3237"},12856:{"value":"3238","name":"PARENTHESIZED IDEOGRAPH LABOR","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 52B4 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3238"},12857:{"value":"3239","name":"PARENTHESIZED IDEOGRAPH REPRESENT","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 4EE3 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3239"},12858:{"value":"323A","name":"PARENTHESIZED IDEOGRAPH CALL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 547C 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323A"},12859:{"value":"323B","name":"PARENTHESIZED IDEOGRAPH STUDY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 5B66 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323B"},12860:{"value":"323C","name":"PARENTHESIZED IDEOGRAPH SUPERVISE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 76E3 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323C"},12861:{"value":"323D","name":"PARENTHESIZED IDEOGRAPH ENTERPRISE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 4F01 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323D"},12862:{"value":"323E","name":"PARENTHESIZED IDEOGRAPH RESOURCE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 8CC7 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323E"},12863:{"value":"323F","name":"PARENTHESIZED IDEOGRAPH ALLIANCE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 5354 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u323F"},12864:{"value":"3240","name":"PARENTHESIZED IDEOGRAPH FESTIVAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 796D 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3240"},12865:{"value":"3241","name":"PARENTHESIZED IDEOGRAPH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 4F11 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3241"},12866:{"value":"3242","name":"PARENTHESIZED IDEOGRAPH SELF","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 81EA 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3242"},12867:{"value":"3243","name":"PARENTHESIZED IDEOGRAPH REACH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 81F3 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3243"},12868:{"value":"3244","name":"CIRCLED IDEOGRAPH QUESTION","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 554F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3244"},12869:{"value":"3245","name":"CIRCLED IDEOGRAPH KINDERGARTEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5E7C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3245"},12870:{"value":"3246","name":"CIRCLED IDEOGRAPH SCHOOL","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6587","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3246"},12871:{"value":"3247","name":"CIRCLED IDEOGRAPH KOTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 7B8F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3247"},12880:{"value":"3250","name":"PARTNERSHIP SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0050 0054 0045","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3250"},12896:{"value":"3260","name":"CIRCLED HANGUL KIYEOK","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1100","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL GIYEOG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3260"},12897:{"value":"3261","name":"CIRCLED HANGUL NIEUN","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1102","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3261"},12898:{"value":"3262","name":"CIRCLED HANGUL TIKEUT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1103","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL DIGEUD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3262"},12899:{"value":"3263","name":"CIRCLED HANGUL RIEUL","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1105","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL LIEUL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3263"},12900:{"value":"3264","name":"CIRCLED HANGUL MIEUM","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1106","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3264"},12901:{"value":"3265","name":"CIRCLED HANGUL PIEUP","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1107","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL BIEUB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3265"},12902:{"value":"3266","name":"CIRCLED HANGUL SIOS","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1109","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3266"},12903:{"value":"3267","name":"CIRCLED HANGUL IEUNG","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3267"},12904:{"value":"3268","name":"CIRCLED HANGUL CIEUC","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL JIEUJ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3268"},12905:{"value":"3269","name":"CIRCLED HANGUL CHIEUCH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL CIEUC","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3269"},12906:{"value":"326A","name":"CIRCLED HANGUL KHIEUKH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL KIYEOK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326A"},12907:{"value":"326B","name":"CIRCLED HANGUL THIEUTH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1110","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL TIEUT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326B"},12908:{"value":"326C","name":"CIRCLED HANGUL PHIEUPH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1111","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL PIEUP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326C"},12909:{"value":"326D","name":"CIRCLED HANGUL HIEUH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1112","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326D"},12910:{"value":"326E","name":"CIRCLED HANGUL KIYEOK A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1100 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL GA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326E"},12911:{"value":"326F","name":"CIRCLED HANGUL NIEUN A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1102 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL NA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u326F"},12912:{"value":"3270","name":"CIRCLED HANGUL TIKEUT A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1103 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL DA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3270"},12913:{"value":"3271","name":"CIRCLED HANGUL RIEUL A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1105 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL LA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3271"},12914:{"value":"3272","name":"CIRCLED HANGUL MIEUM A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1106 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL MA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3272"},12915:{"value":"3273","name":"CIRCLED HANGUL PIEUP A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1107 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL BA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3273"},12916:{"value":"3274","name":"CIRCLED HANGUL SIOS A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1109 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL SA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3274"},12917:{"value":"3275","name":"CIRCLED HANGUL IEUNG A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110B 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL A","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3275"},12918:{"value":"3276","name":"CIRCLED HANGUL CIEUC A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110C 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL JA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3276"},12919:{"value":"3277","name":"CIRCLED HANGUL CHIEUCH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110E 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL CA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3277"},12920:{"value":"3278","name":"CIRCLED HANGUL KHIEUKH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 110F 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL KA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3278"},12921:{"value":"3279","name":"CIRCLED HANGUL THIEUTH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1110 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL TA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3279"},12922:{"value":"327A","name":"CIRCLED HANGUL PHIEUPH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1111 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL PA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327A"},12923:{"value":"327B","name":"CIRCLED HANGUL HIEUH A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 1112 1161","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED HANGUL HA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327B"},12924:{"value":"327C","name":"CIRCLED KOREAN CHARACTER CHAMKO","category":"So","class":"0","bidirectional_category":"ON","mapping":"<circle> 110E 1161 11B7 1100 1169","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327C"},12925:{"value":"327D","name":"CIRCLED KOREAN CHARACTER JUEUI","category":"So","class":"0","bidirectional_category":"ON","mapping":"<circle> 110C 116E 110B 1174","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327D"},12926:{"value":"327E","name":"CIRCLED HANGUL IEUNG U","category":"So","class":"0","bidirectional_category":"ON","mapping":"<circle> 110B 116E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327E"},12927:{"value":"327F","name":"KOREAN STANDARD SYMBOL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u327F"},12938:{"value":"328A","name":"CIRCLED IDEOGRAPH MOON","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328A"},12939:{"value":"328B","name":"CIRCLED IDEOGRAPH FIRE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 706B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328B"},12940:{"value":"328C","name":"CIRCLED IDEOGRAPH WATER","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6C34","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328C"},12941:{"value":"328D","name":"CIRCLED IDEOGRAPH WOOD","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6728","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328D"},12942:{"value":"328E","name":"CIRCLED IDEOGRAPH METAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 91D1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328E"},12943:{"value":"328F","name":"CIRCLED IDEOGRAPH EARTH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 571F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u328F"},12944:{"value":"3290","name":"CIRCLED IDEOGRAPH SUN","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3290"},12945:{"value":"3291","name":"CIRCLED IDEOGRAPH STOCK","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 682A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3291"},12946:{"value":"3292","name":"CIRCLED IDEOGRAPH HAVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6709","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3292"},12947:{"value":"3293","name":"CIRCLED IDEOGRAPH SOCIETY","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 793E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3293"},12948:{"value":"3294","name":"CIRCLED IDEOGRAPH NAME","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 540D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3294"},12949:{"value":"3295","name":"CIRCLED IDEOGRAPH SPECIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 7279","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3295"},12950:{"value":"3296","name":"CIRCLED IDEOGRAPH FINANCIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 8CA1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3296"},12951:{"value":"3297","name":"CIRCLED IDEOGRAPH CONGRATULATION","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 795D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3297"},12952:{"value":"3298","name":"CIRCLED IDEOGRAPH LABOR","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 52B4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3298"},12953:{"value":"3299","name":"CIRCLED IDEOGRAPH SECRET","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 79D8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3299"},12954:{"value":"329A","name":"CIRCLED IDEOGRAPH MALE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 7537","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329A"},12955:{"value":"329B","name":"CIRCLED IDEOGRAPH FEMALE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5973","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329B"},12956:{"value":"329C","name":"CIRCLED IDEOGRAPH SUITABLE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 9069","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329C"},12957:{"value":"329D","name":"CIRCLED IDEOGRAPH EXCELLENT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 512A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329D"},12958:{"value":"329E","name":"CIRCLED IDEOGRAPH PRINT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5370","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329E"},12959:{"value":"329F","name":"CIRCLED IDEOGRAPH ATTENTION","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6CE8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u329F"},12960:{"value":"32A0","name":"CIRCLED IDEOGRAPH ITEM","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 9805","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A0"},12961:{"value":"32A1","name":"CIRCLED IDEOGRAPH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 4F11","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A1"},12962:{"value":"32A2","name":"CIRCLED IDEOGRAPH COPY","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5199","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A2"},12963:{"value":"32A3","name":"CIRCLED IDEOGRAPH CORRECT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 6B63","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A3"},12964:{"value":"32A4","name":"CIRCLED IDEOGRAPH HIGH","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 4E0A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A4"},12965:{"value":"32A5","name":"CIRCLED IDEOGRAPH CENTRE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 4E2D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"CIRCLED IDEOGRAPH CENTER","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A5"},12966:{"value":"32A6","name":"CIRCLED IDEOGRAPH LOW","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 4E0B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A6"},12967:{"value":"32A7","name":"CIRCLED IDEOGRAPH LEFT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5DE6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A7"},12968:{"value":"32A8","name":"CIRCLED IDEOGRAPH RIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 53F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A8"},12969:{"value":"32A9","name":"CIRCLED IDEOGRAPH MEDICINE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 533B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32A9"},12970:{"value":"32AA","name":"CIRCLED IDEOGRAPH RELIGION","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5B97","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AA"},12971:{"value":"32AB","name":"CIRCLED IDEOGRAPH STUDY","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5B66","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AB"},12972:{"value":"32AC","name":"CIRCLED IDEOGRAPH SUPERVISE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 76E3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AC"},12973:{"value":"32AD","name":"CIRCLED IDEOGRAPH ENTERPRISE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 4F01","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AD"},12974:{"value":"32AE","name":"CIRCLED IDEOGRAPH RESOURCE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 8CC7","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AE"},12975:{"value":"32AF","name":"CIRCLED IDEOGRAPH ALLIANCE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5354","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32AF"},12976:{"value":"32B0","name":"CIRCLED IDEOGRAPH NIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 591C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32B0"},12992:{"value":"32C0","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR JANUARY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C0"},12993:{"value":"32C1","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR FEBRUARY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C1"},12994:{"value":"32C2","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR MARCH","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0033 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C2"},12995:{"value":"32C3","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR APRIL","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0034 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C3"},12996:{"value":"32C4","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR MAY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0035 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C4"},12997:{"value":"32C5","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR JUNE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0036 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C5"},12998:{"value":"32C6","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR JULY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0037 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C6"},12999:{"value":"32C7","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR AUGUST","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0038 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C7"},13000:{"value":"32C8","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR SEPTEMBER","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0039 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C8"},13001:{"value":"32C9","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR OCTOBER","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0030 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32C9"},13002:{"value":"32CA","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR NOVEMBER","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0031 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CA"},13003:{"value":"32CB","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DECEMBER","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0032 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CB"},13004:{"value":"32CC","name":"SQUARE HG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0048 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CC"},13005:{"value":"32CD","name":"SQUARE ERG","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0065 0072 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CD"},13006:{"value":"32CE","name":"SQUARE EV","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0065 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CE"},13007:{"value":"32CF","name":"LIMITED LIABILITY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 004C 0054 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32CF"},13008:{"value":"32D0","name":"CIRCLED KATAKANA A","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30A2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D0"},13009:{"value":"32D1","name":"CIRCLED KATAKANA I","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30A4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D1"},13010:{"value":"32D2","name":"CIRCLED KATAKANA U","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30A6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D2"},13011:{"value":"32D3","name":"CIRCLED KATAKANA E","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30A8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D3"},13012:{"value":"32D4","name":"CIRCLED KATAKANA O","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30AA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D4"},13013:{"value":"32D5","name":"CIRCLED KATAKANA KA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30AB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D5"},13014:{"value":"32D6","name":"CIRCLED KATAKANA KI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30AD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D6"},13015:{"value":"32D7","name":"CIRCLED KATAKANA KU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30AF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D7"},13016:{"value":"32D8","name":"CIRCLED KATAKANA KE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30B1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D8"},13017:{"value":"32D9","name":"CIRCLED KATAKANA KO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32D9"},13018:{"value":"32DA","name":"CIRCLED KATAKANA SA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30B5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DA"},13019:{"value":"32DB","name":"CIRCLED KATAKANA SI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30B7","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DB"},13020:{"value":"32DC","name":"CIRCLED KATAKANA SU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DC"},13021:{"value":"32DD","name":"CIRCLED KATAKANA SE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30BB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DD"},13022:{"value":"32DE","name":"CIRCLED KATAKANA SO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30BD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DE"},13023:{"value":"32DF","name":"CIRCLED KATAKANA TA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30BF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32DF"},13024:{"value":"32E0","name":"CIRCLED KATAKANA TI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30C1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E0"},13025:{"value":"32E1","name":"CIRCLED KATAKANA TU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30C4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E1"},13026:{"value":"32E2","name":"CIRCLED KATAKANA TE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30C6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E2"},13027:{"value":"32E3","name":"CIRCLED KATAKANA TO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E3"},13028:{"value":"32E4","name":"CIRCLED KATAKANA NA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E4"},13029:{"value":"32E5","name":"CIRCLED KATAKANA NI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E5"},13030:{"value":"32E6","name":"CIRCLED KATAKANA NU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E6"},13031:{"value":"32E7","name":"CIRCLED KATAKANA NE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E7"},13032:{"value":"32E8","name":"CIRCLED KATAKANA NO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E8"},13033:{"value":"32E9","name":"CIRCLED KATAKANA HA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30CF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32E9"},13034:{"value":"32EA","name":"CIRCLED KATAKANA HI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30D2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32EA"},13035:{"value":"32EB","name":"CIRCLED KATAKANA HU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30D5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32EB"},13036:{"value":"32EC","name":"CIRCLED KATAKANA HE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30D8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32EC"},13037:{"value":"32ED","name":"CIRCLED KATAKANA HO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30DB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32ED"},13038:{"value":"32EE","name":"CIRCLED KATAKANA MA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30DE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32EE"},13039:{"value":"32EF","name":"CIRCLED KATAKANA MI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30DF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32EF"},13040:{"value":"32F0","name":"CIRCLED KATAKANA MU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F0"},13041:{"value":"32F1","name":"CIRCLED KATAKANA ME","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F1"},13042:{"value":"32F2","name":"CIRCLED KATAKANA MO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F2"},13043:{"value":"32F3","name":"CIRCLED KATAKANA YA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F3"},13044:{"value":"32F4","name":"CIRCLED KATAKANA YU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F4"},13045:{"value":"32F5","name":"CIRCLED KATAKANA YO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F5"},13046:{"value":"32F6","name":"CIRCLED KATAKANA RA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30E9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F6"},13047:{"value":"32F7","name":"CIRCLED KATAKANA RI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30EA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F7"},13048:{"value":"32F8","name":"CIRCLED KATAKANA RU","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F8"},13049:{"value":"32F9","name":"CIRCLED KATAKANA RE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30EC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32F9"},13050:{"value":"32FA","name":"CIRCLED KATAKANA RO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30ED","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32FA"},13051:{"value":"32FB","name":"CIRCLED KATAKANA WA","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30EF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32FB"},13052:{"value":"32FC","name":"CIRCLED KATAKANA WI","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30F0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32FC"},13053:{"value":"32FD","name":"CIRCLED KATAKANA WE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30F1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32FD"},13054:{"value":"32FE","name":"CIRCLED KATAKANA WO","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 30F2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u32FE"},13056:{"value":"3300","name":"SQUARE APAATO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A2 30D1 30FC 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED APAATO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3300"},13057:{"value":"3301","name":"SQUARE ARUHUA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A2 30EB 30D5 30A1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ARUHUA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3301"},13058:{"value":"3302","name":"SQUARE ANPEA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A2 30F3 30DA 30A2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ANPEA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3302"},13059:{"value":"3303","name":"SQUARE AARU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A2 30FC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED AARU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3303"},13060:{"value":"3304","name":"SQUARE ININGU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A4 30CB 30F3 30B0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ININGU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3304"},13061:{"value":"3305","name":"SQUARE INTI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A4 30F3 30C1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED INTI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3305"},13062:{"value":"3306","name":"SQUARE UON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A6 30A9 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED UON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3306"},13063:{"value":"3307","name":"SQUARE ESUKUUDO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A8 30B9 30AF 30FC 30C9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ESUKUUDO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3307"},13064:{"value":"3308","name":"SQUARE EEKAA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30A8 30FC 30AB 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED EEKAA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3308"},13065:{"value":"3309","name":"SQUARE ONSU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AA 30F3 30B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ONSU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3309"},13066:{"value":"330A","name":"SQUARE OOMU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AA 30FC 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED OOMU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330A"},13067:{"value":"330B","name":"SQUARE KAIRI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AB 30A4 30EA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KAIRI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330B"},13068:{"value":"330C","name":"SQUARE KARATTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AB 30E9 30C3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KARATTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330C"},13069:{"value":"330D","name":"SQUARE KARORII","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AB 30ED 30EA 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KARORII","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330D"},13070:{"value":"330E","name":"SQUARE GARON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AC 30ED 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GARON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330E"},13071:{"value":"330F","name":"SQUARE GANMA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AC 30F3 30DE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GANMA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u330F"},13072:{"value":"3310","name":"SQUARE GIGA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AE 30AC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GIGA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3310"},13073:{"value":"3311","name":"SQUARE GINII","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AE 30CB 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GINII","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3311"},13074:{"value":"3312","name":"SQUARE KYURII","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AD 30E5 30EA 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KYURII","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3312"},13075:{"value":"3313","name":"SQUARE GIRUDAA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AE 30EB 30C0 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GIRUDAA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3313"},13076:{"value":"3314","name":"SQUARE KIRO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AD 30ED","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KIRO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3314"},13077:{"value":"3315","name":"SQUARE KIROGURAMU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AD 30ED 30B0 30E9 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KIROGURAMU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3315"},13078:{"value":"3316","name":"SQUARE KIROMEETORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AD 30ED 30E1 30FC 30C8 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KIROMEETORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3316"},13079:{"value":"3317","name":"SQUARE KIROWATTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AD 30ED 30EF 30C3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KIROWATTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3317"},13080:{"value":"3318","name":"SQUARE GURAMU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B0 30E9 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GURAMU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3318"},13081:{"value":"3319","name":"SQUARE GURAMUTON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B0 30E9 30E0 30C8 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GURAMUTON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3319"},13082:{"value":"331A","name":"SQUARE KURUZEIRO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AF 30EB 30BC 30A4 30ED","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KURUZEIRO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331A"},13083:{"value":"331B","name":"SQUARE KUROONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30AF 30ED 30FC 30CD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KUROONE","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331B"},13084:{"value":"331C","name":"SQUARE KEESU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B1 30FC 30B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KEESU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331C"},13085:{"value":"331D","name":"SQUARE KORUNA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B3 30EB 30CA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KORUNA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331D"},13086:{"value":"331E","name":"SQUARE KOOPO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B3 30FC 30DD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KOOPO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331E"},13087:{"value":"331F","name":"SQUARE SAIKURU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B5 30A4 30AF 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SAIKURU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u331F"},13088:{"value":"3320","name":"SQUARE SANTIIMU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B5 30F3 30C1 30FC 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SANTIIMU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3320"},13089:{"value":"3321","name":"SQUARE SIRINGU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B7 30EA 30F3 30B0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SIRINGU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3321"},13090:{"value":"3322","name":"SQUARE SENTI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30BB 30F3 30C1","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SENTI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3322"},13091:{"value":"3323","name":"SQUARE SENTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30BB 30F3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SENTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3323"},13092:{"value":"3324","name":"SQUARE DAASU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30C0 30FC 30B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED DAASU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3324"},13093:{"value":"3325","name":"SQUARE DESI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30C7 30B7","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED DESI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3325"},13094:{"value":"3326","name":"SQUARE DORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30C9 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED DORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3326"},13095:{"value":"3327","name":"SQUARE TON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30C8 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED TON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3327"},13096:{"value":"3328","name":"SQUARE NANO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30CA 30CE","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NANO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3328"},13097:{"value":"3329","name":"SQUARE NOTTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30CE 30C3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NOTTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3329"},13098:{"value":"332A","name":"SQUARE HAITU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30CF 30A4 30C4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HAITU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332A"},13099:{"value":"332B","name":"SQUARE PAASENTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D1 30FC 30BB 30F3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PAASENTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332B"},13100:{"value":"332C","name":"SQUARE PAATU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D1 30FC 30C4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PAATU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332C"},13101:{"value":"332D","name":"SQUARE BAARERU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D0 30FC 30EC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BAARERU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332D"},13102:{"value":"332E","name":"SQUARE PIASUTORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D4 30A2 30B9 30C8 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PIASUTORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332E"},13103:{"value":"332F","name":"SQUARE PIKURU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D4 30AF 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PIKURU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u332F"},13104:{"value":"3330","name":"SQUARE PIKO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D4 30B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PIKO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3330"},13105:{"value":"3331","name":"SQUARE BIRU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D3 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BIRU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3331"},13106:{"value":"3332","name":"SQUARE HUARADDO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D5 30A1 30E9 30C3 30C9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HUARADDO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3332"},13107:{"value":"3333","name":"SQUARE HUIITO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D5 30A3 30FC 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HUIITO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3333"},13108:{"value":"3334","name":"SQUARE BUSSYERU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D6 30C3 30B7 30A7 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BUSSYERU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3334"},13109:{"value":"3335","name":"SQUARE HURAN","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D5 30E9 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HURAN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3335"},13110:{"value":"3336","name":"SQUARE HEKUTAARU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D8 30AF 30BF 30FC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HEKUTAARU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3336"},13111:{"value":"3337","name":"SQUARE PESO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DA 30BD","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PESO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3337"},13112:{"value":"3338","name":"SQUARE PENIHI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DA 30CB 30D2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PENIHI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3338"},13113:{"value":"3339","name":"SQUARE HERUTU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D8 30EB 30C4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HERUTU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3339"},13114:{"value":"333A","name":"SQUARE PENSU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DA 30F3 30B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PENSU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333A"},13115:{"value":"333B","name":"SQUARE PEEZI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DA 30FC 30B8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PEEZI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333B"},13116:{"value":"333C","name":"SQUARE BEETA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30D9 30FC 30BF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BEETA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333C"},13117:{"value":"333D","name":"SQUARE POINTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DD 30A4 30F3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED POINTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333D"},13118:{"value":"333E","name":"SQUARE BORUTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DC 30EB 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BORUTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333E"},13119:{"value":"333F","name":"SQUARE HON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DB 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u333F"},13120:{"value":"3340","name":"SQUARE PONDO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DD 30F3 30C9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PONDO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3340"},13121:{"value":"3341","name":"SQUARE HOORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DB 30FC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HOORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3341"},13122:{"value":"3342","name":"SQUARE HOON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DB 30FC 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HOON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3342"},13123:{"value":"3343","name":"SQUARE MAIKURO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DE 30A4 30AF 30ED","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MAIKURO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3343"},13124:{"value":"3344","name":"SQUARE MAIRU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DE 30A4 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MAIRU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3344"},13125:{"value":"3345","name":"SQUARE MAHHA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DE 30C3 30CF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MAHHA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3345"},13126:{"value":"3346","name":"SQUARE MARUKU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DE 30EB 30AF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MARUKU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3346"},13127:{"value":"3347","name":"SQUARE MANSYON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DE 30F3 30B7 30E7 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MANSYON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3347"},13128:{"value":"3348","name":"SQUARE MIKURON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DF 30AF 30ED 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MIKURON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3348"},13129:{"value":"3349","name":"SQUARE MIRI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DF 30EA","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MIRI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3349"},13130:{"value":"334A","name":"SQUARE MIRIBAARU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30DF 30EA 30D0 30FC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MIRIBAARU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334A"},13131:{"value":"334B","name":"SQUARE MEGA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E1 30AC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MEGA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334B"},13132:{"value":"334C","name":"SQUARE MEGATON","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E1 30AC 30C8 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MEGATON","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334C"},13133:{"value":"334D","name":"SQUARE MEETORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E1 30FC 30C8 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MEETORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334D"},13134:{"value":"334E","name":"SQUARE YAADO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E4 30FC 30C9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED YAADO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334E"},13135:{"value":"334F","name":"SQUARE YAARU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E4 30FC 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED YAARU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u334F"},13136:{"value":"3350","name":"SQUARE YUAN","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30E6 30A2 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED YUAN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3350"},13137:{"value":"3351","name":"SQUARE RITTORU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EA 30C3 30C8 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RITTORU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3351"},13138:{"value":"3352","name":"SQUARE RIRA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EA 30E9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RIRA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3352"},13139:{"value":"3353","name":"SQUARE RUPII","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EB 30D4 30FC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RUPII","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3353"},13140:{"value":"3354","name":"SQUARE RUUBURU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EB 30FC 30D6 30EB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RUUBURU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3354"},13141:{"value":"3355","name":"SQUARE REMU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EC 30E0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED REMU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3355"},13142:{"value":"3356","name":"SQUARE RENTOGEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EC 30F3 30C8 30B2 30F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RENTOGEN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3356"},13143:{"value":"3357","name":"SQUARE WATTO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30EF 30C3 30C8","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED WATTO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3357"},13144:{"value":"3358","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR ZERO","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0030 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3358"},13145:{"value":"3359","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3359"},13146:{"value":"335A","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335A"},13147:{"value":"335B","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR THREE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0033 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335B"},13148:{"value":"335C","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR FOUR","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0034 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335C"},13149:{"value":"335D","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR FIVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0035 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335D"},13150:{"value":"335E","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR SIX","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0036 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335E"},13151:{"value":"335F","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR SEVEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0037 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u335F"},13152:{"value":"3360","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR EIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0038 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3360"},13153:{"value":"3361","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR NINE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0039 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3361"},13154:{"value":"3362","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0030 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3362"},13155:{"value":"3363","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR ELEVEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0031 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3363"},13156:{"value":"3364","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWELVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0032 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3364"},13157:{"value":"3365","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR THIRTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0033 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3365"},13158:{"value":"3366","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR FOURTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0034 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3366"},13159:{"value":"3367","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR FIFTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0035 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3367"},13160:{"value":"3368","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR SIXTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0036 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3368"},13161:{"value":"3369","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR SEVENTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0037 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3369"},13162:{"value":"336A","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR EIGHTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0038 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336A"},13163:{"value":"336B","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR NINETEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0039 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336B"},13164:{"value":"336C","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWENTY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0030 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336C"},13165:{"value":"336D","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWENTY-ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0031 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336D"},13166:{"value":"336E","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWENTY-TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0032 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336E"},13167:{"value":"336F","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWENTY-THREE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0033 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u336F"},13168:{"value":"3370","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR HOUR TWENTY-FOUR","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0034 70B9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3370"},13169:{"value":"3371","name":"SQUARE HPA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0068 0050 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3371"},13170:{"value":"3372","name":"SQUARE DA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0064 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3372"},13171:{"value":"3373","name":"SQUARE AU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0041 0055","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3373"},13172:{"value":"3374","name":"SQUARE BAR","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0062 0061 0072","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3374"},13173:{"value":"3375","name":"SQUARE OV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006F 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3375"},13174:{"value":"3376","name":"SQUARE PC","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0063","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3376"},13175:{"value":"3377","name":"SQUARE DM","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0064 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3377"},13176:{"value":"3378","name":"SQUARE DM SQUARED","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0064 006D 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3378"},13177:{"value":"3379","name":"SQUARE DM CUBED","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0064 006D 00B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3379"},13178:{"value":"337A","name":"SQUARE IU","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0049 0055","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337A"},13179:{"value":"337B","name":"SQUARE ERA NAME HEISEI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5E73 6210","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED TWO IDEOGRAPHS ERA NAME HEISEI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337B"},13180:{"value":"337C","name":"SQUARE ERA NAME SYOUWA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 662D 548C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED TWO IDEOGRAPHS ERA NAME SYOUWA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337C"},13181:{"value":"337D","name":"SQUARE ERA NAME TAISYOU","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5927 6B63","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED TWO IDEOGRAPHS ERA NAME TAISYOU","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337D"},13182:{"value":"337E","name":"SQUARE ERA NAME MEIZI","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 660E 6CBB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED TWO IDEOGRAPHS ERA NAME MEIZI","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337E"},13183:{"value":"337F","name":"SQUARE CORPORATION","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 682A 5F0F 4F1A 793E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED FOUR IDEOGRAPHS CORPORATION","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u337F"},13184:{"value":"3380","name":"SQUARE PA AMPS","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PA AMPS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3380"},13185:{"value":"3381","name":"SQUARE NA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3381"},13186:{"value":"3382","name":"SQUARE MU A","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU A","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3382"},13187:{"value":"3383","name":"SQUARE MA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3383"},13188:{"value":"3384","name":"SQUARE KA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3384"},13189:{"value":"3385","name":"SQUARE KB","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004B 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3385"},13190:{"value":"3386","name":"SQUARE MB","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3386"},13191:{"value":"3387","name":"SQUARE GB","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0047 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3387"},13192:{"value":"3388","name":"SQUARE CAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 0061 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3388"},13193:{"value":"3389","name":"SQUARE KCAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0063 0061 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KCAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3389"},13194:{"value":"338A","name":"SQUARE PF","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PF","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338A"},13195:{"value":"338B","name":"SQUARE NF","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NF","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338B"},13196:{"value":"338C","name":"SQUARE MU F","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU F","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338C"},13197:{"value":"338D","name":"SQUARE MU G","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU G","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338D"},13198:{"value":"338E","name":"SQUARE MG","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338E"},13199:{"value":"338F","name":"SQUARE KG","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u338F"},13200:{"value":"3390","name":"SQUARE HZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0048 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HZ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3390"},13201:{"value":"3391","name":"SQUARE KHZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0048 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KHZ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3391"},13202:{"value":"3392","name":"SQUARE MHZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0048 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MHZ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3392"},13203:{"value":"3393","name":"SQUARE GHZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0047 0048 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GHZ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3393"},13204:{"value":"3394","name":"SQUARE THZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0054 0048 007A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED THZ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3394"},13205:{"value":"3395","name":"SQUARE MU L","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 2113","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU L","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3395"},13206:{"value":"3396","name":"SQUARE ML","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 2113","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED ML","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3396"},13207:{"value":"3397","name":"SQUARE DL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0064 2113","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED DL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3397"},13208:{"value":"3398","name":"SQUARE KL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 2113","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3398"},13209:{"value":"3399","name":"SQUARE FM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0066 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED FM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u3399"},13210:{"value":"339A","name":"SQUARE NM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339A"},13211:{"value":"339B","name":"SQUARE MU M","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU M","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339B"},13212:{"value":"339C","name":"SQUARE MM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339C"},13213:{"value":"339D","name":"SQUARE CM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339D"},13214:{"value":"339E","name":"SQUARE KM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339E"},13215:{"value":"339F","name":"SQUARE MM SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 006D 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MM SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u339F"},13216:{"value":"33A0","name":"SQUARE CM SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 006D 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CM SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A0"},13217:{"value":"33A1","name":"SQUARE M SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED M SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A1"},13218:{"value":"33A2","name":"SQUARE KM SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 006D 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KM SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A2"},13219:{"value":"33A3","name":"SQUARE MM CUBED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 006D 00B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MM CUBED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A3"},13220:{"value":"33A4","name":"SQUARE CM CUBED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 006D 00B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CM CUBED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A4"},13221:{"value":"33A5","name":"SQUARE M CUBED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 00B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED M CUBED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A5"},13222:{"value":"33A6","name":"SQUARE KM CUBED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 006D 00B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KM CUBED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A6"},13223:{"value":"33A7","name":"SQUARE M OVER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 2215 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED M OVER S","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A7"},13224:{"value":"33A8","name":"SQUARE M OVER S SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 2215 0073 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED M OVER S SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A8"},13225:{"value":"33A9","name":"SQUARE PA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33A9"},13226:{"value":"33AA","name":"SQUARE KPA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0050 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KPA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AA"},13227:{"value":"33AB","name":"SQUARE MPA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0050 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MPA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AB"},13228:{"value":"33AC","name":"SQUARE GPA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0047 0050 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GPA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AC"},13229:{"value":"33AD","name":"SQUARE RAD","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0072 0061 0064","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RAD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AD"},13230:{"value":"33AE","name":"SQUARE RAD OVER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0072 0061 0064 2215 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RAD OVER S","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AE"},13231:{"value":"33AF","name":"SQUARE RAD OVER S SQUARED","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0072 0061 0064 2215 0073 00B2","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED RAD OVER S SQUARED","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33AF"},13232:{"value":"33B0","name":"SQUARE PS","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B0"},13233:{"value":"33B1","name":"SQUARE NS","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B1"},13234:{"value":"33B2","name":"SQUARE MU S","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU S","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B2"},13235:{"value":"33B3","name":"SQUARE MS","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0073","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MS","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B3"},13236:{"value":"33B4","name":"SQUARE PV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PV","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B4"},13237:{"value":"33B5","name":"SQUARE NV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NV","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B5"},13238:{"value":"33B6","name":"SQUARE MU V","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU V","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B6"},13239:{"value":"33B7","name":"SQUARE MV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MV","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B7"},13240:{"value":"33B8","name":"SQUARE KV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KV","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B8"},13241:{"value":"33B9","name":"SQUARE MV MEGA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MV MEGA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33B9"},13242:{"value":"33BA","name":"SQUARE PW","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BA"},13243:{"value":"33BB","name":"SQUARE NW","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006E 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED NW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BB"},13244:{"value":"33BC","name":"SQUARE MU W","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 03BC 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MU W","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BC"},13245:{"value":"33BD","name":"SQUARE MW","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BD"},13246:{"value":"33BE","name":"SQUARE KW","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KW","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BE"},13247:{"value":"33BF","name":"SQUARE MW MEGA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MW MEGA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33BF"},13248:{"value":"33C0","name":"SQUARE K OHM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 03A9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED K OHM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C0"},13249:{"value":"33C1","name":"SQUARE M OHM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 03A9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED M OHM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C1"},13250:{"value":"33C2","name":"SQUARE AM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0061 002E 006D 002E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED AM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C2"},13251:{"value":"33C3","name":"SQUARE BQ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0042 0071","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED BQ","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C3"},13252:{"value":"33C4","name":"SQUARE CC","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 0063","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CC","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C4"},13253:{"value":"33C5","name":"SQUARE CD","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0063 0064","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CD","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C5"},13254:{"value":"33C6","name":"SQUARE C OVER KG","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0043 2215 006B 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED C OVER KG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C6"},13255:{"value":"33C7","name":"SQUARE CO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0043 006F 002E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED CO","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C7"},13256:{"value":"33C8","name":"SQUARE DB","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0064 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED DB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C8"},13257:{"value":"33C9","name":"SQUARE GY","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0047 0079","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED GY","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33C9"},13258:{"value":"33CA","name":"SQUARE HA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0068 0061","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HA","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CA"},13259:{"value":"33CB","name":"SQUARE HP","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0048 0050","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED HP","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CB"},13260:{"value":"33CC","name":"SQUARE IN","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0069 006E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED IN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CC"},13261:{"value":"33CD","name":"SQUARE KK","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004B 004B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KK","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CD"},13262:{"value":"33CE","name":"SQUARE KM CAPITAL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004B 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KM CAPITAL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CE"},13263:{"value":"33CF","name":"SQUARE KT","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006B 0074","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED KT","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33CF"},13264:{"value":"33D0","name":"SQUARE LM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006C 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED LM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D0"},13265:{"value":"33D1","name":"SQUARE LN","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006C 006E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED LN","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D1"},13266:{"value":"33D2","name":"SQUARE LOG","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006C 006F 0067","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED LOG","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D2"},13267:{"value":"33D3","name":"SQUARE LX","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006C 0078","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED LX","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D3"},13268:{"value":"33D4","name":"SQUARE MB SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0062","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MB SMALL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D4"},13269:{"value":"33D5","name":"SQUARE MIL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 0069 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MIL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D5"},13270:{"value":"33D6","name":"SQUARE MOL","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 006D 006F 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED MOL","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D6"},13271:{"value":"33D7","name":"SQUARE PH","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050 0048","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PH","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D7"},13272:{"value":"33D8","name":"SQUARE PM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0070 002E 006D 002E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D8"},13273:{"value":"33D9","name":"SQUARE PPM","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050 0050 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PPM","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33D9"},13274:{"value":"33DA","name":"SQUARE PR","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050 0052","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED PR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DA"},13275:{"value":"33DB","name":"SQUARE SR","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0073 0072","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DB"},13276:{"value":"33DC","name":"SQUARE SV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0053 0076","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED SV","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DC"},13277:{"value":"33DD","name":"SQUARE WB","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0057 0062","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"SQUARED WB","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DD"},13278:{"value":"33DE","name":"SQUARE V OVER M","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0056 2215 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DE"},13279:{"value":"33DF","name":"SQUARE A OVER M","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0041 2215 006D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33DF"},13280:{"value":"33E0","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E0"},13281:{"value":"33E1","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E1"},13282:{"value":"33E2","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY THREE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0033 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E2"},13283:{"value":"33E3","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY FOUR","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0034 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E3"},13284:{"value":"33E4","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY FIVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0035 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E4"},13285:{"value":"33E5","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY SIX","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0036 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E5"},13286:{"value":"33E6","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY SEVEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0037 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E6"},13287:{"value":"33E7","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY EIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0038 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E7"},13288:{"value":"33E8","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY NINE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0039 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E8"},13289:{"value":"33E9","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0030 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33E9"},13290:{"value":"33EA","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY ELEVEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0031 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33EA"},13291:{"value":"33EB","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWELVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0032 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33EB"},13292:{"value":"33EC","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY THIRTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0033 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33EC"},13293:{"value":"33ED","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY FOURTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0034 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33ED"},13294:{"value":"33EE","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY FIFTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0035 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33EE"},13295:{"value":"33EF","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY SIXTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0036 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33EF"},13296:{"value":"33F0","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY SEVENTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0037 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F0"},13297:{"value":"33F1","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY EIGHTEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0038 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F1"},13298:{"value":"33F2","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY NINETEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0031 0039 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F2"},13299:{"value":"33F3","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0030 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F3"},13300:{"value":"33F4","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0031 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F4"},13301:{"value":"33F5","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0032 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F5"},13302:{"value":"33F6","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-THREE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0033 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F6"},13303:{"value":"33F7","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-FOUR","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0034 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F7"},13304:{"value":"33F8","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-FIVE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0035 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F8"},13305:{"value":"33F9","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-SIX","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0036 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33F9"},13306:{"value":"33FA","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-SEVEN","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0037 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FA"},13307:{"value":"33FB","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-EIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0038 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FB"},13308:{"value":"33FC","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY TWENTY-NINE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0032 0039 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FC"},13309:{"value":"33FD","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY THIRTY","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0033 0030 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FD"},13310:{"value":"33FE","name":"IDEOGRAPHIC TELEGRAPH SYMBOL FOR DAY THIRTY-ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0033 0031 65E5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FE"},13311:{"value":"33FF","name":"SQUARE GAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<square> 0067 0061 006C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u33FF"},19904:{"value":"4DC0","name":"HEXAGRAM FOR THE CREATIVE HEAVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC0"},19905:{"value":"4DC1","name":"HEXAGRAM FOR THE RECEPTIVE EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC1"},19906:{"value":"4DC2","name":"HEXAGRAM FOR DIFFICULTY AT THE BEGINNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC2"},19907:{"value":"4DC3","name":"HEXAGRAM FOR YOUTHFUL FOLLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC3"},19908:{"value":"4DC4","name":"HEXAGRAM FOR WAITING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC4"},19909:{"value":"4DC5","name":"HEXAGRAM FOR CONFLICT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC5"},19910:{"value":"4DC6","name":"HEXAGRAM FOR THE ARMY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC6"},19911:{"value":"4DC7","name":"HEXAGRAM FOR HOLDING TOGETHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC7"},19912:{"value":"4DC8","name":"HEXAGRAM FOR SMALL TAMING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC8"},19913:{"value":"4DC9","name":"HEXAGRAM FOR TREADING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DC9"},19914:{"value":"4DCA","name":"HEXAGRAM FOR PEACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCA"},19915:{"value":"4DCB","name":"HEXAGRAM FOR STANDSTILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCB"},19916:{"value":"4DCC","name":"HEXAGRAM FOR FELLOWSHIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCC"},19917:{"value":"4DCD","name":"HEXAGRAM FOR GREAT POSSESSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCD"},19918:{"value":"4DCE","name":"HEXAGRAM FOR MODESTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCE"},19919:{"value":"4DCF","name":"HEXAGRAM FOR ENTHUSIASM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DCF"},19920:{"value":"4DD0","name":"HEXAGRAM FOR FOLLOWING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD0"},19921:{"value":"4DD1","name":"HEXAGRAM FOR WORK ON THE DECAYED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD1"},19922:{"value":"4DD2","name":"HEXAGRAM FOR APPROACH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD2"},19923:{"value":"4DD3","name":"HEXAGRAM FOR CONTEMPLATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD3"},19924:{"value":"4DD4","name":"HEXAGRAM FOR BITING THROUGH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD4"},19925:{"value":"4DD5","name":"HEXAGRAM FOR GRACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD5"},19926:{"value":"4DD6","name":"HEXAGRAM FOR SPLITTING APART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD6"},19927:{"value":"4DD7","name":"HEXAGRAM FOR RETURN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD7"},19928:{"value":"4DD8","name":"HEXAGRAM FOR INNOCENCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD8"},19929:{"value":"4DD9","name":"HEXAGRAM FOR GREAT TAMING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DD9"},19930:{"value":"4DDA","name":"HEXAGRAM FOR MOUTH CORNERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDA"},19931:{"value":"4DDB","name":"HEXAGRAM FOR GREAT PREPONDERANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDB"},19932:{"value":"4DDC","name":"HEXAGRAM FOR THE ABYSMAL WATER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDC"},19933:{"value":"4DDD","name":"HEXAGRAM FOR THE CLINGING FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDD"},19934:{"value":"4DDE","name":"HEXAGRAM FOR INFLUENCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDE"},19935:{"value":"4DDF","name":"HEXAGRAM FOR DURATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DDF"},19936:{"value":"4DE0","name":"HEXAGRAM FOR RETREAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE0"},19937:{"value":"4DE1","name":"HEXAGRAM FOR GREAT POWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE1"},19938:{"value":"4DE2","name":"HEXAGRAM FOR PROGRESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE2"},19939:{"value":"4DE3","name":"HEXAGRAM FOR DARKENING OF THE LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE3"},19940:{"value":"4DE4","name":"HEXAGRAM FOR THE FAMILY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE4"},19941:{"value":"4DE5","name":"HEXAGRAM FOR OPPOSITION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE5"},19942:{"value":"4DE6","name":"HEXAGRAM FOR OBSTRUCTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE6"},19943:{"value":"4DE7","name":"HEXAGRAM FOR DELIVERANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE7"},19944:{"value":"4DE8","name":"HEXAGRAM FOR DECREASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE8"},19945:{"value":"4DE9","name":"HEXAGRAM FOR INCREASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DE9"},19946:{"value":"4DEA","name":"HEXAGRAM FOR BREAKTHROUGH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DEA"},19947:{"value":"4DEB","name":"HEXAGRAM FOR COMING TO MEET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DEB"},19948:{"value":"4DEC","name":"HEXAGRAM FOR GATHERING TOGETHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DEC"},19949:{"value":"4DED","name":"HEXAGRAM FOR PUSHING UPWARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DED"},19950:{"value":"4DEE","name":"HEXAGRAM FOR OPPRESSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DEE"},19951:{"value":"4DEF","name":"HEXAGRAM FOR THE WELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DEF"},19952:{"value":"4DF0","name":"HEXAGRAM FOR REVOLUTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF0"},19953:{"value":"4DF1","name":"HEXAGRAM FOR THE CAULDRON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF1"},19954:{"value":"4DF2","name":"HEXAGRAM FOR THE AROUSING THUNDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF2"},19955:{"value":"4DF3","name":"HEXAGRAM FOR THE KEEPING STILL MOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF3"},19956:{"value":"4DF4","name":"HEXAGRAM FOR DEVELOPMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF4"},19957:{"value":"4DF5","name":"HEXAGRAM FOR THE MARRYING MAIDEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF5"},19958:{"value":"4DF6","name":"HEXAGRAM FOR ABUNDANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF6"},19959:{"value":"4DF7","name":"HEXAGRAM FOR THE WANDERER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF7"},19960:{"value":"4DF8","name":"HEXAGRAM FOR THE GENTLE WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF8"},19961:{"value":"4DF9","name":"HEXAGRAM FOR THE JOYOUS LAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DF9"},19962:{"value":"4DFA","name":"HEXAGRAM FOR DISPERSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFA"},19963:{"value":"4DFB","name":"HEXAGRAM FOR LIMITATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFB"},19964:{"value":"4DFC","name":"HEXAGRAM FOR INNER TRUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFC"},19965:{"value":"4DFD","name":"HEXAGRAM FOR SMALL PREPONDERANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFD"},19966:{"value":"4DFE","name":"HEXAGRAM FOR AFTER COMPLETION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFE"},19967:{"value":"4DFF","name":"HEXAGRAM FOR BEFORE COMPLETION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u4DFF"},42128:{"value":"A490","name":"YI RADICAL QOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA490"},42129:{"value":"A491","name":"YI RADICAL LI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA491"},42130:{"value":"A492","name":"YI RADICAL KIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA492"},42131:{"value":"A493","name":"YI RADICAL NYIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA493"},42132:{"value":"A494","name":"YI RADICAL CYP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA494"},42133:{"value":"A495","name":"YI RADICAL SSI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA495"},42134:{"value":"A496","name":"YI RADICAL GGOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA496"},42135:{"value":"A497","name":"YI RADICAL GEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA497"},42136:{"value":"A498","name":"YI RADICAL MI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA498"},42137:{"value":"A499","name":"YI RADICAL HXIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA499"},42138:{"value":"A49A","name":"YI RADICAL LYR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49A"},42139:{"value":"A49B","name":"YI RADICAL BBUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49B"},42140:{"value":"A49C","name":"YI RADICAL MOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49C"},42141:{"value":"A49D","name":"YI RADICAL YO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49D"},42142:{"value":"A49E","name":"YI RADICAL PUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49E"},42143:{"value":"A49F","name":"YI RADICAL HXUO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA49F"},42144:{"value":"A4A0","name":"YI RADICAL TAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A0"},42145:{"value":"A4A1","name":"YI RADICAL GA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A1"},42146:{"value":"A4A2","name":"YI RADICAL ZUP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A2"},42147:{"value":"A4A3","name":"YI RADICAL CYT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A3"},42148:{"value":"A4A4","name":"YI RADICAL DDUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A4"},42149:{"value":"A4A5","name":"YI RADICAL BUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A5"},42150:{"value":"A4A6","name":"YI RADICAL GGUO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A6"},42151:{"value":"A4A7","name":"YI RADICAL NYOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A7"},42152:{"value":"A4A8","name":"YI RADICAL TU","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A8"},42153:{"value":"A4A9","name":"YI RADICAL OP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4A9"},42154:{"value":"A4AA","name":"YI RADICAL JJUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AA"},42155:{"value":"A4AB","name":"YI RADICAL ZOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AB"},42156:{"value":"A4AC","name":"YI RADICAL PYT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AC"},42157:{"value":"A4AD","name":"YI RADICAL HMO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AD"},42158:{"value":"A4AE","name":"YI RADICAL YIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AE"},42159:{"value":"A4AF","name":"YI RADICAL VUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4AF"},42160:{"value":"A4B0","name":"YI RADICAL SHY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B0"},42161:{"value":"A4B1","name":"YI RADICAL VEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B1"},42162:{"value":"A4B2","name":"YI RADICAL ZA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B2"},42163:{"value":"A4B3","name":"YI RADICAL JO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B3"},42164:{"value":"A4B4","name":"YI RADICAL NZUP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B4"},42165:{"value":"A4B5","name":"YI RADICAL JJY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B5"},42166:{"value":"A4B6","name":"YI RADICAL GOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B6"},42167:{"value":"A4B7","name":"YI RADICAL JJIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B7"},42168:{"value":"A4B8","name":"YI RADICAL WO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B8"},42169:{"value":"A4B9","name":"YI RADICAL DU","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4B9"},42170:{"value":"A4BA","name":"YI RADICAL SHUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BA"},42171:{"value":"A4BB","name":"YI RADICAL LIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BB"},42172:{"value":"A4BC","name":"YI RADICAL CY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BC"},42173:{"value":"A4BD","name":"YI RADICAL CUOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BD"},42174:{"value":"A4BE","name":"YI RADICAL CIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BE"},42175:{"value":"A4BF","name":"YI RADICAL HXOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4BF"},42176:{"value":"A4C0","name":"YI RADICAL SHAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C0"},42177:{"value":"A4C1","name":"YI RADICAL ZUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C1"},42178:{"value":"A4C2","name":"YI RADICAL SHOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C2"},42179:{"value":"A4C3","name":"YI RADICAL CHE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C3"},42180:{"value":"A4C4","name":"YI RADICAL ZZIET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C4"},42181:{"value":"A4C5","name":"YI RADICAL NBIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C5"},42182:{"value":"A4C6","name":"YI RADICAL KE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA4C6"},43048:{"value":"A828","name":"SYLOTI NAGRI POETRY MARK-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA828"},43049:{"value":"A829","name":"SYLOTI NAGRI POETRY MARK-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA829"},43050:{"value":"A82A","name":"SYLOTI NAGRI POETRY MARK-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA82A"},43051:{"value":"A82B","name":"SYLOTI NAGRI POETRY MARK-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA82B"},43062:{"value":"A836","name":"NORTH INDIC QUARTER MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA836"},43063:{"value":"A837","name":"NORTH INDIC PLACEHOLDER MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA837"},43065:{"value":"A839","name":"NORTH INDIC QUANTITY MARK","category":"So","class":"0","bidirectional_category":"ET","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uA839"},43639:{"value":"AA77","name":"MYANMAR SYMBOL AITON EXCLAMATION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uAA77"},43640:{"value":"AA78","name":"MYANMAR SYMBOL AITON ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uAA78"},43641:{"value":"AA79","name":"MYANMAR SYMBOL AITON TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uAA79"},65021:{"value":"FDFD","name":"ARABIC LIGATURE BISMILLAH AR-RAHMAN AR-RAHEEM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFDFD"},65508:{"value":"FFE4","name":"FULLWIDTH BROKEN BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"<wide> 00A6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"FULLWIDTH BROKEN VERTICAL BAR","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFE4"},65512:{"value":"FFE8","name":"HALFWIDTH FORMS LIGHT VERTICAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"<narrow> 2502","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFE8"},65517:{"value":"FFED","name":"HALFWIDTH BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<narrow> 25A0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFED"},65518:{"value":"FFEE","name":"HALFWIDTH WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"<narrow> 25CB","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFEE"},65532:{"value":"FFFC","name":"OBJECT REPLACEMENT CHARACTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFFC"},65533:{"value":"FFFD","name":"REPLACEMENT CHARACTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uFFFD"},65847:{"value":"10137","name":"AEGEAN WEIGHT BASE UNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0137"},65848:{"value":"10138","name":"AEGEAN WEIGHT FIRST SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0138"},65849:{"value":"10139","name":"AEGEAN WEIGHT SECOND SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0139"},65850:{"value":"1013A","name":"AEGEAN WEIGHT THIRD SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013A"},65851:{"value":"1013B","name":"AEGEAN WEIGHT FOURTH SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013B"},65852:{"value":"1013C","name":"AEGEAN DRY MEASURE FIRST SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013C"},65853:{"value":"1013D","name":"AEGEAN LIQUID MEASURE FIRST SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013D"},65854:{"value":"1013E","name":"AEGEAN MEASURE SECOND SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013E"},65855:{"value":"1013F","name":"AEGEAN MEASURE THIRD SUBUNIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u013F"},65913:{"value":"10179","name":"GREEK YEAR SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0179"},65914:{"value":"1017A","name":"GREEK TALENT SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017A"},65915:{"value":"1017B","name":"GREEK DRACHMA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017B"},65916:{"value":"1017C","name":"GREEK OBOL SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017C"},65917:{"value":"1017D","name":"GREEK TWO OBOLS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017D"},65918:{"value":"1017E","name":"GREEK THREE OBOLS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017E"},65919:{"value":"1017F","name":"GREEK FOUR OBOLS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u017F"},65920:{"value":"10180","name":"GREEK FIVE OBOLS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0180"},65921:{"value":"10181","name":"GREEK METRETES SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0181"},65922:{"value":"10182","name":"GREEK KYATHOS BASE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0182"},65923:{"value":"10183","name":"GREEK LITRA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0183"},65924:{"value":"10184","name":"GREEK OUNKIA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0184"},65925:{"value":"10185","name":"GREEK XESTES SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0185"},65926:{"value":"10186","name":"GREEK ARTABE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0186"},65927:{"value":"10187","name":"GREEK AROURA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0187"},65928:{"value":"10188","name":"GREEK GRAMMA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0188"},65929:{"value":"10189","name":"GREEK TRYBLION BASE SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0189"},65932:{"value":"1018C","name":"GREEK SINUSOID SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u018C"},65933:{"value":"1018D","name":"GREEK INDICTION SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u018D"},65934:{"value":"1018E","name":"NOMISMA SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u018E"},65936:{"value":"10190","name":"ROMAN SEXTANS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0190"},65937:{"value":"10191","name":"ROMAN UNCIA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0191"},65938:{"value":"10192","name":"ROMAN SEMUNCIA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0192"},65939:{"value":"10193","name":"ROMAN SEXTULA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0193"},65940:{"value":"10194","name":"ROMAN DIMIDIA SEXTULA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0194"},65941:{"value":"10195","name":"ROMAN SILIQUA SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0195"},65942:{"value":"10196","name":"ROMAN DENARIUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0196"},65943:{"value":"10197","name":"ROMAN QUINARIUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0197"},65944:{"value":"10198","name":"ROMAN SESTERTIUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0198"},65945:{"value":"10199","name":"ROMAN DUPONDIUS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0199"},65946:{"value":"1019A","name":"ROMAN AS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u019A"},65947:{"value":"1019B","name":"ROMAN CENTURIAL SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u019B"},65952:{"value":"101A0","name":"GREEK SYMBOL TAU RHO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01A0"},66000:{"value":"101D0","name":"PHAISTOS DISC SIGN PEDESTRIAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D0"},66001:{"value":"101D1","name":"PHAISTOS DISC SIGN PLUMED HEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D1"},66002:{"value":"101D2","name":"PHAISTOS DISC SIGN TATTOOED HEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D2"},66003:{"value":"101D3","name":"PHAISTOS DISC SIGN CAPTIVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D3"},66004:{"value":"101D4","name":"PHAISTOS DISC SIGN CHILD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D4"},66005:{"value":"101D5","name":"PHAISTOS DISC SIGN WOMAN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D5"},66006:{"value":"101D6","name":"PHAISTOS DISC SIGN HELMET","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D6"},66007:{"value":"101D7","name":"PHAISTOS DISC SIGN GAUNTLET","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D7"},66008:{"value":"101D8","name":"PHAISTOS DISC SIGN TIARA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D8"},66009:{"value":"101D9","name":"PHAISTOS DISC SIGN ARROW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01D9"},66010:{"value":"101DA","name":"PHAISTOS DISC SIGN BOW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DA"},66011:{"value":"101DB","name":"PHAISTOS DISC SIGN SHIELD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DB"},66012:{"value":"101DC","name":"PHAISTOS DISC SIGN CLUB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DC"},66013:{"value":"101DD","name":"PHAISTOS DISC SIGN MANACLES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DD"},66014:{"value":"101DE","name":"PHAISTOS DISC SIGN MATTOCK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DE"},66015:{"value":"101DF","name":"PHAISTOS DISC SIGN SAW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01DF"},66016:{"value":"101E0","name":"PHAISTOS DISC SIGN LID","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E0"},66017:{"value":"101E1","name":"PHAISTOS DISC SIGN BOOMERANG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E1"},66018:{"value":"101E2","name":"PHAISTOS DISC SIGN CARPENTRY PLANE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E2"},66019:{"value":"101E3","name":"PHAISTOS DISC SIGN DOLIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E3"},66020:{"value":"101E4","name":"PHAISTOS DISC SIGN COMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E4"},66021:{"value":"101E5","name":"PHAISTOS DISC SIGN SLING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E5"},66022:{"value":"101E6","name":"PHAISTOS DISC SIGN COLUMN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E6"},66023:{"value":"101E7","name":"PHAISTOS DISC SIGN BEEHIVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E7"},66024:{"value":"101E8","name":"PHAISTOS DISC SIGN SHIP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E8"},66025:{"value":"101E9","name":"PHAISTOS DISC SIGN HORN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01E9"},66026:{"value":"101EA","name":"PHAISTOS DISC SIGN HIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01EA"},66027:{"value":"101EB","name":"PHAISTOS DISC SIGN BULLS LEG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01EB"},66028:{"value":"101EC","name":"PHAISTOS DISC SIGN CAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01EC"},66029:{"value":"101ED","name":"PHAISTOS DISC SIGN RAM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01ED"},66030:{"value":"101EE","name":"PHAISTOS DISC SIGN EAGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01EE"},66031:{"value":"101EF","name":"PHAISTOS DISC SIGN DOVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01EF"},66032:{"value":"101F0","name":"PHAISTOS DISC SIGN TUNNY","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F0"},66033:{"value":"101F1","name":"PHAISTOS DISC SIGN BEE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F1"},66034:{"value":"101F2","name":"PHAISTOS DISC SIGN PLANE TREE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F2"},66035:{"value":"101F3","name":"PHAISTOS DISC SIGN VINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F3"},66036:{"value":"101F4","name":"PHAISTOS DISC SIGN PAPYRUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F4"},66037:{"value":"101F5","name":"PHAISTOS DISC SIGN ROSETTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F5"},66038:{"value":"101F6","name":"PHAISTOS DISC SIGN LILY","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F6"},66039:{"value":"101F7","name":"PHAISTOS DISC SIGN OX BACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F7"},66040:{"value":"101F8","name":"PHAISTOS DISC SIGN FLUTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F8"},66041:{"value":"101F9","name":"PHAISTOS DISC SIGN GRATER","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01F9"},66042:{"value":"101FA","name":"PHAISTOS DISC SIGN STRAINER","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01FA"},66043:{"value":"101FB","name":"PHAISTOS DISC SIGN SMALL AXE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01FB"},66044:{"value":"101FC","name":"PHAISTOS DISC SIGN WAVY BAND","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u01FC"},67703:{"value":"10877","name":"PALMYRENE LEFT-POINTING FLEURON","category":"So","class":"0","bidirectional_category":"R","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0877"},67704:{"value":"10878","name":"PALMYRENE RIGHT-POINTING FLEURON","category":"So","class":"0","bidirectional_category":"R","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0878"},68296:{"value":"10AC8","name":"MANICHAEAN SIGN UD","category":"So","class":"0","bidirectional_category":"R","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u0AC8"},71487:{"value":"1173F","name":"AHOM SYMBOL VI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u173F"},92988:{"value":"16B3C","name":"PAHAWH HMONG SIGN XYEEM NTXIV","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u6B3C"},92989:{"value":"16B3D","name":"PAHAWH HMONG SIGN XYEEM RHO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u6B3D"},92990:{"value":"16B3E","name":"PAHAWH HMONG SIGN XYEEM TOV","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u6B3E"},92991:{"value":"16B3F","name":"PAHAWH HMONG SIGN XYEEM FAIB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u6B3F"},92997:{"value":"16B45","name":"PAHAWH HMONG SIGN CIM TSOV ROG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\u6B45"},113820:{"value":"1BC9C","name":"DUPLOYAN SIGN O WITH CROSS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uBC9C"},118784:{"value":"1D000","name":"BYZANTINE MUSICAL SYMBOL PSILI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD000"},118785:{"value":"1D001","name":"BYZANTINE MUSICAL SYMBOL DASEIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD001"},118786:{"value":"1D002","name":"BYZANTINE MUSICAL SYMBOL PERISPOMENI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD002"},118787:{"value":"1D003","name":"BYZANTINE MUSICAL SYMBOL OXEIA EKFONITIKON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD003"},118788:{"value":"1D004","name":"BYZANTINE MUSICAL SYMBOL OXEIA DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD004"},118789:{"value":"1D005","name":"BYZANTINE MUSICAL SYMBOL VAREIA EKFONITIKON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD005"},118790:{"value":"1D006","name":"BYZANTINE MUSICAL SYMBOL VAREIA DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD006"},118791:{"value":"1D007","name":"BYZANTINE MUSICAL SYMBOL KATHISTI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD007"},118792:{"value":"1D008","name":"BYZANTINE MUSICAL SYMBOL SYRMATIKI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD008"},118793:{"value":"1D009","name":"BYZANTINE MUSICAL SYMBOL PARAKLITIKI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD009"},118794:{"value":"1D00A","name":"BYZANTINE MUSICAL SYMBOL YPOKRISIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00A"},118795:{"value":"1D00B","name":"BYZANTINE MUSICAL SYMBOL YPOKRISIS DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00B"},118796:{"value":"1D00C","name":"BYZANTINE MUSICAL SYMBOL KREMASTI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00C"},118797:{"value":"1D00D","name":"BYZANTINE MUSICAL SYMBOL APESO EKFONITIKON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00D"},118798:{"value":"1D00E","name":"BYZANTINE MUSICAL SYMBOL EXO EKFONITIKON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00E"},118799:{"value":"1D00F","name":"BYZANTINE MUSICAL SYMBOL TELEIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD00F"},118800:{"value":"1D010","name":"BYZANTINE MUSICAL SYMBOL KENTIMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD010"},118801:{"value":"1D011","name":"BYZANTINE MUSICAL SYMBOL APOSTROFOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD011"},118802:{"value":"1D012","name":"BYZANTINE MUSICAL SYMBOL APOSTROFOS DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD012"},118803:{"value":"1D013","name":"BYZANTINE MUSICAL SYMBOL SYNEVMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD013"},118804:{"value":"1D014","name":"BYZANTINE MUSICAL SYMBOL THITA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD014"},118805:{"value":"1D015","name":"BYZANTINE MUSICAL SYMBOL OLIGON ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD015"},118806:{"value":"1D016","name":"BYZANTINE MUSICAL SYMBOL GORGON ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD016"},118807:{"value":"1D017","name":"BYZANTINE MUSICAL SYMBOL PSILON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD017"},118808:{"value":"1D018","name":"BYZANTINE MUSICAL SYMBOL CHAMILON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD018"},118809:{"value":"1D019","name":"BYZANTINE MUSICAL SYMBOL VATHY","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD019"},118810:{"value":"1D01A","name":"BYZANTINE MUSICAL SYMBOL ISON ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01A"},118811:{"value":"1D01B","name":"BYZANTINE MUSICAL SYMBOL KENTIMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01B"},118812:{"value":"1D01C","name":"BYZANTINE MUSICAL SYMBOL KENTIMATA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01C"},118813:{"value":"1D01D","name":"BYZANTINE MUSICAL SYMBOL SAXIMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01D"},118814:{"value":"1D01E","name":"BYZANTINE MUSICAL SYMBOL PARICHON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01E"},118815:{"value":"1D01F","name":"BYZANTINE MUSICAL SYMBOL STAVROS APODEXIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD01F"},118816:{"value":"1D020","name":"BYZANTINE MUSICAL SYMBOL OXEIAI ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD020"},118817:{"value":"1D021","name":"BYZANTINE MUSICAL SYMBOL VAREIAI ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD021"},118818:{"value":"1D022","name":"BYZANTINE MUSICAL SYMBOL APODERMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD022"},118819:{"value":"1D023","name":"BYZANTINE MUSICAL SYMBOL APOTHEMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD023"},118820:{"value":"1D024","name":"BYZANTINE MUSICAL SYMBOL KLASMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD024"},118821:{"value":"1D025","name":"BYZANTINE MUSICAL SYMBOL REVMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD025"},118822:{"value":"1D026","name":"BYZANTINE MUSICAL SYMBOL PIASMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD026"},118823:{"value":"1D027","name":"BYZANTINE MUSICAL SYMBOL TINAGMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD027"},118824:{"value":"1D028","name":"BYZANTINE MUSICAL SYMBOL ANATRICHISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD028"},118825:{"value":"1D029","name":"BYZANTINE MUSICAL SYMBOL SEISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD029"},118826:{"value":"1D02A","name":"BYZANTINE MUSICAL SYMBOL SYNAGMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02A"},118827:{"value":"1D02B","name":"BYZANTINE MUSICAL SYMBOL SYNAGMA META STAVROU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02B"},118828:{"value":"1D02C","name":"BYZANTINE MUSICAL SYMBOL OYRANISMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02C"},118829:{"value":"1D02D","name":"BYZANTINE MUSICAL SYMBOL THEMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02D"},118830:{"value":"1D02E","name":"BYZANTINE MUSICAL SYMBOL LEMOI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02E"},118831:{"value":"1D02F","name":"BYZANTINE MUSICAL SYMBOL DYO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD02F"},118832:{"value":"1D030","name":"BYZANTINE MUSICAL SYMBOL TRIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD030"},118833:{"value":"1D031","name":"BYZANTINE MUSICAL SYMBOL TESSERA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD031"},118834:{"value":"1D032","name":"BYZANTINE MUSICAL SYMBOL KRATIMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD032"},118835:{"value":"1D033","name":"BYZANTINE MUSICAL SYMBOL APESO EXO NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD033"},118836:{"value":"1D034","name":"BYZANTINE MUSICAL SYMBOL FTHORA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD034"},118837:{"value":"1D035","name":"BYZANTINE MUSICAL SYMBOL IMIFTHORA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD035"},118838:{"value":"1D036","name":"BYZANTINE MUSICAL SYMBOL TROMIKON ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD036"},118839:{"value":"1D037","name":"BYZANTINE MUSICAL SYMBOL KATAVA TROMIKON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD037"},118840:{"value":"1D038","name":"BYZANTINE MUSICAL SYMBOL PELASTON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD038"},118841:{"value":"1D039","name":"BYZANTINE MUSICAL SYMBOL PSIFISTON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD039"},118842:{"value":"1D03A","name":"BYZANTINE MUSICAL SYMBOL KONTEVMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03A"},118843:{"value":"1D03B","name":"BYZANTINE MUSICAL SYMBOL CHOREVMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03B"},118844:{"value":"1D03C","name":"BYZANTINE MUSICAL SYMBOL RAPISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03C"},118845:{"value":"1D03D","name":"BYZANTINE MUSICAL SYMBOL PARAKALESMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03D"},118846:{"value":"1D03E","name":"BYZANTINE MUSICAL SYMBOL PARAKLITIKI ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03E"},118847:{"value":"1D03F","name":"BYZANTINE MUSICAL SYMBOL ICHADIN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD03F"},118848:{"value":"1D040","name":"BYZANTINE MUSICAL SYMBOL NANA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD040"},118849:{"value":"1D041","name":"BYZANTINE MUSICAL SYMBOL PETASMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD041"},118850:{"value":"1D042","name":"BYZANTINE MUSICAL SYMBOL KONTEVMA ALLO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD042"},118851:{"value":"1D043","name":"BYZANTINE MUSICAL SYMBOL TROMIKON ALLO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD043"},118852:{"value":"1D044","name":"BYZANTINE MUSICAL SYMBOL STRAGGISMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD044"},118853:{"value":"1D045","name":"BYZANTINE MUSICAL SYMBOL GRONTHISMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD045"},118854:{"value":"1D046","name":"BYZANTINE MUSICAL SYMBOL ISON NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD046"},118855:{"value":"1D047","name":"BYZANTINE MUSICAL SYMBOL OLIGON NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD047"},118856:{"value":"1D048","name":"BYZANTINE MUSICAL SYMBOL OXEIA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD048"},118857:{"value":"1D049","name":"BYZANTINE MUSICAL SYMBOL PETASTI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD049"},118858:{"value":"1D04A","name":"BYZANTINE MUSICAL SYMBOL KOUFISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04A"},118859:{"value":"1D04B","name":"BYZANTINE MUSICAL SYMBOL PETASTOKOUFISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04B"},118860:{"value":"1D04C","name":"BYZANTINE MUSICAL SYMBOL KRATIMOKOUFISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04C"},118861:{"value":"1D04D","name":"BYZANTINE MUSICAL SYMBOL PELASTON NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04D"},118862:{"value":"1D04E","name":"BYZANTINE MUSICAL SYMBOL KENTIMATA NEO ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04E"},118863:{"value":"1D04F","name":"BYZANTINE MUSICAL SYMBOL KENTIMA NEO ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD04F"},118864:{"value":"1D050","name":"BYZANTINE MUSICAL SYMBOL YPSILI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD050"},118865:{"value":"1D051","name":"BYZANTINE MUSICAL SYMBOL APOSTROFOS NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD051"},118866:{"value":"1D052","name":"BYZANTINE MUSICAL SYMBOL APOSTROFOI SYNDESMOS NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD052"},118867:{"value":"1D053","name":"BYZANTINE MUSICAL SYMBOL YPORROI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD053"},118868:{"value":"1D054","name":"BYZANTINE MUSICAL SYMBOL KRATIMOYPORROON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD054"},118869:{"value":"1D055","name":"BYZANTINE MUSICAL SYMBOL ELAFRON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD055"},118870:{"value":"1D056","name":"BYZANTINE MUSICAL SYMBOL CHAMILI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD056"},118871:{"value":"1D057","name":"BYZANTINE MUSICAL SYMBOL MIKRON ISON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD057"},118872:{"value":"1D058","name":"BYZANTINE MUSICAL SYMBOL VAREIA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD058"},118873:{"value":"1D059","name":"BYZANTINE MUSICAL SYMBOL PIASMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD059"},118874:{"value":"1D05A","name":"BYZANTINE MUSICAL SYMBOL PSIFISTON NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05A"},118875:{"value":"1D05B","name":"BYZANTINE MUSICAL SYMBOL OMALON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05B"},118876:{"value":"1D05C","name":"BYZANTINE MUSICAL SYMBOL ANTIKENOMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05C"},118877:{"value":"1D05D","name":"BYZANTINE MUSICAL SYMBOL LYGISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05D"},118878:{"value":"1D05E","name":"BYZANTINE MUSICAL SYMBOL PARAKLITIKI NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05E"},118879:{"value":"1D05F","name":"BYZANTINE MUSICAL SYMBOL PARAKALESMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD05F"},118880:{"value":"1D060","name":"BYZANTINE MUSICAL SYMBOL ETERON PARAKALESMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD060"},118881:{"value":"1D061","name":"BYZANTINE MUSICAL SYMBOL KYLISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD061"},118882:{"value":"1D062","name":"BYZANTINE MUSICAL SYMBOL ANTIKENOKYLISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD062"},118883:{"value":"1D063","name":"BYZANTINE MUSICAL SYMBOL TROMIKON NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD063"},118884:{"value":"1D064","name":"BYZANTINE MUSICAL SYMBOL EKSTREPTON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD064"},118885:{"value":"1D065","name":"BYZANTINE MUSICAL SYMBOL SYNAGMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD065"},118886:{"value":"1D066","name":"BYZANTINE MUSICAL SYMBOL SYRMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD066"},118887:{"value":"1D067","name":"BYZANTINE MUSICAL SYMBOL CHOREVMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD067"},118888:{"value":"1D068","name":"BYZANTINE MUSICAL SYMBOL EPEGERMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD068"},118889:{"value":"1D069","name":"BYZANTINE MUSICAL SYMBOL SEISMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD069"},118890:{"value":"1D06A","name":"BYZANTINE MUSICAL SYMBOL XIRON KLASMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06A"},118891:{"value":"1D06B","name":"BYZANTINE MUSICAL SYMBOL TROMIKOPSIFISTON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06B"},118892:{"value":"1D06C","name":"BYZANTINE MUSICAL SYMBOL PSIFISTOLYGISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06C"},118893:{"value":"1D06D","name":"BYZANTINE MUSICAL SYMBOL TROMIKOLYGISMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06D"},118894:{"value":"1D06E","name":"BYZANTINE MUSICAL SYMBOL TROMIKOPARAKALESMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06E"},118895:{"value":"1D06F","name":"BYZANTINE MUSICAL SYMBOL PSIFISTOPARAKALESMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD06F"},118896:{"value":"1D070","name":"BYZANTINE MUSICAL SYMBOL TROMIKOSYNAGMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD070"},118897:{"value":"1D071","name":"BYZANTINE MUSICAL SYMBOL PSIFISTOSYNAGMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD071"},118898:{"value":"1D072","name":"BYZANTINE MUSICAL SYMBOL GORGOSYNTHETON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD072"},118899:{"value":"1D073","name":"BYZANTINE MUSICAL SYMBOL ARGOSYNTHETON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD073"},118900:{"value":"1D074","name":"BYZANTINE MUSICAL SYMBOL ETERON ARGOSYNTHETON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD074"},118901:{"value":"1D075","name":"BYZANTINE MUSICAL SYMBOL OYRANISMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD075"},118902:{"value":"1D076","name":"BYZANTINE MUSICAL SYMBOL THEMATISMOS ESO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD076"},118903:{"value":"1D077","name":"BYZANTINE MUSICAL SYMBOL THEMATISMOS EXO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD077"},118904:{"value":"1D078","name":"BYZANTINE MUSICAL SYMBOL THEMA APLOUN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD078"},118905:{"value":"1D079","name":"BYZANTINE MUSICAL SYMBOL THES KAI APOTHES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD079"},118906:{"value":"1D07A","name":"BYZANTINE MUSICAL SYMBOL KATAVASMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07A"},118907:{"value":"1D07B","name":"BYZANTINE MUSICAL SYMBOL ENDOFONON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07B"},118908:{"value":"1D07C","name":"BYZANTINE MUSICAL SYMBOL YFEN KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07C"},118909:{"value":"1D07D","name":"BYZANTINE MUSICAL SYMBOL YFEN ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07D"},118910:{"value":"1D07E","name":"BYZANTINE MUSICAL SYMBOL STAVROS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07E"},118911:{"value":"1D07F","name":"BYZANTINE MUSICAL SYMBOL KLASMA ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD07F"},118912:{"value":"1D080","name":"BYZANTINE MUSICAL SYMBOL DIPLI ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD080"},118913:{"value":"1D081","name":"BYZANTINE MUSICAL SYMBOL KRATIMA ARCHAION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD081"},118914:{"value":"1D082","name":"BYZANTINE MUSICAL SYMBOL KRATIMA ALLO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD082"},118915:{"value":"1D083","name":"BYZANTINE MUSICAL SYMBOL KRATIMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD083"},118916:{"value":"1D084","name":"BYZANTINE MUSICAL SYMBOL APODERMA NEO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD084"},118917:{"value":"1D085","name":"BYZANTINE MUSICAL SYMBOL APLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD085"},118918:{"value":"1D086","name":"BYZANTINE MUSICAL SYMBOL DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD086"},118919:{"value":"1D087","name":"BYZANTINE MUSICAL SYMBOL TRIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD087"},118920:{"value":"1D088","name":"BYZANTINE MUSICAL SYMBOL TETRAPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD088"},118921:{"value":"1D089","name":"BYZANTINE MUSICAL SYMBOL KORONIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD089"},118922:{"value":"1D08A","name":"BYZANTINE MUSICAL SYMBOL LEIMMA ENOS CHRONOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08A"},118923:{"value":"1D08B","name":"BYZANTINE MUSICAL SYMBOL LEIMMA DYO CHRONON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08B"},118924:{"value":"1D08C","name":"BYZANTINE MUSICAL SYMBOL LEIMMA TRION CHRONON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08C"},118925:{"value":"1D08D","name":"BYZANTINE MUSICAL SYMBOL LEIMMA TESSARON CHRONON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08D"},118926:{"value":"1D08E","name":"BYZANTINE MUSICAL SYMBOL LEIMMA IMISEOS CHRONOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08E"},118927:{"value":"1D08F","name":"BYZANTINE MUSICAL SYMBOL GORGON NEO ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD08F"},118928:{"value":"1D090","name":"BYZANTINE MUSICAL SYMBOL GORGON PARESTIGMENON ARISTERA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD090"},118929:{"value":"1D091","name":"BYZANTINE MUSICAL SYMBOL GORGON PARESTIGMENON DEXIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD091"},118930:{"value":"1D092","name":"BYZANTINE MUSICAL SYMBOL DIGORGON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD092"},118931:{"value":"1D093","name":"BYZANTINE MUSICAL SYMBOL DIGORGON PARESTIGMENON ARISTERA KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD093"},118932:{"value":"1D094","name":"BYZANTINE MUSICAL SYMBOL DIGORGON PARESTIGMENON ARISTERA ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD094"},118933:{"value":"1D095","name":"BYZANTINE MUSICAL SYMBOL DIGORGON PARESTIGMENON DEXIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD095"},118934:{"value":"1D096","name":"BYZANTINE MUSICAL SYMBOL TRIGORGON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD096"},118935:{"value":"1D097","name":"BYZANTINE MUSICAL SYMBOL ARGON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD097"},118936:{"value":"1D098","name":"BYZANTINE MUSICAL SYMBOL IMIDIARGON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD098"},118937:{"value":"1D099","name":"BYZANTINE MUSICAL SYMBOL DIARGON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD099"},118938:{"value":"1D09A","name":"BYZANTINE MUSICAL SYMBOL AGOGI POLI ARGI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09A"},118939:{"value":"1D09B","name":"BYZANTINE MUSICAL SYMBOL AGOGI ARGOTERI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09B"},118940:{"value":"1D09C","name":"BYZANTINE MUSICAL SYMBOL AGOGI ARGI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09C"},118941:{"value":"1D09D","name":"BYZANTINE MUSICAL SYMBOL AGOGI METRIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09D"},118942:{"value":"1D09E","name":"BYZANTINE MUSICAL SYMBOL AGOGI MESI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09E"},118943:{"value":"1D09F","name":"BYZANTINE MUSICAL SYMBOL AGOGI GORGI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD09F"},118944:{"value":"1D0A0","name":"BYZANTINE MUSICAL SYMBOL AGOGI GORGOTERI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A0"},118945:{"value":"1D0A1","name":"BYZANTINE MUSICAL SYMBOL AGOGI POLI GORGI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A1"},118946:{"value":"1D0A2","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA PROTOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A2"},118947:{"value":"1D0A3","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA ALLI PROTOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A3"},118948:{"value":"1D0A4","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA DEYTEROS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A4"},118949:{"value":"1D0A5","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA ALLI DEYTEROS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A5"},118950:{"value":"1D0A6","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA TRITOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A6"},118951:{"value":"1D0A7","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA TRIFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A7"},118952:{"value":"1D0A8","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA TETARTOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A8"},118953:{"value":"1D0A9","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA TETARTOS LEGETOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0A9"},118954:{"value":"1D0AA","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA LEGETOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AA"},118955:{"value":"1D0AB","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA PLAGIOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AB"},118956:{"value":"1D0AC","name":"BYZANTINE MUSICAL SYMBOL ISAKIA TELOUS ICHIMATOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AC"},118957:{"value":"1D0AD","name":"BYZANTINE MUSICAL SYMBOL APOSTROFOI TELOUS ICHIMATOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AD"},118958:{"value":"1D0AE","name":"BYZANTINE MUSICAL SYMBOL FANEROSIS TETRAFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AE"},118959:{"value":"1D0AF","name":"BYZANTINE MUSICAL SYMBOL FANEROSIS MONOFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0AF"},118960:{"value":"1D0B0","name":"BYZANTINE MUSICAL SYMBOL FANEROSIS DIFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B0"},118961:{"value":"1D0B1","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA VARYS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B1"},118962:{"value":"1D0B2","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA PROTOVARYS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B2"},118963:{"value":"1D0B3","name":"BYZANTINE MUSICAL SYMBOL MARTYRIA PLAGIOS TETARTOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B3"},118964:{"value":"1D0B4","name":"BYZANTINE MUSICAL SYMBOL GORTHMIKON N APLOUN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B4"},118965:{"value":"1D0B5","name":"BYZANTINE MUSICAL SYMBOL GORTHMIKON N DIPLOUN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B5"},118966:{"value":"1D0B6","name":"BYZANTINE MUSICAL SYMBOL ENARXIS KAI FTHORA VOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B6"},118967:{"value":"1D0B7","name":"BYZANTINE MUSICAL SYMBOL IMIFONON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B7"},118968:{"value":"1D0B8","name":"BYZANTINE MUSICAL SYMBOL IMIFTHORON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B8"},118969:{"value":"1D0B9","name":"BYZANTINE MUSICAL SYMBOL FTHORA ARCHAION DEYTEROU ICHOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0B9"},118970:{"value":"1D0BA","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI PA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BA"},118971:{"value":"1D0BB","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI NANA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BB"},118972:{"value":"1D0BC","name":"BYZANTINE MUSICAL SYMBOL FTHORA NAOS ICHOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BC"},118973:{"value":"1D0BD","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI DI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BD"},118974:{"value":"1D0BE","name":"BYZANTINE MUSICAL SYMBOL FTHORA SKLIRON DIATONON DI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BE"},118975:{"value":"1D0BF","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI KE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0BF"},118976:{"value":"1D0C0","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI ZO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C0"},118977:{"value":"1D0C1","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI NI KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C1"},118978:{"value":"1D0C2","name":"BYZANTINE MUSICAL SYMBOL FTHORA DIATONIKI NI ANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C2"},118979:{"value":"1D0C3","name":"BYZANTINE MUSICAL SYMBOL FTHORA MALAKON CHROMA DIFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C3"},118980:{"value":"1D0C4","name":"BYZANTINE MUSICAL SYMBOL FTHORA MALAKON CHROMA MONOFONIAS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C4"},118981:{"value":"1D0C5","name":"BYZANTINE MUSICAL SYMBOL FHTORA SKLIRON CHROMA VASIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C5"},118982:{"value":"1D0C6","name":"BYZANTINE MUSICAL SYMBOL FTHORA SKLIRON CHROMA SYNAFI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C6"},118983:{"value":"1D0C7","name":"BYZANTINE MUSICAL SYMBOL FTHORA NENANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C7"},118984:{"value":"1D0C8","name":"BYZANTINE MUSICAL SYMBOL CHROA ZYGOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C8"},118985:{"value":"1D0C9","name":"BYZANTINE MUSICAL SYMBOL CHROA KLITON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0C9"},118986:{"value":"1D0CA","name":"BYZANTINE MUSICAL SYMBOL CHROA SPATHI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CA"},118987:{"value":"1D0CB","name":"BYZANTINE MUSICAL SYMBOL FTHORA I YFESIS TETARTIMORION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CB"},118988:{"value":"1D0CC","name":"BYZANTINE MUSICAL SYMBOL FTHORA ENARMONIOS ANTIFONIA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CC"},118989:{"value":"1D0CD","name":"BYZANTINE MUSICAL SYMBOL YFESIS TRITIMORION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CD"},118990:{"value":"1D0CE","name":"BYZANTINE MUSICAL SYMBOL DIESIS TRITIMORION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CE"},118991:{"value":"1D0CF","name":"BYZANTINE MUSICAL SYMBOL DIESIS TETARTIMORION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0CF"},118992:{"value":"1D0D0","name":"BYZANTINE MUSICAL SYMBOL DIESIS APLI DYO DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D0"},118993:{"value":"1D0D1","name":"BYZANTINE MUSICAL SYMBOL DIESIS MONOGRAMMOS TESSERA DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D1"},118994:{"value":"1D0D2","name":"BYZANTINE MUSICAL SYMBOL DIESIS DIGRAMMOS EX DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D2"},118995:{"value":"1D0D3","name":"BYZANTINE MUSICAL SYMBOL DIESIS TRIGRAMMOS OKTO DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D3"},118996:{"value":"1D0D4","name":"BYZANTINE MUSICAL SYMBOL YFESIS APLI DYO DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D4"},118997:{"value":"1D0D5","name":"BYZANTINE MUSICAL SYMBOL YFESIS MONOGRAMMOS TESSERA DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D5"},118998:{"value":"1D0D6","name":"BYZANTINE MUSICAL SYMBOL YFESIS DIGRAMMOS EX DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D6"},118999:{"value":"1D0D7","name":"BYZANTINE MUSICAL SYMBOL YFESIS TRIGRAMMOS OKTO DODEKATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D7"},119000:{"value":"1D0D8","name":"BYZANTINE MUSICAL SYMBOL GENIKI DIESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D8"},119001:{"value":"1D0D9","name":"BYZANTINE MUSICAL SYMBOL GENIKI YFESIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0D9"},119002:{"value":"1D0DA","name":"BYZANTINE MUSICAL SYMBOL DIASTOLI APLI MIKRI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DA"},119003:{"value":"1D0DB","name":"BYZANTINE MUSICAL SYMBOL DIASTOLI APLI MEGALI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DB"},119004:{"value":"1D0DC","name":"BYZANTINE MUSICAL SYMBOL DIASTOLI DIPLI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DC"},119005:{"value":"1D0DD","name":"BYZANTINE MUSICAL SYMBOL DIASTOLI THESEOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DD"},119006:{"value":"1D0DE","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS THESEOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DE"},119007:{"value":"1D0DF","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS THESEOS DISIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0DF"},119008:{"value":"1D0E0","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS THESEOS TRISIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E0"},119009:{"value":"1D0E1","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS THESEOS TETRASIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E1"},119010:{"value":"1D0E2","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS ARSEOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E2"},119011:{"value":"1D0E3","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS ARSEOS DISIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E3"},119012:{"value":"1D0E4","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS ARSEOS TRISIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E4"},119013:{"value":"1D0E5","name":"BYZANTINE MUSICAL SYMBOL SIMANSIS ARSEOS TETRASIMOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E5"},119014:{"value":"1D0E6","name":"BYZANTINE MUSICAL SYMBOL DIGRAMMA GG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E6"},119015:{"value":"1D0E7","name":"BYZANTINE MUSICAL SYMBOL DIFTOGGOS OU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E7"},119016:{"value":"1D0E8","name":"BYZANTINE MUSICAL SYMBOL STIGMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E8"},119017:{"value":"1D0E9","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO PA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0E9"},119018:{"value":"1D0EA","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO VOU","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0EA"},119019:{"value":"1D0EB","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO GA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0EB"},119020:{"value":"1D0EC","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO DI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0EC"},119021:{"value":"1D0ED","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO KE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0ED"},119022:{"value":"1D0EE","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO ZO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0EE"},119023:{"value":"1D0EF","name":"BYZANTINE MUSICAL SYMBOL ARKTIKO NI","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0EF"},119024:{"value":"1D0F0","name":"BYZANTINE MUSICAL SYMBOL KENTIMATA NEO MESO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F0"},119025:{"value":"1D0F1","name":"BYZANTINE MUSICAL SYMBOL KENTIMA NEO MESO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F1"},119026:{"value":"1D0F2","name":"BYZANTINE MUSICAL SYMBOL KENTIMATA NEO KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F2"},119027:{"value":"1D0F3","name":"BYZANTINE MUSICAL SYMBOL KENTIMA NEO KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F3"},119028:{"value":"1D0F4","name":"BYZANTINE MUSICAL SYMBOL KLASMA KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F4"},119029:{"value":"1D0F5","name":"BYZANTINE MUSICAL SYMBOL GORGON NEO KATO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD0F5"},119040:{"value":"1D100","name":"MUSICAL SYMBOL SINGLE BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD100"},119041:{"value":"1D101","name":"MUSICAL SYMBOL DOUBLE BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD101"},119042:{"value":"1D102","name":"MUSICAL SYMBOL FINAL BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD102"},119043:{"value":"1D103","name":"MUSICAL SYMBOL REVERSE FINAL BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD103"},119044:{"value":"1D104","name":"MUSICAL SYMBOL DASHED BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD104"},119045:{"value":"1D105","name":"MUSICAL SYMBOL SHORT BARLINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD105"},119046:{"value":"1D106","name":"MUSICAL SYMBOL LEFT REPEAT SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD106"},119047:{"value":"1D107","name":"MUSICAL SYMBOL RIGHT REPEAT SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD107"},119048:{"value":"1D108","name":"MUSICAL SYMBOL REPEAT DOTS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD108"},119049:{"value":"1D109","name":"MUSICAL SYMBOL DAL SEGNO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD109"},119050:{"value":"1D10A","name":"MUSICAL SYMBOL DA CAPO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10A"},119051:{"value":"1D10B","name":"MUSICAL SYMBOL SEGNO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10B"},119052:{"value":"1D10C","name":"MUSICAL SYMBOL CODA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10C"},119053:{"value":"1D10D","name":"MUSICAL SYMBOL REPEATED FIGURE-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10D"},119054:{"value":"1D10E","name":"MUSICAL SYMBOL REPEATED FIGURE-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10E"},119055:{"value":"1D10F","name":"MUSICAL SYMBOL REPEATED FIGURE-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD10F"},119056:{"value":"1D110","name":"MUSICAL SYMBOL FERMATA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD110"},119057:{"value":"1D111","name":"MUSICAL SYMBOL FERMATA BELOW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD111"},119058:{"value":"1D112","name":"MUSICAL SYMBOL BREATH MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD112"},119059:{"value":"1D113","name":"MUSICAL SYMBOL CAESURA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD113"},119060:{"value":"1D114","name":"MUSICAL SYMBOL BRACE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD114"},119061:{"value":"1D115","name":"MUSICAL SYMBOL BRACKET","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD115"},119062:{"value":"1D116","name":"MUSICAL SYMBOL ONE-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD116"},119063:{"value":"1D117","name":"MUSICAL SYMBOL TWO-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD117"},119064:{"value":"1D118","name":"MUSICAL SYMBOL THREE-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD118"},119065:{"value":"1D119","name":"MUSICAL SYMBOL FOUR-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD119"},119066:{"value":"1D11A","name":"MUSICAL SYMBOL FIVE-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11A"},119067:{"value":"1D11B","name":"MUSICAL SYMBOL SIX-LINE STAFF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11B"},119068:{"value":"1D11C","name":"MUSICAL SYMBOL SIX-STRING FRETBOARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11C"},119069:{"value":"1D11D","name":"MUSICAL SYMBOL FOUR-STRING FRETBOARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11D"},119070:{"value":"1D11E","name":"MUSICAL SYMBOL G CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11E"},119071:{"value":"1D11F","name":"MUSICAL SYMBOL G CLEF OTTAVA ALTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD11F"},119072:{"value":"1D120","name":"MUSICAL SYMBOL G CLEF OTTAVA BASSA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD120"},119073:{"value":"1D121","name":"MUSICAL SYMBOL C CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD121"},119074:{"value":"1D122","name":"MUSICAL SYMBOL F CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD122"},119075:{"value":"1D123","name":"MUSICAL SYMBOL F CLEF OTTAVA ALTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD123"},119076:{"value":"1D124","name":"MUSICAL SYMBOL F CLEF OTTAVA BASSA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD124"},119077:{"value":"1D125","name":"MUSICAL SYMBOL DRUM CLEF-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD125"},119078:{"value":"1D126","name":"MUSICAL SYMBOL DRUM CLEF-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD126"},119081:{"value":"1D129","name":"MUSICAL SYMBOL MULTIPLE MEASURE REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD129"},119082:{"value":"1D12A","name":"MUSICAL SYMBOL DOUBLE SHARP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12A"},119083:{"value":"1D12B","name":"MUSICAL SYMBOL DOUBLE FLAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12B"},119084:{"value":"1D12C","name":"MUSICAL SYMBOL FLAT UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12C"},119085:{"value":"1D12D","name":"MUSICAL SYMBOL FLAT DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12D"},119086:{"value":"1D12E","name":"MUSICAL SYMBOL NATURAL UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12E"},119087:{"value":"1D12F","name":"MUSICAL SYMBOL NATURAL DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD12F"},119088:{"value":"1D130","name":"MUSICAL SYMBOL SHARP UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD130"},119089:{"value":"1D131","name":"MUSICAL SYMBOL SHARP DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD131"},119090:{"value":"1D132","name":"MUSICAL SYMBOL QUARTER TONE SHARP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD132"},119091:{"value":"1D133","name":"MUSICAL SYMBOL QUARTER TONE FLAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD133"},119092:{"value":"1D134","name":"MUSICAL SYMBOL COMMON TIME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD134"},119093:{"value":"1D135","name":"MUSICAL SYMBOL CUT TIME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD135"},119094:{"value":"1D136","name":"MUSICAL SYMBOL OTTAVA ALTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD136"},119095:{"value":"1D137","name":"MUSICAL SYMBOL OTTAVA BASSA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD137"},119096:{"value":"1D138","name":"MUSICAL SYMBOL QUINDICESIMA ALTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD138"},119097:{"value":"1D139","name":"MUSICAL SYMBOL QUINDICESIMA BASSA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD139"},119098:{"value":"1D13A","name":"MUSICAL SYMBOL MULTI REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13A"},119099:{"value":"1D13B","name":"MUSICAL SYMBOL WHOLE REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13B"},119100:{"value":"1D13C","name":"MUSICAL SYMBOL HALF REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13C"},119101:{"value":"1D13D","name":"MUSICAL SYMBOL QUARTER REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13D"},119102:{"value":"1D13E","name":"MUSICAL SYMBOL EIGHTH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13E"},119103:{"value":"1D13F","name":"MUSICAL SYMBOL SIXTEENTH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD13F"},119104:{"value":"1D140","name":"MUSICAL SYMBOL THIRTY-SECOND REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD140"},119105:{"value":"1D141","name":"MUSICAL SYMBOL SIXTY-FOURTH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD141"},119106:{"value":"1D142","name":"MUSICAL SYMBOL ONE HUNDRED TWENTY-EIGHTH REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD142"},119107:{"value":"1D143","name":"MUSICAL SYMBOL X NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD143"},119108:{"value":"1D144","name":"MUSICAL SYMBOL PLUS NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD144"},119109:{"value":"1D145","name":"MUSICAL SYMBOL CIRCLE X NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD145"},119110:{"value":"1D146","name":"MUSICAL SYMBOL SQUARE NOTEHEAD WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD146"},119111:{"value":"1D147","name":"MUSICAL SYMBOL SQUARE NOTEHEAD BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD147"},119112:{"value":"1D148","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD UP WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD148"},119113:{"value":"1D149","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD UP BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD149"},119114:{"value":"1D14A","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD LEFT WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14A"},119115:{"value":"1D14B","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD LEFT BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14B"},119116:{"value":"1D14C","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD RIGHT WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14C"},119117:{"value":"1D14D","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD RIGHT BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14D"},119118:{"value":"1D14E","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD DOWN WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14E"},119119:{"value":"1D14F","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD DOWN BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD14F"},119120:{"value":"1D150","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD UP RIGHT WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD150"},119121:{"value":"1D151","name":"MUSICAL SYMBOL TRIANGLE NOTEHEAD UP RIGHT BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD151"},119122:{"value":"1D152","name":"MUSICAL SYMBOL MOON NOTEHEAD WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD152"},119123:{"value":"1D153","name":"MUSICAL SYMBOL MOON NOTEHEAD BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD153"},119124:{"value":"1D154","name":"MUSICAL SYMBOL TRIANGLE-ROUND NOTEHEAD DOWN WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD154"},119125:{"value":"1D155","name":"MUSICAL SYMBOL TRIANGLE-ROUND NOTEHEAD DOWN BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD155"},119126:{"value":"1D156","name":"MUSICAL SYMBOL PARENTHESIS NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD156"},119127:{"value":"1D157","name":"MUSICAL SYMBOL VOID NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD157"},119128:{"value":"1D158","name":"MUSICAL SYMBOL NOTEHEAD BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD158"},119129:{"value":"1D159","name":"MUSICAL SYMBOL NULL NOTEHEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD159"},119130:{"value":"1D15A","name":"MUSICAL SYMBOL CLUSTER NOTEHEAD WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15A"},119131:{"value":"1D15B","name":"MUSICAL SYMBOL CLUSTER NOTEHEAD BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15B"},119132:{"value":"1D15C","name":"MUSICAL SYMBOL BREVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15C"},119133:{"value":"1D15D","name":"MUSICAL SYMBOL WHOLE NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15D"},119134:{"value":"1D15E","name":"MUSICAL SYMBOL HALF NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D157 1D165","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15E"},119135:{"value":"1D15F","name":"MUSICAL SYMBOL QUARTER NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D158 1D165","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD15F"},119136:{"value":"1D160","name":"MUSICAL SYMBOL EIGHTH NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D15F 1D16E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD160"},119137:{"value":"1D161","name":"MUSICAL SYMBOL SIXTEENTH NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D15F 1D16F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD161"},119138:{"value":"1D162","name":"MUSICAL SYMBOL THIRTY-SECOND NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D15F 1D170","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD162"},119139:{"value":"1D163","name":"MUSICAL SYMBOL SIXTY-FOURTH NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D15F 1D171","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD163"},119140:{"value":"1D164","name":"MUSICAL SYMBOL ONE HUNDRED TWENTY-EIGHTH NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D15F 1D172","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD164"},119146:{"value":"1D16A","name":"MUSICAL SYMBOL FINGERED TREMOLO-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD16A"},119147:{"value":"1D16B","name":"MUSICAL SYMBOL FINGERED TREMOLO-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD16B"},119148:{"value":"1D16C","name":"MUSICAL SYMBOL FINGERED TREMOLO-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD16C"},119171:{"value":"1D183","name":"MUSICAL SYMBOL ARPEGGIATO UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD183"},119172:{"value":"1D184","name":"MUSICAL SYMBOL ARPEGGIATO DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD184"},119180:{"value":"1D18C","name":"MUSICAL SYMBOL RINFORZANDO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD18C"},119181:{"value":"1D18D","name":"MUSICAL SYMBOL SUBITO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD18D"},119182:{"value":"1D18E","name":"MUSICAL SYMBOL Z","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD18E"},119183:{"value":"1D18F","name":"MUSICAL SYMBOL PIANO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD18F"},119184:{"value":"1D190","name":"MUSICAL SYMBOL MEZZO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD190"},119185:{"value":"1D191","name":"MUSICAL SYMBOL FORTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD191"},119186:{"value":"1D192","name":"MUSICAL SYMBOL CRESCENDO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD192"},119187:{"value":"1D193","name":"MUSICAL SYMBOL DECRESCENDO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD193"},119188:{"value":"1D194","name":"MUSICAL SYMBOL GRACE NOTE SLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD194"},119189:{"value":"1D195","name":"MUSICAL SYMBOL GRACE NOTE NO SLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD195"},119190:{"value":"1D196","name":"MUSICAL SYMBOL TR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD196"},119191:{"value":"1D197","name":"MUSICAL SYMBOL TURN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD197"},119192:{"value":"1D198","name":"MUSICAL SYMBOL INVERTED TURN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD198"},119193:{"value":"1D199","name":"MUSICAL SYMBOL TURN SLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD199"},119194:{"value":"1D19A","name":"MUSICAL SYMBOL TURN UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19A"},119195:{"value":"1D19B","name":"MUSICAL SYMBOL ORNAMENT STROKE-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19B"},119196:{"value":"1D19C","name":"MUSICAL SYMBOL ORNAMENT STROKE-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19C"},119197:{"value":"1D19D","name":"MUSICAL SYMBOL ORNAMENT STROKE-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19D"},119198:{"value":"1D19E","name":"MUSICAL SYMBOL ORNAMENT STROKE-4","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19E"},119199:{"value":"1D19F","name":"MUSICAL SYMBOL ORNAMENT STROKE-5","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD19F"},119200:{"value":"1D1A0","name":"MUSICAL SYMBOL ORNAMENT STROKE-6","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A0"},119201:{"value":"1D1A1","name":"MUSICAL SYMBOL ORNAMENT STROKE-7","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A1"},119202:{"value":"1D1A2","name":"MUSICAL SYMBOL ORNAMENT STROKE-8","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A2"},119203:{"value":"1D1A3","name":"MUSICAL SYMBOL ORNAMENT STROKE-9","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A3"},119204:{"value":"1D1A4","name":"MUSICAL SYMBOL ORNAMENT STROKE-10","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A4"},119205:{"value":"1D1A5","name":"MUSICAL SYMBOL ORNAMENT STROKE-11","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A5"},119206:{"value":"1D1A6","name":"MUSICAL SYMBOL HAUPTSTIMME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A6"},119207:{"value":"1D1A7","name":"MUSICAL SYMBOL NEBENSTIMME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A7"},119208:{"value":"1D1A8","name":"MUSICAL SYMBOL END OF STIMME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A8"},119209:{"value":"1D1A9","name":"MUSICAL SYMBOL DEGREE SLASH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1A9"},119214:{"value":"1D1AE","name":"MUSICAL SYMBOL PEDAL MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1AE"},119215:{"value":"1D1AF","name":"MUSICAL SYMBOL PEDAL UP MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1AF"},119216:{"value":"1D1B0","name":"MUSICAL SYMBOL HALF PEDAL MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B0"},119217:{"value":"1D1B1","name":"MUSICAL SYMBOL GLISSANDO UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B1"},119218:{"value":"1D1B2","name":"MUSICAL SYMBOL GLISSANDO DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B2"},119219:{"value":"1D1B3","name":"MUSICAL SYMBOL WITH FINGERNAILS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B3"},119220:{"value":"1D1B4","name":"MUSICAL SYMBOL DAMP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B4"},119221:{"value":"1D1B5","name":"MUSICAL SYMBOL DAMP ALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B5"},119222:{"value":"1D1B6","name":"MUSICAL SYMBOL MAXIMA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B6"},119223:{"value":"1D1B7","name":"MUSICAL SYMBOL LONGA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B7"},119224:{"value":"1D1B8","name":"MUSICAL SYMBOL BREVIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B8"},119225:{"value":"1D1B9","name":"MUSICAL SYMBOL SEMIBREVIS WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1B9"},119226:{"value":"1D1BA","name":"MUSICAL SYMBOL SEMIBREVIS BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BA"},119227:{"value":"1D1BB","name":"MUSICAL SYMBOL MINIMA","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1B9 1D165","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BB"},119228:{"value":"1D1BC","name":"MUSICAL SYMBOL MINIMA BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1BA 1D165","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BC"},119229:{"value":"1D1BD","name":"MUSICAL SYMBOL SEMIMINIMA WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1BB 1D16E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BD"},119230:{"value":"1D1BE","name":"MUSICAL SYMBOL SEMIMINIMA BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1BC 1D16E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BE"},119231:{"value":"1D1BF","name":"MUSICAL SYMBOL FUSA WHITE","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1BB 1D16F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1BF"},119232:{"value":"1D1C0","name":"MUSICAL SYMBOL FUSA BLACK","category":"So","class":"0","bidirectional_category":"L","mapping":"1D1BC 1D16F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C0"},119233:{"value":"1D1C1","name":"MUSICAL SYMBOL LONGA PERFECTA REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C1"},119234:{"value":"1D1C2","name":"MUSICAL SYMBOL LONGA IMPERFECTA REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C2"},119235:{"value":"1D1C3","name":"MUSICAL SYMBOL BREVIS REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C3"},119236:{"value":"1D1C4","name":"MUSICAL SYMBOL SEMIBREVIS REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C4"},119237:{"value":"1D1C5","name":"MUSICAL SYMBOL MINIMA REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C5"},119238:{"value":"1D1C6","name":"MUSICAL SYMBOL SEMIMINIMA REST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C6"},119239:{"value":"1D1C7","name":"MUSICAL SYMBOL TEMPUS PERFECTUM CUM PROLATIONE PERFECTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C7"},119240:{"value":"1D1C8","name":"MUSICAL SYMBOL TEMPUS PERFECTUM CUM PROLATIONE IMPERFECTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C8"},119241:{"value":"1D1C9","name":"MUSICAL SYMBOL TEMPUS PERFECTUM CUM PROLATIONE PERFECTA DIMINUTION-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1C9"},119242:{"value":"1D1CA","name":"MUSICAL SYMBOL TEMPUS IMPERFECTUM CUM PROLATIONE PERFECTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CA"},119243:{"value":"1D1CB","name":"MUSICAL SYMBOL TEMPUS IMPERFECTUM CUM PROLATIONE IMPERFECTA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CB"},119244:{"value":"1D1CC","name":"MUSICAL SYMBOL TEMPUS IMPERFECTUM CUM PROLATIONE IMPERFECTA DIMINUTION-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CC"},119245:{"value":"1D1CD","name":"MUSICAL SYMBOL TEMPUS IMPERFECTUM CUM PROLATIONE IMPERFECTA DIMINUTION-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CD"},119246:{"value":"1D1CE","name":"MUSICAL SYMBOL TEMPUS IMPERFECTUM CUM PROLATIONE IMPERFECTA DIMINUTION-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CE"},119247:{"value":"1D1CF","name":"MUSICAL SYMBOL CROIX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1CF"},119248:{"value":"1D1D0","name":"MUSICAL SYMBOL GREGORIAN C CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D0"},119249:{"value":"1D1D1","name":"MUSICAL SYMBOL GREGORIAN F CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D1"},119250:{"value":"1D1D2","name":"MUSICAL SYMBOL SQUARE B","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D2"},119251:{"value":"1D1D3","name":"MUSICAL SYMBOL VIRGA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D3"},119252:{"value":"1D1D4","name":"MUSICAL SYMBOL PODATUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D4"},119253:{"value":"1D1D5","name":"MUSICAL SYMBOL CLIVIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D5"},119254:{"value":"1D1D6","name":"MUSICAL SYMBOL SCANDICUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D6"},119255:{"value":"1D1D7","name":"MUSICAL SYMBOL CLIMACUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D7"},119256:{"value":"1D1D8","name":"MUSICAL SYMBOL TORCULUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D8"},119257:{"value":"1D1D9","name":"MUSICAL SYMBOL PORRECTUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1D9"},119258:{"value":"1D1DA","name":"MUSICAL SYMBOL PORRECTUS FLEXUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DA"},119259:{"value":"1D1DB","name":"MUSICAL SYMBOL SCANDICUS FLEXUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DB"},119260:{"value":"1D1DC","name":"MUSICAL SYMBOL TORCULUS RESUPINUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DC"},119261:{"value":"1D1DD","name":"MUSICAL SYMBOL PES SUBPUNCTIS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DD"},119262:{"value":"1D1DE","name":"MUSICAL SYMBOL KIEVAN C CLEF","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DE"},119263:{"value":"1D1DF","name":"MUSICAL SYMBOL KIEVAN END OF PIECE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1DF"},119264:{"value":"1D1E0","name":"MUSICAL SYMBOL KIEVAN FINAL NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E0"},119265:{"value":"1D1E1","name":"MUSICAL SYMBOL KIEVAN RECITATIVE MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E1"},119266:{"value":"1D1E2","name":"MUSICAL SYMBOL KIEVAN WHOLE NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E2"},119267:{"value":"1D1E3","name":"MUSICAL SYMBOL KIEVAN HALF NOTE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E3"},119268:{"value":"1D1E4","name":"MUSICAL SYMBOL KIEVAN QUARTER NOTE STEM DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E4"},119269:{"value":"1D1E5","name":"MUSICAL SYMBOL KIEVAN QUARTER NOTE STEM UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E5"},119270:{"value":"1D1E6","name":"MUSICAL SYMBOL KIEVAN EIGHTH NOTE STEM DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E6"},119271:{"value":"1D1E7","name":"MUSICAL SYMBOL KIEVAN EIGHTH NOTE STEM UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E7"},119272:{"value":"1D1E8","name":"MUSICAL SYMBOL KIEVAN FLAT SIGN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD1E8"},119296:{"value":"1D200","name":"GREEK VOCAL NOTATION SYMBOL-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD200"},119297:{"value":"1D201","name":"GREEK VOCAL NOTATION SYMBOL-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD201"},119298:{"value":"1D202","name":"GREEK VOCAL NOTATION SYMBOL-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD202"},119299:{"value":"1D203","name":"GREEK VOCAL NOTATION SYMBOL-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD203"},119300:{"value":"1D204","name":"GREEK VOCAL NOTATION SYMBOL-5","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD204"},119301:{"value":"1D205","name":"GREEK VOCAL NOTATION SYMBOL-6","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD205"},119302:{"value":"1D206","name":"GREEK VOCAL NOTATION SYMBOL-7","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD206"},119303:{"value":"1D207","name":"GREEK VOCAL NOTATION SYMBOL-8","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD207"},119304:{"value":"1D208","name":"GREEK VOCAL NOTATION SYMBOL-9","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD208"},119305:{"value":"1D209","name":"GREEK VOCAL NOTATION SYMBOL-10","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD209"},119306:{"value":"1D20A","name":"GREEK VOCAL NOTATION SYMBOL-11","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20A"},119307:{"value":"1D20B","name":"GREEK VOCAL NOTATION SYMBOL-12","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20B"},119308:{"value":"1D20C","name":"GREEK VOCAL NOTATION SYMBOL-13","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20C"},119309:{"value":"1D20D","name":"GREEK VOCAL NOTATION SYMBOL-14","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20D"},119310:{"value":"1D20E","name":"GREEK VOCAL NOTATION SYMBOL-15","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20E"},119311:{"value":"1D20F","name":"GREEK VOCAL NOTATION SYMBOL-16","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD20F"},119312:{"value":"1D210","name":"GREEK VOCAL NOTATION SYMBOL-17","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD210"},119313:{"value":"1D211","name":"GREEK VOCAL NOTATION SYMBOL-18","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD211"},119314:{"value":"1D212","name":"GREEK VOCAL NOTATION SYMBOL-19","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD212"},119315:{"value":"1D213","name":"GREEK VOCAL NOTATION SYMBOL-20","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD213"},119316:{"value":"1D214","name":"GREEK VOCAL NOTATION SYMBOL-21","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD214"},119317:{"value":"1D215","name":"GREEK VOCAL NOTATION SYMBOL-22","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD215"},119318:{"value":"1D216","name":"GREEK VOCAL NOTATION SYMBOL-23","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD216"},119319:{"value":"1D217","name":"GREEK VOCAL NOTATION SYMBOL-24","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD217"},119320:{"value":"1D218","name":"GREEK VOCAL NOTATION SYMBOL-50","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD218"},119321:{"value":"1D219","name":"GREEK VOCAL NOTATION SYMBOL-51","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD219"},119322:{"value":"1D21A","name":"GREEK VOCAL NOTATION SYMBOL-52","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21A"},119323:{"value":"1D21B","name":"GREEK VOCAL NOTATION SYMBOL-53","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21B"},119324:{"value":"1D21C","name":"GREEK VOCAL NOTATION SYMBOL-54","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21C"},119325:{"value":"1D21D","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21D"},119326:{"value":"1D21E","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21E"},119327:{"value":"1D21F","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD21F"},119328:{"value":"1D220","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-5","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD220"},119329:{"value":"1D221","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-7","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD221"},119330:{"value":"1D222","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-8","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD222"},119331:{"value":"1D223","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-11","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD223"},119332:{"value":"1D224","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-12","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD224"},119333:{"value":"1D225","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-13","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD225"},119334:{"value":"1D226","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-14","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD226"},119335:{"value":"1D227","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-17","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD227"},119336:{"value":"1D228","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-18","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD228"},119337:{"value":"1D229","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-19","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD229"},119338:{"value":"1D22A","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-23","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22A"},119339:{"value":"1D22B","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-24","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22B"},119340:{"value":"1D22C","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-25","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22C"},119341:{"value":"1D22D","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-26","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22D"},119342:{"value":"1D22E","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-27","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22E"},119343:{"value":"1D22F","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-29","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD22F"},119344:{"value":"1D230","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-30","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD230"},119345:{"value":"1D231","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-32","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD231"},119346:{"value":"1D232","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-36","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD232"},119347:{"value":"1D233","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-37","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD233"},119348:{"value":"1D234","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-38","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD234"},119349:{"value":"1D235","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-39","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD235"},119350:{"value":"1D236","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-40","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD236"},119351:{"value":"1D237","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-42","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD237"},119352:{"value":"1D238","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-43","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD238"},119353:{"value":"1D239","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-45","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD239"},119354:{"value":"1D23A","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-47","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23A"},119355:{"value":"1D23B","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-48","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23B"},119356:{"value":"1D23C","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-49","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23C"},119357:{"value":"1D23D","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-50","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23D"},119358:{"value":"1D23E","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-51","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23E"},119359:{"value":"1D23F","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-52","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD23F"},119360:{"value":"1D240","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-53","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD240"},119361:{"value":"1D241","name":"GREEK INSTRUMENTAL NOTATION SYMBOL-54","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD241"},119365:{"value":"1D245","name":"GREEK MUSICAL LEIMMA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD245"},119552:{"value":"1D300","name":"MONOGRAM FOR EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD300"},119553:{"value":"1D301","name":"DIGRAM FOR HEAVENLY EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD301"},119554:{"value":"1D302","name":"DIGRAM FOR HUMAN EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD302"},119555:{"value":"1D303","name":"DIGRAM FOR EARTHLY HEAVEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD303"},119556:{"value":"1D304","name":"DIGRAM FOR EARTHLY HUMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD304"},119557:{"value":"1D305","name":"DIGRAM FOR EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD305"},119558:{"value":"1D306","name":"TETRAGRAM FOR CENTRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD306"},119559:{"value":"1D307","name":"TETRAGRAM FOR FULL CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD307"},119560:{"value":"1D308","name":"TETRAGRAM FOR MIRED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD308"},119561:{"value":"1D309","name":"TETRAGRAM FOR BARRIER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD309"},119562:{"value":"1D30A","name":"TETRAGRAM FOR KEEPING SMALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30A"},119563:{"value":"1D30B","name":"TETRAGRAM FOR CONTRARIETY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30B"},119564:{"value":"1D30C","name":"TETRAGRAM FOR ASCENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30C"},119565:{"value":"1D30D","name":"TETRAGRAM FOR OPPOSITION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30D"},119566:{"value":"1D30E","name":"TETRAGRAM FOR BRANCHING OUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30E"},119567:{"value":"1D30F","name":"TETRAGRAM FOR DEFECTIVENESS OR DISTORTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD30F"},119568:{"value":"1D310","name":"TETRAGRAM FOR DIVERGENCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD310"},119569:{"value":"1D311","name":"TETRAGRAM FOR YOUTHFULNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD311"},119570:{"value":"1D312","name":"TETRAGRAM FOR INCREASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD312"},119571:{"value":"1D313","name":"TETRAGRAM FOR PENETRATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD313"},119572:{"value":"1D314","name":"TETRAGRAM FOR REACH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD314"},119573:{"value":"1D315","name":"TETRAGRAM FOR CONTACT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD315"},119574:{"value":"1D316","name":"TETRAGRAM FOR HOLDING BACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD316"},119575:{"value":"1D317","name":"TETRAGRAM FOR WAITING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD317"},119576:{"value":"1D318","name":"TETRAGRAM FOR FOLLOWING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD318"},119577:{"value":"1D319","name":"TETRAGRAM FOR ADVANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD319"},119578:{"value":"1D31A","name":"TETRAGRAM FOR RELEASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31A"},119579:{"value":"1D31B","name":"TETRAGRAM FOR RESISTANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31B"},119580:{"value":"1D31C","name":"TETRAGRAM FOR EASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31C"},119581:{"value":"1D31D","name":"TETRAGRAM FOR JOY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31D"},119582:{"value":"1D31E","name":"TETRAGRAM FOR CONTENTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31E"},119583:{"value":"1D31F","name":"TETRAGRAM FOR ENDEAVOUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD31F"},119584:{"value":"1D320","name":"TETRAGRAM FOR DUTIES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD320"},119585:{"value":"1D321","name":"TETRAGRAM FOR CHANGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD321"},119586:{"value":"1D322","name":"TETRAGRAM FOR DECISIVENESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD322"},119587:{"value":"1D323","name":"TETRAGRAM FOR BOLD RESOLUTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD323"},119588:{"value":"1D324","name":"TETRAGRAM FOR PACKING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD324"},119589:{"value":"1D325","name":"TETRAGRAM FOR LEGION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD325"},119590:{"value":"1D326","name":"TETRAGRAM FOR CLOSENESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD326"},119591:{"value":"1D327","name":"TETRAGRAM FOR KINSHIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD327"},119592:{"value":"1D328","name":"TETRAGRAM FOR GATHERING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD328"},119593:{"value":"1D329","name":"TETRAGRAM FOR STRENGTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD329"},119594:{"value":"1D32A","name":"TETRAGRAM FOR PURITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32A"},119595:{"value":"1D32B","name":"TETRAGRAM FOR FULLNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32B"},119596:{"value":"1D32C","name":"TETRAGRAM FOR RESIDENCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32C"},119597:{"value":"1D32D","name":"TETRAGRAM FOR LAW OR MODEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32D"},119598:{"value":"1D32E","name":"TETRAGRAM FOR RESPONSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32E"},119599:{"value":"1D32F","name":"TETRAGRAM FOR GOING TO MEET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD32F"},119600:{"value":"1D330","name":"TETRAGRAM FOR ENCOUNTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD330"},119601:{"value":"1D331","name":"TETRAGRAM FOR STOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD331"},119602:{"value":"1D332","name":"TETRAGRAM FOR GREATNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD332"},119603:{"value":"1D333","name":"TETRAGRAM FOR ENLARGEMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD333"},119604:{"value":"1D334","name":"TETRAGRAM FOR PATTERN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD334"},119605:{"value":"1D335","name":"TETRAGRAM FOR RITUAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD335"},119606:{"value":"1D336","name":"TETRAGRAM FOR FLIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD336"},119607:{"value":"1D337","name":"TETRAGRAM FOR VASTNESS OR WASTING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD337"},119608:{"value":"1D338","name":"TETRAGRAM FOR CONSTANCY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD338"},119609:{"value":"1D339","name":"TETRAGRAM FOR MEASURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD339"},119610:{"value":"1D33A","name":"TETRAGRAM FOR ETERNITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33A"},119611:{"value":"1D33B","name":"TETRAGRAM FOR UNITY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33B"},119612:{"value":"1D33C","name":"TETRAGRAM FOR DIMINISHMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33C"},119613:{"value":"1D33D","name":"TETRAGRAM FOR CLOSED MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33D"},119614:{"value":"1D33E","name":"TETRAGRAM FOR GUARDEDNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33E"},119615:{"value":"1D33F","name":"TETRAGRAM FOR GATHERING IN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD33F"},119616:{"value":"1D340","name":"TETRAGRAM FOR MASSING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD340"},119617:{"value":"1D341","name":"TETRAGRAM FOR ACCUMULATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD341"},119618:{"value":"1D342","name":"TETRAGRAM FOR EMBELLISHMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD342"},119619:{"value":"1D343","name":"TETRAGRAM FOR DOUBT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD343"},119620:{"value":"1D344","name":"TETRAGRAM FOR WATCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD344"},119621:{"value":"1D345","name":"TETRAGRAM FOR SINKING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD345"},119622:{"value":"1D346","name":"TETRAGRAM FOR INNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD346"},119623:{"value":"1D347","name":"TETRAGRAM FOR DEPARTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD347"},119624:{"value":"1D348","name":"TETRAGRAM FOR DARKENING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD348"},119625:{"value":"1D349","name":"TETRAGRAM FOR DIMMING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD349"},119626:{"value":"1D34A","name":"TETRAGRAM FOR EXHAUSTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34A"},119627:{"value":"1D34B","name":"TETRAGRAM FOR SEVERANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34B"},119628:{"value":"1D34C","name":"TETRAGRAM FOR STOPPAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34C"},119629:{"value":"1D34D","name":"TETRAGRAM FOR HARDNESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34D"},119630:{"value":"1D34E","name":"TETRAGRAM FOR COMPLETION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34E"},119631:{"value":"1D34F","name":"TETRAGRAM FOR CLOSURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD34F"},119632:{"value":"1D350","name":"TETRAGRAM FOR FAILURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD350"},119633:{"value":"1D351","name":"TETRAGRAM FOR AGGRAVATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD351"},119634:{"value":"1D352","name":"TETRAGRAM FOR COMPLIANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD352"},119635:{"value":"1D353","name":"TETRAGRAM FOR ON THE VERGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD353"},119636:{"value":"1D354","name":"TETRAGRAM FOR DIFFICULTIES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD354"},119637:{"value":"1D355","name":"TETRAGRAM FOR LABOURING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD355"},119638:{"value":"1D356","name":"TETRAGRAM FOR FOSTERING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD356"},120832:{"value":"1D800","name":"SIGNWRITING HAND-FIST INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD800"},120833:{"value":"1D801","name":"SIGNWRITING HAND-CIRCLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD801"},120834:{"value":"1D802","name":"SIGNWRITING HAND-CUP INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD802"},120835:{"value":"1D803","name":"SIGNWRITING HAND-OVAL INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD803"},120836:{"value":"1D804","name":"SIGNWRITING HAND-HINGE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD804"},120837:{"value":"1D805","name":"SIGNWRITING HAND-ANGLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD805"},120838:{"value":"1D806","name":"SIGNWRITING HAND-FIST INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD806"},120839:{"value":"1D807","name":"SIGNWRITING HAND-CIRCLE INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD807"},120840:{"value":"1D808","name":"SIGNWRITING HAND-FIST THUMB UNDER INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD808"},120841:{"value":"1D809","name":"SIGNWRITING HAND-FIST INDEX RAISED KNUCKLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD809"},120842:{"value":"1D80A","name":"SIGNWRITING HAND-FIST INDEX CUPPED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80A"},120843:{"value":"1D80B","name":"SIGNWRITING HAND-FIST INDEX HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80B"},120844:{"value":"1D80C","name":"SIGNWRITING HAND-FIST INDEX HINGED LOW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80C"},120845:{"value":"1D80D","name":"SIGNWRITING HAND-CIRCLE INDEX HINGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80D"},120846:{"value":"1D80E","name":"SIGNWRITING HAND-FIST INDEX MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80E"},120847:{"value":"1D80F","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD80F"},120848:{"value":"1D810","name":"SIGNWRITING HAND-FIST INDEX MIDDLE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD810"},120849:{"value":"1D811","name":"SIGNWRITING HAND-FIST INDEX MIDDLE RAISED KNUCKLES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD811"},120850:{"value":"1D812","name":"SIGNWRITING HAND-FIST INDEX MIDDLE HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD812"},120851:{"value":"1D813","name":"SIGNWRITING HAND-FIST INDEX UP MIDDLE HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD813"},120852:{"value":"1D814","name":"SIGNWRITING HAND-FIST INDEX HINGED MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD814"},120853:{"value":"1D815","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD815"},120854:{"value":"1D816","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD816"},120855:{"value":"1D817","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED MIDDLE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD817"},120856:{"value":"1D818","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED CUPPED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD818"},120857:{"value":"1D819","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD819"},120858:{"value":"1D81A","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CROSSED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81A"},120859:{"value":"1D81B","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE CROSSED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81B"},120860:{"value":"1D81C","name":"SIGNWRITING HAND-FIST MIDDLE BENT OVER INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81C"},120861:{"value":"1D81D","name":"SIGNWRITING HAND-FIST INDEX BENT OVER MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81D"},120862:{"value":"1D81E","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81E"},120863:{"value":"1D81F","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD81F"},120864:{"value":"1D820","name":"SIGNWRITING HAND-FIST INDEX MIDDLE STRAIGHT THUMB BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD820"},120865:{"value":"1D821","name":"SIGNWRITING HAND-FIST INDEX MIDDLE BENT THUMB STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD821"},120866:{"value":"1D822","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD822"},120867:{"value":"1D823","name":"SIGNWRITING HAND-FIST INDEX MIDDLE HINGED SPREAD THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD823"},120868:{"value":"1D824","name":"SIGNWRITING HAND-FIST INDEX UP MIDDLE HINGED THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD824"},120869:{"value":"1D825","name":"SIGNWRITING HAND-FIST INDEX UP MIDDLE HINGED THUMB CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD825"},120870:{"value":"1D826","name":"SIGNWRITING HAND-FIST INDEX HINGED MIDDLE UP THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD826"},120871:{"value":"1D827","name":"SIGNWRITING HAND-FIST INDEX MIDDLE UP SPREAD THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD827"},120872:{"value":"1D828","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB CUPPED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD828"},120873:{"value":"1D829","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB CIRCLED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD829"},120874:{"value":"1D82A","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB HOOKED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82A"},120875:{"value":"1D82B","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82B"},120876:{"value":"1D82C","name":"SIGNWRITING HAND-FIST THUMB BETWEEN INDEX MIDDLE STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82C"},120877:{"value":"1D82D","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82D"},120878:{"value":"1D82E","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED THUMB SIDE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82E"},120879:{"value":"1D82F","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED THUMB SIDE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD82F"},120880:{"value":"1D830","name":"SIGNWRITING HAND-FIST MIDDLE THUMB HOOKED INDEX UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD830"},120881:{"value":"1D831","name":"SIGNWRITING HAND-FIST INDEX THUMB HOOKED MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD831"},120882:{"value":"1D832","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED HINGED THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD832"},120883:{"value":"1D833","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CROSSED THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD833"},120884:{"value":"1D834","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD834"},120885:{"value":"1D835","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CONJOINED CUPPED THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD835"},120886:{"value":"1D836","name":"SIGNWRITING HAND-FIST MIDDLE THUMB CUPPED INDEX UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD836"},120887:{"value":"1D837","name":"SIGNWRITING HAND-FIST INDEX THUMB CUPPED MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD837"},120888:{"value":"1D838","name":"SIGNWRITING HAND-FIST MIDDLE THUMB CIRCLED INDEX UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD838"},120889:{"value":"1D839","name":"SIGNWRITING HAND-FIST MIDDLE THUMB CIRCLED INDEX HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD839"},120890:{"value":"1D83A","name":"SIGNWRITING HAND-FIST INDEX THUMB ANGLED OUT MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83A"},120891:{"value":"1D83B","name":"SIGNWRITING HAND-FIST INDEX THUMB ANGLED IN MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83B"},120892:{"value":"1D83C","name":"SIGNWRITING HAND-FIST INDEX THUMB CIRCLED MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83C"},120893:{"value":"1D83D","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB CONJOINED HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83D"},120894:{"value":"1D83E","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB ANGLED OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83E"},120895:{"value":"1D83F","name":"SIGNWRITING HAND-FIST INDEX MIDDLE THUMB ANGLED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD83F"},120896:{"value":"1D840","name":"SIGNWRITING HAND-FIST MIDDLE THUMB ANGLED OUT INDEX UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD840"},120897:{"value":"1D841","name":"SIGNWRITING HAND-FIST MIDDLE THUMB ANGLED OUT INDEX CROSSED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD841"},120898:{"value":"1D842","name":"SIGNWRITING HAND-FIST MIDDLE THUMB ANGLED INDEX UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD842"},120899:{"value":"1D843","name":"SIGNWRITING HAND-FIST INDEX THUMB HOOKED MIDDLE HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD843"},120900:{"value":"1D844","name":"SIGNWRITING HAND-FLAT FOUR FINGERS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD844"},120901:{"value":"1D845","name":"SIGNWRITING HAND-FLAT FOUR FINGERS BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD845"},120902:{"value":"1D846","name":"SIGNWRITING HAND-FLAT FOUR FINGERS HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD846"},120903:{"value":"1D847","name":"SIGNWRITING HAND-FLAT FOUR FINGERS CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD847"},120904:{"value":"1D848","name":"SIGNWRITING HAND-FLAT FOUR FINGERS CONJOINED SPLIT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD848"},120905:{"value":"1D849","name":"SIGNWRITING HAND-CLAW FOUR FINGERS CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD849"},120906:{"value":"1D84A","name":"SIGNWRITING HAND-FIST FOUR FINGERS CONJOINED BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84A"},120907:{"value":"1D84B","name":"SIGNWRITING HAND-HINGE FOUR FINGERS CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84B"},120908:{"value":"1D84C","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84C"},120909:{"value":"1D84D","name":"SIGNWRITING HAND-FLAT HEEL FIVE FINGERS SPREAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84D"},120910:{"value":"1D84E","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD FOUR BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84E"},120911:{"value":"1D84F","name":"SIGNWRITING HAND-FLAT HEEL FIVE FINGERS SPREAD FOUR BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD84F"},120912:{"value":"1D850","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD850"},120913:{"value":"1D851","name":"SIGNWRITING HAND-FLAT HEEL FIVE FINGERS SPREAD BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD851"},120914:{"value":"1D852","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD852"},120915:{"value":"1D853","name":"SIGNWRITING HAND-CUP FIVE FINGERS SPREAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD853"},120916:{"value":"1D854","name":"SIGNWRITING HAND-CUP FIVE FINGERS SPREAD OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD854"},120917:{"value":"1D855","name":"SIGNWRITING HAND-HINGE FIVE FINGERS SPREAD OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD855"},120918:{"value":"1D856","name":"SIGNWRITING HAND-OVAL FIVE FINGERS SPREAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD856"},120919:{"value":"1D857","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD857"},120920:{"value":"1D858","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD HINGED THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD858"},120921:{"value":"1D859","name":"SIGNWRITING HAND-FLAT FIVE FINGERS SPREAD HINGED NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD859"},120922:{"value":"1D85A","name":"SIGNWRITING HAND-FLAT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85A"},120923:{"value":"1D85B","name":"SIGNWRITING HAND-FLAT BETWEEN PALM FACINGS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85B"},120924:{"value":"1D85C","name":"SIGNWRITING HAND-FLAT HEEL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85C"},120925:{"value":"1D85D","name":"SIGNWRITING HAND-FLAT THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85D"},120926:{"value":"1D85E","name":"SIGNWRITING HAND-FLAT HEEL THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85E"},120927:{"value":"1D85F","name":"SIGNWRITING HAND-FLAT THUMB BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD85F"},120928:{"value":"1D860","name":"SIGNWRITING HAND-FLAT THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD860"},120929:{"value":"1D861","name":"SIGNWRITING HAND-FLAT SPLIT INDEX THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD861"},120930:{"value":"1D862","name":"SIGNWRITING HAND-FLAT SPLIT CENTRE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD862"},120931:{"value":"1D863","name":"SIGNWRITING HAND-FLAT SPLIT CENTRE THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD863"},120932:{"value":"1D864","name":"SIGNWRITING HAND-FLAT SPLIT CENTRE THUMB SIDE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD864"},120933:{"value":"1D865","name":"SIGNWRITING HAND-FLAT SPLIT LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD865"},120934:{"value":"1D866","name":"SIGNWRITING HAND-CLAW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD866"},120935:{"value":"1D867","name":"SIGNWRITING HAND-CLAW THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD867"},120936:{"value":"1D868","name":"SIGNWRITING HAND-CLAW NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD868"},120937:{"value":"1D869","name":"SIGNWRITING HAND-CLAW THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD869"},120938:{"value":"1D86A","name":"SIGNWRITING HAND-HOOK CURLICUE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86A"},120939:{"value":"1D86B","name":"SIGNWRITING HAND-HOOK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86B"},120940:{"value":"1D86C","name":"SIGNWRITING HAND-CUP OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86C"},120941:{"value":"1D86D","name":"SIGNWRITING HAND-CUP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86D"},120942:{"value":"1D86E","name":"SIGNWRITING HAND-CUP OPEN THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86E"},120943:{"value":"1D86F","name":"SIGNWRITING HAND-CUP THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD86F"},120944:{"value":"1D870","name":"SIGNWRITING HAND-CUP OPEN NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD870"},120945:{"value":"1D871","name":"SIGNWRITING HAND-CUP NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD871"},120946:{"value":"1D872","name":"SIGNWRITING HAND-CUP OPEN THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD872"},120947:{"value":"1D873","name":"SIGNWRITING HAND-CUP THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD873"},120948:{"value":"1D874","name":"SIGNWRITING HAND-CURLICUE OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD874"},120949:{"value":"1D875","name":"SIGNWRITING HAND-CURLICUE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD875"},120950:{"value":"1D876","name":"SIGNWRITING HAND-CIRCLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD876"},120951:{"value":"1D877","name":"SIGNWRITING HAND-OVAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD877"},120952:{"value":"1D878","name":"SIGNWRITING HAND-OVAL THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD878"},120953:{"value":"1D879","name":"SIGNWRITING HAND-OVAL NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD879"},120954:{"value":"1D87A","name":"SIGNWRITING HAND-OVAL THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87A"},120955:{"value":"1D87B","name":"SIGNWRITING HAND-HINGE OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87B"},120956:{"value":"1D87C","name":"SIGNWRITING HAND-HINGE OPEN THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87C"},120957:{"value":"1D87D","name":"SIGNWRITING HAND-HINGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87D"},120958:{"value":"1D87E","name":"SIGNWRITING HAND-HINGE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87E"},120959:{"value":"1D87F","name":"SIGNWRITING HAND-HINGE OPEN THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD87F"},120960:{"value":"1D880","name":"SIGNWRITING HAND-HINGE THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD880"},120961:{"value":"1D881","name":"SIGNWRITING HAND-HINGE OPEN NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD881"},120962:{"value":"1D882","name":"SIGNWRITING HAND-HINGE NO THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD882"},120963:{"value":"1D883","name":"SIGNWRITING HAND-HINGE THUMB SIDE TOUCHING INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD883"},120964:{"value":"1D884","name":"SIGNWRITING HAND-HINGE THUMB BETWEEN MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD884"},120965:{"value":"1D885","name":"SIGNWRITING HAND-ANGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD885"},120966:{"value":"1D886","name":"SIGNWRITING HAND-FIST INDEX MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD886"},120967:{"value":"1D887","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD887"},120968:{"value":"1D888","name":"SIGNWRITING HAND-HINGE INDEX MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD888"},120969:{"value":"1D889","name":"SIGNWRITING HAND-ANGLE INDEX MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD889"},120970:{"value":"1D88A","name":"SIGNWRITING HAND-HINGE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88A"},120971:{"value":"1D88B","name":"SIGNWRITING HAND-FIST INDEX MIDDLE RING BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88B"},120972:{"value":"1D88C","name":"SIGNWRITING HAND-FIST INDEX MIDDLE RING CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88C"},120973:{"value":"1D88D","name":"SIGNWRITING HAND-HINGE INDEX MIDDLE RING CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88D"},120974:{"value":"1D88E","name":"SIGNWRITING HAND-FIST LITTLE DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88E"},120975:{"value":"1D88F","name":"SIGNWRITING HAND-FIST LITTLE DOWN RIPPLE STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD88F"},120976:{"value":"1D890","name":"SIGNWRITING HAND-FIST LITTLE DOWN RIPPLE CURVED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD890"},120977:{"value":"1D891","name":"SIGNWRITING HAND-FIST LITTLE DOWN OTHERS CIRCLED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD891"},120978:{"value":"1D892","name":"SIGNWRITING HAND-FIST LITTLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD892"},120979:{"value":"1D893","name":"SIGNWRITING HAND-FIST THUMB UNDER LITTLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD893"},120980:{"value":"1D894","name":"SIGNWRITING HAND-CIRCLE LITTLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD894"},120981:{"value":"1D895","name":"SIGNWRITING HAND-OVAL LITTLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD895"},120982:{"value":"1D896","name":"SIGNWRITING HAND-ANGLE LITTLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD896"},120983:{"value":"1D897","name":"SIGNWRITING HAND-FIST LITTLE RAISED KNUCKLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD897"},120984:{"value":"1D898","name":"SIGNWRITING HAND-FIST LITTLE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD898"},120985:{"value":"1D899","name":"SIGNWRITING HAND-FIST LITTLE TOUCHES THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD899"},120986:{"value":"1D89A","name":"SIGNWRITING HAND-FIST LITTLE THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89A"},120987:{"value":"1D89B","name":"SIGNWRITING HAND-HINGE LITTLE THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89B"},120988:{"value":"1D89C","name":"SIGNWRITING HAND-FIST LITTLE INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89C"},120989:{"value":"1D89D","name":"SIGNWRITING HAND-HINGE LITTLE INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89D"},120990:{"value":"1D89E","name":"SIGNWRITING HAND-ANGLE LITTLE INDEX THUMB INDEX THUMB OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89E"},120991:{"value":"1D89F","name":"SIGNWRITING HAND-ANGLE LITTLE INDEX THUMB INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD89F"},120992:{"value":"1D8A0","name":"SIGNWRITING HAND-FIST LITTLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A0"},120993:{"value":"1D8A1","name":"SIGNWRITING HAND-CIRCLE LITTLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A1"},120994:{"value":"1D8A2","name":"SIGNWRITING HAND-HINGE LITTLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A2"},120995:{"value":"1D8A3","name":"SIGNWRITING HAND-ANGLE LITTLE INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A3"},120996:{"value":"1D8A4","name":"SIGNWRITING HAND-FIST INDEX MIDDLE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A4"},120997:{"value":"1D8A5","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A5"},120998:{"value":"1D8A6","name":"SIGNWRITING HAND-HINGE INDEX MIDDLE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A6"},120999:{"value":"1D8A7","name":"SIGNWRITING HAND-HINGE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A7"},121000:{"value":"1D8A8","name":"SIGNWRITING HAND-ANGLE INDEX MIDDLE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A8"},121001:{"value":"1D8A9","name":"SIGNWRITING HAND-FIST INDEX MIDDLE CROSS LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8A9"},121002:{"value":"1D8AA","name":"SIGNWRITING HAND-CIRCLE INDEX MIDDLE CROSS LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AA"},121003:{"value":"1D8AB","name":"SIGNWRITING HAND-FIST RING DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AB"},121004:{"value":"1D8AC","name":"SIGNWRITING HAND-HINGE RING DOWN INDEX THUMB HOOK MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AC"},121005:{"value":"1D8AD","name":"SIGNWRITING HAND-ANGLE RING DOWN MIDDLE THUMB INDEX CROSS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AD"},121006:{"value":"1D8AE","name":"SIGNWRITING HAND-FIST RING UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AE"},121007:{"value":"1D8AF","name":"SIGNWRITING HAND-FIST RING RAISED KNUCKLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8AF"},121008:{"value":"1D8B0","name":"SIGNWRITING HAND-FIST RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B0"},121009:{"value":"1D8B1","name":"SIGNWRITING HAND-CIRCLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B1"},121010:{"value":"1D8B2","name":"SIGNWRITING HAND-OVAL RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B2"},121011:{"value":"1D8B3","name":"SIGNWRITING HAND-ANGLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B3"},121012:{"value":"1D8B4","name":"SIGNWRITING HAND-FIST RING MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B4"},121013:{"value":"1D8B5","name":"SIGNWRITING HAND-FIST RING MIDDLE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B5"},121014:{"value":"1D8B6","name":"SIGNWRITING HAND-FIST RING MIDDLE RAISED KNUCKLES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B6"},121015:{"value":"1D8B7","name":"SIGNWRITING HAND-FIST RING INDEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B7"},121016:{"value":"1D8B8","name":"SIGNWRITING HAND-FIST RING THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B8"},121017:{"value":"1D8B9","name":"SIGNWRITING HAND-HOOK RING THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8B9"},121018:{"value":"1D8BA","name":"SIGNWRITING HAND-FIST INDEX RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BA"},121019:{"value":"1D8BB","name":"SIGNWRITING HAND-CIRCLE INDEX RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BB"},121020:{"value":"1D8BC","name":"SIGNWRITING HAND-CURLICUE INDEX RING LITTLE ON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BC"},121021:{"value":"1D8BD","name":"SIGNWRITING HAND-HOOK INDEX RING LITTLE OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BD"},121022:{"value":"1D8BE","name":"SIGNWRITING HAND-HOOK INDEX RING LITTLE IN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BE"},121023:{"value":"1D8BF","name":"SIGNWRITING HAND-HOOK INDEX RING LITTLE UNDER","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8BF"},121024:{"value":"1D8C0","name":"SIGNWRITING HAND-CUP INDEX RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C0"},121025:{"value":"1D8C1","name":"SIGNWRITING HAND-HINGE INDEX RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C1"},121026:{"value":"1D8C2","name":"SIGNWRITING HAND-ANGLE INDEX RING LITTLE OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C2"},121027:{"value":"1D8C3","name":"SIGNWRITING HAND-ANGLE INDEX RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C3"},121028:{"value":"1D8C4","name":"SIGNWRITING HAND-FIST MIDDLE DOWN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C4"},121029:{"value":"1D8C5","name":"SIGNWRITING HAND-HINGE MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C5"},121030:{"value":"1D8C6","name":"SIGNWRITING HAND-FIST MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C6"},121031:{"value":"1D8C7","name":"SIGNWRITING HAND-CIRCLE MIDDLE UP","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C7"},121032:{"value":"1D8C8","name":"SIGNWRITING HAND-FIST MIDDLE RAISED KNUCKLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C8"},121033:{"value":"1D8C9","name":"SIGNWRITING HAND-FIST MIDDLE UP THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8C9"},121034:{"value":"1D8CA","name":"SIGNWRITING HAND-HOOK MIDDLE THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CA"},121035:{"value":"1D8CB","name":"SIGNWRITING HAND-FIST MIDDLE THUMB LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CB"},121036:{"value":"1D8CC","name":"SIGNWRITING HAND-FIST MIDDLE LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CC"},121037:{"value":"1D8CD","name":"SIGNWRITING HAND-FIST MIDDLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CD"},121038:{"value":"1D8CE","name":"SIGNWRITING HAND-CIRCLE MIDDLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CE"},121039:{"value":"1D8CF","name":"SIGNWRITING HAND-CURLICUE MIDDLE RING LITTLE ON","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8CF"},121040:{"value":"1D8D0","name":"SIGNWRITING HAND-CUP MIDDLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D0"},121041:{"value":"1D8D1","name":"SIGNWRITING HAND-HINGE MIDDLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D1"},121042:{"value":"1D8D2","name":"SIGNWRITING HAND-ANGLE MIDDLE RING LITTLE OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D2"},121043:{"value":"1D8D3","name":"SIGNWRITING HAND-ANGLE MIDDLE RING LITTLE IN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D3"},121044:{"value":"1D8D4","name":"SIGNWRITING HAND-ANGLE MIDDLE RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D4"},121045:{"value":"1D8D5","name":"SIGNWRITING HAND-CIRCLE MIDDLE RING LITTLE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D5"},121046:{"value":"1D8D6","name":"SIGNWRITING HAND-CLAW MIDDLE RING LITTLE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D6"},121047:{"value":"1D8D7","name":"SIGNWRITING HAND-CLAW MIDDLE RING LITTLE CONJOINED SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D7"},121048:{"value":"1D8D8","name":"SIGNWRITING HAND-HOOK MIDDLE RING LITTLE CONJOINED OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D8"},121049:{"value":"1D8D9","name":"SIGNWRITING HAND-HOOK MIDDLE RING LITTLE CONJOINED IN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8D9"},121050:{"value":"1D8DA","name":"SIGNWRITING HAND-HOOK MIDDLE RING LITTLE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DA"},121051:{"value":"1D8DB","name":"SIGNWRITING HAND-HINGE INDEX HINGED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DB"},121052:{"value":"1D8DC","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DC"},121053:{"value":"1D8DD","name":"SIGNWRITING HAND-HINGE INDEX THUMB SIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DD"},121054:{"value":"1D8DE","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE THUMB DIAGONAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DE"},121055:{"value":"1D8DF","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE THUMB CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8DF"},121056:{"value":"1D8E0","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE THUMB BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E0"},121057:{"value":"1D8E1","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E1"},121058:{"value":"1D8E2","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE BOTH BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E2"},121059:{"value":"1D8E3","name":"SIGNWRITING HAND-FIST INDEX THUMB SIDE INDEX HINGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E3"},121060:{"value":"1D8E4","name":"SIGNWRITING HAND-FIST INDEX THUMB FORWARD INDEX STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E4"},121061:{"value":"1D8E5","name":"SIGNWRITING HAND-FIST INDEX THUMB FORWARD INDEX BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E5"},121062:{"value":"1D8E6","name":"SIGNWRITING HAND-FIST INDEX THUMB HOOK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E6"},121063:{"value":"1D8E7","name":"SIGNWRITING HAND-FIST INDEX THUMB CURLICUE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E7"},121064:{"value":"1D8E8","name":"SIGNWRITING HAND-FIST INDEX THUMB CURVE THUMB INSIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E8"},121065:{"value":"1D8E9","name":"SIGNWRITING HAND-CLAW INDEX THUMB CURVE THUMB INSIDE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8E9"},121066:{"value":"1D8EA","name":"SIGNWRITING HAND-FIST INDEX THUMB CURVE THUMB UNDER","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8EA"},121067:{"value":"1D8EB","name":"SIGNWRITING HAND-FIST INDEX THUMB CIRCLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8EB"},121068:{"value":"1D8EC","name":"SIGNWRITING HAND-CUP INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8EC"},121069:{"value":"1D8ED","name":"SIGNWRITING HAND-CUP INDEX THUMB OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8ED"},121070:{"value":"1D8EE","name":"SIGNWRITING HAND-HINGE INDEX THUMB OPEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8EE"},121071:{"value":"1D8EF","name":"SIGNWRITING HAND-HINGE INDEX THUMB LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8EF"},121072:{"value":"1D8F0","name":"SIGNWRITING HAND-HINGE INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F0"},121073:{"value":"1D8F1","name":"SIGNWRITING HAND-HINGE INDEX THUMB SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F1"},121074:{"value":"1D8F2","name":"SIGNWRITING HAND-ANGLE INDEX THUMB OUT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F2"},121075:{"value":"1D8F3","name":"SIGNWRITING HAND-ANGLE INDEX THUMB IN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F3"},121076:{"value":"1D8F4","name":"SIGNWRITING HAND-ANGLE INDEX THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F4"},121077:{"value":"1D8F5","name":"SIGNWRITING HAND-FIST THUMB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F5"},121078:{"value":"1D8F6","name":"SIGNWRITING HAND-FIST THUMB HEEL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F6"},121079:{"value":"1D8F7","name":"SIGNWRITING HAND-FIST THUMB SIDE DIAGONAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F7"},121080:{"value":"1D8F8","name":"SIGNWRITING HAND-FIST THUMB SIDE CONJOINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F8"},121081:{"value":"1D8F9","name":"SIGNWRITING HAND-FIST THUMB SIDE BENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8F9"},121082:{"value":"1D8FA","name":"SIGNWRITING HAND-FIST THUMB FORWARD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FA"},121083:{"value":"1D8FB","name":"SIGNWRITING HAND-FIST THUMB BETWEEN INDEX MIDDLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FB"},121084:{"value":"1D8FC","name":"SIGNWRITING HAND-FIST THUMB BETWEEN MIDDLE RING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FC"},121085:{"value":"1D8FD","name":"SIGNWRITING HAND-FIST THUMB BETWEEN RING LITTLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FD"},121086:{"value":"1D8FE","name":"SIGNWRITING HAND-FIST THUMB UNDER TWO FINGERS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FE"},121087:{"value":"1D8FF","name":"SIGNWRITING HAND-FIST THUMB OVER TWO FINGERS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD8FF"},121088:{"value":"1D900","name":"SIGNWRITING HAND-FIST THUMB UNDER THREE FINGERS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD900"},121089:{"value":"1D901","name":"SIGNWRITING HAND-FIST THUMB UNDER FOUR FINGERS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD901"},121090:{"value":"1D902","name":"SIGNWRITING HAND-FIST THUMB OVER FOUR RAISED KNUCKLES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD902"},121091:{"value":"1D903","name":"SIGNWRITING HAND-FIST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD903"},121092:{"value":"1D904","name":"SIGNWRITING HAND-FIST HEEL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD904"},121093:{"value":"1D905","name":"SIGNWRITING TOUCH SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD905"},121094:{"value":"1D906","name":"SIGNWRITING TOUCH MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD906"},121095:{"value":"1D907","name":"SIGNWRITING TOUCH BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD907"},121096:{"value":"1D908","name":"SIGNWRITING GRASP SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD908"},121097:{"value":"1D909","name":"SIGNWRITING GRASP MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD909"},121098:{"value":"1D90A","name":"SIGNWRITING GRASP BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90A"},121099:{"value":"1D90B","name":"SIGNWRITING STRIKE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90B"},121100:{"value":"1D90C","name":"SIGNWRITING STRIKE MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90C"},121101:{"value":"1D90D","name":"SIGNWRITING STRIKE BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90D"},121102:{"value":"1D90E","name":"SIGNWRITING BRUSH SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90E"},121103:{"value":"1D90F","name":"SIGNWRITING BRUSH MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD90F"},121104:{"value":"1D910","name":"SIGNWRITING BRUSH BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD910"},121105:{"value":"1D911","name":"SIGNWRITING RUB SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD911"},121106:{"value":"1D912","name":"SIGNWRITING RUB MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD912"},121107:{"value":"1D913","name":"SIGNWRITING RUB BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD913"},121108:{"value":"1D914","name":"SIGNWRITING SURFACE SYMBOLS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD914"},121109:{"value":"1D915","name":"SIGNWRITING SURFACE BETWEEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD915"},121110:{"value":"1D916","name":"SIGNWRITING SQUEEZE LARGE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD916"},121111:{"value":"1D917","name":"SIGNWRITING SQUEEZE SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD917"},121112:{"value":"1D918","name":"SIGNWRITING SQUEEZE LARGE MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD918"},121113:{"value":"1D919","name":"SIGNWRITING SQUEEZE SMALL MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD919"},121114:{"value":"1D91A","name":"SIGNWRITING SQUEEZE SEQUENTIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91A"},121115:{"value":"1D91B","name":"SIGNWRITING FLICK LARGE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91B"},121116:{"value":"1D91C","name":"SIGNWRITING FLICK SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91C"},121117:{"value":"1D91D","name":"SIGNWRITING FLICK LARGE MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91D"},121118:{"value":"1D91E","name":"SIGNWRITING FLICK SMALL MULTIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91E"},121119:{"value":"1D91F","name":"SIGNWRITING FLICK SEQUENTIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD91F"},121120:{"value":"1D920","name":"SIGNWRITING SQUEEZE FLICK ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD920"},121121:{"value":"1D921","name":"SIGNWRITING MOVEMENT-HINGE UP DOWN LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD921"},121122:{"value":"1D922","name":"SIGNWRITING MOVEMENT-HINGE UP DOWN SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD922"},121123:{"value":"1D923","name":"SIGNWRITING MOVEMENT-HINGE UP SEQUENTIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD923"},121124:{"value":"1D924","name":"SIGNWRITING MOVEMENT-HINGE DOWN SEQUENTIAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD924"},121125:{"value":"1D925","name":"SIGNWRITING MOVEMENT-HINGE UP DOWN ALTERNATING LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD925"},121126:{"value":"1D926","name":"SIGNWRITING MOVEMENT-HINGE UP DOWN ALTERNATING SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD926"},121127:{"value":"1D927","name":"SIGNWRITING MOVEMENT-HINGE SIDE TO SIDE SCISSORS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD927"},121128:{"value":"1D928","name":"SIGNWRITING MOVEMENT-WALLPLANE FINGER CONTACT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD928"},121129:{"value":"1D929","name":"SIGNWRITING MOVEMENT-FLOORPLANE FINGER CONTACT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD929"},121130:{"value":"1D92A","name":"SIGNWRITING MOVEMENT-WALLPLANE SINGLE STRAIGHT SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92A"},121131:{"value":"1D92B","name":"SIGNWRITING MOVEMENT-WALLPLANE SINGLE STRAIGHT MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92B"},121132:{"value":"1D92C","name":"SIGNWRITING MOVEMENT-WALLPLANE SINGLE STRAIGHT LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92C"},121133:{"value":"1D92D","name":"SIGNWRITING MOVEMENT-WALLPLANE SINGLE STRAIGHT LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92D"},121134:{"value":"1D92E","name":"SIGNWRITING MOVEMENT-WALLPLANE SINGLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92E"},121135:{"value":"1D92F","name":"SIGNWRITING MOVEMENT-WALLPLANE DOUBLE STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD92F"},121136:{"value":"1D930","name":"SIGNWRITING MOVEMENT-WALLPLANE DOUBLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD930"},121137:{"value":"1D931","name":"SIGNWRITING MOVEMENT-WALLPLANE DOUBLE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD931"},121138:{"value":"1D932","name":"SIGNWRITING MOVEMENT-WALLPLANE DOUBLE ALTERNATING WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD932"},121139:{"value":"1D933","name":"SIGNWRITING MOVEMENT-WALLPLANE CROSS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD933"},121140:{"value":"1D934","name":"SIGNWRITING MOVEMENT-WALLPLANE TRIPLE STRAIGHT MOVEMENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD934"},121141:{"value":"1D935","name":"SIGNWRITING MOVEMENT-WALLPLANE TRIPLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD935"},121142:{"value":"1D936","name":"SIGNWRITING MOVEMENT-WALLPLANE TRIPLE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD936"},121143:{"value":"1D937","name":"SIGNWRITING MOVEMENT-WALLPLANE TRIPLE ALTERNATING WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD937"},121144:{"value":"1D938","name":"SIGNWRITING MOVEMENT-WALLPLANE BEND SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD938"},121145:{"value":"1D939","name":"SIGNWRITING MOVEMENT-WALLPLANE BEND MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD939"},121146:{"value":"1D93A","name":"SIGNWRITING MOVEMENT-WALLPLANE BEND LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93A"},121147:{"value":"1D93B","name":"SIGNWRITING MOVEMENT-WALLPLANE CORNER SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93B"},121148:{"value":"1D93C","name":"SIGNWRITING MOVEMENT-WALLPLANE CORNER MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93C"},121149:{"value":"1D93D","name":"SIGNWRITING MOVEMENT-WALLPLANE CORNER LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93D"},121150:{"value":"1D93E","name":"SIGNWRITING MOVEMENT-WALLPLANE CORNER ROTATION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93E"},121151:{"value":"1D93F","name":"SIGNWRITING MOVEMENT-WALLPLANE CHECK SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD93F"},121152:{"value":"1D940","name":"SIGNWRITING MOVEMENT-WALLPLANE CHECK MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD940"},121153:{"value":"1D941","name":"SIGNWRITING MOVEMENT-WALLPLANE CHECK LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD941"},121154:{"value":"1D942","name":"SIGNWRITING MOVEMENT-WALLPLANE BOX SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD942"},121155:{"value":"1D943","name":"SIGNWRITING MOVEMENT-WALLPLANE BOX MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD943"},121156:{"value":"1D944","name":"SIGNWRITING MOVEMENT-WALLPLANE BOX LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD944"},121157:{"value":"1D945","name":"SIGNWRITING MOVEMENT-WALLPLANE ZIGZAG SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD945"},121158:{"value":"1D946","name":"SIGNWRITING MOVEMENT-WALLPLANE ZIGZAG MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD946"},121159:{"value":"1D947","name":"SIGNWRITING MOVEMENT-WALLPLANE ZIGZAG LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD947"},121160:{"value":"1D948","name":"SIGNWRITING MOVEMENT-WALLPLANE PEAKS SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD948"},121161:{"value":"1D949","name":"SIGNWRITING MOVEMENT-WALLPLANE PEAKS MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD949"},121162:{"value":"1D94A","name":"SIGNWRITING MOVEMENT-WALLPLANE PEAKS LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94A"},121163:{"value":"1D94B","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-WALLPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94B"},121164:{"value":"1D94C","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-WALLPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94C"},121165:{"value":"1D94D","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-WALLPLANE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94D"},121166:{"value":"1D94E","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-FLOORPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94E"},121167:{"value":"1D94F","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-FLOORPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD94F"},121168:{"value":"1D950","name":"SIGNWRITING TRAVEL-WALLPLANE ROTATION-FLOORPLANE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD950"},121169:{"value":"1D951","name":"SIGNWRITING TRAVEL-WALLPLANE SHAKING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD951"},121170:{"value":"1D952","name":"SIGNWRITING TRAVEL-WALLPLANE ARM SPIRAL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD952"},121171:{"value":"1D953","name":"SIGNWRITING TRAVEL-WALLPLANE ARM SPIRAL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD953"},121172:{"value":"1D954","name":"SIGNWRITING TRAVEL-WALLPLANE ARM SPIRAL TRIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD954"},121173:{"value":"1D955","name":"SIGNWRITING MOVEMENT-DIAGONAL AWAY SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD955"},121174:{"value":"1D956","name":"SIGNWRITING MOVEMENT-DIAGONAL AWAY MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD956"},121175:{"value":"1D957","name":"SIGNWRITING MOVEMENT-DIAGONAL AWAY LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD957"},121176:{"value":"1D958","name":"SIGNWRITING MOVEMENT-DIAGONAL AWAY LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD958"},121177:{"value":"1D959","name":"SIGNWRITING MOVEMENT-DIAGONAL TOWARDS SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD959"},121178:{"value":"1D95A","name":"SIGNWRITING MOVEMENT-DIAGONAL TOWARDS MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95A"},121179:{"value":"1D95B","name":"SIGNWRITING MOVEMENT-DIAGONAL TOWARDS LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95B"},121180:{"value":"1D95C","name":"SIGNWRITING MOVEMENT-DIAGONAL TOWARDS LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95C"},121181:{"value":"1D95D","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN AWAY SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95D"},121182:{"value":"1D95E","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN AWAY MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95E"},121183:{"value":"1D95F","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN AWAY LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD95F"},121184:{"value":"1D960","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN AWAY LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD960"},121185:{"value":"1D961","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN TOWARDS SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD961"},121186:{"value":"1D962","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN TOWARDS MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD962"},121187:{"value":"1D963","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN TOWARDS LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD963"},121188:{"value":"1D964","name":"SIGNWRITING MOVEMENT-DIAGONAL BETWEEN TOWARDS LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD964"},121189:{"value":"1D965","name":"SIGNWRITING MOVEMENT-FLOORPLANE SINGLE STRAIGHT SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD965"},121190:{"value":"1D966","name":"SIGNWRITING MOVEMENT-FLOORPLANE SINGLE STRAIGHT MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD966"},121191:{"value":"1D967","name":"SIGNWRITING MOVEMENT-FLOORPLANE SINGLE STRAIGHT LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD967"},121192:{"value":"1D968","name":"SIGNWRITING MOVEMENT-FLOORPLANE SINGLE STRAIGHT LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD968"},121193:{"value":"1D969","name":"SIGNWRITING MOVEMENT-FLOORPLANE SINGLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD969"},121194:{"value":"1D96A","name":"SIGNWRITING MOVEMENT-FLOORPLANE DOUBLE STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96A"},121195:{"value":"1D96B","name":"SIGNWRITING MOVEMENT-FLOORPLANE DOUBLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96B"},121196:{"value":"1D96C","name":"SIGNWRITING MOVEMENT-FLOORPLANE DOUBLE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96C"},121197:{"value":"1D96D","name":"SIGNWRITING MOVEMENT-FLOORPLANE DOUBLE ALTERNATING WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96D"},121198:{"value":"1D96E","name":"SIGNWRITING MOVEMENT-FLOORPLANE CROSS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96E"},121199:{"value":"1D96F","name":"SIGNWRITING MOVEMENT-FLOORPLANE TRIPLE STRAIGHT MOVEMENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD96F"},121200:{"value":"1D970","name":"SIGNWRITING MOVEMENT-FLOORPLANE TRIPLE WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD970"},121201:{"value":"1D971","name":"SIGNWRITING MOVEMENT-FLOORPLANE TRIPLE ALTERNATING MOVEMENT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD971"},121202:{"value":"1D972","name":"SIGNWRITING MOVEMENT-FLOORPLANE TRIPLE ALTERNATING WRIST FLEX","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD972"},121203:{"value":"1D973","name":"SIGNWRITING MOVEMENT-FLOORPLANE BEND","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD973"},121204:{"value":"1D974","name":"SIGNWRITING MOVEMENT-FLOORPLANE CORNER SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD974"},121205:{"value":"1D975","name":"SIGNWRITING MOVEMENT-FLOORPLANE CORNER MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD975"},121206:{"value":"1D976","name":"SIGNWRITING MOVEMENT-FLOORPLANE CORNER LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD976"},121207:{"value":"1D977","name":"SIGNWRITING MOVEMENT-FLOORPLANE CHECK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD977"},121208:{"value":"1D978","name":"SIGNWRITING MOVEMENT-FLOORPLANE BOX SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD978"},121209:{"value":"1D979","name":"SIGNWRITING MOVEMENT-FLOORPLANE BOX MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD979"},121210:{"value":"1D97A","name":"SIGNWRITING MOVEMENT-FLOORPLANE BOX LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97A"},121211:{"value":"1D97B","name":"SIGNWRITING MOVEMENT-FLOORPLANE ZIGZAG SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97B"},121212:{"value":"1D97C","name":"SIGNWRITING MOVEMENT-FLOORPLANE ZIGZAG MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97C"},121213:{"value":"1D97D","name":"SIGNWRITING MOVEMENT-FLOORPLANE ZIGZAG LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97D"},121214:{"value":"1D97E","name":"SIGNWRITING MOVEMENT-FLOORPLANE PEAKS SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97E"},121215:{"value":"1D97F","name":"SIGNWRITING MOVEMENT-FLOORPLANE PEAKS MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD97F"},121216:{"value":"1D980","name":"SIGNWRITING MOVEMENT-FLOORPLANE PEAKS LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD980"},121217:{"value":"1D981","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-FLOORPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD981"},121218:{"value":"1D982","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-FLOORPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD982"},121219:{"value":"1D983","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-FLOORPLANE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD983"},121220:{"value":"1D984","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-WALLPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD984"},121221:{"value":"1D985","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-WALLPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD985"},121222:{"value":"1D986","name":"SIGNWRITING TRAVEL-FLOORPLANE ROTATION-WALLPLANE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD986"},121223:{"value":"1D987","name":"SIGNWRITING TRAVEL-FLOORPLANE SHAKING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD987"},121224:{"value":"1D988","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE QUARTER SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD988"},121225:{"value":"1D989","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE QUARTER MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD989"},121226:{"value":"1D98A","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE QUARTER LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98A"},121227:{"value":"1D98B","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE QUARTER LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98B"},121228:{"value":"1D98C","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HALF-CIRCLE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98C"},121229:{"value":"1D98D","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HALF-CIRCLE MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98D"},121230:{"value":"1D98E","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HALF-CIRCLE LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98E"},121231:{"value":"1D98F","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HALF-CIRCLE LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD98F"},121232:{"value":"1D990","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE THREE-QUARTER CIRCLE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD990"},121233:{"value":"1D991","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE THREE-QUARTER CIRCLE MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD991"},121234:{"value":"1D992","name":"SIGNWRITING MOVEMENT-WALLPLANE HUMP SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD992"},121235:{"value":"1D993","name":"SIGNWRITING MOVEMENT-WALLPLANE HUMP MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD993"},121236:{"value":"1D994","name":"SIGNWRITING MOVEMENT-WALLPLANE HUMP LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD994"},121237:{"value":"1D995","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD995"},121238:{"value":"1D996","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD996"},121239:{"value":"1D997","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD997"},121240:{"value":"1D998","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD998"},121241:{"value":"1D999","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE DOUBLE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD999"},121242:{"value":"1D99A","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE DOUBLE MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99A"},121243:{"value":"1D99B","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE DOUBLE LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99B"},121244:{"value":"1D99C","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE TRIPLE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99C"},121245:{"value":"1D99D","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE TRIPLE MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99D"},121246:{"value":"1D99E","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE CURVE TRIPLE LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99E"},121247:{"value":"1D99F","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE THEN STRAIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD99F"},121248:{"value":"1D9A0","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVED CROSS SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A0"},121249:{"value":"1D9A1","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVED CROSS MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A1"},121250:{"value":"1D9A2","name":"SIGNWRITING ROTATION-WALLPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A2"},121251:{"value":"1D9A3","name":"SIGNWRITING ROTATION-WALLPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A3"},121252:{"value":"1D9A4","name":"SIGNWRITING ROTATION-WALLPLANE ALTERNATE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A4"},121253:{"value":"1D9A5","name":"SIGNWRITING MOVEMENT-WALLPLANE SHAKING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A5"},121254:{"value":"1D9A6","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A6"},121255:{"value":"1D9A7","name":"SIGNWRITING MOVEMENT-WALLPLANE HUMP HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A7"},121256:{"value":"1D9A8","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A8"},121257:{"value":"1D9A9","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9A9"},121258:{"value":"1D9AA","name":"SIGNWRITING ROTATION-WALLPLANE SINGLE HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AA"},121259:{"value":"1D9AB","name":"SIGNWRITING ROTATION-WALLPLANE DOUBLE HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AB"},121260:{"value":"1D9AC","name":"SIGNWRITING ROTATION-WALLPLANE ALTERNATING HITTING FRONT WALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AC"},121261:{"value":"1D9AD","name":"SIGNWRITING MOVEMENT-WALLPLANE CURVE HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AD"},121262:{"value":"1D9AE","name":"SIGNWRITING MOVEMENT-WALLPLANE HUMP HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AE"},121263:{"value":"1D9AF","name":"SIGNWRITING MOVEMENT-WALLPLANE LOOP HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9AF"},121264:{"value":"1D9B0","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B0"},121265:{"value":"1D9B1","name":"SIGNWRITING ROTATION-WALLPLANE SINGLE HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B1"},121266:{"value":"1D9B2","name":"SIGNWRITING ROTATION-WALLPLANE DOUBLE HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B2"},121267:{"value":"1D9B3","name":"SIGNWRITING ROTATION-WALLPLANE ALTERNATING HITTING CHEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B3"},121268:{"value":"1D9B4","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE DIAGONAL PATH SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B4"},121269:{"value":"1D9B5","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE DIAGONAL PATH MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B5"},121270:{"value":"1D9B6","name":"SIGNWRITING MOVEMENT-WALLPLANE WAVE DIAGONAL PATH LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B6"},121271:{"value":"1D9B7","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE HITTING CEILING SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B7"},121272:{"value":"1D9B8","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE HITTING CEILING LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B8"},121273:{"value":"1D9B9","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING CEILING SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9B9"},121274:{"value":"1D9BA","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING CEILING LARGE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BA"},121275:{"value":"1D9BB","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING CEILING SMALL TRIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BB"},121276:{"value":"1D9BC","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING CEILING LARGE TRIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BC"},121277:{"value":"1D9BD","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING CEILING SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BD"},121278:{"value":"1D9BE","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING CEILING LARGE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BE"},121279:{"value":"1D9BF","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING CEILING SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9BF"},121280:{"value":"1D9C0","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING CEILING LARGE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C0"},121281:{"value":"1D9C1","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE HITTING CEILING SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C1"},121282:{"value":"1D9C2","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE HITTING CEILING LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C2"},121283:{"value":"1D9C3","name":"SIGNWRITING ROTATION-FLOORPLANE SINGLE HITTING CEILING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C3"},121284:{"value":"1D9C4","name":"SIGNWRITING ROTATION-FLOORPLANE DOUBLE HITTING CEILING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C4"},121285:{"value":"1D9C5","name":"SIGNWRITING ROTATION-FLOORPLANE ALTERNATING HITTING CEILING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C5"},121286:{"value":"1D9C6","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE HITTING FLOOR SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C6"},121287:{"value":"1D9C7","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE HITTING FLOOR LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C7"},121288:{"value":"1D9C8","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING FLOOR SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C8"},121289:{"value":"1D9C9","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING FLOOR LARGE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9C9"},121290:{"value":"1D9CA","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING FLOOR TRIPLE SMALL TRIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CA"},121291:{"value":"1D9CB","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP HITTING FLOOR TRIPLE LARGE TRIPLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CB"},121292:{"value":"1D9CC","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING FLOOR SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CC"},121293:{"value":"1D9CD","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING FLOOR LARGE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CD"},121294:{"value":"1D9CE","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING FLOOR SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CE"},121295:{"value":"1D9CF","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP HITTING FLOOR LARGE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9CF"},121296:{"value":"1D9D0","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE HITTING FLOOR SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D0"},121297:{"value":"1D9D1","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE HITTING FLOOR LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D1"},121298:{"value":"1D9D2","name":"SIGNWRITING ROTATION-FLOORPLANE SINGLE HITTING FLOOR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D2"},121299:{"value":"1D9D3","name":"SIGNWRITING ROTATION-FLOORPLANE DOUBLE HITTING FLOOR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D3"},121300:{"value":"1D9D4","name":"SIGNWRITING ROTATION-FLOORPLANE ALTERNATING HITTING FLOOR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D4"},121301:{"value":"1D9D5","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D5"},121302:{"value":"1D9D6","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE MEDIUM","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D6"},121303:{"value":"1D9D7","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D7"},121304:{"value":"1D9D8","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE LARGEST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D8"},121305:{"value":"1D9D9","name":"SIGNWRITING MOVEMENT-FLOORPLANE CURVE COMBINED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9D9"},121306:{"value":"1D9DA","name":"SIGNWRITING MOVEMENT-FLOORPLANE HUMP SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DA"},121307:{"value":"1D9DB","name":"SIGNWRITING MOVEMENT-FLOORPLANE LOOP SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DB"},121308:{"value":"1D9DC","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE SNAKE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DC"},121309:{"value":"1D9DD","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DD"},121310:{"value":"1D9DE","name":"SIGNWRITING MOVEMENT-FLOORPLANE WAVE LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DE"},121311:{"value":"1D9DF","name":"SIGNWRITING ROTATION-FLOORPLANE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9DF"},121312:{"value":"1D9E0","name":"SIGNWRITING ROTATION-FLOORPLANE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E0"},121313:{"value":"1D9E1","name":"SIGNWRITING ROTATION-FLOORPLANE ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E1"},121314:{"value":"1D9E2","name":"SIGNWRITING MOVEMENT-FLOORPLANE SHAKING PARALLEL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E2"},121315:{"value":"1D9E3","name":"SIGNWRITING MOVEMENT-WALLPLANE ARM CIRCLE SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E3"},121316:{"value":"1D9E4","name":"SIGNWRITING MOVEMENT-WALLPLANE ARM CIRCLE MEDIUM SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E4"},121317:{"value":"1D9E5","name":"SIGNWRITING MOVEMENT-WALLPLANE ARM CIRCLE SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E5"},121318:{"value":"1D9E6","name":"SIGNWRITING MOVEMENT-WALLPLANE ARM CIRCLE MEDIUM DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E6"},121319:{"value":"1D9E7","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL SMALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E7"},121320:{"value":"1D9E8","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL MEDIUM SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E8"},121321:{"value":"1D9E9","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL LARGE SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9E9"},121322:{"value":"1D9EA","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL SMALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9EA"},121323:{"value":"1D9EB","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL MEDIUM DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9EB"},121324:{"value":"1D9EC","name":"SIGNWRITING MOVEMENT-FLOORPLANE ARM CIRCLE HITTING WALL LARGE DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9EC"},121325:{"value":"1D9ED","name":"SIGNWRITING MOVEMENT-WALLPLANE WRIST CIRCLE FRONT SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9ED"},121326:{"value":"1D9EE","name":"SIGNWRITING MOVEMENT-WALLPLANE WRIST CIRCLE FRONT DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9EE"},121327:{"value":"1D9EF","name":"SIGNWRITING MOVEMENT-FLOORPLANE WRIST CIRCLE HITTING WALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9EF"},121328:{"value":"1D9F0","name":"SIGNWRITING MOVEMENT-FLOORPLANE WRIST CIRCLE HITTING WALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F0"},121329:{"value":"1D9F1","name":"SIGNWRITING MOVEMENT-WALLPLANE FINGER CIRCLES SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F1"},121330:{"value":"1D9F2","name":"SIGNWRITING MOVEMENT-WALLPLANE FINGER CIRCLES DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F2"},121331:{"value":"1D9F3","name":"SIGNWRITING MOVEMENT-FLOORPLANE FINGER CIRCLES HITTING WALL SINGLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F3"},121332:{"value":"1D9F4","name":"SIGNWRITING MOVEMENT-FLOORPLANE FINGER CIRCLES HITTING WALL DOUBLE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F4"},121333:{"value":"1D9F5","name":"SIGNWRITING DYNAMIC ARROWHEAD SMALL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F5"},121334:{"value":"1D9F6","name":"SIGNWRITING DYNAMIC ARROWHEAD LARGE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F6"},121335:{"value":"1D9F7","name":"SIGNWRITING DYNAMIC FAST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F7"},121336:{"value":"1D9F8","name":"SIGNWRITING DYNAMIC SLOW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F8"},121337:{"value":"1D9F9","name":"SIGNWRITING DYNAMIC TENSE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9F9"},121338:{"value":"1D9FA","name":"SIGNWRITING DYNAMIC RELAXED","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FA"},121339:{"value":"1D9FB","name":"SIGNWRITING DYNAMIC SIMULTANEOUS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FB"},121340:{"value":"1D9FC","name":"SIGNWRITING DYNAMIC SIMULTANEOUS ALTERNATING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FC"},121341:{"value":"1D9FD","name":"SIGNWRITING DYNAMIC EVERY OTHER TIME","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FD"},121342:{"value":"1D9FE","name":"SIGNWRITING DYNAMIC GRADUAL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FE"},121343:{"value":"1D9FF","name":"SIGNWRITING HEAD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uD9FF"},121399:{"value":"1DA37","name":"SIGNWRITING AIR BLOW SMALL ROTATIONS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA37"},121400:{"value":"1DA38","name":"SIGNWRITING AIR SUCK SMALL ROTATIONS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA38"},121401:{"value":"1DA39","name":"SIGNWRITING BREATH INHALE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA39"},121402:{"value":"1DA3A","name":"SIGNWRITING BREATH EXHALE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA3A"},121453:{"value":"1DA6D","name":"SIGNWRITING SHOULDER HIP SPINE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA6D"},121454:{"value":"1DA6E","name":"SIGNWRITING SHOULDER HIP POSITIONS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA6E"},121455:{"value":"1DA6F","name":"SIGNWRITING WALLPLANE SHOULDER HIP MOVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA6F"},121456:{"value":"1DA70","name":"SIGNWRITING FLOORPLANE SHOULDER HIP MOVE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA70"},121457:{"value":"1DA71","name":"SIGNWRITING SHOULDER TILTING FROM WAIST","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA71"},121458:{"value":"1DA72","name":"SIGNWRITING TORSO-WALLPLANE STRAIGHT STRETCH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA72"},121459:{"value":"1DA73","name":"SIGNWRITING TORSO-WALLPLANE CURVED BEND","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA73"},121460:{"value":"1DA74","name":"SIGNWRITING TORSO-FLOORPLANE TWISTING","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA74"},121462:{"value":"1DA76","name":"SIGNWRITING LIMB COMBINATION","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA76"},121463:{"value":"1DA77","name":"SIGNWRITING LIMB LENGTH-1","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA77"},121464:{"value":"1DA78","name":"SIGNWRITING LIMB LENGTH-2","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA78"},121465:{"value":"1DA79","name":"SIGNWRITING LIMB LENGTH-3","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA79"},121466:{"value":"1DA7A","name":"SIGNWRITING LIMB LENGTH-4","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7A"},121467:{"value":"1DA7B","name":"SIGNWRITING LIMB LENGTH-5","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7B"},121468:{"value":"1DA7C","name":"SIGNWRITING LIMB LENGTH-6","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7C"},121469:{"value":"1DA7D","name":"SIGNWRITING LIMB LENGTH-7","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7D"},121470:{"value":"1DA7E","name":"SIGNWRITING FINGER","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7E"},121471:{"value":"1DA7F","name":"SIGNWRITING LOCATION-WALLPLANE SPACE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA7F"},121472:{"value":"1DA80","name":"SIGNWRITING LOCATION-FLOORPLANE SPACE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA80"},121473:{"value":"1DA81","name":"SIGNWRITING LOCATION HEIGHT","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA81"},121474:{"value":"1DA82","name":"SIGNWRITING LOCATION WIDTH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA82"},121475:{"value":"1DA83","name":"SIGNWRITING LOCATION DEPTH","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA83"},121477:{"value":"1DA85","name":"SIGNWRITING LOCATION TORSO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA85"},121478:{"value":"1DA86","name":"SIGNWRITING LOCATION LIMBS DIGITS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uDA86"},126976:{"value":"1F000","name":"MAHJONG TILE EAST WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF000"},126977:{"value":"1F001","name":"MAHJONG TILE SOUTH WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF001"},126978:{"value":"1F002","name":"MAHJONG TILE WEST WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF002"},126979:{"value":"1F003","name":"MAHJONG TILE NORTH WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF003"},126980:{"value":"1F004","name":"MAHJONG TILE RED DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF004"},126981:{"value":"1F005","name":"MAHJONG TILE GREEN DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF005"},126982:{"value":"1F006","name":"MAHJONG TILE WHITE DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF006"},126983:{"value":"1F007","name":"MAHJONG TILE ONE OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF007"},126984:{"value":"1F008","name":"MAHJONG TILE TWO OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF008"},126985:{"value":"1F009","name":"MAHJONG TILE THREE OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF009"},126986:{"value":"1F00A","name":"MAHJONG TILE FOUR OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00A"},126987:{"value":"1F00B","name":"MAHJONG TILE FIVE OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00B"},126988:{"value":"1F00C","name":"MAHJONG TILE SIX OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00C"},126989:{"value":"1F00D","name":"MAHJONG TILE SEVEN OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00D"},126990:{"value":"1F00E","name":"MAHJONG TILE EIGHT OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00E"},126991:{"value":"1F00F","name":"MAHJONG TILE NINE OF CHARACTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF00F"},126992:{"value":"1F010","name":"MAHJONG TILE ONE OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF010"},126993:{"value":"1F011","name":"MAHJONG TILE TWO OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF011"},126994:{"value":"1F012","name":"MAHJONG TILE THREE OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF012"},126995:{"value":"1F013","name":"MAHJONG TILE FOUR OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF013"},126996:{"value":"1F014","name":"MAHJONG TILE FIVE OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF014"},126997:{"value":"1F015","name":"MAHJONG TILE SIX OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF015"},126998:{"value":"1F016","name":"MAHJONG TILE SEVEN OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF016"},126999:{"value":"1F017","name":"MAHJONG TILE EIGHT OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF017"},127000:{"value":"1F018","name":"MAHJONG TILE NINE OF BAMBOOS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF018"},127001:{"value":"1F019","name":"MAHJONG TILE ONE OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF019"},127002:{"value":"1F01A","name":"MAHJONG TILE TWO OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01A"},127003:{"value":"1F01B","name":"MAHJONG TILE THREE OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01B"},127004:{"value":"1F01C","name":"MAHJONG TILE FOUR OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01C"},127005:{"value":"1F01D","name":"MAHJONG TILE FIVE OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01D"},127006:{"value":"1F01E","name":"MAHJONG TILE SIX OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01E"},127007:{"value":"1F01F","name":"MAHJONG TILE SEVEN OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF01F"},127008:{"value":"1F020","name":"MAHJONG TILE EIGHT OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF020"},127009:{"value":"1F021","name":"MAHJONG TILE NINE OF CIRCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF021"},127010:{"value":"1F022","name":"MAHJONG TILE PLUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF022"},127011:{"value":"1F023","name":"MAHJONG TILE ORCHID","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF023"},127012:{"value":"1F024","name":"MAHJONG TILE BAMBOO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF024"},127013:{"value":"1F025","name":"MAHJONG TILE CHRYSANTHEMUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF025"},127014:{"value":"1F026","name":"MAHJONG TILE SPRING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF026"},127015:{"value":"1F027","name":"MAHJONG TILE SUMMER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF027"},127016:{"value":"1F028","name":"MAHJONG TILE AUTUMN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF028"},127017:{"value":"1F029","name":"MAHJONG TILE WINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF029"},127018:{"value":"1F02A","name":"MAHJONG TILE JOKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF02A"},127019:{"value":"1F02B","name":"MAHJONG TILE BACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF02B"},127024:{"value":"1F030","name":"DOMINO TILE HORIZONTAL BACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF030"},127025:{"value":"1F031","name":"DOMINO TILE HORIZONTAL-00-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF031"},127026:{"value":"1F032","name":"DOMINO TILE HORIZONTAL-00-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF032"},127027:{"value":"1F033","name":"DOMINO TILE HORIZONTAL-00-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF033"},127028:{"value":"1F034","name":"DOMINO TILE HORIZONTAL-00-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF034"},127029:{"value":"1F035","name":"DOMINO TILE HORIZONTAL-00-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF035"},127030:{"value":"1F036","name":"DOMINO TILE HORIZONTAL-00-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF036"},127031:{"value":"1F037","name":"DOMINO TILE HORIZONTAL-00-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF037"},127032:{"value":"1F038","name":"DOMINO TILE HORIZONTAL-01-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF038"},127033:{"value":"1F039","name":"DOMINO TILE HORIZONTAL-01-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF039"},127034:{"value":"1F03A","name":"DOMINO TILE HORIZONTAL-01-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03A"},127035:{"value":"1F03B","name":"DOMINO TILE HORIZONTAL-01-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03B"},127036:{"value":"1F03C","name":"DOMINO TILE HORIZONTAL-01-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03C"},127037:{"value":"1F03D","name":"DOMINO TILE HORIZONTAL-01-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03D"},127038:{"value":"1F03E","name":"DOMINO TILE HORIZONTAL-01-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03E"},127039:{"value":"1F03F","name":"DOMINO TILE HORIZONTAL-02-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF03F"},127040:{"value":"1F040","name":"DOMINO TILE HORIZONTAL-02-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF040"},127041:{"value":"1F041","name":"DOMINO TILE HORIZONTAL-02-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF041"},127042:{"value":"1F042","name":"DOMINO TILE HORIZONTAL-02-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF042"},127043:{"value":"1F043","name":"DOMINO TILE HORIZONTAL-02-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF043"},127044:{"value":"1F044","name":"DOMINO TILE HORIZONTAL-02-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF044"},127045:{"value":"1F045","name":"DOMINO TILE HORIZONTAL-02-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF045"},127046:{"value":"1F046","name":"DOMINO TILE HORIZONTAL-03-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF046"},127047:{"value":"1F047","name":"DOMINO TILE HORIZONTAL-03-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF047"},127048:{"value":"1F048","name":"DOMINO TILE HORIZONTAL-03-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF048"},127049:{"value":"1F049","name":"DOMINO TILE HORIZONTAL-03-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF049"},127050:{"value":"1F04A","name":"DOMINO TILE HORIZONTAL-03-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04A"},127051:{"value":"1F04B","name":"DOMINO TILE HORIZONTAL-03-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04B"},127052:{"value":"1F04C","name":"DOMINO TILE HORIZONTAL-03-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04C"},127053:{"value":"1F04D","name":"DOMINO TILE HORIZONTAL-04-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04D"},127054:{"value":"1F04E","name":"DOMINO TILE HORIZONTAL-04-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04E"},127055:{"value":"1F04F","name":"DOMINO TILE HORIZONTAL-04-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF04F"},127056:{"value":"1F050","name":"DOMINO TILE HORIZONTAL-04-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF050"},127057:{"value":"1F051","name":"DOMINO TILE HORIZONTAL-04-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF051"},127058:{"value":"1F052","name":"DOMINO TILE HORIZONTAL-04-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF052"},127059:{"value":"1F053","name":"DOMINO TILE HORIZONTAL-04-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF053"},127060:{"value":"1F054","name":"DOMINO TILE HORIZONTAL-05-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF054"},127061:{"value":"1F055","name":"DOMINO TILE HORIZONTAL-05-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF055"},127062:{"value":"1F056","name":"DOMINO TILE HORIZONTAL-05-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF056"},127063:{"value":"1F057","name":"DOMINO TILE HORIZONTAL-05-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF057"},127064:{"value":"1F058","name":"DOMINO TILE HORIZONTAL-05-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF058"},127065:{"value":"1F059","name":"DOMINO TILE HORIZONTAL-05-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF059"},127066:{"value":"1F05A","name":"DOMINO TILE HORIZONTAL-05-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05A"},127067:{"value":"1F05B","name":"DOMINO TILE HORIZONTAL-06-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05B"},127068:{"value":"1F05C","name":"DOMINO TILE HORIZONTAL-06-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05C"},127069:{"value":"1F05D","name":"DOMINO TILE HORIZONTAL-06-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05D"},127070:{"value":"1F05E","name":"DOMINO TILE HORIZONTAL-06-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05E"},127071:{"value":"1F05F","name":"DOMINO TILE HORIZONTAL-06-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF05F"},127072:{"value":"1F060","name":"DOMINO TILE HORIZONTAL-06-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF060"},127073:{"value":"1F061","name":"DOMINO TILE HORIZONTAL-06-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF061"},127074:{"value":"1F062","name":"DOMINO TILE VERTICAL BACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF062"},127075:{"value":"1F063","name":"DOMINO TILE VERTICAL-00-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF063"},127076:{"value":"1F064","name":"DOMINO TILE VERTICAL-00-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF064"},127077:{"value":"1F065","name":"DOMINO TILE VERTICAL-00-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF065"},127078:{"value":"1F066","name":"DOMINO TILE VERTICAL-00-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF066"},127079:{"value":"1F067","name":"DOMINO TILE VERTICAL-00-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF067"},127080:{"value":"1F068","name":"DOMINO TILE VERTICAL-00-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF068"},127081:{"value":"1F069","name":"DOMINO TILE VERTICAL-00-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF069"},127082:{"value":"1F06A","name":"DOMINO TILE VERTICAL-01-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06A"},127083:{"value":"1F06B","name":"DOMINO TILE VERTICAL-01-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06B"},127084:{"value":"1F06C","name":"DOMINO TILE VERTICAL-01-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06C"},127085:{"value":"1F06D","name":"DOMINO TILE VERTICAL-01-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06D"},127086:{"value":"1F06E","name":"DOMINO TILE VERTICAL-01-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06E"},127087:{"value":"1F06F","name":"DOMINO TILE VERTICAL-01-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF06F"},127088:{"value":"1F070","name":"DOMINO TILE VERTICAL-01-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF070"},127089:{"value":"1F071","name":"DOMINO TILE VERTICAL-02-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF071"},127090:{"value":"1F072","name":"DOMINO TILE VERTICAL-02-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF072"},127091:{"value":"1F073","name":"DOMINO TILE VERTICAL-02-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF073"},127092:{"value":"1F074","name":"DOMINO TILE VERTICAL-02-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF074"},127093:{"value":"1F075","name":"DOMINO TILE VERTICAL-02-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF075"},127094:{"value":"1F076","name":"DOMINO TILE VERTICAL-02-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF076"},127095:{"value":"1F077","name":"DOMINO TILE VERTICAL-02-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF077"},127096:{"value":"1F078","name":"DOMINO TILE VERTICAL-03-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF078"},127097:{"value":"1F079","name":"DOMINO TILE VERTICAL-03-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF079"},127098:{"value":"1F07A","name":"DOMINO TILE VERTICAL-03-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07A"},127099:{"value":"1F07B","name":"DOMINO TILE VERTICAL-03-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07B"},127100:{"value":"1F07C","name":"DOMINO TILE VERTICAL-03-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07C"},127101:{"value":"1F07D","name":"DOMINO TILE VERTICAL-03-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07D"},127102:{"value":"1F07E","name":"DOMINO TILE VERTICAL-03-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07E"},127103:{"value":"1F07F","name":"DOMINO TILE VERTICAL-04-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF07F"},127104:{"value":"1F080","name":"DOMINO TILE VERTICAL-04-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF080"},127105:{"value":"1F081","name":"DOMINO TILE VERTICAL-04-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF081"},127106:{"value":"1F082","name":"DOMINO TILE VERTICAL-04-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF082"},127107:{"value":"1F083","name":"DOMINO TILE VERTICAL-04-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF083"},127108:{"value":"1F084","name":"DOMINO TILE VERTICAL-04-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF084"},127109:{"value":"1F085","name":"DOMINO TILE VERTICAL-04-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF085"},127110:{"value":"1F086","name":"DOMINO TILE VERTICAL-05-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF086"},127111:{"value":"1F087","name":"DOMINO TILE VERTICAL-05-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF087"},127112:{"value":"1F088","name":"DOMINO TILE VERTICAL-05-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF088"},127113:{"value":"1F089","name":"DOMINO TILE VERTICAL-05-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF089"},127114:{"value":"1F08A","name":"DOMINO TILE VERTICAL-05-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08A"},127115:{"value":"1F08B","name":"DOMINO TILE VERTICAL-05-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08B"},127116:{"value":"1F08C","name":"DOMINO TILE VERTICAL-05-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08C"},127117:{"value":"1F08D","name":"DOMINO TILE VERTICAL-06-00","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08D"},127118:{"value":"1F08E","name":"DOMINO TILE VERTICAL-06-01","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08E"},127119:{"value":"1F08F","name":"DOMINO TILE VERTICAL-06-02","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF08F"},127120:{"value":"1F090","name":"DOMINO TILE VERTICAL-06-03","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF090"},127121:{"value":"1F091","name":"DOMINO TILE VERTICAL-06-04","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF091"},127122:{"value":"1F092","name":"DOMINO TILE VERTICAL-06-05","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF092"},127123:{"value":"1F093","name":"DOMINO TILE VERTICAL-06-06","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF093"},127136:{"value":"1F0A0","name":"PLAYING CARD BACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A0"},127137:{"value":"1F0A1","name":"PLAYING CARD ACE OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A1"},127138:{"value":"1F0A2","name":"PLAYING CARD TWO OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A2"},127139:{"value":"1F0A3","name":"PLAYING CARD THREE OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A3"},127140:{"value":"1F0A4","name":"PLAYING CARD FOUR OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A4"},127141:{"value":"1F0A5","name":"PLAYING CARD FIVE OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A5"},127142:{"value":"1F0A6","name":"PLAYING CARD SIX OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A6"},127143:{"value":"1F0A7","name":"PLAYING CARD SEVEN OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A7"},127144:{"value":"1F0A8","name":"PLAYING CARD EIGHT OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A8"},127145:{"value":"1F0A9","name":"PLAYING CARD NINE OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0A9"},127146:{"value":"1F0AA","name":"PLAYING CARD TEN OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0AA"},127147:{"value":"1F0AB","name":"PLAYING CARD JACK OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0AB"},127148:{"value":"1F0AC","name":"PLAYING CARD KNIGHT OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0AC"},127149:{"value":"1F0AD","name":"PLAYING CARD QUEEN OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0AD"},127150:{"value":"1F0AE","name":"PLAYING CARD KING OF SPADES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0AE"},127153:{"value":"1F0B1","name":"PLAYING CARD ACE OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B1"},127154:{"value":"1F0B2","name":"PLAYING CARD TWO OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B2"},127155:{"value":"1F0B3","name":"PLAYING CARD THREE OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B3"},127156:{"value":"1F0B4","name":"PLAYING CARD FOUR OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B4"},127157:{"value":"1F0B5","name":"PLAYING CARD FIVE OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B5"},127158:{"value":"1F0B6","name":"PLAYING CARD SIX OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B6"},127159:{"value":"1F0B7","name":"PLAYING CARD SEVEN OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B7"},127160:{"value":"1F0B8","name":"PLAYING CARD EIGHT OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B8"},127161:{"value":"1F0B9","name":"PLAYING CARD NINE OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0B9"},127162:{"value":"1F0BA","name":"PLAYING CARD TEN OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BA"},127163:{"value":"1F0BB","name":"PLAYING CARD JACK OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BB"},127164:{"value":"1F0BC","name":"PLAYING CARD KNIGHT OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BC"},127165:{"value":"1F0BD","name":"PLAYING CARD QUEEN OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BD"},127166:{"value":"1F0BE","name":"PLAYING CARD KING OF HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BE"},127167:{"value":"1F0BF","name":"PLAYING CARD RED JOKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0BF"},127169:{"value":"1F0C1","name":"PLAYING CARD ACE OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C1"},127170:{"value":"1F0C2","name":"PLAYING CARD TWO OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C2"},127171:{"value":"1F0C3","name":"PLAYING CARD THREE OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C3"},127172:{"value":"1F0C4","name":"PLAYING CARD FOUR OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C4"},127173:{"value":"1F0C5","name":"PLAYING CARD FIVE OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C5"},127174:{"value":"1F0C6","name":"PLAYING CARD SIX OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C6"},127175:{"value":"1F0C7","name":"PLAYING CARD SEVEN OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C7"},127176:{"value":"1F0C8","name":"PLAYING CARD EIGHT OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C8"},127177:{"value":"1F0C9","name":"PLAYING CARD NINE OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0C9"},127178:{"value":"1F0CA","name":"PLAYING CARD TEN OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CA"},127179:{"value":"1F0CB","name":"PLAYING CARD JACK OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CB"},127180:{"value":"1F0CC","name":"PLAYING CARD KNIGHT OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CC"},127181:{"value":"1F0CD","name":"PLAYING CARD QUEEN OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CD"},127182:{"value":"1F0CE","name":"PLAYING CARD KING OF DIAMONDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CE"},127183:{"value":"1F0CF","name":"PLAYING CARD BLACK JOKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0CF"},127185:{"value":"1F0D1","name":"PLAYING CARD ACE OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D1"},127186:{"value":"1F0D2","name":"PLAYING CARD TWO OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D2"},127187:{"value":"1F0D3","name":"PLAYING CARD THREE OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D3"},127188:{"value":"1F0D4","name":"PLAYING CARD FOUR OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D4"},127189:{"value":"1F0D5","name":"PLAYING CARD FIVE OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D5"},127190:{"value":"1F0D6","name":"PLAYING CARD SIX OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D6"},127191:{"value":"1F0D7","name":"PLAYING CARD SEVEN OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D7"},127192:{"value":"1F0D8","name":"PLAYING CARD EIGHT OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D8"},127193:{"value":"1F0D9","name":"PLAYING CARD NINE OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0D9"},127194:{"value":"1F0DA","name":"PLAYING CARD TEN OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DA"},127195:{"value":"1F0DB","name":"PLAYING CARD JACK OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DB"},127196:{"value":"1F0DC","name":"PLAYING CARD KNIGHT OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DC"},127197:{"value":"1F0DD","name":"PLAYING CARD QUEEN OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DD"},127198:{"value":"1F0DE","name":"PLAYING CARD KING OF CLUBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DE"},127199:{"value":"1F0DF","name":"PLAYING CARD WHITE JOKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0DF"},127200:{"value":"1F0E0","name":"PLAYING CARD FOOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E0"},127201:{"value":"1F0E1","name":"PLAYING CARD TRUMP-1","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E1"},127202:{"value":"1F0E2","name":"PLAYING CARD TRUMP-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E2"},127203:{"value":"1F0E3","name":"PLAYING CARD TRUMP-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E3"},127204:{"value":"1F0E4","name":"PLAYING CARD TRUMP-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E4"},127205:{"value":"1F0E5","name":"PLAYING CARD TRUMP-5","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E5"},127206:{"value":"1F0E6","name":"PLAYING CARD TRUMP-6","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E6"},127207:{"value":"1F0E7","name":"PLAYING CARD TRUMP-7","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E7"},127208:{"value":"1F0E8","name":"PLAYING CARD TRUMP-8","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E8"},127209:{"value":"1F0E9","name":"PLAYING CARD TRUMP-9","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0E9"},127210:{"value":"1F0EA","name":"PLAYING CARD TRUMP-10","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0EA"},127211:{"value":"1F0EB","name":"PLAYING CARD TRUMP-11","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0EB"},127212:{"value":"1F0EC","name":"PLAYING CARD TRUMP-12","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0EC"},127213:{"value":"1F0ED","name":"PLAYING CARD TRUMP-13","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0ED"},127214:{"value":"1F0EE","name":"PLAYING CARD TRUMP-14","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0EE"},127215:{"value":"1F0EF","name":"PLAYING CARD TRUMP-15","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0EF"},127216:{"value":"1F0F0","name":"PLAYING CARD TRUMP-16","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F0"},127217:{"value":"1F0F1","name":"PLAYING CARD TRUMP-17","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F1"},127218:{"value":"1F0F2","name":"PLAYING CARD TRUMP-18","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F2"},127219:{"value":"1F0F3","name":"PLAYING CARD TRUMP-19","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F3"},127220:{"value":"1F0F4","name":"PLAYING CARD TRUMP-20","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F4"},127221:{"value":"1F0F5","name":"PLAYING CARD TRUMP-21","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF0F5"},127248:{"value":"1F110","name":"PARENTHESIZED LATIN CAPITAL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0041 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF110"},127249:{"value":"1F111","name":"PARENTHESIZED LATIN CAPITAL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0042 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF111"},127250:{"value":"1F112","name":"PARENTHESIZED LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0043 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF112"},127251:{"value":"1F113","name":"PARENTHESIZED LATIN CAPITAL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0044 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF113"},127252:{"value":"1F114","name":"PARENTHESIZED LATIN CAPITAL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0045 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF114"},127253:{"value":"1F115","name":"PARENTHESIZED LATIN CAPITAL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0046 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF115"},127254:{"value":"1F116","name":"PARENTHESIZED LATIN CAPITAL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0047 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF116"},127255:{"value":"1F117","name":"PARENTHESIZED LATIN CAPITAL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0048 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF117"},127256:{"value":"1F118","name":"PARENTHESIZED LATIN CAPITAL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0049 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF118"},127257:{"value":"1F119","name":"PARENTHESIZED LATIN CAPITAL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004A 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF119"},127258:{"value":"1F11A","name":"PARENTHESIZED LATIN CAPITAL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004B 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11A"},127259:{"value":"1F11B","name":"PARENTHESIZED LATIN CAPITAL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004C 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11B"},127260:{"value":"1F11C","name":"PARENTHESIZED LATIN CAPITAL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004D 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11C"},127261:{"value":"1F11D","name":"PARENTHESIZED LATIN CAPITAL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004E 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11D"},127262:{"value":"1F11E","name":"PARENTHESIZED LATIN CAPITAL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 004F 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11E"},127263:{"value":"1F11F","name":"PARENTHESIZED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0050 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF11F"},127264:{"value":"1F120","name":"PARENTHESIZED LATIN CAPITAL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0051 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF120"},127265:{"value":"1F121","name":"PARENTHESIZED LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0052 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF121"},127266:{"value":"1F122","name":"PARENTHESIZED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0053 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF122"},127267:{"value":"1F123","name":"PARENTHESIZED LATIN CAPITAL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0054 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF123"},127268:{"value":"1F124","name":"PARENTHESIZED LATIN CAPITAL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0055 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF124"},127269:{"value":"1F125","name":"PARENTHESIZED LATIN CAPITAL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0056 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF125"},127270:{"value":"1F126","name":"PARENTHESIZED LATIN CAPITAL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0057 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF126"},127271:{"value":"1F127","name":"PARENTHESIZED LATIN CAPITAL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0058 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF127"},127272:{"value":"1F128","name":"PARENTHESIZED LATIN CAPITAL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 0059 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF128"},127273:{"value":"1F129","name":"PARENTHESIZED LATIN CAPITAL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 0028 005A 0029","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF129"},127274:{"value":"1F12A","name":"TORTOISE SHELL BRACKETED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 0053 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF12A"},127275:{"value":"1F12B","name":"CIRCLED ITALIC LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF12B"},127276:{"value":"1F12C","name":"CIRCLED ITALIC LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0052","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF12C"},127277:{"value":"1F12D","name":"CIRCLED CD","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0043 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF12D"},127278:{"value":"1F12E","name":"CIRCLED WZ","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 0057 005A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF12E"},127280:{"value":"1F130","name":"SQUARED LATIN CAPITAL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0041","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF130"},127281:{"value":"1F131","name":"SQUARED LATIN CAPITAL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0042","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF131"},127282:{"value":"1F132","name":"SQUARED LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF132"},127283:{"value":"1F133","name":"SQUARED LATIN CAPITAL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF133"},127284:{"value":"1F134","name":"SQUARED LATIN CAPITAL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0045","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF134"},127285:{"value":"1F135","name":"SQUARED LATIN CAPITAL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0046","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF135"},127286:{"value":"1F136","name":"SQUARED LATIN CAPITAL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0047","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF136"},127287:{"value":"1F137","name":"SQUARED LATIN CAPITAL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0048","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF137"},127288:{"value":"1F138","name":"SQUARED LATIN CAPITAL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0049","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF138"},127289:{"value":"1F139","name":"SQUARED LATIN CAPITAL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF139"},127290:{"value":"1F13A","name":"SQUARED LATIN CAPITAL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13A"},127291:{"value":"1F13B","name":"SQUARED LATIN CAPITAL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13B"},127292:{"value":"1F13C","name":"SQUARED LATIN CAPITAL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13C"},127293:{"value":"1F13D","name":"SQUARED LATIN CAPITAL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004E","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13D"},127294:{"value":"1F13E","name":"SQUARED LATIN CAPITAL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13E"},127295:{"value":"1F13F","name":"SQUARED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF13F"},127296:{"value":"1F140","name":"SQUARED LATIN CAPITAL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0051","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF140"},127297:{"value":"1F141","name":"SQUARED LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0052","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF141"},127298:{"value":"1F142","name":"SQUARED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0053","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF142"},127299:{"value":"1F143","name":"SQUARED LATIN CAPITAL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0054","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF143"},127300:{"value":"1F144","name":"SQUARED LATIN CAPITAL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0055","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF144"},127301:{"value":"1F145","name":"SQUARED LATIN CAPITAL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF145"},127302:{"value":"1F146","name":"SQUARED LATIN CAPITAL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0057","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF146"},127303:{"value":"1F147","name":"SQUARED LATIN CAPITAL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0058","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF147"},127304:{"value":"1F148","name":"SQUARED LATIN CAPITAL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0059","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF148"},127305:{"value":"1F149","name":"SQUARED LATIN CAPITAL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 005A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF149"},127306:{"value":"1F14A","name":"SQUARED HV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0048 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14A"},127307:{"value":"1F14B","name":"SQUARED MV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 004D 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14B"},127308:{"value":"1F14C","name":"SQUARED SD","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0053 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14C"},127309:{"value":"1F14D","name":"SQUARED SS","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0053 0053","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14D"},127310:{"value":"1F14E","name":"SQUARED PPV","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0050 0050 0056","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14E"},127311:{"value":"1F14F","name":"SQUARED WC","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0057 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF14F"},127312:{"value":"1F150","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF150"},127313:{"value":"1F151","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF151"},127314:{"value":"1F152","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF152"},127315:{"value":"1F153","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF153"},127316:{"value":"1F154","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF154"},127317:{"value":"1F155","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF155"},127318:{"value":"1F156","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF156"},127319:{"value":"1F157","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF157"},127320:{"value":"1F158","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF158"},127321:{"value":"1F159","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF159"},127322:{"value":"1F15A","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15A"},127323:{"value":"1F15B","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15B"},127324:{"value":"1F15C","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15C"},127325:{"value":"1F15D","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15D"},127326:{"value":"1F15E","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15E"},127327:{"value":"1F15F","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF15F"},127328:{"value":"1F160","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF160"},127329:{"value":"1F161","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF161"},127330:{"value":"1F162","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF162"},127331:{"value":"1F163","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF163"},127332:{"value":"1F164","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF164"},127333:{"value":"1F165","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF165"},127334:{"value":"1F166","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF166"},127335:{"value":"1F167","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF167"},127336:{"value":"1F168","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF168"},127337:{"value":"1F169","name":"NEGATIVE CIRCLED LATIN CAPITAL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF169"},127338:{"value":"1F16A","name":"RAISED MC SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<super> 004D 0043","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF16A"},127339:{"value":"1F16B","name":"RAISED MD SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"<super> 004D 0044","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF16B"},127344:{"value":"1F170","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF170"},127345:{"value":"1F171","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF171"},127346:{"value":"1F172","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF172"},127347:{"value":"1F173","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF173"},127348:{"value":"1F174","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF174"},127349:{"value":"1F175","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF175"},127350:{"value":"1F176","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF176"},127351:{"value":"1F177","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF177"},127352:{"value":"1F178","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF178"},127353:{"value":"1F179","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF179"},127354:{"value":"1F17A","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17A"},127355:{"value":"1F17B","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17B"},127356:{"value":"1F17C","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17C"},127357:{"value":"1F17D","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17D"},127358:{"value":"1F17E","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17E"},127359:{"value":"1F17F","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF17F"},127360:{"value":"1F180","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF180"},127361:{"value":"1F181","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF181"},127362:{"value":"1F182","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF182"},127363:{"value":"1F183","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF183"},127364:{"value":"1F184","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF184"},127365:{"value":"1F185","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF185"},127366:{"value":"1F186","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF186"},127367:{"value":"1F187","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF187"},127368:{"value":"1F188","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF188"},127369:{"value":"1F189","name":"NEGATIVE SQUARED LATIN CAPITAL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF189"},127370:{"value":"1F18A","name":"CROSSED NEGATIVE SQUARED LATIN CAPITAL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18A"},127371:{"value":"1F18B","name":"NEGATIVE SQUARED IC","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18B"},127372:{"value":"1F18C","name":"NEGATIVE SQUARED PA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18C"},127373:{"value":"1F18D","name":"NEGATIVE SQUARED SA","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18D"},127374:{"value":"1F18E","name":"NEGATIVE SQUARED AB","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18E"},127375:{"value":"1F18F","name":"NEGATIVE SQUARED WC","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF18F"},127376:{"value":"1F190","name":"SQUARE DJ","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 0044 004A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF190"},127377:{"value":"1F191","name":"SQUARED CL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF191"},127378:{"value":"1F192","name":"SQUARED COOL","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF192"},127379:{"value":"1F193","name":"SQUARED FREE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF193"},127380:{"value":"1F194","name":"SQUARED ID","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF194"},127381:{"value":"1F195","name":"SQUARED NEW","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF195"},127382:{"value":"1F196","name":"SQUARED NG","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF196"},127383:{"value":"1F197","name":"SQUARED OK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF197"},127384:{"value":"1F198","name":"SQUARED SOS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF198"},127385:{"value":"1F199","name":"SQUARED UP WITH EXCLAMATION MARK","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF199"},127386:{"value":"1F19A","name":"SQUARED VS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19A"},127387:{"value":"1F19B","name":"SQUARED THREE D","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19B"},127388:{"value":"1F19C","name":"SQUARED SECOND SCREEN","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19C"},127389:{"value":"1F19D","name":"SQUARED TWO K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19D"},127390:{"value":"1F19E","name":"SQUARED FOUR K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19E"},127391:{"value":"1F19F","name":"SQUARED EIGHT K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF19F"},127392:{"value":"1F1A0","name":"SQUARED FIVE POINT ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A0"},127393:{"value":"1F1A1","name":"SQUARED SEVEN POINT ONE","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A1"},127394:{"value":"1F1A2","name":"SQUARED TWENTY-TWO POINT TWO","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A2"},127395:{"value":"1F1A3","name":"SQUARED SIXTY P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A3"},127396:{"value":"1F1A4","name":"SQUARED ONE HUNDRED TWENTY P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A4"},127397:{"value":"1F1A5","name":"SQUARED LATIN SMALL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A5"},127398:{"value":"1F1A6","name":"SQUARED HC","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A6"},127399:{"value":"1F1A7","name":"SQUARED HDR","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A7"},127400:{"value":"1F1A8","name":"SQUARED HI-RES","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A8"},127401:{"value":"1F1A9","name":"SQUARED LOSSLESS","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1A9"},127402:{"value":"1F1AA","name":"SQUARED SHV","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1AA"},127403:{"value":"1F1AB","name":"SQUARED UHD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1AB"},127404:{"value":"1F1AC","name":"SQUARED VOD","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1AC"},127462:{"value":"1F1E6","name":"REGIONAL INDICATOR SYMBOL LETTER A","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1E6"},127463:{"value":"1F1E7","name":"REGIONAL INDICATOR SYMBOL LETTER B","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1E7"},127464:{"value":"1F1E8","name":"REGIONAL INDICATOR SYMBOL LETTER C","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1E8"},127465:{"value":"1F1E9","name":"REGIONAL INDICATOR SYMBOL LETTER D","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1E9"},127466:{"value":"1F1EA","name":"REGIONAL INDICATOR SYMBOL LETTER E","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1EA"},127467:{"value":"1F1EB","name":"REGIONAL INDICATOR SYMBOL LETTER F","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1EB"},127468:{"value":"1F1EC","name":"REGIONAL INDICATOR SYMBOL LETTER G","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1EC"},127469:{"value":"1F1ED","name":"REGIONAL INDICATOR SYMBOL LETTER H","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1ED"},127470:{"value":"1F1EE","name":"REGIONAL INDICATOR SYMBOL LETTER I","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1EE"},127471:{"value":"1F1EF","name":"REGIONAL INDICATOR SYMBOL LETTER J","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1EF"},127472:{"value":"1F1F0","name":"REGIONAL INDICATOR SYMBOL LETTER K","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F0"},127473:{"value":"1F1F1","name":"REGIONAL INDICATOR SYMBOL LETTER L","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F1"},127474:{"value":"1F1F2","name":"REGIONAL INDICATOR SYMBOL LETTER M","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F2"},127475:{"value":"1F1F3","name":"REGIONAL INDICATOR SYMBOL LETTER N","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F3"},127476:{"value":"1F1F4","name":"REGIONAL INDICATOR SYMBOL LETTER O","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F4"},127477:{"value":"1F1F5","name":"REGIONAL INDICATOR SYMBOL LETTER P","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F5"},127478:{"value":"1F1F6","name":"REGIONAL INDICATOR SYMBOL LETTER Q","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F6"},127479:{"value":"1F1F7","name":"REGIONAL INDICATOR SYMBOL LETTER R","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F7"},127480:{"value":"1F1F8","name":"REGIONAL INDICATOR SYMBOL LETTER S","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F8"},127481:{"value":"1F1F9","name":"REGIONAL INDICATOR SYMBOL LETTER T","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1F9"},127482:{"value":"1F1FA","name":"REGIONAL INDICATOR SYMBOL LETTER U","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FA"},127483:{"value":"1F1FB","name":"REGIONAL INDICATOR SYMBOL LETTER V","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FB"},127484:{"value":"1F1FC","name":"REGIONAL INDICATOR SYMBOL LETTER W","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FC"},127485:{"value":"1F1FD","name":"REGIONAL INDICATOR SYMBOL LETTER X","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FD"},127486:{"value":"1F1FE","name":"REGIONAL INDICATOR SYMBOL LETTER Y","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FE"},127487:{"value":"1F1FF","name":"REGIONAL INDICATOR SYMBOL LETTER Z","category":"So","class":"0","bidirectional_category":"L","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF1FF"},127488:{"value":"1F200","name":"SQUARE HIRAGANA HOKA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 307B 304B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF200"},127489:{"value":"1F201","name":"SQUARED KATAKANA KOKO","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B3 30B3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF201"},127490:{"value":"1F202","name":"SQUARED KATAKANA SA","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30B5","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF202"},127504:{"value":"1F210","name":"SQUARED CJK UNIFIED IDEOGRAPH-624B","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 624B","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF210"},127505:{"value":"1F211","name":"SQUARED CJK UNIFIED IDEOGRAPH-5B57","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5B57","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF211"},127506:{"value":"1F212","name":"SQUARED CJK UNIFIED IDEOGRAPH-53CC","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 53CC","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF212"},127507:{"value":"1F213","name":"SQUARED KATAKANA DE","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 30C7","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF213"},127508:{"value":"1F214","name":"SQUARED CJK UNIFIED IDEOGRAPH-4E8C","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 4E8C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF214"},127509:{"value":"1F215","name":"SQUARED CJK UNIFIED IDEOGRAPH-591A","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 591A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF215"},127510:{"value":"1F216","name":"SQUARED CJK UNIFIED IDEOGRAPH-89E3","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 89E3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF216"},127511:{"value":"1F217","name":"SQUARED CJK UNIFIED IDEOGRAPH-5929","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5929","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF217"},127512:{"value":"1F218","name":"SQUARED CJK UNIFIED IDEOGRAPH-4EA4","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 4EA4","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF218"},127513:{"value":"1F219","name":"SQUARED CJK UNIFIED IDEOGRAPH-6620","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6620","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF219"},127514:{"value":"1F21A","name":"SQUARED CJK UNIFIED IDEOGRAPH-7121","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 7121","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21A"},127515:{"value":"1F21B","name":"SQUARED CJK UNIFIED IDEOGRAPH-6599","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6599","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21B"},127516:{"value":"1F21C","name":"SQUARED CJK UNIFIED IDEOGRAPH-524D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 524D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21C"},127517:{"value":"1F21D","name":"SQUARED CJK UNIFIED IDEOGRAPH-5F8C","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5F8C","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21D"},127518:{"value":"1F21E","name":"SQUARED CJK UNIFIED IDEOGRAPH-518D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 518D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21E"},127519:{"value":"1F21F","name":"SQUARED CJK UNIFIED IDEOGRAPH-65B0","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 65B0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF21F"},127520:{"value":"1F220","name":"SQUARED CJK UNIFIED IDEOGRAPH-521D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 521D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF220"},127521:{"value":"1F221","name":"SQUARED CJK UNIFIED IDEOGRAPH-7D42","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 7D42","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF221"},127522:{"value":"1F222","name":"SQUARED CJK UNIFIED IDEOGRAPH-751F","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 751F","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF222"},127523:{"value":"1F223","name":"SQUARED CJK UNIFIED IDEOGRAPH-8CA9","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 8CA9","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF223"},127524:{"value":"1F224","name":"SQUARED CJK UNIFIED IDEOGRAPH-58F0","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 58F0","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF224"},127525:{"value":"1F225","name":"SQUARED CJK UNIFIED IDEOGRAPH-5439","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5439","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF225"},127526:{"value":"1F226","name":"SQUARED CJK UNIFIED IDEOGRAPH-6F14","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6F14","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF226"},127527:{"value":"1F227","name":"SQUARED CJK UNIFIED IDEOGRAPH-6295","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6295","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF227"},127528:{"value":"1F228","name":"SQUARED CJK UNIFIED IDEOGRAPH-6355","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6355","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF228"},127529:{"value":"1F229","name":"SQUARED CJK UNIFIED IDEOGRAPH-4E00","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 4E00","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF229"},127530:{"value":"1F22A","name":"SQUARED CJK UNIFIED IDEOGRAPH-4E09","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 4E09","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22A"},127531:{"value":"1F22B","name":"SQUARED CJK UNIFIED IDEOGRAPH-904A","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 904A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22B"},127532:{"value":"1F22C","name":"SQUARED CJK UNIFIED IDEOGRAPH-5DE6","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5DE6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22C"},127533:{"value":"1F22D","name":"SQUARED CJK UNIFIED IDEOGRAPH-4E2D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 4E2D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22D"},127534:{"value":"1F22E","name":"SQUARED CJK UNIFIED IDEOGRAPH-53F3","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 53F3","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22E"},127535:{"value":"1F22F","name":"SQUARED CJK UNIFIED IDEOGRAPH-6307","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6307","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF22F"},127536:{"value":"1F230","name":"SQUARED CJK UNIFIED IDEOGRAPH-8D70","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 8D70","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF230"},127537:{"value":"1F231","name":"SQUARED CJK UNIFIED IDEOGRAPH-6253","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6253","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF231"},127538:{"value":"1F232","name":"SQUARED CJK UNIFIED IDEOGRAPH-7981","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 7981","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF232"},127539:{"value":"1F233","name":"SQUARED CJK UNIFIED IDEOGRAPH-7A7A","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 7A7A","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF233"},127540:{"value":"1F234","name":"SQUARED CJK UNIFIED IDEOGRAPH-5408","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5408","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF234"},127541:{"value":"1F235","name":"SQUARED CJK UNIFIED IDEOGRAPH-6E80","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6E80","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF235"},127542:{"value":"1F236","name":"SQUARED CJK UNIFIED IDEOGRAPH-6709","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6709","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF236"},127543:{"value":"1F237","name":"SQUARED CJK UNIFIED IDEOGRAPH-6708","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 6708","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF237"},127544:{"value":"1F238","name":"SQUARED CJK UNIFIED IDEOGRAPH-7533","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 7533","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF238"},127545:{"value":"1F239","name":"SQUARED CJK UNIFIED IDEOGRAPH-5272","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 5272","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF239"},127546:{"value":"1F23A","name":"SQUARED CJK UNIFIED IDEOGRAPH-55B6","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 55B6","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF23A"},127547:{"value":"1F23B","name":"SQUARED CJK UNIFIED IDEOGRAPH-914D","category":"So","class":"0","bidirectional_category":"L","mapping":"<square> 914D","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF23B"},127552:{"value":"1F240","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-672C","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 672C 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF240"},127553:{"value":"1F241","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-4E09","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 4E09 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF241"},127554:{"value":"1F242","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-4E8C","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 4E8C 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF242"},127555:{"value":"1F243","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-5B89","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 5B89 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF243"},127556:{"value":"1F244","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-70B9","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 70B9 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF244"},127557:{"value":"1F245","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-6253","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 6253 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF245"},127558:{"value":"1F246","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-76D7","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 76D7 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF246"},127559:{"value":"1F247","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-52DD","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 52DD 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF247"},127560:{"value":"1F248","name":"TORTOISE SHELL BRACKETED CJK UNIFIED IDEOGRAPH-6557","category":"So","class":"0","bidirectional_category":"L","mapping":"<compat> 3014 6557 3015","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF248"},127568:{"value":"1F250","name":"CIRCLED IDEOGRAPH ADVANTAGE","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 5F97","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF250"},127569:{"value":"1F251","name":"CIRCLED IDEOGRAPH ACCEPT","category":"So","class":"0","bidirectional_category":"L","mapping":"<circle> 53EF","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF251"},127584:{"value":"1F260","name":"ROUNDED SYMBOL FOR FU","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF260"},127585:{"value":"1F261","name":"ROUNDED SYMBOL FOR LU","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF261"},127586:{"value":"1F262","name":"ROUNDED SYMBOL FOR SHOU","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF262"},127587:{"value":"1F263","name":"ROUNDED SYMBOL FOR XI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF263"},127588:{"value":"1F264","name":"ROUNDED SYMBOL FOR SHUANGXI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF264"},127589:{"value":"1F265","name":"ROUNDED SYMBOL FOR CAI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF265"},127744:{"value":"1F300","name":"CYCLONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF300"},127745:{"value":"1F301","name":"FOGGY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF301"},127746:{"value":"1F302","name":"CLOSED UMBRELLA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF302"},127747:{"value":"1F303","name":"NIGHT WITH STARS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF303"},127748:{"value":"1F304","name":"SUNRISE OVER MOUNTAINS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF304"},127749:{"value":"1F305","name":"SUNRISE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF305"},127750:{"value":"1F306","name":"CITYSCAPE AT DUSK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF306"},127751:{"value":"1F307","name":"SUNSET OVER BUILDINGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF307"},127752:{"value":"1F308","name":"RAINBOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF308"},127753:{"value":"1F309","name":"BRIDGE AT NIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF309"},127754:{"value":"1F30A","name":"WATER WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30A"},127755:{"value":"1F30B","name":"VOLCANO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30B"},127756:{"value":"1F30C","name":"MILKY WAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30C"},127757:{"value":"1F30D","name":"EARTH GLOBE EUROPE-AFRICA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30D"},127758:{"value":"1F30E","name":"EARTH GLOBE AMERICAS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30E"},127759:{"value":"1F30F","name":"EARTH GLOBE ASIA-AUSTRALIA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF30F"},127760:{"value":"1F310","name":"GLOBE WITH MERIDIANS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF310"},127761:{"value":"1F311","name":"NEW MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF311"},127762:{"value":"1F312","name":"WAXING CRESCENT MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF312"},127763:{"value":"1F313","name":"FIRST QUARTER MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF313"},127764:{"value":"1F314","name":"WAXING GIBBOUS MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF314"},127765:{"value":"1F315","name":"FULL MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF315"},127766:{"value":"1F316","name":"WANING GIBBOUS MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF316"},127767:{"value":"1F317","name":"LAST QUARTER MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF317"},127768:{"value":"1F318","name":"WANING CRESCENT MOON SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF318"},127769:{"value":"1F319","name":"CRESCENT MOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF319"},127770:{"value":"1F31A","name":"NEW MOON WITH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31A"},127771:{"value":"1F31B","name":"FIRST QUARTER MOON WITH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31B"},127772:{"value":"1F31C","name":"LAST QUARTER MOON WITH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31C"},127773:{"value":"1F31D","name":"FULL MOON WITH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31D"},127774:{"value":"1F31E","name":"SUN WITH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31E"},127775:{"value":"1F31F","name":"GLOWING STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF31F"},127776:{"value":"1F320","name":"SHOOTING STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF320"},127777:{"value":"1F321","name":"THERMOMETER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF321"},127778:{"value":"1F322","name":"BLACK DROPLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF322"},127779:{"value":"1F323","name":"WHITE SUN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF323"},127780:{"value":"1F324","name":"WHITE SUN WITH SMALL CLOUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF324"},127781:{"value":"1F325","name":"WHITE SUN BEHIND CLOUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF325"},127782:{"value":"1F326","name":"WHITE SUN BEHIND CLOUD WITH RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF326"},127783:{"value":"1F327","name":"CLOUD WITH RAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF327"},127784:{"value":"1F328","name":"CLOUD WITH SNOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF328"},127785:{"value":"1F329","name":"CLOUD WITH LIGHTNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF329"},127786:{"value":"1F32A","name":"CLOUD WITH TORNADO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32A"},127787:{"value":"1F32B","name":"FOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32B"},127788:{"value":"1F32C","name":"WIND BLOWING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32C"},127789:{"value":"1F32D","name":"HOT DOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32D"},127790:{"value":"1F32E","name":"TACO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32E"},127791:{"value":"1F32F","name":"BURRITO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF32F"},127792:{"value":"1F330","name":"CHESTNUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF330"},127793:{"value":"1F331","name":"SEEDLING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF331"},127794:{"value":"1F332","name":"EVERGREEN TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF332"},127795:{"value":"1F333","name":"DECIDUOUS TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF333"},127796:{"value":"1F334","name":"PALM TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF334"},127797:{"value":"1F335","name":"CACTUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF335"},127798:{"value":"1F336","name":"HOT PEPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF336"},127799:{"value":"1F337","name":"TULIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF337"},127800:{"value":"1F338","name":"CHERRY BLOSSOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF338"},127801:{"value":"1F339","name":"ROSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF339"},127802:{"value":"1F33A","name":"HIBISCUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33A"},127803:{"value":"1F33B","name":"SUNFLOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33B"},127804:{"value":"1F33C","name":"BLOSSOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33C"},127805:{"value":"1F33D","name":"EAR OF MAIZE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33D"},127806:{"value":"1F33E","name":"EAR OF RICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33E"},127807:{"value":"1F33F","name":"HERB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF33F"},127808:{"value":"1F340","name":"FOUR LEAF CLOVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF340"},127809:{"value":"1F341","name":"MAPLE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF341"},127810:{"value":"1F342","name":"FALLEN LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF342"},127811:{"value":"1F343","name":"LEAF FLUTTERING IN WIND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF343"},127812:{"value":"1F344","name":"MUSHROOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF344"},127813:{"value":"1F345","name":"TOMATO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF345"},127814:{"value":"1F346","name":"AUBERGINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF346"},127815:{"value":"1F347","name":"GRAPES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF347"},127816:{"value":"1F348","name":"MELON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF348"},127817:{"value":"1F349","name":"WATERMELON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF349"},127818:{"value":"1F34A","name":"TANGERINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34A"},127819:{"value":"1F34B","name":"LEMON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34B"},127820:{"value":"1F34C","name":"BANANA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34C"},127821:{"value":"1F34D","name":"PINEAPPLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34D"},127822:{"value":"1F34E","name":"RED APPLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34E"},127823:{"value":"1F34F","name":"GREEN APPLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF34F"},127824:{"value":"1F350","name":"PEAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF350"},127825:{"value":"1F351","name":"PEACH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF351"},127826:{"value":"1F352","name":"CHERRIES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF352"},127827:{"value":"1F353","name":"STRAWBERRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF353"},127828:{"value":"1F354","name":"HAMBURGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF354"},127829:{"value":"1F355","name":"SLICE OF PIZZA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF355"},127830:{"value":"1F356","name":"MEAT ON BONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF356"},127831:{"value":"1F357","name":"POULTRY LEG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF357"},127832:{"value":"1F358","name":"RICE CRACKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF358"},127833:{"value":"1F359","name":"RICE BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF359"},127834:{"value":"1F35A","name":"COOKED RICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35A"},127835:{"value":"1F35B","name":"CURRY AND RICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35B"},127836:{"value":"1F35C","name":"STEAMING BOWL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35C"},127837:{"value":"1F35D","name":"SPAGHETTI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35D"},127838:{"value":"1F35E","name":"BREAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35E"},127839:{"value":"1F35F","name":"FRENCH FRIES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF35F"},127840:{"value":"1F360","name":"ROASTED SWEET POTATO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF360"},127841:{"value":"1F361","name":"DANGO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF361"},127842:{"value":"1F362","name":"ODEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF362"},127843:{"value":"1F363","name":"SUSHI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF363"},127844:{"value":"1F364","name":"FRIED SHRIMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF364"},127845:{"value":"1F365","name":"FISH CAKE WITH SWIRL DESIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF365"},127846:{"value":"1F366","name":"SOFT ICE CREAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF366"},127847:{"value":"1F367","name":"SHAVED ICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF367"},127848:{"value":"1F368","name":"ICE CREAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF368"},127849:{"value":"1F369","name":"DOUGHNUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF369"},127850:{"value":"1F36A","name":"COOKIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36A"},127851:{"value":"1F36B","name":"CHOCOLATE BAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36B"},127852:{"value":"1F36C","name":"CANDY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36C"},127853:{"value":"1F36D","name":"LOLLIPOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36D"},127854:{"value":"1F36E","name":"CUSTARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36E"},127855:{"value":"1F36F","name":"HONEY POT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF36F"},127856:{"value":"1F370","name":"SHORTCAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF370"},127857:{"value":"1F371","name":"BENTO BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF371"},127858:{"value":"1F372","name":"POT OF FOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF372"},127859:{"value":"1F373","name":"COOKING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF373"},127860:{"value":"1F374","name":"FORK AND KNIFE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF374"},127861:{"value":"1F375","name":"TEACUP WITHOUT HANDLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF375"},127862:{"value":"1F376","name":"SAKE BOTTLE AND CUP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF376"},127863:{"value":"1F377","name":"WINE GLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF377"},127864:{"value":"1F378","name":"COCKTAIL GLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF378"},127865:{"value":"1F379","name":"TROPICAL DRINK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF379"},127866:{"value":"1F37A","name":"BEER MUG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37A"},127867:{"value":"1F37B","name":"CLINKING BEER MUGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37B"},127868:{"value":"1F37C","name":"BABY BOTTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37C"},127869:{"value":"1F37D","name":"FORK AND KNIFE WITH PLATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37D"},127870:{"value":"1F37E","name":"BOTTLE WITH POPPING CORK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37E"},127871:{"value":"1F37F","name":"POPCORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF37F"},127872:{"value":"1F380","name":"RIBBON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF380"},127873:{"value":"1F381","name":"WRAPPED PRESENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF381"},127874:{"value":"1F382","name":"BIRTHDAY CAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF382"},127875:{"value":"1F383","name":"JACK-O-LANTERN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF383"},127876:{"value":"1F384","name":"CHRISTMAS TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF384"},127877:{"value":"1F385","name":"FATHER CHRISTMAS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF385"},127878:{"value":"1F386","name":"FIREWORKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF386"},127879:{"value":"1F387","name":"FIREWORK SPARKLER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF387"},127880:{"value":"1F388","name":"BALLOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF388"},127881:{"value":"1F389","name":"PARTY POPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF389"},127882:{"value":"1F38A","name":"CONFETTI BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38A"},127883:{"value":"1F38B","name":"TANABATA TREE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38B"},127884:{"value":"1F38C","name":"CROSSED FLAGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38C"},127885:{"value":"1F38D","name":"PINE DECORATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38D"},127886:{"value":"1F38E","name":"JAPANESE DOLLS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38E"},127887:{"value":"1F38F","name":"CARP STREAMER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF38F"},127888:{"value":"1F390","name":"WIND CHIME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF390"},127889:{"value":"1F391","name":"MOON VIEWING CEREMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF391"},127890:{"value":"1F392","name":"SCHOOL SATCHEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF392"},127891:{"value":"1F393","name":"GRADUATION CAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF393"},127892:{"value":"1F394","name":"HEART WITH TIP ON THE LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF394"},127893:{"value":"1F395","name":"BOUQUET OF FLOWERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF395"},127894:{"value":"1F396","name":"MILITARY MEDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF396"},127895:{"value":"1F397","name":"REMINDER RIBBON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF397"},127896:{"value":"1F398","name":"MUSICAL KEYBOARD WITH JACKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF398"},127897:{"value":"1F399","name":"STUDIO MICROPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF399"},127898:{"value":"1F39A","name":"LEVEL SLIDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39A"},127899:{"value":"1F39B","name":"CONTROL KNOBS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39B"},127900:{"value":"1F39C","name":"BEAMED ASCENDING MUSICAL NOTES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39C"},127901:{"value":"1F39D","name":"BEAMED DESCENDING MUSICAL NOTES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39D"},127902:{"value":"1F39E","name":"FILM FRAMES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39E"},127903:{"value":"1F39F","name":"ADMISSION TICKETS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF39F"},127904:{"value":"1F3A0","name":"CAROUSEL HORSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A0"},127905:{"value":"1F3A1","name":"FERRIS WHEEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A1"},127906:{"value":"1F3A2","name":"ROLLER COASTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A2"},127907:{"value":"1F3A3","name":"FISHING POLE AND FISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A3"},127908:{"value":"1F3A4","name":"MICROPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A4"},127909:{"value":"1F3A5","name":"MOVIE CAMERA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A5"},127910:{"value":"1F3A6","name":"CINEMA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A6"},127911:{"value":"1F3A7","name":"HEADPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A7"},127912:{"value":"1F3A8","name":"ARTIST PALETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A8"},127913:{"value":"1F3A9","name":"TOP HAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3A9"},127914:{"value":"1F3AA","name":"CIRCUS TENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AA"},127915:{"value":"1F3AB","name":"TICKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AB"},127916:{"value":"1F3AC","name":"CLAPPER BOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AC"},127917:{"value":"1F3AD","name":"PERFORMING ARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AD"},127918:{"value":"1F3AE","name":"VIDEO GAME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AE"},127919:{"value":"1F3AF","name":"DIRECT HIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3AF"},127920:{"value":"1F3B0","name":"SLOT MACHINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B0"},127921:{"value":"1F3B1","name":"BILLIARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B1"},127922:{"value":"1F3B2","name":"GAME DIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B2"},127923:{"value":"1F3B3","name":"BOWLING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B3"},127924:{"value":"1F3B4","name":"FLOWER PLAYING CARDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B4"},127925:{"value":"1F3B5","name":"MUSICAL NOTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B5"},127926:{"value":"1F3B6","name":"MULTIPLE MUSICAL NOTES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B6"},127927:{"value":"1F3B7","name":"SAXOPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B7"},127928:{"value":"1F3B8","name":"GUITAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B8"},127929:{"value":"1F3B9","name":"MUSICAL KEYBOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3B9"},127930:{"value":"1F3BA","name":"TRUMPET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BA"},127931:{"value":"1F3BB","name":"VIOLIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BB"},127932:{"value":"1F3BC","name":"MUSICAL SCORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BC"},127933:{"value":"1F3BD","name":"RUNNING SHIRT WITH SASH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BD"},127934:{"value":"1F3BE","name":"TENNIS RACQUET AND BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BE"},127935:{"value":"1F3BF","name":"SKI AND SKI BOOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3BF"},127936:{"value":"1F3C0","name":"BASKETBALL AND HOOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C0"},127937:{"value":"1F3C1","name":"CHEQUERED FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C1"},127938:{"value":"1F3C2","name":"SNOWBOARDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C2"},127939:{"value":"1F3C3","name":"RUNNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C3"},127940:{"value":"1F3C4","name":"SURFER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C4"},127941:{"value":"1F3C5","name":"SPORTS MEDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C5"},127942:{"value":"1F3C6","name":"TROPHY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C6"},127943:{"value":"1F3C7","name":"HORSE RACING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C7"},127944:{"value":"1F3C8","name":"AMERICAN FOOTBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C8"},127945:{"value":"1F3C9","name":"RUGBY FOOTBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3C9"},127946:{"value":"1F3CA","name":"SWIMMER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CA"},127947:{"value":"1F3CB","name":"WEIGHT LIFTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CB"},127948:{"value":"1F3CC","name":"GOLFER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CC"},127949:{"value":"1F3CD","name":"RACING MOTORCYCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CD"},127950:{"value":"1F3CE","name":"RACING CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CE"},127951:{"value":"1F3CF","name":"CRICKET BAT AND BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3CF"},127952:{"value":"1F3D0","name":"VOLLEYBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D0"},127953:{"value":"1F3D1","name":"FIELD HOCKEY STICK AND BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D1"},127954:{"value":"1F3D2","name":"ICE HOCKEY STICK AND PUCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D2"},127955:{"value":"1F3D3","name":"TABLE TENNIS PADDLE AND BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D3"},127956:{"value":"1F3D4","name":"SNOW CAPPED MOUNTAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D4"},127957:{"value":"1F3D5","name":"CAMPING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D5"},127958:{"value":"1F3D6","name":"BEACH WITH UMBRELLA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D6"},127959:{"value":"1F3D7","name":"BUILDING CONSTRUCTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D7"},127960:{"value":"1F3D8","name":"HOUSE BUILDINGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D8"},127961:{"value":"1F3D9","name":"CITYSCAPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3D9"},127962:{"value":"1F3DA","name":"DERELICT HOUSE BUILDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DA"},127963:{"value":"1F3DB","name":"CLASSICAL BUILDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DB"},127964:{"value":"1F3DC","name":"DESERT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DC"},127965:{"value":"1F3DD","name":"DESERT ISLAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DD"},127966:{"value":"1F3DE","name":"NATIONAL PARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DE"},127967:{"value":"1F3DF","name":"STADIUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3DF"},127968:{"value":"1F3E0","name":"HOUSE BUILDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E0"},127969:{"value":"1F3E1","name":"HOUSE WITH GARDEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E1"},127970:{"value":"1F3E2","name":"OFFICE BUILDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E2"},127971:{"value":"1F3E3","name":"JAPANESE POST OFFICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E3"},127972:{"value":"1F3E4","name":"EUROPEAN POST OFFICE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E4"},127973:{"value":"1F3E5","name":"HOSPITAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E5"},127974:{"value":"1F3E6","name":"BANK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E6"},127975:{"value":"1F3E7","name":"AUTOMATED TELLER MACHINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E7"},127976:{"value":"1F3E8","name":"HOTEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E8"},127977:{"value":"1F3E9","name":"LOVE HOTEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3E9"},127978:{"value":"1F3EA","name":"CONVENIENCE STORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3EA"},127979:{"value":"1F3EB","name":"SCHOOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3EB"},127980:{"value":"1F3EC","name":"DEPARTMENT STORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3EC"},127981:{"value":"1F3ED","name":"FACTORY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3ED"},127982:{"value":"1F3EE","name":"IZAKAYA LANTERN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3EE"},127983:{"value":"1F3EF","name":"JAPANESE CASTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3EF"},127984:{"value":"1F3F0","name":"EUROPEAN CASTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F0"},127985:{"value":"1F3F1","name":"WHITE PENNANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F1"},127986:{"value":"1F3F2","name":"BLACK PENNANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F2"},127987:{"value":"1F3F3","name":"WAVING WHITE FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F3"},127988:{"value":"1F3F4","name":"WAVING BLACK FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F4"},127989:{"value":"1F3F5","name":"ROSETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F5"},127990:{"value":"1F3F6","name":"BLACK ROSETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F6"},127991:{"value":"1F3F7","name":"LABEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F7"},127992:{"value":"1F3F8","name":"BADMINTON RACQUET AND SHUTTLECOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F8"},127993:{"value":"1F3F9","name":"BOW AND ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3F9"},127994:{"value":"1F3FA","name":"AMPHORA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF3FA"},128000:{"value":"1F400","name":"RAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF400"},128001:{"value":"1F401","name":"MOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF401"},128002:{"value":"1F402","name":"OX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF402"},128003:{"value":"1F403","name":"WATER BUFFALO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF403"},128004:{"value":"1F404","name":"COW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF404"},128005:{"value":"1F405","name":"TIGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF405"},128006:{"value":"1F406","name":"LEOPARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF406"},128007:{"value":"1F407","name":"RABBIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF407"},128008:{"value":"1F408","name":"CAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF408"},128009:{"value":"1F409","name":"DRAGON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF409"},128010:{"value":"1F40A","name":"CROCODILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40A"},128011:{"value":"1F40B","name":"WHALE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40B"},128012:{"value":"1F40C","name":"SNAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40C"},128013:{"value":"1F40D","name":"SNAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40D"},128014:{"value":"1F40E","name":"HORSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40E"},128015:{"value":"1F40F","name":"RAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF40F"},128016:{"value":"1F410","name":"GOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF410"},128017:{"value":"1F411","name":"SHEEP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF411"},128018:{"value":"1F412","name":"MONKEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF412"},128019:{"value":"1F413","name":"ROOSTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF413"},128020:{"value":"1F414","name":"CHICKEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF414"},128021:{"value":"1F415","name":"DOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF415"},128022:{"value":"1F416","name":"PIG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF416"},128023:{"value":"1F417","name":"BOAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF417"},128024:{"value":"1F418","name":"ELEPHANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF418"},128025:{"value":"1F419","name":"OCTOPUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF419"},128026:{"value":"1F41A","name":"SPIRAL SHELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41A"},128027:{"value":"1F41B","name":"BUG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41B"},128028:{"value":"1F41C","name":"ANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41C"},128029:{"value":"1F41D","name":"HONEYBEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41D"},128030:{"value":"1F41E","name":"LADY BEETLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41E"},128031:{"value":"1F41F","name":"FISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF41F"},128032:{"value":"1F420","name":"TROPICAL FISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF420"},128033:{"value":"1F421","name":"BLOWFISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF421"},128034:{"value":"1F422","name":"TURTLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF422"},128035:{"value":"1F423","name":"HATCHING CHICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF423"},128036:{"value":"1F424","name":"BABY CHICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF424"},128037:{"value":"1F425","name":"FRONT-FACING BABY CHICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF425"},128038:{"value":"1F426","name":"BIRD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF426"},128039:{"value":"1F427","name":"PENGUIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF427"},128040:{"value":"1F428","name":"KOALA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF428"},128041:{"value":"1F429","name":"POODLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF429"},128042:{"value":"1F42A","name":"DROMEDARY CAMEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42A"},128043:{"value":"1F42B","name":"BACTRIAN CAMEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42B"},128044:{"value":"1F42C","name":"DOLPHIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42C"},128045:{"value":"1F42D","name":"MOUSE FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42D"},128046:{"value":"1F42E","name":"COW FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42E"},128047:{"value":"1F42F","name":"TIGER FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF42F"},128048:{"value":"1F430","name":"RABBIT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF430"},128049:{"value":"1F431","name":"CAT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF431"},128050:{"value":"1F432","name":"DRAGON FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF432"},128051:{"value":"1F433","name":"SPOUTING WHALE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF433"},128052:{"value":"1F434","name":"HORSE FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF434"},128053:{"value":"1F435","name":"MONKEY FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF435"},128054:{"value":"1F436","name":"DOG FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF436"},128055:{"value":"1F437","name":"PIG FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF437"},128056:{"value":"1F438","name":"FROG FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF438"},128057:{"value":"1F439","name":"HAMSTER FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF439"},128058:{"value":"1F43A","name":"WOLF FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43A"},128059:{"value":"1F43B","name":"BEAR FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43B"},128060:{"value":"1F43C","name":"PANDA FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43C"},128061:{"value":"1F43D","name":"PIG NOSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43D"},128062:{"value":"1F43E","name":"PAW PRINTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43E"},128063:{"value":"1F43F","name":"CHIPMUNK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF43F"},128064:{"value":"1F440","name":"EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF440"},128065:{"value":"1F441","name":"EYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF441"},128066:{"value":"1F442","name":"EAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF442"},128067:{"value":"1F443","name":"NOSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF443"},128068:{"value":"1F444","name":"MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF444"},128069:{"value":"1F445","name":"TONGUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF445"},128070:{"value":"1F446","name":"WHITE UP POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF446"},128071:{"value":"1F447","name":"WHITE DOWN POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF447"},128072:{"value":"1F448","name":"WHITE LEFT POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF448"},128073:{"value":"1F449","name":"WHITE RIGHT POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF449"},128074:{"value":"1F44A","name":"FISTED HAND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44A"},128075:{"value":"1F44B","name":"WAVING HAND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44B"},128076:{"value":"1F44C","name":"OK HAND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44C"},128077:{"value":"1F44D","name":"THUMBS UP SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44D"},128078:{"value":"1F44E","name":"THUMBS DOWN SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44E"},128079:{"value":"1F44F","name":"CLAPPING HANDS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF44F"},128080:{"value":"1F450","name":"OPEN HANDS SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF450"},128081:{"value":"1F451","name":"CROWN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF451"},128082:{"value":"1F452","name":"WOMANS HAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF452"},128083:{"value":"1F453","name":"EYEGLASSES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF453"},128084:{"value":"1F454","name":"NECKTIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF454"},128085:{"value":"1F455","name":"T-SHIRT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF455"},128086:{"value":"1F456","name":"JEANS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF456"},128087:{"value":"1F457","name":"DRESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF457"},128088:{"value":"1F458","name":"KIMONO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF458"},128089:{"value":"1F459","name":"BIKINI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF459"},128090:{"value":"1F45A","name":"WOMANS CLOTHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45A"},128091:{"value":"1F45B","name":"PURSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45B"},128092:{"value":"1F45C","name":"HANDBAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45C"},128093:{"value":"1F45D","name":"POUCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45D"},128094:{"value":"1F45E","name":"MANS SHOE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45E"},128095:{"value":"1F45F","name":"ATHLETIC SHOE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF45F"},128096:{"value":"1F460","name":"HIGH-HEELED SHOE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF460"},128097:{"value":"1F461","name":"WOMANS SANDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF461"},128098:{"value":"1F462","name":"WOMANS BOOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF462"},128099:{"value":"1F463","name":"FOOTPRINTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF463"},128100:{"value":"1F464","name":"BUST IN SILHOUETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF464"},128101:{"value":"1F465","name":"BUSTS IN SILHOUETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF465"},128102:{"value":"1F466","name":"BOY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF466"},128103:{"value":"1F467","name":"GIRL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF467"},128104:{"value":"1F468","name":"MAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF468"},128105:{"value":"1F469","name":"WOMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF469"},128106:{"value":"1F46A","name":"FAMILY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46A"},128107:{"value":"1F46B","name":"MAN AND WOMAN HOLDING HANDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46B"},128108:{"value":"1F46C","name":"TWO MEN HOLDING HANDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46C"},128109:{"value":"1F46D","name":"TWO WOMEN HOLDING HANDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46D"},128110:{"value":"1F46E","name":"POLICE OFFICER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46E"},128111:{"value":"1F46F","name":"WOMAN WITH BUNNY EARS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF46F"},128112:{"value":"1F470","name":"BRIDE WITH VEIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF470"},128113:{"value":"1F471","name":"PERSON WITH BLOND HAIR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF471"},128114:{"value":"1F472","name":"MAN WITH GUA PI MAO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF472"},128115:{"value":"1F473","name":"MAN WITH TURBAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF473"},128116:{"value":"1F474","name":"OLDER MAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF474"},128117:{"value":"1F475","name":"OLDER WOMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF475"},128118:{"value":"1F476","name":"BABY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF476"},128119:{"value":"1F477","name":"CONSTRUCTION WORKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF477"},128120:{"value":"1F478","name":"PRINCESS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF478"},128121:{"value":"1F479","name":"JAPANESE OGRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF479"},128122:{"value":"1F47A","name":"JAPANESE GOBLIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47A"},128123:{"value":"1F47B","name":"GHOST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47B"},128124:{"value":"1F47C","name":"BABY ANGEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47C"},128125:{"value":"1F47D","name":"EXTRATERRESTRIAL ALIEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47D"},128126:{"value":"1F47E","name":"ALIEN MONSTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47E"},128127:{"value":"1F47F","name":"IMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF47F"},128128:{"value":"1F480","name":"SKULL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF480"},128129:{"value":"1F481","name":"INFORMATION DESK PERSON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF481"},128130:{"value":"1F482","name":"GUARDSMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF482"},128131:{"value":"1F483","name":"DANCER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF483"},128132:{"value":"1F484","name":"LIPSTICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF484"},128133:{"value":"1F485","name":"NAIL POLISH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF485"},128134:{"value":"1F486","name":"FACE MASSAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF486"},128135:{"value":"1F487","name":"HAIRCUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF487"},128136:{"value":"1F488","name":"BARBER POLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF488"},128137:{"value":"1F489","name":"SYRINGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF489"},128138:{"value":"1F48A","name":"PILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48A"},128139:{"value":"1F48B","name":"KISS MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48B"},128140:{"value":"1F48C","name":"LOVE LETTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48C"},128141:{"value":"1F48D","name":"RING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48D"},128142:{"value":"1F48E","name":"GEM STONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48E"},128143:{"value":"1F48F","name":"KISS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF48F"},128144:{"value":"1F490","name":"BOUQUET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF490"},128145:{"value":"1F491","name":"COUPLE WITH HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF491"},128146:{"value":"1F492","name":"WEDDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF492"},128147:{"value":"1F493","name":"BEATING HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF493"},128148:{"value":"1F494","name":"BROKEN HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF494"},128149:{"value":"1F495","name":"TWO HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF495"},128150:{"value":"1F496","name":"SPARKLING HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF496"},128151:{"value":"1F497","name":"GROWING HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF497"},128152:{"value":"1F498","name":"HEART WITH ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF498"},128153:{"value":"1F499","name":"BLUE HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF499"},128154:{"value":"1F49A","name":"GREEN HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49A"},128155:{"value":"1F49B","name":"YELLOW HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49B"},128156:{"value":"1F49C","name":"PURPLE HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49C"},128157:{"value":"1F49D","name":"HEART WITH RIBBON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49D"},128158:{"value":"1F49E","name":"REVOLVING HEARTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49E"},128159:{"value":"1F49F","name":"HEART DECORATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF49F"},128160:{"value":"1F4A0","name":"DIAMOND SHAPE WITH A DOT INSIDE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A0"},128161:{"value":"1F4A1","name":"ELECTRIC LIGHT BULB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A1"},128162:{"value":"1F4A2","name":"ANGER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A2"},128163:{"value":"1F4A3","name":"BOMB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A3"},128164:{"value":"1F4A4","name":"SLEEPING SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A4"},128165:{"value":"1F4A5","name":"COLLISION SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A5"},128166:{"value":"1F4A6","name":"SPLASHING SWEAT SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A6"},128167:{"value":"1F4A7","name":"DROPLET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A7"},128168:{"value":"1F4A8","name":"DASH SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A8"},128169:{"value":"1F4A9","name":"PILE OF POO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4A9"},128170:{"value":"1F4AA","name":"FLEXED BICEPS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AA"},128171:{"value":"1F4AB","name":"DIZZY SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AB"},128172:{"value":"1F4AC","name":"SPEECH BALLOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AC"},128173:{"value":"1F4AD","name":"THOUGHT BALLOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AD"},128174:{"value":"1F4AE","name":"WHITE FLOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AE"},128175:{"value":"1F4AF","name":"HUNDRED POINTS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4AF"},128176:{"value":"1F4B0","name":"MONEY BAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B0"},128177:{"value":"1F4B1","name":"CURRENCY EXCHANGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B1"},128178:{"value":"1F4B2","name":"HEAVY DOLLAR SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B2"},128179:{"value":"1F4B3","name":"CREDIT CARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B3"},128180:{"value":"1F4B4","name":"BANKNOTE WITH YEN SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B4"},128181:{"value":"1F4B5","name":"BANKNOTE WITH DOLLAR SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B5"},128182:{"value":"1F4B6","name":"BANKNOTE WITH EURO SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B6"},128183:{"value":"1F4B7","name":"BANKNOTE WITH POUND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B7"},128184:{"value":"1F4B8","name":"MONEY WITH WINGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B8"},128185:{"value":"1F4B9","name":"CHART WITH UPWARDS TREND AND YEN SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4B9"},128186:{"value":"1F4BA","name":"SEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BA"},128187:{"value":"1F4BB","name":"PERSONAL COMPUTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BB"},128188:{"value":"1F4BC","name":"BRIEFCASE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BC"},128189:{"value":"1F4BD","name":"MINIDISC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BD"},128190:{"value":"1F4BE","name":"FLOPPY DISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BE"},128191:{"value":"1F4BF","name":"OPTICAL DISC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4BF"},128192:{"value":"1F4C0","name":"DVD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C0"},128193:{"value":"1F4C1","name":"FILE FOLDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C1"},128194:{"value":"1F4C2","name":"OPEN FILE FOLDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C2"},128195:{"value":"1F4C3","name":"PAGE WITH CURL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C3"},128196:{"value":"1F4C4","name":"PAGE FACING UP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C4"},128197:{"value":"1F4C5","name":"CALENDAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C5"},128198:{"value":"1F4C6","name":"TEAR-OFF CALENDAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C6"},128199:{"value":"1F4C7","name":"CARD INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C7"},128200:{"value":"1F4C8","name":"CHART WITH UPWARDS TREND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C8"},128201:{"value":"1F4C9","name":"CHART WITH DOWNWARDS TREND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4C9"},128202:{"value":"1F4CA","name":"BAR CHART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CA"},128203:{"value":"1F4CB","name":"CLIPBOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CB"},128204:{"value":"1F4CC","name":"PUSHPIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CC"},128205:{"value":"1F4CD","name":"ROUND PUSHPIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CD"},128206:{"value":"1F4CE","name":"PAPERCLIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CE"},128207:{"value":"1F4CF","name":"STRAIGHT RULER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4CF"},128208:{"value":"1F4D0","name":"TRIANGULAR RULER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D0"},128209:{"value":"1F4D1","name":"BOOKMARK TABS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D1"},128210:{"value":"1F4D2","name":"LEDGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D2"},128211:{"value":"1F4D3","name":"NOTEBOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D3"},128212:{"value":"1F4D4","name":"NOTEBOOK WITH DECORATIVE COVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D4"},128213:{"value":"1F4D5","name":"CLOSED BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D5"},128214:{"value":"1F4D6","name":"OPEN BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D6"},128215:{"value":"1F4D7","name":"GREEN BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D7"},128216:{"value":"1F4D8","name":"BLUE BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D8"},128217:{"value":"1F4D9","name":"ORANGE BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4D9"},128218:{"value":"1F4DA","name":"BOOKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DA"},128219:{"value":"1F4DB","name":"NAME BADGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DB"},128220:{"value":"1F4DC","name":"SCROLL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DC"},128221:{"value":"1F4DD","name":"MEMO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DD"},128222:{"value":"1F4DE","name":"TELEPHONE RECEIVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DE"},128223:{"value":"1F4DF","name":"PAGER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4DF"},128224:{"value":"1F4E0","name":"FAX MACHINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E0"},128225:{"value":"1F4E1","name":"SATELLITE ANTENNA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E1"},128226:{"value":"1F4E2","name":"PUBLIC ADDRESS LOUDSPEAKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E2"},128227:{"value":"1F4E3","name":"CHEERING MEGAPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E3"},128228:{"value":"1F4E4","name":"OUTBOX TRAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E4"},128229:{"value":"1F4E5","name":"INBOX TRAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E5"},128230:{"value":"1F4E6","name":"PACKAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E6"},128231:{"value":"1F4E7","name":"E-MAIL SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E7"},128232:{"value":"1F4E8","name":"INCOMING ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E8"},128233:{"value":"1F4E9","name":"ENVELOPE WITH DOWNWARDS ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4E9"},128234:{"value":"1F4EA","name":"CLOSED MAILBOX WITH LOWERED FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4EA"},128235:{"value":"1F4EB","name":"CLOSED MAILBOX WITH RAISED FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4EB"},128236:{"value":"1F4EC","name":"OPEN MAILBOX WITH RAISED FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4EC"},128237:{"value":"1F4ED","name":"OPEN MAILBOX WITH LOWERED FLAG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4ED"},128238:{"value":"1F4EE","name":"POSTBOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4EE"},128239:{"value":"1F4EF","name":"POSTAL HORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4EF"},128240:{"value":"1F4F0","name":"NEWSPAPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F0"},128241:{"value":"1F4F1","name":"MOBILE PHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F1"},128242:{"value":"1F4F2","name":"MOBILE PHONE WITH RIGHTWARDS ARROW AT LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F2"},128243:{"value":"1F4F3","name":"VIBRATION MODE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F3"},128244:{"value":"1F4F4","name":"MOBILE PHONE OFF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F4"},128245:{"value":"1F4F5","name":"NO MOBILE PHONES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F5"},128246:{"value":"1F4F6","name":"ANTENNA WITH BARS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F6"},128247:{"value":"1F4F7","name":"CAMERA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F7"},128248:{"value":"1F4F8","name":"CAMERA WITH FLASH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F8"},128249:{"value":"1F4F9","name":"VIDEO CAMERA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4F9"},128250:{"value":"1F4FA","name":"TELEVISION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FA"},128251:{"value":"1F4FB","name":"RADIO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FB"},128252:{"value":"1F4FC","name":"VIDEOCASSETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FC"},128253:{"value":"1F4FD","name":"FILM PROJECTOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FD"},128254:{"value":"1F4FE","name":"PORTABLE STEREO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FE"},128255:{"value":"1F4FF","name":"PRAYER BEADS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF4FF"},128256:{"value":"1F500","name":"TWISTED RIGHTWARDS ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF500"},128257:{"value":"1F501","name":"CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF501"},128258:{"value":"1F502","name":"CLOCKWISE RIGHTWARDS AND LEFTWARDS OPEN CIRCLE ARROWS WITH CIRCLED ONE OVERLAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF502"},128259:{"value":"1F503","name":"CLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF503"},128260:{"value":"1F504","name":"ANTICLOCKWISE DOWNWARDS AND UPWARDS OPEN CIRCLE ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF504"},128261:{"value":"1F505","name":"LOW BRIGHTNESS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF505"},128262:{"value":"1F506","name":"HIGH BRIGHTNESS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF506"},128263:{"value":"1F507","name":"SPEAKER WITH CANCELLATION STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF507"},128264:{"value":"1F508","name":"SPEAKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF508"},128265:{"value":"1F509","name":"SPEAKER WITH ONE SOUND WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF509"},128266:{"value":"1F50A","name":"SPEAKER WITH THREE SOUND WAVES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50A"},128267:{"value":"1F50B","name":"BATTERY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50B"},128268:{"value":"1F50C","name":"ELECTRIC PLUG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50C"},128269:{"value":"1F50D","name":"LEFT-POINTING MAGNIFYING GLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50D"},128270:{"value":"1F50E","name":"RIGHT-POINTING MAGNIFYING GLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50E"},128271:{"value":"1F50F","name":"LOCK WITH INK PEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF50F"},128272:{"value":"1F510","name":"CLOSED LOCK WITH KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF510"},128273:{"value":"1F511","name":"KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF511"},128274:{"value":"1F512","name":"LOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF512"},128275:{"value":"1F513","name":"OPEN LOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF513"},128276:{"value":"1F514","name":"BELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF514"},128277:{"value":"1F515","name":"BELL WITH CANCELLATION STROKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF515"},128278:{"value":"1F516","name":"BOOKMARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF516"},128279:{"value":"1F517","name":"LINK SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF517"},128280:{"value":"1F518","name":"RADIO BUTTON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF518"},128281:{"value":"1F519","name":"BACK WITH LEFTWARDS ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF519"},128282:{"value":"1F51A","name":"END WITH LEFTWARDS ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51A"},128283:{"value":"1F51B","name":"ON WITH EXCLAMATION MARK WITH LEFT RIGHT ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51B"},128284:{"value":"1F51C","name":"SOON WITH RIGHTWARDS ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51C"},128285:{"value":"1F51D","name":"TOP WITH UPWARDS ARROW ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51D"},128286:{"value":"1F51E","name":"NO ONE UNDER EIGHTEEN SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51E"},128287:{"value":"1F51F","name":"KEYCAP TEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF51F"},128288:{"value":"1F520","name":"INPUT SYMBOL FOR LATIN CAPITAL LETTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF520"},128289:{"value":"1F521","name":"INPUT SYMBOL FOR LATIN SMALL LETTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF521"},128290:{"value":"1F522","name":"INPUT SYMBOL FOR NUMBERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF522"},128291:{"value":"1F523","name":"INPUT SYMBOL FOR SYMBOLS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF523"},128292:{"value":"1F524","name":"INPUT SYMBOL FOR LATIN LETTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF524"},128293:{"value":"1F525","name":"FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF525"},128294:{"value":"1F526","name":"ELECTRIC TORCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF526"},128295:{"value":"1F527","name":"WRENCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF527"},128296:{"value":"1F528","name":"HAMMER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF528"},128297:{"value":"1F529","name":"NUT AND BOLT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF529"},128298:{"value":"1F52A","name":"HOCHO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52A"},128299:{"value":"1F52B","name":"PISTOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52B"},128300:{"value":"1F52C","name":"MICROSCOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52C"},128301:{"value":"1F52D","name":"TELESCOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52D"},128302:{"value":"1F52E","name":"CRYSTAL BALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52E"},128303:{"value":"1F52F","name":"SIX POINTED STAR WITH MIDDLE DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF52F"},128304:{"value":"1F530","name":"JAPANESE SYMBOL FOR BEGINNER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF530"},128305:{"value":"1F531","name":"TRIDENT EMBLEM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF531"},128306:{"value":"1F532","name":"BLACK SQUARE BUTTON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF532"},128307:{"value":"1F533","name":"WHITE SQUARE BUTTON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF533"},128308:{"value":"1F534","name":"LARGE RED CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF534"},128309:{"value":"1F535","name":"LARGE BLUE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF535"},128310:{"value":"1F536","name":"LARGE ORANGE DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF536"},128311:{"value":"1F537","name":"LARGE BLUE DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF537"},128312:{"value":"1F538","name":"SMALL ORANGE DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF538"},128313:{"value":"1F539","name":"SMALL BLUE DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF539"},128314:{"value":"1F53A","name":"UP-POINTING RED TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53A"},128315:{"value":"1F53B","name":"DOWN-POINTING RED TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53B"},128316:{"value":"1F53C","name":"UP-POINTING SMALL RED TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53C"},128317:{"value":"1F53D","name":"DOWN-POINTING SMALL RED TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53D"},128318:{"value":"1F53E","name":"LOWER RIGHT SHADOWED WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53E"},128319:{"value":"1F53F","name":"UPPER RIGHT SHADOWED WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF53F"},128320:{"value":"1F540","name":"CIRCLED CROSS POMMEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF540"},128321:{"value":"1F541","name":"CROSS POMMEE WITH HALF-CIRCLE BELOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF541"},128322:{"value":"1F542","name":"CROSS POMMEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF542"},128323:{"value":"1F543","name":"NOTCHED LEFT SEMICIRCLE WITH THREE DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF543"},128324:{"value":"1F544","name":"NOTCHED RIGHT SEMICIRCLE WITH THREE DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF544"},128325:{"value":"1F545","name":"SYMBOL FOR MARKS CHAPTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF545"},128326:{"value":"1F546","name":"WHITE LATIN CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF546"},128327:{"value":"1F547","name":"HEAVY LATIN CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF547"},128328:{"value":"1F548","name":"CELTIC CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF548"},128329:{"value":"1F549","name":"OM SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF549"},128330:{"value":"1F54A","name":"DOVE OF PEACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54A"},128331:{"value":"1F54B","name":"KAABA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54B"},128332:{"value":"1F54C","name":"MOSQUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54C"},128333:{"value":"1F54D","name":"SYNAGOGUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54D"},128334:{"value":"1F54E","name":"MENORAH WITH NINE BRANCHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54E"},128335:{"value":"1F54F","name":"BOWL OF HYGIEIA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF54F"},128336:{"value":"1F550","name":"CLOCK FACE ONE OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF550"},128337:{"value":"1F551","name":"CLOCK FACE TWO OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF551"},128338:{"value":"1F552","name":"CLOCK FACE THREE OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF552"},128339:{"value":"1F553","name":"CLOCK FACE FOUR OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF553"},128340:{"value":"1F554","name":"CLOCK FACE FIVE OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF554"},128341:{"value":"1F555","name":"CLOCK FACE SIX OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF555"},128342:{"value":"1F556","name":"CLOCK FACE SEVEN OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF556"},128343:{"value":"1F557","name":"CLOCK FACE EIGHT OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF557"},128344:{"value":"1F558","name":"CLOCK FACE NINE OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF558"},128345:{"value":"1F559","name":"CLOCK FACE TEN OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF559"},128346:{"value":"1F55A","name":"CLOCK FACE ELEVEN OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55A"},128347:{"value":"1F55B","name":"CLOCK FACE TWELVE OCLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55B"},128348:{"value":"1F55C","name":"CLOCK FACE ONE-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55C"},128349:{"value":"1F55D","name":"CLOCK FACE TWO-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55D"},128350:{"value":"1F55E","name":"CLOCK FACE THREE-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55E"},128351:{"value":"1F55F","name":"CLOCK FACE FOUR-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF55F"},128352:{"value":"1F560","name":"CLOCK FACE FIVE-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF560"},128353:{"value":"1F561","name":"CLOCK FACE SIX-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF561"},128354:{"value":"1F562","name":"CLOCK FACE SEVEN-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF562"},128355:{"value":"1F563","name":"CLOCK FACE EIGHT-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF563"},128356:{"value":"1F564","name":"CLOCK FACE NINE-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF564"},128357:{"value":"1F565","name":"CLOCK FACE TEN-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF565"},128358:{"value":"1F566","name":"CLOCK FACE ELEVEN-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF566"},128359:{"value":"1F567","name":"CLOCK FACE TWELVE-THIRTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF567"},128360:{"value":"1F568","name":"RIGHT SPEAKER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF568"},128361:{"value":"1F569","name":"RIGHT SPEAKER WITH ONE SOUND WAVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF569"},128362:{"value":"1F56A","name":"RIGHT SPEAKER WITH THREE SOUND WAVES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56A"},128363:{"value":"1F56B","name":"BULLHORN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56B"},128364:{"value":"1F56C","name":"BULLHORN WITH SOUND WAVES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56C"},128365:{"value":"1F56D","name":"RINGING BELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56D"},128366:{"value":"1F56E","name":"BOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56E"},128367:{"value":"1F56F","name":"CANDLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF56F"},128368:{"value":"1F570","name":"MANTELPIECE CLOCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF570"},128369:{"value":"1F571","name":"BLACK SKULL AND CROSSBONES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF571"},128370:{"value":"1F572","name":"NO PIRACY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF572"},128371:{"value":"1F573","name":"HOLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF573"},128372:{"value":"1F574","name":"MAN IN BUSINESS SUIT LEVITATING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF574"},128373:{"value":"1F575","name":"SLEUTH OR SPY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF575"},128374:{"value":"1F576","name":"DARK SUNGLASSES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF576"},128375:{"value":"1F577","name":"SPIDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF577"},128376:{"value":"1F578","name":"SPIDER WEB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF578"},128377:{"value":"1F579","name":"JOYSTICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF579"},128378:{"value":"1F57A","name":"MAN DANCING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57A"},128379:{"value":"1F57B","name":"LEFT HAND TELEPHONE RECEIVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57B"},128380:{"value":"1F57C","name":"TELEPHONE RECEIVER WITH PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57C"},128381:{"value":"1F57D","name":"RIGHT HAND TELEPHONE RECEIVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57D"},128382:{"value":"1F57E","name":"WHITE TOUCHTONE TELEPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57E"},128383:{"value":"1F57F","name":"BLACK TOUCHTONE TELEPHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF57F"},128384:{"value":"1F580","name":"TELEPHONE ON TOP OF MODEM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF580"},128385:{"value":"1F581","name":"CLAMSHELL MOBILE PHONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF581"},128386:{"value":"1F582","name":"BACK OF ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF582"},128387:{"value":"1F583","name":"STAMPED ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF583"},128388:{"value":"1F584","name":"ENVELOPE WITH LIGHTNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF584"},128389:{"value":"1F585","name":"FLYING ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF585"},128390:{"value":"1F586","name":"PEN OVER STAMPED ENVELOPE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF586"},128391:{"value":"1F587","name":"LINKED PAPERCLIPS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF587"},128392:{"value":"1F588","name":"BLACK PUSHPIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF588"},128393:{"value":"1F589","name":"LOWER LEFT PENCIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF589"},128394:{"value":"1F58A","name":"LOWER LEFT BALLPOINT PEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58A"},128395:{"value":"1F58B","name":"LOWER LEFT FOUNTAIN PEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58B"},128396:{"value":"1F58C","name":"LOWER LEFT PAINTBRUSH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58C"},128397:{"value":"1F58D","name":"LOWER LEFT CRAYON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58D"},128398:{"value":"1F58E","name":"LEFT WRITING HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58E"},128399:{"value":"1F58F","name":"TURNED OK HAND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF58F"},128400:{"value":"1F590","name":"RAISED HAND WITH FINGERS SPLAYED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF590"},128401:{"value":"1F591","name":"REVERSED RAISED HAND WITH FINGERS SPLAYED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF591"},128402:{"value":"1F592","name":"REVERSED THUMBS UP SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF592"},128403:{"value":"1F593","name":"REVERSED THUMBS DOWN SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF593"},128404:{"value":"1F594","name":"REVERSED VICTORY HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF594"},128405:{"value":"1F595","name":"REVERSED HAND WITH MIDDLE FINGER EXTENDED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF595"},128406:{"value":"1F596","name":"RAISED HAND WITH PART BETWEEN MIDDLE AND RING FINGERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF596"},128407:{"value":"1F597","name":"WHITE DOWN POINTING LEFT HAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF597"},128408:{"value":"1F598","name":"SIDEWAYS WHITE LEFT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF598"},128409:{"value":"1F599","name":"SIDEWAYS WHITE RIGHT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF599"},128410:{"value":"1F59A","name":"SIDEWAYS BLACK LEFT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59A"},128411:{"value":"1F59B","name":"SIDEWAYS BLACK RIGHT POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59B"},128412:{"value":"1F59C","name":"BLACK LEFT POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59C"},128413:{"value":"1F59D","name":"BLACK RIGHT POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59D"},128414:{"value":"1F59E","name":"SIDEWAYS WHITE UP POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59E"},128415:{"value":"1F59F","name":"SIDEWAYS WHITE DOWN POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF59F"},128416:{"value":"1F5A0","name":"SIDEWAYS BLACK UP POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A0"},128417:{"value":"1F5A1","name":"SIDEWAYS BLACK DOWN POINTING INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A1"},128418:{"value":"1F5A2","name":"BLACK UP POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A2"},128419:{"value":"1F5A3","name":"BLACK DOWN POINTING BACKHAND INDEX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A3"},128420:{"value":"1F5A4","name":"BLACK HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A4"},128421:{"value":"1F5A5","name":"DESKTOP COMPUTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A5"},128422:{"value":"1F5A6","name":"KEYBOARD AND MOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A6"},128423:{"value":"1F5A7","name":"THREE NETWORKED COMPUTERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A7"},128424:{"value":"1F5A8","name":"PRINTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A8"},128425:{"value":"1F5A9","name":"POCKET CALCULATOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5A9"},128426:{"value":"1F5AA","name":"BLACK HARD SHELL FLOPPY DISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AA"},128427:{"value":"1F5AB","name":"WHITE HARD SHELL FLOPPY DISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AB"},128428:{"value":"1F5AC","name":"SOFT SHELL FLOPPY DISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AC"},128429:{"value":"1F5AD","name":"TAPE CARTRIDGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AD"},128430:{"value":"1F5AE","name":"WIRED KEYBOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AE"},128431:{"value":"1F5AF","name":"ONE BUTTON MOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5AF"},128432:{"value":"1F5B0","name":"TWO BUTTON MOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B0"},128433:{"value":"1F5B1","name":"THREE BUTTON MOUSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B1"},128434:{"value":"1F5B2","name":"TRACKBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B2"},128435:{"value":"1F5B3","name":"OLD PERSONAL COMPUTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B3"},128436:{"value":"1F5B4","name":"HARD DISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B4"},128437:{"value":"1F5B5","name":"SCREEN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B5"},128438:{"value":"1F5B6","name":"PRINTER ICON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B6"},128439:{"value":"1F5B7","name":"FAX ICON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B7"},128440:{"value":"1F5B8","name":"OPTICAL DISC ICON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B8"},128441:{"value":"1F5B9","name":"DOCUMENT WITH TEXT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5B9"},128442:{"value":"1F5BA","name":"DOCUMENT WITH TEXT AND PICTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BA"},128443:{"value":"1F5BB","name":"DOCUMENT WITH PICTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BB"},128444:{"value":"1F5BC","name":"FRAME WITH PICTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BC"},128445:{"value":"1F5BD","name":"FRAME WITH TILES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BD"},128446:{"value":"1F5BE","name":"FRAME WITH AN X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BE"},128447:{"value":"1F5BF","name":"BLACK FOLDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5BF"},128448:{"value":"1F5C0","name":"FOLDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C0"},128449:{"value":"1F5C1","name":"OPEN FOLDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C1"},128450:{"value":"1F5C2","name":"CARD INDEX DIVIDERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C2"},128451:{"value":"1F5C3","name":"CARD FILE BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C3"},128452:{"value":"1F5C4","name":"FILE CABINET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C4"},128453:{"value":"1F5C5","name":"EMPTY NOTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C5"},128454:{"value":"1F5C6","name":"EMPTY NOTE PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C6"},128455:{"value":"1F5C7","name":"EMPTY NOTE PAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C7"},128456:{"value":"1F5C8","name":"NOTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C8"},128457:{"value":"1F5C9","name":"NOTE PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5C9"},128458:{"value":"1F5CA","name":"NOTE PAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CA"},128459:{"value":"1F5CB","name":"EMPTY DOCUMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CB"},128460:{"value":"1F5CC","name":"EMPTY PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CC"},128461:{"value":"1F5CD","name":"EMPTY PAGES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CD"},128462:{"value":"1F5CE","name":"DOCUMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CE"},128463:{"value":"1F5CF","name":"PAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5CF"},128464:{"value":"1F5D0","name":"PAGES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D0"},128465:{"value":"1F5D1","name":"WASTEBASKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D1"},128466:{"value":"1F5D2","name":"SPIRAL NOTE PAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D2"},128467:{"value":"1F5D3","name":"SPIRAL CALENDAR PAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D3"},128468:{"value":"1F5D4","name":"DESKTOP WINDOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D4"},128469:{"value":"1F5D5","name":"MINIMIZE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D5"},128470:{"value":"1F5D6","name":"MAXIMIZE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D6"},128471:{"value":"1F5D7","name":"OVERLAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D7"},128472:{"value":"1F5D8","name":"CLOCKWISE RIGHT AND LEFT SEMICIRCLE ARROWS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D8"},128473:{"value":"1F5D9","name":"CANCELLATION X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5D9"},128474:{"value":"1F5DA","name":"INCREASE FONT SIZE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DA"},128475:{"value":"1F5DB","name":"DECREASE FONT SIZE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DB"},128476:{"value":"1F5DC","name":"COMPRESSION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DC"},128477:{"value":"1F5DD","name":"OLD KEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DD"},128478:{"value":"1F5DE","name":"ROLLED-UP NEWSPAPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DE"},128479:{"value":"1F5DF","name":"PAGE WITH CIRCLED TEXT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5DF"},128480:{"value":"1F5E0","name":"STOCK CHART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E0"},128481:{"value":"1F5E1","name":"DAGGER KNIFE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E1"},128482:{"value":"1F5E2","name":"LIPS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E2"},128483:{"value":"1F5E3","name":"SPEAKING HEAD IN SILHOUETTE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E3"},128484:{"value":"1F5E4","name":"THREE RAYS ABOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E4"},128485:{"value":"1F5E5","name":"THREE RAYS BELOW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E5"},128486:{"value":"1F5E6","name":"THREE RAYS LEFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E6"},128487:{"value":"1F5E7","name":"THREE RAYS RIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E7"},128488:{"value":"1F5E8","name":"LEFT SPEECH BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E8"},128489:{"value":"1F5E9","name":"RIGHT SPEECH BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5E9"},128490:{"value":"1F5EA","name":"TWO SPEECH BUBBLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5EA"},128491:{"value":"1F5EB","name":"THREE SPEECH BUBBLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5EB"},128492:{"value":"1F5EC","name":"LEFT THOUGHT BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5EC"},128493:{"value":"1F5ED","name":"RIGHT THOUGHT BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5ED"},128494:{"value":"1F5EE","name":"LEFT ANGER BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5EE"},128495:{"value":"1F5EF","name":"RIGHT ANGER BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5EF"},128496:{"value":"1F5F0","name":"MOOD BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F0"},128497:{"value":"1F5F1","name":"LIGHTNING MOOD BUBBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F1"},128498:{"value":"1F5F2","name":"LIGHTNING MOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F2"},128499:{"value":"1F5F3","name":"BALLOT BOX WITH BALLOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F3"},128500:{"value":"1F5F4","name":"BALLOT SCRIPT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F4"},128501:{"value":"1F5F5","name":"BALLOT BOX WITH SCRIPT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F5"},128502:{"value":"1F5F6","name":"BALLOT BOLD SCRIPT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F6"},128503:{"value":"1F5F7","name":"BALLOT BOX WITH BOLD SCRIPT X","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F7"},128504:{"value":"1F5F8","name":"LIGHT CHECK MARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F8"},128505:{"value":"1F5F9","name":"BALLOT BOX WITH BOLD CHECK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5F9"},128506:{"value":"1F5FA","name":"WORLD MAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FA"},128507:{"value":"1F5FB","name":"MOUNT FUJI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FB"},128508:{"value":"1F5FC","name":"TOKYO TOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FC"},128509:{"value":"1F5FD","name":"STATUE OF LIBERTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FD"},128510:{"value":"1F5FE","name":"SILHOUETTE OF JAPAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FE"},128511:{"value":"1F5FF","name":"MOYAI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF5FF"},128512:{"value":"1F600","name":"GRINNING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF600"},128513:{"value":"1F601","name":"GRINNING FACE WITH SMILING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF601"},128514:{"value":"1F602","name":"FACE WITH TEARS OF JOY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF602"},128515:{"value":"1F603","name":"SMILING FACE WITH OPEN MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF603"},128516:{"value":"1F604","name":"SMILING FACE WITH OPEN MOUTH AND SMILING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF604"},128517:{"value":"1F605","name":"SMILING FACE WITH OPEN MOUTH AND COLD SWEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF605"},128518:{"value":"1F606","name":"SMILING FACE WITH OPEN MOUTH AND TIGHTLY-CLOSED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF606"},128519:{"value":"1F607","name":"SMILING FACE WITH HALO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF607"},128520:{"value":"1F608","name":"SMILING FACE WITH HORNS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF608"},128521:{"value":"1F609","name":"WINKING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF609"},128522:{"value":"1F60A","name":"SMILING FACE WITH SMILING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60A"},128523:{"value":"1F60B","name":"FACE SAVOURING DELICIOUS FOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60B"},128524:{"value":"1F60C","name":"RELIEVED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60C"},128525:{"value":"1F60D","name":"SMILING FACE WITH HEART-SHAPED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60D"},128526:{"value":"1F60E","name":"SMILING FACE WITH SUNGLASSES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60E"},128527:{"value":"1F60F","name":"SMIRKING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF60F"},128528:{"value":"1F610","name":"NEUTRAL FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF610"},128529:{"value":"1F611","name":"EXPRESSIONLESS FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF611"},128530:{"value":"1F612","name":"UNAMUSED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF612"},128531:{"value":"1F613","name":"FACE WITH COLD SWEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF613"},128532:{"value":"1F614","name":"PENSIVE FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF614"},128533:{"value":"1F615","name":"CONFUSED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF615"},128534:{"value":"1F616","name":"CONFOUNDED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF616"},128535:{"value":"1F617","name":"KISSING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF617"},128536:{"value":"1F618","name":"FACE THROWING A KISS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF618"},128537:{"value":"1F619","name":"KISSING FACE WITH SMILING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF619"},128538:{"value":"1F61A","name":"KISSING FACE WITH CLOSED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61A"},128539:{"value":"1F61B","name":"FACE WITH STUCK-OUT TONGUE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61B"},128540:{"value":"1F61C","name":"FACE WITH STUCK-OUT TONGUE AND WINKING EYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61C"},128541:{"value":"1F61D","name":"FACE WITH STUCK-OUT TONGUE AND TIGHTLY-CLOSED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61D"},128542:{"value":"1F61E","name":"DISAPPOINTED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61E"},128543:{"value":"1F61F","name":"WORRIED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF61F"},128544:{"value":"1F620","name":"ANGRY FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF620"},128545:{"value":"1F621","name":"POUTING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF621"},128546:{"value":"1F622","name":"CRYING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF622"},128547:{"value":"1F623","name":"PERSEVERING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF623"},128548:{"value":"1F624","name":"FACE WITH LOOK OF TRIUMPH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF624"},128549:{"value":"1F625","name":"DISAPPOINTED BUT RELIEVED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF625"},128550:{"value":"1F626","name":"FROWNING FACE WITH OPEN MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF626"},128551:{"value":"1F627","name":"ANGUISHED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF627"},128552:{"value":"1F628","name":"FEARFUL FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF628"},128553:{"value":"1F629","name":"WEARY FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF629"},128554:{"value":"1F62A","name":"SLEEPY FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62A"},128555:{"value":"1F62B","name":"TIRED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62B"},128556:{"value":"1F62C","name":"GRIMACING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62C"},128557:{"value":"1F62D","name":"LOUDLY CRYING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62D"},128558:{"value":"1F62E","name":"FACE WITH OPEN MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62E"},128559:{"value":"1F62F","name":"HUSHED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF62F"},128560:{"value":"1F630","name":"FACE WITH OPEN MOUTH AND COLD SWEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF630"},128561:{"value":"1F631","name":"FACE SCREAMING IN FEAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF631"},128562:{"value":"1F632","name":"ASTONISHED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF632"},128563:{"value":"1F633","name":"FLUSHED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF633"},128564:{"value":"1F634","name":"SLEEPING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF634"},128565:{"value":"1F635","name":"DIZZY FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF635"},128566:{"value":"1F636","name":"FACE WITHOUT MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF636"},128567:{"value":"1F637","name":"FACE WITH MEDICAL MASK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF637"},128568:{"value":"1F638","name":"GRINNING CAT FACE WITH SMILING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF638"},128569:{"value":"1F639","name":"CAT FACE WITH TEARS OF JOY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF639"},128570:{"value":"1F63A","name":"SMILING CAT FACE WITH OPEN MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63A"},128571:{"value":"1F63B","name":"SMILING CAT FACE WITH HEART-SHAPED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63B"},128572:{"value":"1F63C","name":"CAT FACE WITH WRY SMILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63C"},128573:{"value":"1F63D","name":"KISSING CAT FACE WITH CLOSED EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63D"},128574:{"value":"1F63E","name":"POUTING CAT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63E"},128575:{"value":"1F63F","name":"CRYING CAT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF63F"},128576:{"value":"1F640","name":"WEARY CAT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF640"},128577:{"value":"1F641","name":"SLIGHTLY FROWNING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF641"},128578:{"value":"1F642","name":"SLIGHTLY SMILING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF642"},128579:{"value":"1F643","name":"UPSIDE-DOWN FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF643"},128580:{"value":"1F644","name":"FACE WITH ROLLING EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF644"},128581:{"value":"1F645","name":"FACE WITH NO GOOD GESTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF645"},128582:{"value":"1F646","name":"FACE WITH OK GESTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF646"},128583:{"value":"1F647","name":"PERSON BOWING DEEPLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF647"},128584:{"value":"1F648","name":"SEE-NO-EVIL MONKEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF648"},128585:{"value":"1F649","name":"HEAR-NO-EVIL MONKEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF649"},128586:{"value":"1F64A","name":"SPEAK-NO-EVIL MONKEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64A"},128587:{"value":"1F64B","name":"HAPPY PERSON RAISING ONE HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64B"},128588:{"value":"1F64C","name":"PERSON RAISING BOTH HANDS IN CELEBRATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64C"},128589:{"value":"1F64D","name":"PERSON FROWNING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64D"},128590:{"value":"1F64E","name":"PERSON WITH POUTING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64E"},128591:{"value":"1F64F","name":"PERSON WITH FOLDED HANDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF64F"},128592:{"value":"1F650","name":"NORTH WEST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF650"},128593:{"value":"1F651","name":"SOUTH WEST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF651"},128594:{"value":"1F652","name":"NORTH EAST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF652"},128595:{"value":"1F653","name":"SOUTH EAST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF653"},128596:{"value":"1F654","name":"TURNED NORTH WEST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF654"},128597:{"value":"1F655","name":"TURNED SOUTH WEST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF655"},128598:{"value":"1F656","name":"TURNED NORTH EAST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF656"},128599:{"value":"1F657","name":"TURNED SOUTH EAST POINTING LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF657"},128600:{"value":"1F658","name":"NORTH WEST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF658"},128601:{"value":"1F659","name":"SOUTH WEST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF659"},128602:{"value":"1F65A","name":"NORTH EAST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65A"},128603:{"value":"1F65B","name":"SOUTH EAST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65B"},128604:{"value":"1F65C","name":"HEAVY NORTH WEST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65C"},128605:{"value":"1F65D","name":"HEAVY SOUTH WEST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65D"},128606:{"value":"1F65E","name":"HEAVY NORTH EAST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65E"},128607:{"value":"1F65F","name":"HEAVY SOUTH EAST POINTING VINE LEAF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF65F"},128608:{"value":"1F660","name":"NORTH WEST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF660"},128609:{"value":"1F661","name":"SOUTH WEST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF661"},128610:{"value":"1F662","name":"NORTH EAST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF662"},128611:{"value":"1F663","name":"SOUTH EAST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF663"},128612:{"value":"1F664","name":"HEAVY NORTH WEST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF664"},128613:{"value":"1F665","name":"HEAVY SOUTH WEST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF665"},128614:{"value":"1F666","name":"HEAVY NORTH EAST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF666"},128615:{"value":"1F667","name":"HEAVY SOUTH EAST POINTING BUD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF667"},128616:{"value":"1F668","name":"HOLLOW QUILT SQUARE ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF668"},128617:{"value":"1F669","name":"HOLLOW QUILT SQUARE ORNAMENT IN BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF669"},128618:{"value":"1F66A","name":"SOLID QUILT SQUARE ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66A"},128619:{"value":"1F66B","name":"SOLID QUILT SQUARE ORNAMENT IN BLACK SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66B"},128620:{"value":"1F66C","name":"LEFTWARDS ROCKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66C"},128621:{"value":"1F66D","name":"UPWARDS ROCKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66D"},128622:{"value":"1F66E","name":"RIGHTWARDS ROCKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66E"},128623:{"value":"1F66F","name":"DOWNWARDS ROCKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF66F"},128624:{"value":"1F670","name":"SCRIPT LIGATURE ET ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF670"},128625:{"value":"1F671","name":"HEAVY SCRIPT LIGATURE ET ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF671"},128626:{"value":"1F672","name":"LIGATURE OPEN ET ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF672"},128627:{"value":"1F673","name":"HEAVY LIGATURE OPEN ET ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF673"},128628:{"value":"1F674","name":"HEAVY AMPERSAND ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF674"},128629:{"value":"1F675","name":"SWASH AMPERSAND ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF675"},128630:{"value":"1F676","name":"SANS-SERIF HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF676"},128631:{"value":"1F677","name":"SANS-SERIF HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF677"},128632:{"value":"1F678","name":"SANS-SERIF HEAVY LOW DOUBLE COMMA QUOTATION MARK ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF678"},128633:{"value":"1F679","name":"HEAVY INTERROBANG ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF679"},128634:{"value":"1F67A","name":"SANS-SERIF INTERROBANG ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67A"},128635:{"value":"1F67B","name":"HEAVY SANS-SERIF INTERROBANG ORNAMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67B"},128636:{"value":"1F67C","name":"VERY HEAVY SOLIDUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67C"},128637:{"value":"1F67D","name":"VERY HEAVY REVERSE SOLIDUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67D"},128638:{"value":"1F67E","name":"CHECKER BOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67E"},128639:{"value":"1F67F","name":"REVERSE CHECKER BOARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF67F"},128640:{"value":"1F680","name":"ROCKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF680"},128641:{"value":"1F681","name":"HELICOPTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF681"},128642:{"value":"1F682","name":"STEAM LOCOMOTIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF682"},128643:{"value":"1F683","name":"RAILWAY CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF683"},128644:{"value":"1F684","name":"HIGH-SPEED TRAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF684"},128645:{"value":"1F685","name":"HIGH-SPEED TRAIN WITH BULLET NOSE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF685"},128646:{"value":"1F686","name":"TRAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF686"},128647:{"value":"1F687","name":"METRO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF687"},128648:{"value":"1F688","name":"LIGHT RAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF688"},128649:{"value":"1F689","name":"STATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF689"},128650:{"value":"1F68A","name":"TRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68A"},128651:{"value":"1F68B","name":"TRAM CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68B"},128652:{"value":"1F68C","name":"BUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68C"},128653:{"value":"1F68D","name":"ONCOMING BUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68D"},128654:{"value":"1F68E","name":"TROLLEYBUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68E"},128655:{"value":"1F68F","name":"BUS STOP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF68F"},128656:{"value":"1F690","name":"MINIBUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF690"},128657:{"value":"1F691","name":"AMBULANCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF691"},128658:{"value":"1F692","name":"FIRE ENGINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF692"},128659:{"value":"1F693","name":"POLICE CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF693"},128660:{"value":"1F694","name":"ONCOMING POLICE CAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF694"},128661:{"value":"1F695","name":"TAXI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF695"},128662:{"value":"1F696","name":"ONCOMING TAXI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF696"},128663:{"value":"1F697","name":"AUTOMOBILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF697"},128664:{"value":"1F698","name":"ONCOMING AUTOMOBILE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF698"},128665:{"value":"1F699","name":"RECREATIONAL VEHICLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF699"},128666:{"value":"1F69A","name":"DELIVERY TRUCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69A"},128667:{"value":"1F69B","name":"ARTICULATED LORRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69B"},128668:{"value":"1F69C","name":"TRACTOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69C"},128669:{"value":"1F69D","name":"MONORAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69D"},128670:{"value":"1F69E","name":"MOUNTAIN RAILWAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69E"},128671:{"value":"1F69F","name":"SUSPENSION RAILWAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF69F"},128672:{"value":"1F6A0","name":"MOUNTAIN CABLEWAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A0"},128673:{"value":"1F6A1","name":"AERIAL TRAMWAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A1"},128674:{"value":"1F6A2","name":"SHIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A2"},128675:{"value":"1F6A3","name":"ROWBOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A3"},128676:{"value":"1F6A4","name":"SPEEDBOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A4"},128677:{"value":"1F6A5","name":"HORIZONTAL TRAFFIC LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A5"},128678:{"value":"1F6A6","name":"VERTICAL TRAFFIC LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A6"},128679:{"value":"1F6A7","name":"CONSTRUCTION SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A7"},128680:{"value":"1F6A8","name":"POLICE CARS REVOLVING LIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A8"},128681:{"value":"1F6A9","name":"TRIANGULAR FLAG ON POST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6A9"},128682:{"value":"1F6AA","name":"DOOR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AA"},128683:{"value":"1F6AB","name":"NO ENTRY SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AB"},128684:{"value":"1F6AC","name":"SMOKING SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AC"},128685:{"value":"1F6AD","name":"NO SMOKING SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AD"},128686:{"value":"1F6AE","name":"PUT LITTER IN ITS PLACE SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AE"},128687:{"value":"1F6AF","name":"DO NOT LITTER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6AF"},128688:{"value":"1F6B0","name":"POTABLE WATER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B0"},128689:{"value":"1F6B1","name":"NON-POTABLE WATER SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B1"},128690:{"value":"1F6B2","name":"BICYCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B2"},128691:{"value":"1F6B3","name":"NO BICYCLES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B3"},128692:{"value":"1F6B4","name":"BICYCLIST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B4"},128693:{"value":"1F6B5","name":"MOUNTAIN BICYCLIST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B5"},128694:{"value":"1F6B6","name":"PEDESTRIAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B6"},128695:{"value":"1F6B7","name":"NO PEDESTRIANS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B7"},128696:{"value":"1F6B8","name":"CHILDREN CROSSING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B8"},128697:{"value":"1F6B9","name":"MENS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6B9"},128698:{"value":"1F6BA","name":"WOMENS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BA"},128699:{"value":"1F6BB","name":"RESTROOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BB"},128700:{"value":"1F6BC","name":"BABY SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BC"},128701:{"value":"1F6BD","name":"TOILET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BD"},128702:{"value":"1F6BE","name":"WATER CLOSET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BE"},128703:{"value":"1F6BF","name":"SHOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6BF"},128704:{"value":"1F6C0","name":"BATH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C0"},128705:{"value":"1F6C1","name":"BATHTUB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C1"},128706:{"value":"1F6C2","name":"PASSPORT CONTROL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C2"},128707:{"value":"1F6C3","name":"CUSTOMS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C3"},128708:{"value":"1F6C4","name":"BAGGAGE CLAIM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C4"},128709:{"value":"1F6C5","name":"LEFT LUGGAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C5"},128710:{"value":"1F6C6","name":"TRIANGLE WITH ROUNDED CORNERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C6"},128711:{"value":"1F6C7","name":"PROHIBITED SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C7"},128712:{"value":"1F6C8","name":"CIRCLED INFORMATION SOURCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C8"},128713:{"value":"1F6C9","name":"BOYS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6C9"},128714:{"value":"1F6CA","name":"GIRLS SYMBOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CA"},128715:{"value":"1F6CB","name":"COUCH AND LAMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CB"},128716:{"value":"1F6CC","name":"SLEEPING ACCOMMODATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CC"},128717:{"value":"1F6CD","name":"SHOPPING BAGS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CD"},128718:{"value":"1F6CE","name":"BELLHOP BELL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CE"},128719:{"value":"1F6CF","name":"BED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6CF"},128720:{"value":"1F6D0","name":"PLACE OF WORSHIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6D0"},128721:{"value":"1F6D1","name":"OCTAGONAL SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6D1"},128722:{"value":"1F6D2","name":"SHOPPING TROLLEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6D2"},128723:{"value":"1F6D3","name":"STUPA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6D3"},128724:{"value":"1F6D4","name":"PAGODA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6D4"},128736:{"value":"1F6E0","name":"HAMMER AND WRENCH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E0"},128737:{"value":"1F6E1","name":"SHIELD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E1"},128738:{"value":"1F6E2","name":"OIL DRUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E2"},128739:{"value":"1F6E3","name":"MOTORWAY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E3"},128740:{"value":"1F6E4","name":"RAILWAY TRACK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E4"},128741:{"value":"1F6E5","name":"MOTOR BOAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E5"},128742:{"value":"1F6E6","name":"UP-POINTING MILITARY AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E6"},128743:{"value":"1F6E7","name":"UP-POINTING AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E7"},128744:{"value":"1F6E8","name":"UP-POINTING SMALL AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E8"},128745:{"value":"1F6E9","name":"SMALL AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6E9"},128746:{"value":"1F6EA","name":"NORTHEAST-POINTING AIRPLANE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6EA"},128747:{"value":"1F6EB","name":"AIRPLANE DEPARTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6EB"},128748:{"value":"1F6EC","name":"AIRPLANE ARRIVING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6EC"},128752:{"value":"1F6F0","name":"SATELLITE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F0"},128753:{"value":"1F6F1","name":"ONCOMING FIRE ENGINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F1"},128754:{"value":"1F6F2","name":"DIESEL LOCOMOTIVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F2"},128755:{"value":"1F6F3","name":"PASSENGER SHIP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F3"},128756:{"value":"1F6F4","name":"SCOOTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F4"},128757:{"value":"1F6F5","name":"MOTOR SCOOTER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F5"},128758:{"value":"1F6F6","name":"CANOE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F6"},128759:{"value":"1F6F7","name":"SLED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F7"},128760:{"value":"1F6F8","name":"FLYING SAUCER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF6F8"},128768:{"value":"1F700","name":"ALCHEMICAL SYMBOL FOR QUINTESSENCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF700"},128769:{"value":"1F701","name":"ALCHEMICAL SYMBOL FOR AIR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF701"},128770:{"value":"1F702","name":"ALCHEMICAL SYMBOL FOR FIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF702"},128771:{"value":"1F703","name":"ALCHEMICAL SYMBOL FOR EARTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF703"},128772:{"value":"1F704","name":"ALCHEMICAL SYMBOL FOR WATER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF704"},128773:{"value":"1F705","name":"ALCHEMICAL SYMBOL FOR AQUAFORTIS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF705"},128774:{"value":"1F706","name":"ALCHEMICAL SYMBOL FOR AQUA REGIA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF706"},128775:{"value":"1F707","name":"ALCHEMICAL SYMBOL FOR AQUA REGIA-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF707"},128776:{"value":"1F708","name":"ALCHEMICAL SYMBOL FOR AQUA VITAE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF708"},128777:{"value":"1F709","name":"ALCHEMICAL SYMBOL FOR AQUA VITAE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF709"},128778:{"value":"1F70A","name":"ALCHEMICAL SYMBOL FOR VINEGAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70A"},128779:{"value":"1F70B","name":"ALCHEMICAL SYMBOL FOR VINEGAR-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70B"},128780:{"value":"1F70C","name":"ALCHEMICAL SYMBOL FOR VINEGAR-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70C"},128781:{"value":"1F70D","name":"ALCHEMICAL SYMBOL FOR SULFUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70D"},128782:{"value":"1F70E","name":"ALCHEMICAL SYMBOL FOR PHILOSOPHERS SULFUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70E"},128783:{"value":"1F70F","name":"ALCHEMICAL SYMBOL FOR BLACK SULFUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF70F"},128784:{"value":"1F710","name":"ALCHEMICAL SYMBOL FOR MERCURY SUBLIMATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF710"},128785:{"value":"1F711","name":"ALCHEMICAL SYMBOL FOR MERCURY SUBLIMATE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF711"},128786:{"value":"1F712","name":"ALCHEMICAL SYMBOL FOR MERCURY SUBLIMATE-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF712"},128787:{"value":"1F713","name":"ALCHEMICAL SYMBOL FOR CINNABAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF713"},128788:{"value":"1F714","name":"ALCHEMICAL SYMBOL FOR SALT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF714"},128789:{"value":"1F715","name":"ALCHEMICAL SYMBOL FOR NITRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF715"},128790:{"value":"1F716","name":"ALCHEMICAL SYMBOL FOR VITRIOL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF716"},128791:{"value":"1F717","name":"ALCHEMICAL SYMBOL FOR VITRIOL-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF717"},128792:{"value":"1F718","name":"ALCHEMICAL SYMBOL FOR ROCK SALT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF718"},128793:{"value":"1F719","name":"ALCHEMICAL SYMBOL FOR ROCK SALT-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF719"},128794:{"value":"1F71A","name":"ALCHEMICAL SYMBOL FOR GOLD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71A"},128795:{"value":"1F71B","name":"ALCHEMICAL SYMBOL FOR SILVER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71B"},128796:{"value":"1F71C","name":"ALCHEMICAL SYMBOL FOR IRON ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71C"},128797:{"value":"1F71D","name":"ALCHEMICAL SYMBOL FOR IRON ORE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71D"},128798:{"value":"1F71E","name":"ALCHEMICAL SYMBOL FOR CROCUS OF IRON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71E"},128799:{"value":"1F71F","name":"ALCHEMICAL SYMBOL FOR REGULUS OF IRON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF71F"},128800:{"value":"1F720","name":"ALCHEMICAL SYMBOL FOR COPPER ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF720"},128801:{"value":"1F721","name":"ALCHEMICAL SYMBOL FOR IRON-COPPER ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF721"},128802:{"value":"1F722","name":"ALCHEMICAL SYMBOL FOR SUBLIMATE OF COPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF722"},128803:{"value":"1F723","name":"ALCHEMICAL SYMBOL FOR CROCUS OF COPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF723"},128804:{"value":"1F724","name":"ALCHEMICAL SYMBOL FOR CROCUS OF COPPER-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF724"},128805:{"value":"1F725","name":"ALCHEMICAL SYMBOL FOR COPPER ANTIMONIATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF725"},128806:{"value":"1F726","name":"ALCHEMICAL SYMBOL FOR SALT OF COPPER ANTIMONIATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF726"},128807:{"value":"1F727","name":"ALCHEMICAL SYMBOL FOR SUBLIMATE OF SALT OF COPPER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF727"},128808:{"value":"1F728","name":"ALCHEMICAL SYMBOL FOR VERDIGRIS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF728"},128809:{"value":"1F729","name":"ALCHEMICAL SYMBOL FOR TIN ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF729"},128810:{"value":"1F72A","name":"ALCHEMICAL SYMBOL FOR LEAD ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72A"},128811:{"value":"1F72B","name":"ALCHEMICAL SYMBOL FOR ANTIMONY ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72B"},128812:{"value":"1F72C","name":"ALCHEMICAL SYMBOL FOR SUBLIMATE OF ANTIMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72C"},128813:{"value":"1F72D","name":"ALCHEMICAL SYMBOL FOR SALT OF ANTIMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72D"},128814:{"value":"1F72E","name":"ALCHEMICAL SYMBOL FOR SUBLIMATE OF SALT OF ANTIMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72E"},128815:{"value":"1F72F","name":"ALCHEMICAL SYMBOL FOR VINEGAR OF ANTIMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF72F"},128816:{"value":"1F730","name":"ALCHEMICAL SYMBOL FOR REGULUS OF ANTIMONY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF730"},128817:{"value":"1F731","name":"ALCHEMICAL SYMBOL FOR REGULUS OF ANTIMONY-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF731"},128818:{"value":"1F732","name":"ALCHEMICAL SYMBOL FOR REGULUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF732"},128819:{"value":"1F733","name":"ALCHEMICAL SYMBOL FOR REGULUS-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF733"},128820:{"value":"1F734","name":"ALCHEMICAL SYMBOL FOR REGULUS-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF734"},128821:{"value":"1F735","name":"ALCHEMICAL SYMBOL FOR REGULUS-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF735"},128822:{"value":"1F736","name":"ALCHEMICAL SYMBOL FOR ALKALI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF736"},128823:{"value":"1F737","name":"ALCHEMICAL SYMBOL FOR ALKALI-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF737"},128824:{"value":"1F738","name":"ALCHEMICAL SYMBOL FOR MARCASITE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF738"},128825:{"value":"1F739","name":"ALCHEMICAL SYMBOL FOR SAL-AMMONIAC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF739"},128826:{"value":"1F73A","name":"ALCHEMICAL SYMBOL FOR ARSENIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73A"},128827:{"value":"1F73B","name":"ALCHEMICAL SYMBOL FOR REALGAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73B"},128828:{"value":"1F73C","name":"ALCHEMICAL SYMBOL FOR REALGAR-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73C"},128829:{"value":"1F73D","name":"ALCHEMICAL SYMBOL FOR AURIPIGMENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73D"},128830:{"value":"1F73E","name":"ALCHEMICAL SYMBOL FOR BISMUTH ORE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73E"},128831:{"value":"1F73F","name":"ALCHEMICAL SYMBOL FOR TARTAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF73F"},128832:{"value":"1F740","name":"ALCHEMICAL SYMBOL FOR TARTAR-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF740"},128833:{"value":"1F741","name":"ALCHEMICAL SYMBOL FOR QUICK LIME","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF741"},128834:{"value":"1F742","name":"ALCHEMICAL SYMBOL FOR BORAX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF742"},128835:{"value":"1F743","name":"ALCHEMICAL SYMBOL FOR BORAX-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF743"},128836:{"value":"1F744","name":"ALCHEMICAL SYMBOL FOR BORAX-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF744"},128837:{"value":"1F745","name":"ALCHEMICAL SYMBOL FOR ALUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF745"},128838:{"value":"1F746","name":"ALCHEMICAL SYMBOL FOR OIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF746"},128839:{"value":"1F747","name":"ALCHEMICAL SYMBOL FOR SPIRIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF747"},128840:{"value":"1F748","name":"ALCHEMICAL SYMBOL FOR TINCTURE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF748"},128841:{"value":"1F749","name":"ALCHEMICAL SYMBOL FOR GUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF749"},128842:{"value":"1F74A","name":"ALCHEMICAL SYMBOL FOR WAX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74A"},128843:{"value":"1F74B","name":"ALCHEMICAL SYMBOL FOR POWDER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74B"},128844:{"value":"1F74C","name":"ALCHEMICAL SYMBOL FOR CALX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74C"},128845:{"value":"1F74D","name":"ALCHEMICAL SYMBOL FOR TUTTY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74D"},128846:{"value":"1F74E","name":"ALCHEMICAL SYMBOL FOR CAPUT MORTUUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74E"},128847:{"value":"1F74F","name":"ALCHEMICAL SYMBOL FOR SCEPTER OF JOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF74F"},128848:{"value":"1F750","name":"ALCHEMICAL SYMBOL FOR CADUCEUS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF750"},128849:{"value":"1F751","name":"ALCHEMICAL SYMBOL FOR TRIDENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF751"},128850:{"value":"1F752","name":"ALCHEMICAL SYMBOL FOR STARRED TRIDENT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF752"},128851:{"value":"1F753","name":"ALCHEMICAL SYMBOL FOR LODESTONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF753"},128852:{"value":"1F754","name":"ALCHEMICAL SYMBOL FOR SOAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF754"},128853:{"value":"1F755","name":"ALCHEMICAL SYMBOL FOR URINE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF755"},128854:{"value":"1F756","name":"ALCHEMICAL SYMBOL FOR HORSE DUNG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF756"},128855:{"value":"1F757","name":"ALCHEMICAL SYMBOL FOR ASHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF757"},128856:{"value":"1F758","name":"ALCHEMICAL SYMBOL FOR POT ASHES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF758"},128857:{"value":"1F759","name":"ALCHEMICAL SYMBOL FOR BRICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF759"},128858:{"value":"1F75A","name":"ALCHEMICAL SYMBOL FOR POWDERED BRICK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75A"},128859:{"value":"1F75B","name":"ALCHEMICAL SYMBOL FOR AMALGAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75B"},128860:{"value":"1F75C","name":"ALCHEMICAL SYMBOL FOR STRATUM SUPER STRATUM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75C"},128861:{"value":"1F75D","name":"ALCHEMICAL SYMBOL FOR STRATUM SUPER STRATUM-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75D"},128862:{"value":"1F75E","name":"ALCHEMICAL SYMBOL FOR SUBLIMATION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75E"},128863:{"value":"1F75F","name":"ALCHEMICAL SYMBOL FOR PRECIPITATE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF75F"},128864:{"value":"1F760","name":"ALCHEMICAL SYMBOL FOR DISTILL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF760"},128865:{"value":"1F761","name":"ALCHEMICAL SYMBOL FOR DISSOLVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF761"},128866:{"value":"1F762","name":"ALCHEMICAL SYMBOL FOR DISSOLVE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF762"},128867:{"value":"1F763","name":"ALCHEMICAL SYMBOL FOR PURIFY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF763"},128868:{"value":"1F764","name":"ALCHEMICAL SYMBOL FOR PUTREFACTION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF764"},128869:{"value":"1F765","name":"ALCHEMICAL SYMBOL FOR CRUCIBLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF765"},128870:{"value":"1F766","name":"ALCHEMICAL SYMBOL FOR CRUCIBLE-2","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF766"},128871:{"value":"1F767","name":"ALCHEMICAL SYMBOL FOR CRUCIBLE-3","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF767"},128872:{"value":"1F768","name":"ALCHEMICAL SYMBOL FOR CRUCIBLE-4","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF768"},128873:{"value":"1F769","name":"ALCHEMICAL SYMBOL FOR CRUCIBLE-5","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF769"},128874:{"value":"1F76A","name":"ALCHEMICAL SYMBOL FOR ALEMBIC","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76A"},128875:{"value":"1F76B","name":"ALCHEMICAL SYMBOL FOR BATH OF MARY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76B"},128876:{"value":"1F76C","name":"ALCHEMICAL SYMBOL FOR BATH OF VAPOURS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76C"},128877:{"value":"1F76D","name":"ALCHEMICAL SYMBOL FOR RETORT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76D"},128878:{"value":"1F76E","name":"ALCHEMICAL SYMBOL FOR HOUR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76E"},128879:{"value":"1F76F","name":"ALCHEMICAL SYMBOL FOR NIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF76F"},128880:{"value":"1F770","name":"ALCHEMICAL SYMBOL FOR DAY-NIGHT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF770"},128881:{"value":"1F771","name":"ALCHEMICAL SYMBOL FOR MONTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF771"},128882:{"value":"1F772","name":"ALCHEMICAL SYMBOL FOR HALF DRAM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF772"},128883:{"value":"1F773","name":"ALCHEMICAL SYMBOL FOR HALF OUNCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF773"},128896:{"value":"1F780","name":"BLACK LEFT-POINTING ISOSCELES RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF780"},128897:{"value":"1F781","name":"BLACK UP-POINTING ISOSCELES RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF781"},128898:{"value":"1F782","name":"BLACK RIGHT-POINTING ISOSCELES RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF782"},128899:{"value":"1F783","name":"BLACK DOWN-POINTING ISOSCELES RIGHT TRIANGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF783"},128900:{"value":"1F784","name":"BLACK SLIGHTLY SMALL CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF784"},128901:{"value":"1F785","name":"MEDIUM BOLD WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF785"},128902:{"value":"1F786","name":"BOLD WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF786"},128903:{"value":"1F787","name":"HEAVY WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF787"},128904:{"value":"1F788","name":"VERY HEAVY WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF788"},128905:{"value":"1F789","name":"EXTREMELY HEAVY WHITE CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF789"},128906:{"value":"1F78A","name":"WHITE CIRCLE CONTAINING BLACK SMALL CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78A"},128907:{"value":"1F78B","name":"ROUND TARGET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78B"},128908:{"value":"1F78C","name":"BLACK TINY SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78C"},128909:{"value":"1F78D","name":"BLACK SLIGHTLY SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78D"},128910:{"value":"1F78E","name":"LIGHT WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78E"},128911:{"value":"1F78F","name":"MEDIUM WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF78F"},128912:{"value":"1F790","name":"BOLD WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF790"},128913:{"value":"1F791","name":"HEAVY WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF791"},128914:{"value":"1F792","name":"VERY HEAVY WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF792"},128915:{"value":"1F793","name":"EXTREMELY HEAVY WHITE SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF793"},128916:{"value":"1F794","name":"WHITE SQUARE CONTAINING BLACK VERY SMALL SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF794"},128917:{"value":"1F795","name":"WHITE SQUARE CONTAINING BLACK MEDIUM SQUARE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF795"},128918:{"value":"1F796","name":"SQUARE TARGET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF796"},128919:{"value":"1F797","name":"BLACK TINY DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF797"},128920:{"value":"1F798","name":"BLACK VERY SMALL DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF798"},128921:{"value":"1F799","name":"BLACK MEDIUM SMALL DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF799"},128922:{"value":"1F79A","name":"WHITE DIAMOND CONTAINING BLACK VERY SMALL DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79A"},128923:{"value":"1F79B","name":"WHITE DIAMOND CONTAINING BLACK MEDIUM DIAMOND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79B"},128924:{"value":"1F79C","name":"DIAMOND TARGET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79C"},128925:{"value":"1F79D","name":"BLACK TINY LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79D"},128926:{"value":"1F79E","name":"BLACK VERY SMALL LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79E"},128927:{"value":"1F79F","name":"BLACK MEDIUM SMALL LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF79F"},128928:{"value":"1F7A0","name":"WHITE LOZENGE CONTAINING BLACK SMALL LOZENGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A0"},128929:{"value":"1F7A1","name":"THIN GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A1"},128930:{"value":"1F7A2","name":"LIGHT GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A2"},128931:{"value":"1F7A3","name":"MEDIUM GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A3"},128932:{"value":"1F7A4","name":"BOLD GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A4"},128933:{"value":"1F7A5","name":"VERY BOLD GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A5"},128934:{"value":"1F7A6","name":"VERY HEAVY GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A6"},128935:{"value":"1F7A7","name":"EXTREMELY HEAVY GREEK CROSS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A7"},128936:{"value":"1F7A8","name":"THIN SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A8"},128937:{"value":"1F7A9","name":"LIGHT SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7A9"},128938:{"value":"1F7AA","name":"MEDIUM SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AA"},128939:{"value":"1F7AB","name":"BOLD SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AB"},128940:{"value":"1F7AC","name":"HEAVY SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AC"},128941:{"value":"1F7AD","name":"VERY HEAVY SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AD"},128942:{"value":"1F7AE","name":"EXTREMELY HEAVY SALTIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AE"},128943:{"value":"1F7AF","name":"LIGHT FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7AF"},128944:{"value":"1F7B0","name":"MEDIUM FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B0"},128945:{"value":"1F7B1","name":"BOLD FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B1"},128946:{"value":"1F7B2","name":"HEAVY FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B2"},128947:{"value":"1F7B3","name":"VERY HEAVY FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B3"},128948:{"value":"1F7B4","name":"EXTREMELY HEAVY FIVE SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B4"},128949:{"value":"1F7B5","name":"LIGHT SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B5"},128950:{"value":"1F7B6","name":"MEDIUM SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B6"},128951:{"value":"1F7B7","name":"BOLD SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B7"},128952:{"value":"1F7B8","name":"HEAVY SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B8"},128953:{"value":"1F7B9","name":"VERY HEAVY SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7B9"},128954:{"value":"1F7BA","name":"EXTREMELY HEAVY SIX SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BA"},128955:{"value":"1F7BB","name":"LIGHT EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BB"},128956:{"value":"1F7BC","name":"MEDIUM EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BC"},128957:{"value":"1F7BD","name":"BOLD EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BD"},128958:{"value":"1F7BE","name":"HEAVY EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BE"},128959:{"value":"1F7BF","name":"VERY HEAVY EIGHT SPOKED ASTERISK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7BF"},128960:{"value":"1F7C0","name":"LIGHT THREE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C0"},128961:{"value":"1F7C1","name":"MEDIUM THREE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C1"},128962:{"value":"1F7C2","name":"THREE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C2"},128963:{"value":"1F7C3","name":"MEDIUM THREE POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C3"},128964:{"value":"1F7C4","name":"LIGHT FOUR POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C4"},128965:{"value":"1F7C5","name":"MEDIUM FOUR POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C5"},128966:{"value":"1F7C6","name":"FOUR POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C6"},128967:{"value":"1F7C7","name":"MEDIUM FOUR POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C7"},128968:{"value":"1F7C8","name":"REVERSE LIGHT FOUR POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C8"},128969:{"value":"1F7C9","name":"LIGHT FIVE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7C9"},128970:{"value":"1F7CA","name":"HEAVY FIVE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CA"},128971:{"value":"1F7CB","name":"MEDIUM SIX POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CB"},128972:{"value":"1F7CC","name":"HEAVY SIX POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CC"},128973:{"value":"1F7CD","name":"SIX POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CD"},128974:{"value":"1F7CE","name":"MEDIUM EIGHT POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CE"},128975:{"value":"1F7CF","name":"HEAVY EIGHT POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7CF"},128976:{"value":"1F7D0","name":"VERY HEAVY EIGHT POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7D0"},128977:{"value":"1F7D1","name":"HEAVY EIGHT POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7D1"},128978:{"value":"1F7D2","name":"LIGHT TWELVE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7D2"},128979:{"value":"1F7D3","name":"HEAVY TWELVE POINTED BLACK STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7D3"},128980:{"value":"1F7D4","name":"HEAVY TWELVE POINTED PINWHEEL STAR","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF7D4"},129024:{"value":"1F800","name":"LEFTWARDS ARROW WITH SMALL TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF800"},129025:{"value":"1F801","name":"UPWARDS ARROW WITH SMALL TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF801"},129026:{"value":"1F802","name":"RIGHTWARDS ARROW WITH SMALL TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF802"},129027:{"value":"1F803","name":"DOWNWARDS ARROW WITH SMALL TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF803"},129028:{"value":"1F804","name":"LEFTWARDS ARROW WITH MEDIUM TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF804"},129029:{"value":"1F805","name":"UPWARDS ARROW WITH MEDIUM TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF805"},129030:{"value":"1F806","name":"RIGHTWARDS ARROW WITH MEDIUM TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF806"},129031:{"value":"1F807","name":"DOWNWARDS ARROW WITH MEDIUM TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF807"},129032:{"value":"1F808","name":"LEFTWARDS ARROW WITH LARGE TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF808"},129033:{"value":"1F809","name":"UPWARDS ARROW WITH LARGE TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF809"},129034:{"value":"1F80A","name":"RIGHTWARDS ARROW WITH LARGE TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF80A"},129035:{"value":"1F80B","name":"DOWNWARDS ARROW WITH LARGE TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF80B"},129040:{"value":"1F810","name":"LEFTWARDS ARROW WITH SMALL EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF810"},129041:{"value":"1F811","name":"UPWARDS ARROW WITH SMALL EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF811"},129042:{"value":"1F812","name":"RIGHTWARDS ARROW WITH SMALL EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF812"},129043:{"value":"1F813","name":"DOWNWARDS ARROW WITH SMALL EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF813"},129044:{"value":"1F814","name":"LEFTWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF814"},129045:{"value":"1F815","name":"UPWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF815"},129046:{"value":"1F816","name":"RIGHTWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF816"},129047:{"value":"1F817","name":"DOWNWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF817"},129048:{"value":"1F818","name":"HEAVY LEFTWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF818"},129049:{"value":"1F819","name":"HEAVY UPWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF819"},129050:{"value":"1F81A","name":"HEAVY RIGHTWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81A"},129051:{"value":"1F81B","name":"HEAVY DOWNWARDS ARROW WITH EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81B"},129052:{"value":"1F81C","name":"HEAVY LEFTWARDS ARROW WITH LARGE EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81C"},129053:{"value":"1F81D","name":"HEAVY UPWARDS ARROW WITH LARGE EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81D"},129054:{"value":"1F81E","name":"HEAVY RIGHTWARDS ARROW WITH LARGE EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81E"},129055:{"value":"1F81F","name":"HEAVY DOWNWARDS ARROW WITH LARGE EQUILATERAL ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF81F"},129056:{"value":"1F820","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH NARROW SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF820"},129057:{"value":"1F821","name":"UPWARDS TRIANGLE-HEADED ARROW WITH NARROW SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF821"},129058:{"value":"1F822","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH NARROW SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF822"},129059:{"value":"1F823","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH NARROW SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF823"},129060:{"value":"1F824","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH MEDIUM SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF824"},129061:{"value":"1F825","name":"UPWARDS TRIANGLE-HEADED ARROW WITH MEDIUM SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF825"},129062:{"value":"1F826","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH MEDIUM SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF826"},129063:{"value":"1F827","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH MEDIUM SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF827"},129064:{"value":"1F828","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH BOLD SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF828"},129065:{"value":"1F829","name":"UPWARDS TRIANGLE-HEADED ARROW WITH BOLD SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF829"},129066:{"value":"1F82A","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH BOLD SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82A"},129067:{"value":"1F82B","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH BOLD SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82B"},129068:{"value":"1F82C","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82C"},129069:{"value":"1F82D","name":"UPWARDS TRIANGLE-HEADED ARROW WITH HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82D"},129070:{"value":"1F82E","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82E"},129071:{"value":"1F82F","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF82F"},129072:{"value":"1F830","name":"LEFTWARDS TRIANGLE-HEADED ARROW WITH VERY HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF830"},129073:{"value":"1F831","name":"UPWARDS TRIANGLE-HEADED ARROW WITH VERY HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF831"},129074:{"value":"1F832","name":"RIGHTWARDS TRIANGLE-HEADED ARROW WITH VERY HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF832"},129075:{"value":"1F833","name":"DOWNWARDS TRIANGLE-HEADED ARROW WITH VERY HEAVY SHAFT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF833"},129076:{"value":"1F834","name":"LEFTWARDS FINGER-POST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF834"},129077:{"value":"1F835","name":"UPWARDS FINGER-POST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF835"},129078:{"value":"1F836","name":"RIGHTWARDS FINGER-POST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF836"},129079:{"value":"1F837","name":"DOWNWARDS FINGER-POST ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF837"},129080:{"value":"1F838","name":"LEFTWARDS SQUARED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF838"},129081:{"value":"1F839","name":"UPWARDS SQUARED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF839"},129082:{"value":"1F83A","name":"RIGHTWARDS SQUARED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83A"},129083:{"value":"1F83B","name":"DOWNWARDS SQUARED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83B"},129084:{"value":"1F83C","name":"LEFTWARDS COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83C"},129085:{"value":"1F83D","name":"UPWARDS COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83D"},129086:{"value":"1F83E","name":"RIGHTWARDS COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83E"},129087:{"value":"1F83F","name":"DOWNWARDS COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF83F"},129088:{"value":"1F840","name":"LEFTWARDS HEAVY COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF840"},129089:{"value":"1F841","name":"UPWARDS HEAVY COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF841"},129090:{"value":"1F842","name":"RIGHTWARDS HEAVY COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF842"},129091:{"value":"1F843","name":"DOWNWARDS HEAVY COMPRESSED ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF843"},129092:{"value":"1F844","name":"LEFTWARDS HEAVY ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF844"},129093:{"value":"1F845","name":"UPWARDS HEAVY ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF845"},129094:{"value":"1F846","name":"RIGHTWARDS HEAVY ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF846"},129095:{"value":"1F847","name":"DOWNWARDS HEAVY ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF847"},129104:{"value":"1F850","name":"LEFTWARDS SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF850"},129105:{"value":"1F851","name":"UPWARDS SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF851"},129106:{"value":"1F852","name":"RIGHTWARDS SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF852"},129107:{"value":"1F853","name":"DOWNWARDS SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF853"},129108:{"value":"1F854","name":"NORTH WEST SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF854"},129109:{"value":"1F855","name":"NORTH EAST SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF855"},129110:{"value":"1F856","name":"SOUTH EAST SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF856"},129111:{"value":"1F857","name":"SOUTH WEST SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF857"},129112:{"value":"1F858","name":"LEFT RIGHT SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF858"},129113:{"value":"1F859","name":"UP DOWN SANS-SERIF ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF859"},129120:{"value":"1F860","name":"WIDE-HEADED LEFTWARDS LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF860"},129121:{"value":"1F861","name":"WIDE-HEADED UPWARDS LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF861"},129122:{"value":"1F862","name":"WIDE-HEADED RIGHTWARDS LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF862"},129123:{"value":"1F863","name":"WIDE-HEADED DOWNWARDS LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF863"},129124:{"value":"1F864","name":"WIDE-HEADED NORTH WEST LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF864"},129125:{"value":"1F865","name":"WIDE-HEADED NORTH EAST LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF865"},129126:{"value":"1F866","name":"WIDE-HEADED SOUTH EAST LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF866"},129127:{"value":"1F867","name":"WIDE-HEADED SOUTH WEST LIGHT BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF867"},129128:{"value":"1F868","name":"WIDE-HEADED LEFTWARDS BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF868"},129129:{"value":"1F869","name":"WIDE-HEADED UPWARDS BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF869"},129130:{"value":"1F86A","name":"WIDE-HEADED RIGHTWARDS BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86A"},129131:{"value":"1F86B","name":"WIDE-HEADED DOWNWARDS BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86B"},129132:{"value":"1F86C","name":"WIDE-HEADED NORTH WEST BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86C"},129133:{"value":"1F86D","name":"WIDE-HEADED NORTH EAST BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86D"},129134:{"value":"1F86E","name":"WIDE-HEADED SOUTH EAST BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86E"},129135:{"value":"1F86F","name":"WIDE-HEADED SOUTH WEST BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF86F"},129136:{"value":"1F870","name":"WIDE-HEADED LEFTWARDS MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF870"},129137:{"value":"1F871","name":"WIDE-HEADED UPWARDS MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF871"},129138:{"value":"1F872","name":"WIDE-HEADED RIGHTWARDS MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF872"},129139:{"value":"1F873","name":"WIDE-HEADED DOWNWARDS MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF873"},129140:{"value":"1F874","name":"WIDE-HEADED NORTH WEST MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF874"},129141:{"value":"1F875","name":"WIDE-HEADED NORTH EAST MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF875"},129142:{"value":"1F876","name":"WIDE-HEADED SOUTH EAST MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF876"},129143:{"value":"1F877","name":"WIDE-HEADED SOUTH WEST MEDIUM BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF877"},129144:{"value":"1F878","name":"WIDE-HEADED LEFTWARDS HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF878"},129145:{"value":"1F879","name":"WIDE-HEADED UPWARDS HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF879"},129146:{"value":"1F87A","name":"WIDE-HEADED RIGHTWARDS HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87A"},129147:{"value":"1F87B","name":"WIDE-HEADED DOWNWARDS HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87B"},129148:{"value":"1F87C","name":"WIDE-HEADED NORTH WEST HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87C"},129149:{"value":"1F87D","name":"WIDE-HEADED NORTH EAST HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87D"},129150:{"value":"1F87E","name":"WIDE-HEADED SOUTH EAST HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87E"},129151:{"value":"1F87F","name":"WIDE-HEADED SOUTH WEST HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF87F"},129152:{"value":"1F880","name":"WIDE-HEADED LEFTWARDS VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF880"},129153:{"value":"1F881","name":"WIDE-HEADED UPWARDS VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF881"},129154:{"value":"1F882","name":"WIDE-HEADED RIGHTWARDS VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF882"},129155:{"value":"1F883","name":"WIDE-HEADED DOWNWARDS VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF883"},129156:{"value":"1F884","name":"WIDE-HEADED NORTH WEST VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF884"},129157:{"value":"1F885","name":"WIDE-HEADED NORTH EAST VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF885"},129158:{"value":"1F886","name":"WIDE-HEADED SOUTH EAST VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF886"},129159:{"value":"1F887","name":"WIDE-HEADED SOUTH WEST VERY HEAVY BARB ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF887"},129168:{"value":"1F890","name":"LEFTWARDS TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF890"},129169:{"value":"1F891","name":"UPWARDS TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF891"},129170:{"value":"1F892","name":"RIGHTWARDS TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF892"},129171:{"value":"1F893","name":"DOWNWARDS TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF893"},129172:{"value":"1F894","name":"LEFTWARDS WHITE ARROW WITHIN TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF894"},129173:{"value":"1F895","name":"UPWARDS WHITE ARROW WITHIN TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF895"},129174:{"value":"1F896","name":"RIGHTWARDS WHITE ARROW WITHIN TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF896"},129175:{"value":"1F897","name":"DOWNWARDS WHITE ARROW WITHIN TRIANGLE ARROWHEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF897"},129176:{"value":"1F898","name":"LEFTWARDS ARROW WITH NOTCHED TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF898"},129177:{"value":"1F899","name":"UPWARDS ARROW WITH NOTCHED TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF899"},129178:{"value":"1F89A","name":"RIGHTWARDS ARROW WITH NOTCHED TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89A"},129179:{"value":"1F89B","name":"DOWNWARDS ARROW WITH NOTCHED TAIL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89B"},129180:{"value":"1F89C","name":"HEAVY ARROW SHAFT WIDTH ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89C"},129181:{"value":"1F89D","name":"HEAVY ARROW SHAFT WIDTH TWO THIRDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89D"},129182:{"value":"1F89E","name":"HEAVY ARROW SHAFT WIDTH ONE HALF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89E"},129183:{"value":"1F89F","name":"HEAVY ARROW SHAFT WIDTH ONE THIRD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF89F"},129184:{"value":"1F8A0","name":"LEFTWARDS BOTTOM-SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A0"},129185:{"value":"1F8A1","name":"RIGHTWARDS BOTTOM SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A1"},129186:{"value":"1F8A2","name":"LEFTWARDS TOP SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A2"},129187:{"value":"1F8A3","name":"RIGHTWARDS TOP SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A3"},129188:{"value":"1F8A4","name":"LEFTWARDS LEFT-SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A4"},129189:{"value":"1F8A5","name":"RIGHTWARDS RIGHT-SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A5"},129190:{"value":"1F8A6","name":"LEFTWARDS RIGHT-SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A6"},129191:{"value":"1F8A7","name":"RIGHTWARDS LEFT-SHADED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A7"},129192:{"value":"1F8A8","name":"LEFTWARDS BACK-TILTED SHADOWED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A8"},129193:{"value":"1F8A9","name":"RIGHTWARDS BACK-TILTED SHADOWED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8A9"},129194:{"value":"1F8AA","name":"LEFTWARDS FRONT-TILTED SHADOWED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8AA"},129195:{"value":"1F8AB","name":"RIGHTWARDS FRONT-TILTED SHADOWED WHITE ARROW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8AB"},129196:{"value":"1F8AC","name":"WHITE ARROW SHAFT WIDTH ONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8AC"},129197:{"value":"1F8AD","name":"WHITE ARROW SHAFT WIDTH TWO THIRDS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF8AD"},129280:{"value":"1F900","name":"CIRCLED CROSS FORMEE WITH FOUR DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF900"},129281:{"value":"1F901","name":"CIRCLED CROSS FORMEE WITH TWO DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF901"},129282:{"value":"1F902","name":"CIRCLED CROSS FORMEE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF902"},129283:{"value":"1F903","name":"LEFT HALF CIRCLE WITH FOUR DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF903"},129284:{"value":"1F904","name":"LEFT HALF CIRCLE WITH THREE DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF904"},129285:{"value":"1F905","name":"LEFT HALF CIRCLE WITH TWO DOTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF905"},129286:{"value":"1F906","name":"LEFT HALF CIRCLE WITH DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF906"},129287:{"value":"1F907","name":"LEFT HALF CIRCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF907"},129288:{"value":"1F908","name":"DOWNWARD FACING HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF908"},129289:{"value":"1F909","name":"DOWNWARD FACING NOTCHED HOOK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF909"},129290:{"value":"1F90A","name":"DOWNWARD FACING HOOK WITH DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF90A"},129291:{"value":"1F90B","name":"DOWNWARD FACING NOTCHED HOOK WITH DOT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF90B"},129296:{"value":"1F910","name":"ZIPPER-MOUTH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF910"},129297:{"value":"1F911","name":"MONEY-MOUTH FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF911"},129298:{"value":"1F912","name":"FACE WITH THERMOMETER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF912"},129299:{"value":"1F913","name":"NERD FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF913"},129300:{"value":"1F914","name":"THINKING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF914"},129301:{"value":"1F915","name":"FACE WITH HEAD-BANDAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF915"},129302:{"value":"1F916","name":"ROBOT FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF916"},129303:{"value":"1F917","name":"HUGGING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF917"},129304:{"value":"1F918","name":"SIGN OF THE HORNS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF918"},129305:{"value":"1F919","name":"CALL ME HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF919"},129306:{"value":"1F91A","name":"RAISED BACK OF HAND","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91A"},129307:{"value":"1F91B","name":"LEFT-FACING FIST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91B"},129308:{"value":"1F91C","name":"RIGHT-FACING FIST","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91C"},129309:{"value":"1F91D","name":"HANDSHAKE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91D"},129310:{"value":"1F91E","name":"HAND WITH INDEX AND MIDDLE FINGERS CROSSED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91E"},129311:{"value":"1F91F","name":"I LOVE YOU HAND SIGN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF91F"},129312:{"value":"1F920","name":"FACE WITH COWBOY HAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF920"},129313:{"value":"1F921","name":"CLOWN FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF921"},129314:{"value":"1F922","name":"NAUSEATED FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF922"},129315:{"value":"1F923","name":"ROLLING ON THE FLOOR LAUGHING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF923"},129316:{"value":"1F924","name":"DROOLING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF924"},129317:{"value":"1F925","name":"LYING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF925"},129318:{"value":"1F926","name":"FACE PALM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF926"},129319:{"value":"1F927","name":"SNEEZING FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF927"},129320:{"value":"1F928","name":"FACE WITH ONE EYEBROW RAISED","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF928"},129321:{"value":"1F929","name":"GRINNING FACE WITH STAR EYES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF929"},129322:{"value":"1F92A","name":"GRINNING FACE WITH ONE LARGE AND ONE SMALL EYE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92A"},129323:{"value":"1F92B","name":"FACE WITH FINGER COVERING CLOSED LIPS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92B"},129324:{"value":"1F92C","name":"SERIOUS FACE WITH SYMBOLS COVERING MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92C"},129325:{"value":"1F92D","name":"SMILING FACE WITH SMILING EYES AND HAND COVERING MOUTH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92D"},129326:{"value":"1F92E","name":"FACE WITH OPEN MOUTH VOMITING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92E"},129327:{"value":"1F92F","name":"SHOCKED FACE WITH EXPLODING HEAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF92F"},129328:{"value":"1F930","name":"PREGNANT WOMAN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF930"},129329:{"value":"1F931","name":"BREAST-FEEDING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF931"},129330:{"value":"1F932","name":"PALMS UP TOGETHER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF932"},129331:{"value":"1F933","name":"SELFIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF933"},129332:{"value":"1F934","name":"PRINCE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF934"},129333:{"value":"1F935","name":"MAN IN TUXEDO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF935"},129334:{"value":"1F936","name":"MOTHER CHRISTMAS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF936"},129335:{"value":"1F937","name":"SHRUG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF937"},129336:{"value":"1F938","name":"PERSON DOING CARTWHEEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF938"},129337:{"value":"1F939","name":"JUGGLING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF939"},129338:{"value":"1F93A","name":"FENCER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF93A"},129339:{"value":"1F93B","name":"MODERN PENTATHLON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF93B"},129340:{"value":"1F93C","name":"WRESTLERS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF93C"},129341:{"value":"1F93D","name":"WATER POLO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF93D"},129342:{"value":"1F93E","name":"HANDBALL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF93E"},129344:{"value":"1F940","name":"WILTED FLOWER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF940"},129345:{"value":"1F941","name":"DRUM WITH DRUMSTICKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF941"},129346:{"value":"1F942","name":"CLINKING GLASSES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF942"},129347:{"value":"1F943","name":"TUMBLER GLASS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF943"},129348:{"value":"1F944","name":"SPOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF944"},129349:{"value":"1F945","name":"GOAL NET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF945"},129350:{"value":"1F946","name":"RIFLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF946"},129351:{"value":"1F947","name":"FIRST PLACE MEDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF947"},129352:{"value":"1F948","name":"SECOND PLACE MEDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF948"},129353:{"value":"1F949","name":"THIRD PLACE MEDAL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF949"},129354:{"value":"1F94A","name":"BOXING GLOVE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF94A"},129355:{"value":"1F94B","name":"MARTIAL ARTS UNIFORM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF94B"},129356:{"value":"1F94C","name":"CURLING STONE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF94C"},129360:{"value":"1F950","name":"CROISSANT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF950"},129361:{"value":"1F951","name":"AVOCADO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF951"},129362:{"value":"1F952","name":"CUCUMBER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF952"},129363:{"value":"1F953","name":"BACON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF953"},129364:{"value":"1F954","name":"POTATO","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF954"},129365:{"value":"1F955","name":"CARROT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF955"},129366:{"value":"1F956","name":"BAGUETTE BREAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF956"},129367:{"value":"1F957","name":"GREEN SALAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF957"},129368:{"value":"1F958","name":"SHALLOW PAN OF FOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF958"},129369:{"value":"1F959","name":"STUFFED FLATBREAD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF959"},129370:{"value":"1F95A","name":"EGG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95A"},129371:{"value":"1F95B","name":"GLASS OF MILK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95B"},129372:{"value":"1F95C","name":"PEANUTS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95C"},129373:{"value":"1F95D","name":"KIWIFRUIT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95D"},129374:{"value":"1F95E","name":"PANCAKES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95E"},129375:{"value":"1F95F","name":"DUMPLING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF95F"},129376:{"value":"1F960","name":"FORTUNE COOKIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF960"},129377:{"value":"1F961","name":"TAKEOUT BOX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF961"},129378:{"value":"1F962","name":"CHOPSTICKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF962"},129379:{"value":"1F963","name":"BOWL WITH SPOON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF963"},129380:{"value":"1F964","name":"CUP WITH STRAW","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF964"},129381:{"value":"1F965","name":"COCONUT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF965"},129382:{"value":"1F966","name":"BROCCOLI","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF966"},129383:{"value":"1F967","name":"PIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF967"},129384:{"value":"1F968","name":"PRETZEL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF968"},129385:{"value":"1F969","name":"CUT OF MEAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF969"},129386:{"value":"1F96A","name":"SANDWICH","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF96A"},129387:{"value":"1F96B","name":"CANNED FOOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF96B"},129408:{"value":"1F980","name":"CRAB","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF980"},129409:{"value":"1F981","name":"LION FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF981"},129410:{"value":"1F982","name":"SCORPION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF982"},129411:{"value":"1F983","name":"TURKEY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF983"},129412:{"value":"1F984","name":"UNICORN FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF984"},129413:{"value":"1F985","name":"EAGLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF985"},129414:{"value":"1F986","name":"DUCK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF986"},129415:{"value":"1F987","name":"BAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF987"},129416:{"value":"1F988","name":"SHARK","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF988"},129417:{"value":"1F989","name":"OWL","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF989"},129418:{"value":"1F98A","name":"FOX FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98A"},129419:{"value":"1F98B","name":"BUTTERFLY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98B"},129420:{"value":"1F98C","name":"DEER","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98C"},129421:{"value":"1F98D","name":"GORILLA","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98D"},129422:{"value":"1F98E","name":"LIZARD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98E"},129423:{"value":"1F98F","name":"RHINOCEROS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF98F"},129424:{"value":"1F990","name":"SHRIMP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF990"},129425:{"value":"1F991","name":"SQUID","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF991"},129426:{"value":"1F992","name":"GIRAFFE FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF992"},129427:{"value":"1F993","name":"ZEBRA FACE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF993"},129428:{"value":"1F994","name":"HEDGEHOG","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF994"},129429:{"value":"1F995","name":"SAUROPOD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF995"},129430:{"value":"1F996","name":"T-REX","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF996"},129431:{"value":"1F997","name":"CRICKET","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF997"},129472:{"value":"1F9C0","name":"CHEESE WEDGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9C0"},129488:{"value":"1F9D0","name":"FACE WITH MONOCLE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D0"},129489:{"value":"1F9D1","name":"ADULT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D1"},129490:{"value":"1F9D2","name":"CHILD","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D2"},129491:{"value":"1F9D3","name":"OLDER ADULT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D3"},129492:{"value":"1F9D4","name":"BEARDED PERSON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D4"},129493:{"value":"1F9D5","name":"PERSON WITH HEADSCARF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D5"},129494:{"value":"1F9D6","name":"PERSON IN STEAMY ROOM","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D6"},129495:{"value":"1F9D7","name":"PERSON CLIMBING","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D7"},129496:{"value":"1F9D8","name":"PERSON IN LOTUS POSITION","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D8"},129497:{"value":"1F9D9","name":"MAGE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9D9"},129498:{"value":"1F9DA","name":"FAIRY","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DA"},129499:{"value":"1F9DB","name":"VAMPIRE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DB"},129500:{"value":"1F9DC","name":"MERPERSON","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DC"},129501:{"value":"1F9DD","name":"ELF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DD"},129502:{"value":"1F9DE","name":"GENIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DE"},129503:{"value":"1F9DF","name":"ZOMBIE","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9DF"},129504:{"value":"1F9E0","name":"BRAIN","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E0"},129505:{"value":"1F9E1","name":"ORANGE HEART","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E1"},129506:{"value":"1F9E2","name":"BILLED CAP","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E2"},129507:{"value":"1F9E3","name":"SCARF","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E3"},129508:{"value":"1F9E4","name":"GLOVES","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E4"},129509:{"value":"1F9E5","name":"COAT","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E5"},129510:{"value":"1F9E6","name":"SOCKS","category":"So","class":"0","bidirectional_category":"ON","mapping":"","decimal_digit_value":"","digit_value":"","numeric_value":"","mirrored":"N","unicode_name":"","comment":"","uppercase_mapping":"","lowercase_mapping":"","titlecase_mapping":"","symbol":"\uF9E6"}};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/award.fc32f775.jpg";

/***/ }),
/* 917 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/*
Copyright (c) 2015, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.

Authors: Nera Liu <neraliu@yahoo-inc.com>
         Adonis Fung <adon@yahoo-inc.com>
         Albert Yu <albertyu@yahoo-inc.com>
*/
/*jshint node: true */

exports._getPrivFilters = function () {

    var LT     = /</g,
        QUOT   = /"/g,
        SQUOT  = /'/g,
        AMP    = /&/g,
        NULL   = /\x00/g,
        SPECIAL_ATTR_VALUE_UNQUOTED_CHARS = /(?:^$|[\x00\x09-\x0D "'`=<>])/g,
        SPECIAL_HTML_CHARS = /[&<>"'`]/g, 
        SPECIAL_COMMENT_CHARS = /(?:\x00|^-*!?>|--!?>|--?!?$|\]>|\]$)/g;

    // CSS sensitive chars: ()"'/,!*@{}:;
    // By CSS: (Tab|NewLine|colon|semi|lpar|rpar|apos|sol|comma|excl|ast|midast);|(quot|QUOT)
    // By URI_PROTOCOL: (Tab|NewLine);
    var SENSITIVE_HTML_ENTITIES = /&(?:#([xX][0-9A-Fa-f]+|\d+);?|(Tab|NewLine|colon|semi|lpar|rpar|apos|sol|comma|excl|ast|midast|ensp|emsp|thinsp);|(nbsp|amp|AMP|lt|LT|gt|GT|quot|QUOT);?)/g,
        SENSITIVE_NAMED_REF_MAP = {Tab: '\t', NewLine: '\n', colon: ':', semi: ';', lpar: '(', rpar: ')', apos: '\'', sol: '/', comma: ',', excl: '!', ast: '*', midast: '*', ensp: '\u2002', emsp: '\u2003', thinsp: '\u2009', nbsp: '\xA0', amp: '&', lt: '<', gt: '>', quot: '"', QUOT: '"'};

    // var CSS_VALID_VALUE = 
    //     /^(?:
    //     (?!-*expression)#?[-\w]+
    //     |[+-]?(?:\d+|\d*\.\d+)(?:em|ex|ch|rem|px|mm|cm|in|pt|pc|%|vh|vw|vmin|vmax)?
    //     |!important
    //     | //empty
    //     )$/i;
    var CSS_VALID_VALUE = /^(?:(?!-*expression)#?[-\w]+|[+-]?(?:\d+|\d*\.\d+)(?:r?em|ex|ch|cm|mm|in|px|pt|pc|%|vh|vw|vmin|vmax)?|!important|)$/i,
        // TODO: prevent double css escaping by not encoding \ again, but this may require CSS decoding
        // \x7F and \x01-\x1F less \x09 are for Safari 5.0, added []{}/* for unbalanced quote
        CSS_DOUBLE_QUOTED_CHARS = /[\x00-\x1F\x7F\[\]{}\\"]/g,
        CSS_SINGLE_QUOTED_CHARS = /[\x00-\x1F\x7F\[\]{}\\']/g,
        // (, \u207D and \u208D can be used in background: 'url(...)' in IE, assumed all \ chars are encoded by QUOTED_CHARS, and null is already replaced with \uFFFD
        // otherwise, use this CSS_BLACKLIST instead (enhance it with url matching): /(?:\\?\(|[\u207D\u208D]|\\0{0,4}28 ?|\\0{0,2}20[78][Dd] ?)+/g
        CSS_BLACKLIST = /url[\(\u207D\u208D]+/g,
        // this assumes encodeURI() and encodeURIComponent() has escaped 1-32, 127 for IE8
        CSS_UNQUOTED_URL = /['\(\)]/g; // " \ treated by encodeURI()

    // Given a full URI, need to support "[" ( IPv6address ) "]" in URI as per RFC3986
    // Reference: https://tools.ietf.org/html/rfc3986
    var URL_IPV6 = /\/\/%5[Bb]([A-Fa-f0-9:]+)%5[Dd]/;


    // Reference: http://shazzer.co.uk/database/All/characters-allowd-in-html-entities
    // Reference: http://shazzer.co.uk/vector/Characters-allowed-after-ampersand-in-named-character-references
    // Reference: http://shazzer.co.uk/database/All/Characters-before-javascript-uri
    // Reference: http://shazzer.co.uk/database/All/Characters-after-javascript-uri
    // Reference: https://html.spec.whatwg.org/multipage/syntax.html#consume-a-character-reference
    // Reference for named characters: https://html.spec.whatwg.org/multipage/entities.json
    var URI_BLACKLIST_PROTOCOLS = {'javascript':1, 'data':1, 'vbscript':1, 'mhtml':1, 'x-schema':1},
        URI_PROTOCOL_COLON = /(?::|&#[xX]0*3[aA];?|&#0*58;?|&colon;)/,
        URI_PROTOCOL_WHITESPACES = /(?:^[\x00-\x20]+|[\t\n\r\x00]+)/g,
        URI_PROTOCOL_NAMED_REF_MAP = {Tab: '\t', NewLine: '\n'};

    var x, 
        strReplace = function (s, regexp, callback) {
            return s === undefined ? 'undefined'
                    : s === null            ? 'null'
                    : s.toString().replace(regexp, callback);
        },
        fromCodePoint = String.fromCodePoint || function(codePoint) {
            if (arguments.length === 0) {
                return '';
            }
            if (codePoint <= 0xFFFF) { // BMP code point
                return String.fromCharCode(codePoint);
            }

            // Astral code point; split in surrogate halves
            // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            codePoint -= 0x10000;
            return String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint % 0x400) + 0xDC00);
        };


    function getProtocol(str) {
        var s = str.split(URI_PROTOCOL_COLON, 2);
        // str.length !== s[0].length is for older IE (e.g., v8), where delimeter residing at last will result in length equals 1, but not 2
        return (s[0] && (s.length === 2 || str.length !== s[0].length)) ? s[0] : null;
    }

    function htmlDecode(s, namedRefMap, reNamedRef, skipReplacement) {
        
        namedRefMap = namedRefMap || SENSITIVE_NAMED_REF_MAP;
        reNamedRef = reNamedRef || SENSITIVE_HTML_ENTITIES;

        function regExpFunction(m, num, named, named1) {
            if (num) {
                num = Number(num[0] <= '9' ? num : '0' + num);
                // switch(num) {
                //     case 0x80: return '\u20AC';  // EURO SIGN (€)
                //     case 0x82: return '\u201A';  // SINGLE LOW-9 QUOTATION MARK (‚)
                //     case 0x83: return '\u0192';  // LATIN SMALL LETTER F WITH HOOK (ƒ)
                //     case 0x84: return '\u201E';  // DOUBLE LOW-9 QUOTATION MARK („)
                //     case 0x85: return '\u2026';  // HORIZONTAL ELLIPSIS (…)
                //     case 0x86: return '\u2020';  // DAGGER (†)
                //     case 0x87: return '\u2021';  // DOUBLE DAGGER (‡)
                //     case 0x88: return '\u02C6';  // MODIFIER LETTER CIRCUMFLEX ACCENT (ˆ)
                //     case 0x89: return '\u2030';  // PER MILLE SIGN (‰)
                //     case 0x8A: return '\u0160';  // LATIN CAPITAL LETTER S WITH CARON (Š)
                //     case 0x8B: return '\u2039';  // SINGLE LEFT-POINTING ANGLE QUOTATION MARK (‹)
                //     case 0x8C: return '\u0152';  // LATIN CAPITAL LIGATURE OE (Œ)
                //     case 0x8E: return '\u017D';  // LATIN CAPITAL LETTER Z WITH CARON (Ž)
                //     case 0x91: return '\u2018';  // LEFT SINGLE QUOTATION MARK (‘)
                //     case 0x92: return '\u2019';  // RIGHT SINGLE QUOTATION MARK (’)
                //     case 0x93: return '\u201C';  // LEFT DOUBLE QUOTATION MARK (“)
                //     case 0x94: return '\u201D';  // RIGHT DOUBLE QUOTATION MARK (”)
                //     case 0x95: return '\u2022';  // BULLET (•)
                //     case 0x96: return '\u2013';  // EN DASH (–)
                //     case 0x97: return '\u2014';  // EM DASH (—)
                //     case 0x98: return '\u02DC';  // SMALL TILDE (˜)
                //     case 0x99: return '\u2122';  // TRADE MARK SIGN (™)
                //     case 0x9A: return '\u0161';  // LATIN SMALL LETTER S WITH CARON (š)
                //     case 0x9B: return '\u203A';  // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (›)
                //     case 0x9C: return '\u0153';  // LATIN SMALL LIGATURE OE (œ)
                //     case 0x9E: return '\u017E';  // LATIN SMALL LETTER Z WITH CARON (ž)
                //     case 0x9F: return '\u0178';  // LATIN CAPITAL LETTER Y WITH DIAERESIS (Ÿ)
                // }
                // // num >= 0xD800 && num <= 0xDFFF, and 0x0D is separately handled, as it doesn't fall into the range of x.pec()
                // return (num >= 0xD800 && num <= 0xDFFF) || num === 0x0D ? '\uFFFD' : x.frCoPt(num);

                return skipReplacement ? fromCodePoint(num)
                        : num === 0x80 ? '\u20AC'  // EURO SIGN (€)
                        : num === 0x82 ? '\u201A'  // SINGLE LOW-9 QUOTATION MARK (‚)
                        : num === 0x83 ? '\u0192'  // LATIN SMALL LETTER F WITH HOOK (ƒ)
                        : num === 0x84 ? '\u201E'  // DOUBLE LOW-9 QUOTATION MARK („)
                        : num === 0x85 ? '\u2026'  // HORIZONTAL ELLIPSIS (…)
                        : num === 0x86 ? '\u2020'  // DAGGER (†)
                        : num === 0x87 ? '\u2021'  // DOUBLE DAGGER (‡)
                        : num === 0x88 ? '\u02C6'  // MODIFIER LETTER CIRCUMFLEX ACCENT (ˆ)
                        : num === 0x89 ? '\u2030'  // PER MILLE SIGN (‰)
                        : num === 0x8A ? '\u0160'  // LATIN CAPITAL LETTER S WITH CARON (Š)
                        : num === 0x8B ? '\u2039'  // SINGLE LEFT-POINTING ANGLE QUOTATION MARK (‹)
                        : num === 0x8C ? '\u0152'  // LATIN CAPITAL LIGATURE OE (Œ)
                        : num === 0x8E ? '\u017D'  // LATIN CAPITAL LETTER Z WITH CARON (Ž)
                        : num === 0x91 ? '\u2018'  // LEFT SINGLE QUOTATION MARK (‘)
                        : num === 0x92 ? '\u2019'  // RIGHT SINGLE QUOTATION MARK (’)
                        : num === 0x93 ? '\u201C'  // LEFT DOUBLE QUOTATION MARK (“)
                        : num === 0x94 ? '\u201D'  // RIGHT DOUBLE QUOTATION MARK (”)
                        : num === 0x95 ? '\u2022'  // BULLET (•)
                        : num === 0x96 ? '\u2013'  // EN DASH (–)
                        : num === 0x97 ? '\u2014'  // EM DASH (—)
                        : num === 0x98 ? '\u02DC'  // SMALL TILDE (˜)
                        : num === 0x99 ? '\u2122'  // TRADE MARK SIGN (™)
                        : num === 0x9A ? '\u0161'  // LATIN SMALL LETTER S WITH CARON (š)
                        : num === 0x9B ? '\u203A'  // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (›)
                        : num === 0x9C ? '\u0153'  // LATIN SMALL LIGATURE OE (œ)
                        : num === 0x9E ? '\u017E'  // LATIN SMALL LETTER Z WITH CARON (ž)
                        : num === 0x9F ? '\u0178'  // LATIN CAPITAL LETTER Y WITH DIAERESIS (Ÿ)
                        : (num >= 0xD800 && num <= 0xDFFF) || num === 0x0D ? '\uFFFD'
                        : x.frCoPt(num);
            }
            return namedRefMap[named || named1] || m;
        }

        return s === undefined  ? 'undefined'
            : s === null        ? 'null'
            : s.toString().replace(NULL, '\uFFFD').replace(reNamedRef, regExpFunction);
    }

    function cssEncode(chr) {
        // space after \\HEX is needed by spec
        return '\\' + chr.charCodeAt(0).toString(16).toLowerCase() + ' ';
    }
    function cssBlacklist(s) {
        return s.replace(CSS_BLACKLIST, function(m){ return '-x-' + m; });
    }
    function cssUrl(s) {
        // encodeURI() in yufull() will throw error for use of the CSS_UNSUPPORTED_CODE_POINT (i.e., [\uD800-\uDFFF])
        s = x.yufull(htmlDecode(s));
        var protocol = getProtocol(s);

        // prefix ## for blacklisted protocols
        // here .replace(URI_PROTOCOL_WHITESPACES, '') is not needed since yufull has already percent-encoded the whitespaces
        return (protocol && URI_BLACKLIST_PROTOCOLS[protocol.toLowerCase()]) ? '##' + s : s;
    }

    return (x = {
        // turn invalid codePoints and that of non-characters to \uFFFD, and then fromCodePoint()
        frCoPt: function(num) {
            return num === undefined || num === null ? '' :
                !isFinite(num = Number(num)) || // `NaN`, `+Infinity`, or `-Infinity`
                num <= 0 ||                     // not a valid Unicode code point
                num > 0x10FFFF ||               // not a valid Unicode code point
                // Math.floor(num) != num || 

                (num >= 0x01 && num <= 0x08) ||
                (num >= 0x0E && num <= 0x1F) ||
                (num >= 0x7F && num <= 0x9F) ||
                (num >= 0xFDD0 && num <= 0xFDEF) ||
                
                 num === 0x0B || 
                (num & 0xFFFF) === 0xFFFF || 
                (num & 0xFFFF) === 0xFFFE ? '\uFFFD' : fromCodePoint(num);
        },
        d: htmlDecode,
        /*
         * @param {string} s - An untrusted uri input
         * @returns {string} s - null if relative url, otherwise the protocol with whitespaces stripped and lower-cased
         */
        yup: function(s) {
            s = getProtocol(s.replace(NULL, ''));
            // URI_PROTOCOL_WHITESPACES is required for left trim and remove interim whitespaces
            return s ? htmlDecode(s, URI_PROTOCOL_NAMED_REF_MAP, null, true).replace(URI_PROTOCOL_WHITESPACES, '').toLowerCase() : null;
        },

        /*
         * @deprecated
         * @param {string} s - An untrusted user input
         * @returns {string} s - The original user input with & < > " ' ` encoded respectively as &amp; &lt; &gt; &quot; &#39; and &#96;.
         *
         */
        y: function(s) {
            return strReplace(s, SPECIAL_HTML_CHARS, function (m) {
                return m === '&' ? '&amp;'
                    :  m === '<' ? '&lt;'
                    :  m === '>' ? '&gt;'
                    :  m === '"' ? '&quot;'
                    :  m === "'" ? '&#39;'
                    :  /*m === '`'*/ '&#96;';       // in hex: 60
            });
        },

        // This filter is meant to introduce double-encoding, and should be used with extra care.
        ya: function(s) {
            return strReplace(s, AMP, '&amp;');
        },

        // FOR DETAILS, refer to inHTMLData()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#data-state
        yd: function (s) {
            return strReplace(s, LT, '&lt;');
        },

        // FOR DETAILS, refer to inHTMLComment()
        // All NULL characters in s are first replaced with \uFFFD.
        // If s contains -->, --!>, or starts with -*>, insert a space right before > to stop state breaking at <!--{{{yc s}}}-->
        // If s ends with --!, --, or -, append a space to stop collaborative state breaking at {{{yc s}}}>, {{{yc s}}}!>, {{{yc s}}}-!>, {{{yc s}}}->
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#comment-state
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-3
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment
        // Reference: http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-0021
        // If s contains ]> or ends with ], append a space after ] is verified in IE to stop IE conditional comments.
        // Reference: http://msdn.microsoft.com/en-us/library/ms537512%28v=vs.85%29.aspx
        // We do not care --\s>, which can possibly be intepreted as a valid close comment tag in very old browsers (e.g., firefox 3.6), as specified in the html4 spec
        // Reference: http://www.w3.org/TR/html401/intro/sgmltut.html#h-3.2.4
        yc: function (s) {
            return strReplace(s, SPECIAL_COMMENT_CHARS, function(m){
                return m === '\x00' ? '\uFFFD'
                    : m === '--!' || m === '--' || m === '-' || m === ']' ? m + ' '
                    :/*
                    :  m === ']>'   ? '] >'
                    :  m === '-->'  ? '-- >'
                    :  m === '--!>' ? '--! >'
                    : /-*!?>/.test(m) ? */ m.slice(0, -1) + ' >';
            });
        },

        // FOR DETAILS, refer to inDoubleQuotedAttr()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state
        yavd: function (s) {
            return strReplace(s, QUOT, '&quot;');
        },

        // FOR DETAILS, refer to inSingleQuotedAttr()
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state
        yavs: function (s) {
            return strReplace(s, SQUOT, '&#39;');
        },

        // FOR DETAILS, refer to inUnQuotedAttr()
        // PART A.
        // if s contains any state breaking chars (\t, \n, \v, \f, \r, space, and >),
        // they are escaped and encoded into their equivalent HTML entity representations. 
        // Reference: http://shazzer.co.uk/database/All/Characters-which-break-attributes-without-quotes
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state
        //
        // PART B. 
        // if s starts with ', " or `, encode it resp. as &#39;, &quot;, or &#96; to 
        // enforce the attr value (unquoted) state
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#before-attribute-value-state
        // Reference: http://shazzer.co.uk/vector/Characters-allowed-attribute-quote
        // 
        // PART C.
        // Inject a \uFFFD character if an empty or all null string is encountered in 
        // unquoted attribute value state.
        // 
        // Rationale 1: our belief is that developers wouldn't expect an 
        //   empty string would result in ' name="passwd"' rendered as 
        //   attribute value, even though this is how HTML5 is specified.
        // Rationale 2: an empty or all null string (for IE) can 
        //   effectively alter its immediate subsequent state, we choose
        //   \uFFFD to end the unquoted attr 
        //   state, which therefore will not mess up later contexts.
        // Rationale 3: Since IE 6, it is verified that NULL chars are stripped.
        // Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state
        // 
        // Example:
        // <input value={{{yavu s}}} name="passwd"/>
        yavu: function (s) {
            return strReplace(s, SPECIAL_ATTR_VALUE_UNQUOTED_CHARS, function (m) {
                return m === '\t'   ? '&#9;'  // in hex: 09
                    :  m === '\n'   ? '&#10;' // in hex: 0A
                    :  m === '\x0B' ? '&#11;' // in hex: 0B  for IE. IE<9 \v equals v, so use \x0B instead
                    :  m === '\f'   ? '&#12;' // in hex: 0C
                    :  m === '\r'   ? '&#13;' // in hex: 0D
                    :  m === ' '    ? '&#32;' // in hex: 20
                    :  m === '='    ? '&#61;' // in hex: 3D
                    :  m === '<'    ? '&lt;'
                    :  m === '>'    ? '&gt;'
                    :  m === '"'    ? '&quot;'
                    :  m === "'"    ? '&#39;'
                    :  m === '`'    ? '&#96;'
                    : /*empty or null*/ '\uFFFD';
            });
        },

        yu: encodeURI,
        yuc: encodeURIComponent,

        // Notice that yubl MUST BE APPLIED LAST, and will not be used independently (expected output from encodeURI/encodeURIComponent and yavd/yavs/yavu)
        // This is used to disable JS execution capabilities by prefixing x- to ^javascript:, ^vbscript: or ^data: that possibly could trigger script execution in URI attribute context
        yubl: function (s) {
            return URI_BLACKLIST_PROTOCOLS[x.yup(s)] ? 'x-' + s : s;
        },

        // This is NOT a security-critical filter.
        // Reference: https://tools.ietf.org/html/rfc3986
        yufull: function (s) {
            return x.yu(s).replace(URL_IPV6, function(m, p) {
                return '//[' + p + ']';
            });
        },

        // chain yufull() with yubl()
        yublf: function (s) {
            return x.yubl(x.yufull(s));
        },

        // The design principle of the CSS filter MUST meet the following goal(s).
        // (1) The input cannot break out of the context (expr) and this is to fulfill the just sufficient encoding principle.
        // (2) The input cannot introduce CSS parsing error and this is to address the concern of UI redressing.
        //
        // term
        //   : unary_operator?
        //     [ NUMBER S* | PERCENTAGE S* | LENGTH S* | EMS S* | EXS S* | ANGLE S* |
        //     TIME S* | FREQ S* ]
        //   | STRING S* | IDENT S* | URI S* | hexcolor | function
        // 
        // Reference:
        // * http://www.w3.org/TR/CSS21/grammar.html 
        // * http://www.w3.org/TR/css-syntax-3/
        // 
        // NOTE: delimiter in CSS -  \  _  :  ;  (  )  "  '  /  ,  %  #  !  *  @  .  {  }
        //                        2d 5c 5f 3a 3b 28 29 22 27 2f 2c 25 23 21 2a 40 2e 7b 7d

        yceu: function(s) {
            s = htmlDecode(s);
            return CSS_VALID_VALUE.test(s) ? s : ";-x:'" + cssBlacklist(s.replace(CSS_SINGLE_QUOTED_CHARS, cssEncode)) + "';-v:";
        },

        // string1 = \"([^\n\r\f\\"]|\\{nl}|\\[^\n\r\f0-9a-f]|\\[0-9a-f]{1,6}(\r\n|[ \n\r\t\f])?)*\"
        yced: function(s) {
            return cssBlacklist(htmlDecode(s).replace(CSS_DOUBLE_QUOTED_CHARS, cssEncode));
        },

        // string2 = \'([^\n\r\f\\']|\\{nl}|\\[^\n\r\f0-9a-f]|\\[0-9a-f]{1,6}(\r\n|[ \n\r\t\f])?)*\'
        yces: function(s) {
            return cssBlacklist(htmlDecode(s).replace(CSS_SINGLE_QUOTED_CHARS, cssEncode));
        },

        // for url({{{yceuu url}}}
        // unquoted_url = ([!#$%&*-~]|\\{h}{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])* (CSS 2.1 definition)
        // unquoted_url = ([^"'()\\ \t\n\r\f\v\u0000\u0008\u000b\u000e-\u001f\u007f]|\\{h}{1,6}(\r\n|[ \t\r\n\f])?|\\[^\r\n\f0-9a-f])* (CSS 3.0 definition)
        // The state machine in CSS 3.0 is more well defined - http://www.w3.org/TR/css-syntax-3/#consume-a-url-token0
        // CSS_UNQUOTED_URL = /['\(\)]/g; // " \ treated by encodeURI()   
        yceuu: function(s) {
            return cssUrl(s).replace(CSS_UNQUOTED_URL, function (chr) {
                return  chr === '\''        ? '\\27 ' :
                        chr === '('         ? '%28' :
                        /* chr === ')' ? */   '%29';
            });
        },

        // for url("{{{yceud url}}}
        yceud: function(s) { 
            return cssUrl(s);
        },

        // for url('{{{yceus url}}}
        yceus: function(s) { 
            return cssUrl(s).replace(SQUOT, '\\27 ');
        }
    });
};

// exposing privFilters
// this is an undocumented feature, and please use it with extra care
var privFilters = exports._privFilters = exports._getPrivFilters();


/* chaining filters */

// uriInAttr and literally uriPathInAttr
// yubl is always used 
// Rationale: given pattern like this: <a href="{{{uriPathInDoubleQuotedAttr s}}}">
//            developer may expect s is always prefixed with ? or /, but an attacker can abuse it with 'javascript:alert(1)'
function uriInAttr (s, yav, yu) {
    return privFilters.yubl(yav((yu || privFilters.yufull)(s)));
}

/** 
* Yahoo Secure XSS Filters - just sufficient output filtering to prevent XSS!
* @module xss-filters 
*/

/**
* @function module:xss-filters#inHTMLData
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with '<' encoded as '&amp;lt;'
*
* @description
* This filter is to be placed in HTML Data context to encode all '<' characters into '&amp;lt;'
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <div>{{{inHTMLData htmlData}}}</div>
*
*/
exports.inHTMLData = privFilters.yd;

/**
* @function module:xss-filters#inHTMLComment
*
* @param {string} s - An untrusted user input
* @returns {string} All NULL characters in s are first replaced with \uFFFD. If s contains -->, --!>, or starts with -*>, insert a space right before > to stop state breaking at <!--{{{yc s}}}-->. If s ends with --!, --, or -, append a space to stop collaborative state breaking at {{{yc s}}}>, {{{yc s}}}!>, {{{yc s}}}-!>, {{{yc s}}}->. If s contains ]> or ends with ], append a space after ] is verified in IE to stop IE conditional comments.
*
* @description
* This filter is to be placed in HTML Comment context
* <ul>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-3">Shazzer - Closing comments for -.-></a>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment">Shazzer - Closing comments for --.></a>
* <li><a href="http://shazzer.co.uk/vector/Characters-that-close-a-HTML-comment-0021">Shazzer - Closing comments for .></a>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-start-state">HTML5 Comment Start State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-start-dash-state">HTML5 Comment Start Dash State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-dash-state">HTML5 Comment End Dash State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-state">HTML5 Comment End State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-end-bang-state">HTML5 Comment End Bang State</a></li>
* <li><a href="http://msdn.microsoft.com/en-us/library/ms537512%28v=vs.85%29.aspx">Conditional Comments in Internet Explorer</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- {{{inHTMLComment html_comment}}} -->
*
*/
exports.inHTMLComment = privFilters.yc;

/**
* @function module:xss-filters#inSingleQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with any single-quote characters encoded into '&amp;&#39;'.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InSingleQuotedAttr filter </p>
* This filter is to be placed in HTML Attribute Value (single-quoted) state to encode all single-quote characters into '&amp;&#39;'
*
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name='firstname' value='{{{inSingleQuotedAttr firstname}}}' />
*
*/
exports.inSingleQuotedAttr = privFilters.yavs;

/**
* @function module:xss-filters#inDoubleQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} The string s with any single-quote characters encoded into '&amp;&quot;'.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InDoubleQuotedAttr filter </p>
* This filter is to be placed in HTML Attribute Value (double-quoted) state to encode all single-quote characters into '&amp;&quot;'
*
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name="firstname" value="{{{inDoubleQuotedAttr firstname}}}" />
*
*/
exports.inDoubleQuotedAttr = privFilters.yavd;

/**
* @function module:xss-filters#inUnQuotedAttr
*
* @param {string} s - An untrusted user input
* @returns {string} If s contains any state breaking chars (\t, \n, \v, \f, \r, space, null, ', ", `, <, >, and =), they are escaped and encoded into their equivalent HTML entity representations. If the string is empty, inject a \uFFFD character.
*
* @description
* <p class="warning">Warning: This is NOT designed for any onX (e.g., onclick) attributes!</p>
* <p class="warning">Warning: If you're working on URI/components, use the more specific uri___InUnQuotedAttr filter </p>
* <p>Regarding \uFFFD injection, given <a id={{{id}}} name="passwd">,<br/>
*        Rationale 1: our belief is that developers wouldn't expect when id equals an
*          empty string would result in ' name="passwd"' rendered as 
*          attribute value, even though this is how HTML5 is specified.<br/>
*        Rationale 2: an empty or all null string (for IE) can 
*          effectively alter its immediate subsequent state, we choose
*          \uFFFD to end the unquoted attr 
*          state, which therefore will not mess up later contexts.<br/>
*        Rationale 3: Since IE 6, it is verified that NULL chars are stripped.<br/>
*        Reference: https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state</p>
* <ul>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#before-attribute-value-state">HTML5 Before Attribute Value State</a></li>
* <li><a href="http://shazzer.co.uk/database/All/Characters-which-break-attributes-without-quotes">Shazzer - Characters-which-break-attributes-without-quotes</a></li>
* <li><a href="http://shazzer.co.uk/vector/Characters-allowed-attribute-quote">Shazzer - Characters-allowed-attribute-quote</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <input name="firstname" value={{{inUnQuotedAttr firstname}}} />
*
*/
exports.inUnQuotedAttr = privFilters.yavu;


/**
* @function module:xss-filters#uriInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='{{{uriInSingleQuotedAttr full_uri}}}'>link</a>
* 
*/
exports.uriInSingleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavs);
};

/**
* @function module:xss-filters#uriInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="{{{uriInDoubleQuotedAttr full_uri}}}">link</a>
* 
*/
exports.uriInDoubleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavd);
};


/**
* @function module:xss-filters#uriInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded first by window.encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for an <strong>absolute</strong> URI.<br/>
* The correct order of encoders is thus: first the built-in encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href={{{uriInUnQuotedAttr full_uri}}}>link</a>
* 
*/
exports.uriInUnQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavu);
};

/**
* @function module:xss-filters#uriInHTMLData
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded by window.encodeURI() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for an <strong>absolute</strong> URI.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURI().</p>
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="/somewhere">{{{uriInHTMLData full_uri}}}</a>
* 
*/
exports.uriInHTMLData = privFilters.yufull;


/**
* @function module:xss-filters#uriInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly an <strong>absolute</strong> URI
* @returns {string} The string s encoded by window.encodeURI(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for an <strong>absolute</strong> URI.
*
* <p>Notice: This filter is IPv6 friendly by not encoding '[' and ']'.</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- {{{uriInHTMLComment full_uri}}} -->
* 
*/
exports.uriInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yufull(s));
};




/**
* @function module:xss-filters#uriPathInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/{{{uriPathInSingleQuotedAttr uri_path}}}'>link</a>
* <a href='http://example.com/?{{{uriQueryInSingleQuotedAttr uri_query}}}'>link</a>
* 
*/
exports.uriPathInSingleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavs, privFilters.yu);
};

/**
* @function module:xss-filters#uriPathInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first window.encodeURI(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/{{{uriPathInDoubleQuotedAttr uri_path}}}">link</a>
* <a href="http://example.com/?{{{uriQueryInDoubleQuotedAttr uri_query}}}">link</a>
* 
*/
exports.uriPathInDoubleQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavd, privFilters.yu);
};


/**
* @function module:xss-filters#uriPathInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded first by window.encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Path/Query or relative URI.<br/>
* The correct order of encoders is thus: first the built-in encodeURI(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/{{{uriPathInUnQuotedAttr uri_path}}}>link</a>
* <a href=http://example.com/?{{{uriQueryInUnQuotedAttr uri_query}}}>link</a>
* 
*/
exports.uriPathInUnQuotedAttr = function (s) {
    return uriInAttr(s, privFilters.yavu, privFilters.yu);
};

/**
* @function module:xss-filters#uriPathInHTMLData
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded by window.encodeURI() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for a URI Path/Query or relative URI.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURI().</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/">http://example.com/{{{uriPathInHTMLData uri_path}}}</a>
* <a href="http://example.com/">http://example.com/?{{{uriQueryInHTMLData uri_query}}}</a>
* 
*/
exports.uriPathInHTMLData = privFilters.yu;


/**
* @function module:xss-filters#uriPathInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly a URI Path/Query or relative URI
* @returns {string} The string s encoded by window.encodeURI(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for a URI Path/Query or relative URI.
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI">encodeURI | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- http://example.com/{{{uriPathInHTMLComment uri_path}}} -->
* <!-- http://example.com/?{{{uriQueryInHTMLComment uri_query}}} -->
*/
exports.uriPathInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yu(s));
};


/**
* @function module:xss-filters#uriQueryInSingleQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInSingleQuotedAttr}
* 
* @alias module:xss-filters#uriPathInSingleQuotedAttr
*/
exports.uriQueryInSingleQuotedAttr = exports.uriPathInSingleQuotedAttr;

/**
* @function module:xss-filters#uriQueryInDoubleQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInDoubleQuotedAttr}
* 
* @alias module:xss-filters#uriPathInDoubleQuotedAttr
*/
exports.uriQueryInDoubleQuotedAttr = exports.uriPathInDoubleQuotedAttr;

/**
* @function module:xss-filters#uriQueryInUnQuotedAttr
* @description This is an alias of {@link module:xss-filters#uriPathInUnQuotedAttr}
* 
* @alias module:xss-filters#uriPathInUnQuotedAttr
*/
exports.uriQueryInUnQuotedAttr = exports.uriPathInUnQuotedAttr;

/**
* @function module:xss-filters#uriQueryInHTMLData
* @description This is an alias of {@link module:xss-filters#uriPathInHTMLData}
* 
* @alias module:xss-filters#uriPathInHTMLData
*/
exports.uriQueryInHTMLData = exports.uriPathInHTMLData;

/**
* @function module:xss-filters#uriQueryInHTMLComment
* @description This is an alias of {@link module:xss-filters#uriPathInHTMLComment}
* 
* @alias module:xss-filters#uriPathInHTMLComment
*/
exports.uriQueryInHTMLComment = exports.uriPathInHTMLComment;



/**
* @function module:xss-filters#uriComponentInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inSingleQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inSingleQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/?q={{{uriComponentInSingleQuotedAttr uri_component}}}'>link</a>
* 
*/
exports.uriComponentInSingleQuotedAttr = function (s) {
    return privFilters.yavs(privFilters.yuc(s));
};

/**
* @function module:xss-filters#uriComponentInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inDoubleQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inDoubleQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/?q={{{uriComponentInDoubleQuotedAttr uri_component}}}">link</a>
* 
*/
exports.uriComponentInDoubleQuotedAttr = function (s) {
    return privFilters.yavd(privFilters.yuc(s));
};


/**
* @function module:xss-filters#uriComponentInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inUnQuotedAttr()
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Component.<br/>
* The correct order of encoders is thus: first the built-in encodeURIComponent(), then inUnQuotedAttr()
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/?q={{{uriComponentInUnQuotedAttr uri_component}}}>link</a>
* 
*/
exports.uriComponentInUnQuotedAttr = function (s) {
    return privFilters.yavu(privFilters.yuc(s));
};

/**
* @function module:xss-filters#uriComponentInHTMLData
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded by window.encodeURIComponent() and then inHTMLData()
*
* @description
* This filter is to be placed in HTML Data state for a URI Component.
*
* <p>Notice: The actual implementation skips inHTMLData(), since '<' is already encoded as '%3C' by encodeURIComponent().</p>
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/">http://example.com/?q={{{uriComponentInHTMLData uri_component}}}</a>
* <a href="http://example.com/">http://example.com/#{{{uriComponentInHTMLData uri_fragment}}}</a>
* 
*/
exports.uriComponentInHTMLData = privFilters.yuc;


/**
* @function module:xss-filters#uriComponentInHTMLComment
*
* @param {string} s - An untrusted user input, supposedly a URI Component
* @returns {string} The string s encoded by window.encodeURIComponent(), and finally inHTMLComment()
*
* @description
* This filter is to be placed in HTML Comment state for a URI Component.
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#data-state">HTML5 Data State</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#comment-state">HTML5 Comment State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <!-- http://example.com/?q={{{uriComponentInHTMLComment uri_component}}} -->
* <!-- http://example.com/#{{{uriComponentInHTMLComment uri_fragment}}} -->
*/
exports.uriComponentInHTMLComment = function (s) {
    return privFilters.yc(privFilters.yuc(s));
};


// uriFragmentInSingleQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href='{{{uriFragmentInSingleQuotedAttr s}}}'>
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInSingleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (single-quoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inSingleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(single-quoted)-state">HTML5 Attribute Value (Single-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href='http://example.com/#{{{uriFragmentInSingleQuotedAttr uri_fragment}}}'>link</a>
* 
*/
exports.uriFragmentInSingleQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavs(privFilters.yuc(s)));
};

// uriFragmentInDoubleQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href="{{{uriFragmentInDoubleQuotedAttr s}}}">
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInDoubleQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (double-quoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first window.encodeURIComponent(), then inDoubleQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(double-quoted)-state">HTML5 Attribute Value (Double-Quoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href="http://example.com/#{{{uriFragmentInDoubleQuotedAttr uri_fragment}}}">link</a>
* 
*/
exports.uriFragmentInDoubleQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavd(privFilters.yuc(s)));
};

// uriFragmentInUnQuotedAttr
// added yubl on top of uriComponentInAttr 
// Rationale: given pattern like this: <a href={{{uriFragmentInUnQuotedAttr s}}}>
//            developer may expect s is always prefixed with #, but an attacker can abuse it with 'javascript:alert(1)'

/**
* @function module:xss-filters#uriFragmentInUnQuotedAttr
*
* @param {string} s - An untrusted user input, supposedly a URI Fragment
* @returns {string} The string s encoded first by window.encodeURIComponent(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* @description
* This filter is to be placed in HTML Attribute Value (unquoted) state for a URI Fragment.<br/>
* The correct order of encoders is thus: first the built-in encodeURIComponent(), then inUnQuotedAttr(), and finally prefix the resulted string with 'x-' if it begins with 'javascript:' or 'vbscript:' that could possibly lead to script execution
*
* <ul>
* <li><a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent">encodeURIComponent | MDN</a></li>
* <li><a href="http://tools.ietf.org/html/rfc3986">RFC 3986</a></li>
* <li><a href="https://html.spec.whatwg.org/multipage/syntax.html#attribute-value-(unquoted)-state">HTML5 Attribute Value (Unquoted) State</a></li>
* </ul>
*
* @example
* // output context to be applied by this filter.
* <a href=http://example.com/#{{{uriFragmentInUnQuotedAttr uri_fragment}}}>link</a>
* 
*/
exports.uriFragmentInUnQuotedAttr = function (s) {
    return privFilters.yubl(privFilters.yavu(privFilters.yuc(s)));
};


/**
* @function module:xss-filters#uriFragmentInHTMLData
* @description This is an alias of {@link module:xss-filters#uriComponentInHTMLData}
* 
* @alias module:xss-filters#uriComponentInHTMLData
*/
exports.uriFragmentInHTMLData = exports.uriComponentInHTMLData;

/**
* @function module:xss-filters#uriFragmentInHTMLComment
* @description This is an alias of {@link module:xss-filters#uriComponentInHTMLComment}
* 
* @alias module:xss-filters#uriComponentInHTMLComment
*/
exports.uriFragmentInHTMLComment = exports.uriComponentInHTMLComment;


/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports = {"newsletter":{"orderTitle":"Subscribe to newsletter","title":"Newsletter","text":"Subscribe to our newsletter and you will be among the first to know our latest news and further information about our upcoming events.","placeholder":"Email address","private":"I am a private customer","business":"I am a business customer","submit":"Submit","success":"Thank you! You'll be hearing from us shortly.","fail":"Subscription failed.","tryAgain":"Try again"},"footer":{"openTitle":"Opening hours","specialHours":"Special hours","privacyPolicy":"Privacy policy","b2bPrivacyPolicy":"B2B Privacy policy","webshopPrivacyPolicy":"Webshop Privacy Policy","webshopTerms":"Webshop Terms and Conditions","otherTimes":"Other times by agreement"},"contact":{"onlineInvoices":"Online invoices"},"contactForm":{"heading":"Contact us","description":"You can contact us directly by email or telephone or by filling in the form below. We will get back to you as soon as possible!","success":"Thank you! You'll be hearing from us shortly.","fail":"Sending failed. Please try again!","name":"Name","email":"Email","phone":"Phone","message":"Message","submit":"Send"},"header":{"home":"Home","foodAndDrinks":"Food and drinks","contactUs":"Contact us"},"general":{"loadMore":"Load more","giftBtn":"Gifts","bookTable":"Book a table","bookOnline":"Book online\n(1-8 person)","bookFormBtn":"Reservation inquiry\n(over 8 person)","businessCard":"Order a business card","giftCard":"Order gift cards","forMedia":"For media","sendRequest":"Send request","oiva":"Oiva report"},"offerForm":{"heading":"Request for an Offer","description":"We want to work hand-in-hand and plan a memorable event. Please submit your request by filling in the form or drop us an email at sales@w-restaurants.fi","premisesHeading":"Premises","premisesDescription":"Leave a brief description of your premises and the kitchen.","dishesHeading":"Do you need dishes?","dishesYes":"Yes","dishesNo":"No","activityHeading":"Program Services","activityDescription":"If you are looking for out of the box experiences, you can always trust in our program services.","activityCocktailSchool":"Cocktail-school","activitySakeTasting":"Sake-tasting","activityWineTasting":"Wine-tasting","budget":"Preliminary budget","name":"Name","company":"Company","email":"Email","phone":"Phone","date":"Date","location":"Location","time":"Time","people":"Number of People","serviceType":"Type of Service","serviceTypeCocktail":"Cocktails with tray service","serviceTypeBuffet":"Buffet","serviceTypeDinner":"Seated Dinner","eventType":"Type of Event","submit":"Send","success":"Thank you for the inquiry, we'll get back to you soonest!","fail":"Sending failed. Please fill all required fields and try again!"},"groupReservation":{"heading":"Reservation inquiry for parties over 8 persons","date":"Date *","time":"Time","people":"People","wishes":"Wishes","name":"Name","email":"Email","phone":"Phone","billing":"Billing info and company ID","notice":"Reservation is valid only after confirmation by email or phone. Please notice that the billing is possible only for companies and organizations. We confirm the possibility for billing when confirming the reservation. Invoicing fee 15 € will be added to the final invoice.","success":"Thank you! Your reservation has been received.","fail":"Sending failed. Please try again!"},"shoppingCart":{"heading":"Shopping Cart","emptyCart":"Your cart is empty","totalPrice":"Total","checkout":"Proceed to Checkout"},"webshop":{"addToCart":"Add to cart","chooseValue":"Choose gift card value:"}}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = {"newsletter":{"orderTitle":"Tilaa uutiskirje","title":"Uutiskirje","text":"Tilaamalla uutiskirjeemme kuulet ensimmäisten joukossa ajankohtaisia kuulumisiamme sekä lisätietoja tulevista tapahtumistamme.","private":"Olen yksityisasiakas","business":"Olen yritysasiakas","placeholder":"Sähköpostiosoitteesi","submit":"Tilaa","success":"Kiitos! Tilauksesi on vastaanotettu.","fail":"Uutiskirjeen tilaaminen epäonnistui.","tryAgain":"Yritä uudelleen"},"footer":{"openTitle":"Aukioloajat","specialHours":"Poikkeusaukioloajat","privacyPolicy":"Asiakasrekisterin tietosuojaseloste","b2bPrivacyPolicy":"B2B suoramarkkinoinnin tietosuojaseloste","webshopPrivacyPolicy":"Verkkokaupan rekisteriseloste","webshopTerms":"Verkkokaupan toimitusehdot","otherTimes":"Muutoin avoinna sopimuksen mukaan"},"contact":{"onlineInvoices":"Verkkolaskut"},"contactForm":{"heading":"Ota yhteyttä","description":"Voit olla meihin yhteydessä suoraan sähköpostitse, puhelimitse tai täyttämällä oheisen lomakkeen. Saatuamme yhteydenottopyyntönne palaamme teille mahdollisimman pian asiaan!","success":"Kiitos! Viestisi on vastaanotettu.","fail":"Lähetys epäonnistui. Tarkista että täytit kaikki pakolliset kentät ja yritä hetken päästä uudelleen!","name":"Nimi","email":"Sähköpostiosoite","phone":"Puhelinnumero","message":"Viesti","submit":"Lähetä"},"header":{"home":"Etusivu","foodAndDrinks":"Ruoka ja juoma","contactUs":"Yhteystiedot"},"general":{"loadMore":"Lataa lisää","giftBtn":"Lahjaksi","bookTable":"Varaa pöytä","bookOnline":"Tee pöytävaraus\n(1-8 henkilöä)","bookFormBtn":"Tee varauspyyntö\n(yli 8 henkilöä)","businessCard":"Tilaa yrityskortti","giftCard":"Osta lahjakortti","forMedia":"Medialle","sendRequest":"Lähetä varaustiedustelu","oiva":"Oiva-raportti"},"offerForm":{"heading":"Tarjouspyyntö","description":"Olethan meihin yhteydessä niin suunnitellaan teille yhdessä ikimuistoisen tilaisuus! Tarjouspyynnön voit jättää alla olevalla lomakkeella tai sähköpostitse sales@w-restaurants.fi.","premisesHeading":"Kuvaus tiloista","premisesDescription":"Jätä tähän lyhyt kuvaus tiloista ja keittiöstä, kuten onko tapahtumapaikalla hellaa, uunia, jääkaappia, pakastinta tai laskutilaa.","dishesHeading":"Tarvitaanko astiat?","dishesYes":"Kyllä","dishesNo":"Ei","activityHeading":"Ohjelmapalvelut","activityDescription":"Toteutamme mielellämme mukavaa ja rentoa ohjelmaa tärkeisiin hetkiinne. Kyseessä voi olla esimerkiksi viini- tai sake-tasting pikkujoulujen aluksi tai cocktail-koulu polttariseurueelle. Voit tutustua ohjelmapalveluihimme tarkemmin","activityCocktailSchool":"Cocktail-koulu","activitySakeTasting":"Sake-tasting","activityWineTasting":"Viini-tasting","budget":"Alustava budjetti","name":"Nimi","company":"Yritys","email":"Sähköpostiosoite","phone":"Puhelinnumero","date":"Päivä","location":"Paikka","time":"Klo","people":"Henkilömäärä","serviceType":"Toivottu tarjoilutapa","serviceTypeCocktail":"Cocktail-tilaisuus tarjottimilta","serviceTypeBuffet":"Buffet","serviceTypeDinner":"Istuva illallinen","eventType":"Tilaisuuden luonne","submit":"Lähetä","success":"Kiitos tarjouspyynnöstä, palaamme asiaan mahdollisimman pian!","fail":"Lähetys epäonnistui. Tarkista että täytit kaikki pakolliset kentät ja yritä hetken päästä uudelleen!"},"groupReservation":{"heading":"Pöytävaraukset yli 8 hengen seurueille","date":"Päivämäärä *","time":"Kellonaika","people":"Henkilömäärä","wishes":"Toiveet","name":"Nimi","email":"Sähköpostiosoite","phone":"Puhelinnumero","billing":"Laskutustiedot ja Y-tunnus","notice":"Varauspyyntö on voimassa vasta kun se on vahvistettu sähköpostitse tai puhelimitse. Huomioittehan, että laskutus on mahdollinen vain yrityksille tai yhteisöille. Vahvistamme laskutusmahdollisuuden varauksen vahvistamisen yhteydessä. Lisäämme laskun loppusummaan laskutuslisän 15 €.","success":"Kiitos! Varauspyyntösi on vastaanotettu.","fail":"Lähetys epäonnistui. Tarkista että täytit kaikki pakolliset kentät ja yritä hetken päästä uudelleen!"},"shoppingCart":{"heading":"Ostoskorisi","emptyCart":"Ostoskorisi on tyhjä","totalPrice":"Loppusumma","checkout":"Siirry maksamaan"},"webshop":{"addToCart":"Lisää ostoskoriin","chooseValue":"Valitse lahjakortin arvo"}}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 922 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 923 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 924 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 925 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(350);
module.exports = __webpack_require__(349);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.3cbc126a.js